/*! jQuery v1.12.4 | (c) jQuery Foundation | jquery.org/license */
!(function (a, b) {
  "object" == typeof module && "object" == typeof module.exports
    ? (module.exports = a.document
        ? b(a, !0)
        : function (a) {
            if (!a.document)
              throw new Error("jQuery requires a window with a document");
            return b(a);
          })
    : b(a);
})("undefined" != typeof window ? window : this, function (a, b) {
  var c = [],
    d = a.document,
    e = c.slice,
    f = c.concat,
    g = c.push,
    h = c.indexOf,
    i = {},
    j = i.toString,
    k = i.hasOwnProperty,
    l = {},
    m = "1.12.4",
    n = function (a, b) {
      return new n.fn.init(a, b);
    },
    o = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
    p = /^-ms-/,
    q = /-([\da-z])/gi,
    r = function (a, b) {
      return b.toUpperCase();
    };
  (n.fn = n.prototype =
    {
      jquery: m,
      constructor: n,
      selector: "",
      length: 0,
      toArray: function () {
        return e.call(this);
      },
      get: function (a) {
        return null != a
          ? 0 > a
            ? this[a + this.length]
            : this[a]
          : e.call(this);
      },
      pushStack: function (a) {
        var b = n.merge(this.constructor(), a);
        return (b.prevObject = this), (b.context = this.context), b;
      },
      each: function (a) {
        return n.each(this, a);
      },
      map: function (a) {
        return this.pushStack(
          n.map(this, function (b, c) {
            return a.call(b, c, b);
          })
        );
      },
      slice: function () {
        return this.pushStack(e.apply(this, arguments));
      },
      first: function () {
        return this.eq(0);
      },
      last: function () {
        return this.eq(-1);
      },
      eq: function (a) {
        var b = this.length,
          c = +a + (0 > a ? b : 0);
        return this.pushStack(c >= 0 && b > c ? [this[c]] : []);
      },
      end: function () {
        return this.prevObject || this.constructor();
      },
      push: g,
      sort: c.sort,
      splice: c.splice,
    }),
    (n.extend = n.fn.extend =
      function () {
        var a,
          b,
          c,
          d,
          e,
          f,
          g = arguments[0] || {},
          h = 1,
          i = arguments.length,
          j = !1;
        for (
          "boolean" == typeof g && ((j = g), (g = arguments[h] || {}), h++),
            "object" == typeof g || n.isFunction(g) || (g = {}),
            h === i && ((g = this), h--);
          i > h;
          h++
        )
          if (null != (e = arguments[h]))
            for (d in e)
              (a = g[d]),
                (c = e[d]),
                g !== c &&
                  (j && c && (n.isPlainObject(c) || (b = n.isArray(c)))
                    ? (b
                        ? ((b = !1), (f = a && n.isArray(a) ? a : []))
                        : (f = a && n.isPlainObject(a) ? a : {}),
                      (g[d] = n.extend(j, f, c)))
                    : void 0 !== c && (g[d] = c));
        return g;
      }),
    n.extend({
      expando: "jQuery" + (m + Math.random()).replace(/\D/g, ""),
      isReady: !0,
      error: function (a) {
        throw new Error(a);
      },
      noop: function () {},
      isFunction: function (a) {
        return "function" === n.type(a);
      },
      isArray:
        Array.isArray ||
        function (a) {
          return "array" === n.type(a);
        },
      isWindow: function (a) {
        return null != a && a == a.window;
      },
      isNumeric: function (a) {
        var b = a && a.toString();
        return !n.isArray(a) && b - parseFloat(b) + 1 >= 0;
      },
      isEmptyObject: function (a) {
        var b;
        for (b in a) return !1;
        return !0;
      },
      isPlainObject: function (a) {
        var b;
        if (!a || "object" !== n.type(a) || a.nodeType || n.isWindow(a))
          return !1;
        try {
          if (
            a.constructor &&
            !k.call(a, "constructor") &&
            !k.call(a.constructor.prototype, "isPrototypeOf")
          )
            return !1;
        } catch (c) {
          return !1;
        }
        if (!l.ownFirst) for (b in a) return k.call(a, b);
        for (b in a);
        return void 0 === b || k.call(a, b);
      },
      type: function (a) {
        return null == a
          ? a + ""
          : "object" == typeof a || "function" == typeof a
          ? i[j.call(a)] || "object"
          : typeof a;
      },
      globalEval: function (b) {
        b &&
          n.trim(b) &&
          (
            a.execScript ||
            function (b) {
              a.eval.call(a, b);
            }
          )(b);
      },
      camelCase: function (a) {
        return a.replace(p, "ms-").replace(q, r);
      },
      nodeName: function (a, b) {
        return a.nodeName && a.nodeName.toLowerCase() === b.toLowerCase();
      },
      each: function (a, b) {
        var c,
          d = 0;
        if (s(a)) {
          for (c = a.length; c > d; d++)
            if (b.call(a[d], d, a[d]) === !1) break;
        } else for (d in a) if (b.call(a[d], d, a[d]) === !1) break;
        return a;
      },
      trim: function (a) {
        return null == a ? "" : (a + "").replace(o, "");
      },
      makeArray: function (a, b) {
        var c = b || [];
        return (
          null != a &&
            (s(Object(a))
              ? n.merge(c, "string" == typeof a ? [a] : a)
              : g.call(c, a)),
          c
        );
      },
      inArray: function (a, b, c) {
        var d;
        if (b) {
          if (h) return h.call(b, a, c);
          for (
            d = b.length, c = c ? (0 > c ? Math.max(0, d + c) : c) : 0;
            d > c;
            c++
          )
            if (c in b && b[c] === a) return c;
        }
        return -1;
      },
      merge: function (a, b) {
        var c = +b.length,
          d = 0,
          e = a.length;
        while (c > d) a[e++] = b[d++];
        if (c !== c) while (void 0 !== b[d]) a[e++] = b[d++];
        return (a.length = e), a;
      },
      grep: function (a, b, c) {
        for (var d, e = [], f = 0, g = a.length, h = !c; g > f; f++)
          (d = !b(a[f], f)), d !== h && e.push(a[f]);
        return e;
      },
      map: function (a, b, c) {
        var d,
          e,
          g = 0,
          h = [];
        if (s(a))
          for (d = a.length; d > g; g++)
            (e = b(a[g], g, c)), null != e && h.push(e);
        else for (g in a) (e = b(a[g], g, c)), null != e && h.push(e);
        return f.apply([], h);
      },
      guid: 1,
      proxy: function (a, b) {
        var c, d, f;
        return (
          "string" == typeof b && ((f = a[b]), (b = a), (a = f)),
          n.isFunction(a)
            ? ((c = e.call(arguments, 2)),
              (d = function () {
                return a.apply(b || this, c.concat(e.call(arguments)));
              }),
              (d.guid = a.guid = a.guid || n.guid++),
              d)
            : void 0
        );
      },
      now: function () {
        return +new Date();
      },
      support: l,
    }),
    "function" == typeof Symbol && (n.fn[Symbol.iterator] = c[Symbol.iterator]),
    n.each(
      "Boolean Number String Function Array Date RegExp Object Error Symbol".split(
        " "
      ),
      function (a, b) {
        i["[object " + b + "]"] = b.toLowerCase();
      }
    );
  function s(a) {
    var b = !!a && "length" in a && a.length,
      c = n.type(a);
    return "function" === c || n.isWindow(a)
      ? !1
      : "array" === c ||
          0 === b ||
          ("number" == typeof b && b > 0 && b - 1 in a);
  }
  var t = (function (a) {
    var b,
      c,
      d,
      e,
      f,
      g,
      h,
      i,
      j,
      k,
      l,
      m,
      n,
      o,
      p,
      q,
      r,
      s,
      t,
      u = "sizzle" + 1 * new Date(),
      v = a.document,
      w = 0,
      x = 0,
      y = ga(),
      z = ga(),
      A = ga(),
      B = function (a, b) {
        return a === b && (l = !0), 0;
      },
      C = 1 << 31,
      D = {}.hasOwnProperty,
      E = [],
      F = E.pop,
      G = E.push,
      H = E.push,
      I = E.slice,
      J = function (a, b) {
        for (var c = 0, d = a.length; d > c; c++) if (a[c] === b) return c;
        return -1;
      },
      K =
        "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
      L = "[\\x20\\t\\r\\n\\f]",
      M = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
      N =
        "\\[" +
        L +
        "*(" +
        M +
        ")(?:" +
        L +
        "*([*^$|!~]?=)" +
        L +
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" +
        M +
        "))|)" +
        L +
        "*\\]",
      O =
        ":(" +
        M +
        ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" +
        N +
        ")*)|.*)\\)|)",
      P = new RegExp(L + "+", "g"),
      Q = new RegExp("^" + L + "+|((?:^|[^\\\\])(?:\\\\.)*)" + L + "+$", "g"),
      R = new RegExp("^" + L + "*," + L + "*"),
      S = new RegExp("^" + L + "*([>+~]|" + L + ")" + L + "*"),
      T = new RegExp("=" + L + "*([^\\]'\"]*?)" + L + "*\\]", "g"),
      U = new RegExp(O),
      V = new RegExp("^" + M + "$"),
      W = {
        ID: new RegExp("^#(" + M + ")"),
        CLASS: new RegExp("^\\.(" + M + ")"),
        TAG: new RegExp("^(" + M + "|[*])"),
        ATTR: new RegExp("^" + N),
        PSEUDO: new RegExp("^" + O),
        CHILD: new RegExp(
          "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
            L +
            "*(even|odd|(([+-]|)(\\d*)n|)" +
            L +
            "*(?:([+-]|)" +
            L +
            "*(\\d+)|))" +
            L +
            "*\\)|)",
          "i"
        ),
        bool: new RegExp("^(?:" + K + ")$", "i"),
        needsContext: new RegExp(
          "^" +
            L +
            "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
            L +
            "*((?:-\\d)?\\d*)" +
            L +
            "*\\)|)(?=[^-]|$)",
          "i"
        ),
      },
      X = /^(?:input|select|textarea|button)$/i,
      Y = /^h\d$/i,
      Z = /^[^{]+\{\s*\[native \w/,
      $ = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
      _ = /[+~]/,
      aa = /'|\\/g,
      ba = new RegExp("\\\\([\\da-f]{1,6}" + L + "?|(" + L + ")|.)", "ig"),
      ca = function (a, b, c) {
        var d = "0x" + b - 65536;
        return d !== d || c
          ? b
          : 0 > d
          ? String.fromCharCode(d + 65536)
          : String.fromCharCode((d >> 10) | 55296, (1023 & d) | 56320);
      },
      da = function () {
        m();
      };
    try {
      H.apply((E = I.call(v.childNodes)), v.childNodes),
        E[v.childNodes.length].nodeType;
    } catch (ea) {
      H = {
        apply: E.length
          ? function (a, b) {
              G.apply(a, I.call(b));
            }
          : function (a, b) {
              var c = a.length,
                d = 0;
              while ((a[c++] = b[d++]));
              a.length = c - 1;
            },
      };
    }
    function fa(a, b, d, e) {
      var f,
        h,
        j,
        k,
        l,
        o,
        r,
        s,
        w = b && b.ownerDocument,
        x = b ? b.nodeType : 9;
      if (
        ((d = d || []),
        "string" != typeof a || !a || (1 !== x && 9 !== x && 11 !== x))
      )
        return d;
      if (
        !e &&
        ((b ? b.ownerDocument || b : v) !== n && m(b), (b = b || n), p)
      ) {
        if (11 !== x && (o = $.exec(a)))
          if ((f = o[1])) {
            if (9 === x) {
              if (!(j = b.getElementById(f))) return d;
              if (j.id === f) return d.push(j), d;
            } else if (w && (j = w.getElementById(f)) && t(b, j) && j.id === f)
              return d.push(j), d;
          } else {
            if (o[2]) return H.apply(d, b.getElementsByTagName(a)), d;
            if (
              (f = o[3]) &&
              c.getElementsByClassName &&
              b.getElementsByClassName
            )
              return H.apply(d, b.getElementsByClassName(f)), d;
          }
        if (c.qsa && !A[a + " "] && (!q || !q.test(a))) {
          if (1 !== x) (w = b), (s = a);
          else if ("object" !== b.nodeName.toLowerCase()) {
            (k = b.getAttribute("id"))
              ? (k = k.replace(aa, "\\$&"))
              : b.setAttribute("id", (k = u)),
              (r = g(a)),
              (h = r.length),
              (l = V.test(k) ? "#" + k : "[id='" + k + "']");
            while (h--) r[h] = l + " " + qa(r[h]);
            (s = r.join(",")), (w = (_.test(a) && oa(b.parentNode)) || b);
          }
          if (s)
            try {
              return H.apply(d, w.querySelectorAll(s)), d;
            } catch (y) {
            } finally {
              k === u && b.removeAttribute("id");
            }
        }
      }
      return i(a.replace(Q, "$1"), b, d, e);
    }
    function ga() {
      var a = [];
      function b(c, e) {
        return (
          a.push(c + " ") > d.cacheLength && delete b[a.shift()],
          (b[c + " "] = e)
        );
      }
      return b;
    }
    function ha(a) {
      return (a[u] = !0), a;
    }
    function ia(a) {
      var b = n.createElement("div");
      try {
        return !!a(b);
      } catch (c) {
        return !1;
      } finally {
        b.parentNode && b.parentNode.removeChild(b), (b = null);
      }
    }
    function ja(a, b) {
      var c = a.split("|"),
        e = c.length;
      while (e--) d.attrHandle[c[e]] = b;
    }
    function ka(a, b) {
      var c = b && a,
        d =
          c &&
          1 === a.nodeType &&
          1 === b.nodeType &&
          (~b.sourceIndex || C) - (~a.sourceIndex || C);
      if (d) return d;
      if (c) while ((c = c.nextSibling)) if (c === b) return -1;
      return a ? 1 : -1;
    }
    function la(a) {
      return function (b) {
        var c = b.nodeName.toLowerCase();
        return "input" === c && b.type === a;
      };
    }
    function ma(a) {
      return function (b) {
        var c = b.nodeName.toLowerCase();
        return ("input" === c || "button" === c) && b.type === a;
      };
    }
    function na(a) {
      return ha(function (b) {
        return (
          (b = +b),
          ha(function (c, d) {
            var e,
              f = a([], c.length, b),
              g = f.length;
            while (g--) c[(e = f[g])] && (c[e] = !(d[e] = c[e]));
          })
        );
      });
    }
    function oa(a) {
      return a && "undefined" != typeof a.getElementsByTagName && a;
    }
    (c = fa.support = {}),
      (f = fa.isXML =
        function (a) {
          var b = a && (a.ownerDocument || a).documentElement;
          return b ? "HTML" !== b.nodeName : !1;
        }),
      (m = fa.setDocument =
        function (a) {
          var b,
            e,
            g = a ? a.ownerDocument || a : v;
          return g !== n && 9 === g.nodeType && g.documentElement
            ? ((n = g),
              (o = n.documentElement),
              (p = !f(n)),
              (e = n.defaultView) &&
                e.top !== e &&
                (e.addEventListener
                  ? e.addEventListener("unload", da, !1)
                  : e.attachEvent && e.attachEvent("onunload", da)),
              (c.attributes = ia(function (a) {
                return (a.className = "i"), !a.getAttribute("className");
              })),
              (c.getElementsByTagName = ia(function (a) {
                return (
                  a.appendChild(n.createComment("")),
                  !a.getElementsByTagName("*").length
                );
              })),
              (c.getElementsByClassName = Z.test(n.getElementsByClassName)),
              (c.getById = ia(function (a) {
                return (
                  (o.appendChild(a).id = u),
                  !n.getElementsByName || !n.getElementsByName(u).length
                );
              })),
              c.getById
                ? ((d.find.ID = function (a, b) {
                    if ("undefined" != typeof b.getElementById && p) {
                      var c = b.getElementById(a);
                      return c ? [c] : [];
                    }
                  }),
                  (d.filter.ID = function (a) {
                    var b = a.replace(ba, ca);
                    return function (a) {
                      return a.getAttribute("id") === b;
                    };
                  }))
                : (delete d.find.ID,
                  (d.filter.ID = function (a) {
                    var b = a.replace(ba, ca);
                    return function (a) {
                      var c =
                        "undefined" != typeof a.getAttributeNode &&
                        a.getAttributeNode("id");
                      return c && c.value === b;
                    };
                  })),
              (d.find.TAG = c.getElementsByTagName
                ? function (a, b) {
                    return "undefined" != typeof b.getElementsByTagName
                      ? b.getElementsByTagName(a)
                      : c.qsa
                      ? b.querySelectorAll(a)
                      : void 0;
                  }
                : function (a, b) {
                    var c,
                      d = [],
                      e = 0,
                      f = b.getElementsByTagName(a);
                    if ("*" === a) {
                      while ((c = f[e++])) 1 === c.nodeType && d.push(c);
                      return d;
                    }
                    return f;
                  }),
              (d.find.CLASS =
                c.getElementsByClassName &&
                function (a, b) {
                  return "undefined" != typeof b.getElementsByClassName && p
                    ? b.getElementsByClassName(a)
                    : void 0;
                }),
              (r = []),
              (q = []),
              (c.qsa = Z.test(n.querySelectorAll)) &&
                (ia(function (a) {
                  (o.appendChild(a).innerHTML =
                    "<a id='" +
                    u +
                    "'></a><select id='" +
                    u +
                    "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                    a.querySelectorAll("[msallowcapture^='']").length &&
                      q.push("[*^$]=" + L + "*(?:''|\"\")"),
                    a.querySelectorAll("[selected]").length ||
                      q.push("\\[" + L + "*(?:value|" + K + ")"),
                    a.querySelectorAll("[id~=" + u + "-]").length ||
                      q.push("~="),
                    a.querySelectorAll(":checked").length || q.push(":checked"),
                    a.querySelectorAll("a#" + u + "+*").length ||
                      q.push(".#.+[+~]");
                }),
                ia(function (a) {
                  var b = n.createElement("input");
                  b.setAttribute("type", "hidden"),
                    a.appendChild(b).setAttribute("name", "D"),
                    a.querySelectorAll("[name=d]").length &&
                      q.push("name" + L + "*[*^$|!~]?="),
                    a.querySelectorAll(":enabled").length ||
                      q.push(":enabled", ":disabled"),
                    a.querySelectorAll("*,:x"),
                    q.push(",.*:");
                })),
              (c.matchesSelector = Z.test(
                (s =
                  o.matches ||
                  o.webkitMatchesSelector ||
                  o.mozMatchesSelector ||
                  o.oMatchesSelector ||
                  o.msMatchesSelector)
              )) &&
                ia(function (a) {
                  (c.disconnectedMatch = s.call(a, "div")),
                    s.call(a, "[s!='']:x"),
                    r.push("!=", O);
                }),
              (q = q.length && new RegExp(q.join("|"))),
              (r = r.length && new RegExp(r.join("|"))),
              (b = Z.test(o.compareDocumentPosition)),
              (t =
                b || Z.test(o.contains)
                  ? function (a, b) {
                      var c = 9 === a.nodeType ? a.documentElement : a,
                        d = b && b.parentNode;
                      return (
                        a === d ||
                        !(
                          !d ||
                          1 !== d.nodeType ||
                          !(c.contains
                            ? c.contains(d)
                            : a.compareDocumentPosition &&
                              16 & a.compareDocumentPosition(d))
                        )
                      );
                    }
                  : function (a, b) {
                      if (b) while ((b = b.parentNode)) if (b === a) return !0;
                      return !1;
                    }),
              (B = b
                ? function (a, b) {
                    if (a === b) return (l = !0), 0;
                    var d =
                      !a.compareDocumentPosition - !b.compareDocumentPosition;
                    return d
                      ? d
                      : ((d =
                          (a.ownerDocument || a) === (b.ownerDocument || b)
                            ? a.compareDocumentPosition(b)
                            : 1),
                        1 & d ||
                        (!c.sortDetached && b.compareDocumentPosition(a) === d)
                          ? a === n || (a.ownerDocument === v && t(v, a))
                            ? -1
                            : b === n || (b.ownerDocument === v && t(v, b))
                            ? 1
                            : k
                            ? J(k, a) - J(k, b)
                            : 0
                          : 4 & d
                          ? -1
                          : 1);
                  }
                : function (a, b) {
                    if (a === b) return (l = !0), 0;
                    var c,
                      d = 0,
                      e = a.parentNode,
                      f = b.parentNode,
                      g = [a],
                      h = [b];
                    if (!e || !f)
                      return a === n
                        ? -1
                        : b === n
                        ? 1
                        : e
                        ? -1
                        : f
                        ? 1
                        : k
                        ? J(k, a) - J(k, b)
                        : 0;
                    if (e === f) return ka(a, b);
                    c = a;
                    while ((c = c.parentNode)) g.unshift(c);
                    c = b;
                    while ((c = c.parentNode)) h.unshift(c);
                    while (g[d] === h[d]) d++;
                    return d
                      ? ka(g[d], h[d])
                      : g[d] === v
                      ? -1
                      : h[d] === v
                      ? 1
                      : 0;
                  }),
              n)
            : n;
        }),
      (fa.matches = function (a, b) {
        return fa(a, null, null, b);
      }),
      (fa.matchesSelector = function (a, b) {
        if (
          ((a.ownerDocument || a) !== n && m(a),
          (b = b.replace(T, "='$1']")),
          c.matchesSelector &&
            p &&
            !A[b + " "] &&
            (!r || !r.test(b)) &&
            (!q || !q.test(b)))
        )
          try {
            var d = s.call(a, b);
            if (
              d ||
              c.disconnectedMatch ||
              (a.document && 11 !== a.document.nodeType)
            )
              return d;
          } catch (e) {}
        return fa(b, n, null, [a]).length > 0;
      }),
      (fa.contains = function (a, b) {
        return (a.ownerDocument || a) !== n && m(a), t(a, b);
      }),
      (fa.attr = function (a, b) {
        (a.ownerDocument || a) !== n && m(a);
        var e = d.attrHandle[b.toLowerCase()],
          f = e && D.call(d.attrHandle, b.toLowerCase()) ? e(a, b, !p) : void 0;
        return void 0 !== f
          ? f
          : c.attributes || !p
          ? a.getAttribute(b)
          : (f = a.getAttributeNode(b)) && f.specified
          ? f.value
          : null;
      }),
      (fa.error = function (a) {
        throw new Error("Syntax error, unrecognized expression: " + a);
      }),
      (fa.uniqueSort = function (a) {
        var b,
          d = [],
          e = 0,
          f = 0;
        if (
          ((l = !c.detectDuplicates),
          (k = !c.sortStable && a.slice(0)),
          a.sort(B),
          l)
        ) {
          while ((b = a[f++])) b === a[f] && (e = d.push(f));
          while (e--) a.splice(d[e], 1);
        }
        return (k = null), a;
      }),
      (e = fa.getText =
        function (a) {
          var b,
            c = "",
            d = 0,
            f = a.nodeType;
          if (f) {
            if (1 === f || 9 === f || 11 === f) {
              if ("string" == typeof a.textContent) return a.textContent;
              for (a = a.firstChild; a; a = a.nextSibling) c += e(a);
            } else if (3 === f || 4 === f) return a.nodeValue;
          } else while ((b = a[d++])) c += e(b);
          return c;
        }),
      (d = fa.selectors =
        {
          cacheLength: 50,
          createPseudo: ha,
          match: W,
          attrHandle: {},
          find: {},
          relative: {
            ">": { dir: "parentNode", first: !0 },
            " ": { dir: "parentNode" },
            "+": { dir: "previousSibling", first: !0 },
            "~": { dir: "previousSibling" },
          },
          preFilter: {
            ATTR: function (a) {
              return (
                (a[1] = a[1].replace(ba, ca)),
                (a[3] = (a[3] || a[4] || a[5] || "").replace(ba, ca)),
                "~=" === a[2] && (a[3] = " " + a[3] + " "),
                a.slice(0, 4)
              );
            },
            CHILD: function (a) {
              return (
                (a[1] = a[1].toLowerCase()),
                "nth" === a[1].slice(0, 3)
                  ? (a[3] || fa.error(a[0]),
                    (a[4] = +(a[4]
                      ? a[5] + (a[6] || 1)
                      : 2 * ("even" === a[3] || "odd" === a[3]))),
                    (a[5] = +(a[7] + a[8] || "odd" === a[3])))
                  : a[3] && fa.error(a[0]),
                a
              );
            },
            PSEUDO: function (a) {
              var b,
                c = !a[6] && a[2];
              return W.CHILD.test(a[0])
                ? null
                : (a[3]
                    ? (a[2] = a[4] || a[5] || "")
                    : c &&
                      U.test(c) &&
                      (b = g(c, !0)) &&
                      (b = c.indexOf(")", c.length - b) - c.length) &&
                      ((a[0] = a[0].slice(0, b)), (a[2] = c.slice(0, b))),
                  a.slice(0, 3));
            },
          },
          filter: {
            TAG: function (a) {
              var b = a.replace(ba, ca).toLowerCase();
              return "*" === a
                ? function () {
                    return !0;
                  }
                : function (a) {
                    return a.nodeName && a.nodeName.toLowerCase() === b;
                  };
            },
            CLASS: function (a) {
              var b = y[a + " "];
              return (
                b ||
                ((b = new RegExp("(^|" + L + ")" + a + "(" + L + "|$)")) &&
                  y(a, function (a) {
                    return b.test(
                      ("string" == typeof a.className && a.className) ||
                        ("undefined" != typeof a.getAttribute &&
                          a.getAttribute("class")) ||
                        ""
                    );
                  }))
              );
            },
            ATTR: function (a, b, c) {
              return function (d) {
                var e = fa.attr(d, a);
                return null == e
                  ? "!=" === b
                  : b
                  ? ((e += ""),
                    "=" === b
                      ? e === c
                      : "!=" === b
                      ? e !== c
                      : "^=" === b
                      ? c && 0 === e.indexOf(c)
                      : "*=" === b
                      ? c && e.indexOf(c) > -1
                      : "$=" === b
                      ? c && e.slice(-c.length) === c
                      : "~=" === b
                      ? (" " + e.replace(P, " ") + " ").indexOf(c) > -1
                      : "|=" === b
                      ? e === c || e.slice(0, c.length + 1) === c + "-"
                      : !1)
                  : !0;
              };
            },
            CHILD: function (a, b, c, d, e) {
              var f = "nth" !== a.slice(0, 3),
                g = "last" !== a.slice(-4),
                h = "of-type" === b;
              return 1 === d && 0 === e
                ? function (a) {
                    return !!a.parentNode;
                  }
                : function (b, c, i) {
                    var j,
                      k,
                      l,
                      m,
                      n,
                      o,
                      p = f !== g ? "nextSibling" : "previousSibling",
                      q = b.parentNode,
                      r = h && b.nodeName.toLowerCase(),
                      s = !i && !h,
                      t = !1;
                    if (q) {
                      if (f) {
                        while (p) {
                          m = b;
                          while ((m = m[p]))
                            if (
                              h
                                ? m.nodeName.toLowerCase() === r
                                : 1 === m.nodeType
                            )
                              return !1;
                          o = p = "only" === a && !o && "nextSibling";
                        }
                        return !0;
                      }
                      if (((o = [g ? q.firstChild : q.lastChild]), g && s)) {
                        (m = q),
                          (l = m[u] || (m[u] = {})),
                          (k = l[m.uniqueID] || (l[m.uniqueID] = {})),
                          (j = k[a] || []),
                          (n = j[0] === w && j[1]),
                          (t = n && j[2]),
                          (m = n && q.childNodes[n]);
                        while (
                          (m = (++n && m && m[p]) || (t = n = 0) || o.pop())
                        )
                          if (1 === m.nodeType && ++t && m === b) {
                            k[a] = [w, n, t];
                            break;
                          }
                      } else if (
                        (s &&
                          ((m = b),
                          (l = m[u] || (m[u] = {})),
                          (k = l[m.uniqueID] || (l[m.uniqueID] = {})),
                          (j = k[a] || []),
                          (n = j[0] === w && j[1]),
                          (t = n)),
                        t === !1)
                      )
                        while (
                          (m = (++n && m && m[p]) || (t = n = 0) || o.pop())
                        )
                          if (
                            (h
                              ? m.nodeName.toLowerCase() === r
                              : 1 === m.nodeType) &&
                            ++t &&
                            (s &&
                              ((l = m[u] || (m[u] = {})),
                              (k = l[m.uniqueID] || (l[m.uniqueID] = {})),
                              (k[a] = [w, t])),
                            m === b)
                          )
                            break;
                      return (t -= e), t === d || (t % d === 0 && t / d >= 0);
                    }
                  };
            },
            PSEUDO: function (a, b) {
              var c,
                e =
                  d.pseudos[a] ||
                  d.setFilters[a.toLowerCase()] ||
                  fa.error("unsupported pseudo: " + a);
              return e[u]
                ? e(b)
                : e.length > 1
                ? ((c = [a, a, "", b]),
                  d.setFilters.hasOwnProperty(a.toLowerCase())
                    ? ha(function (a, c) {
                        var d,
                          f = e(a, b),
                          g = f.length;
                        while (g--) (d = J(a, f[g])), (a[d] = !(c[d] = f[g]));
                      })
                    : function (a) {
                        return e(a, 0, c);
                      })
                : e;
            },
          },
          pseudos: {
            not: ha(function (a) {
              var b = [],
                c = [],
                d = h(a.replace(Q, "$1"));
              return d[u]
                ? ha(function (a, b, c, e) {
                    var f,
                      g = d(a, null, e, []),
                      h = a.length;
                    while (h--) (f = g[h]) && (a[h] = !(b[h] = f));
                  })
                : function (a, e, f) {
                    return (
                      (b[0] = a), d(b, null, f, c), (b[0] = null), !c.pop()
                    );
                  };
            }),
            has: ha(function (a) {
              return function (b) {
                return fa(a, b).length > 0;
              };
            }),
            contains: ha(function (a) {
              return (
                (a = a.replace(ba, ca)),
                function (b) {
                  return (b.textContent || b.innerText || e(b)).indexOf(a) > -1;
                }
              );
            }),
            lang: ha(function (a) {
              return (
                V.test(a || "") || fa.error("unsupported lang: " + a),
                (a = a.replace(ba, ca).toLowerCase()),
                function (b) {
                  var c;
                  do
                    if (
                      (c = p
                        ? b.lang
                        : b.getAttribute("xml:lang") || b.getAttribute("lang"))
                    )
                      return (
                        (c = c.toLowerCase()),
                        c === a || 0 === c.indexOf(a + "-")
                      );
                  while ((b = b.parentNode) && 1 === b.nodeType);
                  return !1;
                }
              );
            }),
            target: function (b) {
              var c = a.location && a.location.hash;
              return c && c.slice(1) === b.id;
            },
            root: function (a) {
              return a === o;
            },
            focus: function (a) {
              return (
                a === n.activeElement &&
                (!n.hasFocus || n.hasFocus()) &&
                !!(a.type || a.href || ~a.tabIndex)
              );
            },
            enabled: function (a) {
              return a.disabled === !1;
            },
            disabled: function (a) {
              return a.disabled === !0;
            },
            checked: function (a) {
              var b = a.nodeName.toLowerCase();
              return (
                ("input" === b && !!a.checked) ||
                ("option" === b && !!a.selected)
              );
            },
            selected: function (a) {
              return (
                a.parentNode && a.parentNode.selectedIndex, a.selected === !0
              );
            },
            empty: function (a) {
              for (a = a.firstChild; a; a = a.nextSibling)
                if (a.nodeType < 6) return !1;
              return !0;
            },
            parent: function (a) {
              return !d.pseudos.empty(a);
            },
            header: function (a) {
              return Y.test(a.nodeName);
            },
            input: function (a) {
              return X.test(a.nodeName);
            },
            button: function (a) {
              var b = a.nodeName.toLowerCase();
              return ("input" === b && "button" === a.type) || "button" === b;
            },
            text: function (a) {
              var b;
              return (
                "input" === a.nodeName.toLowerCase() &&
                "text" === a.type &&
                (null == (b = a.getAttribute("type")) ||
                  "text" === b.toLowerCase())
              );
            },
            first: na(function () {
              return [0];
            }),
            last: na(function (a, b) {
              return [b - 1];
            }),
            eq: na(function (a, b, c) {
              return [0 > c ? c + b : c];
            }),
            even: na(function (a, b) {
              for (var c = 0; b > c; c += 2) a.push(c);
              return a;
            }),
            odd: na(function (a, b) {
              for (var c = 1; b > c; c += 2) a.push(c);
              return a;
            }),
            lt: na(function (a, b, c) {
              for (var d = 0 > c ? c + b : c; --d >= 0; ) a.push(d);
              return a;
            }),
            gt: na(function (a, b, c) {
              for (var d = 0 > c ? c + b : c; ++d < b; ) a.push(d);
              return a;
            }),
          },
        }),
      (d.pseudos.nth = d.pseudos.eq);
    for (b in { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 })
      d.pseudos[b] = la(b);
    for (b in { submit: !0, reset: !0 }) d.pseudos[b] = ma(b);
    function pa() {}
    (pa.prototype = d.filters = d.pseudos),
      (d.setFilters = new pa()),
      (g = fa.tokenize =
        function (a, b) {
          var c,
            e,
            f,
            g,
            h,
            i,
            j,
            k = z[a + " "];
          if (k) return b ? 0 : k.slice(0);
          (h = a), (i = []), (j = d.preFilter);
          while (h) {
            (c && !(e = R.exec(h))) ||
              (e && (h = h.slice(e[0].length) || h), i.push((f = []))),
              (c = !1),
              (e = S.exec(h)) &&
                ((c = e.shift()),
                f.push({ value: c, type: e[0].replace(Q, " ") }),
                (h = h.slice(c.length)));
            for (g in d.filter)
              !(e = W[g].exec(h)) ||
                (j[g] && !(e = j[g](e))) ||
                ((c = e.shift()),
                f.push({ value: c, type: g, matches: e }),
                (h = h.slice(c.length)));
            if (!c) break;
          }
          return b ? h.length : h ? fa.error(a) : z(a, i).slice(0);
        });
    function qa(a) {
      for (var b = 0, c = a.length, d = ""; c > b; b++) d += a[b].value;
      return d;
    }
    function ra(a, b, c) {
      var d = b.dir,
        e = c && "parentNode" === d,
        f = x++;
      return b.first
        ? function (b, c, f) {
            while ((b = b[d])) if (1 === b.nodeType || e) return a(b, c, f);
          }
        : function (b, c, g) {
            var h,
              i,
              j,
              k = [w, f];
            if (g) {
              while ((b = b[d]))
                if ((1 === b.nodeType || e) && a(b, c, g)) return !0;
            } else
              while ((b = b[d]))
                if (1 === b.nodeType || e) {
                  if (
                    ((j = b[u] || (b[u] = {})),
                    (i = j[b.uniqueID] || (j[b.uniqueID] = {})),
                    (h = i[d]) && h[0] === w && h[1] === f)
                  )
                    return (k[2] = h[2]);
                  if (((i[d] = k), (k[2] = a(b, c, g)))) return !0;
                }
          };
    }
    function sa(a) {
      return a.length > 1
        ? function (b, c, d) {
            var e = a.length;
            while (e--) if (!a[e](b, c, d)) return !1;
            return !0;
          }
        : a[0];
    }
    function ta(a, b, c) {
      for (var d = 0, e = b.length; e > d; d++) fa(a, b[d], c);
      return c;
    }
    function ua(a, b, c, d, e) {
      for (var f, g = [], h = 0, i = a.length, j = null != b; i > h; h++)
        (f = a[h]) && ((c && !c(f, d, e)) || (g.push(f), j && b.push(h)));
      return g;
    }
    function va(a, b, c, d, e, f) {
      return (
        d && !d[u] && (d = va(d)),
        e && !e[u] && (e = va(e, f)),
        ha(function (f, g, h, i) {
          var j,
            k,
            l,
            m = [],
            n = [],
            o = g.length,
            p = f || ta(b || "*", h.nodeType ? [h] : h, []),
            q = !a || (!f && b) ? p : ua(p, m, a, h, i),
            r = c ? (e || (f ? a : o || d) ? [] : g) : q;
          if ((c && c(q, r, h, i), d)) {
            (j = ua(r, n)), d(j, [], h, i), (k = j.length);
            while (k--) (l = j[k]) && (r[n[k]] = !(q[n[k]] = l));
          }
          if (f) {
            if (e || a) {
              if (e) {
                (j = []), (k = r.length);
                while (k--) (l = r[k]) && j.push((q[k] = l));
                e(null, (r = []), j, i);
              }
              k = r.length;
              while (k--)
                (l = r[k]) &&
                  (j = e ? J(f, l) : m[k]) > -1 &&
                  (f[j] = !(g[j] = l));
            }
          } else (r = ua(r === g ? r.splice(o, r.length) : r)), e ? e(null, g, r, i) : H.apply(g, r);
        })
      );
    }
    function wa(a) {
      for (
        var b,
          c,
          e,
          f = a.length,
          g = d.relative[a[0].type],
          h = g || d.relative[" "],
          i = g ? 1 : 0,
          k = ra(
            function (a) {
              return a === b;
            },
            h,
            !0
          ),
          l = ra(
            function (a) {
              return J(b, a) > -1;
            },
            h,
            !0
          ),
          m = [
            function (a, c, d) {
              var e =
                (!g && (d || c !== j)) ||
                ((b = c).nodeType ? k(a, c, d) : l(a, c, d));
              return (b = null), e;
            },
          ];
        f > i;
        i++
      )
        if ((c = d.relative[a[i].type])) m = [ra(sa(m), c)];
        else {
          if (((c = d.filter[a[i].type].apply(null, a[i].matches)), c[u])) {
            for (e = ++i; f > e; e++) if (d.relative[a[e].type]) break;
            return va(
              i > 1 && sa(m),
              i > 1 &&
                qa(
                  a
                    .slice(0, i - 1)
                    .concat({ value: " " === a[i - 2].type ? "*" : "" })
                ).replace(Q, "$1"),
              c,
              e > i && wa(a.slice(i, e)),
              f > e && wa((a = a.slice(e))),
              f > e && qa(a)
            );
          }
          m.push(c);
        }
      return sa(m);
    }
    function xa(a, b) {
      var c = b.length > 0,
        e = a.length > 0,
        f = function (f, g, h, i, k) {
          var l,
            o,
            q,
            r = 0,
            s = "0",
            t = f && [],
            u = [],
            v = j,
            x = f || (e && d.find.TAG("*", k)),
            y = (w += null == v ? 1 : Math.random() || 0.1),
            z = x.length;
          for (
            k && (j = g === n || g || k);
            s !== z && null != (l = x[s]);
            s++
          ) {
            if (e && l) {
              (o = 0), g || l.ownerDocument === n || (m(l), (h = !p));
              while ((q = a[o++]))
                if (q(l, g || n, h)) {
                  i.push(l);
                  break;
                }
              k && (w = y);
            }
            c && ((l = !q && l) && r--, f && t.push(l));
          }
          if (((r += s), c && s !== r)) {
            o = 0;
            while ((q = b[o++])) q(t, u, g, h);
            if (f) {
              if (r > 0) while (s--) t[s] || u[s] || (u[s] = F.call(i));
              u = ua(u);
            }
            H.apply(i, u),
              k && !f && u.length > 0 && r + b.length > 1 && fa.uniqueSort(i);
          }
          return k && ((w = y), (j = v)), t;
        };
      return c ? ha(f) : f;
    }
    return (
      (h = fa.compile =
        function (a, b) {
          var c,
            d = [],
            e = [],
            f = A[a + " "];
          if (!f) {
            b || (b = g(a)), (c = b.length);
            while (c--) (f = wa(b[c])), f[u] ? d.push(f) : e.push(f);
            (f = A(a, xa(e, d))), (f.selector = a);
          }
          return f;
        }),
      (i = fa.select =
        function (a, b, e, f) {
          var i,
            j,
            k,
            l,
            m,
            n = "function" == typeof a && a,
            o = !f && g((a = n.selector || a));
          if (((e = e || []), 1 === o.length)) {
            if (
              ((j = o[0] = o[0].slice(0)),
              j.length > 2 &&
                "ID" === (k = j[0]).type &&
                c.getById &&
                9 === b.nodeType &&
                p &&
                d.relative[j[1].type])
            ) {
              if (
                ((b = (d.find.ID(k.matches[0].replace(ba, ca), b) || [])[0]),
                !b)
              )
                return e;
              n && (b = b.parentNode), (a = a.slice(j.shift().value.length));
            }
            i = W.needsContext.test(a) ? 0 : j.length;
            while (i--) {
              if (((k = j[i]), d.relative[(l = k.type)])) break;
              if (
                (m = d.find[l]) &&
                (f = m(
                  k.matches[0].replace(ba, ca),
                  (_.test(j[0].type) && oa(b.parentNode)) || b
                ))
              ) {
                if ((j.splice(i, 1), (a = f.length && qa(j)), !a))
                  return H.apply(e, f), e;
                break;
              }
            }
          }
          return (
            (n || h(a, o))(
              f,
              b,
              !p,
              e,
              !b || (_.test(a) && oa(b.parentNode)) || b
            ),
            e
          );
        }),
      (c.sortStable = u.split("").sort(B).join("") === u),
      (c.detectDuplicates = !!l),
      m(),
      (c.sortDetached = ia(function (a) {
        return 1 & a.compareDocumentPosition(n.createElement("div"));
      })),
      ia(function (a) {
        return (
          (a.innerHTML = "<a href='#'></a>"),
          "#" === a.firstChild.getAttribute("href")
        );
      }) ||
        ja("type|href|height|width", function (a, b, c) {
          return c
            ? void 0
            : a.getAttribute(b, "type" === b.toLowerCase() ? 1 : 2);
        }),
      (c.attributes &&
        ia(function (a) {
          return (
            (a.innerHTML = "<input/>"),
            a.firstChild.setAttribute("value", ""),
            "" === a.firstChild.getAttribute("value")
          );
        })) ||
        ja("value", function (a, b, c) {
          return c || "input" !== a.nodeName.toLowerCase()
            ? void 0
            : a.defaultValue;
        }),
      ia(function (a) {
        return null == a.getAttribute("disabled");
      }) ||
        ja(K, function (a, b, c) {
          var d;
          return c
            ? void 0
            : a[b] === !0
            ? b.toLowerCase()
            : (d = a.getAttributeNode(b)) && d.specified
            ? d.value
            : null;
        }),
      fa
    );
  })(a);
  (n.find = t),
    (n.expr = t.selectors),
    (n.expr[":"] = n.expr.pseudos),
    (n.uniqueSort = n.unique = t.uniqueSort),
    (n.text = t.getText),
    (n.isXMLDoc = t.isXML),
    (n.contains = t.contains);
  var u = function (a, b, c) {
      var d = [],
        e = void 0 !== c;
      while ((a = a[b]) && 9 !== a.nodeType)
        if (1 === a.nodeType) {
          if (e && n(a).is(c)) break;
          d.push(a);
        }
      return d;
    },
    v = function (a, b) {
      for (var c = []; a; a = a.nextSibling)
        1 === a.nodeType && a !== b && c.push(a);
      return c;
    },
    w = n.expr.match.needsContext,
    x = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/,
    y = /^.[^:#\[\.,]*$/;
  function z(a, b, c) {
    if (n.isFunction(b))
      return n.grep(a, function (a, d) {
        return !!b.call(a, d, a) !== c;
      });
    if (b.nodeType)
      return n.grep(a, function (a) {
        return (a === b) !== c;
      });
    if ("string" == typeof b) {
      if (y.test(b)) return n.filter(b, a, c);
      b = n.filter(b, a);
    }
    return n.grep(a, function (a) {
      return n.inArray(a, b) > -1 !== c;
    });
  }
  (n.filter = function (a, b, c) {
    var d = b[0];
    return (
      c && (a = ":not(" + a + ")"),
      1 === b.length && 1 === d.nodeType
        ? n.find.matchesSelector(d, a)
          ? [d]
          : []
        : n.find.matches(
            a,
            n.grep(b, function (a) {
              return 1 === a.nodeType;
            })
          )
    );
  }),
    n.fn.extend({
      find: function (a) {
        var b,
          c = [],
          d = this,
          e = d.length;
        if ("string" != typeof a)
          return this.pushStack(
            n(a).filter(function () {
              for (b = 0; e > b; b++) if (n.contains(d[b], this)) return !0;
            })
          );
        for (b = 0; e > b; b++) n.find(a, d[b], c);
        return (
          (c = this.pushStack(e > 1 ? n.unique(c) : c)),
          (c.selector = this.selector ? this.selector + " " + a : a),
          c
        );
      },
      filter: function (a) {
        return this.pushStack(z(this, a || [], !1));
      },
      not: function (a) {
        return this.pushStack(z(this, a || [], !0));
      },
      is: function (a) {
        return !!z(this, "string" == typeof a && w.test(a) ? n(a) : a || [], !1)
          .length;
      },
    });
  var A,
    B = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
    C = (n.fn.init = function (a, b, c) {
      var e, f;
      if (!a) return this;
      if (((c = c || A), "string" == typeof a)) {
        if (
          ((e =
            "<" === a.charAt(0) &&
            ">" === a.charAt(a.length - 1) &&
            a.length >= 3
              ? [null, a, null]
              : B.exec(a)),
          !e || (!e[1] && b))
        )
          return !b || b.jquery
            ? (b || c).find(a)
            : this.constructor(b).find(a);
        if (e[1]) {
          if (
            ((b = b instanceof n ? b[0] : b),
            n.merge(
              this,
              n.parseHTML(e[1], b && b.nodeType ? b.ownerDocument || b : d, !0)
            ),
            x.test(e[1]) && n.isPlainObject(b))
          )
            for (e in b)
              n.isFunction(this[e]) ? this[e](b[e]) : this.attr(e, b[e]);
          return this;
        }
        if (((f = d.getElementById(e[2])), f && f.parentNode)) {
          if (f.id !== e[2]) return A.find(a);
          (this.length = 1), (this[0] = f);
        }
        return (this.context = d), (this.selector = a), this;
      }
      return a.nodeType
        ? ((this.context = this[0] = a), (this.length = 1), this)
        : n.isFunction(a)
        ? "undefined" != typeof c.ready
          ? c.ready(a)
          : a(n)
        : (void 0 !== a.selector &&
            ((this.selector = a.selector), (this.context = a.context)),
          n.makeArray(a, this));
    });
  (C.prototype = n.fn), (A = n(d));
  var D = /^(?:parents|prev(?:Until|All))/,
    E = { children: !0, contents: !0, next: !0, prev: !0 };
  n.fn.extend({
    has: function (a) {
      var b,
        c = n(a, this),
        d = c.length;
      return this.filter(function () {
        for (b = 0; d > b; b++) if (n.contains(this, c[b])) return !0;
      });
    },
    closest: function (a, b) {
      for (
        var c,
          d = 0,
          e = this.length,
          f = [],
          g = w.test(a) || "string" != typeof a ? n(a, b || this.context) : 0;
        e > d;
        d++
      )
        for (c = this[d]; c && c !== b; c = c.parentNode)
          if (
            c.nodeType < 11 &&
            (g
              ? g.index(c) > -1
              : 1 === c.nodeType && n.find.matchesSelector(c, a))
          ) {
            f.push(c);
            break;
          }
      return this.pushStack(f.length > 1 ? n.uniqueSort(f) : f);
    },
    index: function (a) {
      return a
        ? "string" == typeof a
          ? n.inArray(this[0], n(a))
          : n.inArray(a.jquery ? a[0] : a, this)
        : this[0] && this[0].parentNode
        ? this.first().prevAll().length
        : -1;
    },
    add: function (a, b) {
      return this.pushStack(n.uniqueSort(n.merge(this.get(), n(a, b))));
    },
    addBack: function (a) {
      return this.add(null == a ? this.prevObject : this.prevObject.filter(a));
    },
  });
  function F(a, b) {
    do a = a[b];
    while (a && 1 !== a.nodeType);
    return a;
  }
  n.each(
    {
      parent: function (a) {
        var b = a.parentNode;
        return b && 11 !== b.nodeType ? b : null;
      },
      parents: function (a) {
        return u(a, "parentNode");
      },
      parentsUntil: function (a, b, c) {
        return u(a, "parentNode", c);
      },
      next: function (a) {
        return F(a, "nextSibling");
      },
      prev: function (a) {
        return F(a, "previousSibling");
      },
      nextAll: function (a) {
        return u(a, "nextSibling");
      },
      prevAll: function (a) {
        return u(a, "previousSibling");
      },
      nextUntil: function (a, b, c) {
        return u(a, "nextSibling", c);
      },
      prevUntil: function (a, b, c) {
        return u(a, "previousSibling", c);
      },
      siblings: function (a) {
        return v((a.parentNode || {}).firstChild, a);
      },
      children: function (a) {
        return v(a.firstChild);
      },
      contents: function (a) {
        return n.nodeName(a, "iframe")
          ? a.contentDocument || a.contentWindow.document
          : n.merge([], a.childNodes);
      },
    },
    function (a, b) {
      n.fn[a] = function (c, d) {
        var e = n.map(this, b, c);
        return (
          "Until" !== a.slice(-5) && (d = c),
          d && "string" == typeof d && (e = n.filter(d, e)),
          this.length > 1 &&
            (E[a] || (e = n.uniqueSort(e)), D.test(a) && (e = e.reverse())),
          this.pushStack(e)
        );
      };
    }
  );
  var G = /\S+/g;
  function H(a) {
    var b = {};
    return (
      n.each(a.match(G) || [], function (a, c) {
        b[c] = !0;
      }),
      b
    );
  }
  (n.Callbacks = function (a) {
    a = "string" == typeof a ? H(a) : n.extend({}, a);
    var b,
      c,
      d,
      e,
      f = [],
      g = [],
      h = -1,
      i = function () {
        for (e = a.once, d = b = !0; g.length; h = -1) {
          c = g.shift();
          while (++h < f.length)
            f[h].apply(c[0], c[1]) === !1 &&
              a.stopOnFalse &&
              ((h = f.length), (c = !1));
        }
        a.memory || (c = !1), (b = !1), e && (f = c ? [] : "");
      },
      j = {
        add: function () {
          return (
            f &&
              (c && !b && ((h = f.length - 1), g.push(c)),
              (function d(b) {
                n.each(b, function (b, c) {
                  n.isFunction(c)
                    ? (a.unique && j.has(c)) || f.push(c)
                    : c && c.length && "string" !== n.type(c) && d(c);
                });
              })(arguments),
              c && !b && i()),
            this
          );
        },
        remove: function () {
          return (
            n.each(arguments, function (a, b) {
              var c;
              while ((c = n.inArray(b, f, c)) > -1)
                f.splice(c, 1), h >= c && h--;
            }),
            this
          );
        },
        has: function (a) {
          return a ? n.inArray(a, f) > -1 : f.length > 0;
        },
        empty: function () {
          return f && (f = []), this;
        },
        disable: function () {
          return (e = g = []), (f = c = ""), this;
        },
        disabled: function () {
          return !f;
        },
        lock: function () {
          return (e = !0), c || j.disable(), this;
        },
        locked: function () {
          return !!e;
        },
        fireWith: function (a, c) {
          return (
            e ||
              ((c = c || []),
              (c = [a, c.slice ? c.slice() : c]),
              g.push(c),
              b || i()),
            this
          );
        },
        fire: function () {
          return j.fireWith(this, arguments), this;
        },
        fired: function () {
          return !!d;
        },
      };
    return j;
  }),
    n.extend({
      Deferred: function (a) {
        var b = [
            ["resolve", "done", n.Callbacks("once memory"), "resolved"],
            ["reject", "fail", n.Callbacks("once memory"), "rejected"],
            ["notify", "progress", n.Callbacks("memory")],
          ],
          c = "pending",
          d = {
            state: function () {
              return c;
            },
            always: function () {
              return e.done(arguments).fail(arguments), this;
            },
            then: function () {
              var a = arguments;
              return n
                .Deferred(function (c) {
                  n.each(b, function (b, f) {
                    var g = n.isFunction(a[b]) && a[b];
                    e[f[1]](function () {
                      var a = g && g.apply(this, arguments);
                      a && n.isFunction(a.promise)
                        ? a
                            .promise()
                            .progress(c.notify)
                            .done(c.resolve)
                            .fail(c.reject)
                        : c[f[0] + "With"](
                            this === d ? c.promise() : this,
                            g ? [a] : arguments
                          );
                    });
                  }),
                    (a = null);
                })
                .promise();
            },
            promise: function (a) {
              return null != a ? n.extend(a, d) : d;
            },
          },
          e = {};
        return (
          (d.pipe = d.then),
          n.each(b, function (a, f) {
            var g = f[2],
              h = f[3];
            (d[f[1]] = g.add),
              h &&
                g.add(
                  function () {
                    c = h;
                  },
                  b[1 ^ a][2].disable,
                  b[2][2].lock
                ),
              (e[f[0]] = function () {
                return e[f[0] + "With"](this === e ? d : this, arguments), this;
              }),
              (e[f[0] + "With"] = g.fireWith);
          }),
          d.promise(e),
          a && a.call(e, e),
          e
        );
      },
      when: function (a) {
        var b = 0,
          c = e.call(arguments),
          d = c.length,
          f = 1 !== d || (a && n.isFunction(a.promise)) ? d : 0,
          g = 1 === f ? a : n.Deferred(),
          h = function (a, b, c) {
            return function (d) {
              (b[a] = this),
                (c[a] = arguments.length > 1 ? e.call(arguments) : d),
                c === i ? g.notifyWith(b, c) : --f || g.resolveWith(b, c);
            };
          },
          i,
          j,
          k;
        if (d > 1)
          for (i = new Array(d), j = new Array(d), k = new Array(d); d > b; b++)
            c[b] && n.isFunction(c[b].promise)
              ? c[b]
                  .promise()
                  .progress(h(b, j, i))
                  .done(h(b, k, c))
                  .fail(g.reject)
              : --f;
        return f || g.resolveWith(k, c), g.promise();
      },
    });
  var I;
  (n.fn.ready = function (a) {
    return n.ready.promise().done(a), this;
  }),
    n.extend({
      isReady: !1,
      readyWait: 1,
      holdReady: function (a) {
        a ? n.readyWait++ : n.ready(!0);
      },
      ready: function (a) {
        (a === !0 ? --n.readyWait : n.isReady) ||
          ((n.isReady = !0),
          (a !== !0 && --n.readyWait > 0) ||
            (I.resolveWith(d, [n]),
            n.fn.triggerHandler &&
              (n(d).triggerHandler("ready"), n(d).off("ready"))));
      },
    });
  function J() {
    d.addEventListener
      ? (d.removeEventListener("DOMContentLoaded", K),
        a.removeEventListener("load", K))
      : (d.detachEvent("onreadystatechange", K), a.detachEvent("onload", K));
  }
  function K() {
    (d.addEventListener ||
      "load" === a.event.type ||
      "complete" === d.readyState) &&
      (J(), n.ready());
  }
  (n.ready.promise = function (b) {
    if (!I)
      if (
        ((I = n.Deferred()),
        "complete" === d.readyState ||
          ("loading" !== d.readyState && !d.documentElement.doScroll))
      )
        a.setTimeout(n.ready);
      else if (d.addEventListener)
        d.addEventListener("DOMContentLoaded", K),
          a.addEventListener("load", K);
      else {
        d.attachEvent("onreadystatechange", K), a.attachEvent("onload", K);
        var c = !1;
        try {
          c = null == a.frameElement && d.documentElement;
        } catch (e) {}
        c &&
          c.doScroll &&
          !(function f() {
            if (!n.isReady) {
              try {
                c.doScroll("left");
              } catch (b) {
                return a.setTimeout(f, 50);
              }
              J(), n.ready();
            }
          })();
      }
    return I.promise(b);
  }),
    n.ready.promise();
  var L;
  for (L in n(l)) break;
  (l.ownFirst = "0" === L),
    (l.inlineBlockNeedsLayout = !1),
    n(function () {
      var a, b, c, e;
      (c = d.getElementsByTagName("body")[0]),
        c &&
          c.style &&
          ((b = d.createElement("div")),
          (e = d.createElement("div")),
          (e.style.cssText =
            "position:absolute;border:0;width:0;height:0;top:0;left:-9999px"),
          c.appendChild(e).appendChild(b),
          "undefined" != typeof b.style.zoom &&
            ((b.style.cssText =
              "display:inline;margin:0;border:0;padding:1px;width:1px;zoom:1"),
            (l.inlineBlockNeedsLayout = a = 3 === b.offsetWidth),
            a && (c.style.zoom = 1)),
          c.removeChild(e));
    }),
    (function () {
      var a = d.createElement("div");
      l.deleteExpando = !0;
      try {
        delete a.test;
      } catch (b) {
        l.deleteExpando = !1;
      }
      a = null;
    })();
  var M = function (a) {
      var b = n.noData[(a.nodeName + " ").toLowerCase()],
        c = +a.nodeType || 1;
      return 1 !== c && 9 !== c
        ? !1
        : !b || (b !== !0 && a.getAttribute("classid") === b);
    },
    N = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
    O = /([A-Z])/g;
  function P(a, b, c) {
    if (void 0 === c && 1 === a.nodeType) {
      var d = "data-" + b.replace(O, "-$1").toLowerCase();
      if (((c = a.getAttribute(d)), "string" == typeof c)) {
        try {
          c =
            "true" === c
              ? !0
              : "false" === c
              ? !1
              : "null" === c
              ? null
              : +c + "" === c
              ? +c
              : N.test(c)
              ? n.parseJSON(c)
              : c;
        } catch (e) {}
        n.data(a, b, c);
      } else c = void 0;
    }
    return c;
  }
  function Q(a) {
    var b;
    for (b in a)
      if (("data" !== b || !n.isEmptyObject(a[b])) && "toJSON" !== b) return !1;
    return !0;
  }
  function R(a, b, d, e) {
    if (M(a)) {
      var f,
        g,
        h = n.expando,
        i = a.nodeType,
        j = i ? n.cache : a,
        k = i ? a[h] : a[h] && h;
      if (
        (k && j[k] && (e || j[k].data)) ||
        void 0 !== d ||
        "string" != typeof b
      )
        return (
          k || (k = i ? (a[h] = c.pop() || n.guid++) : h),
          j[k] || (j[k] = i ? {} : { toJSON: n.noop }),
          ("object" != typeof b && "function" != typeof b) ||
            (e
              ? (j[k] = n.extend(j[k], b))
              : (j[k].data = n.extend(j[k].data, b))),
          (g = j[k]),
          e || (g.data || (g.data = {}), (g = g.data)),
          void 0 !== d && (g[n.camelCase(b)] = d),
          "string" == typeof b
            ? ((f = g[b]), null == f && (f = g[n.camelCase(b)]))
            : (f = g),
          f
        );
    }
  }
  function S(a, b, c) {
    if (M(a)) {
      var d,
        e,
        f = a.nodeType,
        g = f ? n.cache : a,
        h = f ? a[n.expando] : n.expando;
      if (g[h]) {
        if (b && (d = c ? g[h] : g[h].data)) {
          n.isArray(b)
            ? (b = b.concat(n.map(b, n.camelCase)))
            : b in d
            ? (b = [b])
            : ((b = n.camelCase(b)), (b = b in d ? [b] : b.split(" "))),
            (e = b.length);
          while (e--) delete d[b[e]];
          if (c ? !Q(d) : !n.isEmptyObject(d)) return;
        }
        (c || (delete g[h].data, Q(g[h]))) &&
          (f
            ? n.cleanData([a], !0)
            : l.deleteExpando || g != g.window
            ? delete g[h]
            : (g[h] = void 0));
      }
    }
  }
  n.extend({
    cache: {},
    noData: {
      "applet ": !0,
      "embed ": !0,
      "object ": "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000",
    },
    hasData: function (a) {
      return (
        (a = a.nodeType ? n.cache[a[n.expando]] : a[n.expando]), !!a && !Q(a)
      );
    },
    data: function (a, b, c) {
      return R(a, b, c);
    },
    removeData: function (a, b) {
      return S(a, b);
    },
    _data: function (a, b, c) {
      return R(a, b, c, !0);
    },
    _removeData: function (a, b) {
      return S(a, b, !0);
    },
  }),
    n.fn.extend({
      data: function (a, b) {
        var c,
          d,
          e,
          f = this[0],
          g = f && f.attributes;
        if (void 0 === a) {
          if (
            this.length &&
            ((e = n.data(f)), 1 === f.nodeType && !n._data(f, "parsedAttrs"))
          ) {
            c = g.length;
            while (c--)
              g[c] &&
                ((d = g[c].name),
                0 === d.indexOf("data-") &&
                  ((d = n.camelCase(d.slice(5))), P(f, d, e[d])));
            n._data(f, "parsedAttrs", !0);
          }
          return e;
        }
        return "object" == typeof a
          ? this.each(function () {
              n.data(this, a);
            })
          : arguments.length > 1
          ? this.each(function () {
              n.data(this, a, b);
            })
          : f
          ? P(f, a, n.data(f, a))
          : void 0;
      },
      removeData: function (a) {
        return this.each(function () {
          n.removeData(this, a);
        });
      },
    }),
    n.extend({
      queue: function (a, b, c) {
        var d;
        return a
          ? ((b = (b || "fx") + "queue"),
            (d = n._data(a, b)),
            c &&
              (!d || n.isArray(c)
                ? (d = n._data(a, b, n.makeArray(c)))
                : d.push(c)),
            d || [])
          : void 0;
      },
      dequeue: function (a, b) {
        b = b || "fx";
        var c = n.queue(a, b),
          d = c.length,
          e = c.shift(),
          f = n._queueHooks(a, b),
          g = function () {
            n.dequeue(a, b);
          };
        "inprogress" === e && ((e = c.shift()), d--),
          e &&
            ("fx" === b && c.unshift("inprogress"),
            delete f.stop,
            e.call(a, g, f)),
          !d && f && f.empty.fire();
      },
      _queueHooks: function (a, b) {
        var c = b + "queueHooks";
        return (
          n._data(a, c) ||
          n._data(a, c, {
            empty: n.Callbacks("once memory").add(function () {
              n._removeData(a, b + "queue"), n._removeData(a, c);
            }),
          })
        );
      },
    }),
    n.fn.extend({
      queue: function (a, b) {
        var c = 2;
        return (
          "string" != typeof a && ((b = a), (a = "fx"), c--),
          arguments.length < c
            ? n.queue(this[0], a)
            : void 0 === b
            ? this
            : this.each(function () {
                var c = n.queue(this, a, b);
                n._queueHooks(this, a),
                  "fx" === a && "inprogress" !== c[0] && n.dequeue(this, a);
              })
        );
      },
      dequeue: function (a) {
        return this.each(function () {
          n.dequeue(this, a);
        });
      },
      clearQueue: function (a) {
        return this.queue(a || "fx", []);
      },
      promise: function (a, b) {
        var c,
          d = 1,
          e = n.Deferred(),
          f = this,
          g = this.length,
          h = function () {
            --d || e.resolveWith(f, [f]);
          };
        "string" != typeof a && ((b = a), (a = void 0)), (a = a || "fx");
        while (g--)
          (c = n._data(f[g], a + "queueHooks")),
            c && c.empty && (d++, c.empty.add(h));
        return h(), e.promise(b);
      },
    }),
    (function () {
      var a;
      l.shrinkWrapBlocks = function () {
        if (null != a) return a;
        a = !1;
        var b, c, e;
        return (
          (c = d.getElementsByTagName("body")[0]),
          c && c.style
            ? ((b = d.createElement("div")),
              (e = d.createElement("div")),
              (e.style.cssText =
                "position:absolute;border:0;width:0;height:0;top:0;left:-9999px"),
              c.appendChild(e).appendChild(b),
              "undefined" != typeof b.style.zoom &&
                ((b.style.cssText =
                  "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:1px;width:1px;zoom:1"),
                (b.appendChild(d.createElement("div")).style.width = "5px"),
                (a = 3 !== b.offsetWidth)),
              c.removeChild(e),
              a)
            : void 0
        );
      };
    })();
  var T = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
    U = new RegExp("^(?:([+-])=|)(" + T + ")([a-z%]*)$", "i"),
    V = ["Top", "Right", "Bottom", "Left"],
    W = function (a, b) {
      return (
        (a = b || a),
        "none" === n.css(a, "display") || !n.contains(a.ownerDocument, a)
      );
    };
  function X(a, b, c, d) {
    var e,
      f = 1,
      g = 20,
      h = d
        ? function () {
            return d.cur();
          }
        : function () {
            return n.css(a, b, "");
          },
      i = h(),
      j = (c && c[3]) || (n.cssNumber[b] ? "" : "px"),
      k = (n.cssNumber[b] || ("px" !== j && +i)) && U.exec(n.css(a, b));
    if (k && k[3] !== j) {
      (j = j || k[3]), (c = c || []), (k = +i || 1);
      do (f = f || ".5"), (k /= f), n.style(a, b, k + j);
      while (f !== (f = h() / i) && 1 !== f && --g);
    }
    return (
      c &&
        ((k = +k || +i || 0),
        (e = c[1] ? k + (c[1] + 1) * c[2] : +c[2]),
        d && ((d.unit = j), (d.start = k), (d.end = e))),
      e
    );
  }
  var Y = function (a, b, c, d, e, f, g) {
      var h = 0,
        i = a.length,
        j = null == c;
      if ("object" === n.type(c)) {
        e = !0;
        for (h in c) Y(a, b, h, c[h], !0, f, g);
      } else if (
        void 0 !== d &&
        ((e = !0),
        n.isFunction(d) || (g = !0),
        j &&
          (g
            ? (b.call(a, d), (b = null))
            : ((j = b),
              (b = function (a, b, c) {
                return j.call(n(a), c);
              }))),
        b)
      )
        for (; i > h; h++) b(a[h], c, g ? d : d.call(a[h], h, b(a[h], c)));
      return e ? a : j ? b.call(a) : i ? b(a[0], c) : f;
    },
    Z = /^(?:checkbox|radio)$/i,
    $ = /<([\w:-]+)/,
    _ = /^$|\/(?:java|ecma)script/i,
    aa = /^\s+/,
    ba =
      "abbr|article|aside|audio|bdi|canvas|data|datalist|details|dialog|figcaption|figure|footer|header|hgroup|main|mark|meter|nav|output|picture|progress|section|summary|template|time|video";
  function ca(a) {
    var b = ba.split("|"),
      c = a.createDocumentFragment();
    if (c.createElement) while (b.length) c.createElement(b.pop());
    return c;
  }
  !(function () {
    var a = d.createElement("div"),
      b = d.createDocumentFragment(),
      c = d.createElement("input");
    (a.innerHTML =
      "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>"),
      (l.leadingWhitespace = 3 === a.firstChild.nodeType),
      (l.tbody = !a.getElementsByTagName("tbody").length),
      (l.htmlSerialize = !!a.getElementsByTagName("link").length),
      (l.html5Clone =
        "<:nav></:nav>" !== d.createElement("nav").cloneNode(!0).outerHTML),
      (c.type = "checkbox"),
      (c.checked = !0),
      b.appendChild(c),
      (l.appendChecked = c.checked),
      (a.innerHTML = "<textarea>x</textarea>"),
      (l.noCloneChecked = !!a.cloneNode(!0).lastChild.defaultValue),
      b.appendChild(a),
      (c = d.createElement("input")),
      c.setAttribute("type", "radio"),
      c.setAttribute("checked", "checked"),
      c.setAttribute("name", "t"),
      a.appendChild(c),
      (l.checkClone = a.cloneNode(!0).cloneNode(!0).lastChild.checked),
      (l.noCloneEvent = !!a.addEventListener),
      (a[n.expando] = 1),
      (l.attributes = !a.getAttribute(n.expando));
  })();
  var da = {
    option: [1, "<select multiple='multiple'>", "</select>"],
    legend: [1, "<fieldset>", "</fieldset>"],
    area: [1, "<map>", "</map>"],
    param: [1, "<object>", "</object>"],
    thead: [1, "<table>", "</table>"],
    tr: [2, "<table><tbody>", "</tbody></table>"],
    col: [2, "<table><tbody></tbody><colgroup>", "</colgroup></table>"],
    td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
    _default: l.htmlSerialize ? [0, "", ""] : [1, "X<div>", "</div>"],
  };
  (da.optgroup = da.option),
    (da.tbody = da.tfoot = da.colgroup = da.caption = da.thead),
    (da.th = da.td);
  function ea(a, b) {
    var c,
      d,
      e = 0,
      f =
        "undefined" != typeof a.getElementsByTagName
          ? a.getElementsByTagName(b || "*")
          : "undefined" != typeof a.querySelectorAll
          ? a.querySelectorAll(b || "*")
          : void 0;
    if (!f)
      for (f = [], c = a.childNodes || a; null != (d = c[e]); e++)
        !b || n.nodeName(d, b) ? f.push(d) : n.merge(f, ea(d, b));
    return void 0 === b || (b && n.nodeName(a, b)) ? n.merge([a], f) : f;
  }
  function fa(a, b) {
    for (var c, d = 0; null != (c = a[d]); d++)
      n._data(c, "globalEval", !b || n._data(b[d], "globalEval"));
  }
  var ga = /<|&#?\w+;/,
    ha = /<tbody/i;
  function ia(a) {
    Z.test(a.type) && (a.defaultChecked = a.checked);
  }
  function ja(a, b, c, d, e) {
    for (
      var f, g, h, i, j, k, m, o = a.length, p = ca(b), q = [], r = 0;
      o > r;
      r++
    )
      if (((g = a[r]), g || 0 === g))
        if ("object" === n.type(g)) n.merge(q, g.nodeType ? [g] : g);
        else if (ga.test(g)) {
          (i = i || p.appendChild(b.createElement("div"))),
            (j = ($.exec(g) || ["", ""])[1].toLowerCase()),
            (m = da[j] || da._default),
            (i.innerHTML = m[1] + n.htmlPrefilter(g) + m[2]),
            (f = m[0]);
          while (f--) i = i.lastChild;
          if (
            (!l.leadingWhitespace &&
              aa.test(g) &&
              q.push(b.createTextNode(aa.exec(g)[0])),
            !l.tbody)
          ) {
            (g =
              "table" !== j || ha.test(g)
                ? "<table>" !== m[1] || ha.test(g)
                  ? 0
                  : i
                : i.firstChild),
              (f = g && g.childNodes.length);
            while (f--)
              n.nodeName((k = g.childNodes[f]), "tbody") &&
                !k.childNodes.length &&
                g.removeChild(k);
          }
          n.merge(q, i.childNodes), (i.textContent = "");
          while (i.firstChild) i.removeChild(i.firstChild);
          i = p.lastChild;
        } else q.push(b.createTextNode(g));
    i && p.removeChild(i),
      l.appendChecked || n.grep(ea(q, "input"), ia),
      (r = 0);
    while ((g = q[r++]))
      if (d && n.inArray(g, d) > -1) e && e.push(g);
      else if (
        ((h = n.contains(g.ownerDocument, g)),
        (i = ea(p.appendChild(g), "script")),
        h && fa(i),
        c)
      ) {
        f = 0;
        while ((g = i[f++])) _.test(g.type || "") && c.push(g);
      }
    return (i = null), p;
  }
  !(function () {
    var b,
      c,
      e = d.createElement("div");
    for (b in { submit: !0, change: !0, focusin: !0 })
      (c = "on" + b),
        (l[b] = c in a) ||
          (e.setAttribute(c, "t"), (l[b] = e.attributes[c].expando === !1));
    e = null;
  })();
  var ka = /^(?:input|select|textarea)$/i,
    la = /^key/,
    ma = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
    na = /^(?:focusinfocus|focusoutblur)$/,
    oa = /^([^.]*)(?:\.(.+)|)/;
  function pa() {
    return !0;
  }
  function qa() {
    return !1;
  }
  function ra() {
    try {
      return d.activeElement;
    } catch (a) {}
  }
  function sa(a, b, c, d, e, f) {
    var g, h;
    if ("object" == typeof b) {
      "string" != typeof c && ((d = d || c), (c = void 0));
      for (h in b) sa(a, h, c, d, b[h], f);
      return a;
    }
    if (
      (null == d && null == e
        ? ((e = c), (d = c = void 0))
        : null == e &&
          ("string" == typeof c
            ? ((e = d), (d = void 0))
            : ((e = d), (d = c), (c = void 0))),
      e === !1)
    )
      e = qa;
    else if (!e) return a;
    return (
      1 === f &&
        ((g = e),
        (e = function (a) {
          return n().off(a), g.apply(this, arguments);
        }),
        (e.guid = g.guid || (g.guid = n.guid++))),
      a.each(function () {
        n.event.add(this, b, e, d, c);
      })
    );
  }
  (n.event = {
    global: {},
    add: function (a, b, c, d, e) {
      var f,
        g,
        h,
        i,
        j,
        k,
        l,
        m,
        o,
        p,
        q,
        r = n._data(a);
      if (r) {
        c.handler && ((i = c), (c = i.handler), (e = i.selector)),
          c.guid || (c.guid = n.guid++),
          (g = r.events) || (g = r.events = {}),
          (k = r.handle) ||
            ((k = r.handle =
              function (a) {
                return "undefined" == typeof n ||
                  (a && n.event.triggered === a.type)
                  ? void 0
                  : n.event.dispatch.apply(k.elem, arguments);
              }),
            (k.elem = a)),
          (b = (b || "").match(G) || [""]),
          (h = b.length);
        while (h--)
          (f = oa.exec(b[h]) || []),
            (o = q = f[1]),
            (p = (f[2] || "").split(".").sort()),
            o &&
              ((j = n.event.special[o] || {}),
              (o = (e ? j.delegateType : j.bindType) || o),
              (j = n.event.special[o] || {}),
              (l = n.extend(
                {
                  type: o,
                  origType: q,
                  data: d,
                  handler: c,
                  guid: c.guid,
                  selector: e,
                  needsContext: e && n.expr.match.needsContext.test(e),
                  namespace: p.join("."),
                },
                i
              )),
              (m = g[o]) ||
                ((m = g[o] = []),
                (m.delegateCount = 0),
                (j.setup && j.setup.call(a, d, p, k) !== !1) ||
                  (a.addEventListener
                    ? a.addEventListener(o, k, !1)
                    : a.attachEvent && a.attachEvent("on" + o, k))),
              j.add &&
                (j.add.call(a, l), l.handler.guid || (l.handler.guid = c.guid)),
              e ? m.splice(m.delegateCount++, 0, l) : m.push(l),
              (n.event.global[o] = !0));
        a = null;
      }
    },
    remove: function (a, b, c, d, e) {
      var f,
        g,
        h,
        i,
        j,
        k,
        l,
        m,
        o,
        p,
        q,
        r = n.hasData(a) && n._data(a);
      if (r && (k = r.events)) {
        (b = (b || "").match(G) || [""]), (j = b.length);
        while (j--)
          if (
            ((h = oa.exec(b[j]) || []),
            (o = q = h[1]),
            (p = (h[2] || "").split(".").sort()),
            o)
          ) {
            (l = n.event.special[o] || {}),
              (o = (d ? l.delegateType : l.bindType) || o),
              (m = k[o] || []),
              (h =
                h[2] &&
                new RegExp("(^|\\.)" + p.join("\\.(?:.*\\.|)") + "(\\.|$)")),
              (i = f = m.length);
            while (f--)
              (g = m[f]),
                (!e && q !== g.origType) ||
                  (c && c.guid !== g.guid) ||
                  (h && !h.test(g.namespace)) ||
                  (d && d !== g.selector && ("**" !== d || !g.selector)) ||
                  (m.splice(f, 1),
                  g.selector && m.delegateCount--,
                  l.remove && l.remove.call(a, g));
            i &&
              !m.length &&
              ((l.teardown && l.teardown.call(a, p, r.handle) !== !1) ||
                n.removeEvent(a, o, r.handle),
              delete k[o]);
          } else for (o in k) n.event.remove(a, o + b[j], c, d, !0);
        n.isEmptyObject(k) && (delete r.handle, n._removeData(a, "events"));
      }
    },
    trigger: function (b, c, e, f) {
      var g,
        h,
        i,
        j,
        l,
        m,
        o,
        p = [e || d],
        q = k.call(b, "type") ? b.type : b,
        r = k.call(b, "namespace") ? b.namespace.split(".") : [];
      if (
        ((i = m = e = e || d),
        3 !== e.nodeType &&
          8 !== e.nodeType &&
          !na.test(q + n.event.triggered) &&
          (q.indexOf(".") > -1 &&
            ((r = q.split(".")), (q = r.shift()), r.sort()),
          (h = q.indexOf(":") < 0 && "on" + q),
          (b = b[n.expando] ? b : new n.Event(q, "object" == typeof b && b)),
          (b.isTrigger = f ? 2 : 3),
          (b.namespace = r.join(".")),
          (b.rnamespace = b.namespace
            ? new RegExp("(^|\\.)" + r.join("\\.(?:.*\\.|)") + "(\\.|$)")
            : null),
          (b.result = void 0),
          b.target || (b.target = e),
          (c = null == c ? [b] : n.makeArray(c, [b])),
          (l = n.event.special[q] || {}),
          f || !l.trigger || l.trigger.apply(e, c) !== !1))
      ) {
        if (!f && !l.noBubble && !n.isWindow(e)) {
          for (
            j = l.delegateType || q, na.test(j + q) || (i = i.parentNode);
            i;
            i = i.parentNode
          )
            p.push(i), (m = i);
          m === (e.ownerDocument || d) &&
            p.push(m.defaultView || m.parentWindow || a);
        }
        o = 0;
        while ((i = p[o++]) && !b.isPropagationStopped())
          (b.type = o > 1 ? j : l.bindType || q),
            (g = (n._data(i, "events") || {})[b.type] && n._data(i, "handle")),
            g && g.apply(i, c),
            (g = h && i[h]),
            g &&
              g.apply &&
              M(i) &&
              ((b.result = g.apply(i, c)),
              b.result === !1 && b.preventDefault());
        if (
          ((b.type = q),
          !f &&
            !b.isDefaultPrevented() &&
            (!l._default || l._default.apply(p.pop(), c) === !1) &&
            M(e) &&
            h &&
            e[q] &&
            !n.isWindow(e))
        ) {
          (m = e[h]), m && (e[h] = null), (n.event.triggered = q);
          try {
            e[q]();
          } catch (s) {}
          (n.event.triggered = void 0), m && (e[h] = m);
        }
        return b.result;
      }
    },
    dispatch: function (a) {
      a = n.event.fix(a);
      var b,
        c,
        d,
        f,
        g,
        h = [],
        i = e.call(arguments),
        j = (n._data(this, "events") || {})[a.type] || [],
        k = n.event.special[a.type] || {};
      if (
        ((i[0] = a),
        (a.delegateTarget = this),
        !k.preDispatch || k.preDispatch.call(this, a) !== !1)
      ) {
        (h = n.event.handlers.call(this, a, j)), (b = 0);
        while ((f = h[b++]) && !a.isPropagationStopped()) {
          (a.currentTarget = f.elem), (c = 0);
          while ((g = f.handlers[c++]) && !a.isImmediatePropagationStopped())
            (a.rnamespace && !a.rnamespace.test(g.namespace)) ||
              ((a.handleObj = g),
              (a.data = g.data),
              (d = (
                (n.event.special[g.origType] || {}).handle || g.handler
              ).apply(f.elem, i)),
              void 0 !== d &&
                (a.result = d) === !1 &&
                (a.preventDefault(), a.stopPropagation()));
        }
        return k.postDispatch && k.postDispatch.call(this, a), a.result;
      }
    },
    handlers: function (a, b) {
      var c,
        d,
        e,
        f,
        g = [],
        h = b.delegateCount,
        i = a.target;
      if (
        h &&
        i.nodeType &&
        ("click" !== a.type || isNaN(a.button) || a.button < 1)
      )
        for (; i != this; i = i.parentNode || this)
          if (1 === i.nodeType && (i.disabled !== !0 || "click" !== a.type)) {
            for (d = [], c = 0; h > c; c++)
              (f = b[c]),
                (e = f.selector + " "),
                void 0 === d[e] &&
                  (d[e] = f.needsContext
                    ? n(e, this).index(i) > -1
                    : n.find(e, this, null, [i]).length),
                d[e] && d.push(f);
            d.length && g.push({ elem: i, handlers: d });
          }
      return h < b.length && g.push({ elem: this, handlers: b.slice(h) }), g;
    },
    fix: function (a) {
      if (a[n.expando]) return a;
      var b,
        c,
        e,
        f = a.type,
        g = a,
        h = this.fixHooks[f];
      h ||
        (this.fixHooks[f] = h =
          ma.test(f) ? this.mouseHooks : la.test(f) ? this.keyHooks : {}),
        (e = h.props ? this.props.concat(h.props) : this.props),
        (a = new n.Event(g)),
        (b = e.length);
      while (b--) (c = e[b]), (a[c] = g[c]);
      return (
        a.target || (a.target = g.srcElement || d),
        3 === a.target.nodeType && (a.target = a.target.parentNode),
        (a.metaKey = !!a.metaKey),
        h.filter ? h.filter(a, g) : a
      );
    },
    props:
      "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(
        " "
      ),
    fixHooks: {},
    keyHooks: {
      props: "char charCode key keyCode".split(" "),
      filter: function (a, b) {
        return (
          null == a.which &&
            (a.which = null != b.charCode ? b.charCode : b.keyCode),
          a
        );
      },
    },
    mouseHooks: {
      props:
        "button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(
          " "
        ),
      filter: function (a, b) {
        var c,
          e,
          f,
          g = b.button,
          h = b.fromElement;
        return (
          null == a.pageX &&
            null != b.clientX &&
            ((e = a.target.ownerDocument || d),
            (f = e.documentElement),
            (c = e.body),
            (a.pageX =
              b.clientX +
              ((f && f.scrollLeft) || (c && c.scrollLeft) || 0) -
              ((f && f.clientLeft) || (c && c.clientLeft) || 0)),
            (a.pageY =
              b.clientY +
              ((f && f.scrollTop) || (c && c.scrollTop) || 0) -
              ((f && f.clientTop) || (c && c.clientTop) || 0))),
          !a.relatedTarget &&
            h &&
            (a.relatedTarget = h === a.target ? b.toElement : h),
          a.which ||
            void 0 === g ||
            (a.which = 1 & g ? 1 : 2 & g ? 3 : 4 & g ? 2 : 0),
          a
        );
      },
    },
    special: {
      load: { noBubble: !0 },
      focus: {
        trigger: function () {
          if (this !== ra() && this.focus)
            try {
              return this.focus(), !1;
            } catch (a) {}
        },
        delegateType: "focusin",
      },
      blur: {
        trigger: function () {
          return this === ra() && this.blur ? (this.blur(), !1) : void 0;
        },
        delegateType: "focusout",
      },
      click: {
        trigger: function () {
          return n.nodeName(this, "input") &&
            "checkbox" === this.type &&
            this.click
            ? (this.click(), !1)
            : void 0;
        },
        _default: function (a) {
          return n.nodeName(a.target, "a");
        },
      },
      beforeunload: {
        postDispatch: function (a) {
          void 0 !== a.result &&
            a.originalEvent &&
            (a.originalEvent.returnValue = a.result);
        },
      },
    },
    simulate: function (a, b, c) {
      var d = n.extend(new n.Event(), c, { type: a, isSimulated: !0 });
      n.event.trigger(d, null, b), d.isDefaultPrevented() && c.preventDefault();
    },
  }),
    (n.removeEvent = d.removeEventListener
      ? function (a, b, c) {
          a.removeEventListener && a.removeEventListener(b, c);
        }
      : function (a, b, c) {
          var d = "on" + b;
          a.detachEvent &&
            ("undefined" == typeof a[d] && (a[d] = null), a.detachEvent(d, c));
        }),
    (n.Event = function (a, b) {
      return this instanceof n.Event
        ? (a && a.type
            ? ((this.originalEvent = a),
              (this.type = a.type),
              (this.isDefaultPrevented =
                a.defaultPrevented ||
                (void 0 === a.defaultPrevented && a.returnValue === !1)
                  ? pa
                  : qa))
            : (this.type = a),
          b && n.extend(this, b),
          (this.timeStamp = (a && a.timeStamp) || n.now()),
          void (this[n.expando] = !0))
        : new n.Event(a, b);
    }),
    (n.Event.prototype = {
      constructor: n.Event,
      isDefaultPrevented: qa,
      isPropagationStopped: qa,
      isImmediatePropagationStopped: qa,
      preventDefault: function () {
        var a = this.originalEvent;
        (this.isDefaultPrevented = pa),
          a && (a.preventDefault ? a.preventDefault() : (a.returnValue = !1));
      },
      stopPropagation: function () {
        var a = this.originalEvent;
        (this.isPropagationStopped = pa),
          a &&
            !this.isSimulated &&
            (a.stopPropagation && a.stopPropagation(), (a.cancelBubble = !0));
      },
      stopImmediatePropagation: function () {
        var a = this.originalEvent;
        (this.isImmediatePropagationStopped = pa),
          a && a.stopImmediatePropagation && a.stopImmediatePropagation(),
          this.stopPropagation();
      },
    }),
    n.each(
      {
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout",
      },
      function (a, b) {
        n.event.special[a] = {
          delegateType: b,
          bindType: b,
          handle: function (a) {
            var c,
              d = this,
              e = a.relatedTarget,
              f = a.handleObj;
            return (
              (e && (e === d || n.contains(d, e))) ||
                ((a.type = f.origType),
                (c = f.handler.apply(this, arguments)),
                (a.type = b)),
              c
            );
          },
        };
      }
    ),
    l.submit ||
      (n.event.special.submit = {
        setup: function () {
          return n.nodeName(this, "form")
            ? !1
            : void n.event.add(
                this,
                "click._submit keypress._submit",
                function (a) {
                  var b = a.target,
                    c =
                      n.nodeName(b, "input") || n.nodeName(b, "button")
                        ? n.prop(b, "form")
                        : void 0;
                  c &&
                    !n._data(c, "submit") &&
                    (n.event.add(c, "submit._submit", function (a) {
                      a._submitBubble = !0;
                    }),
                    n._data(c, "submit", !0));
                }
              );
        },
        postDispatch: function (a) {
          a._submitBubble &&
            (delete a._submitBubble,
            this.parentNode &&
              !a.isTrigger &&
              n.event.simulate("submit", this.parentNode, a));
        },
        teardown: function () {
          return n.nodeName(this, "form")
            ? !1
            : void n.event.remove(this, "._submit");
        },
      }),
    l.change ||
      (n.event.special.change = {
        setup: function () {
          return ka.test(this.nodeName)
            ? (("checkbox" !== this.type && "radio" !== this.type) ||
                (n.event.add(this, "propertychange._change", function (a) {
                  "checked" === a.originalEvent.propertyName &&
                    (this._justChanged = !0);
                }),
                n.event.add(this, "click._change", function (a) {
                  this._justChanged && !a.isTrigger && (this._justChanged = !1),
                    n.event.simulate("change", this, a);
                })),
              !1)
            : void n.event.add(this, "beforeactivate._change", function (a) {
                var b = a.target;
                ka.test(b.nodeName) &&
                  !n._data(b, "change") &&
                  (n.event.add(b, "change._change", function (a) {
                    !this.parentNode ||
                      a.isSimulated ||
                      a.isTrigger ||
                      n.event.simulate("change", this.parentNode, a);
                  }),
                  n._data(b, "change", !0));
              });
        },
        handle: function (a) {
          var b = a.target;
          return this !== b ||
            a.isSimulated ||
            a.isTrigger ||
            ("radio" !== b.type && "checkbox" !== b.type)
            ? a.handleObj.handler.apply(this, arguments)
            : void 0;
        },
        teardown: function () {
          return n.event.remove(this, "._change"), !ka.test(this.nodeName);
        },
      }),
    l.focusin ||
      n.each({ focus: "focusin", blur: "focusout" }, function (a, b) {
        var c = function (a) {
          n.event.simulate(b, a.target, n.event.fix(a));
        };
        n.event.special[b] = {
          setup: function () {
            var d = this.ownerDocument || this,
              e = n._data(d, b);
            e || d.addEventListener(a, c, !0), n._data(d, b, (e || 0) + 1);
          },
          teardown: function () {
            var d = this.ownerDocument || this,
              e = n._data(d, b) - 1;
            e
              ? n._data(d, b, e)
              : (d.removeEventListener(a, c, !0), n._removeData(d, b));
          },
        };
      }),
    n.fn.extend({
      on: function (a, b, c, d) {
        return sa(this, a, b, c, d);
      },
      one: function (a, b, c, d) {
        return sa(this, a, b, c, d, 1);
      },
      off: function (a, b, c) {
        var d, e;
        if (a && a.preventDefault && a.handleObj)
          return (
            (d = a.handleObj),
            n(a.delegateTarget).off(
              d.namespace ? d.origType + "." + d.namespace : d.origType,
              d.selector,
              d.handler
            ),
            this
          );
        if ("object" == typeof a) {
          for (e in a) this.off(e, b, a[e]);
          return this;
        }
        return (
          (b !== !1 && "function" != typeof b) || ((c = b), (b = void 0)),
          c === !1 && (c = qa),
          this.each(function () {
            n.event.remove(this, a, c, b);
          })
        );
      },
      trigger: function (a, b) {
        return this.each(function () {
          n.event.trigger(a, b, this);
        });
      },
      triggerHandler: function (a, b) {
        var c = this[0];
        return c ? n.event.trigger(a, b, c, !0) : void 0;
      },
    });
  var ta = / jQuery\d+="(?:null|\d+)"/g,
    ua = new RegExp("<(?:" + ba + ")[\\s/>]", "i"),
    va =
      /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,
    wa = /<script|<style|<link/i,
    xa = /checked\s*(?:[^=]|=\s*.checked.)/i,
    ya = /^true\/(.*)/,
    za = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,
    Aa = ca(d),
    Ba = Aa.appendChild(d.createElement("div"));
  function Ca(a, b) {
    return n.nodeName(a, "table") &&
      n.nodeName(11 !== b.nodeType ? b : b.firstChild, "tr")
      ? a.getElementsByTagName("tbody")[0] ||
          a.appendChild(a.ownerDocument.createElement("tbody"))
      : a;
  }
  function Da(a) {
    return (a.type = (null !== n.find.attr(a, "type")) + "/" + a.type), a;
  }
  function Ea(a) {
    var b = ya.exec(a.type);
    return b ? (a.type = b[1]) : a.removeAttribute("type"), a;
  }
  function Fa(a, b) {
    if (1 === b.nodeType && n.hasData(a)) {
      var c,
        d,
        e,
        f = n._data(a),
        g = n._data(b, f),
        h = f.events;
      if (h) {
        delete g.handle, (g.events = {});
        for (c in h)
          for (d = 0, e = h[c].length; e > d; d++) n.event.add(b, c, h[c][d]);
      }
      g.data && (g.data = n.extend({}, g.data));
    }
  }
  function Ga(a, b) {
    var c, d, e;
    if (1 === b.nodeType) {
      if (((c = b.nodeName.toLowerCase()), !l.noCloneEvent && b[n.expando])) {
        e = n._data(b);
        for (d in e.events) n.removeEvent(b, d, e.handle);
        b.removeAttribute(n.expando);
      }
      "script" === c && b.text !== a.text
        ? ((Da(b).text = a.text), Ea(b))
        : "object" === c
        ? (b.parentNode && (b.outerHTML = a.outerHTML),
          l.html5Clone &&
            a.innerHTML &&
            !n.trim(b.innerHTML) &&
            (b.innerHTML = a.innerHTML))
        : "input" === c && Z.test(a.type)
        ? ((b.defaultChecked = b.checked = a.checked),
          b.value !== a.value && (b.value = a.value))
        : "option" === c
        ? (b.defaultSelected = b.selected = a.defaultSelected)
        : ("input" !== c && "textarea" !== c) ||
          (b.defaultValue = a.defaultValue);
    }
  }
  function Ha(a, b, c, d) {
    b = f.apply([], b);
    var e,
      g,
      h,
      i,
      j,
      k,
      m = 0,
      o = a.length,
      p = o - 1,
      q = b[0],
      r = n.isFunction(q);
    if (r || (o > 1 && "string" == typeof q && !l.checkClone && xa.test(q)))
      return a.each(function (e) {
        var f = a.eq(e);
        r && (b[0] = q.call(this, e, f.html())), Ha(f, b, c, d);
      });
    if (
      o &&
      ((k = ja(b, a[0].ownerDocument, !1, a, d)),
      (e = k.firstChild),
      1 === k.childNodes.length && (k = e),
      e || d)
    ) {
      for (i = n.map(ea(k, "script"), Da), h = i.length; o > m; m++)
        (g = k),
          m !== p &&
            ((g = n.clone(g, !0, !0)), h && n.merge(i, ea(g, "script"))),
          c.call(a[m], g, m);
      if (h)
        for (j = i[i.length - 1].ownerDocument, n.map(i, Ea), m = 0; h > m; m++)
          (g = i[m]),
            _.test(g.type || "") &&
              !n._data(g, "globalEval") &&
              n.contains(j, g) &&
              (g.src
                ? n._evalUrl && n._evalUrl(g.src)
                : n.globalEval(
                    (g.text || g.textContent || g.innerHTML || "").replace(
                      za,
                      ""
                    )
                  ));
      k = e = null;
    }
    return a;
  }
  function Ia(a, b, c) {
    for (var d, e = b ? n.filter(b, a) : a, f = 0; null != (d = e[f]); f++)
      c || 1 !== d.nodeType || n.cleanData(ea(d)),
        d.parentNode &&
          (c && n.contains(d.ownerDocument, d) && fa(ea(d, "script")),
          d.parentNode.removeChild(d));
    return a;
  }
  n.extend({
    htmlPrefilter: function (a) {
      return a.replace(va, "<$1></$2>");
    },
    clone: function (a, b, c) {
      var d,
        e,
        f,
        g,
        h,
        i = n.contains(a.ownerDocument, a);
      if (
        (l.html5Clone || n.isXMLDoc(a) || !ua.test("<" + a.nodeName + ">")
          ? (f = a.cloneNode(!0))
          : ((Ba.innerHTML = a.outerHTML), Ba.removeChild((f = Ba.firstChild))),
        !(
          (l.noCloneEvent && l.noCloneChecked) ||
          (1 !== a.nodeType && 11 !== a.nodeType) ||
          n.isXMLDoc(a)
        ))
      )
        for (d = ea(f), h = ea(a), g = 0; null != (e = h[g]); ++g)
          d[g] && Ga(e, d[g]);
      if (b)
        if (c)
          for (h = h || ea(a), d = d || ea(f), g = 0; null != (e = h[g]); g++)
            Fa(e, d[g]);
        else Fa(a, f);
      return (
        (d = ea(f, "script")),
        d.length > 0 && fa(d, !i && ea(a, "script")),
        (d = h = e = null),
        f
      );
    },
    cleanData: function (a, b) {
      for (
        var d,
          e,
          f,
          g,
          h = 0,
          i = n.expando,
          j = n.cache,
          k = l.attributes,
          m = n.event.special;
        null != (d = a[h]);
        h++
      )
        if ((b || M(d)) && ((f = d[i]), (g = f && j[f]))) {
          if (g.events)
            for (e in g.events)
              m[e] ? n.event.remove(d, e) : n.removeEvent(d, e, g.handle);
          j[f] &&
            (delete j[f],
            k || "undefined" == typeof d.removeAttribute
              ? (d[i] = void 0)
              : d.removeAttribute(i),
            c.push(f));
        }
    },
  }),
    n.fn.extend({
      domManip: Ha,
      detach: function (a) {
        return Ia(this, a, !0);
      },
      remove: function (a) {
        return Ia(this, a);
      },
      text: function (a) {
        return Y(
          this,
          function (a) {
            return void 0 === a
              ? n.text(this)
              : this.empty().append(
                  ((this[0] && this[0].ownerDocument) || d).createTextNode(a)
                );
          },
          null,
          a,
          arguments.length
        );
      },
      append: function () {
        return Ha(this, arguments, function (a) {
          if (
            1 === this.nodeType ||
            11 === this.nodeType ||
            9 === this.nodeType
          ) {
            var b = Ca(this, a);
            b.appendChild(a);
          }
        });
      },
      prepend: function () {
        return Ha(this, arguments, function (a) {
          if (
            1 === this.nodeType ||
            11 === this.nodeType ||
            9 === this.nodeType
          ) {
            var b = Ca(this, a);
            b.insertBefore(a, b.firstChild);
          }
        });
      },
      before: function () {
        return Ha(this, arguments, function (a) {
          this.parentNode && this.parentNode.insertBefore(a, this);
        });
      },
      after: function () {
        return Ha(this, arguments, function (a) {
          this.parentNode && this.parentNode.insertBefore(a, this.nextSibling);
        });
      },
      empty: function () {
        for (var a, b = 0; null != (a = this[b]); b++) {
          1 === a.nodeType && n.cleanData(ea(a, !1));
          while (a.firstChild) a.removeChild(a.firstChild);
          a.options && n.nodeName(a, "select") && (a.options.length = 0);
        }
        return this;
      },
      clone: function (a, b) {
        return (
          (a = null == a ? !1 : a),
          (b = null == b ? a : b),
          this.map(function () {
            return n.clone(this, a, b);
          })
        );
      },
      html: function (a) {
        return Y(
          this,
          function (a) {
            var b = this[0] || {},
              c = 0,
              d = this.length;
            if (void 0 === a)
              return 1 === b.nodeType ? b.innerHTML.replace(ta, "") : void 0;
            if (
              "string" == typeof a &&
              !wa.test(a) &&
              (l.htmlSerialize || !ua.test(a)) &&
              (l.leadingWhitespace || !aa.test(a)) &&
              !da[($.exec(a) || ["", ""])[1].toLowerCase()]
            ) {
              a = n.htmlPrefilter(a);
              try {
                for (; d > c; c++)
                  (b = this[c] || {}),
                    1 === b.nodeType &&
                      (n.cleanData(ea(b, !1)), (b.innerHTML = a));
                b = 0;
              } catch (e) {}
            }
            b && this.empty().append(a);
          },
          null,
          a,
          arguments.length
        );
      },
      replaceWith: function () {
        var a = [];
        return Ha(
          this,
          arguments,
          function (b) {
            var c = this.parentNode;
            n.inArray(this, a) < 0 &&
              (n.cleanData(ea(this)), c && c.replaceChild(b, this));
          },
          a
        );
      },
    }),
    n.each(
      {
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith",
      },
      function (a, b) {
        n.fn[a] = function (a) {
          for (var c, d = 0, e = [], f = n(a), h = f.length - 1; h >= d; d++)
            (c = d === h ? this : this.clone(!0)),
              n(f[d])[b](c),
              g.apply(e, c.get());
          return this.pushStack(e);
        };
      }
    );
  var Ja,
    Ka = { HTML: "block", BODY: "block" };
  function La(a, b) {
    var c = n(b.createElement(a)).appendTo(b.body),
      d = n.css(c[0], "display");
    return c.detach(), d;
  }
  function Ma(a) {
    var b = d,
      c = Ka[a];
    return (
      c ||
        ((c = La(a, b)),
        ("none" !== c && c) ||
          ((Ja = (
            Ja || n("<iframe frameborder='0' width='0' height='0'/>")
          ).appendTo(b.documentElement)),
          (b = (Ja[0].contentWindow || Ja[0].contentDocument).document),
          b.write(),
          b.close(),
          (c = La(a, b)),
          Ja.detach()),
        (Ka[a] = c)),
      c
    );
  }
  var Na = /^margin/,
    Oa = new RegExp("^(" + T + ")(?!px)[a-z%]+$", "i"),
    Pa = function (a, b, c, d) {
      var e,
        f,
        g = {};
      for (f in b) (g[f] = a.style[f]), (a.style[f] = b[f]);
      e = c.apply(a, d || []);
      for (f in b) a.style[f] = g[f];
      return e;
    },
    Qa = d.documentElement;
  !(function () {
    var b,
      c,
      e,
      f,
      g,
      h,
      i = d.createElement("div"),
      j = d.createElement("div");
    if (j.style) {
      (j.style.cssText = "float:left;opacity:.5"),
        (l.opacity = "0.5" === j.style.opacity),
        (l.cssFloat = !!j.style.cssFloat),
        (j.style.backgroundClip = "content-box"),
        (j.cloneNode(!0).style.backgroundClip = ""),
        (l.clearCloneStyle = "content-box" === j.style.backgroundClip),
        (i = d.createElement("div")),
        (i.style.cssText =
          "border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute"),
        (j.innerHTML = ""),
        i.appendChild(j),
        (l.boxSizing =
          "" === j.style.boxSizing ||
          "" === j.style.MozBoxSizing ||
          "" === j.style.WebkitBoxSizing),
        n.extend(l, {
          reliableHiddenOffsets: function () {
            return null == b && k(), f;
          },
          boxSizingReliable: function () {
            return null == b && k(), e;
          },
          pixelMarginRight: function () {
            return null == b && k(), c;
          },
          pixelPosition: function () {
            return null == b && k(), b;
          },
          reliableMarginRight: function () {
            return null == b && k(), g;
          },
          reliableMarginLeft: function () {
            return null == b && k(), h;
          },
        });
      function k() {
        var k,
          l,
          m = d.documentElement;
        m.appendChild(i),
          (j.style.cssText =
            "-webkit-box-sizing:border-box;box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%"),
          (b = e = h = !1),
          (c = g = !0),
          a.getComputedStyle &&
            ((l = a.getComputedStyle(j)),
            (b = "1%" !== (l || {}).top),
            (h = "2px" === (l || {}).marginLeft),
            (e = "4px" === (l || { width: "4px" }).width),
            (j.style.marginRight = "50%"),
            (c = "4px" === (l || { marginRight: "4px" }).marginRight),
            (k = j.appendChild(d.createElement("div"))),
            (k.style.cssText = j.style.cssText =
              "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0"),
            (k.style.marginRight = k.style.width = "0"),
            (j.style.width = "1px"),
            (g = !parseFloat((a.getComputedStyle(k) || {}).marginRight)),
            j.removeChild(k)),
          (j.style.display = "none"),
          (f = 0 === j.getClientRects().length),
          f &&
            ((j.style.display = ""),
            (j.innerHTML = "<table><tr><td></td><td>t</td></tr></table>"),
            (j.childNodes[0].style.borderCollapse = "separate"),
            (k = j.getElementsByTagName("td")),
            (k[0].style.cssText = "margin:0;border:0;padding:0;display:none"),
            (f = 0 === k[0].offsetHeight),
            f &&
              ((k[0].style.display = ""),
              (k[1].style.display = "none"),
              (f = 0 === k[0].offsetHeight))),
          m.removeChild(i);
      }
    }
  })();
  var Ra,
    Sa,
    Ta = /^(top|right|bottom|left)$/;
  a.getComputedStyle
    ? ((Ra = function (b) {
        var c = b.ownerDocument.defaultView;
        return (c && c.opener) || (c = a), c.getComputedStyle(b);
      }),
      (Sa = function (a, b, c) {
        var d,
          e,
          f,
          g,
          h = a.style;
        return (
          (c = c || Ra(a)),
          (g = c ? c.getPropertyValue(b) || c[b] : void 0),
          ("" !== g && void 0 !== g) ||
            n.contains(a.ownerDocument, a) ||
            (g = n.style(a, b)),
          c &&
            !l.pixelMarginRight() &&
            Oa.test(g) &&
            Na.test(b) &&
            ((d = h.width),
            (e = h.minWidth),
            (f = h.maxWidth),
            (h.minWidth = h.maxWidth = h.width = g),
            (g = c.width),
            (h.width = d),
            (h.minWidth = e),
            (h.maxWidth = f)),
          void 0 === g ? g : g + ""
        );
      }))
    : Qa.currentStyle &&
      ((Ra = function (a) {
        return a.currentStyle;
      }),
      (Sa = function (a, b, c) {
        var d,
          e,
          f,
          g,
          h = a.style;
        return (
          (c = c || Ra(a)),
          (g = c ? c[b] : void 0),
          null == g && h && h[b] && (g = h[b]),
          Oa.test(g) &&
            !Ta.test(b) &&
            ((d = h.left),
            (e = a.runtimeStyle),
            (f = e && e.left),
            f && (e.left = a.currentStyle.left),
            (h.left = "fontSize" === b ? "1em" : g),
            (g = h.pixelLeft + "px"),
            (h.left = d),
            f && (e.left = f)),
          void 0 === g ? g : g + "" || "auto"
        );
      }));
  function Ua(a, b) {
    return {
      get: function () {
        return a()
          ? void delete this.get
          : (this.get = b).apply(this, arguments);
      },
    };
  }
  var Va = /alpha\([^)]*\)/i,
    Wa = /opacity\s*=\s*([^)]*)/i,
    Xa = /^(none|table(?!-c[ea]).+)/,
    Ya = new RegExp("^(" + T + ")(.*)$", "i"),
    Za = { position: "absolute", visibility: "hidden", display: "block" },
    $a = { letterSpacing: "0", fontWeight: "400" },
    _a = ["Webkit", "O", "Moz", "ms"],
    ab = d.createElement("div").style;
  function bb(a) {
    if (a in ab) return a;
    var b = a.charAt(0).toUpperCase() + a.slice(1),
      c = _a.length;
    while (c--) if (((a = _a[c] + b), a in ab)) return a;
  }
  function cb(a, b) {
    for (var c, d, e, f = [], g = 0, h = a.length; h > g; g++)
      (d = a[g]),
        d.style &&
          ((f[g] = n._data(d, "olddisplay")),
          (c = d.style.display),
          b
            ? (f[g] || "none" !== c || (d.style.display = ""),
              "" === d.style.display &&
                W(d) &&
                (f[g] = n._data(d, "olddisplay", Ma(d.nodeName))))
            : ((e = W(d)),
              ((c && "none" !== c) || !e) &&
                n._data(d, "olddisplay", e ? c : n.css(d, "display"))));
    for (g = 0; h > g; g++)
      (d = a[g]),
        d.style &&
          ((b && "none" !== d.style.display && "" !== d.style.display) ||
            (d.style.display = b ? f[g] || "" : "none"));
    return a;
  }
  function db(a, b, c) {
    var d = Ya.exec(b);
    return d ? Math.max(0, d[1] - (c || 0)) + (d[2] || "px") : b;
  }
  function eb(a, b, c, d, e) {
    for (
      var f = c === (d ? "border" : "content") ? 4 : "width" === b ? 1 : 0,
        g = 0;
      4 > f;
      f += 2
    )
      "margin" === c && (g += n.css(a, c + V[f], !0, e)),
        d
          ? ("content" === c && (g -= n.css(a, "padding" + V[f], !0, e)),
            "margin" !== c && (g -= n.css(a, "border" + V[f] + "Width", !0, e)))
          : ((g += n.css(a, "padding" + V[f], !0, e)),
            "padding" !== c &&
              (g += n.css(a, "border" + V[f] + "Width", !0, e)));
    return g;
  }
  function fb(a, b, c) {
    var d = !0,
      e = "width" === b ? a.offsetWidth : a.offsetHeight,
      f = Ra(a),
      g = l.boxSizing && "border-box" === n.css(a, "boxSizing", !1, f);
    if (0 >= e || null == e) {
      if (
        ((e = Sa(a, b, f)),
        (0 > e || null == e) && (e = a.style[b]),
        Oa.test(e))
      )
        return e;
      (d = g && (l.boxSizingReliable() || e === a.style[b])),
        (e = parseFloat(e) || 0);
    }
    return e + eb(a, b, c || (g ? "border" : "content"), d, f) + "px";
  }
  n.extend({
    cssHooks: {
      opacity: {
        get: function (a, b) {
          if (b) {
            var c = Sa(a, "opacity");
            return "" === c ? "1" : c;
          }
        },
      },
    },
    cssNumber: {
      animationIterationCount: !0,
      columnCount: !0,
      fillOpacity: !0,
      flexGrow: !0,
      flexShrink: !0,
      fontWeight: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
    },
    cssProps: { float: l.cssFloat ? "cssFloat" : "styleFloat" },
    style: function (a, b, c, d) {
      if (a && 3 !== a.nodeType && 8 !== a.nodeType && a.style) {
        var e,
          f,
          g,
          h = n.camelCase(b),
          i = a.style;
        if (
          ((b = n.cssProps[h] || (n.cssProps[h] = bb(h) || h)),
          (g = n.cssHooks[b] || n.cssHooks[h]),
          void 0 === c)
        )
          return g && "get" in g && void 0 !== (e = g.get(a, !1, d)) ? e : i[b];
        if (
          ((f = typeof c),
          "string" === f &&
            (e = U.exec(c)) &&
            e[1] &&
            ((c = X(a, b, e)), (f = "number")),
          null != c &&
            c === c &&
            ("number" === f &&
              (c += (e && e[3]) || (n.cssNumber[h] ? "" : "px")),
            l.clearCloneStyle ||
              "" !== c ||
              0 !== b.indexOf("background") ||
              (i[b] = "inherit"),
            !(g && "set" in g && void 0 === (c = g.set(a, c, d)))))
        )
          try {
            i[b] = c;
          } catch (j) {}
      }
    },
    css: function (a, b, c, d) {
      var e,
        f,
        g,
        h = n.camelCase(b);
      return (
        (b = n.cssProps[h] || (n.cssProps[h] = bb(h) || h)),
        (g = n.cssHooks[b] || n.cssHooks[h]),
        g && "get" in g && (f = g.get(a, !0, c)),
        void 0 === f && (f = Sa(a, b, d)),
        "normal" === f && b in $a && (f = $a[b]),
        "" === c || c
          ? ((e = parseFloat(f)), c === !0 || isFinite(e) ? e || 0 : f)
          : f
      );
    },
  }),
    n.each(["height", "width"], function (a, b) {
      n.cssHooks[b] = {
        get: function (a, c, d) {
          return c
            ? Xa.test(n.css(a, "display")) && 0 === a.offsetWidth
              ? Pa(a, Za, function () {
                  return fb(a, b, d);
                })
              : fb(a, b, d)
            : void 0;
        },
        set: function (a, c, d) {
          var e = d && Ra(a);
          return db(
            a,
            c,
            d
              ? eb(
                  a,
                  b,
                  d,
                  l.boxSizing && "border-box" === n.css(a, "boxSizing", !1, e),
                  e
                )
              : 0
          );
        },
      };
    }),
    l.opacity ||
      (n.cssHooks.opacity = {
        get: function (a, b) {
          return Wa.test(
            (b && a.currentStyle ? a.currentStyle.filter : a.style.filter) || ""
          )
            ? 0.01 * parseFloat(RegExp.$1) + ""
            : b
            ? "1"
            : "";
        },
        set: function (a, b) {
          var c = a.style,
            d = a.currentStyle,
            e = n.isNumeric(b) ? "alpha(opacity=" + 100 * b + ")" : "",
            f = (d && d.filter) || c.filter || "";
          (c.zoom = 1),
            ((b >= 1 || "" === b) &&
              "" === n.trim(f.replace(Va, "")) &&
              c.removeAttribute &&
              (c.removeAttribute("filter"), "" === b || (d && !d.filter))) ||
              (c.filter = Va.test(f) ? f.replace(Va, e) : f + " " + e);
        },
      }),
    (n.cssHooks.marginRight = Ua(l.reliableMarginRight, function (a, b) {
      return b
        ? Pa(a, { display: "inline-block" }, Sa, [a, "marginRight"])
        : void 0;
    })),
    (n.cssHooks.marginLeft = Ua(l.reliableMarginLeft, function (a, b) {
      return b
        ? (parseFloat(Sa(a, "marginLeft")) ||
            (n.contains(a.ownerDocument, a)
              ? a.getBoundingClientRect().left -
                Pa(
                  a,
                  {
                    marginLeft: 0,
                  },
                  function () {
                    return a.getBoundingClientRect().left;
                  }
                )
              : 0)) + "px"
        : void 0;
    })),
    n.each({ margin: "", padding: "", border: "Width" }, function (a, b) {
      (n.cssHooks[a + b] = {
        expand: function (c) {
          for (
            var d = 0, e = {}, f = "string" == typeof c ? c.split(" ") : [c];
            4 > d;
            d++
          )
            e[a + V[d] + b] = f[d] || f[d - 2] || f[0];
          return e;
        },
      }),
        Na.test(a) || (n.cssHooks[a + b].set = db);
    }),
    n.fn.extend({
      css: function (a, b) {
        return Y(
          this,
          function (a, b, c) {
            var d,
              e,
              f = {},
              g = 0;
            if (n.isArray(b)) {
              for (d = Ra(a), e = b.length; e > g; g++)
                f[b[g]] = n.css(a, b[g], !1, d);
              return f;
            }
            return void 0 !== c ? n.style(a, b, c) : n.css(a, b);
          },
          a,
          b,
          arguments.length > 1
        );
      },
      show: function () {
        return cb(this, !0);
      },
      hide: function () {
        return cb(this);
      },
      toggle: function (a) {
        return "boolean" == typeof a
          ? a
            ? this.show()
            : this.hide()
          : this.each(function () {
              W(this) ? n(this).show() : n(this).hide();
            });
      },
    });
  function gb(a, b, c, d, e) {
    return new gb.prototype.init(a, b, c, d, e);
  }
  (n.Tween = gb),
    (gb.prototype = {
      constructor: gb,
      init: function (a, b, c, d, e, f) {
        (this.elem = a),
          (this.prop = c),
          (this.easing = e || n.easing._default),
          (this.options = b),
          (this.start = this.now = this.cur()),
          (this.end = d),
          (this.unit = f || (n.cssNumber[c] ? "" : "px"));
      },
      cur: function () {
        var a = gb.propHooks[this.prop];
        return a && a.get ? a.get(this) : gb.propHooks._default.get(this);
      },
      run: function (a) {
        var b,
          c = gb.propHooks[this.prop];
        return (
          this.options.duration
            ? (this.pos = b =
                n.easing[this.easing](
                  a,
                  this.options.duration * a,
                  0,
                  1,
                  this.options.duration
                ))
            : (this.pos = b = a),
          (this.now = (this.end - this.start) * b + this.start),
          this.options.step &&
            this.options.step.call(this.elem, this.now, this),
          c && c.set ? c.set(this) : gb.propHooks._default.set(this),
          this
        );
      },
    }),
    (gb.prototype.init.prototype = gb.prototype),
    (gb.propHooks = {
      _default: {
        get: function (a) {
          var b;
          return 1 !== a.elem.nodeType ||
            (null != a.elem[a.prop] && null == a.elem.style[a.prop])
            ? a.elem[a.prop]
            : ((b = n.css(a.elem, a.prop, "")), b && "auto" !== b ? b : 0);
        },
        set: function (a) {
          n.fx.step[a.prop]
            ? n.fx.step[a.prop](a)
            : 1 !== a.elem.nodeType ||
              (null == a.elem.style[n.cssProps[a.prop]] && !n.cssHooks[a.prop])
            ? (a.elem[a.prop] = a.now)
            : n.style(a.elem, a.prop, a.now + a.unit);
        },
      },
    }),
    (gb.propHooks.scrollTop = gb.propHooks.scrollLeft =
      {
        set: function (a) {
          a.elem.nodeType && a.elem.parentNode && (a.elem[a.prop] = a.now);
        },
      }),
    (n.easing = {
      linear: function (a) {
        return a;
      },
      swing: function (a) {
        return 0.5 - Math.cos(a * Math.PI) / 2;
      },
      _default: "swing",
    }),
    (n.fx = gb.prototype.init),
    (n.fx.step = {});
  var hb,
    ib,
    jb = /^(?:toggle|show|hide)$/,
    kb = /queueHooks$/;
  function lb() {
    return (
      a.setTimeout(function () {
        hb = void 0;
      }),
      (hb = n.now())
    );
  }
  function mb(a, b) {
    var c,
      d = { height: a },
      e = 0;
    for (b = b ? 1 : 0; 4 > e; e += 2 - b)
      (c = V[e]), (d["margin" + c] = d["padding" + c] = a);
    return b && (d.opacity = d.width = a), d;
  }
  function nb(a, b, c) {
    for (
      var d,
        e = (qb.tweeners[b] || []).concat(qb.tweeners["*"]),
        f = 0,
        g = e.length;
      g > f;
      f++
    )
      if ((d = e[f].call(c, b, a))) return d;
  }
  function ob(a, b, c) {
    var d,
      e,
      f,
      g,
      h,
      i,
      j,
      k,
      m = this,
      o = {},
      p = a.style,
      q = a.nodeType && W(a),
      r = n._data(a, "fxshow");
    c.queue ||
      ((h = n._queueHooks(a, "fx")),
      null == h.unqueued &&
        ((h.unqueued = 0),
        (i = h.empty.fire),
        (h.empty.fire = function () {
          h.unqueued || i();
        })),
      h.unqueued++,
      m.always(function () {
        m.always(function () {
          h.unqueued--, n.queue(a, "fx").length || h.empty.fire();
        });
      })),
      1 === a.nodeType &&
        ("height" in b || "width" in b) &&
        ((c.overflow = [p.overflow, p.overflowX, p.overflowY]),
        (j = n.css(a, "display")),
        (k = "none" === j ? n._data(a, "olddisplay") || Ma(a.nodeName) : j),
        "inline" === k &&
          "none" === n.css(a, "float") &&
          (l.inlineBlockNeedsLayout && "inline" !== Ma(a.nodeName)
            ? (p.zoom = 1)
            : (p.display = "inline-block"))),
      c.overflow &&
        ((p.overflow = "hidden"),
        l.shrinkWrapBlocks() ||
          m.always(function () {
            (p.overflow = c.overflow[0]),
              (p.overflowX = c.overflow[1]),
              (p.overflowY = c.overflow[2]);
          }));
    for (d in b)
      if (((e = b[d]), jb.exec(e))) {
        if (
          (delete b[d], (f = f || "toggle" === e), e === (q ? "hide" : "show"))
        ) {
          if ("show" !== e || !r || void 0 === r[d]) continue;
          q = !0;
        }
        o[d] = (r && r[d]) || n.style(a, d);
      } else j = void 0;
    if (n.isEmptyObject(o))
      "inline" === ("none" === j ? Ma(a.nodeName) : j) && (p.display = j);
    else {
      r ? "hidden" in r && (q = r.hidden) : (r = n._data(a, "fxshow", {})),
        f && (r.hidden = !q),
        q
          ? n(a).show()
          : m.done(function () {
              n(a).hide();
            }),
        m.done(function () {
          var b;
          n._removeData(a, "fxshow");
          for (b in o) n.style(a, b, o[b]);
        });
      for (d in o)
        (g = nb(q ? r[d] : 0, d, m)),
          d in r ||
            ((r[d] = g.start),
            q &&
              ((g.end = g.start),
              (g.start = "width" === d || "height" === d ? 1 : 0)));
    }
  }
  function pb(a, b) {
    var c, d, e, f, g;
    for (c in a)
      if (
        ((d = n.camelCase(c)),
        (e = b[d]),
        (f = a[c]),
        n.isArray(f) && ((e = f[1]), (f = a[c] = f[0])),
        c !== d && ((a[d] = f), delete a[c]),
        (g = n.cssHooks[d]),
        g && "expand" in g)
      ) {
        (f = g.expand(f)), delete a[d];
        for (c in f) c in a || ((a[c] = f[c]), (b[c] = e));
      } else b[d] = e;
  }
  function qb(a, b, c) {
    var d,
      e,
      f = 0,
      g = qb.prefilters.length,
      h = n.Deferred().always(function () {
        delete i.elem;
      }),
      i = function () {
        if (e) return !1;
        for (
          var b = hb || lb(),
            c = Math.max(0, j.startTime + j.duration - b),
            d = c / j.duration || 0,
            f = 1 - d,
            g = 0,
            i = j.tweens.length;
          i > g;
          g++
        )
          j.tweens[g].run(f);
        return (
          h.notifyWith(a, [j, f, c]),
          1 > f && i ? c : (h.resolveWith(a, [j]), !1)
        );
      },
      j = h.promise({
        elem: a,
        props: n.extend({}, b),
        opts: n.extend(!0, { specialEasing: {}, easing: n.easing._default }, c),
        originalProperties: b,
        originalOptions: c,
        startTime: hb || lb(),
        duration: c.duration,
        tweens: [],
        createTween: function (b, c) {
          var d = n.Tween(
            a,
            j.opts,
            b,
            c,
            j.opts.specialEasing[b] || j.opts.easing
          );
          return j.tweens.push(d), d;
        },
        stop: function (b) {
          var c = 0,
            d = b ? j.tweens.length : 0;
          if (e) return this;
          for (e = !0; d > c; c++) j.tweens[c].run(1);
          return (
            b
              ? (h.notifyWith(a, [j, 1, 0]), h.resolveWith(a, [j, b]))
              : h.rejectWith(a, [j, b]),
            this
          );
        },
      }),
      k = j.props;
    for (pb(k, j.opts.specialEasing); g > f; f++)
      if ((d = qb.prefilters[f].call(j, a, k, j.opts)))
        return (
          n.isFunction(d.stop) &&
            (n._queueHooks(j.elem, j.opts.queue).stop = n.proxy(d.stop, d)),
          d
        );
    return (
      n.map(k, nb, j),
      n.isFunction(j.opts.start) && j.opts.start.call(a, j),
      n.fx.timer(n.extend(i, { elem: a, anim: j, queue: j.opts.queue })),
      j
        .progress(j.opts.progress)
        .done(j.opts.done, j.opts.complete)
        .fail(j.opts.fail)
        .always(j.opts.always)
    );
  }
  (n.Animation = n.extend(qb, {
    tweeners: {
      "*": [
        function (a, b) {
          var c = this.createTween(a, b);
          return X(c.elem, a, U.exec(b), c), c;
        },
      ],
    },
    tweener: function (a, b) {
      n.isFunction(a) ? ((b = a), (a = ["*"])) : (a = a.match(G));
      for (var c, d = 0, e = a.length; e > d; d++)
        (c = a[d]),
          (qb.tweeners[c] = qb.tweeners[c] || []),
          qb.tweeners[c].unshift(b);
    },
    prefilters: [ob],
    prefilter: function (a, b) {
      b ? qb.prefilters.unshift(a) : qb.prefilters.push(a);
    },
  })),
    (n.speed = function (a, b, c) {
      var d =
        a && "object" == typeof a
          ? n.extend({}, a)
          : {
              complete: c || (!c && b) || (n.isFunction(a) && a),
              duration: a,
              easing: (c && b) || (b && !n.isFunction(b) && b),
            };
      return (
        (d.duration = n.fx.off
          ? 0
          : "number" == typeof d.duration
          ? d.duration
          : d.duration in n.fx.speeds
          ? n.fx.speeds[d.duration]
          : n.fx.speeds._default),
        (null != d.queue && d.queue !== !0) || (d.queue = "fx"),
        (d.old = d.complete),
        (d.complete = function () {
          n.isFunction(d.old) && d.old.call(this),
            d.queue && n.dequeue(this, d.queue);
        }),
        d
      );
    }),
    n.fn.extend({
      fadeTo: function (a, b, c, d) {
        return this.filter(W)
          .css("opacity", 0)
          .show()
          .end()
          .animate({ opacity: b }, a, c, d);
      },
      animate: function (a, b, c, d) {
        var e = n.isEmptyObject(a),
          f = n.speed(b, c, d),
          g = function () {
            var b = qb(this, n.extend({}, a), f);
            (e || n._data(this, "finish")) && b.stop(!0);
          };
        return (
          (g.finish = g),
          e || f.queue === !1 ? this.each(g) : this.queue(f.queue, g)
        );
      },
      stop: function (a, b, c) {
        var d = function (a) {
          var b = a.stop;
          delete a.stop, b(c);
        };
        return (
          "string" != typeof a && ((c = b), (b = a), (a = void 0)),
          b && a !== !1 && this.queue(a || "fx", []),
          this.each(function () {
            var b = !0,
              e = null != a && a + "queueHooks",
              f = n.timers,
              g = n._data(this);
            if (e) g[e] && g[e].stop && d(g[e]);
            else for (e in g) g[e] && g[e].stop && kb.test(e) && d(g[e]);
            for (e = f.length; e--; )
              f[e].elem !== this ||
                (null != a && f[e].queue !== a) ||
                (f[e].anim.stop(c), (b = !1), f.splice(e, 1));
            (!b && c) || n.dequeue(this, a);
          })
        );
      },
      finish: function (a) {
        return (
          a !== !1 && (a = a || "fx"),
          this.each(function () {
            var b,
              c = n._data(this),
              d = c[a + "queue"],
              e = c[a + "queueHooks"],
              f = n.timers,
              g = d ? d.length : 0;
            for (
              c.finish = !0,
                n.queue(this, a, []),
                e && e.stop && e.stop.call(this, !0),
                b = f.length;
              b--;

            )
              f[b].elem === this &&
                f[b].queue === a &&
                (f[b].anim.stop(!0), f.splice(b, 1));
            for (b = 0; g > b; b++)
              d[b] && d[b].finish && d[b].finish.call(this);
            delete c.finish;
          })
        );
      },
    }),
    n.each(["toggle", "show", "hide"], function (a, b) {
      var c = n.fn[b];
      n.fn[b] = function (a, d, e) {
        return null == a || "boolean" == typeof a
          ? c.apply(this, arguments)
          : this.animate(mb(b, !0), a, d, e);
      };
    }),
    n.each(
      {
        slideDown: mb("show"),
        slideUp: mb("hide"),
        slideToggle: mb("toggle"),
        fadeIn: { opacity: "show" },
        fadeOut: { opacity: "hide" },
        fadeToggle: { opacity: "toggle" },
      },
      function (a, b) {
        n.fn[a] = function (a, c, d) {
          return this.animate(b, a, c, d);
        };
      }
    ),
    (n.timers = []),
    (n.fx.tick = function () {
      var a,
        b = n.timers,
        c = 0;
      for (hb = n.now(); c < b.length; c++)
        (a = b[c]), a() || b[c] !== a || b.splice(c--, 1);
      b.length || n.fx.stop(), (hb = void 0);
    }),
    (n.fx.timer = function (a) {
      n.timers.push(a), a() ? n.fx.start() : n.timers.pop();
    }),
    (n.fx.interval = 13),
    (n.fx.start = function () {
      ib || (ib = a.setInterval(n.fx.tick, n.fx.interval));
    }),
    (n.fx.stop = function () {
      a.clearInterval(ib), (ib = null);
    }),
    (n.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
    (n.fn.delay = function (b, c) {
      return (
        (b = n.fx ? n.fx.speeds[b] || b : b),
        (c = c || "fx"),
        this.queue(c, function (c, d) {
          var e = a.setTimeout(c, b);
          d.stop = function () {
            a.clearTimeout(e);
          };
        })
      );
    }),
    (function () {
      var a,
        b = d.createElement("input"),
        c = d.createElement("div"),
        e = d.createElement("select"),
        f = e.appendChild(d.createElement("option"));
      (c = d.createElement("div")),
        c.setAttribute("className", "t"),
        (c.innerHTML =
          "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>"),
        (a = c.getElementsByTagName("a")[0]),
        b.setAttribute("type", "checkbox"),
        c.appendChild(b),
        (a = c.getElementsByTagName("a")[0]),
        (a.style.cssText = "top:1px"),
        (l.getSetAttribute = "t" !== c.className),
        (l.style = /top/.test(a.getAttribute("style"))),
        (l.hrefNormalized = "/a" === a.getAttribute("href")),
        (l.checkOn = !!b.value),
        (l.optSelected = f.selected),
        (l.enctype = !!d.createElement("form").enctype),
        (e.disabled = !0),
        (l.optDisabled = !f.disabled),
        (b = d.createElement("input")),
        b.setAttribute("value", ""),
        (l.input = "" === b.getAttribute("value")),
        (b.value = "t"),
        b.setAttribute("type", "radio"),
        (l.radioValue = "t" === b.value);
    })();
  var rb = /\r/g,
    sb = /[\x20\t\r\n\f]+/g;
  n.fn.extend({
    val: function (a) {
      var b,
        c,
        d,
        e = this[0];
      {
        if (arguments.length)
          return (
            (d = n.isFunction(a)),
            this.each(function (c) {
              var e;
              1 === this.nodeType &&
                ((e = d ? a.call(this, c, n(this).val()) : a),
                null == e
                  ? (e = "")
                  : "number" == typeof e
                  ? (e += "")
                  : n.isArray(e) &&
                    (e = n.map(e, function (a) {
                      return null == a ? "" : a + "";
                    })),
                (b =
                  n.valHooks[this.type] ||
                  n.valHooks[this.nodeName.toLowerCase()]),
                (b && "set" in b && void 0 !== b.set(this, e, "value")) ||
                  (this.value = e));
            })
          );
        if (e)
          return (
            (b = n.valHooks[e.type] || n.valHooks[e.nodeName.toLowerCase()]),
            b && "get" in b && void 0 !== (c = b.get(e, "value"))
              ? c
              : ((c = e.value),
                "string" == typeof c ? c.replace(rb, "") : null == c ? "" : c)
          );
      }
    },
  }),
    n.extend({
      valHooks: {
        option: {
          get: function (a) {
            var b = n.find.attr(a, "value");
            return null != b ? b : n.trim(n.text(a)).replace(sb, " ");
          },
        },
        select: {
          get: function (a) {
            for (
              var b,
                c,
                d = a.options,
                e = a.selectedIndex,
                f = "select-one" === a.type || 0 > e,
                g = f ? null : [],
                h = f ? e + 1 : d.length,
                i = 0 > e ? h : f ? e : 0;
              h > i;
              i++
            )
              if (
                ((c = d[i]),
                (c.selected || i === e) &&
                  (l.optDisabled
                    ? !c.disabled
                    : null === c.getAttribute("disabled")) &&
                  (!c.parentNode.disabled ||
                    !n.nodeName(c.parentNode, "optgroup")))
              ) {
                if (((b = n(c).val()), f)) return b;
                g.push(b);
              }
            return g;
          },
          set: function (a, b) {
            var c,
              d,
              e = a.options,
              f = n.makeArray(b),
              g = e.length;
            while (g--)
              if (((d = e[g]), n.inArray(n.valHooks.option.get(d), f) > -1))
                try {
                  d.selected = c = !0;
                } catch (h) {
                  d.scrollHeight;
                }
              else d.selected = !1;
            return c || (a.selectedIndex = -1), e;
          },
        },
      },
    }),
    n.each(["radio", "checkbox"], function () {
      (n.valHooks[this] = {
        set: function (a, b) {
          return n.isArray(b)
            ? (a.checked = n.inArray(n(a).val(), b) > -1)
            : void 0;
        },
      }),
        l.checkOn ||
          (n.valHooks[this].get = function (a) {
            return null === a.getAttribute("value") ? "on" : a.value;
          });
    });
  var tb,
    ub,
    vb = n.expr.attrHandle,
    wb = /^(?:checked|selected)$/i,
    xb = l.getSetAttribute,
    yb = l.input;
  n.fn.extend({
    attr: function (a, b) {
      return Y(this, n.attr, a, b, arguments.length > 1);
    },
    removeAttr: function (a) {
      return this.each(function () {
        n.removeAttr(this, a);
      });
    },
  }),
    n.extend({
      attr: function (a, b, c) {
        var d,
          e,
          f = a.nodeType;
        if (3 !== f && 8 !== f && 2 !== f)
          return "undefined" == typeof a.getAttribute
            ? n.prop(a, b, c)
            : ((1 === f && n.isXMLDoc(a)) ||
                ((b = b.toLowerCase()),
                (e = n.attrHooks[b] || (n.expr.match.bool.test(b) ? ub : tb))),
              void 0 !== c
                ? null === c
                  ? void n.removeAttr(a, b)
                  : e && "set" in e && void 0 !== (d = e.set(a, c, b))
                  ? d
                  : (a.setAttribute(b, c + ""), c)
                : e && "get" in e && null !== (d = e.get(a, b))
                ? d
                : ((d = n.find.attr(a, b)), null == d ? void 0 : d));
      },
      attrHooks: {
        type: {
          set: function (a, b) {
            if (!l.radioValue && "radio" === b && n.nodeName(a, "input")) {
              var c = a.value;
              return a.setAttribute("type", b), c && (a.value = c), b;
            }
          },
        },
      },
      removeAttr: function (a, b) {
        var c,
          d,
          e = 0,
          f = b && b.match(G);
        if (f && 1 === a.nodeType)
          while ((c = f[e++]))
            (d = n.propFix[c] || c),
              n.expr.match.bool.test(c)
                ? (yb && xb) || !wb.test(c)
                  ? (a[d] = !1)
                  : (a[n.camelCase("default-" + c)] = a[d] = !1)
                : n.attr(a, c, ""),
              a.removeAttribute(xb ? c : d);
      },
    }),
    (ub = {
      set: function (a, b, c) {
        return (
          b === !1
            ? n.removeAttr(a, c)
            : (yb && xb) || !wb.test(c)
            ? a.setAttribute((!xb && n.propFix[c]) || c, c)
            : (a[n.camelCase("default-" + c)] = a[c] = !0),
          c
        );
      },
    }),
    n.each(n.expr.match.bool.source.match(/\w+/g), function (a, b) {
      var c = vb[b] || n.find.attr;
      (yb && xb) || !wb.test(b)
        ? (vb[b] = function (a, b, d) {
            var e, f;
            return (
              d ||
                ((f = vb[b]),
                (vb[b] = e),
                (e = null != c(a, b, d) ? b.toLowerCase() : null),
                (vb[b] = f)),
              e
            );
          })
        : (vb[b] = function (a, b, c) {
            return c
              ? void 0
              : a[n.camelCase("default-" + b)]
              ? b.toLowerCase()
              : null;
          });
    }),
    (yb && xb) ||
      (n.attrHooks.value = {
        set: function (a, b, c) {
          return n.nodeName(a, "input")
            ? void (a.defaultValue = b)
            : tb && tb.set(a, b, c);
        },
      }),
    xb ||
      ((tb = {
        set: function (a, b, c) {
          var d = a.getAttributeNode(c);
          return (
            d || a.setAttributeNode((d = a.ownerDocument.createAttribute(c))),
            (d.value = b += ""),
            "value" === c || b === a.getAttribute(c) ? b : void 0
          );
        },
      }),
      (vb.id =
        vb.name =
        vb.coords =
          function (a, b, c) {
            var d;
            return c
              ? void 0
              : (d = a.getAttributeNode(b)) && "" !== d.value
              ? d.value
              : null;
          }),
      (n.valHooks.button = {
        get: function (a, b) {
          var c = a.getAttributeNode(b);
          return c && c.specified ? c.value : void 0;
        },
        set: tb.set,
      }),
      (n.attrHooks.contenteditable = {
        set: function (a, b, c) {
          tb.set(a, "" === b ? !1 : b, c);
        },
      }),
      n.each(["width", "height"], function (a, b) {
        n.attrHooks[b] = {
          set: function (a, c) {
            return "" === c ? (a.setAttribute(b, "auto"), c) : void 0;
          },
        };
      })),
    l.style ||
      (n.attrHooks.style = {
        get: function (a) {
          return a.style.cssText || void 0;
        },
        set: function (a, b) {
          return (a.style.cssText = b + "");
        },
      });
  var zb = /^(?:input|select|textarea|button|object)$/i,
    Ab = /^(?:a|area)$/i;
  n.fn.extend({
    prop: function (a, b) {
      return Y(this, n.prop, a, b, arguments.length > 1);
    },
    removeProp: function (a) {
      return (
        (a = n.propFix[a] || a),
        this.each(function () {
          try {
            (this[a] = void 0), delete this[a];
          } catch (b) {}
        })
      );
    },
  }),
    n.extend({
      prop: function (a, b, c) {
        var d,
          e,
          f = a.nodeType;
        if (3 !== f && 8 !== f && 2 !== f)
          return (
            (1 === f && n.isXMLDoc(a)) ||
              ((b = n.propFix[b] || b), (e = n.propHooks[b])),
            void 0 !== c
              ? e && "set" in e && void 0 !== (d = e.set(a, c, b))
                ? d
                : (a[b] = c)
              : e && "get" in e && null !== (d = e.get(a, b))
              ? d
              : a[b]
          );
      },
      propHooks: {
        tabIndex: {
          get: function (a) {
            var b = n.find.attr(a, "tabindex");
            return b
              ? parseInt(b, 10)
              : zb.test(a.nodeName) || (Ab.test(a.nodeName) && a.href)
              ? 0
              : -1;
          },
        },
      },
      propFix: { for: "htmlFor", class: "className" },
    }),
    l.hrefNormalized ||
      n.each(["href", "src"], function (a, b) {
        n.propHooks[b] = {
          get: function (a) {
            return a.getAttribute(b, 4);
          },
        };
      }),
    l.optSelected ||
      (n.propHooks.selected = {
        get: function (a) {
          var b = a.parentNode;
          return (
            b && (b.selectedIndex, b.parentNode && b.parentNode.selectedIndex),
            null
          );
        },
        set: function (a) {
          var b = a.parentNode;
          b && (b.selectedIndex, b.parentNode && b.parentNode.selectedIndex);
        },
      }),
    n.each(
      [
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable",
      ],
      function () {
        n.propFix[this.toLowerCase()] = this;
      }
    ),
    l.enctype || (n.propFix.enctype = "encoding");
  var Bb = /[\t\r\n\f]/g;
  function Cb(a) {
    return n.attr(a, "class") || "";
  }
  n.fn.extend({
    addClass: function (a) {
      var b,
        c,
        d,
        e,
        f,
        g,
        h,
        i = 0;
      if (n.isFunction(a))
        return this.each(function (b) {
          n(this).addClass(a.call(this, b, Cb(this)));
        });
      if ("string" == typeof a && a) {
        b = a.match(G) || [];
        while ((c = this[i++]))
          if (
            ((e = Cb(c)),
            (d = 1 === c.nodeType && (" " + e + " ").replace(Bb, " ")))
          ) {
            g = 0;
            while ((f = b[g++])) d.indexOf(" " + f + " ") < 0 && (d += f + " ");
            (h = n.trim(d)), e !== h && n.attr(c, "class", h);
          }
      }
      return this;
    },
    removeClass: function (a) {
      var b,
        c,
        d,
        e,
        f,
        g,
        h,
        i = 0;
      if (n.isFunction(a))
        return this.each(function (b) {
          n(this).removeClass(a.call(this, b, Cb(this)));
        });
      if (!arguments.length) return this.attr("class", "");
      if ("string" == typeof a && a) {
        b = a.match(G) || [];
        while ((c = this[i++]))
          if (
            ((e = Cb(c)),
            (d = 1 === c.nodeType && (" " + e + " ").replace(Bb, " ")))
          ) {
            g = 0;
            while ((f = b[g++]))
              while (d.indexOf(" " + f + " ") > -1)
                d = d.replace(" " + f + " ", " ");
            (h = n.trim(d)), e !== h && n.attr(c, "class", h);
          }
      }
      return this;
    },
    toggleClass: function (a, b) {
      var c = typeof a;
      return "boolean" == typeof b && "string" === c
        ? b
          ? this.addClass(a)
          : this.removeClass(a)
        : n.isFunction(a)
        ? this.each(function (c) {
            n(this).toggleClass(a.call(this, c, Cb(this), b), b);
          })
        : this.each(function () {
            var b, d, e, f;
            if ("string" === c) {
              (d = 0), (e = n(this)), (f = a.match(G) || []);
              while ((b = f[d++]))
                e.hasClass(b) ? e.removeClass(b) : e.addClass(b);
            } else (void 0 !== a && "boolean" !== c) || ((b = Cb(this)), b && n._data(this, "__className__", b), n.attr(this, "class", b || a === !1 ? "" : n._data(this, "__className__") || ""));
          });
    },
    hasClass: function (a) {
      var b,
        c,
        d = 0;
      b = " " + a + " ";
      while ((c = this[d++]))
        if (
          1 === c.nodeType &&
          (" " + Cb(c) + " ").replace(Bb, " ").indexOf(b) > -1
        )
          return !0;
      return !1;
    },
  }),
    n.each(
      "blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(
        " "
      ),
      function (a, b) {
        n.fn[b] = function (a, c) {
          return arguments.length > 0
            ? this.on(b, null, a, c)
            : this.trigger(b);
        };
      }
    ),
    n.fn.extend({
      hover: function (a, b) {
        return this.mouseenter(a).mouseleave(b || a);
      },
    });
  var Db = a.location,
    Eb = n.now(),
    Fb = /\?/,
    Gb =
      /(,)|(\[|{)|(}|])|"(?:[^"\\\r\n]|\\["\\\/bfnrt]|\\u[\da-fA-F]{4})*"\s*:?|true|false|null|-?(?!0\d)\d+(?:\.\d+|)(?:[eE][+-]?\d+|)/g;
  (n.parseJSON = function (b) {
    if (a.JSON && a.JSON.parse) return a.JSON.parse(b + "");
    var c,
      d = null,
      e = n.trim(b + "");
    return e &&
      !n.trim(
        e.replace(Gb, function (a, b, e, f) {
          return (
            c && b && (d = 0), 0 === d ? a : ((c = e || b), (d += !f - !e), "")
          );
        })
      )
      ? Function("return " + e)()
      : n.error("Invalid JSON: " + b);
  }),
    (n.parseXML = function (b) {
      var c, d;
      if (!b || "string" != typeof b) return null;
      try {
        a.DOMParser
          ? ((d = new a.DOMParser()), (c = d.parseFromString(b, "text/xml")))
          : ((c = new a.ActiveXObject("Microsoft.XMLDOM")),
            (c.async = "false"),
            c.loadXML(b));
      } catch (e) {
        c = void 0;
      }
      return (
        (c &&
          c.documentElement &&
          !c.getElementsByTagName("parsererror").length) ||
          n.error("Invalid XML: " + b),
        c
      );
    });
  var Hb = /#.*$/,
    Ib = /([?&])_=[^&]*/,
    Jb = /^(.*?):[ \t]*([^\r\n]*)\r?$/gm,
    Kb = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
    Lb = /^(?:GET|HEAD)$/,
    Mb = /^\/\//,
    Nb = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,
    Ob = {},
    Pb = {},
    Qb = "*/".concat("*"),
    Rb = Db.href,
    Sb = Nb.exec(Rb.toLowerCase()) || [];
  function Tb(a) {
    return function (b, c) {
      "string" != typeof b && ((c = b), (b = "*"));
      var d,
        e = 0,
        f = b.toLowerCase().match(G) || [];
      if (n.isFunction(c))
        while ((d = f[e++]))
          "+" === d.charAt(0)
            ? ((d = d.slice(1) || "*"), (a[d] = a[d] || []).unshift(c))
            : (a[d] = a[d] || []).push(c);
    };
  }
  function Ub(a, b, c, d) {
    var e = {},
      f = a === Pb;
    function g(h) {
      var i;
      return (
        (e[h] = !0),
        n.each(a[h] || [], function (a, h) {
          var j = h(b, c, d);
          return "string" != typeof j || f || e[j]
            ? f
              ? !(i = j)
              : void 0
            : (b.dataTypes.unshift(j), g(j), !1);
        }),
        i
      );
    }
    return g(b.dataTypes[0]) || (!e["*"] && g("*"));
  }
  function Vb(a, b) {
    var c,
      d,
      e = n.ajaxSettings.flatOptions || {};
    for (d in b) void 0 !== b[d] && ((e[d] ? a : c || (c = {}))[d] = b[d]);
    return c && n.extend(!0, a, c), a;
  }
  function Wb(a, b, c) {
    var d,
      e,
      f,
      g,
      h = a.contents,
      i = a.dataTypes;
    while ("*" === i[0])
      i.shift(),
        void 0 === e && (e = a.mimeType || b.getResponseHeader("Content-Type"));
    if (e)
      for (g in h)
        if (h[g] && h[g].test(e)) {
          i.unshift(g);
          break;
        }
    if (i[0] in c) f = i[0];
    else {
      for (g in c) {
        if (!i[0] || a.converters[g + " " + i[0]]) {
          f = g;
          break;
        }
        d || (d = g);
      }
      f = f || d;
    }
    return f ? (f !== i[0] && i.unshift(f), c[f]) : void 0;
  }
  function Xb(a, b, c, d) {
    var e,
      f,
      g,
      h,
      i,
      j = {},
      k = a.dataTypes.slice();
    if (k[1]) for (g in a.converters) j[g.toLowerCase()] = a.converters[g];
    f = k.shift();
    while (f)
      if (
        (a.responseFields[f] && (c[a.responseFields[f]] = b),
        !i && d && a.dataFilter && (b = a.dataFilter(b, a.dataType)),
        (i = f),
        (f = k.shift()))
      )
        if ("*" === f) f = i;
        else if ("*" !== i && i !== f) {
          if (((g = j[i + " " + f] || j["* " + f]), !g))
            for (e in j)
              if (
                ((h = e.split(" ")),
                h[1] === f && (g = j[i + " " + h[0]] || j["* " + h[0]]))
              ) {
                g === !0
                  ? (g = j[e])
                  : j[e] !== !0 && ((f = h[0]), k.unshift(h[1]));
                break;
              }
          if (g !== !0)
            if (g && a["throws"]) b = g(b);
            else
              try {
                b = g(b);
              } catch (l) {
                return {
                  state: "parsererror",
                  error: g ? l : "No conversion from " + i + " to " + f,
                };
              }
        }
    return { state: "success", data: b };
  }
  n.extend({
    active: 0,
    lastModified: {},
    etag: {},
    ajaxSettings: {
      url: Rb,
      type: "GET",
      isLocal: Kb.test(Sb[1]),
      global: !0,
      processData: !0,
      async: !0,
      contentType: "application/x-www-form-urlencoded; charset=UTF-8",
      accepts: {
        "*": Qb,
        text: "text/plain",
        html: "text/html",
        xml: "application/xml, text/xml",
        json: "application/json, text/javascript",
      },
      contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
      responseFields: {
        xml: "responseXML",
        text: "responseText",
        json: "responseJSON",
      },
      converters: {
        "* text": String,
        "text html": !0,
        "text json": n.parseJSON,
        "text xml": n.parseXML,
      },
      flatOptions: { url: !0, context: !0 },
    },
    ajaxSetup: function (a, b) {
      return b ? Vb(Vb(a, n.ajaxSettings), b) : Vb(n.ajaxSettings, a);
    },
    ajaxPrefilter: Tb(Ob),
    ajaxTransport: Tb(Pb),
    ajax: function (b, c) {
      "object" == typeof b && ((c = b), (b = void 0)), (c = c || {});
      var d,
        e,
        f,
        g,
        h,
        i,
        j,
        k,
        l = n.ajaxSetup({}, c),
        m = l.context || l,
        o = l.context && (m.nodeType || m.jquery) ? n(m) : n.event,
        p = n.Deferred(),
        q = n.Callbacks("once memory"),
        r = l.statusCode || {},
        s = {},
        t = {},
        u = 0,
        v = "canceled",
        w = {
          readyState: 0,
          getResponseHeader: function (a) {
            var b;
            if (2 === u) {
              if (!k) {
                k = {};
                while ((b = Jb.exec(g))) k[b[1].toLowerCase()] = b[2];
              }
              b = k[a.toLowerCase()];
            }
            return null == b ? null : b;
          },
          getAllResponseHeaders: function () {
            return 2 === u ? g : null;
          },
          setRequestHeader: function (a, b) {
            var c = a.toLowerCase();
            return u || ((a = t[c] = t[c] || a), (s[a] = b)), this;
          },
          overrideMimeType: function (a) {
            return u || (l.mimeType = a), this;
          },
          statusCode: function (a) {
            var b;
            if (a)
              if (2 > u) for (b in a) r[b] = [r[b], a[b]];
              else w.always(a[w.status]);
            return this;
          },
          abort: function (a) {
            var b = a || v;
            return j && j.abort(b), y(0, b), this;
          },
        };
      if (
        ((p.promise(w).complete = q.add),
        (w.success = w.done),
        (w.error = w.fail),
        (l.url = ((b || l.url || Rb) + "")
          .replace(Hb, "")
          .replace(Mb, Sb[1] + "//")),
        (l.type = c.method || c.type || l.method || l.type),
        (l.dataTypes = n
          .trim(l.dataType || "*")
          .toLowerCase()
          .match(G) || [""]),
        null == l.crossDomain &&
          ((d = Nb.exec(l.url.toLowerCase())),
          (l.crossDomain = !(
            !d ||
            (d[1] === Sb[1] &&
              d[2] === Sb[2] &&
              (d[3] || ("http:" === d[1] ? "80" : "443")) ===
                (Sb[3] || ("http:" === Sb[1] ? "80" : "443")))
          ))),
        l.data &&
          l.processData &&
          "string" != typeof l.data &&
          (l.data = n.param(l.data, l.traditional)),
        Ub(Ob, l, c, w),
        2 === u)
      )
        return w;
      (i = n.event && l.global),
        i && 0 === n.active++ && n.event.trigger("ajaxStart"),
        (l.type = l.type.toUpperCase()),
        (l.hasContent = !Lb.test(l.type)),
        (f = l.url),
        l.hasContent ||
          (l.data &&
            ((f = l.url += (Fb.test(f) ? "&" : "?") + l.data), delete l.data),
          l.cache === !1 &&
            (l.url = Ib.test(f)
              ? f.replace(Ib, "$1_=" + Eb++)
              : f + (Fb.test(f) ? "&" : "?") + "_=" + Eb++)),
        l.ifModified &&
          (n.lastModified[f] &&
            w.setRequestHeader("If-Modified-Since", n.lastModified[f]),
          n.etag[f] && w.setRequestHeader("If-None-Match", n.etag[f])),
        ((l.data && l.hasContent && l.contentType !== !1) || c.contentType) &&
          w.setRequestHeader("Content-Type", l.contentType),
        w.setRequestHeader(
          "Accept",
          l.dataTypes[0] && l.accepts[l.dataTypes[0]]
            ? l.accepts[l.dataTypes[0]] +
                ("*" !== l.dataTypes[0] ? ", " + Qb + "; q=0.01" : "")
            : l.accepts["*"]
        );
      for (e in l.headers) w.setRequestHeader(e, l.headers[e]);
      if (l.beforeSend && (l.beforeSend.call(m, w, l) === !1 || 2 === u))
        return w.abort();
      v = "abort";
      for (e in { success: 1, error: 1, complete: 1 }) w[e](l[e]);
      if ((j = Ub(Pb, l, c, w))) {
        if (((w.readyState = 1), i && o.trigger("ajaxSend", [w, l]), 2 === u))
          return w;
        l.async &&
          l.timeout > 0 &&
          (h = a.setTimeout(function () {
            w.abort("timeout");
          }, l.timeout));
        try {
          (u = 1), j.send(s, y);
        } catch (x) {
          if (!(2 > u)) throw x;
          y(-1, x);
        }
      } else y(-1, "No Transport");
      function y(b, c, d, e) {
        var k,
          s,
          t,
          v,
          x,
          y = c;
        2 !== u &&
          ((u = 2),
          h && a.clearTimeout(h),
          (j = void 0),
          (g = e || ""),
          (w.readyState = b > 0 ? 4 : 0),
          (k = (b >= 200 && 300 > b) || 304 === b),
          d && (v = Wb(l, w, d)),
          (v = Xb(l, v, w, k)),
          k
            ? (l.ifModified &&
                ((x = w.getResponseHeader("Last-Modified")),
                x && (n.lastModified[f] = x),
                (x = w.getResponseHeader("etag")),
                x && (n.etag[f] = x)),
              204 === b || "HEAD" === l.type
                ? (y = "nocontent")
                : 304 === b
                ? (y = "notmodified")
                : ((y = v.state), (s = v.data), (t = v.error), (k = !t)))
            : ((t = y), (!b && y) || ((y = "error"), 0 > b && (b = 0))),
          (w.status = b),
          (w.statusText = (c || y) + ""),
          k ? p.resolveWith(m, [s, y, w]) : p.rejectWith(m, [w, y, t]),
          w.statusCode(r),
          (r = void 0),
          i && o.trigger(k ? "ajaxSuccess" : "ajaxError", [w, l, k ? s : t]),
          q.fireWith(m, [w, y]),
          i &&
            (o.trigger("ajaxComplete", [w, l]),
            --n.active || n.event.trigger("ajaxStop")));
      }
      return w;
    },
    getJSON: function (a, b, c) {
      return n.get(a, b, c, "json");
    },
    getScript: function (a, b) {
      return n.get(a, void 0, b, "script");
    },
  }),
    n.each(["get", "post"], function (a, b) {
      n[b] = function (a, c, d, e) {
        return (
          n.isFunction(c) && ((e = e || d), (d = c), (c = void 0)),
          n.ajax(
            n.extend(
              { url: a, type: b, dataType: e, data: c, success: d },
              n.isPlainObject(a) && a
            )
          )
        );
      };
    }),
    (n._evalUrl = function (a) {
      return n.ajax({
        url: a,
        type: "GET",
        dataType: "script",
        cache: !0,
        async: !1,
        global: !1,
        throws: !0,
      });
    }),
    n.fn.extend({
      wrapAll: function (a) {
        if (n.isFunction(a))
          return this.each(function (b) {
            n(this).wrapAll(a.call(this, b));
          });
        if (this[0]) {
          var b = n(a, this[0].ownerDocument).eq(0).clone(!0);
          this[0].parentNode && b.insertBefore(this[0]),
            b
              .map(function () {
                var a = this;
                while (a.firstChild && 1 === a.firstChild.nodeType)
                  a = a.firstChild;
                return a;
              })
              .append(this);
        }
        return this;
      },
      wrapInner: function (a) {
        return n.isFunction(a)
          ? this.each(function (b) {
              n(this).wrapInner(a.call(this, b));
            })
          : this.each(function () {
              var b = n(this),
                c = b.contents();
              c.length ? c.wrapAll(a) : b.append(a);
            });
      },
      wrap: function (a) {
        var b = n.isFunction(a);
        return this.each(function (c) {
          n(this).wrapAll(b ? a.call(this, c) : a);
        });
      },
      unwrap: function () {
        return this.parent()
          .each(function () {
            n.nodeName(this, "body") || n(this).replaceWith(this.childNodes);
          })
          .end();
      },
    });
  function Yb(a) {
    return (a.style && a.style.display) || n.css(a, "display");
  }
  function Zb(a) {
    if (!n.contains(a.ownerDocument || d, a)) return !0;
    while (a && 1 === a.nodeType) {
      if ("none" === Yb(a) || "hidden" === a.type) return !0;
      a = a.parentNode;
    }
    return !1;
  }
  (n.expr.filters.hidden = function (a) {
    return l.reliableHiddenOffsets()
      ? a.offsetWidth <= 0 && a.offsetHeight <= 0 && !a.getClientRects().length
      : Zb(a);
  }),
    (n.expr.filters.visible = function (a) {
      return !n.expr.filters.hidden(a);
    });
  var $b = /%20/g,
    _b = /\[\]$/,
    ac = /\r?\n/g,
    bc = /^(?:submit|button|image|reset|file)$/i,
    cc = /^(?:input|select|textarea|keygen)/i;
  function dc(a, b, c, d) {
    var e;
    if (n.isArray(b))
      n.each(b, function (b, e) {
        c || _b.test(a)
          ? d(a, e)
          : dc(
              a + "[" + ("object" == typeof e && null != e ? b : "") + "]",
              e,
              c,
              d
            );
      });
    else if (c || "object" !== n.type(b)) d(a, b);
    else for (e in b) dc(a + "[" + e + "]", b[e], c, d);
  }
  (n.param = function (a, b) {
    var c,
      d = [],
      e = function (a, b) {
        (b = n.isFunction(b) ? b() : null == b ? "" : b),
          (d[d.length] = encodeURIComponent(a) + "=" + encodeURIComponent(b));
      };
    if (
      (void 0 === b && (b = n.ajaxSettings && n.ajaxSettings.traditional),
      n.isArray(a) || (a.jquery && !n.isPlainObject(a)))
    )
      n.each(a, function () {
        e(this.name, this.value);
      });
    else for (c in a) dc(c, a[c], b, e);
    return d.join("&").replace($b, "+");
  }),
    n.fn.extend({
      serialize: function () {
        return n.param(this.serializeArray());
      },
      serializeArray: function () {
        return this.map(function () {
          var a = n.prop(this, "elements");
          return a ? n.makeArray(a) : this;
        })
          .filter(function () {
            var a = this.type;
            return (
              this.name &&
              !n(this).is(":disabled") &&
              cc.test(this.nodeName) &&
              !bc.test(a) &&
              (this.checked || !Z.test(a))
            );
          })
          .map(function (a, b) {
            var c = n(this).val();
            return null == c
              ? null
              : n.isArray(c)
              ? n.map(c, function (a) {
                  return { name: b.name, value: a.replace(ac, "\r\n") };
                })
              : { name: b.name, value: c.replace(ac, "\r\n") };
          })
          .get();
      },
    }),
    (n.ajaxSettings.xhr =
      void 0 !== a.ActiveXObject
        ? function () {
            return this.isLocal
              ? ic()
              : d.documentMode > 8
              ? hc()
              : (/^(get|post|head|put|delete|options)$/i.test(this.type) &&
                  hc()) ||
                ic();
          }
        : hc);
  var ec = 0,
    fc = {},
    gc = n.ajaxSettings.xhr();
  a.attachEvent &&
    a.attachEvent("onunload", function () {
      for (var a in fc) fc[a](void 0, !0);
    }),
    (l.cors = !!gc && "withCredentials" in gc),
    (gc = l.ajax = !!gc),
    gc &&
      n.ajaxTransport(function (b) {
        if (!b.crossDomain || l.cors) {
          var c;
          return {
            send: function (d, e) {
              var f,
                g = b.xhr(),
                h = ++ec;
              if (
                (g.open(b.type, b.url, b.async, b.username, b.password),
                b.xhrFields)
              )
                for (f in b.xhrFields) g[f] = b.xhrFields[f];
              b.mimeType &&
                g.overrideMimeType &&
                g.overrideMimeType(b.mimeType),
                b.crossDomain ||
                  d["X-Requested-With"] ||
                  (d["X-Requested-With"] = "XMLHttpRequest");
              for (f in d) void 0 !== d[f] && g.setRequestHeader(f, d[f] + "");
              g.send((b.hasContent && b.data) || null),
                (c = function (a, d) {
                  var f, i, j;
                  if (c && (d || 4 === g.readyState))
                    if (
                      (delete fc[h],
                      (c = void 0),
                      (g.onreadystatechange = n.noop),
                      d)
                    )
                      4 !== g.readyState && g.abort();
                    else {
                      (j = {}),
                        (f = g.status),
                        "string" == typeof g.responseText &&
                          (j.text = g.responseText);
                      try {
                        i = g.statusText;
                      } catch (k) {
                        i = "";
                      }
                      f || !b.isLocal || b.crossDomain
                        ? 1223 === f && (f = 204)
                        : (f = j.text ? 200 : 404);
                    }
                  j && e(f, i, j, g.getAllResponseHeaders());
                }),
                b.async
                  ? 4 === g.readyState
                    ? a.setTimeout(c)
                    : (g.onreadystatechange = fc[h] = c)
                  : c();
            },
            abort: function () {
              c && c(void 0, !0);
            },
          };
        }
      });
  function hc() {
    try {
      return new a.XMLHttpRequest();
    } catch (b) {}
  }
  function ic() {
    try {
      return new a.ActiveXObject("Microsoft.XMLHTTP");
    } catch (b) {}
  }
  n.ajaxSetup({
    accepts: {
      script:
        "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript",
    },
    contents: { script: /\b(?:java|ecma)script\b/ },
    converters: {
      "text script": function (a) {
        return n.globalEval(a), a;
      },
    },
  }),
    n.ajaxPrefilter("script", function (a) {
      void 0 === a.cache && (a.cache = !1),
        a.crossDomain && ((a.type = "GET"), (a.global = !1));
    }),
    n.ajaxTransport("script", function (a) {
      if (a.crossDomain) {
        var b,
          c = d.head || n("head")[0] || d.documentElement;
        return {
          send: function (e, f) {
            (b = d.createElement("script")),
              (b.async = !0),
              a.scriptCharset && (b.charset = a.scriptCharset),
              (b.src = a.url),
              (b.onload = b.onreadystatechange =
                function (a, c) {
                  (c ||
                    !b.readyState ||
                    /loaded|complete/.test(b.readyState)) &&
                    ((b.onload = b.onreadystatechange = null),
                    b.parentNode && b.parentNode.removeChild(b),
                    (b = null),
                    c || f(200, "success"));
                }),
              c.insertBefore(b, c.firstChild);
          },
          abort: function () {
            b && b.onload(void 0, !0);
          },
        };
      }
    });
  var jc = [],
    kc = /(=)\?(?=&|$)|\?\?/;
  n.ajaxSetup({
    jsonp: "callback",
    jsonpCallback: function () {
      var a = jc.pop() || n.expando + "_" + Eb++;
      return (this[a] = !0), a;
    },
  }),
    n.ajaxPrefilter("json jsonp", function (b, c, d) {
      var e,
        f,
        g,
        h =
          b.jsonp !== !1 &&
          (kc.test(b.url)
            ? "url"
            : "string" == typeof b.data &&
              0 ===
                (b.contentType || "").indexOf(
                  "application/x-www-form-urlencoded"
                ) &&
              kc.test(b.data) &&
              "data");
      return h || "jsonp" === b.dataTypes[0]
        ? ((e = b.jsonpCallback =
            n.isFunction(b.jsonpCallback)
              ? b.jsonpCallback()
              : b.jsonpCallback),
          h
            ? (b[h] = b[h].replace(kc, "$1" + e))
            : b.jsonp !== !1 &&
              (b.url += (Fb.test(b.url) ? "&" : "?") + b.jsonp + "=" + e),
          (b.converters["script json"] = function () {
            return g || n.error(e + " was not called"), g[0];
          }),
          (b.dataTypes[0] = "json"),
          (f = a[e]),
          (a[e] = function () {
            g = arguments;
          }),
          d.always(function () {
            void 0 === f ? n(a).removeProp(e) : (a[e] = f),
              b[e] && ((b.jsonpCallback = c.jsonpCallback), jc.push(e)),
              g && n.isFunction(f) && f(g[0]),
              (g = f = void 0);
          }),
          "script")
        : void 0;
    }),
    (n.parseHTML = function (a, b, c) {
      if (!a || "string" != typeof a) return null;
      "boolean" == typeof b && ((c = b), (b = !1)), (b = b || d);
      var e = x.exec(a),
        f = !c && [];
      return e
        ? [b.createElement(e[1])]
        : ((e = ja([a], b, f)),
          f && f.length && n(f).remove(),
          n.merge([], e.childNodes));
    });
  var lc = n.fn.load;
  (n.fn.load = function (a, b, c) {
    if ("string" != typeof a && lc) return lc.apply(this, arguments);
    var d,
      e,
      f,
      g = this,
      h = a.indexOf(" ");
    return (
      h > -1 && ((d = n.trim(a.slice(h, a.length))), (a = a.slice(0, h))),
      n.isFunction(b)
        ? ((c = b), (b = void 0))
        : b && "object" == typeof b && (e = "POST"),
      g.length > 0 &&
        n
          .ajax({ url: a, type: e || "GET", dataType: "html", data: b })
          .done(function (a) {
            (f = arguments),
              g.html(d ? n("<div>").append(n.parseHTML(a)).find(d) : a);
          })
          .always(
            c &&
              function (a, b) {
                g.each(function () {
                  c.apply(this, f || [a.responseText, b, a]);
                });
              }
          ),
      this
    );
  }),
    n.each(
      [
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend",
      ],
      function (a, b) {
        n.fn[b] = function (a) {
          return this.on(b, a);
        };
      }
    ),
    (n.expr.filters.animated = function (a) {
      return n.grep(n.timers, function (b) {
        return a === b.elem;
      }).length;
    });
  function mc(a) {
    return n.isWindow(a)
      ? a
      : 9 === a.nodeType
      ? a.defaultView || a.parentWindow
      : !1;
  }
  (n.offset = {
    setOffset: function (a, b, c) {
      var d,
        e,
        f,
        g,
        h,
        i,
        j,
        k = n.css(a, "position"),
        l = n(a),
        m = {};
      "static" === k && (a.style.position = "relative"),
        (h = l.offset()),
        (f = n.css(a, "top")),
        (i = n.css(a, "left")),
        (j =
          ("absolute" === k || "fixed" === k) &&
          n.inArray("auto", [f, i]) > -1),
        j
          ? ((d = l.position()), (g = d.top), (e = d.left))
          : ((g = parseFloat(f) || 0), (e = parseFloat(i) || 0)),
        n.isFunction(b) && (b = b.call(a, c, n.extend({}, h))),
        null != b.top && (m.top = b.top - h.top + g),
        null != b.left && (m.left = b.left - h.left + e),
        "using" in b ? b.using.call(a, m) : l.css(m);
    },
  }),
    n.fn.extend({
      offset: function (a) {
        if (arguments.length)
          return void 0 === a
            ? this
            : this.each(function (b) {
                n.offset.setOffset(this, a, b);
              });
        var b,
          c,
          d = { top: 0, left: 0 },
          e = this[0],
          f = e && e.ownerDocument;
        if (f)
          return (
            (b = f.documentElement),
            n.contains(b, e)
              ? ("undefined" != typeof e.getBoundingClientRect &&
                  (d = e.getBoundingClientRect()),
                (c = mc(f)),
                {
                  top:
                    d.top + (c.pageYOffset || b.scrollTop) - (b.clientTop || 0),
                  left:
                    d.left +
                    (c.pageXOffset || b.scrollLeft) -
                    (b.clientLeft || 0),
                })
              : d
          );
      },
      position: function () {
        if (this[0]) {
          var a,
            b,
            c = { top: 0, left: 0 },
            d = this[0];
          return (
            "fixed" === n.css(d, "position")
              ? (b = d.getBoundingClientRect())
              : ((a = this.offsetParent()),
                (b = this.offset()),
                n.nodeName(a[0], "html") || (c = a.offset()),
                (c.top += n.css(a[0], "borderTopWidth", !0)),
                (c.left += n.css(a[0], "borderLeftWidth", !0))),
            {
              top: b.top - c.top - n.css(d, "marginTop", !0),
              left: b.left - c.left - n.css(d, "marginLeft", !0),
            }
          );
        }
      },
      offsetParent: function () {
        return this.map(function () {
          var a = this.offsetParent;
          while (
            a &&
            !n.nodeName(a, "html") &&
            "static" === n.css(a, "position")
          )
            a = a.offsetParent;
          return a || Qa;
        });
      },
    }),
    n.each(
      { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" },
      function (a, b) {
        var c = /Y/.test(b);
        n.fn[a] = function (d) {
          return Y(
            this,
            function (a, d, e) {
              var f = mc(a);
              return void 0 === e
                ? f
                  ? b in f
                    ? f[b]
                    : f.document.documentElement[d]
                  : a[d]
                : void (f
                    ? f.scrollTo(
                        c ? n(f).scrollLeft() : e,
                        c ? e : n(f).scrollTop()
                      )
                    : (a[d] = e));
            },
            a,
            d,
            arguments.length,
            null
          );
        };
      }
    ),
    n.each(["top", "left"], function (a, b) {
      n.cssHooks[b] = Ua(l.pixelPosition, function (a, c) {
        return c
          ? ((c = Sa(a, b)), Oa.test(c) ? n(a).position()[b] + "px" : c)
          : void 0;
      });
    }),
    n.each({ Height: "height", Width: "width" }, function (a, b) {
      n.each(
        {
          padding: "inner" + a,
          content: b,
          "": "outer" + a,
        },
        function (c, d) {
          n.fn[d] = function (d, e) {
            var f = arguments.length && (c || "boolean" != typeof d),
              g = c || (d === !0 || e === !0 ? "margin" : "border");
            return Y(
              this,
              function (b, c, d) {
                var e;
                return n.isWindow(b)
                  ? b.document.documentElement["client" + a]
                  : 9 === b.nodeType
                  ? ((e = b.documentElement),
                    Math.max(
                      b.body["scroll" + a],
                      e["scroll" + a],
                      b.body["offset" + a],
                      e["offset" + a],
                      e["client" + a]
                    ))
                  : void 0 === d
                  ? n.css(b, c, g)
                  : n.style(b, c, d, g);
              },
              b,
              f ? d : void 0,
              f,
              null
            );
          };
        }
      );
    }),
    n.fn.extend({
      bind: function (a, b, c) {
        return this.on(a, null, b, c);
      },
      unbind: function (a, b) {
        return this.off(a, null, b);
      },
      delegate: function (a, b, c, d) {
        return this.on(b, a, c, d);
      },
      undelegate: function (a, b, c) {
        return 1 === arguments.length
          ? this.off(a, "**")
          : this.off(b, a || "**", c);
      },
    }),
    (n.fn.size = function () {
      return this.length;
    }),
    (n.fn.andSelf = n.fn.addBack),
    "function" == typeof define &&
      define.amd &&
      define("jquery", [], function () {
        return n;
      });
  var nc = a.jQuery,
    oc = a.$;
  return (
    (n.noConflict = function (b) {
      return a.$ === n && (a.$ = oc), b && a.jQuery === n && (a.jQuery = nc), n;
    }),
    b || (a.jQuery = a.$ = n),
    n
  );
});

/* counter */
jQuery.fn.countMe = function (t, e, k) {
  if (void 0 !== t || void 0 !== e) {
    var n = k,
      r = this.html();
    return (
      setTimeout(() => {
        var t = setInterval(() => {
          (n = n + 10), this.text(n), n == r && clearInterval(t);
        }, e);
      }, t),
      this
    );
  }
  alert("Worning!\ndelay and speed can't be empty!");
};
var $el = $(".count-section"); //record the elem so you don't crawl the DOM everytime
var window_height = $(window).height();
if ($el.length > 0) {
  var stickyHeaderTop = $el.offset().top - window_height; // passing "true" will also include the top and bottom margin
  console.log(stickyHeaderTop);
}
if ($el.length > 0) {
  var flag = 0;
  $(window).scroll(function () {
    if (flag == 0) {
      console.log($(window).scrollTop() + ">" + stickyHeaderTop);
      if ($(window).scrollTop() > stickyHeaderTop) {
        flag = 1;
      }

      if (flag == 1) {
        // $(selector).countMe(delay,speed)
        //$(".Index_lefticon_rightcount_rightside_info_new h2 span.icon_1").countMe(200, 400);
        $(
          ".Index_lefticon_rightcount_rightside_info_new h2 span.icon_2"
        ).countMe(2, 2, 500);
        //$(".Index_lefticon_rightcount_rightside_info_new h2 span.icon_3").countMe(200, 400);
        //$(".Index_lefticon_rightcount_rightside_info_new h2 span.icon_4").countMe(50, 100);

        //$("#num2").countMe(30, 30);
        //$("#num3").countMe(40, 50);
        //$("#num4").countMe(100,200);
      }
    }
  });
}

/*
 Version: 1.8.0 Slick
 */
!(function (a) {
  "use strict";
  "function" == typeof define && define.amd
    ? define(["jquery"], a)
    : "undefined" != typeof exports
    ? (module.exports = a(require("jquery")))
    : a(jQuery);
})(function (a) {
  "use strict";
  var b = window.Slick || {};
  (b = (function () {
    function c(c, d) {
      var f,
        e = this;
      (e.defaults = {
        accessibility: !0,
        adaptiveHeight: !1,
        appendArrows: a(c),
        appendDots: a(c),
        arrows: !0,
        asNavFor: null,
        prevArrow:
          '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',
        nextArrow:
          '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',
        autoplay: !1,
        autoplaySpeed: 3e3,
        centerMode: !1,
        centerPadding: "50px",
        cssEase: "ease",
        customPaging: function (b, c) {
          return a(
            '<button type="button" data-role="none" role="button" tabindex="0" />'
          ).text(c + 1);
        },
        dots: !1,
        dotsClass: "slick-dots",
        draggable: !0,
        easing: "linear",
        edgeFriction: 0.35,
        fade: !1,
        focusOnSelect: !1,
        infinite: !0,
        initialSlide: 0,
        lazyLoad: "ondemand",
        mobileFirst: !1,
        pauseOnHover: !0,
        pauseOnFocus: !0,
        pauseOnDotsHover: !1,
        respondTo: "window",
        responsive: null,
        rows: 1,
        rtl: !1,
        slide: "",
        slidesPerRow: 1,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        swipe: !0,
        swipeToSlide: !1,
        touchMove: !0,
        touchThreshold: 5,
        useCSS: !0,
        useTransform: !0,
        variableWidth: !1,
        vertical: !1,
        verticalSwiping: !1,
        waitForAnimate: !0,
        zIndex: 1e3,
      }),
        (e.initials = {
          animating: !1,
          dragging: !1,
          autoPlayTimer: null,
          currentDirection: 0,
          currentLeft: null,
          currentSlide: 0,
          direction: 1,
          $dots: null,
          listWidth: null,
          listHeight: null,
          loadIndex: 0,
          $nextArrow: null,
          $prevArrow: null,
          slideCount: null,
          slideWidth: null,
          $slideTrack: null,
          $slides: null,
          sliding: !1,
          slideOffset: 0,
          swipeLeft: null,
          $list: null,
          touchObject: {},
          transformsEnabled: !1,
          unslicked: !1,
        }),
        a.extend(e, e.initials),
        (e.activeBreakpoint = null),
        (e.animType = null),
        (e.animProp = null),
        (e.breakpoints = []),
        (e.breakpointSettings = []),
        (e.cssTransitions = !1),
        (e.focussed = !1),
        (e.interrupted = !1),
        (e.hidden = "hidden"),
        (e.paused = !0),
        (e.positionProp = null),
        (e.respondTo = null),
        (e.rowCount = 1),
        (e.shouldClick = !0),
        (e.$slider = a(c)),
        (e.$slidesCache = null),
        (e.transformType = null),
        (e.transitionType = null),
        (e.visibilityChange = "visibilitychange"),
        (e.windowWidth = 0),
        (e.windowTimer = null),
        (f = a(c).data("slick") || {}),
        (e.options = a.extend({}, e.defaults, d, f)),
        (e.currentSlide = e.options.initialSlide),
        (e.originalSettings = e.options),
        "undefined" != typeof document.mozHidden
          ? ((e.hidden = "mozHidden"),
            (e.visibilityChange = "mozvisibilitychange"))
          : "undefined" != typeof document.webkitHidden &&
            ((e.hidden = "webkitHidden"),
            (e.visibilityChange = "webkitvisibilitychange")),
        (e.autoPlay = a.proxy(e.autoPlay, e)),
        (e.autoPlayClear = a.proxy(e.autoPlayClear, e)),
        (e.autoPlayIterator = a.proxy(e.autoPlayIterator, e)),
        (e.changeSlide = a.proxy(e.changeSlide, e)),
        (e.clickHandler = a.proxy(e.clickHandler, e)),
        (e.selectHandler = a.proxy(e.selectHandler, e)),
        (e.setPosition = a.proxy(e.setPosition, e)),
        (e.swipeHandler = a.proxy(e.swipeHandler, e)),
        (e.dragHandler = a.proxy(e.dragHandler, e)),
        (e.keyHandler = a.proxy(e.keyHandler, e)),
        (e.instanceUid = b++),
        (e.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
        e.registerBreakpoints(),
        e.init(!0);
    }
    var b = 0;
    return c;
  })()),
    (b.prototype.activateADA = function () {
      var a = this;
      a.$slideTrack
        .find(".slick-active")
        .attr({ "aria-hidden": "false" })
        .find("a, input, button, select")
        .attr({ tabindex: "0" });
    }),
    (b.prototype.addSlide = b.prototype.slickAdd =
      function (b, c, d) {
        var e = this;
        if ("boolean" == typeof c) (d = c), (c = null);
        else if (0 > c || c >= e.slideCount) return !1;
        e.unload(),
          "number" == typeof c
            ? 0 === c && 0 === e.$slides.length
              ? a(b).appendTo(e.$slideTrack)
              : d
              ? a(b).insertBefore(e.$slides.eq(c))
              : a(b).insertAfter(e.$slides.eq(c))
            : d === !0
            ? a(b).prependTo(e.$slideTrack)
            : a(b).appendTo(e.$slideTrack),
          (e.$slides = e.$slideTrack.children(this.options.slide)),
          e.$slideTrack.children(this.options.slide).detach(),
          e.$slideTrack.append(e.$slides),
          e.$slides.each(function (b, c) {
            a(c).attr("data-slick-index", b);
          }),
          (e.$slidesCache = e.$slides),
          e.reinit();
      }),
    (b.prototype.animateHeight = function () {
      var a = this;
      if (
        1 === a.options.slidesToShow &&
        a.options.adaptiveHeight === !0 &&
        a.options.vertical === !1
      ) {
        var b = a.$slides.eq(a.currentSlide).outerHeight(!0);
        a.$list.animate({ height: b }, a.options.speed);
      }
    }),
    (b.prototype.animateSlide = function (b, c) {
      var d = {},
        e = this;
      e.animateHeight(),
        e.options.rtl === !0 && e.options.vertical === !1 && (b = -b),
        e.transformsEnabled === !1
          ? e.options.vertical === !1
            ? e.$slideTrack.animate(
                { left: b },
                e.options.speed,
                e.options.easing,
                c
              )
            : e.$slideTrack.animate(
                { top: b },
                e.options.speed,
                e.options.easing,
                c
              )
          : e.cssTransitions === !1
          ? (e.options.rtl === !0 && (e.currentLeft = -e.currentLeft),
            a({ animStart: e.currentLeft }).animate(
              { animStart: b },
              {
                duration: e.options.speed,
                easing: e.options.easing,
                step: function (a) {
                  (a = Math.ceil(a)),
                    e.options.vertical === !1
                      ? ((d[e.animType] = "translate(" + a + "px, 0px)"),
                        e.$slideTrack.css(d))
                      : ((d[e.animType] = "translate(0px," + a + "px)"),
                        e.$slideTrack.css(d));
                },
                complete: function () {
                  c && c.call();
                },
              }
            ))
          : (e.applyTransition(),
            (b = Math.ceil(b)),
            e.options.vertical === !1
              ? (d[e.animType] = "translate3d(" + b + "px, 0px, 0px)")
              : (d[e.animType] = "translate3d(0px," + b + "px, 0px)"),
            e.$slideTrack.css(d),
            c &&
              setTimeout(function () {
                e.disableTransition(), c.call();
              }, e.options.speed));
    }),
    (b.prototype.getNavTarget = function () {
      var b = this,
        c = b.options.asNavFor;
      return c && null !== c && (c = a(c).not(b.$slider)), c;
    }),
    (b.prototype.asNavFor = function (b) {
      var c = this,
        d = c.getNavTarget();
      null !== d &&
        "object" == typeof d &&
        d.each(function () {
          var c = a(this).slick("getSlick");
          c.unslicked || c.slideHandler(b, !0);
        });
    }),
    (b.prototype.applyTransition = function (a) {
      var b = this,
        c = {};
      b.options.fade === !1
        ? (c[b.transitionType] =
            b.transformType + " " + b.options.speed + "ms " + b.options.cssEase)
        : (c[b.transitionType] =
            "opacity " + b.options.speed + "ms " + b.options.cssEase),
        b.options.fade === !1 ? b.$slideTrack.css(c) : b.$slides.eq(a).css(c);
    }),
    (b.prototype.autoPlay = function () {
      var a = this;
      a.autoPlayClear(),
        a.slideCount > a.options.slidesToShow &&
          (a.autoPlayTimer = setInterval(
            a.autoPlayIterator,
            a.options.autoplaySpeed
          ));
    }),
    (b.prototype.autoPlayClear = function () {
      var a = this;
      a.autoPlayTimer && clearInterval(a.autoPlayTimer);
    }),
    (b.prototype.autoPlayIterator = function () {
      var a = this,
        b = a.currentSlide + a.options.slidesToScroll;
      a.paused ||
        a.interrupted ||
        a.focussed ||
        (a.options.infinite === !1 &&
          (1 === a.direction && a.currentSlide + 1 === a.slideCount - 1
            ? (a.direction = 0)
            : 0 === a.direction &&
              ((b = a.currentSlide - a.options.slidesToScroll),
              a.currentSlide - 1 === 0 && (a.direction = 1))),
        a.slideHandler(b));
    }),
    (b.prototype.buildArrows = function () {
      var b = this;
      b.options.arrows === !0 &&
        ((b.$prevArrow = a(b.options.prevArrow).addClass("slick-arrow")),
        (b.$nextArrow = a(b.options.nextArrow).addClass("slick-arrow")),
        b.slideCount > b.options.slidesToShow
          ? (b.$prevArrow
              .removeClass("slick-hidden")
              .removeAttr("aria-hidden tabindex"),
            b.$nextArrow
              .removeClass("slick-hidden")
              .removeAttr("aria-hidden tabindex"),
            b.htmlExpr.test(b.options.prevArrow) &&
              b.$prevArrow.prependTo(b.options.appendArrows),
            b.htmlExpr.test(b.options.nextArrow) &&
              b.$nextArrow.appendTo(b.options.appendArrows),
            b.options.infinite !== !0 &&
              b.$prevArrow
                .addClass("slick-disabled")
                .attr("aria-disabled", "true"))
          : b.$prevArrow
              .add(b.$nextArrow)
              .addClass("slick-hidden")
              .attr({ "aria-disabled": "true", tabindex: "-1" }));
    }),
    (b.prototype.buildDots = function () {
      var c,
        d,
        b = this;
      if (b.options.dots === !0 && b.slideCount > b.options.slidesToShow) {
        for (
          b.$slider.addClass("slick-dotted"),
            d = a("<ul />").addClass(b.options.dotsClass),
            c = 0;
          c <= b.getDotCount();
          c += 1
        )
          d.append(a("<li />").append(b.options.customPaging.call(this, b, c)));
        (b.$dots = d.appendTo(b.options.appendDots)),
          b.$dots
            .find("li")
            .first()
            .addClass("slick-active")
            .attr("aria-hidden", "false");
      }
    }),
    (b.prototype.buildOut = function () {
      var b = this;
      (b.$slides = b.$slider
        .children(b.options.slide + ":not(.slick-cloned)")
        .addClass("slick-slide")),
        (b.slideCount = b.$slides.length),
        b.$slides.each(function (b, c) {
          a(c)
            .attr("data-slick-index", b)
            .data("originalStyling", a(c).attr("style") || "");
        }),
        b.$slider.addClass("slick-slider"),
        (b.$slideTrack =
          0 === b.slideCount
            ? a('<div class="slick-track"/>').appendTo(b.$slider)
            : b.$slides.wrapAll('<div class="slick-track"/>').parent()),
        (b.$list = b.$slideTrack
          .wrap('<div aria-live="polite" class="slick-list"/>')
          .parent()),
        b.$slideTrack.css("opacity", 0),
        (b.options.centerMode === !0 || b.options.swipeToSlide === !0) &&
          (b.options.slidesToScroll = 1),
        a("img[data-lazy]", b.$slider).not("[src]").addClass("slick-loading"),
        b.setupInfinite(),
        b.buildArrows(),
        b.buildDots(),
        b.updateDots(),
        b.setSlideClasses(
          "number" == typeof b.currentSlide ? b.currentSlide : 0
        ),
        b.options.draggable === !0 && b.$list.addClass("draggable");
    }),
    (b.prototype.buildRows = function () {
      var b,
        c,
        d,
        e,
        f,
        g,
        h,
        a = this;
      if (
        ((e = document.createDocumentFragment()),
        (g = a.$slider.children()),
        a.options.rows > 1)
      ) {
        for (
          h = a.options.slidesPerRow * a.options.rows,
            f = Math.ceil(g.length / h),
            b = 0;
          f > b;
          b++
        ) {
          var i = document.createElement("div");
          for (c = 0; c < a.options.rows; c++) {
            var j = document.createElement("div");
            for (d = 0; d < a.options.slidesPerRow; d++) {
              var k = b * h + (c * a.options.slidesPerRow + d);
              g.get(k) && j.appendChild(g.get(k));
            }
            i.appendChild(j);
          }
          e.appendChild(i);
        }
        a.$slider.empty().append(e),
          a.$slider
            .children()
            .children()
            .children()
            .css({
              width: 100 / a.options.slidesPerRow + "%",
              display: "inline-block",
            });
      }
    }),
    (b.prototype.checkResponsive = function (b, c) {
      var e,
        f,
        g,
        d = this,
        h = !1,
        i = d.$slider.width(),
        j = window.innerWidth || a(window).width();
      if (
        ("window" === d.respondTo
          ? (g = j)
          : "slider" === d.respondTo
          ? (g = i)
          : "min" === d.respondTo && (g = Math.min(j, i)),
        d.options.responsive &&
          d.options.responsive.length &&
          null !== d.options.responsive)
      ) {
        f = null;
        for (e in d.breakpoints)
          d.breakpoints.hasOwnProperty(e) &&
            (d.originalSettings.mobileFirst === !1
              ? g < d.breakpoints[e] && (f = d.breakpoints[e])
              : g > d.breakpoints[e] && (f = d.breakpoints[e]));
        null !== f
          ? null !== d.activeBreakpoint
            ? (f !== d.activeBreakpoint || c) &&
              ((d.activeBreakpoint = f),
              "unslick" === d.breakpointSettings[f]
                ? d.unslick(f)
                : ((d.options = a.extend(
                    {},
                    d.originalSettings,
                    d.breakpointSettings[f]
                  )),
                  b === !0 && (d.currentSlide = d.options.initialSlide),
                  d.refresh(b)),
              (h = f))
            : ((d.activeBreakpoint = f),
              "unslick" === d.breakpointSettings[f]
                ? d.unslick(f)
                : ((d.options = a.extend(
                    {},
                    d.originalSettings,
                    d.breakpointSettings[f]
                  )),
                  b === !0 && (d.currentSlide = d.options.initialSlide),
                  d.refresh(b)),
              (h = f))
          : null !== d.activeBreakpoint &&
            ((d.activeBreakpoint = null),
            (d.options = d.originalSettings),
            b === !0 && (d.currentSlide = d.options.initialSlide),
            d.refresh(b),
            (h = f)),
          b || h === !1 || d.$slider.trigger("breakpoint", [d, h]);
      }
    }),
    (b.prototype.changeSlide = function (b, c) {
      var f,
        g,
        h,
        d = this,
        e = a(b.currentTarget);
      switch (
        (e.is("a") && b.preventDefault(),
        e.is("li") || (e = e.closest("li")),
        (h = d.slideCount % d.options.slidesToScroll !== 0),
        (f = h
          ? 0
          : (d.slideCount - d.currentSlide) % d.options.slidesToScroll),
        b.data.message)
      ) {
        case "previous":
          (g = 0 === f ? d.options.slidesToScroll : d.options.slidesToShow - f),
            d.slideCount > d.options.slidesToShow &&
              d.slideHandler(d.currentSlide - g, !1, c);
          break;
        case "next":
          (g = 0 === f ? d.options.slidesToScroll : f),
            d.slideCount > d.options.slidesToShow &&
              d.slideHandler(d.currentSlide + g, !1, c);
          break;
        case "index":
          var i =
            0 === b.data.index
              ? 0
              : b.data.index || e.index() * d.options.slidesToScroll;
          d.slideHandler(d.checkNavigable(i), !1, c),
            e.children().trigger("focus");
          break;
        default:
          return;
      }
    }),
    (b.prototype.checkNavigable = function (a) {
      var c,
        d,
        b = this;
      if (((c = b.getNavigableIndexes()), (d = 0), a > c[c.length - 1]))
        a = c[c.length - 1];
      else
        for (var e in c) {
          if (a < c[e]) {
            a = d;
            break;
          }
          d = c[e];
        }
      return a;
    }),
    (b.prototype.cleanUpEvents = function () {
      var b = this;
      b.options.dots &&
        null !== b.$dots &&
        a("li", b.$dots)
          .off("click.slick", b.changeSlide)
          .off("mouseenter.slick", a.proxy(b.interrupt, b, !0))
          .off("mouseleave.slick", a.proxy(b.interrupt, b, !1)),
        b.$slider.off("focus.slick blur.slick"),
        b.options.arrows === !0 &&
          b.slideCount > b.options.slidesToShow &&
          (b.$prevArrow && b.$prevArrow.off("click.slick", b.changeSlide),
          b.$nextArrow && b.$nextArrow.off("click.slick", b.changeSlide)),
        b.$list.off("touchstart.slick mousedown.slick", b.swipeHandler),
        b.$list.off("touchmove.slick mousemove.slick", b.swipeHandler),
        b.$list.off("touchend.slick mouseup.slick", b.swipeHandler),
        b.$list.off("touchcancel.slick mouseleave.slick", b.swipeHandler),
        b.$list.off("click.slick", b.clickHandler),
        a(document).off(b.visibilityChange, b.visibility),
        b.cleanUpSlideEvents(),
        b.options.accessibility === !0 &&
          b.$list.off("keydown.slick", b.keyHandler),
        b.options.focusOnSelect === !0 &&
          a(b.$slideTrack).children().off("click.slick", b.selectHandler),
        a(window).off(
          "orientationchange.slick.slick-" + b.instanceUid,
          b.orientationChange
        ),
        a(window).off("resize.slick.slick-" + b.instanceUid, b.resize),
        a("[draggable!=true]", b.$slideTrack).off(
          "dragstart",
          b.preventDefault
        ),
        a(window).off("load.slick.slick-" + b.instanceUid, b.setPosition),
        a(document).off("ready.slick.slick-" + b.instanceUid, b.setPosition);
    }),
    (b.prototype.cleanUpSlideEvents = function () {
      var b = this;
      b.$list.off("mouseenter.slick", a.proxy(b.interrupt, b, !0)),
        b.$list.off("mouseleave.slick", a.proxy(b.interrupt, b, !1));
    }),
    (b.prototype.cleanUpRows = function () {
      var b,
        a = this;
      a.options.rows > 1 &&
        ((b = a.$slides.children().children()),
        b.removeAttr("style"),
        a.$slider.empty().append(b));
    }),
    (b.prototype.clickHandler = function (a) {
      var b = this;
      b.shouldClick === !1 &&
        (a.stopImmediatePropagation(), a.stopPropagation(), a.preventDefault());
    }),
    (b.prototype.destroy = function (b) {
      var c = this;
      c.autoPlayClear(),
        (c.touchObject = {}),
        c.cleanUpEvents(),
        a(".slick-cloned", c.$slider).detach(),
        c.$dots && c.$dots.remove(),
        c.$prevArrow &&
          c.$prevArrow.length &&
          (c.$prevArrow
            .removeClass("slick-disabled slick-arrow slick-hidden")
            .removeAttr("aria-hidden aria-disabled tabindex")
            .css("display", ""),
          c.htmlExpr.test(c.options.prevArrow) && c.$prevArrow.remove()),
        c.$nextArrow &&
          c.$nextArrow.length &&
          (c.$nextArrow
            .removeClass("slick-disabled slick-arrow slick-hidden")
            .removeAttr("aria-hidden aria-disabled tabindex")
            .css("display", ""),
          c.htmlExpr.test(c.options.nextArrow) && c.$nextArrow.remove()),
        c.$slides &&
          (c.$slides
            .removeClass(
              "slick-slide slick-active slick-center slick-visible slick-current"
            )
            .removeAttr("aria-hidden")
            .removeAttr("data-slick-index")
            .each(function () {
              a(this).attr("style", a(this).data("originalStyling"));
            }),
          c.$slideTrack.children(this.options.slide).detach(),
          c.$slideTrack.detach(),
          c.$list.detach(),
          c.$slider.append(c.$slides)),
        c.cleanUpRows(),
        c.$slider.removeClass("slick-slider"),
        c.$slider.removeClass("slick-initialized"),
        c.$slider.removeClass("slick-dotted"),
        (c.unslicked = !0),
        b || c.$slider.trigger("destroy", [c]);
    }),
    (b.prototype.disableTransition = function (a) {
      var b = this,
        c = {};
      (c[b.transitionType] = ""),
        b.options.fade === !1 ? b.$slideTrack.css(c) : b.$slides.eq(a).css(c);
    }),
    (b.prototype.fadeSlide = function (a, b) {
      var c = this;
      c.cssTransitions === !1
        ? (c.$slides.eq(a).css({ zIndex: c.options.zIndex }),
          c.$slides
            .eq(a)
            .animate({ opacity: 1 }, c.options.speed, c.options.easing, b))
        : (c.applyTransition(a),
          c.$slides.eq(a).css({ opacity: 1, zIndex: c.options.zIndex }),
          b &&
            setTimeout(function () {
              c.disableTransition(a), b.call();
            }, c.options.speed));
    }),
    (b.prototype.fadeSlideOut = function (a) {
      var b = this;
      b.cssTransitions === !1
        ? b.$slides
            .eq(a)
            .animate(
              { opacity: 0, zIndex: b.options.zIndex - 2 },
              b.options.speed,
              b.options.easing
            )
        : (b.applyTransition(a),
          b.$slides.eq(a).css({ opacity: 0, zIndex: b.options.zIndex - 2 }));
    }),
    (b.prototype.filterSlides = b.prototype.slickFilter =
      function (a) {
        var b = this;
        null !== a &&
          ((b.$slidesCache = b.$slides),
          b.unload(),
          b.$slideTrack.children(this.options.slide).detach(),
          b.$slidesCache.filter(a).appendTo(b.$slideTrack),
          b.reinit());
      }),
    (b.prototype.focusHandler = function () {
      var b = this;
      b.$slider
        .off("focus.slick blur.slick")
        .on("focus.slick blur.slick", "*:not(.slick-arrow)", function (c) {
          c.stopImmediatePropagation();
          var d = a(this);
          setTimeout(function () {
            b.options.pauseOnFocus &&
              ((b.focussed = d.is(":focus")), b.autoPlay());
          }, 0);
        });
    }),
    (b.prototype.getCurrent = b.prototype.slickCurrentSlide =
      function () {
        var a = this;
        return a.currentSlide;
      }),
    (b.prototype.getDotCount = function () {
      var a = this,
        b = 0,
        c = 0,
        d = 0;
      if (a.options.infinite === !0)
        for (; b < a.slideCount; )
          ++d,
            (b = c + a.options.slidesToScroll),
            (c +=
              a.options.slidesToScroll <= a.options.slidesToShow
                ? a.options.slidesToScroll
                : a.options.slidesToShow);
      else if (a.options.centerMode === !0) d = a.slideCount;
      else if (a.options.asNavFor)
        for (; b < a.slideCount; )
          ++d,
            (b = c + a.options.slidesToScroll),
            (c +=
              a.options.slidesToScroll <= a.options.slidesToShow
                ? a.options.slidesToScroll
                : a.options.slidesToShow);
      else
        d =
          1 +
          Math.ceil(
            (a.slideCount - a.options.slidesToShow) / a.options.slidesToScroll
          );
      return d - 1;
    }),
    (b.prototype.getLeft = function (a) {
      var c,
        d,
        f,
        b = this,
        e = 0;
      return (
        (b.slideOffset = 0),
        (d = b.$slides.first().outerHeight(!0)),
        b.options.infinite === !0
          ? (b.slideCount > b.options.slidesToShow &&
              ((b.slideOffset = b.slideWidth * b.options.slidesToShow * -1),
              (e = d * b.options.slidesToShow * -1)),
            b.slideCount % b.options.slidesToScroll !== 0 &&
              a + b.options.slidesToScroll > b.slideCount &&
              b.slideCount > b.options.slidesToShow &&
              (a > b.slideCount
                ? ((b.slideOffset =
                    (b.options.slidesToShow - (a - b.slideCount)) *
                    b.slideWidth *
                    -1),
                  (e = (b.options.slidesToShow - (a - b.slideCount)) * d * -1))
                : ((b.slideOffset =
                    (b.slideCount % b.options.slidesToScroll) *
                    b.slideWidth *
                    -1),
                  (e = (b.slideCount % b.options.slidesToScroll) * d * -1))))
          : a + b.options.slidesToShow > b.slideCount &&
            ((b.slideOffset =
              (a + b.options.slidesToShow - b.slideCount) * b.slideWidth),
            (e = (a + b.options.slidesToShow - b.slideCount) * d)),
        b.slideCount <= b.options.slidesToShow &&
          ((b.slideOffset = 0), (e = 0)),
        b.options.centerMode === !0 && b.options.infinite === !0
          ? (b.slideOffset +=
              b.slideWidth * Math.floor(b.options.slidesToShow / 2) -
              b.slideWidth)
          : b.options.centerMode === !0 &&
            ((b.slideOffset = 0),
            (b.slideOffset +=
              b.slideWidth * Math.floor(b.options.slidesToShow / 2))),
        (c =
          b.options.vertical === !1
            ? a * b.slideWidth * -1 + b.slideOffset
            : a * d * -1 + e),
        b.options.variableWidth === !0 &&
          ((f =
            b.slideCount <= b.options.slidesToShow || b.options.infinite === !1
              ? b.$slideTrack.children(".slick-slide").eq(a)
              : b.$slideTrack
                  .children(".slick-slide")
                  .eq(a + b.options.slidesToShow)),
          (c =
            b.options.rtl === !0
              ? f[0]
                ? -1 * (b.$slideTrack.width() - f[0].offsetLeft - f.width())
                : 0
              : f[0]
              ? -1 * f[0].offsetLeft
              : 0),
          b.options.centerMode === !0 &&
            ((f =
              b.slideCount <= b.options.slidesToShow ||
              b.options.infinite === !1
                ? b.$slideTrack.children(".slick-slide").eq(a)
                : b.$slideTrack
                    .children(".slick-slide")
                    .eq(a + b.options.slidesToShow + 1)),
            (c =
              b.options.rtl === !0
                ? f[0]
                  ? -1 * (b.$slideTrack.width() - f[0].offsetLeft - f.width())
                  : 0
                : f[0]
                ? -1 * f[0].offsetLeft
                : 0),
            (c += (b.$list.width() - f.outerWidth()) / 2))),
        c
      );
    }),
    (b.prototype.getOption = b.prototype.slickGetOption =
      function (a) {
        var b = this;
        return b.options[a];
      }),
    (b.prototype.getNavigableIndexes = function () {
      var e,
        a = this,
        b = 0,
        c = 0,
        d = [];
      for (
        a.options.infinite === !1
          ? (e = a.slideCount)
          : ((b = -1 * a.options.slidesToScroll),
            (c = -1 * a.options.slidesToScroll),
            (e = 2 * a.slideCount));
        e > b;

      )
        d.push(b),
          (b = c + a.options.slidesToScroll),
          (c +=
            a.options.slidesToScroll <= a.options.slidesToShow
              ? a.options.slidesToScroll
              : a.options.slidesToShow);
      return d;
    }),
    (b.prototype.getSlick = function () {
      return this;
    }),
    (b.prototype.getSlideCount = function () {
      var c,
        d,
        e,
        b = this;
      return (
        (e =
          b.options.centerMode === !0
            ? b.slideWidth * Math.floor(b.options.slidesToShow / 2)
            : 0),
        b.options.swipeToSlide === !0
          ? (b.$slideTrack.find(".slick-slide").each(function (c, f) {
              return f.offsetLeft - e + a(f).outerWidth() / 2 > -1 * b.swipeLeft
                ? ((d = f), !1)
                : void 0;
            }),
            (c = Math.abs(a(d).attr("data-slick-index") - b.currentSlide) || 1))
          : b.options.slidesToScroll
      );
    }),
    (b.prototype.goTo = b.prototype.slickGoTo =
      function (a, b) {
        var c = this;
        c.changeSlide({ data: { message: "index", index: parseInt(a) } }, b);
      }),
    (b.prototype.init = function (b) {
      var c = this;
      a(c.$slider).hasClass("slick-initialized") ||
        (a(c.$slider).addClass("slick-initialized"),
        c.buildRows(),
        c.buildOut(),
        c.setProps(),
        c.startLoad(),
        c.loadSlider(),
        c.initializeEvents(),
        c.updateArrows(),
        c.updateDots(),
        c.checkResponsive(!0),
        c.focusHandler()),
        b && c.$slider.trigger("init", [c]),
        c.options.accessibility === !0 && c.initADA(),
        c.options.autoplay && ((c.paused = !1), c.autoPlay());
    }),
    (b.prototype.initADA = function () {
      var b = this;
      b.$slides
        .add(b.$slideTrack.find(".slick-cloned"))
        .attr({ "aria-hidden": "true", tabindex: "-1" })
        .find("a, input, button, select")
        .attr({ tabindex: "-1" }),
        b.$slideTrack.attr("role", "listbox"),
        b.$slides.not(b.$slideTrack.find(".slick-cloned")).each(function (c) {
          a(this).attr({
            role: "option",
            "aria-describedby": "slick-slide" + b.instanceUid + c,
          });
        }),
        null !== b.$dots &&
          b.$dots
            .attr("role", "tablist")
            .find("li")
            .each(function (c) {
              a(this).attr({
                role: "presentation",
                "aria-selected": "false",
                "aria-controls": "navigation" + b.instanceUid + c,
                id: "slick-slide" + b.instanceUid + c,
              });
            })
            .first()
            .attr("aria-selected", "true")
            .end()
            .find("button")
            .attr("role", "button")
            .end()
            .closest("div")
            .attr("role", "toolbar"),
        b.activateADA();
    }),
    (b.prototype.initArrowEvents = function () {
      var a = this;
      a.options.arrows === !0 &&
        a.slideCount > a.options.slidesToShow &&
        (a.$prevArrow
          .off("click.slick")
          .on("click.slick", { message: "previous" }, a.changeSlide),
        a.$nextArrow
          .off("click.slick")
          .on("click.slick", { message: "next" }, a.changeSlide));
    }),
    (b.prototype.initDotEvents = function () {
      var b = this;
      b.options.dots === !0 &&
        b.slideCount > b.options.slidesToShow &&
        a("li", b.$dots).on("click.slick", { message: "index" }, b.changeSlide),
        b.options.dots === !0 &&
          b.options.pauseOnDotsHover === !0 &&
          a("li", b.$dots)
            .on("mouseenter.slick", a.proxy(b.interrupt, b, !0))
            .on("mouseleave.slick", a.proxy(b.interrupt, b, !1));
    }),
    (b.prototype.initSlideEvents = function () {
      var b = this;
      b.options.pauseOnHover &&
        (b.$list.on("mouseenter.slick", a.proxy(b.interrupt, b, !0)),
        b.$list.on("mouseleave.slick", a.proxy(b.interrupt, b, !1)));
    }),
    (b.prototype.initializeEvents = function () {
      var b = this;
      b.initArrowEvents(),
        b.initDotEvents(),
        b.initSlideEvents(),
        b.$list.on(
          "touchstart.slick mousedown.slick",
          { action: "start" },
          b.swipeHandler
        ),
        b.$list.on(
          "touchmove.slick mousemove.slick",
          { action: "move" },
          b.swipeHandler
        ),
        b.$list.on(
          "touchend.slick mouseup.slick",
          { action: "end" },
          b.swipeHandler
        ),
        b.$list.on(
          "touchcancel.slick mouseleave.slick",
          { action: "end" },
          b.swipeHandler
        ),
        b.$list.on("click.slick", b.clickHandler),
        a(document).on(b.visibilityChange, a.proxy(b.visibility, b)),
        b.options.accessibility === !0 &&
          b.$list.on("keydown.slick", b.keyHandler),
        b.options.focusOnSelect === !0 &&
          a(b.$slideTrack).children().on("click.slick", b.selectHandler),
        a(window).on(
          "orientationchange.slick.slick-" + b.instanceUid,
          a.proxy(b.orientationChange, b)
        ),
        a(window).on(
          "resize.slick.slick-" + b.instanceUid,
          a.proxy(b.resize, b)
        ),
        a("[draggable!=true]", b.$slideTrack).on("dragstart", b.preventDefault),
        a(window).on("load.slick.slick-" + b.instanceUid, b.setPosition),
        a(document).on("ready.slick.slick-" + b.instanceUid, b.setPosition);
    }),
    (b.prototype.initUI = function () {
      var a = this;
      a.options.arrows === !0 &&
        a.slideCount > a.options.slidesToShow &&
        (a.$prevArrow.show(), a.$nextArrow.show()),
        a.options.dots === !0 &&
          a.slideCount > a.options.slidesToShow &&
          a.$dots.show();
    }),
    (b.prototype.keyHandler = function (a) {
      var b = this;
      a.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
        (37 === a.keyCode && b.options.accessibility === !0
          ? b.changeSlide({
              data: { message: b.options.rtl === !0 ? "next" : "previous" },
            })
          : 39 === a.keyCode &&
            b.options.accessibility === !0 &&
            b.changeSlide({
              data: { message: b.options.rtl === !0 ? "previous" : "next" },
            }));
    }),
    (b.prototype.lazyLoad = function () {
      function g(c) {
        a("img[data-lazy]", c).each(function () {
          var c = a(this),
            d = a(this).attr("data-lazy"),
            e = document.createElement("img");
          (e.onload = function () {
            c.animate({ opacity: 0 }, 100, function () {
              c.attr("src", d).animate({ opacity: 1 }, 200, function () {
                c.removeAttr("data-lazy").removeClass("slick-loading");
              }),
                b.$slider.trigger("lazyLoaded", [b, c, d]);
            });
          }),
            (e.onerror = function () {
              c
                .removeAttr("data-lazy")
                .removeClass("slick-loading")
                .addClass("slick-lazyload-error"),
                b.$slider.trigger("lazyLoadError", [b, c, d]);
            }),
            (e.src = d);
        });
      }
      var c,
        d,
        e,
        f,
        b = this;
      b.options.centerMode === !0
        ? b.options.infinite === !0
          ? ((e = b.currentSlide + (b.options.slidesToShow / 2 + 1)),
            (f = e + b.options.slidesToShow + 2))
          : ((e = Math.max(
              0,
              b.currentSlide - (b.options.slidesToShow / 2 + 1)
            )),
            (f = 2 + (b.options.slidesToShow / 2 + 1) + b.currentSlide))
        : ((e = b.options.infinite
            ? b.options.slidesToShow + b.currentSlide
            : b.currentSlide),
          (f = Math.ceil(e + b.options.slidesToShow)),
          b.options.fade === !0 && (e > 0 && e--, f <= b.slideCount && f++)),
        (c = b.$slider.find(".slick-slide").slice(e, f)),
        g(c),
        b.slideCount <= b.options.slidesToShow
          ? ((d = b.$slider.find(".slick-slide")), g(d))
          : b.currentSlide >= b.slideCount - b.options.slidesToShow
          ? ((d = b.$slider
              .find(".slick-cloned")
              .slice(0, b.options.slidesToShow)),
            g(d))
          : 0 === b.currentSlide &&
            ((d = b.$slider
              .find(".slick-cloned")
              .slice(-1 * b.options.slidesToShow)),
            g(d));
    }),
    (b.prototype.loadSlider = function () {
      var a = this;
      a.setPosition(),
        a.$slideTrack.css({ opacity: 1 }),
        a.$slider.removeClass("slick-loading"),
        a.initUI(),
        "progressive" === a.options.lazyLoad && a.progressiveLazyLoad();
    }),
    (b.prototype.next = b.prototype.slickNext =
      function () {
        var a = this;
        a.changeSlide({ data: { message: "next" } });
      }),
    (b.prototype.orientationChange = function () {
      var a = this;
      a.checkResponsive(), a.setPosition();
    }),
    (b.prototype.pause = b.prototype.slickPause =
      function () {
        var a = this;
        a.autoPlayClear(), (a.paused = !0);
      }),
    (b.prototype.play = b.prototype.slickPlay =
      function () {
        var a = this;
        a.autoPlay(),
          (a.options.autoplay = !0),
          (a.paused = !1),
          (a.focussed = !1),
          (a.interrupted = !1);
      }),
    (b.prototype.postSlide = function (a) {
      var b = this;
      b.unslicked ||
        (b.$slider.trigger("afterChange", [b, a]),
        (b.animating = !1),
        b.setPosition(),
        (b.swipeLeft = null),
        b.options.autoplay && b.autoPlay(),
        b.options.accessibility === !0 && b.initADA());
    }),
    (b.prototype.prev = b.prototype.slickPrev =
      function () {
        var a = this;
        a.changeSlide({ data: { message: "previous" } });
      }),
    (b.prototype.preventDefault = function (a) {
      a.preventDefault();
    }),
    (b.prototype.progressiveLazyLoad = function (b) {
      b = b || 1;
      var e,
        f,
        g,
        c = this,
        d = a("img[data-lazy]", c.$slider);
      d.length
        ? ((e = d.first()),
          (f = e.attr("data-lazy")),
          (g = document.createElement("img")),
          (g.onload = function () {
            e
              .attr("src", f)
              .removeAttr("data-lazy")
              .removeClass("slick-loading"),
              c.options.adaptiveHeight === !0 && c.setPosition(),
              c.$slider.trigger("lazyLoaded", [c, e, f]),
              c.progressiveLazyLoad();
          }),
          (g.onerror = function () {
            3 > b
              ? setTimeout(function () {
                  c.progressiveLazyLoad(b + 1);
                }, 500)
              : (e
                  .removeAttr("data-lazy")
                  .removeClass("slick-loading")
                  .addClass("slick-lazyload-error"),
                c.$slider.trigger("lazyLoadError", [c, e, f]),
                c.progressiveLazyLoad());
          }),
          (g.src = f))
        : c.$slider.trigger("allImagesLoaded", [c]);
    }),
    (b.prototype.refresh = function (b) {
      var d,
        e,
        c = this;
      (e = c.slideCount - c.options.slidesToShow),
        !c.options.infinite && c.currentSlide > e && (c.currentSlide = e),
        c.slideCount <= c.options.slidesToShow && (c.currentSlide = 0),
        (d = c.currentSlide),
        c.destroy(!0),
        a.extend(c, c.initials, { currentSlide: d }),
        c.init(),
        b || c.changeSlide({ data: { message: "index", index: d } }, !1);
    }),
    (b.prototype.registerBreakpoints = function () {
      var c,
        d,
        e,
        b = this,
        f = b.options.responsive || null;
      if ("array" === a.type(f) && f.length) {
        b.respondTo = b.options.respondTo || "window";
        for (c in f)
          if (
            ((e = b.breakpoints.length - 1),
            (d = f[c].breakpoint),
            f.hasOwnProperty(c))
          ) {
            for (; e >= 0; )
              b.breakpoints[e] &&
                b.breakpoints[e] === d &&
                b.breakpoints.splice(e, 1),
                e--;
            b.breakpoints.push(d), (b.breakpointSettings[d] = f[c].settings);
          }
        b.breakpoints.sort(function (a, c) {
          return b.options.mobileFirst ? a - c : c - a;
        });
      }
    }),
    (b.prototype.reinit = function () {
      var b = this;
      (b.$slides = b.$slideTrack
        .children(b.options.slide)
        .addClass("slick-slide")),
        (b.slideCount = b.$slides.length),
        b.currentSlide >= b.slideCount &&
          0 !== b.currentSlide &&
          (b.currentSlide = b.currentSlide - b.options.slidesToScroll),
        b.slideCount <= b.options.slidesToShow && (b.currentSlide = 0),
        b.registerBreakpoints(),
        b.setProps(),
        b.setupInfinite(),
        b.buildArrows(),
        b.updateArrows(),
        b.initArrowEvents(),
        b.buildDots(),
        b.updateDots(),
        b.initDotEvents(),
        b.cleanUpSlideEvents(),
        b.initSlideEvents(),
        b.checkResponsive(!1, !0),
        b.options.focusOnSelect === !0 &&
          a(b.$slideTrack).children().on("click.slick", b.selectHandler),
        b.setSlideClasses(
          "number" == typeof b.currentSlide ? b.currentSlide : 0
        ),
        b.setPosition(),
        b.focusHandler(),
        (b.paused = !b.options.autoplay),
        b.autoPlay(),
        b.$slider.trigger("reInit", [b]);
    }),
    (b.prototype.resize = function () {
      var b = this;
      a(window).width() !== b.windowWidth &&
        (clearTimeout(b.windowDelay),
        (b.windowDelay = window.setTimeout(function () {
          (b.windowWidth = a(window).width()),
            b.checkResponsive(),
            b.unslicked || b.setPosition();
        }, 50)));
    }),
    (b.prototype.removeSlide = b.prototype.slickRemove =
      function (a, b, c) {
        var d = this;
        return (
          "boolean" == typeof a
            ? ((b = a), (a = b === !0 ? 0 : d.slideCount - 1))
            : (a = b === !0 ? --a : a),
          d.slideCount < 1 || 0 > a || a > d.slideCount - 1
            ? !1
            : (d.unload(),
              c === !0
                ? d.$slideTrack.children().remove()
                : d.$slideTrack.children(this.options.slide).eq(a).remove(),
              (d.$slides = d.$slideTrack.children(this.options.slide)),
              d.$slideTrack.children(this.options.slide).detach(),
              d.$slideTrack.append(d.$slides),
              (d.$slidesCache = d.$slides),
              void d.reinit())
        );
      }),
    (b.prototype.setCSS = function (a) {
      var d,
        e,
        b = this,
        c = {};
      b.options.rtl === !0 && (a = -a),
        (d = "left" == b.positionProp ? Math.ceil(a) + "px" : "0px"),
        (e = "top" == b.positionProp ? Math.ceil(a) + "px" : "0px"),
        (c[b.positionProp] = a),
        b.transformsEnabled === !1
          ? b.$slideTrack.css(c)
          : ((c = {}),
            b.cssTransitions === !1
              ? ((c[b.animType] = "translate(" + d + ", " + e + ")"),
                b.$slideTrack.css(c))
              : ((c[b.animType] = "translate3d(" + d + ", " + e + ", 0px)"),
                b.$slideTrack.css(c)));
    }),
    (b.prototype.setDimensions = function () {
      var a = this;
      a.options.vertical === !1
        ? a.options.centerMode === !0 &&
          a.$list.css({ padding: "0px " + a.options.centerPadding })
        : (a.$list.height(
            a.$slides.first().outerHeight(!0) * a.options.slidesToShow
          ),
          a.options.centerMode === !0 &&
            a.$list.css({ padding: a.options.centerPadding + " 0px" })),
        (a.listWidth = a.$list.width()),
        (a.listHeight = a.$list.height()),
        a.options.vertical === !1 && a.options.variableWidth === !1
          ? ((a.slideWidth = Math.ceil(a.listWidth / a.options.slidesToShow)),
            a.$slideTrack.width(
              Math.ceil(
                a.slideWidth * a.$slideTrack.children(".slick-slide").length
              )
            ))
          : a.options.variableWidth === !0
          ? a.$slideTrack.width(5e3 * a.slideCount)
          : ((a.slideWidth = Math.ceil(a.listWidth)),
            a.$slideTrack.height(
              Math.ceil(
                a.$slides.first().outerHeight(!0) *
                  a.$slideTrack.children(".slick-slide").length
              )
            ));
      var b = a.$slides.first().outerWidth(!0) - a.$slides.first().width();
      a.options.variableWidth === !1 &&
        a.$slideTrack.children(".slick-slide").width(a.slideWidth - b);
    }),
    (b.prototype.setFade = function () {
      var c,
        b = this;
      b.$slides.each(function (d, e) {
        (c = b.slideWidth * d * -1),
          b.options.rtl === !0
            ? a(e).css({
                position: "relative",
                right: c,
                top: 0,
                zIndex: b.options.zIndex - 2,
                opacity: 0,
              })
            : a(e).css({
                position: "relative",
                left: c,
                top: 0,
                zIndex: b.options.zIndex - 2,
                opacity: 0,
              });
      }),
        b.$slides
          .eq(b.currentSlide)
          .css({ zIndex: b.options.zIndex - 1, opacity: 1 });
    }),
    (b.prototype.setHeight = function () {
      var a = this;
      if (
        1 === a.options.slidesToShow &&
        a.options.adaptiveHeight === !0 &&
        a.options.vertical === !1
      ) {
        var b = a.$slides.eq(a.currentSlide).outerHeight(!0);
        a.$list.css("height", b);
      }
    }),
    (b.prototype.setOption = b.prototype.slickSetOption =
      function () {
        var c,
          d,
          e,
          f,
          h,
          b = this,
          g = !1;
        if (
          ("object" === a.type(arguments[0])
            ? ((e = arguments[0]), (g = arguments[1]), (h = "multiple"))
            : "string" === a.type(arguments[0]) &&
              ((e = arguments[0]),
              (f = arguments[1]),
              (g = arguments[2]),
              "responsive" === arguments[0] && "array" === a.type(arguments[1])
                ? (h = "responsive")
                : "undefined" != typeof arguments[1] && (h = "single")),
          "single" === h)
        )
          b.options[e] = f;
        else if ("multiple" === h)
          a.each(e, function (a, c) {
            b.options[a] = c;
          });
        else if ("responsive" === h)
          for (d in f)
            if ("array" !== a.type(b.options.responsive))
              b.options.responsive = [f[d]];
            else {
              for (c = b.options.responsive.length - 1; c >= 0; )
                b.options.responsive[c].breakpoint === f[d].breakpoint &&
                  b.options.responsive.splice(c, 1),
                  c--;
              b.options.responsive.push(f[d]);
            }
        g && (b.unload(), b.reinit());
      }),
    (b.prototype.setPosition = function () {
      var a = this;
      a.setDimensions(),
        a.setHeight(),
        a.options.fade === !1
          ? a.setCSS(a.getLeft(a.currentSlide))
          : a.setFade(),
        a.$slider.trigger("setPosition", [a]);
    }),
    (b.prototype.setProps = function () {
      var a = this,
        b = document.body.style;
      (a.positionProp = a.options.vertical === !0 ? "top" : "left"),
        "top" === a.positionProp
          ? a.$slider.addClass("slick-vertical")
          : a.$slider.removeClass("slick-vertical"),
        (void 0 !== b.WebkitTransition ||
          void 0 !== b.MozTransition ||
          void 0 !== b.msTransition) &&
          a.options.useCSS === !0 &&
          (a.cssTransitions = !0),
        a.options.fade &&
          ("number" == typeof a.options.zIndex
            ? a.options.zIndex < 3 && (a.options.zIndex = 3)
            : (a.options.zIndex = a.defaults.zIndex)),
        void 0 !== b.OTransform &&
          ((a.animType = "OTransform"),
          (a.transformType = "-o-transform"),
          (a.transitionType = "OTransition"),
          void 0 === b.perspectiveProperty &&
            void 0 === b.webkitPerspective &&
            (a.animType = !1)),
        void 0 !== b.MozTransform &&
          ((a.animType = "MozTransform"),
          (a.transformType = "-moz-transform"),
          (a.transitionType = "MozTransition"),
          void 0 === b.perspectiveProperty &&
            void 0 === b.MozPerspective &&
            (a.animType = !1)),
        void 0 !== b.webkitTransform &&
          ((a.animType = "webkitTransform"),
          (a.transformType = "-webkit-transform"),
          (a.transitionType = "webkitTransition"),
          void 0 === b.perspectiveProperty &&
            void 0 === b.webkitPerspective &&
            (a.animType = !1)),
        void 0 !== b.msTransform &&
          ((a.animType = "msTransform"),
          (a.transformType = "-ms-transform"),
          (a.transitionType = "msTransition"),
          void 0 === b.msTransform && (a.animType = !1)),
        void 0 !== b.transform &&
          a.animType !== !1 &&
          ((a.animType = "transform"),
          (a.transformType = "transform"),
          (a.transitionType = "transition")),
        (a.transformsEnabled =
          a.options.useTransform && null !== a.animType && a.animType !== !1);
    }),
    (b.prototype.setSlideClasses = function (a) {
      var c,
        d,
        e,
        f,
        b = this;
      (d = b.$slider
        .find(".slick-slide")
        .removeClass("slick-active slick-center slick-current")
        .attr("aria-hidden", "true")),
        b.$slides.eq(a).addClass("slick-current"),
        b.options.centerMode === !0
          ? ((c = Math.floor(b.options.slidesToShow / 2)),
            b.options.infinite === !0 &&
              (a >= c && a <= b.slideCount - 1 - c
                ? b.$slides
                    .slice(a - c, a + c + 1)
                    .addClass("slick-active")
                    .attr("aria-hidden", "false")
                : ((e = b.options.slidesToShow + a),
                  d
                    .slice(e - c + 1, e + c + 2)
                    .addClass("slick-active")
                    .attr("aria-hidden", "false")),
              0 === a
                ? d
                    .eq(d.length - 1 - b.options.slidesToShow)
                    .addClass("slick-center")
                : a === b.slideCount - 1 &&
                  d.eq(b.options.slidesToShow).addClass("slick-center")),
            b.$slides.eq(a).addClass("slick-center"))
          : a >= 0 && a <= b.slideCount - b.options.slidesToShow
          ? b.$slides
              .slice(a, a + b.options.slidesToShow)
              .addClass("slick-active")
              .attr("aria-hidden", "false")
          : d.length <= b.options.slidesToShow
          ? d.addClass("slick-active").attr("aria-hidden", "false")
          : ((f = b.slideCount % b.options.slidesToShow),
            (e = b.options.infinite === !0 ? b.options.slidesToShow + a : a),
            b.options.slidesToShow == b.options.slidesToScroll &&
            b.slideCount - a < b.options.slidesToShow
              ? d
                  .slice(e - (b.options.slidesToShow - f), e + f)
                  .addClass("slick-active")
                  .attr("aria-hidden", "false")
              : d
                  .slice(e, e + b.options.slidesToShow)
                  .addClass("slick-active")
                  .attr("aria-hidden", "false")),
        "ondemand" === b.options.lazyLoad && b.lazyLoad();
    }),
    (b.prototype.setupInfinite = function () {
      var c,
        d,
        e,
        b = this;
      if (
        (b.options.fade === !0 && (b.options.centerMode = !1),
        b.options.infinite === !0 &&
          b.options.fade === !1 &&
          ((d = null), b.slideCount > b.options.slidesToShow))
      ) {
        for (
          e =
            b.options.centerMode === !0
              ? b.options.slidesToShow + 1
              : b.options.slidesToShow,
            c = b.slideCount;
          c > b.slideCount - e;
          c -= 1
        )
          (d = c - 1),
            a(b.$slides[d])
              .clone(!0)
              .attr("id", "")
              .attr("data-slick-index", d - b.slideCount)
              .prependTo(b.$slideTrack)
              .addClass("slick-cloned");
        for (c = 0; e > c; c += 1)
          (d = c),
            a(b.$slides[d])
              .clone(!0)
              .attr("id", "")
              .attr("data-slick-index", d + b.slideCount)
              .appendTo(b.$slideTrack)
              .addClass("slick-cloned");
        b.$slideTrack
          .find(".slick-cloned")
          .find("[id]")
          .each(function () {
            a(this).attr("id", "");
          });
      }
    }),
    (b.prototype.interrupt = function (a) {
      var b = this;
      a || b.autoPlay(), (b.interrupted = a);
    }),
    (b.prototype.selectHandler = function (b) {
      var c = this,
        d = a(b.target).is(".slick-slide")
          ? a(b.target)
          : a(b.target).parents(".slick-slide"),
        e = parseInt(d.attr("data-slick-index"));
      return (
        e || (e = 0),
        c.slideCount <= c.options.slidesToShow
          ? (c.setSlideClasses(e), void c.asNavFor(e))
          : void c.slideHandler(e)
      );
    }),
    (b.prototype.slideHandler = function (a, b, c) {
      var d,
        e,
        f,
        g,
        j,
        h = null,
        i = this;
      return (
        (b = b || !1),
        (i.animating === !0 && i.options.waitForAnimate === !0) ||
        (i.options.fade === !0 && i.currentSlide === a) ||
        i.slideCount <= i.options.slidesToShow
          ? void 0
          : (b === !1 && i.asNavFor(a),
            (d = a),
            (h = i.getLeft(d)),
            (g = i.getLeft(i.currentSlide)),
            (i.currentLeft = null === i.swipeLeft ? g : i.swipeLeft),
            i.options.infinite === !1 &&
            i.options.centerMode === !1 &&
            (0 > a || a > i.getDotCount() * i.options.slidesToScroll)
              ? void (
                  i.options.fade === !1 &&
                  ((d = i.currentSlide),
                  c !== !0
                    ? i.animateSlide(g, function () {
                        i.postSlide(d);
                      })
                    : i.postSlide(d))
                )
              : i.options.infinite === !1 &&
                i.options.centerMode === !0 &&
                (0 > a || a > i.slideCount - i.options.slidesToScroll)
              ? void (
                  i.options.fade === !1 &&
                  ((d = i.currentSlide),
                  c !== !0
                    ? i.animateSlide(g, function () {
                        i.postSlide(d);
                      })
                    : i.postSlide(d))
                )
              : (i.options.autoplay && clearInterval(i.autoPlayTimer),
                (e =
                  0 > d
                    ? i.slideCount % i.options.slidesToScroll !== 0
                      ? i.slideCount - (i.slideCount % i.options.slidesToScroll)
                      : i.slideCount + d
                    : d >= i.slideCount
                    ? i.slideCount % i.options.slidesToScroll !== 0
                      ? 0
                      : d - i.slideCount
                    : d),
                (i.animating = !0),
                i.$slider.trigger("beforeChange", [i, i.currentSlide, e]),
                (f = i.currentSlide),
                (i.currentSlide = e),
                i.setSlideClasses(i.currentSlide),
                i.options.asNavFor &&
                  ((j = i.getNavTarget()),
                  (j = j.slick("getSlick")),
                  j.slideCount <= j.options.slidesToShow &&
                    j.setSlideClasses(i.currentSlide)),
                i.updateDots(),
                i.updateArrows(),
                i.options.fade === !0
                  ? (c !== !0
                      ? (i.fadeSlideOut(f),
                        i.fadeSlide(e, function () {
                          i.postSlide(e);
                        }))
                      : i.postSlide(e),
                    void i.animateHeight())
                  : void (c !== !0
                      ? i.animateSlide(h, function () {
                          i.postSlide(e);
                        })
                      : i.postSlide(e))))
      );
    }),
    (b.prototype.startLoad = function () {
      var a = this;
      a.options.arrows === !0 &&
        a.slideCount > a.options.slidesToShow &&
        (a.$prevArrow.hide(), a.$nextArrow.hide()),
        a.options.dots === !0 &&
          a.slideCount > a.options.slidesToShow &&
          a.$dots.hide(),
        a.$slider.addClass("slick-loading");
    }),
    (b.prototype.swipeDirection = function () {
      var a,
        b,
        c,
        d,
        e = this;
      return (
        (a = e.touchObject.startX - e.touchObject.curX),
        (b = e.touchObject.startY - e.touchObject.curY),
        (c = Math.atan2(b, a)),
        (d = Math.round((180 * c) / Math.PI)),
        0 > d && (d = 360 - Math.abs(d)),
        45 >= d && d >= 0
          ? e.options.rtl === !1
            ? "left"
            : "right"
          : 360 >= d && d >= 315
          ? e.options.rtl === !1
            ? "left"
            : "right"
          : d >= 135 && 225 >= d
          ? e.options.rtl === !1
            ? "right"
            : "left"
          : e.options.verticalSwiping === !0
          ? d >= 35 && 135 >= d
            ? "down"
            : "up"
          : "vertical"
      );
    }),
    (b.prototype.swipeEnd = function (a) {
      var c,
        d,
        b = this;
      if (
        ((b.dragging = !1),
        (b.interrupted = !1),
        (b.shouldClick = b.touchObject.swipeLength > 10 ? !1 : !0),
        void 0 === b.touchObject.curX)
      )
        return !1;
      if (
        (b.touchObject.edgeHit === !0 &&
          b.$slider.trigger("edge", [b, b.swipeDirection()]),
        b.touchObject.swipeLength >= b.touchObject.minSwipe)
      ) {
        switch ((d = b.swipeDirection())) {
          case "left":
          case "down":
            (c = b.options.swipeToSlide
              ? b.checkNavigable(b.currentSlide + b.getSlideCount())
              : b.currentSlide + b.getSlideCount()),
              (b.currentDirection = 0);
            break;
          case "right":
          case "up":
            (c = b.options.swipeToSlide
              ? b.checkNavigable(b.currentSlide - b.getSlideCount())
              : b.currentSlide - b.getSlideCount()),
              (b.currentDirection = 1);
        }
        "vertical" != d &&
          (b.slideHandler(c),
          (b.touchObject = {}),
          b.$slider.trigger("swipe", [b, d]));
      } else
        b.touchObject.startX !== b.touchObject.curX &&
          (b.slideHandler(b.currentSlide), (b.touchObject = {}));
    }),
    (b.prototype.swipeHandler = function (a) {
      var b = this;
      if (
        !(
          b.options.swipe === !1 ||
          ("ontouchend" in document && b.options.swipe === !1) ||
          (b.options.draggable === !1 && -1 !== a.type.indexOf("mouse"))
        )
      )
        switch (
          ((b.touchObject.fingerCount =
            a.originalEvent && void 0 !== a.originalEvent.touches
              ? a.originalEvent.touches.length
              : 1),
          (b.touchObject.minSwipe = b.listWidth / b.options.touchThreshold),
          b.options.verticalSwiping === !0 &&
            (b.touchObject.minSwipe = b.listHeight / b.options.touchThreshold),
          a.data.action)
        ) {
          case "start":
            b.swipeStart(a);
            break;
          case "move":
            b.swipeMove(a);
            break;
          case "end":
            b.swipeEnd(a);
        }
    }),
    (b.prototype.swipeMove = function (a) {
      var d,
        e,
        f,
        g,
        h,
        b = this;
      return (
        (h = void 0 !== a.originalEvent ? a.originalEvent.touches : null),
        !b.dragging || (h && 1 !== h.length)
          ? !1
          : ((d = b.getLeft(b.currentSlide)),
            (b.touchObject.curX = void 0 !== h ? h[0].pageX : a.clientX),
            (b.touchObject.curY = void 0 !== h ? h[0].pageY : a.clientY),
            (b.touchObject.swipeLength = Math.round(
              Math.sqrt(Math.pow(b.touchObject.curX - b.touchObject.startX, 2))
            )),
            b.options.verticalSwiping === !0 &&
              (b.touchObject.swipeLength = Math.round(
                Math.sqrt(
                  Math.pow(b.touchObject.curY - b.touchObject.startY, 2)
                )
              )),
            (e = b.swipeDirection()),
            "vertical" !== e
              ? (void 0 !== a.originalEvent &&
                  b.touchObject.swipeLength > 4 &&
                  a.preventDefault(),
                (g =
                  (b.options.rtl === !1 ? 1 : -1) *
                  (b.touchObject.curX > b.touchObject.startX ? 1 : -1)),
                b.options.verticalSwiping === !0 &&
                  (g = b.touchObject.curY > b.touchObject.startY ? 1 : -1),
                (f = b.touchObject.swipeLength),
                (b.touchObject.edgeHit = !1),
                b.options.infinite === !1 &&
                  ((0 === b.currentSlide && "right" === e) ||
                    (b.currentSlide >= b.getDotCount() && "left" === e)) &&
                  ((f = b.touchObject.swipeLength * b.options.edgeFriction),
                  (b.touchObject.edgeHit = !0)),
                b.options.vertical === !1
                  ? (b.swipeLeft = d + f * g)
                  : (b.swipeLeft =
                      d + f * (b.$list.height() / b.listWidth) * g),
                b.options.verticalSwiping === !0 && (b.swipeLeft = d + f * g),
                b.options.fade === !0 || b.options.touchMove === !1
                  ? !1
                  : b.animating === !0
                  ? ((b.swipeLeft = null), !1)
                  : void b.setCSS(b.swipeLeft))
              : void 0)
      );
    }),
    (b.prototype.swipeStart = function (a) {
      var c,
        b = this;
      return (
        (b.interrupted = !0),
        1 !== b.touchObject.fingerCount ||
        b.slideCount <= b.options.slidesToShow
          ? ((b.touchObject = {}), !1)
          : (void 0 !== a.originalEvent &&
              void 0 !== a.originalEvent.touches &&
              (c = a.originalEvent.touches[0]),
            (b.touchObject.startX = b.touchObject.curX =
              void 0 !== c ? c.pageX : a.clientX),
            (b.touchObject.startY = b.touchObject.curY =
              void 0 !== c ? c.pageY : a.clientY),
            void (b.dragging = !0))
      );
    }),
    (b.prototype.unfilterSlides = b.prototype.slickUnfilter =
      function () {
        var a = this;
        null !== a.$slidesCache &&
          (a.unload(),
          a.$slideTrack.children(this.options.slide).detach(),
          a.$slidesCache.appendTo(a.$slideTrack),
          a.reinit());
      }),
    (b.prototype.unload = function () {
      var b = this;
      a(".slick-cloned", b.$slider).remove(),
        b.$dots && b.$dots.remove(),
        b.$prevArrow &&
          b.htmlExpr.test(b.options.prevArrow) &&
          b.$prevArrow.remove(),
        b.$nextArrow &&
          b.htmlExpr.test(b.options.nextArrow) &&
          b.$nextArrow.remove(),
        b.$slides
          .removeClass("slick-slide slick-active slick-visible slick-current")
          .attr("aria-hidden", "true")
          .css("width", "");
    }),
    (b.prototype.unslick = function (a) {
      var b = this;
      b.$slider.trigger("unslick", [b, a]), b.destroy();
    }),
    (b.prototype.updateArrows = function () {
      var b,
        a = this;
      (b = Math.floor(a.options.slidesToShow / 2)),
        a.options.arrows === !0 &&
          a.slideCount > a.options.slidesToShow &&
          !a.options.infinite &&
          (a.$prevArrow
            .removeClass("slick-disabled")
            .attr("aria-disabled", "false"),
          a.$nextArrow
            .removeClass("slick-disabled")
            .attr("aria-disabled", "false"),
          0 === a.currentSlide
            ? (a.$prevArrow
                .addClass("slick-disabled")
                .attr("aria-disabled", "true"),
              a.$nextArrow
                .removeClass("slick-disabled")
                .attr("aria-disabled", "false"))
            : a.currentSlide >= a.slideCount - a.options.slidesToShow &&
              a.options.centerMode === !1
            ? (a.$nextArrow
                .addClass("slick-disabled")
                .attr("aria-disabled", "true"),
              a.$prevArrow
                .removeClass("slick-disabled")
                .attr("aria-disabled", "false"))
            : a.currentSlide >= a.slideCount - 1 &&
              a.options.centerMode === !0 &&
              (a.$nextArrow
                .addClass("slick-disabled")
                .attr("aria-disabled", "true"),
              a.$prevArrow
                .removeClass("slick-disabled")
                .attr("aria-disabled", "false")));
    }),
    (b.prototype.updateDots = function () {
      var a = this;
      null !== a.$dots &&
        (a.$dots
          .find("li")
          .removeClass("slick-active")
          .attr("aria-hidden", "true"),
        a.$dots
          .find("li")
          .eq(Math.floor(a.currentSlide / a.options.slidesToScroll))
          .addClass("slick-active")
          .attr("aria-hidden", "false"));
    }),
    (b.prototype.visibility = function () {
      var a = this;
      a.options.autoplay &&
        (document[a.hidden] ? (a.interrupted = !0) : (a.interrupted = !1));
    }),
    (a.fn.slick = function () {
      var f,
        g,
        a = this,
        c = arguments[0],
        d = Array.prototype.slice.call(arguments, 1),
        e = a.length;
      for (f = 0; e > f; f++)
        if (
          ("object" == typeof c || "undefined" == typeof c
            ? (a[f].slick = new b(a[f], c))
            : (g = a[f].slick[c].apply(a[f].slick, d)),
          "undefined" != typeof g)
        )
          return g;
      return a;
    });
});

$(".Index_top_text_imgs_color_rightside_firstimage_new").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  infinite: true,
  fade: true,
  dots: false,
  arrows: false,
});

$(".Index_top_text_imgs_color_rightside_secondimage_new").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 4000,
  infinite: true,
  fade: true,
  dots: false,
  arrows: false,
});

$(".Index_top_text_imgs_color_rightside_thiredimage_new").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  infinite: true,
  fade: true,
  dots: false,
  arrows: false,
});

$(".blog_posts_mobile_slider").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
  autoplaySpeed: 2000,
  infinite: false,
  responsive: [
    {
      breakpoint: 9999,
      settings: "unslick",
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: false,
        dots: false,
        variableWidth: false,
        arrows: false,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        dots: false,
        variableWidth: true,
        arrows: false,
      },
    },
  ],
});

/*team sidebar*/
$(document).ready(function () {
  // Open Popup
  $(".blog_team_link_new").on("click", function () {
    var ID = this.id;
    $("#" + ID + "_open").addClass("active");
    $(".blog_team_template_overlay").fadeIn(300);
    $("body").addClass("slideOpen");
  });

  // Close Popup
  $(".closeBtn").on("click", function () {
    $(".popup").removeClass("active");
    $(".blog_team_template_overlay").fadeOut(300);
    $("body").removeClass("slideOpen");
  });

  // Close Popup when Click outside
  /* $('.popup').on('click', function () {
    $('.popup').removeClass("active");
    $(".blog_team_template_overlay").fadeOut(300);
    $('body').removeClass("slideOpen");
  }).children().click(function () {
    //return false;
  });*/

  $(document).mouseup(function (e) {
    var container = $(".popup-content");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      $(".popup").removeClass("active");
      $(".blog_team_template_overlay").fadeOut(300);
      $("body").removeClass("slideOpen");
    }
  });
});

$(".team_scroll_new").click(function () {
  $("html, body").animate(
    {
      scrollTop: $(".blog_team_top_main_title_scroll_new").offset().top - 50,
    },
    2000
  );
});

$(".value_scroll_new").click(function () {
  $("html, body").animate(
    {
      scrollTop:
        $(".Page_value_of_good_title_image_scroll_new").offset().top - 50,
    },
    2000
  );
});

$(".Index_top_text_imgs_color_leftside_svg_new").click(function () {
  $("html, body").animate(
    {
      scrollTop: $(".Index_icons_texts_loop_main_new").offset().top - 70,
    },
    2000
  );
});

$(".scroll_about_arrow_new").click(function () {
  $("html, body").animate(
    {
      scrollTop: $(".Page_about_us_value_slider_main_new").offset().top - 80,
    },
    2000
  );
});

$(".scroll_portfolio_arrow_new").click(function () {
  $("html, body").animate(
    {
      scrollTop: $(".Index_lefticon_rightcount_main_new").offset().top - 100,
    },
    2000
  );
});

$(document).on(
  "click",
  '.blog_ignite_category_blog_firstpart_new a[href^="#"]',
  function (event) {
    event.preventDefault();

    $("html, body").animate(
      {
        scrollTop: $($.attr(this, "href")).offset().top - 70,
      },
      2000
    );
  }
);

/* ignite */
$(".blog_ignite_top_heading_toppart_first_imagefirst_new").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  infinite: true,
  fade: true,
  dots: false,
  arrows: false,
});

$(".blog_ignite_top_heading_toppart_thired_secondimage_new").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 4000,
  infinite: true,
  fade: true,
  dots: false,
  arrows: false,
});

$(".blog_ignite_template_blog_show_tag_filter_rightpart_new").click(
  function () {
    $(".blog_ignite_template_search_bar_new").fadeIn();
  }
);
$(".close_popup_new").click(function () {
  $(".blog_ignite_template_search_bar_new").fadeOut();
});

/* team slider */

const interleaveOffset = 0.75;

var swiper_team = new Swiper(".team-swiper-container", {
  direction: "vertical",
  speed: 800,
  mousewheelControl: true,
  watchSlidesProgress: true,
  mousewheel: {
    releaseOnEdges: true,
  },
  pagination: {
    el: ".swiper-pagination-new",
    clickable: true,
    type: "bullets",
    renderBullet: function (index, className) {
      return '<span class="' + className + '">' + (index + 1) + "</span>";
      //return '<span class="' + className + '">' + ('0' + (index + 1)) + '</span>';
    },
  },
  on: {
    /*resize: function () {
        var windowWidth = $(window).width();
        if(windowWidth <= 767){
                swiper_team.direction('horizontal');
                //swiper_team.detachEvents();
        }else{
                swiper_team.direction('vertical');
                //swiper_team.attachEvents();
        }
        swiper_team.update();
    },*/
    progress: function () {
      /*var windowWidth = $(window).width();
      if(windowWidth <= 767){
      }
      else{*/
      console.log("test");
      let swiper = this;

      for (let i = 0; i < swiper.slides.length; i++) {
        let slideProgress = swiper.slides[i].progress;
        let innerOffset = swiper.height * interleaveOffset;
        let innerTranslate = slideProgress * innerOffset;

        TweenMax.set(swiper.slides[i].querySelector(".slide-inner"), {
          y: innerTranslate,
        });
      }
      //}
    },
    setTransition: function (slider, speed) {
      /*var windowWidth = $(window).width();
      if(windowWidth <= 767){
      }
      else{*/
      let swiper = this;
      for (let i = 0; i < swiper.slides.length; i++) {
        swiper.slides[i].style.transition = speed + "ms";
        swiper.slides[i].querySelector(".slide-inner").style.transition =
          speed + "ms";
      }
      //}
    },
  },
});

/* team slider Mobile */

const interleaveOffset_1 = 0.75;

var swiper_team_1 = new Swiper(".team-swiper-container-mobile", {
  speed: 800,
  mousewheelControl: true,
  watchSlidesProgress: true,
  mousewheel: {
    releaseOnEdges: true,
  },
  pagination: {
    el: ".swiper-pagination-new",
    clickable: true,
    type: "bullets",
    renderBullet: function (index, className) {
      return '<span class="' + className + '">' + (index + 1) + "</span>";
      //return '<span class="' + className + '">' + ('0' + (index + 1)) + '</span>';
    },
  },
  on: {
    /*resize: function () {
        var windowWidth = $(window).width();
        if(windowWidth <= 767){
                swiper_team.direction('horizontal');
                //swiper_team.detachEvents();
        }else{
                swiper_team.direction('vertical');
                //swiper_team.attachEvents();
        }
        swiper_team.update();
    },*/
    progress: function () {
      /*var windowWidth = $(window).width();
      if(windowWidth <= 767){
      }
      else{*/
      /*console.log('test')
        let swiper = this;
  
        for (let i = 0; i < swiper.slides.length; i++) {
          let slideProgress = swiper.slides[i].progress;
          let innerOffset = swiper.height * interleaveOffset_1;
          let innerTranslate = slideProgress * innerOffset;
  
          TweenMax.set(swiper.slides[i].querySelector(".slide-inner"), {
            y: innerTranslate,
          });
        }*/
      //}
    },
    setTransition: function (slider, speed) {
      /*var windowWidth = $(window).width();
      if(windowWidth <= 767){
      }
      else{*/
      /*let swiper = this;
        for (let i = 0; i < swiper.slides.length; i++) {
          swiper.slides[i].style.transition = speed + "ms";
          swiper.slides[i].querySelector(".slide-inner").style.transition =
            speed + "ms";
        }*/
      //}
    },
  },
});

/* portfolio */
$(".blog_portfolio_top_title_rightside_allimageslider_new").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  infinite: true,
  fade: true,
  dots: false,
  arrows: false,
});

$(".blog_portfolio_top_title_rightside_second_2_allimageslider_new").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 4000,
  infinite: true,
  fade: true,
  dots: false,
  arrows: false,
});

$(".blog_portfolio_top_title_rightside_third_3_allimageslider_new").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  infinite: true,
  fade: true,
  dots: false,
  arrows: false,
});

/* about */
$(".blog_portfolio_top_title_rightside_second_allimageslider_new").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  infinite: true,
  fade: true,
  dots: false,
  arrows: false,
});

/* view all script */
var blog_list_view_val = Cookies.get("blog_list_view");
$(".view_all_new").click(function () {
  //console.log(Cookies.get('blog_list_view'));
  if ($(this).hasClass("active") == false) {
    $(this).html("Block View");
    $(this).addClass("active");
    $(".blog_portfolio_template_inner_new").addClass("blog_list_view_new");
    Cookies.set("blog_list_view", "yes");
    //console.log(Cookies.get('blog_list_view'));
  } else {
    $(this).html("Grid View");
    $(this).removeClass("active");
    $(".blog_portfolio_template_inner_new").removeClass("blog_list_view_new");
    Cookies.set("blog_list_view", "no");
    //console.log(Cookies.get('blog_list_view'));
  }
});
//console.log("data"+Cookies.get('blog_list_view'));
if (blog_list_view_val == "yes") {
  $(".view_all_new").html("Block View");
  $(".view_all_new").addClass("active");
  $(".blog_portfolio_template_inner_new").addClass("blog_list_view_new");
} else {
  $(".view_all_new").html("Grid View");
  $(".view_all_new").removeClass("active");
  $(".blog_portfolio_template_inner_new").removeClass("blog_list_view_new");
}

/* scroll */
/* == jquery mousewheel plugin == Version: 3.1.13, License: MIT License (MIT) */
!(function (a) {
  "function" == typeof define && define.amd
    ? define(["jquery"], a)
    : "object" == typeof exports
    ? (module.exports = a)
    : a(jQuery);
})(function (a) {
  function b(b) {
    var g = b || window.event,
      h = i.call(arguments, 1),
      j = 0,
      l = 0,
      m = 0,
      n = 0,
      o = 0,
      p = 0;
    if (
      ((b = a.event.fix(g)),
      (b.type = "mousewheel"),
      "detail" in g && (m = -1 * g.detail),
      "wheelDelta" in g && (m = g.wheelDelta),
      "wheelDeltaY" in g && (m = g.wheelDeltaY),
      "wheelDeltaX" in g && (l = -1 * g.wheelDeltaX),
      "axis" in g && g.axis === g.HORIZONTAL_AXIS && ((l = -1 * m), (m = 0)),
      (j = 0 === m ? l : m),
      "deltaY" in g && ((m = -1 * g.deltaY), (j = m)),
      "deltaX" in g && ((l = g.deltaX), 0 === m && (j = -1 * l)),
      0 !== m || 0 !== l)
    ) {
      if (1 === g.deltaMode) {
        var q = a.data(this, "mousewheel-line-height");
        (j *= q), (m *= q), (l *= q);
      } else if (2 === g.deltaMode) {
        var r = a.data(this, "mousewheel-page-height");
        (j *= r), (m *= r), (l *= r);
      }
      if (
        ((n = Math.max(Math.abs(m), Math.abs(l))),
        (!f || f > n) && ((f = n), d(g, n) && (f /= 40)),
        d(g, n) && ((j /= 40), (l /= 40), (m /= 40)),
        (j = Math[j >= 1 ? "floor" : "ceil"](j / f)),
        (l = Math[l >= 1 ? "floor" : "ceil"](l / f)),
        (m = Math[m >= 1 ? "floor" : "ceil"](m / f)),
        k.settings.normalizeOffset && this.getBoundingClientRect)
      ) {
        var s = this.getBoundingClientRect();
        (o = b.clientX - s.left), (p = b.clientY - s.top);
      }
      return (
        (b.deltaX = l),
        (b.deltaY = m),
        (b.deltaFactor = f),
        (b.offsetX = o),
        (b.offsetY = p),
        (b.deltaMode = 0),
        h.unshift(b, j, l, m),
        e && clearTimeout(e),
        (e = setTimeout(c, 200)),
        (a.event.dispatch || a.event.handle).apply(this, h)
      );
    }
  }
  function c() {
    f = null;
  }
  function d(a, b) {
    return (
      k.settings.adjustOldDeltas && "mousewheel" === a.type && b % 120 === 0
    );
  }
  var e,
    f,
    g = ["wheel", "mousewheel", "DOMMouseScroll", "MozMousePixelScroll"],
    h =
      "onwheel" in document || document.documentMode >= 9
        ? ["wheel"]
        : ["mousewheel", "DomMouseScroll", "MozMousePixelScroll"],
    i = Array.prototype.slice;
  if (a.event.fixHooks)
    for (var j = g.length; j; ) a.event.fixHooks[g[--j]] = a.event.mouseHooks;
  var k = (a.event.special.mousewheel = {
    version: "3.1.12",
    setup: function () {
      if (this.addEventListener)
        for (var c = h.length; c; ) this.addEventListener(h[--c], b, !1);
      else this.onmousewheel = b;
      a.data(this, "mousewheel-line-height", k.getLineHeight(this)),
        a.data(this, "mousewheel-page-height", k.getPageHeight(this));
    },
    teardown: function () {
      if (this.removeEventListener)
        for (var c = h.length; c; ) this.removeEventListener(h[--c], b, !1);
      else this.onmousewheel = null;
      a.removeData(this, "mousewheel-line-height"),
        a.removeData(this, "mousewheel-page-height");
    },
    getLineHeight: function (b) {
      var c = a(b),
        d = c["offsetParent" in a.fn ? "offsetParent" : "parent"]();
      return (
        d.length || (d = a("body")),
        parseInt(d.css("fontSize"), 10) || parseInt(c.css("fontSize"), 10) || 16
      );
    },
    getPageHeight: function (b) {
      return a(b).height();
    },
    settings: { adjustOldDeltas: !0, normalizeOffset: !0 },
  });
  a.fn.extend({
    mousewheel: function (a) {
      return a ? this.bind("mousewheel", a) : this.trigger("mousewheel");
    },
    unmousewheel: function (a) {
      return this.unbind("mousewheel", a);
    },
  });
});
!(function (a) {
  "function" == typeof define && define.amd
    ? define(["jquery"], a)
    : "object" == typeof exports
    ? (module.exports = a)
    : a(jQuery);
})(function (a) {
  function b(b) {
    var g = b || window.event,
      h = i.call(arguments, 1),
      j = 0,
      l = 0,
      m = 0,
      n = 0,
      o = 0,
      p = 0;
    if (
      ((b = a.event.fix(g)),
      (b.type = "mousewheel"),
      "detail" in g && (m = -1 * g.detail),
      "wheelDelta" in g && (m = g.wheelDelta),
      "wheelDeltaY" in g && (m = g.wheelDeltaY),
      "wheelDeltaX" in g && (l = -1 * g.wheelDeltaX),
      "axis" in g && g.axis === g.HORIZONTAL_AXIS && ((l = -1 * m), (m = 0)),
      (j = 0 === m ? l : m),
      "deltaY" in g && ((m = -1 * g.deltaY), (j = m)),
      "deltaX" in g && ((l = g.deltaX), 0 === m && (j = -1 * l)),
      0 !== m || 0 !== l)
    ) {
      if (1 === g.deltaMode) {
        var q = a.data(this, "mousewheel-line-height");
        (j *= q), (m *= q), (l *= q);
      } else if (2 === g.deltaMode) {
        var r = a.data(this, "mousewheel-page-height");
        (j *= r), (m *= r), (l *= r);
      }
      if (
        ((n = Math.max(Math.abs(m), Math.abs(l))),
        (!f || f > n) && ((f = n), d(g, n) && (f /= 40)),
        d(g, n) && ((j /= 40), (l /= 40), (m /= 40)),
        (j = Math[j >= 1 ? "floor" : "ceil"](j / f)),
        (l = Math[l >= 1 ? "floor" : "ceil"](l / f)),
        (m = Math[m >= 1 ? "floor" : "ceil"](m / f)),
        k.settings.normalizeOffset && this.getBoundingClientRect)
      ) {
        var s = this.getBoundingClientRect();
        (o = b.clientX - s.left), (p = b.clientY - s.top);
      }
      return (
        (b.deltaX = l),
        (b.deltaY = m),
        (b.deltaFactor = f),
        (b.offsetX = o),
        (b.offsetY = p),
        (b.deltaMode = 0),
        h.unshift(b, j, l, m),
        e && clearTimeout(e),
        (e = setTimeout(c, 200)),
        (a.event.dispatch || a.event.handle).apply(this, h)
      );
    }
  }
  function c() {
    f = null;
  }
  function d(a, b) {
    return (
      k.settings.adjustOldDeltas && "mousewheel" === a.type && b % 120 === 0
    );
  }
  var e,
    f,
    g = ["wheel", "mousewheel", "DOMMouseScroll", "MozMousePixelScroll"],
    h =
      "onwheel" in document || document.documentMode >= 9
        ? ["wheel"]
        : ["mousewheel", "DomMouseScroll", "MozMousePixelScroll"],
    i = Array.prototype.slice;
  if (a.event.fixHooks)
    for (var j = g.length; j; ) a.event.fixHooks[g[--j]] = a.event.mouseHooks;
  var k = (a.event.special.mousewheel = {
    version: "3.1.12",
    setup: function () {
      if (this.addEventListener)
        for (var c = h.length; c; ) this.addEventListener(h[--c], b, !1);
      else this.onmousewheel = b;
      a.data(this, "mousewheel-line-height", k.getLineHeight(this)),
        a.data(this, "mousewheel-page-height", k.getPageHeight(this));
    },
    teardown: function () {
      if (this.removeEventListener)
        for (var c = h.length; c; ) this.removeEventListener(h[--c], b, !1);
      else this.onmousewheel = null;
      a.removeData(this, "mousewheel-line-height"),
        a.removeData(this, "mousewheel-page-height");
    },
    getLineHeight: function (b) {
      var c = a(b),
        d = c["offsetParent" in a.fn ? "offsetParent" : "parent"]();
      return (
        d.length || (d = a("body")),
        parseInt(d.css("fontSize"), 10) || parseInt(c.css("fontSize"), 10) || 16
      );
    },
    getPageHeight: function (b) {
      return a(b).height();
    },
    settings: { adjustOldDeltas: !0, normalizeOffset: !0 },
  });
  a.fn.extend({
    mousewheel: function (a) {
      return a ? this.bind("mousewheel", a) : this.trigger("mousewheel");
    },
    unmousewheel: function (a) {
      return this.unbind("mousewheel", a);
    },
  });
});
/* == malihu jquery custom scrollbar plugin == Version: 3.1.5, License: MIT License (MIT) */
!(function (e) {
  "function" == typeof define && define.amd
    ? define(["jquery"], e)
    : "undefined" != typeof module && module.exports
    ? (module.exports = e)
    : e(jQuery, window, document);
})(function (e) {
  !(function (t) {
    var o = "function" == typeof define && define.amd,
      a = "undefined" != typeof module && module.exports,
      n = "https:" == document.location.protocol ? "https:" : "http:",
      i =
        "cdnjs.cloudflare.com/ajax/libs/jquery-mousewheel/3.1.13/jquery.mousewheel.min.js";
    o ||
      (a
        ? require("jquery-mousewheel")(e)
        : e.event.special.mousewheel ||
          e("head").append(
            decodeURI("%3Cscript src=" + n + "//" + i + "%3E%3C/script%3E")
          )),
      t();
  })(function () {
    var t,
      o = "mCustomScrollbar",
      a = "mCS",
      n = ".mCustomScrollbar",
      i = {
        setTop: 0,
        setLeft: 0,
        axis: "y",
        scrollbarPosition: "inside",
        scrollInertia: 950,
        autoDraggerLength: !0,
        alwaysShowScrollbar: 0,
        snapOffset: 0,
        mouseWheel: {
          enable: !0,
          scrollAmount: "auto",
          axis: "y",
          deltaFactor: "auto",
          disableOver: ["select", "option", "keygen", "datalist", "textarea"],
        },
        scrollButtons: { scrollType: "stepless", scrollAmount: "auto" },
        keyboard: { enable: !0, scrollType: "stepless", scrollAmount: "auto" },
        contentTouchScroll: 25,
        documentTouchScroll: !0,
        advanced: {
          autoScrollOnFocus:
            "input,textarea,select,button,datalist,keygen,a[tabindex],area,object,[contenteditable='true']",
          updateOnContentResize: !0,
          updateOnImageLoad: "auto",
          autoUpdateTimeout: 60,
        },
        theme: "light",
        callbacks: {
          onTotalScrollOffset: 0,
          onTotalScrollBackOffset: 0,
          alwaysTriggerOffsets: !0,
        },
      },
      r = 0,
      l = {},
      s = window.attachEvent && !window.addEventListener ? 1 : 0,
      c = !1,
      d = [
        "mCSB_dragger_onDrag",
        "mCSB_scrollTools_onDrag",
        "mCS_img_loaded",
        "mCS_disabled",
        "mCS_destroyed",
        "mCS_no_scrollbar",
        "mCS-autoHide",
        "mCS-dir-rtl",
        "mCS_no_scrollbar_y",
        "mCS_no_scrollbar_x",
        "mCS_y_hidden",
        "mCS_x_hidden",
        "mCSB_draggerContainer",
        "mCSB_buttonUp",
        "mCSB_buttonDown",
        "mCSB_buttonLeft",
        "mCSB_buttonRight",
      ],
      u = {
        init: function (t) {
          var t = e.extend(!0, {}, i, t),
            o = f.call(this);
          if (t.live) {
            var s = t.liveSelector || this.selector || n,
              c = e(s);
            if ("off" === t.live) return void m(s);
            l[s] = setTimeout(function () {
              c.mCustomScrollbar(t), "once" === t.live && c.length && m(s);
            }, 500);
          } else m(s);
          return (
            (t.setWidth = t.set_width ? t.set_width : t.setWidth),
            (t.setHeight = t.set_height ? t.set_height : t.setHeight),
            (t.axis = t.horizontalScroll ? "x" : p(t.axis)),
            (t.scrollInertia =
              t.scrollInertia > 0 && t.scrollInertia < 17
                ? 17
                : t.scrollInertia),
            "object" != typeof t.mouseWheel &&
              1 == t.mouseWheel &&
              (t.mouseWheel = {
                enable: !0,
                scrollAmount: "auto",
                axis: "y",
                preventDefault: !1,
                deltaFactor: "auto",
                normalizeDelta: !1,
                invert: !1,
              }),
            (t.mouseWheel.scrollAmount = t.mouseWheelPixels
              ? t.mouseWheelPixels
              : t.mouseWheel.scrollAmount),
            (t.mouseWheel.normalizeDelta = t.advanced.normalizeMouseWheelDelta
              ? t.advanced.normalizeMouseWheelDelta
              : t.mouseWheel.normalizeDelta),
            (t.scrollButtons.scrollType = g(t.scrollButtons.scrollType)),
            h(t),
            e(o).each(function () {
              var o = e(this);
              if (!o.data(a)) {
                o.data(a, {
                  idx: ++r,
                  opt: t,
                  scrollRatio: { y: null, x: null },
                  overflowed: null,
                  contentReset: { y: null, x: null },
                  bindEvents: !1,
                  tweenRunning: !1,
                  sequential: {},
                  langDir: o.css("direction"),
                  cbOffsets: null,
                  trigger: null,
                  poll: {
                    size: { o: 0, n: 0 },
                    img: { o: 0, n: 0 },
                    change: { o: 0, n: 0 },
                  },
                });
                var n = o.data(a),
                  i = n.opt,
                  l = o.data("mcs-axis"),
                  s = o.data("mcs-scrollbar-position"),
                  c = o.data("mcs-theme");
                l && (i.axis = l),
                  s && (i.scrollbarPosition = s),
                  c && ((i.theme = c), h(i)),
                  v.call(this),
                  n &&
                    i.callbacks.onCreate &&
                    "function" == typeof i.callbacks.onCreate &&
                    i.callbacks.onCreate.call(this),
                  e(
                    "#mCSB_" + n.idx + "_container img:not(." + d[2] + ")"
                  ).addClass(d[2]),
                  u.update.call(null, o);
              }
            })
          );
        },
        update: function (t, o) {
          var n = t || f.call(this);
          return e(n).each(function () {
            var t = e(this);
            if (t.data(a)) {
              var n = t.data(a),
                i = n.opt,
                r = e("#mCSB_" + n.idx + "_container"),
                l = e("#mCSB_" + n.idx),
                s = [
                  e("#mCSB_" + n.idx + "_dragger_vertical"),
                  e("#mCSB_" + n.idx + "_dragger_horizontal"),
                ];
              if (!r.length) return;
              n.tweenRunning && Q(t),
                o &&
                  n &&
                  i.callbacks.onBeforeUpdate &&
                  "function" == typeof i.callbacks.onBeforeUpdate &&
                  i.callbacks.onBeforeUpdate.call(this),
                t.hasClass(d[3]) && t.removeClass(d[3]),
                t.hasClass(d[4]) && t.removeClass(d[4]),
                l.css("max-height", "none"),
                l.height() !== t.height() && l.css("max-height", t.height()),
                _.call(this),
                "y" === i.axis ||
                  i.advanced.autoExpandHorizontalScroll ||
                  r.css("width", x(r)),
                (n.overflowed = y.call(this)),
                M.call(this),
                i.autoDraggerLength && S.call(this),
                b.call(this),
                T.call(this);
              var c = [Math.abs(r[0].offsetTop), Math.abs(r[0].offsetLeft)];
              "x" !== i.axis &&
                (n.overflowed[0]
                  ? s[0].height() > s[0].parent().height()
                    ? B.call(this)
                    : (G(t, c[0].toString(), {
                        dir: "y",
                        dur: 0,
                        overwrite: "none",
                      }),
                      (n.contentReset.y = null))
                  : (B.call(this),
                    "y" === i.axis
                      ? k.call(this)
                      : "yx" === i.axis &&
                        n.overflowed[1] &&
                        G(t, c[1].toString(), {
                          dir: "x",
                          dur: 0,
                          overwrite: "none",
                        }))),
                "y" !== i.axis &&
                  (n.overflowed[1]
                    ? s[1].width() > s[1].parent().width()
                      ? B.call(this)
                      : (G(t, c[1].toString(), {
                          dir: "x",
                          dur: 0,
                          overwrite: "none",
                        }),
                        (n.contentReset.x = null))
                    : (B.call(this),
                      "x" === i.axis
                        ? k.call(this)
                        : "yx" === i.axis &&
                          n.overflowed[0] &&
                          G(t, c[0].toString(), {
                            dir: "y",
                            dur: 0,
                            overwrite: "none",
                          }))),
                o &&
                  n &&
                  (2 === o &&
                  i.callbacks.onImageLoad &&
                  "function" == typeof i.callbacks.onImageLoad
                    ? i.callbacks.onImageLoad.call(this)
                    : 3 === o &&
                      i.callbacks.onSelectorChange &&
                      "function" == typeof i.callbacks.onSelectorChange
                    ? i.callbacks.onSelectorChange.call(this)
                    : i.callbacks.onUpdate &&
                      "function" == typeof i.callbacks.onUpdate &&
                      i.callbacks.onUpdate.call(this)),
                N.call(this);
            }
          });
        },
        scrollTo: function (t, o) {
          if ("undefined" != typeof t && null != t) {
            var n = f.call(this);
            return e(n).each(function () {
              var n = e(this);
              if (n.data(a)) {
                var i = n.data(a),
                  r = i.opt,
                  l = {
                    trigger: "external",
                    scrollInertia: r.scrollInertia,
                    scrollEasing: "mcsEaseInOut",
                    moveDragger: !1,
                    timeout: 60,
                    callbacks: !0,
                    onStart: !0,
                    onUpdate: !0,
                    onComplete: !0,
                  },
                  s = e.extend(!0, {}, l, o),
                  c = Y.call(this, t),
                  d =
                    s.scrollInertia > 0 && s.scrollInertia < 17
                      ? 17
                      : s.scrollInertia;
                (c[0] = X.call(this, c[0], "y")),
                  (c[1] = X.call(this, c[1], "x")),
                  s.moveDragger &&
                    ((c[0] *= i.scrollRatio.y), (c[1] *= i.scrollRatio.x)),
                  (s.dur = ne() ? 0 : d),
                  setTimeout(function () {
                    null !== c[0] &&
                      "undefined" != typeof c[0] &&
                      "x" !== r.axis &&
                      i.overflowed[0] &&
                      ((s.dir = "y"),
                      (s.overwrite = "all"),
                      G(n, c[0].toString(), s)),
                      null !== c[1] &&
                        "undefined" != typeof c[1] &&
                        "y" !== r.axis &&
                        i.overflowed[1] &&
                        ((s.dir = "x"),
                        (s.overwrite = "none"),
                        G(n, c[1].toString(), s));
                  }, s.timeout);
              }
            });
          }
        },
        stop: function () {
          var t = f.call(this);
          return e(t).each(function () {
            var t = e(this);
            t.data(a) && Q(t);
          });
        },
        disable: function (t) {
          var o = f.call(this);
          return e(o).each(function () {
            var o = e(this);
            if (o.data(a)) {
              o.data(a);
              N.call(this, "remove"),
                k.call(this),
                t && B.call(this),
                M.call(this, !0),
                o.addClass(d[3]);
            }
          });
        },
        destroy: function () {
          var t = f.call(this);
          return e(t).each(function () {
            var n = e(this);
            if (n.data(a)) {
              var i = n.data(a),
                r = i.opt,
                l = e("#mCSB_" + i.idx),
                s = e("#mCSB_" + i.idx + "_container"),
                c = e(".mCSB_" + i.idx + "_scrollbar");
              r.live && m(r.liveSelector || e(t).selector),
                N.call(this, "remove"),
                k.call(this),
                B.call(this),
                n.removeData(a),
                $(this, "mcs"),
                c.remove(),
                s.find("img." + d[2]).removeClass(d[2]),
                l.replaceWith(s.contents()),
                n
                  .removeClass(
                    o +
                      " _" +
                      a +
                      "_" +
                      i.idx +
                      " " +
                      d[6] +
                      " " +
                      d[7] +
                      " " +
                      d[5] +
                      " " +
                      d[3]
                  )
                  .addClass(d[4]);
            }
          });
        },
      },
      f = function () {
        return "object" != typeof e(this) || e(this).length < 1 ? n : this;
      },
      h = function (t) {
        var o = [
            "rounded",
            "rounded-dark",
            "rounded-dots",
            "rounded-dots-dark",
          ],
          a = [
            "rounded-dots",
            "rounded-dots-dark",
            "3d",
            "3d-dark",
            "3d-thick",
            "3d-thick-dark",
            "inset",
            "inset-dark",
            "inset-2",
            "inset-2-dark",
            "inset-3",
            "inset-3-dark",
          ],
          n = ["minimal", "minimal-dark"],
          i = ["minimal", "minimal-dark"],
          r = ["minimal", "minimal-dark"];
        (t.autoDraggerLength =
          e.inArray(t.theme, o) > -1 ? !1 : t.autoDraggerLength),
          (t.autoExpandScrollbar =
            e.inArray(t.theme, a) > -1 ? !1 : t.autoExpandScrollbar),
          (t.scrollButtons.enable =
            e.inArray(t.theme, n) > -1 ? !1 : t.scrollButtons.enable),
          (t.autoHideScrollbar =
            e.inArray(t.theme, i) > -1 ? !0 : t.autoHideScrollbar),
          (t.scrollbarPosition =
            e.inArray(t.theme, r) > -1 ? "outside" : t.scrollbarPosition);
      },
      m = function (e) {
        l[e] && (clearTimeout(l[e]), $(l, e));
      },
      p = function (e) {
        return "yx" === e || "xy" === e || "auto" === e
          ? "yx"
          : "x" === e || "horizontal" === e
          ? "x"
          : "y";
      },
      g = function (e) {
        return "stepped" === e ||
          "pixels" === e ||
          "step" === e ||
          "click" === e
          ? "stepped"
          : "stepless";
      },
      v = function () {
        var t = e(this),
          n = t.data(a),
          i = n.opt,
          r = i.autoExpandScrollbar ? " " + d[1] + "_expand" : "",
          l = [
            "<div id='mCSB_" +
              n.idx +
              "_scrollbar_vertical' class='mCSB_scrollTools mCSB_" +
              n.idx +
              "_scrollbar mCS-" +
              i.theme +
              " mCSB_scrollTools_vertical" +
              r +
              "'><div class='" +
              d[12] +
              "'><div id='mCSB_" +
              n.idx +
              "_dragger_vertical' class='mCSB_dragger' style='position:absolute;'><div class='mCSB_dragger_bar' /></div><div class='mCSB_draggerRail' /></div></div>",
            "<div id='mCSB_" +
              n.idx +
              "_scrollbar_horizontal' class='mCSB_scrollTools mCSB_" +
              n.idx +
              "_scrollbar mCS-" +
              i.theme +
              " mCSB_scrollTools_horizontal" +
              r +
              "'><div class='" +
              d[12] +
              "'><div id='mCSB_" +
              n.idx +
              "_dragger_horizontal' class='mCSB_dragger' style='position:absolute;'><div class='mCSB_dragger_bar' /></div><div class='mCSB_draggerRail' /></div></div>",
          ],
          s =
            "yx" === i.axis
              ? "mCSB_vertical_horizontal"
              : "x" === i.axis
              ? "mCSB_horizontal"
              : "mCSB_vertical",
          c = "yx" === i.axis ? l[0] + l[1] : "x" === i.axis ? l[1] : l[0],
          u =
            "yx" === i.axis
              ? "<div id='mCSB_" +
                n.idx +
                "_container_wrapper' class='mCSB_container_wrapper' />"
              : "",
          f = i.autoHideScrollbar ? " " + d[6] : "",
          h = "x" !== i.axis && "rtl" === n.langDir ? " " + d[7] : "";
        i.setWidth && t.css("width", i.setWidth),
          i.setHeight && t.css("height", i.setHeight),
          (i.setLeft =
            "y" !== i.axis && "rtl" === n.langDir ? "989999px" : i.setLeft),
          t
            .addClass(o + " _" + a + "_" + n.idx + f + h)
            .wrapInner(
              "<div id='mCSB_" +
                n.idx +
                "' class='mCustomScrollBox mCS-" +
                i.theme +
                " " +
                s +
                "'><div id='mCSB_" +
                n.idx +
                "_container' class='mCSB_container' style='position:relative; top:" +
                i.setTop +
                "; left:" +
                i.setLeft +
                ";' dir='" +
                n.langDir +
                "' /></div>"
            );
        var m = e("#mCSB_" + n.idx),
          p = e("#mCSB_" + n.idx + "_container");
        "y" === i.axis ||
          i.advanced.autoExpandHorizontalScroll ||
          p.css("width", x(p)),
          "outside" === i.scrollbarPosition
            ? ("static" === t.css("position") && t.css("position", "relative"),
              t.css("overflow", "visible"),
              m.addClass("mCSB_outside").after(c))
            : (m.addClass("mCSB_inside").append(c), p.wrap(u)),
          w.call(this);
        var g = [
          e("#mCSB_" + n.idx + "_dragger_vertical"),
          e("#mCSB_" + n.idx + "_dragger_horizontal"),
        ];
        g[0].css("min-height", g[0].height()),
          g[1].css("min-width", g[1].width());
      },
      x = function (t) {
        var o = [
            t[0].scrollWidth,
            Math.max.apply(
              Math,
              t
                .children()
                .map(function () {
                  return e(this).outerWidth(!0);
                })
                .get()
            ),
          ],
          a = t.parent().width();
        return o[0] > a ? o[0] : o[1] > a ? o[1] : "100%";
      },
      _ = function () {
        var t = e(this),
          o = t.data(a),
          n = o.opt,
          i = e("#mCSB_" + o.idx + "_container");
        if (n.advanced.autoExpandHorizontalScroll && "y" !== n.axis) {
          i.css({ width: "auto", "min-width": 0, "overflow-x": "scroll" });
          var r = Math.ceil(i[0].scrollWidth);
          3 === n.advanced.autoExpandHorizontalScroll ||
          (2 !== n.advanced.autoExpandHorizontalScroll &&
            r > i.parent().width())
            ? i.css({ width: r, "min-width": "100%", "overflow-x": "inherit" })
            : i
                .css({ "overflow-x": "inherit", position: "absolute" })
                .wrap(
                  "<div class='mCSB_h_wrapper' style='position:relative; left:0; width:999999px;' />"
                )
                .css({
                  width:
                    Math.ceil(i[0].getBoundingClientRect().right + 0.4) -
                    Math.floor(i[0].getBoundingClientRect().left),
                  "min-width": "100%",
                  position: "relative",
                })
                .unwrap();
        }
      },
      w = function () {
        var t = e(this),
          o = t.data(a),
          n = o.opt,
          i = e(".mCSB_" + o.idx + "_scrollbar:first"),
          r = oe(n.scrollButtons.tabindex)
            ? "tabindex='" + n.scrollButtons.tabindex + "'"
            : "",
          l = [
            "<a href='#' class='" + d[13] + "' " + r + " />",
            "<a href='#' class='" + d[14] + "' " + r + " />",
            "<a href='#' class='" + d[15] + "' " + r + " />",
            "<a href='#' class='" + d[16] + "' " + r + " />",
          ],
          s = [
            "x" === n.axis ? l[2] : l[0],
            "x" === n.axis ? l[3] : l[1],
            l[2],
            l[3],
          ];
        n.scrollButtons.enable &&
          i
            .prepend(s[0])
            .append(s[1])
            .next(".mCSB_scrollTools")
            .prepend(s[2])
            .append(s[3]);
      },
      S = function () {
        var t = e(this),
          o = t.data(a),
          n = e("#mCSB_" + o.idx),
          i = e("#mCSB_" + o.idx + "_container"),
          r = [
            e("#mCSB_" + o.idx + "_dragger_vertical"),
            e("#mCSB_" + o.idx + "_dragger_horizontal"),
          ],
          l = [n.height() / i.outerHeight(!1), n.width() / i.outerWidth(!1)],
          c = [
            parseInt(r[0].css("min-height")),
            Math.round(l[0] * r[0].parent().height()),
            parseInt(r[1].css("min-width")),
            Math.round(l[1] * r[1].parent().width()),
          ],
          d = s && c[1] < c[0] ? c[0] : c[1],
          u = s && c[3] < c[2] ? c[2] : c[3];
        r[0]
          .css({ height: d, "max-height": r[0].parent().height() - 10 })
          .find(".mCSB_dragger_bar")
          .css({ "line-height": c[0] + "px" }),
          r[1].css({ width: u, "max-width": r[1].parent().width() - 10 });
      },
      b = function () {
        var t = e(this),
          o = t.data(a),
          n = e("#mCSB_" + o.idx),
          i = e("#mCSB_" + o.idx + "_container"),
          r = [
            e("#mCSB_" + o.idx + "_dragger_vertical"),
            e("#mCSB_" + o.idx + "_dragger_horizontal"),
          ],
          l = [i.outerHeight(!1) - n.height(), i.outerWidth(!1) - n.width()],
          s = [
            l[0] / (r[0].parent().height() - r[0].height()),
            l[1] / (r[1].parent().width() - r[1].width()),
          ];
        o.scrollRatio = { y: s[0], x: s[1] };
      },
      C = function (e, t, o) {
        var a = o ? d[0] + "_expanded" : "",
          n = e.closest(".mCSB_scrollTools");
        "active" === t
          ? (e.toggleClass(d[0] + " " + a),
            n.toggleClass(d[1]),
            (e[0]._draggable = e[0]._draggable ? 0 : 1))
          : e[0]._draggable ||
            ("hide" === t
              ? (e.removeClass(d[0]), n.removeClass(d[1]))
              : (e.addClass(d[0]), n.addClass(d[1])));
      },
      y = function () {
        var t = e(this),
          o = t.data(a),
          n = e("#mCSB_" + o.idx),
          i = e("#mCSB_" + o.idx + "_container"),
          r = null == o.overflowed ? i.height() : i.outerHeight(!1),
          l = null == o.overflowed ? i.width() : i.outerWidth(!1),
          s = i[0].scrollHeight,
          c = i[0].scrollWidth;
        return (
          s > r && (r = s), c > l && (l = c), [r > n.height(), l > n.width()]
        );
      },
      B = function () {
        var t = e(this),
          o = t.data(a),
          n = o.opt,
          i = e("#mCSB_" + o.idx),
          r = e("#mCSB_" + o.idx + "_container"),
          l = [
            e("#mCSB_" + o.idx + "_dragger_vertical"),
            e("#mCSB_" + o.idx + "_dragger_horizontal"),
          ];
        if (
          (Q(t),
          (("x" !== n.axis && !o.overflowed[0]) ||
            ("y" === n.axis && o.overflowed[0])) &&
            (l[0].add(r).css("top", 0), G(t, "_resetY")),
          ("y" !== n.axis && !o.overflowed[1]) ||
            ("x" === n.axis && o.overflowed[1]))
        ) {
          var s = (dx = 0);
          "rtl" === o.langDir &&
            ((s = i.width() - r.outerWidth(!1)),
            (dx = Math.abs(s / o.scrollRatio.x))),
            r.css("left", s),
            l[1].css("left", dx),
            G(t, "_resetX");
        }
      },
      T = function () {
        function t() {
          r = setTimeout(function () {
            e.event.special.mousewheel ? (clearTimeout(r), W.call(o[0])) : t();
          }, 100);
        }
        var o = e(this),
          n = o.data(a),
          i = n.opt;
        if (!n.bindEvents) {
          if (
            (I.call(this),
            i.contentTouchScroll && D.call(this),
            E.call(this),
            i.mouseWheel.enable)
          ) {
            var r;
            t();
          }
          P.call(this),
            U.call(this),
            i.advanced.autoScrollOnFocus && H.call(this),
            i.scrollButtons.enable && F.call(this),
            i.keyboard.enable && q.call(this),
            (n.bindEvents = !0);
        }
      },
      k = function () {
        var t = e(this),
          o = t.data(a),
          n = o.opt,
          i = a + "_" + o.idx,
          r = ".mCSB_" + o.idx + "_scrollbar",
          l = e(
            "#mCSB_" +
              o.idx +
              ",#mCSB_" +
              o.idx +
              "_container,#mCSB_" +
              o.idx +
              "_container_wrapper," +
              r +
              " ." +
              d[12] +
              ",#mCSB_" +
              o.idx +
              "_dragger_vertical,#mCSB_" +
              o.idx +
              "_dragger_horizontal," +
              r +
              ">a"
          ),
          s = e("#mCSB_" + o.idx + "_container");
        n.advanced.releaseDraggableSelectors &&
          l.add(e(n.advanced.releaseDraggableSelectors)),
          n.advanced.extraDraggableSelectors &&
            l.add(e(n.advanced.extraDraggableSelectors)),
          o.bindEvents &&
            (e(document)
              .add(e(!A() || top.document))
              .unbind("." + i),
            l.each(function () {
              e(this).unbind("." + i);
            }),
            clearTimeout(t[0]._focusTimeout),
            $(t[0], "_focusTimeout"),
            clearTimeout(o.sequential.step),
            $(o.sequential, "step"),
            clearTimeout(s[0].onCompleteTimeout),
            $(s[0], "onCompleteTimeout"),
            (o.bindEvents = !1));
      },
      M = function (t) {
        var o = e(this),
          n = o.data(a),
          i = n.opt,
          r = e("#mCSB_" + n.idx + "_container_wrapper"),
          l = r.length ? r : e("#mCSB_" + n.idx + "_container"),
          s = [
            e("#mCSB_" + n.idx + "_scrollbar_vertical"),
            e("#mCSB_" + n.idx + "_scrollbar_horizontal"),
          ],
          c = [s[0].find(".mCSB_dragger"), s[1].find(".mCSB_dragger")];
        "x" !== i.axis &&
          (n.overflowed[0] && !t
            ? (s[0].add(c[0]).add(s[0].children("a")).css("display", "block"),
              l.removeClass(d[8] + " " + d[10]))
            : (i.alwaysShowScrollbar
                ? (2 !== i.alwaysShowScrollbar && c[0].css("display", "none"),
                  l.removeClass(d[10]))
                : (s[0].css("display", "none"), l.addClass(d[10])),
              l.addClass(d[8]))),
          "y" !== i.axis &&
            (n.overflowed[1] && !t
              ? (s[1].add(c[1]).add(s[1].children("a")).css("display", "block"),
                l.removeClass(d[9] + " " + d[11]))
              : (i.alwaysShowScrollbar
                  ? (2 !== i.alwaysShowScrollbar && c[1].css("display", "none"),
                    l.removeClass(d[11]))
                  : (s[1].css("display", "none"), l.addClass(d[11])),
                l.addClass(d[9]))),
          n.overflowed[0] || n.overflowed[1]
            ? o.removeClass(d[5])
            : o.addClass(d[5]);
      },
      O = function (t) {
        var o = t.type,
          a =
            t.target.ownerDocument !== document && null !== frameElement
              ? [e(frameElement).offset().top, e(frameElement).offset().left]
              : null,
          n =
            A() &&
            t.target.ownerDocument !== top.document &&
            null !== frameElement
              ? [
                  e(t.view.frameElement).offset().top,
                  e(t.view.frameElement).offset().left,
                ]
              : [0, 0];
        switch (o) {
          case "pointerdown":
          case "MSPointerDown":
          case "pointermove":
          case "MSPointerMove":
          case "pointerup":
          case "MSPointerUp":
            return a
              ? [
                  t.originalEvent.pageY - a[0] + n[0],
                  t.originalEvent.pageX - a[1] + n[1],
                  !1,
                ]
              : [t.originalEvent.pageY, t.originalEvent.pageX, !1];
          case "touchstart":
          case "touchmove":
          case "touchend":
            var i =
                t.originalEvent.touches[0] || t.originalEvent.changedTouches[0],
              r =
                t.originalEvent.touches.length ||
                t.originalEvent.changedTouches.length;
            return t.target.ownerDocument !== document
              ? [i.screenY, i.screenX, r > 1]
              : [i.pageY, i.pageX, r > 1];
          default:
            return a
              ? [t.pageY - a[0] + n[0], t.pageX - a[1] + n[1], !1]
              : [t.pageY, t.pageX, !1];
        }
      },
      I = function () {
        function t(e, t, a, n) {
          if (
            ((h[0].idleTimer = d.scrollInertia < 233 ? 250 : 0),
            o.attr("id") === f[1])
          )
            var i = "x",
              s = (o[0].offsetLeft - t + n) * l.scrollRatio.x;
          else
            var i = "y",
              s = (o[0].offsetTop - e + a) * l.scrollRatio.y;
          G(r, s.toString(), { dir: i, drag: !0 });
        }
        var o,
          n,
          i,
          r = e(this),
          l = r.data(a),
          d = l.opt,
          u = a + "_" + l.idx,
          f = [
            "mCSB_" + l.idx + "_dragger_vertical",
            "mCSB_" + l.idx + "_dragger_horizontal",
          ],
          h = e("#mCSB_" + l.idx + "_container"),
          m = e("#" + f[0] + ",#" + f[1]),
          p = d.advanced.releaseDraggableSelectors
            ? m.add(e(d.advanced.releaseDraggableSelectors))
            : m,
          g = d.advanced.extraDraggableSelectors
            ? e(!A() || top.document).add(e(d.advanced.extraDraggableSelectors))
            : e(!A() || top.document);
        m
          .bind("contextmenu." + u, function (e) {
            e.preventDefault();
          })
          .bind(
            "mousedown." +
              u +
              " touchstart." +
              u +
              " pointerdown." +
              u +
              " MSPointerDown." +
              u,
            function (t) {
              if ((t.stopImmediatePropagation(), t.preventDefault(), ee(t))) {
                (c = !0),
                  s &&
                    (document.onselectstart = function () {
                      return !1;
                    }),
                  L.call(h, !1),
                  Q(r),
                  (o = e(this));
                var a = o.offset(),
                  l = O(t)[0] - a.top,
                  u = O(t)[1] - a.left,
                  f = o.height() + a.top,
                  m = o.width() + a.left;
                f > l && l > 0 && m > u && u > 0 && ((n = l), (i = u)),
                  C(o, "active", d.autoExpandScrollbar);
              }
            }
          )
          .bind("touchmove." + u, function (e) {
            e.stopImmediatePropagation(), e.preventDefault();
            var a = o.offset(),
              r = O(e)[0] - a.top,
              l = O(e)[1] - a.left;
            t(n, i, r, l);
          }),
          e(document)
            .add(g)
            .bind(
              "mousemove." + u + " pointermove." + u + " MSPointerMove." + u,
              function (e) {
                if (o) {
                  var a = o.offset(),
                    r = O(e)[0] - a.top,
                    l = O(e)[1] - a.left;
                  if (n === r && i === l) return;
                  t(n, i, r, l);
                }
              }
            )
            .add(p)
            .bind(
              "mouseup." +
                u +
                " touchend." +
                u +
                " pointerup." +
                u +
                " MSPointerUp." +
                u,
              function () {
                o && (C(o, "active", d.autoExpandScrollbar), (o = null)),
                  (c = !1),
                  s && (document.onselectstart = null),
                  L.call(h, !0);
              }
            );
      },
      D = function () {
        function o(e) {
          if (!te(e) || c || O(e)[2]) return void (t = 0);
          (t = 1), (b = 0), (C = 0), (d = 1), y.removeClass("mCS_touch_action");
          var o = I.offset();
          (u = O(e)[0] - o.top),
            (f = O(e)[1] - o.left),
            (z = [O(e)[0], O(e)[1]]);
        }
        function n(e) {
          if (
            te(e) &&
            !c &&
            !O(e)[2] &&
            (T.documentTouchScroll || e.preventDefault(),
            e.stopImmediatePropagation(),
            (!C || b) && d)
          ) {
            g = K();
            var t = M.offset(),
              o = O(e)[0] - t.top,
              a = O(e)[1] - t.left,
              n = "mcsLinearOut";
            if (
              (E.push(o),
              W.push(a),
              (z[2] = Math.abs(O(e)[0] - z[0])),
              (z[3] = Math.abs(O(e)[1] - z[1])),
              B.overflowed[0])
            )
              var i = D[0].parent().height() - D[0].height(),
                r =
                  u - o > 0 &&
                  o - u > -(i * B.scrollRatio.y) &&
                  (2 * z[3] < z[2] || "yx" === T.axis);
            if (B.overflowed[1])
              var l = D[1].parent().width() - D[1].width(),
                h =
                  f - a > 0 &&
                  a - f > -(l * B.scrollRatio.x) &&
                  (2 * z[2] < z[3] || "yx" === T.axis);
            r || h
              ? (U || e.preventDefault(), (b = 1))
              : ((C = 1), y.addClass("mCS_touch_action")),
              U && e.preventDefault(),
              (w =
                "yx" === T.axis
                  ? [u - o, f - a]
                  : "x" === T.axis
                  ? [null, f - a]
                  : [u - o, null]),
              (I[0].idleTimer = 250),
              B.overflowed[0] && s(w[0], R, n, "y", "all", !0),
              B.overflowed[1] && s(w[1], R, n, "x", L, !0);
          }
        }
        function i(e) {
          if (!te(e) || c || O(e)[2]) return void (t = 0);
          (t = 1), e.stopImmediatePropagation(), Q(y), (p = K());
          var o = M.offset();
          (h = O(e)[0] - o.top), (m = O(e)[1] - o.left), (E = []), (W = []);
        }
        function r(e) {
          if (te(e) && !c && !O(e)[2]) {
            (d = 0), e.stopImmediatePropagation(), (b = 0), (C = 0), (v = K());
            var t = M.offset(),
              o = O(e)[0] - t.top,
              a = O(e)[1] - t.left;
            if (!(v - g > 30)) {
              _ = 1e3 / (v - p);
              var n = "mcsEaseOut",
                i = 2.5 > _,
                r = i ? [E[E.length - 2], W[W.length - 2]] : [0, 0];
              x = i ? [o - r[0], a - r[1]] : [o - h, a - m];
              var u = [Math.abs(x[0]), Math.abs(x[1])];
              _ = i ? [Math.abs(x[0] / 4), Math.abs(x[1] / 4)] : [_, _];
              var f = [
                Math.abs(I[0].offsetTop) - x[0] * l(u[0] / _[0], _[0]),
                Math.abs(I[0].offsetLeft) - x[1] * l(u[1] / _[1], _[1]),
              ];
              (w =
                "yx" === T.axis
                  ? [f[0], f[1]]
                  : "x" === T.axis
                  ? [null, f[1]]
                  : [f[0], null]),
                (S = [4 * u[0] + T.scrollInertia, 4 * u[1] + T.scrollInertia]);
              var y = parseInt(T.contentTouchScroll) || 0;
              (w[0] = u[0] > y ? w[0] : 0),
                (w[1] = u[1] > y ? w[1] : 0),
                B.overflowed[0] && s(w[0], S[0], n, "y", L, !1),
                B.overflowed[1] && s(w[1], S[1], n, "x", L, !1);
            }
          }
        }
        function l(e, t) {
          var o = [1.5 * t, 2 * t, t / 1.5, t / 2];
          return e > 90
            ? t > 4
              ? o[0]
              : o[3]
            : e > 60
            ? t > 3
              ? o[3]
              : o[2]
            : e > 30
            ? t > 8
              ? o[1]
              : t > 6
              ? o[0]
              : t > 4
              ? t
              : o[2]
            : t > 8
            ? t
            : o[3];
        }
        function s(e, t, o, a, n, i) {
          e &&
            G(y, e.toString(), {
              dur: t,
              scrollEasing: o,
              dir: a,
              overwrite: n,
              drag: i,
            });
        }
        var d,
          u,
          f,
          h,
          m,
          p,
          g,
          v,
          x,
          _,
          w,
          S,
          b,
          C,
          y = e(this),
          B = y.data(a),
          T = B.opt,
          k = a + "_" + B.idx,
          M = e("#mCSB_" + B.idx),
          I = e("#mCSB_" + B.idx + "_container"),
          D = [
            e("#mCSB_" + B.idx + "_dragger_vertical"),
            e("#mCSB_" + B.idx + "_dragger_horizontal"),
          ],
          E = [],
          W = [],
          R = 0,
          L = "yx" === T.axis ? "none" : "all",
          z = [],
          P = I.find("iframe"),
          H = [
            "touchstart." + k + " pointerdown." + k + " MSPointerDown." + k,
            "touchmove." + k + " pointermove." + k + " MSPointerMove." + k,
            "touchend." + k + " pointerup." + k + " MSPointerUp." + k,
          ],
          U =
            void 0 !== document.body.style.touchAction &&
            "" !== document.body.style.touchAction;
        I.bind(H[0], function (e) {
          o(e);
        }).bind(H[1], function (e) {
          n(e);
        }),
          M.bind(H[0], function (e) {
            i(e);
          }).bind(H[2], function (e) {
            r(e);
          }),
          P.length &&
            P.each(function () {
              e(this).bind("load", function () {
                A(this) &&
                  e(this.contentDocument || this.contentWindow.document)
                    .bind(H[0], function (e) {
                      o(e), i(e);
                    })
                    .bind(H[1], function (e) {
                      n(e);
                    })
                    .bind(H[2], function (e) {
                      r(e);
                    });
              });
            });
      },
      E = function () {
        function o() {
          return window.getSelection
            ? window.getSelection().toString()
            : document.selection && "Control" != document.selection.type
            ? document.selection.createRange().text
            : 0;
        }
        function n(e, t, o) {
          (d.type = o && i ? "stepped" : "stepless"),
            (d.scrollAmount = 10),
            j(r, e, t, "mcsLinearOut", o ? 60 : null);
        }
        var i,
          r = e(this),
          l = r.data(a),
          s = l.opt,
          d = l.sequential,
          u = a + "_" + l.idx,
          f = e("#mCSB_" + l.idx + "_container"),
          h = f.parent();
        f.bind("mousedown." + u, function () {
          t || i || ((i = 1), (c = !0));
        })
          .add(document)
          .bind("mousemove." + u, function (e) {
            if (!t && i && o()) {
              var a = f.offset(),
                r = O(e)[0] - a.top + f[0].offsetTop,
                c = O(e)[1] - a.left + f[0].offsetLeft;
              r > 0 && r < h.height() && c > 0 && c < h.width()
                ? d.step && n("off", null, "stepped")
                : ("x" !== s.axis &&
                    l.overflowed[0] &&
                    (0 > r ? n("on", 38) : r > h.height() && n("on", 40)),
                  "y" !== s.axis &&
                    l.overflowed[1] &&
                    (0 > c ? n("on", 37) : c > h.width() && n("on", 39)));
            }
          })
          .bind("mouseup." + u + " dragend." + u, function () {
            t || (i && ((i = 0), n("off", null)), (c = !1));
          });
      },
      W = function () {
        function t(t, a) {
          if ((Q(o), !z(o, t.target))) {
            var r =
                "auto" !== i.mouseWheel.deltaFactor
                  ? parseInt(i.mouseWheel.deltaFactor)
                  : s && t.deltaFactor < 100
                  ? 100
                  : t.deltaFactor || 100,
              d = i.scrollInertia;
            if ("x" === i.axis || "x" === i.mouseWheel.axis)
              var u = "x",
                f = [
                  Math.round(r * n.scrollRatio.x),
                  parseInt(i.mouseWheel.scrollAmount),
                ],
                h =
                  "auto" !== i.mouseWheel.scrollAmount
                    ? f[1]
                    : f[0] >= l.width()
                    ? 0.9 * l.width()
                    : f[0],
                m = Math.abs(e("#mCSB_" + n.idx + "_container")[0].offsetLeft),
                p = c[1][0].offsetLeft,
                g = c[1].parent().width() - c[1].width(),
                v = "y" === i.mouseWheel.axis ? t.deltaY || a : t.deltaX;
            else
              var u = "y",
                f = [
                  Math.round(r * n.scrollRatio.y),
                  parseInt(i.mouseWheel.scrollAmount),
                ],
                h =
                  "auto" !== i.mouseWheel.scrollAmount
                    ? f[1]
                    : f[0] >= l.height()
                    ? 0.9 * l.height()
                    : f[0],
                m = Math.abs(e("#mCSB_" + n.idx + "_container")[0].offsetTop),
                p = c[0][0].offsetTop,
                g = c[0].parent().height() - c[0].height(),
                v = t.deltaY || a;
            ("y" === u && !n.overflowed[0]) ||
              ("x" === u && !n.overflowed[1]) ||
              ((i.mouseWheel.invert || t.webkitDirectionInvertedFromDevice) &&
                (v = -v),
              i.mouseWheel.normalizeDelta && (v = 0 > v ? -1 : 1),
              ((v > 0 && 0 !== p) ||
                (0 > v && p !== g) ||
                i.mouseWheel.preventDefault) &&
                (t.stopImmediatePropagation(), t.preventDefault()),
              t.deltaFactor < 5 &&
                !i.mouseWheel.normalizeDelta &&
                ((h = t.deltaFactor), (d = 17)),
              G(o, (m - v * h).toString(), { dir: u, dur: d }));
          }
        }
        if (e(this).data(a)) {
          var o = e(this),
            n = o.data(a),
            i = n.opt,
            r = a + "_" + n.idx,
            l = e("#mCSB_" + n.idx),
            c = [
              e("#mCSB_" + n.idx + "_dragger_vertical"),
              e("#mCSB_" + n.idx + "_dragger_horizontal"),
            ],
            d = e("#mCSB_" + n.idx + "_container").find("iframe");
          d.length &&
            d.each(function () {
              e(this).bind("load", function () {
                A(this) &&
                  e(this.contentDocument || this.contentWindow.document).bind(
                    "mousewheel." + r,
                    function (e, o) {
                      t(e, o);
                    }
                  );
              });
            }),
            l.bind("mousewheel." + r, function (e, o) {
              t(e, o);
            });
        }
      },
      R = new Object(),
      A = function (t) {
        var o = !1,
          a = !1,
          n = null;
        if (
          (void 0 === t
            ? (a = "#empty")
            : void 0 !== e(t).attr("id") && (a = e(t).attr("id")),
          a !== !1 && void 0 !== R[a])
        )
          return R[a];
        if (t) {
          try {
            var i = t.contentDocument || t.contentWindow.document;
            n = i.body.innerHTML;
          } catch (r) {}
          o = null !== n;
        } else {
          try {
            var i = top.document;
            n = i.body.innerHTML;
          } catch (r) {}
          o = null !== n;
        }
        return a !== !1 && (R[a] = o), o;
      },
      L = function (e) {
        var t = this.find("iframe");
        if (t.length) {
          var o = e ? "auto" : "none";
          t.css("pointer-events", o);
        }
      },
      z = function (t, o) {
        var n = o.nodeName.toLowerCase(),
          i = t.data(a).opt.mouseWheel.disableOver,
          r = ["select", "textarea"];
        return (
          e.inArray(n, i) > -1 && !(e.inArray(n, r) > -1 && !e(o).is(":focus"))
        );
      },
      P = function () {
        var t,
          o = e(this),
          n = o.data(a),
          i = a + "_" + n.idx,
          r = e("#mCSB_" + n.idx + "_container"),
          l = r.parent(),
          s = e(".mCSB_" + n.idx + "_scrollbar ." + d[12]);
        s.bind(
          "mousedown." +
            i +
            " touchstart." +
            i +
            " pointerdown." +
            i +
            " MSPointerDown." +
            i,
          function (o) {
            (c = !0), e(o.target).hasClass("mCSB_dragger") || (t = 1);
          }
        )
          .bind(
            "touchend." + i + " pointerup." + i + " MSPointerUp." + i,
            function () {
              c = !1;
            }
          )
          .bind("click." + i, function (a) {
            if (
              t &&
              ((t = 0),
              e(a.target).hasClass(d[12]) ||
                e(a.target).hasClass("mCSB_draggerRail"))
            ) {
              Q(o);
              var i = e(this),
                s = i.find(".mCSB_dragger");
              if (i.parent(".mCSB_scrollTools_horizontal").length > 0) {
                if (!n.overflowed[1]) return;
                var c = "x",
                  u = a.pageX > s.offset().left ? -1 : 1,
                  f = Math.abs(r[0].offsetLeft) - u * (0.9 * l.width());
              } else {
                if (!n.overflowed[0]) return;
                var c = "y",
                  u = a.pageY > s.offset().top ? -1 : 1,
                  f = Math.abs(r[0].offsetTop) - u * (0.9 * l.height());
              }
              G(o, f.toString(), { dir: c, scrollEasing: "mcsEaseInOut" });
            }
          });
      },
      H = function () {
        var t = e(this),
          o = t.data(a),
          n = o.opt,
          i = a + "_" + o.idx,
          r = e("#mCSB_" + o.idx + "_container"),
          l = r.parent();
        r.bind("focusin." + i, function () {
          var o = e(document.activeElement),
            a = r.find(".mCustomScrollBox").length,
            i = 0;
          o.is(n.advanced.autoScrollOnFocus) &&
            (Q(t),
            clearTimeout(t[0]._focusTimeout),
            (t[0]._focusTimer = a ? (i + 17) * a : 0),
            (t[0]._focusTimeout = setTimeout(function () {
              var e = [ae(o)[0], ae(o)[1]],
                a = [r[0].offsetTop, r[0].offsetLeft],
                s = [
                  a[0] + e[0] >= 0 &&
                    a[0] + e[0] < l.height() - o.outerHeight(!1),
                  a[1] + e[1] >= 0 &&
                    a[0] + e[1] < l.width() - o.outerWidth(!1),
                ],
                c = "yx" !== n.axis || s[0] || s[1] ? "all" : "none";
              "x" === n.axis ||
                s[0] ||
                G(t, e[0].toString(), {
                  dir: "y",
                  scrollEasing: "mcsEaseInOut",
                  overwrite: c,
                  dur: i,
                }),
                "y" === n.axis ||
                  s[1] ||
                  G(t, e[1].toString(), {
                    dir: "x",
                    scrollEasing: "mcsEaseInOut",
                    overwrite: c,
                    dur: i,
                  });
            }, t[0]._focusTimer)));
        });
      },
      U = function () {
        var t = e(this),
          o = t.data(a),
          n = a + "_" + o.idx,
          i = e("#mCSB_" + o.idx + "_container").parent();
        i.bind("scroll." + n, function () {
          (0 === i.scrollTop() && 0 === i.scrollLeft()) ||
            e(".mCSB_" + o.idx + "_scrollbar").css("visibility", "hidden");
        });
      },
      F = function () {
        var t = e(this),
          o = t.data(a),
          n = o.opt,
          i = o.sequential,
          r = a + "_" + o.idx,
          l = ".mCSB_" + o.idx + "_scrollbar",
          s = e(l + ">a");
        s.bind("contextmenu." + r, function (e) {
          e.preventDefault();
        }).bind(
          "mousedown." +
            r +
            " touchstart." +
            r +
            " pointerdown." +
            r +
            " MSPointerDown." +
            r +
            " mouseup." +
            r +
            " touchend." +
            r +
            " pointerup." +
            r +
            " MSPointerUp." +
            r +
            " mouseout." +
            r +
            " pointerout." +
            r +
            " MSPointerOut." +
            r +
            " click." +
            r,
          function (a) {
            function r(e, o) {
              (i.scrollAmount = n.scrollButtons.scrollAmount), j(t, e, o);
            }
            if ((a.preventDefault(), ee(a))) {
              var l = e(this).attr("class");
              switch (((i.type = n.scrollButtons.scrollType), a.type)) {
                case "mousedown":
                case "touchstart":
                case "pointerdown":
                case "MSPointerDown":
                  if ("stepped" === i.type) return;
                  (c = !0), (o.tweenRunning = !1), r("on", l);
                  break;
                case "mouseup":
                case "touchend":
                case "pointerup":
                case "MSPointerUp":
                case "mouseout":
                case "pointerout":
                case "MSPointerOut":
                  if ("stepped" === i.type) return;
                  (c = !1), i.dir && r("off", l);
                  break;
                case "click":
                  if ("stepped" !== i.type || o.tweenRunning) return;
                  r("on", l);
              }
            }
          }
        );
      },
      q = function () {
        function t(t) {
          function a(e, t) {
            (r.type = i.keyboard.scrollType),
              (r.scrollAmount = i.keyboard.scrollAmount),
              ("stepped" === r.type && n.tweenRunning) || j(o, e, t);
          }
          switch (t.type) {
            case "blur":
              n.tweenRunning && r.dir && a("off", null);
              break;
            case "keydown":
            case "keyup":
              var l = t.keyCode ? t.keyCode : t.which,
                s = "on";
              if (
                ("x" !== i.axis && (38 === l || 40 === l)) ||
                ("y" !== i.axis && (37 === l || 39 === l))
              ) {
                if (
                  ((38 === l || 40 === l) && !n.overflowed[0]) ||
                  ((37 === l || 39 === l) && !n.overflowed[1])
                )
                  return;
                "keyup" === t.type && (s = "off"),
                  e(document.activeElement).is(u) ||
                    (t.preventDefault(), t.stopImmediatePropagation(), a(s, l));
              } else if (33 === l || 34 === l) {
                if (
                  ((n.overflowed[0] || n.overflowed[1]) &&
                    (t.preventDefault(), t.stopImmediatePropagation()),
                  "keyup" === t.type)
                ) {
                  Q(o);
                  var f = 34 === l ? -1 : 1;
                  if (
                    "x" === i.axis ||
                    ("yx" === i.axis && n.overflowed[1] && !n.overflowed[0])
                  )
                    var h = "x",
                      m = Math.abs(c[0].offsetLeft) - f * (0.9 * d.width());
                  else
                    var h = "y",
                      m = Math.abs(c[0].offsetTop) - f * (0.9 * d.height());
                  G(o, m.toString(), { dir: h, scrollEasing: "mcsEaseInOut" });
                }
              } else if (
                (35 === l || 36 === l) &&
                !e(document.activeElement).is(u) &&
                ((n.overflowed[0] || n.overflowed[1]) &&
                  (t.preventDefault(), t.stopImmediatePropagation()),
                "keyup" === t.type)
              ) {
                if (
                  "x" === i.axis ||
                  ("yx" === i.axis && n.overflowed[1] && !n.overflowed[0])
                )
                  var h = "x",
                    m = 35 === l ? Math.abs(d.width() - c.outerWidth(!1)) : 0;
                else
                  var h = "y",
                    m = 35 === l ? Math.abs(d.height() - c.outerHeight(!1)) : 0;
                G(o, m.toString(), { dir: h, scrollEasing: "mcsEaseInOut" });
              }
          }
        }
        var o = e(this),
          n = o.data(a),
          i = n.opt,
          r = n.sequential,
          l = a + "_" + n.idx,
          s = e("#mCSB_" + n.idx),
          c = e("#mCSB_" + n.idx + "_container"),
          d = c.parent(),
          u = "input,textarea,select,datalist,keygen,[contenteditable='true']",
          f = c.find("iframe"),
          h = ["blur." + l + " keydown." + l + " keyup." + l];
        f.length &&
          f.each(function () {
            e(this).bind("load", function () {
              A(this) &&
                e(this.contentDocument || this.contentWindow.document).bind(
                  h[0],
                  function (e) {
                    t(e);
                  }
                );
            });
          }),
          s.attr("tabindex", "0").bind(h[0], function (e) {
            t(e);
          });
      },
      j = function (t, o, n, i, r) {
        function l(e) {
          u.snapAmount &&
            (f.scrollAmount =
              u.snapAmount instanceof Array
                ? "x" === f.dir[0]
                  ? u.snapAmount[1]
                  : u.snapAmount[0]
                : u.snapAmount);
          var o = "stepped" !== f.type,
            a = r ? r : e ? (o ? p / 1.5 : g) : 1e3 / 60,
            n = e ? (o ? 7.5 : 40) : 2.5,
            s = [Math.abs(h[0].offsetTop), Math.abs(h[0].offsetLeft)],
            d = [
              c.scrollRatio.y > 10 ? 10 : c.scrollRatio.y,
              c.scrollRatio.x > 10 ? 10 : c.scrollRatio.x,
            ],
            m =
              "x" === f.dir[0]
                ? s[1] + f.dir[1] * (d[1] * n)
                : s[0] + f.dir[1] * (d[0] * n),
            v =
              "x" === f.dir[0]
                ? s[1] + f.dir[1] * parseInt(f.scrollAmount)
                : s[0] + f.dir[1] * parseInt(f.scrollAmount),
            x = "auto" !== f.scrollAmount ? v : m,
            _ = i ? i : e ? (o ? "mcsLinearOut" : "mcsEaseInOut") : "mcsLinear",
            w = !!e;
          return (
            e && 17 > a && (x = "x" === f.dir[0] ? s[1] : s[0]),
            G(t, x.toString(), {
              dir: f.dir[0],
              scrollEasing: _,
              dur: a,
              onComplete: w,
            }),
            e
              ? void (f.dir = !1)
              : (clearTimeout(f.step),
                void (f.step = setTimeout(function () {
                  l();
                }, a)))
          );
        }
        function s() {
          clearTimeout(f.step), $(f, "step"), Q(t);
        }
        var c = t.data(a),
          u = c.opt,
          f = c.sequential,
          h = e("#mCSB_" + c.idx + "_container"),
          m = "stepped" === f.type,
          p = u.scrollInertia < 26 ? 26 : u.scrollInertia,
          g = u.scrollInertia < 1 ? 17 : u.scrollInertia;
        switch (o) {
          case "on":
            if (
              ((f.dir = [
                n === d[16] || n === d[15] || 39 === n || 37 === n ? "x" : "y",
                n === d[13] || n === d[15] || 38 === n || 37 === n ? -1 : 1,
              ]),
              Q(t),
              oe(n) && "stepped" === f.type)
            )
              return;
            l(m);
            break;
          case "off":
            s(), (m || (c.tweenRunning && f.dir)) && l(!0);
        }
      },
      Y = function (t) {
        var o = e(this).data(a).opt,
          n = [];
        return (
          "function" == typeof t && (t = t()),
          t instanceof Array
            ? (n =
                t.length > 1
                  ? [t[0], t[1]]
                  : "x" === o.axis
                  ? [null, t[0]]
                  : [t[0], null])
            : ((n[0] = t.y ? t.y : t.x || "x" === o.axis ? null : t),
              (n[1] = t.x ? t.x : t.y || "y" === o.axis ? null : t)),
          "function" == typeof n[0] && (n[0] = n[0]()),
          "function" == typeof n[1] && (n[1] = n[1]()),
          n
        );
      },
      X = function (t, o) {
        if (null != t && "undefined" != typeof t) {
          var n = e(this),
            i = n.data(a),
            r = i.opt,
            l = e("#mCSB_" + i.idx + "_container"),
            s = l.parent(),
            c = typeof t;
          o || (o = "x" === r.axis ? "x" : "y");
          var d =
              "x" === o
                ? l.outerWidth(!1) - s.width()
                : l.outerHeight(!1) - s.height(),
            f = "x" === o ? l[0].offsetLeft : l[0].offsetTop,
            h = "x" === o ? "left" : "top";
          switch (c) {
            case "function":
              return t();
            case "object":
              var m = t.jquery ? t : e(t);
              if (!m.length) return;
              return "x" === o ? ae(m)[1] : ae(m)[0];
            case "string":
            case "number":
              if (oe(t)) return Math.abs(t);
              if (-1 !== t.indexOf("%"))
                return Math.abs((d * parseInt(t)) / 100);
              if (-1 !== t.indexOf("-="))
                return Math.abs(f - parseInt(t.split("-=")[1]));
              if (-1 !== t.indexOf("+=")) {
                var p = f + parseInt(t.split("+=")[1]);
                return p >= 0 ? 0 : Math.abs(p);
              }
              if (-1 !== t.indexOf("px") && oe(t.split("px")[0]))
                return Math.abs(t.split("px")[0]);
              if ("top" === t || "left" === t) return 0;
              if ("bottom" === t)
                return Math.abs(s.height() - l.outerHeight(!1));
              if ("right" === t) return Math.abs(s.width() - l.outerWidth(!1));
              if ("first" === t || "last" === t) {
                var m = l.find(":" + t);
                return "x" === o ? ae(m)[1] : ae(m)[0];
              }
              return e(t).length
                ? "x" === o
                  ? ae(e(t))[1]
                  : ae(e(t))[0]
                : (l.css(h, t), void u.update.call(null, n[0]));
          }
        }
      },
      N = function (t) {
        function o() {
          return (
            clearTimeout(f[0].autoUpdate),
            0 === l.parents("html").length
              ? void (l = null)
              : void (f[0].autoUpdate = setTimeout(function () {
                  return c.advanced.updateOnSelectorChange &&
                    ((s.poll.change.n = i()),
                    s.poll.change.n !== s.poll.change.o)
                    ? ((s.poll.change.o = s.poll.change.n), void r(3))
                    : c.advanced.updateOnContentResize &&
                      ((s.poll.size.n =
                        l[0].scrollHeight +
                        l[0].scrollWidth +
                        f[0].offsetHeight +
                        l[0].offsetHeight +
                        l[0].offsetWidth),
                      s.poll.size.n !== s.poll.size.o)
                    ? ((s.poll.size.o = s.poll.size.n), void r(1))
                    : !c.advanced.updateOnImageLoad ||
                      ("auto" === c.advanced.updateOnImageLoad &&
                        "y" === c.axis) ||
                      ((s.poll.img.n = f.find("img").length),
                      s.poll.img.n === s.poll.img.o)
                    ? void (
                        (c.advanced.updateOnSelectorChange ||
                          c.advanced.updateOnContentResize ||
                          c.advanced.updateOnImageLoad) &&
                        o()
                      )
                    : ((s.poll.img.o = s.poll.img.n),
                      void f.find("img").each(function () {
                        n(this);
                      }));
                }, c.advanced.autoUpdateTimeout))
          );
        }
        function n(t) {
          function o(e, t) {
            return function () {
              return t.apply(e, arguments);
            };
          }
          function a() {
            (this.onload = null), e(t).addClass(d[2]), r(2);
          }
          if (e(t).hasClass(d[2])) return void r();
          var n = new Image();
          (n.onload = o(n, a)), (n.src = t.src);
        }
        function i() {
          c.advanced.updateOnSelectorChange === !0 &&
            (c.advanced.updateOnSelectorChange = "*");
          var e = 0,
            t = f.find(c.advanced.updateOnSelectorChange);
          return (
            c.advanced.updateOnSelectorChange &&
              t.length > 0 &&
              t.each(function () {
                e += this.offsetHeight + this.offsetWidth;
              }),
            e
          );
        }
        function r(e) {
          clearTimeout(f[0].autoUpdate), u.update.call(null, l[0], e);
        }
        var l = e(this),
          s = l.data(a),
          c = s.opt,
          f = e("#mCSB_" + s.idx + "_container");
        return t
          ? (clearTimeout(f[0].autoUpdate), void $(f[0], "autoUpdate"))
          : void o();
      },
      V = function (e, t, o) {
        return Math.round(e / t) * t - o;
      },
      Q = function (t) {
        var o = t.data(a),
          n = e(
            "#mCSB_" +
              o.idx +
              "_container,#mCSB_" +
              o.idx +
              "_container_wrapper,#mCSB_" +
              o.idx +
              "_dragger_vertical,#mCSB_" +
              o.idx +
              "_dragger_horizontal"
          );
        n.each(function () {
          Z.call(this);
        });
      },
      G = function (t, o, n) {
        function i(e) {
          return s && c.callbacks[e] && "function" == typeof c.callbacks[e];
        }
        function r() {
          return [
            c.callbacks.alwaysTriggerOffsets || w >= S[0] + y,
            c.callbacks.alwaysTriggerOffsets || -B >= w,
          ];
        }
        function l() {
          var e = [h[0].offsetTop, h[0].offsetLeft],
            o = [x[0].offsetTop, x[0].offsetLeft],
            a = [h.outerHeight(!1), h.outerWidth(!1)],
            i = [f.height(), f.width()];
          t[0].mcs = {
            content: h,
            top: e[0],
            left: e[1],
            draggerTop: o[0],
            draggerLeft: o[1],
            topPct: Math.round(
              (100 * Math.abs(e[0])) / (Math.abs(a[0]) - i[0])
            ),
            leftPct: Math.round(
              (100 * Math.abs(e[1])) / (Math.abs(a[1]) - i[1])
            ),
            direction: n.dir,
          };
        }
        var s = t.data(a),
          c = s.opt,
          d = {
            trigger: "internal",
            dir: "y",
            scrollEasing: "mcsEaseOut",
            drag: !1,
            dur: c.scrollInertia,
            overwrite: "all",
            callbacks: !0,
            onStart: !0,
            onUpdate: !0,
            onComplete: !0,
          },
          n = e.extend(d, n),
          u = [n.dur, n.drag ? 0 : n.dur],
          f = e("#mCSB_" + s.idx),
          h = e("#mCSB_" + s.idx + "_container"),
          m = h.parent(),
          p = c.callbacks.onTotalScrollOffset
            ? Y.call(t, c.callbacks.onTotalScrollOffset)
            : [0, 0],
          g = c.callbacks.onTotalScrollBackOffset
            ? Y.call(t, c.callbacks.onTotalScrollBackOffset)
            : [0, 0];
        if (
          ((s.trigger = n.trigger),
          (0 === m.scrollTop() && 0 === m.scrollLeft()) ||
            (e(".mCSB_" + s.idx + "_scrollbar").css("visibility", "visible"),
            m.scrollTop(0).scrollLeft(0)),
          "_resetY" !== o ||
            s.contentReset.y ||
            (i("onOverflowYNone") && c.callbacks.onOverflowYNone.call(t[0]),
            (s.contentReset.y = 1)),
          "_resetX" !== o ||
            s.contentReset.x ||
            (i("onOverflowXNone") && c.callbacks.onOverflowXNone.call(t[0]),
            (s.contentReset.x = 1)),
          "_resetY" !== o && "_resetX" !== o)
        ) {
          if (
            ((!s.contentReset.y && t[0].mcs) ||
              !s.overflowed[0] ||
              (i("onOverflowY") && c.callbacks.onOverflowY.call(t[0]),
              (s.contentReset.x = null)),
            (!s.contentReset.x && t[0].mcs) ||
              !s.overflowed[1] ||
              (i("onOverflowX") && c.callbacks.onOverflowX.call(t[0]),
              (s.contentReset.x = null)),
            c.snapAmount)
          ) {
            var v =
              c.snapAmount instanceof Array
                ? "x" === n.dir
                  ? c.snapAmount[1]
                  : c.snapAmount[0]
                : c.snapAmount;
            o = V(o, v, c.snapOffset);
          }
          switch (n.dir) {
            case "x":
              var x = e("#mCSB_" + s.idx + "_dragger_horizontal"),
                _ = "left",
                w = h[0].offsetLeft,
                S = [
                  f.width() - h.outerWidth(!1),
                  x.parent().width() - x.width(),
                ],
                b = [o, 0 === o ? 0 : o / s.scrollRatio.x],
                y = p[1],
                B = g[1],
                T = y > 0 ? y / s.scrollRatio.x : 0,
                k = B > 0 ? B / s.scrollRatio.x : 0;
              break;
            case "y":
              var x = e("#mCSB_" + s.idx + "_dragger_vertical"),
                _ = "top",
                w = h[0].offsetTop,
                S = [
                  f.height() - h.outerHeight(!1),
                  x.parent().height() - x.height(),
                ],
                b = [o, 0 === o ? 0 : o / s.scrollRatio.y],
                y = p[0],
                B = g[0],
                T = y > 0 ? y / s.scrollRatio.y : 0,
                k = B > 0 ? B / s.scrollRatio.y : 0;
          }
          b[1] < 0 || (0 === b[0] && 0 === b[1])
            ? (b = [0, 0])
            : b[1] >= S[1]
            ? (b = [S[0], S[1]])
            : (b[0] = -b[0]),
            t[0].mcs || (l(), i("onInit") && c.callbacks.onInit.call(t[0])),
            clearTimeout(h[0].onCompleteTimeout),
            J(x[0], _, Math.round(b[1]), u[1], n.scrollEasing),
            (!s.tweenRunning &&
              ((0 === w && b[0] >= 0) || (w === S[0] && b[0] <= S[0]))) ||
              J(h[0], _, Math.round(b[0]), u[0], n.scrollEasing, n.overwrite, {
                onStart: function () {
                  n.callbacks &&
                    n.onStart &&
                    !s.tweenRunning &&
                    (i("onScrollStart") &&
                      (l(), c.callbacks.onScrollStart.call(t[0])),
                    (s.tweenRunning = !0),
                    C(x),
                    (s.cbOffsets = r()));
                },
                onUpdate: function () {
                  n.callbacks &&
                    n.onUpdate &&
                    i("whileScrolling") &&
                    (l(), c.callbacks.whileScrolling.call(t[0]));
                },
                onComplete: function () {
                  if (n.callbacks && n.onComplete) {
                    "yx" === c.axis && clearTimeout(h[0].onCompleteTimeout);
                    var e = h[0].idleTimer || 0;
                    h[0].onCompleteTimeout = setTimeout(function () {
                      i("onScroll") && (l(), c.callbacks.onScroll.call(t[0])),
                        i("onTotalScroll") &&
                          b[1] >= S[1] - T &&
                          s.cbOffsets[0] &&
                          (l(), c.callbacks.onTotalScroll.call(t[0])),
                        i("onTotalScrollBack") &&
                          b[1] <= k &&
                          s.cbOffsets[1] &&
                          (l(), c.callbacks.onTotalScrollBack.call(t[0])),
                        (s.tweenRunning = !1),
                        (h[0].idleTimer = 0),
                        C(x, "hide");
                    }, e);
                  }
                },
              });
        }
      },
      J = function (e, t, o, a, n, i, r) {
        function l() {
          S.stop ||
            (x || m.call(),
            (x = K() - v),
            s(),
            x >= S.time &&
              ((S.time = x > S.time ? x + f - (x - S.time) : x + f - 1),
              S.time < x + 1 && (S.time = x + 1)),
            S.time < a ? (S.id = h(l)) : g.call());
        }
        function s() {
          a > 0
            ? ((S.currVal = u(S.time, _, b, a, n)),
              (w[t] = Math.round(S.currVal) + "px"))
            : (w[t] = o + "px"),
            p.call();
        }
        function c() {
          (f = 1e3 / 60),
            (S.time = x + f),
            (h = window.requestAnimationFrame
              ? window.requestAnimationFrame
              : function (e) {
                  return s(), setTimeout(e, 0.01);
                }),
            (S.id = h(l));
        }
        function d() {
          null != S.id &&
            (window.requestAnimationFrame
              ? window.cancelAnimationFrame(S.id)
              : clearTimeout(S.id),
            (S.id = null));
        }
        function u(e, t, o, a, n) {
          switch (n) {
            case "linear":
            case "mcsLinear":
              return (o * e) / a + t;
            case "mcsLinearOut":
              return (e /= a), e--, o * Math.sqrt(1 - e * e) + t;
            case "easeInOutSmooth":
              return (
                (e /= a / 2),
                1 > e
                  ? (o / 2) * e * e + t
                  : (e--, (-o / 2) * (e * (e - 2) - 1) + t)
              );
            case "easeInOutStrong":
              return (
                (e /= a / 2),
                1 > e
                  ? (o / 2) * Math.pow(2, 10 * (e - 1)) + t
                  : (e--, (o / 2) * (-Math.pow(2, -10 * e) + 2) + t)
              );
            case "easeInOut":
            case "mcsEaseInOut":
              return (
                (e /= a / 2),
                1 > e
                  ? (o / 2) * e * e * e + t
                  : ((e -= 2), (o / 2) * (e * e * e + 2) + t)
              );
            case "easeOutSmooth":
              return (e /= a), e--, -o * (e * e * e * e - 1) + t;
            case "easeOutStrong":
              return o * (-Math.pow(2, (-10 * e) / a) + 1) + t;
            case "easeOut":
            case "mcsEaseOut":
            default:
              var i = (e /= a) * e,
                r = i * e;
              return (
                t +
                o *
                  (0.499999999999997 * r * i +
                    -2.5 * i * i +
                    5.5 * r +
                    -6.5 * i +
                    4 * e)
              );
          }
        }
        e._mTween || (e._mTween = { top: {}, left: {} });
        var f,
          h,
          r = r || {},
          m = r.onStart || function () {},
          p = r.onUpdate || function () {},
          g = r.onComplete || function () {},
          v = K(),
          x = 0,
          _ = e.offsetTop,
          w = e.style,
          S = e._mTween[t];
        "left" === t && (_ = e.offsetLeft);
        var b = o - _;
        (S.stop = 0), "none" !== i && d(), c();
      },
      K = function () {
        return window.performance && window.performance.now
          ? window.performance.now()
          : window.performance && window.performance.webkitNow
          ? window.performance.webkitNow()
          : Date.now
          ? Date.now()
          : new Date().getTime();
      },
      Z = function () {
        var e = this;
        e._mTween || (e._mTween = { top: {}, left: {} });
        for (var t = ["top", "left"], o = 0; o < t.length; o++) {
          var a = t[o];
          e._mTween[a].id &&
            (window.requestAnimationFrame
              ? window.cancelAnimationFrame(e._mTween[a].id)
              : clearTimeout(e._mTween[a].id),
            (e._mTween[a].id = null),
            (e._mTween[a].stop = 1));
        }
      },
      $ = function (e, t) {
        try {
          delete e[t];
        } catch (o) {
          e[t] = null;
        }
      },
      ee = function (e) {
        return !(e.which && 1 !== e.which);
      },
      te = function (e) {
        var t = e.originalEvent.pointerType;
        return !(t && "touch" !== t && 2 !== t);
      },
      oe = function (e) {
        return !isNaN(parseFloat(e)) && isFinite(e);
      },
      ae = function (e) {
        var t = e.parents(".mCSB_container");
        return [
          e.offset().top - t.offset().top,
          e.offset().left - t.offset().left,
        ];
      },
      ne = function () {
        function e() {
          var e = ["webkit", "moz", "ms", "o"];
          if ("hidden" in document) return "hidden";
          for (var t = 0; t < e.length; t++)
            if (e[t] + "Hidden" in document) return e[t] + "Hidden";
          return null;
        }
        var t = e();
        return t ? document[t] : !1;
      };
    (e.fn[o] = function (t) {
      return u[t]
        ? u[t].apply(this, Array.prototype.slice.call(arguments, 1))
        : "object" != typeof t && t
        ? void e.error("Method " + t + " does not exist")
        : u.init.apply(this, arguments);
    }),
      (e[o] = function (t) {
        return u[t]
          ? u[t].apply(this, Array.prototype.slice.call(arguments, 1))
          : "object" != typeof t && t
          ? void e.error("Method " + t + " does not exist")
          : u.init.apply(this, arguments);
      }),
      (e[o].defaults = i),
      (window[o] = !0),
      e(window).bind("load", function () {
        e(n)[o](),
          e.extend(e.expr[":"], {
            mcsInView:
              e.expr[":"].mcsInView ||
              function (t) {
                var o,
                  a,
                  n = e(t),
                  i = n.parents(".mCSB_container");
                if (i.length)
                  return (
                    (o = i.parent()),
                    (a = [i[0].offsetTop, i[0].offsetLeft]),
                    a[0] + ae(n)[0] >= 0 &&
                      a[0] + ae(n)[0] < o.height() - n.outerHeight(!1) &&
                      a[1] + ae(n)[1] >= 0 &&
                      a[1] + ae(n)[1] < o.width() - n.outerWidth(!1)
                  );
              },
            mcsInSight:
              e.expr[":"].mcsInSight ||
              function (t, o, a) {
                var n,
                  i,
                  r,
                  l,
                  s = e(t),
                  c = s.parents(".mCSB_container"),
                  d =
                    "exact" === a[3]
                      ? [
                          [1, 0],
                          [1, 0],
                        ]
                      : [
                          [0.9, 0.1],
                          [0.6, 0.4],
                        ];
                if (c.length)
                  return (
                    (n = [s.outerHeight(!1), s.outerWidth(!1)]),
                    (r = [
                      c[0].offsetTop + ae(s)[0],
                      c[0].offsetLeft + ae(s)[1],
                    ]),
                    (i = [
                      c.parent()[0].offsetHeight,
                      c.parent()[0].offsetWidth,
                    ]),
                    (l = [
                      n[0] < i[0] ? d[0] : d[1],
                      n[1] < i[1] ? d[0] : d[1],
                    ]),
                    r[0] - i[0] * l[0][0] < 0 &&
                      r[0] + n[0] - i[0] * l[0][1] >= 0 &&
                      r[1] - i[1] * l[1][0] < 0 &&
                      r[1] + n[1] - i[1] * l[1][1] >= 0
                  );
              },
            mcsOverflow:
              e.expr[":"].mcsOverflow ||
              function (t) {
                var o = e(t).data(a);
                if (o) return o.overflowed[0] || o.overflowed[1];
              },
          });
      });
  });
});

$("#content-6").mCustomScrollbar({
  axis: "x",
  theme: "light-3",
  advanced: { autoExpandHorizontalScroll: true },
});

$(".content_loop").mCustomScrollbar({
  axis: "x",
  theme: "light-3",
  advanced: { autoExpandHorizontalScroll: true },
});

/* value of good */
$(".Page_value_of_good_title_image_rightside_allslide_new").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 4000,
  infinite: true,
  fade: true,
  dots: false,
  arrows: false,
});

/* Careers */
$(".accordion .question").click(function () {
  if ($(this).parent(".accordion li").hasClass("open") == false) {
    $(".accordion .answer").slideUp();
    $(".accordion li").removeClass("open");

    $(this).next(".answer").slideDown();
    $(this).parent(".accordion li").addClass("open");
  } else {
    $(".accordion .answer").slideUp();
    $(".accordion li").removeClass("open");
  }
});

// About us page circle tab script
window.onload = function () {
  let container = $("#our-history"),
    $li = container.find("[js-header-tab-item]"),
    liWidth = $li.first().outerWidth(),
    liHeight = $li.first().outerHeight(),
    liNum = $li.length,
    $contentbox = container.find("[js-circle-body-tab]"),
    fullwidth = container.data("fullwidth"),
    rotation = container.data("rotation"),
    rotationRadius = container.data("rotation-radius"),
    rotationWapperDeg = container.data("rotation-wrapper-angle"),
    rotationDisplay = container.data("rotation-display"),
    tabBoxID = 1;

  if ($(document).width() < 992) {
    rotationRadius = 230;
  }
  if ($(document).width() < 561) {
    rotationRadius = 145;
  }

  if (typeof fullwidth != typeof undefined && fullwidth == 1) {
    $li.css("width", 100 / liNum + "%");
  }

  if (typeof rotation === typeof undefined) {
    rotation = false;
  }

  if (typeof rotationWapperDeg === typeof undefined) {
    rotationWapperDeg = 0;
  }

  if (typeof rotationDisplay === typeof undefined) {
    rotationDisplay = 5;
  }

  $li.each(function (index) {
    index = index + 1;
    $(this).attr("href", "javascript:");
    $(this).attr("data-tab", tabBoxID + "-tabs-show" + index);
  });
  $($contentbox).each(function (index) {
    index = index + 1;
    $(this).attr("id", tabBoxID + "-tabs-show" + index);
  });

  // Tab Rotation Effect
  if (rotation) {
    container.find("[js-header-tab-list-wrapper]").css({
      width: rotationRadius * 2 + "px",
    });

    container.find("ul").css({
      width: rotationRadius * 2 + "px",
      height: rotationRadius * 2 + "px",
      transform: "rotate(" + parseFloat(rotationWapperDeg) + "deg)",
    });

    //Layout components in a circle layout
    var angle = 0,
      step = (2 * Math.PI) / rotationDisplay,
      transitionDelay = 0,
      pad = container.find("ul").width();

    container.find("[js-header-tab-item]").each(function () {
      //Can'nt use arrow function here!!!
      // 'this' works differently with arrow fucntions
      var el = $(this),
        x = rotationRadius * Math.cos(angle) - liWidth / 2,
        y = rotationRadius * Math.sin(angle) - liHeight / 2;

      el.css({
        transform:
          "translate(" +
          parseFloat(x) +
          "px," +
          parseFloat(pad / 2 + y) +
          "px)",
        "transition-delay": transitionDelay + "s",
      })
        .find("> [js-header-tab-text]")
        .css({
          transform: "rotate(" + parseFloat(-rotationWapperDeg) + "deg)",
        });

      angle += step;
      transitionDelay += 0.15;

      //Click on the rotation effect
      //----------------------- begin ----------------------
      el.on("click", function (e) {
        var increase = (Math.PI * 2) / rotationDisplay,
          n = $(this).index(),
          endAngle = (n % rotationDisplay) * increase;

        (function turn() {
          if (Math.abs(endAngle - angle) > 1 / 8) {
            var sign = endAngle > angle ? 1 : -1;
            angle = angle + sign / 8;
            setTimeout(turn, 20);
          } else {
            angle = endAngle;
          }

          container.find("[js-header-tab-item]").each(function (index) {
            var x2 =
                Math.cos(-Math.PI / 2 + index * increase - angle) *
                  rotationRadius -
                liWidth / 2,
              y2 =
                Math.sin(-Math.PI / 2 + index * increase - angle) *
                  rotationRadius +
                liHeight;

            $(this)
              .css({
                transform:
                  "translate(" +
                  parseFloat(x2) +
                  "px," +
                  parseFloat(y2) +
                  "px)",
                transition: "none",
                "transition-delay": 0,
              })
              .find("> [js-header-tab-text]")
              .css({
                transform: "rotate(" + parseFloat(-rotationWapperDeg) + "deg)",
              });
          });
        })();
      });
      //----------------------- end ----------------------
    });
  }

  // Tab Fade Effect
  container.on("click", "[js-header-tab-item]", function (e) {
    var tabID = $(this).attr("data-tab");

    container.find("[js-header-tab-item]").removeClass("active");

    container.find("[js-circle-body-tab]").removeClass("active");

    $(this).addClass("active");
    $("#" + tabID).addClass("active");

    if ($("body").hasClass("fix-about")) {
      $("html, body").animate(
        {
          scrollTop:
            $(".tab-grid").offset().top +
            $("[js-header-tab-list]").height() / 2.4,
        },
        "slow"
      );
    }

    return false;
  });

  // Init
  container.find(".active[js-header-tab-item]").trigger("click");

  //Active current tab
  var url = window.location.href,
    locArr,
    loc,
    curTab;

  if (url.indexOf("#") >= 0) {
    locArr = url.split("#");
    loc = locArr[1];
    curTab = $(".uix-tabs").find("ul > li:eq(" + loc + ")");
    curTab.trigger("click");
  }
};

/*-- FIX_slider_about_START --*/
$(window).load(function () {
  $(".circle-tab-header").css(
    "min-height",
    $(".circle-tab-header").height() + "px"
  );
  var $el = $(".our-history-contents"); //record the elem so you don't crawl the DOM everytime
  if ($el.length > 0) {
    var stickyHeaderTop =
      $el.offset().top + $el.height() + 12 - $("#SiteHeader").height(); // passing "true" will also include the top and bottom margin
    //var stickyHeaderTop = top_part + 90;
    console.log(stickyHeaderTop);
  }
  $(window).scroll(function () {
    if ($(window).scrollTop() > stickyHeaderTop) {
      if ($("body").hasClass("fix-about") == false) {
        $("body").addClass("fix-about");
      }
    } else {
      $("body").removeClass("fix-about");
    }
  });
});
/*-- FIX_slider_about_START --*/

/*-- FIX_slider_about_START --*/
$(window).load(function () {
  $(".Page_about_us_value_slider_new").css(
    "min-height",
    $(".Page_about_us_value_slider_new").height() + "px"
  );
  var $el_1 = $(".Page_about_us_value_slider_new"); //record the elem so you don't crawl the DOM everytime
  if ($el_1.length > 0) {
    var stickyHeaderTop_1 =
      $el_1.offset().top + $el.height() - 15 - $("#SiteHeader").height(); // passing "true" will also include the top and bottom margin
    //var stickyHeaderTop = top_part + 90;
    console.log(stickyHeaderTop_1);
  }
  $(window).scroll(function () {
    if ($(window).scrollTop() > stickyHeaderTop_1) {
      if ($("body").hasClass("fix-about-2") == false) {
        $("body").addClass("fix-about-2");
      }
    } else {
      $("body").removeClass("fix-about-2");
    }
  });
});
/*-- FIX_slider_about_START --*/

/* Masonary */

$(window).load(function () {
  /*!
   * Masonry PACKAGED v4.2.2
   */
  !(function (t, e) {
    "function" == typeof define && define.amd
      ? define("jquery-bridget/jquery-bridget", ["jquery"], function (i) {
          return e(t, i);
        })
      : "object" == typeof module && module.exports
      ? (module.exports = e(t, require("jquery")))
      : (t.jQueryBridget = e(t, t.jQuery));
  })(window, function (t, e) {
    "use strict";
    function i(i, r, a) {
      function h(t, e, n) {
        var o,
          r = "$()." + i + '("' + e + '")';
        return (
          t.each(function (t, h) {
            var u = a.data(h, i);
            if (!u)
              return void s(
                i + " not initialized. Cannot call methods, i.e. " + r
              );
            var d = u[e];
            if (!d || "_" == e.charAt(0))
              return void s(r + " is not a valid method");
            var l = d.apply(u, n);
            o = void 0 === o ? l : o;
          }),
          void 0 !== o ? o : t
        );
      }
      function u(t, e) {
        t.each(function (t, n) {
          var o = a.data(n, i);
          o ? (o.option(e), o._init()) : ((o = new r(n, e)), a.data(n, i, o));
        });
      }
      (a = a || e || t.jQuery),
        a &&
          (r.prototype.option ||
            (r.prototype.option = function (t) {
              a.isPlainObject(t) &&
                (this.options = a.extend(!0, this.options, t));
            }),
          (a.fn[i] = function (t) {
            if ("string" == typeof t) {
              var e = o.call(arguments, 1);
              return h(this, t, e);
            }
            return u(this, t), this;
          }),
          n(a));
    }
    function n(t) {
      !t || (t && t.bridget) || (t.bridget = i);
    }
    var o = Array.prototype.slice,
      r = t.console,
      s =
        "undefined" == typeof r
          ? function () {}
          : function (t) {
              r.error(t);
            };
    return n(e || t.jQuery), i;
  }),
    (function (t, e) {
      "function" == typeof define && define.amd
        ? define("ev-emitter/ev-emitter", e)
        : "object" == typeof module && module.exports
        ? (module.exports = e())
        : (t.EvEmitter = e());
    })("undefined" != typeof window ? window : this, function () {
      function t() {}
      var e = t.prototype;
      return (
        (e.on = function (t, e) {
          if (t && e) {
            var i = (this._events = this._events || {}),
              n = (i[t] = i[t] || []);
            return -1 == n.indexOf(e) && n.push(e), this;
          }
        }),
        (e.once = function (t, e) {
          if (t && e) {
            this.on(t, e);
            var i = (this._onceEvents = this._onceEvents || {}),
              n = (i[t] = i[t] || {});
            return (n[e] = !0), this;
          }
        }),
        (e.off = function (t, e) {
          var i = this._events && this._events[t];
          if (i && i.length) {
            var n = i.indexOf(e);
            return -1 != n && i.splice(n, 1), this;
          }
        }),
        (e.emitEvent = function (t, e) {
          var i = this._events && this._events[t];
          if (i && i.length) {
            (i = i.slice(0)), (e = e || []);
            for (
              var n = this._onceEvents && this._onceEvents[t], o = 0;
              o < i.length;
              o++
            ) {
              var r = i[o],
                s = n && n[r];
              s && (this.off(t, r), delete n[r]), r.apply(this, e);
            }
            return this;
          }
        }),
        (e.allOff = function () {
          delete this._events, delete this._onceEvents;
        }),
        t
      );
    }),
    (function (t, e) {
      "function" == typeof define && define.amd
        ? define("get-size/get-size", e)
        : "object" == typeof module && module.exports
        ? (module.exports = e())
        : (t.getSize = e());
    })(window, function () {
      "use strict";
      function t(t) {
        var e = parseFloat(t),
          i = -1 == t.indexOf("%") && !isNaN(e);
        return i && e;
      }
      function e() {}
      function i() {
        for (
          var t = {
              width: 0,
              height: 0,
              innerWidth: 0,
              innerHeight: 0,
              outerWidth: 0,
              outerHeight: 0,
            },
            e = 0;
          u > e;
          e++
        ) {
          var i = h[e];
          t[i] = 0;
        }
        return t;
      }
      function n(t) {
        var e = getComputedStyle(t);
        return (
          e ||
            a(
              "Style returned " +
                e +
                ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"
            ),
          e
        );
      }
      function o() {
        if (!d) {
          d = !0;
          var e = document.createElement("div");
          (e.style.width = "200px"),
            (e.style.padding = "1px 2px 3px 4px"),
            (e.style.borderStyle = "solid"),
            (e.style.borderWidth = "1px 2px 3px 4px"),
            (e.style.boxSizing = "border-box");
          var i = document.body || document.documentElement;
          i.appendChild(e);
          var o = n(e);
          (s = 200 == Math.round(t(o.width))),
            (r.isBoxSizeOuter = s),
            i.removeChild(e);
        }
      }
      function r(e) {
        if (
          (o(),
          "string" == typeof e && (e = document.querySelector(e)),
          e && "object" == typeof e && e.nodeType)
        ) {
          var r = n(e);
          if ("none" == r.display) return i();
          var a = {};
          (a.width = e.offsetWidth), (a.height = e.offsetHeight);
          for (
            var d = (a.isBorderBox = "border-box" == r.boxSizing), l = 0;
            u > l;
            l++
          ) {
            var c = h[l],
              f = r[c],
              m = parseFloat(f);
            a[c] = isNaN(m) ? 0 : m;
          }
          var p = a.paddingLeft + a.paddingRight,
            g = a.paddingTop + a.paddingBottom,
            y = a.marginLeft + a.marginRight,
            v = a.marginTop + a.marginBottom,
            _ = a.borderLeftWidth + a.borderRightWidth,
            z = a.borderTopWidth + a.borderBottomWidth,
            E = d && s,
            b = t(r.width);
          b !== !1 && (a.width = b + (E ? 0 : p + _));
          var x = t(r.height);
          return (
            x !== !1 && (a.height = x + (E ? 0 : g + z)),
            (a.innerWidth = a.width - (p + _)),
            (a.innerHeight = a.height - (g + z)),
            (a.outerWidth = a.width + y),
            (a.outerHeight = a.height + v),
            a
          );
        }
      }
      var s,
        a =
          "undefined" == typeof console
            ? e
            : function (t) {
                console.error(t);
              },
        h = [
          "paddingLeft",
          "paddingRight",
          "paddingTop",
          "paddingBottom",
          "marginLeft",
          "marginRight",
          "marginTop",
          "marginBottom",
          "borderLeftWidth",
          "borderRightWidth",
          "borderTopWidth",
          "borderBottomWidth",
        ],
        u = h.length,
        d = !1;
      return r;
    }),
    (function (t, e) {
      "use strict";
      "function" == typeof define && define.amd
        ? define("desandro-matches-selector/matches-selector", e)
        : "object" == typeof module && module.exports
        ? (module.exports = e())
        : (t.matchesSelector = e());
    })(window, function () {
      "use strict";
      var t = (function () {
        var t = window.Element.prototype;
        if (t.matches) return "matches";
        if (t.matchesSelector) return "matchesSelector";
        for (var e = ["webkit", "moz", "ms", "o"], i = 0; i < e.length; i++) {
          var n = e[i],
            o = n + "MatchesSelector";
          if (t[o]) return o;
        }
      })();
      return function (e, i) {
        return e[t](i);
      };
    }),
    (function (t, e) {
      "function" == typeof define && define.amd
        ? define(
            "fizzy-ui-utils/utils",
            ["desandro-matches-selector/matches-selector"],
            function (i) {
              return e(t, i);
            }
          )
        : "object" == typeof module && module.exports
        ? (module.exports = e(t, require("desandro-matches-selector")))
        : (t.fizzyUIUtils = e(t, t.matchesSelector));
    })(window, function (t, e) {
      var i = {};
      (i.extend = function (t, e) {
        for (var i in e) t[i] = e[i];
        return t;
      }),
        (i.modulo = function (t, e) {
          return ((t % e) + e) % e;
        });
      var n = Array.prototype.slice;
      (i.makeArray = function (t) {
        if (Array.isArray(t)) return t;
        if (null === t || void 0 === t) return [];
        var e = "object" == typeof t && "number" == typeof t.length;
        return e ? n.call(t) : [t];
      }),
        (i.removeFrom = function (t, e) {
          var i = t.indexOf(e);
          -1 != i && t.splice(i, 1);
        }),
        (i.getParent = function (t, i) {
          for (; t.parentNode && t != document.body; )
            if (((t = t.parentNode), e(t, i))) return t;
        }),
        (i.getQueryElement = function (t) {
          return "string" == typeof t ? document.querySelector(t) : t;
        }),
        (i.handleEvent = function (t) {
          var e = "on" + t.type;
          this[e] && this[e](t);
        }),
        (i.filterFindElements = function (t, n) {
          t = i.makeArray(t);
          var o = [];
          return (
            t.forEach(function (t) {
              if (t instanceof HTMLElement) {
                if (!n) return void o.push(t);
                e(t, n) && o.push(t);
                for (var i = t.querySelectorAll(n), r = 0; r < i.length; r++)
                  o.push(i[r]);
              }
            }),
            o
          );
        }),
        (i.debounceMethod = function (t, e, i) {
          i = i || 100;
          var n = t.prototype[e],
            o = e + "Timeout";
          t.prototype[e] = function () {
            var t = this[o];
            clearTimeout(t);
            var e = arguments,
              r = this;
            this[o] = setTimeout(function () {
              n.apply(r, e), delete r[o];
            }, i);
          };
        }),
        (i.docReady = function (t) {
          var e = document.readyState;
          "complete" == e || "interactive" == e
            ? setTimeout(t)
            : document.addEventListener("DOMContentLoaded", t);
        }),
        (i.toDashed = function (t) {
          return t
            .replace(/(.)([A-Z])/g, function (t, e, i) {
              return e + "-" + i;
            })
            .toLowerCase();
        });
      var o = t.console;
      return (
        (i.htmlInit = function (e, n) {
          i.docReady(function () {
            var r = i.toDashed(n),
              s = "data-" + r,
              a = document.querySelectorAll("[" + s + "]"),
              h = document.querySelectorAll(".js-" + r),
              u = i.makeArray(a).concat(i.makeArray(h)),
              d = s + "-options",
              l = t.jQuery;
            u.forEach(function (t) {
              var i,
                r = t.getAttribute(s) || t.getAttribute(d);
              try {
                i = r && JSON.parse(r);
              } catch (a) {
                return void (
                  o &&
                  o.error(
                    "Error parsing " + s + " on " + t.className + ": " + a
                  )
                );
              }
              var h = new e(t, i);
              l && l.data(t, n, h);
            });
          });
        }),
        i
      );
    }),
    (function (t, e) {
      "function" == typeof define && define.amd
        ? define(
            "outlayer/item",
            ["ev-emitter/ev-emitter", "get-size/get-size"],
            e
          )
        : "object" == typeof module && module.exports
        ? (module.exports = e(require("ev-emitter"), require("get-size")))
        : ((t.Outlayer = {}), (t.Outlayer.Item = e(t.EvEmitter, t.getSize)));
    })(window, function (t, e) {
      "use strict";
      function i(t) {
        for (var e in t) return !1;
        return (e = null), !0;
      }
      function n(t, e) {
        t &&
          ((this.element = t),
          (this.layout = e),
          (this.position = { x: 0, y: 0 }),
          this._create());
      }
      function o(t) {
        return t.replace(/([A-Z])/g, function (t) {
          return "-" + t.toLowerCase();
        });
      }
      var r = document.documentElement.style,
        s = "string" == typeof r.transition ? "transition" : "WebkitTransition",
        a = "string" == typeof r.transform ? "transform" : "WebkitTransform",
        h = {
          WebkitTransition: "webkitTransitionEnd",
          transition: "transitionend",
        }[s],
        u = {
          transform: a,
          transition: s,
          transitionDuration: s + "Duration",
          transitionProperty: s + "Property",
          transitionDelay: s + "Delay",
        },
        d = (n.prototype = Object.create(t.prototype));
      (d.constructor = n),
        (d._create = function () {
          (this._transn = { ingProperties: {}, clean: {}, onEnd: {} }),
            this.css({ position: "absolute" });
        }),
        (d.handleEvent = function (t) {
          var e = "on" + t.type;
          this[e] && this[e](t);
        }),
        (d.getSize = function () {
          this.size = e(this.element);
        }),
        (d.css = function (t) {
          var e = this.element.style;
          for (var i in t) {
            var n = u[i] || i;
            e[n] = t[i];
          }
        }),
        (d.getPosition = function () {
          var t = getComputedStyle(this.element),
            e = this.layout._getOption("originLeft"),
            i = this.layout._getOption("originTop"),
            n = t[e ? "left" : "right"],
            o = t[i ? "top" : "bottom"],
            r = parseFloat(n),
            s = parseFloat(o),
            a = this.layout.size;
          -1 != n.indexOf("%") && (r = (r / 100) * a.width),
            -1 != o.indexOf("%") && (s = (s / 100) * a.height),
            (r = isNaN(r) ? 0 : r),
            (s = isNaN(s) ? 0 : s),
            (r -= e ? a.paddingLeft : a.paddingRight),
            (s -= i ? a.paddingTop : a.paddingBottom),
            (this.position.x = r),
            (this.position.y = s);
        }),
        (d.layoutPosition = function () {
          var t = this.layout.size,
            e = {},
            i = this.layout._getOption("originLeft"),
            n = this.layout._getOption("originTop"),
            o = i ? "paddingLeft" : "paddingRight",
            r = i ? "left" : "right",
            s = i ? "right" : "left",
            a = this.position.x + t[o];
          (e[r] = this.getXValue(a)), (e[s] = "");
          var h = n ? "paddingTop" : "paddingBottom",
            u = n ? "top" : "bottom",
            d = n ? "bottom" : "top",
            l = this.position.y + t[h];
          (e[u] = this.getYValue(l)),
            (e[d] = ""),
            this.css(e),
            this.emitEvent("layout", [this]);
        }),
        (d.getXValue = function (t) {
          var e = this.layout._getOption("horizontal");
          return this.layout.options.percentPosition && !e
            ? (t / this.layout.size.width) * 100 + "%"
            : t + "px";
        }),
        (d.getYValue = function (t) {
          var e = this.layout._getOption("horizontal");
          return this.layout.options.percentPosition && e
            ? (t / this.layout.size.height) * 100 + "%"
            : t + "px";
        }),
        (d._transitionTo = function (t, e) {
          this.getPosition();
          var i = this.position.x,
            n = this.position.y,
            o = t == this.position.x && e == this.position.y;
          if ((this.setPosition(t, e), o && !this.isTransitioning))
            return void this.layoutPosition();
          var r = t - i,
            s = e - n,
            a = {};
          (a.transform = this.getTranslate(r, s)),
            this.transition({
              to: a,
              onTransitionEnd: { transform: this.layoutPosition },
              isCleaning: !0,
            });
        }),
        (d.getTranslate = function (t, e) {
          var i = this.layout._getOption("originLeft"),
            n = this.layout._getOption("originTop");
          return (
            (t = i ? t : -t),
            (e = n ? e : -e),
            "translate3d(" + t + "px, " + e + "px, 0)"
          );
        }),
        (d.goTo = function (t, e) {
          this.setPosition(t, e), this.layoutPosition();
        }),
        (d.moveTo = d._transitionTo),
        (d.setPosition = function (t, e) {
          (this.position.x = parseFloat(t)), (this.position.y = parseFloat(e));
        }),
        (d._nonTransition = function (t) {
          this.css(t.to), t.isCleaning && this._removeStyles(t.to);
          for (var e in t.onTransitionEnd) t.onTransitionEnd[e].call(this);
        }),
        (d.transition = function (t) {
          if (!parseFloat(this.layout.options.transitionDuration))
            return void this._nonTransition(t);
          var e = this._transn;
          for (var i in t.onTransitionEnd) e.onEnd[i] = t.onTransitionEnd[i];
          for (i in t.to)
            (e.ingProperties[i] = !0), t.isCleaning && (e.clean[i] = !0);
          if (t.from) {
            this.css(t.from);
            var n = this.element.offsetHeight;
            n = null;
          }
          this.enableTransition(t.to),
            this.css(t.to),
            (this.isTransitioning = !0);
        });
      var l = "opacity," + o(a);
      (d.enableTransition = function () {
        if (!this.isTransitioning) {
          var t = this.layout.options.transitionDuration;
          (t = "number" == typeof t ? t + "ms" : t),
            this.css({
              transitionProperty: l,
              transitionDuration: t,
              transitionDelay: this.staggerDelay || 0,
            }),
            this.element.addEventListener(h, this, !1);
        }
      }),
        (d.onwebkitTransitionEnd = function (t) {
          this.ontransitionend(t);
        }),
        (d.onotransitionend = function (t) {
          this.ontransitionend(t);
        });
      var c = { "-webkit-transform": "transform" };
      (d.ontransitionend = function (t) {
        if (t.target === this.element) {
          var e = this._transn,
            n = c[t.propertyName] || t.propertyName;
          if (
            (delete e.ingProperties[n],
            i(e.ingProperties) && this.disableTransition(),
            n in e.clean &&
              ((this.element.style[t.propertyName] = ""), delete e.clean[n]),
            n in e.onEnd)
          ) {
            var o = e.onEnd[n];
            o.call(this), delete e.onEnd[n];
          }
          this.emitEvent("transitionEnd", [this]);
        }
      }),
        (d.disableTransition = function () {
          this.removeTransitionStyles(),
            this.element.removeEventListener(h, this, !1),
            (this.isTransitioning = !1);
        }),
        (d._removeStyles = function (t) {
          var e = {};
          for (var i in t) e[i] = "";
          this.css(e);
        });
      var f = {
        transitionProperty: "",
        transitionDuration: "",
        transitionDelay: "",
      };
      return (
        (d.removeTransitionStyles = function () {
          this.css(f);
        }),
        (d.stagger = function (t) {
          (t = isNaN(t) ? 0 : t), (this.staggerDelay = t + "ms");
        }),
        (d.removeElem = function () {
          this.element.parentNode.removeChild(this.element),
            this.css({ display: "" }),
            this.emitEvent("remove", [this]);
        }),
        (d.remove = function () {
          return s && parseFloat(this.layout.options.transitionDuration)
            ? (this.once("transitionEnd", function () {
                this.removeElem();
              }),
              void this.hide())
            : void this.removeElem();
        }),
        (d.reveal = function () {
          delete this.isHidden, this.css({ display: "" });
          var t = this.layout.options,
            e = {},
            i = this.getHideRevealTransitionEndProperty("visibleStyle");
          (e[i] = this.onRevealTransitionEnd),
            this.transition({
              from: t.hiddenStyle,
              to: t.visibleStyle,
              isCleaning: !0,
              onTransitionEnd: e,
            });
        }),
        (d.onRevealTransitionEnd = function () {
          this.isHidden || this.emitEvent("reveal");
        }),
        (d.getHideRevealTransitionEndProperty = function (t) {
          var e = this.layout.options[t];
          if (e.opacity) return "opacity";
          for (var i in e) return i;
        }),
        (d.hide = function () {
          (this.isHidden = !0), this.css({ display: "" });
          var t = this.layout.options,
            e = {},
            i = this.getHideRevealTransitionEndProperty("hiddenStyle");
          (e[i] = this.onHideTransitionEnd),
            this.transition({
              from: t.visibleStyle,
              to: t.hiddenStyle,
              isCleaning: !0,
              onTransitionEnd: e,
            });
        }),
        (d.onHideTransitionEnd = function () {
          this.isHidden &&
            (this.css({ display: "none" }), this.emitEvent("hide"));
        }),
        (d.destroy = function () {
          this.css({
            position: "",
            left: "",
            right: "",
            top: "",
            bottom: "",
            transition: "",
            transform: "",
          });
        }),
        n
      );
    }),
    (function (t, e) {
      "use strict";
      "function" == typeof define && define.amd
        ? define(
            "outlayer/outlayer",
            [
              "ev-emitter/ev-emitter",
              "get-size/get-size",
              "fizzy-ui-utils/utils",
              "./item",
            ],
            function (i, n, o, r) {
              return e(t, i, n, o, r);
            }
          )
        : "object" == typeof module && module.exports
        ? (module.exports = e(
            t,
            require("ev-emitter"),
            require("get-size"),
            require("fizzy-ui-utils"),
            require("./item")
          ))
        : (t.Outlayer = e(
            t,
            t.EvEmitter,
            t.getSize,
            t.fizzyUIUtils,
            t.Outlayer.Item
          ));
    })(window, function (t, e, i, n, o) {
      "use strict";
      function r(t, e) {
        var i = n.getQueryElement(t);
        if (!i)
          return void (
            h &&
            h.error(
              "Bad element for " + this.constructor.namespace + ": " + (i || t)
            )
          );
        (this.element = i),
          u && (this.$element = u(this.element)),
          (this.options = n.extend({}, this.constructor.defaults)),
          this.option(e);
        var o = ++l;
        (this.element.outlayerGUID = o), (c[o] = this), this._create();
        var r = this._getOption("initLayout");
        r && this.layout();
      }
      function s(t) {
        function e() {
          t.apply(this, arguments);
        }
        return (
          (e.prototype = Object.create(t.prototype)),
          (e.prototype.constructor = e),
          e
        );
      }
      function a(t) {
        if ("number" == typeof t) return t;
        var e = t.match(/(^\d*\.?\d*)(\w*)/),
          i = e && e[1],
          n = e && e[2];
        if (!i.length) return 0;
        i = parseFloat(i);
        var o = m[n] || 1;
        return i * o;
      }
      var h = t.console,
        u = t.jQuery,
        d = function () {},
        l = 0,
        c = {};
      (r.namespace = "outlayer"),
        (r.Item = o),
        (r.defaults = {
          containerStyle: { position: "relative" },
          initLayout: !0,
          originLeft: !0,
          originTop: !0,
          resize: !0,
          resizeContainer: !0,
          transitionDuration: "0.4s",
          hiddenStyle: { opacity: 0, transform: "scale(0.001)" },
          visibleStyle: { opacity: 1, transform: "scale(1)" },
        });
      var f = r.prototype;
      n.extend(f, e.prototype),
        (f.option = function (t) {
          n.extend(this.options, t);
        }),
        (f._getOption = function (t) {
          var e = this.constructor.compatOptions[t];
          return e && void 0 !== this.options[e]
            ? this.options[e]
            : this.options[t];
        }),
        (r.compatOptions = {
          initLayout: "isInitLayout",
          horizontal: "isHorizontal",
          layoutInstant: "isLayoutInstant",
          originLeft: "isOriginLeft",
          originTop: "isOriginTop",
          resize: "isResizeBound",
          resizeContainer: "isResizingContainer",
        }),
        (f._create = function () {
          this.reloadItems(),
            (this.stamps = []),
            this.stamp(this.options.stamp),
            n.extend(this.element.style, this.options.containerStyle);
          var t = this._getOption("resize");
          t && this.bindResize();
        }),
        (f.reloadItems = function () {
          this.items = this._itemize(this.element.children);
        }),
        (f._itemize = function (t) {
          for (
            var e = this._filterFindItemElements(t),
              i = this.constructor.Item,
              n = [],
              o = 0;
            o < e.length;
            o++
          ) {
            var r = e[o],
              s = new i(r, this);
            n.push(s);
          }
          return n;
        }),
        (f._filterFindItemElements = function (t) {
          return n.filterFindElements(t, this.options.itemSelector);
        }),
        (f.getItemElements = function () {
          return this.items.map(function (t) {
            return t.element;
          });
        }),
        (f.layout = function () {
          this._resetLayout(), this._manageStamps();
          var t = this._getOption("layoutInstant"),
            e = void 0 !== t ? t : !this._isLayoutInited;
          this.layoutItems(this.items, e), (this._isLayoutInited = !0);
        }),
        (f._init = f.layout),
        (f._resetLayout = function () {
          this.getSize();
        }),
        (f.getSize = function () {
          this.size = i(this.element);
        }),
        (f._getMeasurement = function (t, e) {
          var n,
            o = this.options[t];
          o
            ? ("string" == typeof o
                ? (n = this.element.querySelector(o))
                : o instanceof HTMLElement && (n = o),
              (this[t] = n ? i(n)[e] : o))
            : (this[t] = 0);
        }),
        (f.layoutItems = function (t, e) {
          (t = this._getItemsForLayout(t)),
            this._layoutItems(t, e),
            this._postLayout();
        }),
        (f._getItemsForLayout = function (t) {
          return t.filter(function (t) {
            return !t.isIgnored;
          });
        }),
        (f._layoutItems = function (t, e) {
          if ((this._emitCompleteOnItems("layout", t), t && t.length)) {
            var i = [];
            t.forEach(function (t) {
              var n = this._getItemLayoutPosition(t);
              (n.item = t), (n.isInstant = e || t.isLayoutInstant), i.push(n);
            }, this),
              this._processLayoutQueue(i);
          }
        }),
        (f._getItemLayoutPosition = function () {
          return { x: 0, y: 0 };
        }),
        (f._processLayoutQueue = function (t) {
          this.updateStagger(),
            t.forEach(function (t, e) {
              this._positionItem(t.item, t.x, t.y, t.isInstant, e);
            }, this);
        }),
        (f.updateStagger = function () {
          var t = this.options.stagger;
          return null === t || void 0 === t
            ? void (this.stagger = 0)
            : ((this.stagger = a(t)), this.stagger);
        }),
        (f._positionItem = function (t, e, i, n, o) {
          n ? t.goTo(e, i) : (t.stagger(o * this.stagger), t.moveTo(e, i));
        }),
        (f._postLayout = function () {
          this.resizeContainer();
        }),
        (f.resizeContainer = function () {
          var t = this._getOption("resizeContainer");
          if (t) {
            var e = this._getContainerSize();
            e &&
              (this._setContainerMeasure(e.width, !0),
              this._setContainerMeasure(e.height, !1));
          }
        }),
        (f._getContainerSize = d),
        (f._setContainerMeasure = function (t, e) {
          if (void 0 !== t) {
            var i = this.size;
            i.isBorderBox &&
              (t += e
                ? i.paddingLeft +
                  i.paddingRight +
                  i.borderLeftWidth +
                  i.borderRightWidth
                : i.paddingBottom +
                  i.paddingTop +
                  i.borderTopWidth +
                  i.borderBottomWidth),
              (t = Math.max(t, 0)),
              (this.element.style[e ? "width" : "height"] = t + "px");
          }
        }),
        (f._emitCompleteOnItems = function (t, e) {
          function i() {
            o.dispatchEvent(t + "Complete", null, [e]);
          }
          function n() {
            s++, s == r && i();
          }
          var o = this,
            r = e.length;
          if (!e || !r) return void i();
          var s = 0;
          e.forEach(function (e) {
            e.once(t, n);
          });
        }),
        (f.dispatchEvent = function (t, e, i) {
          var n = e ? [e].concat(i) : i;
          if ((this.emitEvent(t, n), u))
            if (((this.$element = this.$element || u(this.element)), e)) {
              var o = u.Event(e);
              (o.type = t), this.$element.trigger(o, i);
            } else this.$element.trigger(t, i);
        }),
        (f.ignore = function (t) {
          var e = this.getItem(t);
          e && (e.isIgnored = !0);
        }),
        (f.unignore = function (t) {
          var e = this.getItem(t);
          e && delete e.isIgnored;
        }),
        (f.stamp = function (t) {
          (t = this._find(t)),
            t &&
              ((this.stamps = this.stamps.concat(t)),
              t.forEach(this.ignore, this));
        }),
        (f.unstamp = function (t) {
          (t = this._find(t)),
            t &&
              t.forEach(function (t) {
                n.removeFrom(this.stamps, t), this.unignore(t);
              }, this);
        }),
        (f._find = function (t) {
          return t
            ? ("string" == typeof t && (t = this.element.querySelectorAll(t)),
              (t = n.makeArray(t)))
            : void 0;
        }),
        (f._manageStamps = function () {
          this.stamps &&
            this.stamps.length &&
            (this._getBoundingRect(),
            this.stamps.forEach(this._manageStamp, this));
        }),
        (f._getBoundingRect = function () {
          var t = this.element.getBoundingClientRect(),
            e = this.size;
          this._boundingRect = {
            left: t.left + e.paddingLeft + e.borderLeftWidth,
            top: t.top + e.paddingTop + e.borderTopWidth,
            right: t.right - (e.paddingRight + e.borderRightWidth),
            bottom: t.bottom - (e.paddingBottom + e.borderBottomWidth),
          };
        }),
        (f._manageStamp = d),
        (f._getElementOffset = function (t) {
          var e = t.getBoundingClientRect(),
            n = this._boundingRect,
            o = i(t),
            r = {
              left: e.left - n.left - o.marginLeft,
              top: e.top - n.top - o.marginTop,
              right: n.right - e.right - o.marginRight,
              bottom: n.bottom - e.bottom - o.marginBottom,
            };
          return r;
        }),
        (f.handleEvent = n.handleEvent),
        (f.bindResize = function () {
          t.addEventListener("resize", this), (this.isResizeBound = !0);
        }),
        (f.unbindResize = function () {
          t.removeEventListener("resize", this), (this.isResizeBound = !1);
        }),
        (f.onresize = function () {
          this.resize();
        }),
        n.debounceMethod(r, "onresize", 100),
        (f.resize = function () {
          this.isResizeBound && this.needsResizeLayout() && this.layout();
        }),
        (f.needsResizeLayout = function () {
          var t = i(this.element),
            e = this.size && t;
          return e && t.innerWidth !== this.size.innerWidth;
        }),
        (f.addItems = function (t) {
          var e = this._itemize(t);
          return e.length && (this.items = this.items.concat(e)), e;
        }),
        (f.appended = function (t) {
          var e = this.addItems(t);
          e.length && (this.layoutItems(e, !0), this.reveal(e));
        }),
        (f.prepended = function (t) {
          var e = this._itemize(t);
          if (e.length) {
            var i = this.items.slice(0);
            (this.items = e.concat(i)),
              this._resetLayout(),
              this._manageStamps(),
              this.layoutItems(e, !0),
              this.reveal(e),
              this.layoutItems(i);
          }
        }),
        (f.reveal = function (t) {
          if ((this._emitCompleteOnItems("reveal", t), t && t.length)) {
            var e = this.updateStagger();
            t.forEach(function (t, i) {
              t.stagger(i * e), t.reveal();
            });
          }
        }),
        (f.hide = function (t) {
          if ((this._emitCompleteOnItems("hide", t), t && t.length)) {
            var e = this.updateStagger();
            t.forEach(function (t, i) {
              t.stagger(i * e), t.hide();
            });
          }
        }),
        (f.revealItemElements = function (t) {
          var e = this.getItems(t);
          this.reveal(e);
        }),
        (f.hideItemElements = function (t) {
          var e = this.getItems(t);
          this.hide(e);
        }),
        (f.getItem = function (t) {
          for (var e = 0; e < this.items.length; e++) {
            var i = this.items[e];
            if (i.element == t) return i;
          }
        }),
        (f.getItems = function (t) {
          t = n.makeArray(t);
          var e = [];
          return (
            t.forEach(function (t) {
              var i = this.getItem(t);
              i && e.push(i);
            }, this),
            e
          );
        }),
        (f.remove = function (t) {
          var e = this.getItems(t);
          this._emitCompleteOnItems("remove", e),
            e &&
              e.length &&
              e.forEach(function (t) {
                t.remove(), n.removeFrom(this.items, t);
              }, this);
        }),
        (f.destroy = function () {
          var t = this.element.style;
          (t.height = ""),
            (t.position = ""),
            (t.width = ""),
            this.items.forEach(function (t) {
              t.destroy();
            }),
            this.unbindResize();
          var e = this.element.outlayerGUID;
          delete c[e],
            delete this.element.outlayerGUID,
            u && u.removeData(this.element, this.constructor.namespace);
        }),
        (r.data = function (t) {
          t = n.getQueryElement(t);
          var e = t && t.outlayerGUID;
          return e && c[e];
        }),
        (r.create = function (t, e) {
          var i = s(r);
          return (
            (i.defaults = n.extend({}, r.defaults)),
            n.extend(i.defaults, e),
            (i.compatOptions = n.extend({}, r.compatOptions)),
            (i.namespace = t),
            (i.data = r.data),
            (i.Item = s(o)),
            n.htmlInit(i, t),
            u && u.bridget && u.bridget(t, i),
            i
          );
        });
      var m = { ms: 1, s: 1e3 };
      return (r.Item = o), r;
    }),
    (function (t, e) {
      "function" == typeof define && define.amd
        ? define(["outlayer/outlayer", "get-size/get-size"], e)
        : "object" == typeof module && module.exports
        ? (module.exports = e(require("outlayer"), require("get-size")))
        : (t.Masonry = e(t.Outlayer, t.getSize));
    })(window, function (t, e) {
      var i = t.create("masonry");
      i.compatOptions.fitWidth = "isFitWidth";
      var n = i.prototype;
      return (
        (n._resetLayout = function () {
          this.getSize(),
            this._getMeasurement("columnWidth", "outerWidth"),
            this._getMeasurement("gutter", "outerWidth"),
            this.measureColumns(),
            (this.colYs = []);
          for (var t = 0; t < this.cols; t++) this.colYs.push(0);
          (this.maxY = 0), (this.horizontalColIndex = 0);
        }),
        (n.measureColumns = function () {
          if ((this.getContainerWidth(), !this.columnWidth)) {
            var t = this.items[0],
              i = t && t.element;
            this.columnWidth = (i && e(i).outerWidth) || this.containerWidth;
          }
          var n = (this.columnWidth += this.gutter),
            o = this.containerWidth + this.gutter,
            r = o / n,
            s = n - (o % n),
            a = s && 1 > s ? "round" : "floor";
          (r = Math[a](r)), (this.cols = Math.max(r, 1));
        }),
        (n.getContainerWidth = function () {
          var t = this._getOption("fitWidth"),
            i = t ? this.element.parentNode : this.element,
            n = e(i);
          this.containerWidth = n && n.innerWidth;
        }),
        (n._getItemLayoutPosition = function (t) {
          t.getSize();
          var e = t.size.outerWidth % this.columnWidth,
            i = e && 1 > e ? "round" : "ceil",
            n = Math[i](t.size.outerWidth / this.columnWidth);
          n = Math.min(n, this.cols);
          for (
            var o = this.options.horizontalOrder
                ? "_getHorizontalColPosition"
                : "_getTopColPosition",
              r = this[o](n, t),
              s = { x: this.columnWidth * r.col, y: r.y },
              a = r.y + t.size.outerHeight,
              h = n + r.col,
              u = r.col;
            h > u;
            u++
          )
            this.colYs[u] = a;
          return s;
        }),
        (n._getTopColPosition = function (t) {
          var e = this._getTopColGroup(t),
            i = Math.min.apply(Math, e);
          return { col: e.indexOf(i), y: i };
        }),
        (n._getTopColGroup = function (t) {
          if (2 > t) return this.colYs;
          for (var e = [], i = this.cols + 1 - t, n = 0; i > n; n++)
            e[n] = this._getColGroupY(n, t);
          return e;
        }),
        (n._getColGroupY = function (t, e) {
          if (2 > e) return this.colYs[t];
          var i = this.colYs.slice(t, t + e);
          return Math.max.apply(Math, i);
        }),
        (n._getHorizontalColPosition = function (t, e) {
          var i = this.horizontalColIndex % this.cols,
            n = t > 1 && i + t > this.cols;
          i = n ? 0 : i;
          var o = e.size.outerWidth && e.size.outerHeight;
          return (
            (this.horizontalColIndex = o ? i + t : this.horizontalColIndex),
            { col: i, y: this._getColGroupY(i, t) }
          );
        }),
        (n._manageStamp = function (t) {
          var i = e(t),
            n = this._getElementOffset(t),
            o = this._getOption("originLeft"),
            r = o ? n.left : n.right,
            s = r + i.outerWidth,
            a = Math.floor(r / this.columnWidth);
          a = Math.max(0, a);
          var h = Math.floor(s / this.columnWidth);
          (h -= s % this.columnWidth ? 0 : 1), (h = Math.min(this.cols - 1, h));
          for (
            var u = this._getOption("originTop"),
              d = (u ? n.top : n.bottom) + i.outerHeight,
              l = a;
            h >= l;
            l++
          )
            this.colYs[l] = Math.max(d, this.colYs[l]);
        }),
        (n._getContainerSize = function () {
          this.maxY = Math.max.apply(Math, this.colYs);
          var t = { height: this.maxY };
          return (
            this._getOption("fitWidth") &&
              (t.width = this._getContainerFitWidth()),
            t
          );
        }),
        (n._getContainerFitWidth = function () {
          for (var t = 0, e = this.cols; --e && 0 === this.colYs[e]; ) t++;
          return (this.cols - t) * this.columnWidth - this.gutter;
        }),
        (n.needsResizeLayout = function () {
          var t = this.containerWidth;
          return this.getContainerWidth(), t != this.containerWidth;
        }),
        i
      );
    });
  /*!
   * imagesLoaded PACKAGED v4.1.4
   */
  !(function (e, t) {
    "function" == typeof define && define.amd
      ? define("ev-emitter/ev-emitter", t)
      : "object" == typeof module && module.exports
      ? (module.exports = t())
      : (e.EvEmitter = t());
  })("undefined" != typeof window ? window : this, function () {
    function e() {}
    var t = e.prototype;
    return (
      (t.on = function (e, t) {
        if (e && t) {
          var i = (this._events = this._events || {}),
            n = (i[e] = i[e] || []);
          return n.indexOf(t) == -1 && n.push(t), this;
        }
      }),
      (t.once = function (e, t) {
        if (e && t) {
          this.on(e, t);
          var i = (this._onceEvents = this._onceEvents || {}),
            n = (i[e] = i[e] || {});
          return (n[t] = !0), this;
        }
      }),
      (t.off = function (e, t) {
        var i = this._events && this._events[e];
        if (i && i.length) {
          var n = i.indexOf(t);
          return n != -1 && i.splice(n, 1), this;
        }
      }),
      (t.emitEvent = function (e, t) {
        var i = this._events && this._events[e];
        if (i && i.length) {
          (i = i.slice(0)), (t = t || []);
          for (
            var n = this._onceEvents && this._onceEvents[e], o = 0;
            o < i.length;
            o++
          ) {
            var r = i[o],
              s = n && n[r];
            s && (this.off(e, r), delete n[r]), r.apply(this, t);
          }
          return this;
        }
      }),
      (t.allOff = function () {
        delete this._events, delete this._onceEvents;
      }),
      e
    );
  }),
    (function (e, t) {
      "use strict";
      "function" == typeof define && define.amd
        ? define(["ev-emitter/ev-emitter"], function (i) {
            return t(e, i);
          })
        : "object" == typeof module && module.exports
        ? (module.exports = t(e, require("ev-emitter")))
        : (e.imagesLoaded = t(e, e.EvEmitter));
    })("undefined" != typeof window ? window : this, function (e, t) {
      function i(e, t) {
        for (var i in t) e[i] = t[i];
        return e;
      }
      function n(e) {
        if (Array.isArray(e)) return e;
        var t = "object" == typeof e && "number" == typeof e.length;
        return t ? d.call(e) : [e];
      }
      function o(e, t, r) {
        if (!(this instanceof o)) return new o(e, t, r);
        var s = e;
        return (
          "string" == typeof e && (s = document.querySelectorAll(e)),
          s
            ? ((this.elements = n(s)),
              (this.options = i({}, this.options)),
              "function" == typeof t ? (r = t) : i(this.options, t),
              r && this.on("always", r),
              this.getImages(),
              h && (this.jqDeferred = new h.Deferred()),
              void setTimeout(this.check.bind(this)))
            : void a.error("Bad element for imagesLoaded " + (s || e))
        );
      }
      function r(e) {
        this.img = e;
      }
      function s(e, t) {
        (this.url = e), (this.element = t), (this.img = new Image());
      }
      var h = e.jQuery,
        a = e.console,
        d = Array.prototype.slice;
      (o.prototype = Object.create(t.prototype)),
        (o.prototype.options = {}),
        (o.prototype.getImages = function () {
          (this.images = []),
            this.elements.forEach(this.addElementImages, this);
        }),
        (o.prototype.addElementImages = function (e) {
          "IMG" == e.nodeName && this.addImage(e),
            this.options.background === !0 &&
              this.addElementBackgroundImages(e);
          var t = e.nodeType;
          if (t && u[t]) {
            for (var i = e.querySelectorAll("img"), n = 0; n < i.length; n++) {
              var o = i[n];
              this.addImage(o);
            }
            if ("string" == typeof this.options.background) {
              var r = e.querySelectorAll(this.options.background);
              for (n = 0; n < r.length; n++) {
                var s = r[n];
                this.addElementBackgroundImages(s);
              }
            }
          }
        });
      var u = { 1: !0, 9: !0, 11: !0 };
      return (
        (o.prototype.addElementBackgroundImages = function (e) {
          var t = getComputedStyle(e);
          if (t)
            for (
              var i = /url\((['"])?(.*?)\1\)/gi, n = i.exec(t.backgroundImage);
              null !== n;

            ) {
              var o = n && n[2];
              o && this.addBackground(o, e), (n = i.exec(t.backgroundImage));
            }
        }),
        (o.prototype.addImage = function (e) {
          var t = new r(e);
          this.images.push(t);
        }),
        (o.prototype.addBackground = function (e, t) {
          var i = new s(e, t);
          this.images.push(i);
        }),
        (o.prototype.check = function () {
          function e(e, i, n) {
            setTimeout(function () {
              t.progress(e, i, n);
            });
          }
          var t = this;
          return (
            (this.progressedCount = 0),
            (this.hasAnyBroken = !1),
            this.images.length
              ? void this.images.forEach(function (t) {
                  t.once("progress", e), t.check();
                })
              : void this.complete()
          );
        }),
        (o.prototype.progress = function (e, t, i) {
          this.progressedCount++,
            (this.hasAnyBroken = this.hasAnyBroken || !e.isLoaded),
            this.emitEvent("progress", [this, e, t]),
            this.jqDeferred &&
              this.jqDeferred.notify &&
              this.jqDeferred.notify(this, e),
            this.progressedCount == this.images.length && this.complete(),
            this.options.debug && a && a.log("progress: " + i, e, t);
        }),
        (o.prototype.complete = function () {
          var e = this.hasAnyBroken ? "fail" : "done";
          if (
            ((this.isComplete = !0),
            this.emitEvent(e, [this]),
            this.emitEvent("always", [this]),
            this.jqDeferred)
          ) {
            var t = this.hasAnyBroken ? "reject" : "resolve";
            this.jqDeferred[t](this);
          }
        }),
        (r.prototype = Object.create(t.prototype)),
        (r.prototype.check = function () {
          var e = this.getIsImageComplete();
          return e
            ? void this.confirm(0 !== this.img.naturalWidth, "naturalWidth")
            : ((this.proxyImage = new Image()),
              this.proxyImage.addEventListener("load", this),
              this.proxyImage.addEventListener("error", this),
              this.img.addEventListener("load", this),
              this.img.addEventListener("error", this),
              void (this.proxyImage.src = this.img.src));
        }),
        (r.prototype.getIsImageComplete = function () {
          return this.img.complete && this.img.naturalWidth;
        }),
        (r.prototype.confirm = function (e, t) {
          (this.isLoaded = e), this.emitEvent("progress", [this, this.img, t]);
        }),
        (r.prototype.handleEvent = function (e) {
          var t = "on" + e.type;
          this[t] && this[t](e);
        }),
        (r.prototype.onload = function () {
          this.confirm(!0, "onload"), this.unbindEvents();
        }),
        (r.prototype.onerror = function () {
          this.confirm(!1, "onerror"), this.unbindEvents();
        }),
        (r.prototype.unbindEvents = function () {
          this.proxyImage.removeEventListener("load", this),
            this.proxyImage.removeEventListener("error", this),
            this.img.removeEventListener("load", this),
            this.img.removeEventListener("error", this);
        }),
        (s.prototype = Object.create(r.prototype)),
        (s.prototype.check = function () {
          this.img.addEventListener("load", this),
            this.img.addEventListener("error", this),
            (this.img.src = this.url);
          var e = this.getIsImageComplete();
          e &&
            (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"),
            this.unbindEvents());
        }),
        (s.prototype.unbindEvents = function () {
          this.img.removeEventListener("load", this),
            this.img.removeEventListener("error", this);
        }),
        (s.prototype.confirm = function (e, t) {
          (this.isLoaded = e),
            this.emitEvent("progress", [this, this.element, t]);
        }),
        (o.makeJQueryPlugin = function (t) {
          (t = t || e.jQuery),
            t &&
              ((h = t),
              (h.fn.imagesLoaded = function (e, t) {
                var i = new o(this, e, t);
                return i.jqDeferred.promise(h(this));
              }));
        }),
        o.makeJQueryPlugin(),
        o
      );
    });
});

$(window).load(function () {
  let $masonryGrid = null;
  setInterval(function () {
    // init Masonry
    $masonryGrid = $(".Index_meta_blog_category_bottompart_new").masonry({
      itemSelector: ".Index_meta_blog_category_bottompart_article_new",
      columnWidth: ".Index_meta_blog_category_bottompart_article_new",
      percentPosition: true,
    });
    // layout Masonry after each image loads
    $masonryGrid.imagesLoaded().progress(function () {
      $masonryGrid.masonry();
    });
  }, 100);

  /*==== Load More ==================================================================*/
  const loadMOreBtn = $("#load_more_btn");
  var products_on_page = $(".blogs-on-page");
  var next_url = products_on_page.data("next-url");

  var load_more_btn = $(".load-more_btn ");
  var load_more_spinner = $(".load-more_spinner");

  function loadMoreProducts() {
    $.ajax({
      url: next_url,
      type: "GET",
      dataType: "html",
      beforeSend: function () {
        load_more_btn.hide();
        load_more_spinner.show();
      },
    }).done(function (next_page) {
      load_more_spinner.hide();

      var mainWrapper = $(next_page).find(".blogs-on-page");
      var new_products = $(next_page).find(
        ".Index_meta_blog_category_bottompart_article_new"
      );
      var new_url = mainWrapper.data("next-url");

      if (new_url) load_more_btn.show();

      next_url = new_url;

      const $content = $(new_products);
      $masonryGrid.append($content).masonry("appended", $content);
    });
  }

  loadMOreBtn.click(loadMoreProducts);

  /*======================================================================*/
});

/*==== Load More Media ==================================================================*/
const loadMOreBtn_2 = $("#load_more_btn_2");
var products_on_page_2 = $(".blogs-on-page-2");
var next_url_2 = products_on_page_2.data("next-url-2");

var load_more_btn_2 = $(".load-more_btn-2 ");
var load_more_spinner_2 = $(".load-more_spinner-2");

function loadMoreProducts_1() {
  $.ajax({
    url: next_url_2,
    type: "GET",
    dataType: "html",
    beforeSend: function () {
      load_more_btn_2.hide();
      load_more_spinner_2.show();
    },
  }).done(function (next_page_2) {
    load_more_spinner_2.hide();

    var new_products_2 = $(next_page_2).find(".blogs-on-page-2");
    var new_url_2 = new_products_2.data("next-url-2");

    if (new_url_2) load_more_btn_2.show();

    next_url_2 = new_url_2;
    products_on_page_2.append(new_products_2.html());
  });
}
loadMOreBtn_2.click(loadMoreProducts_1);
/*======================================================================*/

/* icon animation */
"undefined" != typeof navigator &&
  (function (t, e) {
    "object" == typeof exports && "undefined" != typeof module
      ? (module.exports = e())
      : "function" == typeof define && define.amd
      ? define(e)
      : ((t =
          "undefined" != typeof globalThis ? globalThis : t || self).lottie =
          e());
  })(this, function () {
    "use strict";
    var svgNS = "http://www.w3.org/2000/svg",
      locationHref = "",
      _useWebWorker = !1,
      initialDefaultFrame = -999999,
      setWebWorker = function (t) {
        _useWebWorker = !!t;
      },
      getWebWorker = function () {
        return _useWebWorker;
      },
      setLocationHref = function (t) {
        locationHref = t;
      },
      getLocationHref = function () {
        return locationHref;
      };
    function createTag(t) {
      return document.createElement(t);
    }
    function extendPrototype(t, e) {
      var r,
        i,
        s = t.length;
      for (r = 0; r < s; r += 1)
        for (var a in (i = t[r].prototype))
          Object.prototype.hasOwnProperty.call(i, a) && (e.prototype[a] = i[a]);
    }
    function getDescriptor(t, e) {
      return Object.getOwnPropertyDescriptor(t, e);
    }
    function createProxyFunction(t) {
      function e() {}
      return (e.prototype = t), e;
    }
    var audioControllerFactory = (function () {
        function t(t) {
          (this.audios = []),
            (this.audioFactory = t),
            (this._volume = 1),
            (this._isMuted = !1);
        }
        return (
          (t.prototype = {
            addAudio: function (t) {
              this.audios.push(t);
            },
            pause: function () {
              var t,
                e = this.audios.length;
              for (t = 0; t < e; t += 1) this.audios[t].pause();
            },
            resume: function () {
              var t,
                e = this.audios.length;
              for (t = 0; t < e; t += 1) this.audios[t].resume();
            },
            setRate: function (t) {
              var e,
                r = this.audios.length;
              for (e = 0; e < r; e += 1) this.audios[e].setRate(t);
            },
            createAudio: function (t) {
              return this.audioFactory
                ? this.audioFactory(t)
                : window.Howl
                ? new window.Howl({ src: [t] })
                : {
                    isPlaying: !1,
                    play: function () {
                      this.isPlaying = !0;
                    },
                    seek: function () {
                      this.isPlaying = !1;
                    },
                    playing: function () {},
                    rate: function () {},
                    setVolume: function () {},
                  };
            },
            setAudioFactory: function (t) {
              this.audioFactory = t;
            },
            setVolume: function (t) {
              (this._volume = t), this._updateVolume();
            },
            mute: function () {
              (this._isMuted = !0), this._updateVolume();
            },
            unmute: function () {
              (this._isMuted = !1), this._updateVolume();
            },
            getVolume: function () {
              return this._volume;
            },
            _updateVolume: function () {
              var t,
                e = this.audios.length;
              for (t = 0; t < e; t += 1)
                this.audios[t].volume(this._volume * (this._isMuted ? 0 : 1));
            },
          }),
          function () {
            return new t();
          }
        );
      })(),
      createTypedArray = (function () {
        function t(t, e) {
          var r,
            i = 0,
            s = [];
          switch (t) {
            case "int16":
            case "uint8c":
              r = 1;
              break;
            default:
              r = 1.1;
          }
          for (i = 0; i < e; i += 1) s.push(r);
          return s;
        }
        return "function" == typeof Uint8ClampedArray &&
          "function" == typeof Float32Array
          ? function (e, r) {
              return "float32" === e
                ? new Float32Array(r)
                : "int16" === e
                ? new Int16Array(r)
                : "uint8c" === e
                ? new Uint8ClampedArray(r)
                : t(e, r);
            }
          : t;
      })();
    function createSizedArray(t) {
      return Array.apply(null, { length: t });
    }
    function _typeof$6(t) {
      return (
        (_typeof$6 =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
                return typeof t;
              }
            : function (t) {
                return t &&
                  "function" == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              }),
        _typeof$6(t)
      );
    }
    var subframeEnabled = !0,
      expressionsPlugin = null,
      idPrefix$1 = "",
      isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent),
      _shouldRoundValues = !1,
      bmPow = Math.pow,
      bmSqrt = Math.sqrt,
      bmFloor = Math.floor,
      bmMax = Math.max,
      bmMin = Math.min,
      BMMath = {};
    function ProjectInterface$1() {
      return {};
    }
    !(function () {
      var t,
        e = [
          "abs",
          "acos",
          "acosh",
          "asin",
          "asinh",
          "atan",
          "atanh",
          "atan2",
          "ceil",
          "cbrt",
          "expm1",
          "clz32",
          "cos",
          "cosh",
          "exp",
          "floor",
          "fround",
          "hypot",
          "imul",
          "log",
          "log1p",
          "log2",
          "log10",
          "max",
          "min",
          "pow",
          "random",
          "round",
          "sign",
          "sin",
          "sinh",
          "sqrt",
          "tan",
          "tanh",
          "trunc",
          "E",
          "LN10",
          "LN2",
          "LOG10E",
          "LOG2E",
          "PI",
          "SQRT1_2",
          "SQRT2",
        ],
        r = e.length;
      for (t = 0; t < r; t += 1) BMMath[e[t]] = Math[e[t]];
    })(),
      (BMMath.random = Math.random),
      (BMMath.abs = function (t) {
        if ("object" === _typeof$6(t) && t.length) {
          var e,
            r = createSizedArray(t.length),
            i = t.length;
          for (e = 0; e < i; e += 1) r[e] = Math.abs(t[e]);
          return r;
        }
        return Math.abs(t);
      });
    var defaultCurveSegments = 150,
      degToRads = Math.PI / 180,
      roundCorner = 0.5519;
    function roundValues(t) {
      _shouldRoundValues = !!t;
    }
    function bmRnd(t) {
      return _shouldRoundValues ? Math.round(t) : t;
    }
    function styleDiv(t) {
      (t.style.position = "absolute"),
        (t.style.top = 0),
        (t.style.left = 0),
        (t.style.display = "block"),
        (t.style.transformOrigin = "0 0"),
        (t.style.webkitTransformOrigin = "0 0"),
        (t.style.backfaceVisibility = "visible"),
        (t.style.webkitBackfaceVisibility = "visible"),
        (t.style.transformStyle = "preserve-3d"),
        (t.style.webkitTransformStyle = "preserve-3d"),
        (t.style.mozTransformStyle = "preserve-3d");
    }
    function BMEnterFrameEvent(t, e, r, i) {
      (this.type = t),
        (this.currentTime = e),
        (this.totalTime = r),
        (this.direction = i < 0 ? -1 : 1);
    }
    function BMCompleteEvent(t, e) {
      (this.type = t), (this.direction = e < 0 ? -1 : 1);
    }
    function BMCompleteLoopEvent(t, e, r, i) {
      (this.type = t),
        (this.currentLoop = r),
        (this.totalLoops = e),
        (this.direction = i < 0 ? -1 : 1);
    }
    function BMSegmentStartEvent(t, e, r) {
      (this.type = t), (this.firstFrame = e), (this.totalFrames = r);
    }
    function BMDestroyEvent(t, e) {
      (this.type = t), (this.target = e);
    }
    function BMRenderFrameErrorEvent(t, e) {
      (this.type = "renderFrameError"),
        (this.nativeError = t),
        (this.currentTime = e);
    }
    function BMConfigErrorEvent(t) {
      (this.type = "configError"), (this.nativeError = t);
    }
    function BMAnimationConfigErrorEvent(t, e) {
      (this.type = t), (this.nativeError = e);
    }
    var createElementID =
        ((_count = 0),
        function () {
          return idPrefix$1 + "__lottie_element_" + (_count += 1);
        }),
      _count;
    function HSVtoRGB(t, e, r) {
      var i, s, a, n, o, h, l, p;
      switch (
        ((h = r * (1 - e)),
        (l = r * (1 - (o = 6 * t - (n = Math.floor(6 * t))) * e)),
        (p = r * (1 - (1 - o) * e)),
        n % 6)
      ) {
        case 0:
          (i = r), (s = p), (a = h);
          break;
        case 1:
          (i = l), (s = r), (a = h);
          break;
        case 2:
          (i = h), (s = r), (a = p);
          break;
        case 3:
          (i = h), (s = l), (a = r);
          break;
        case 4:
          (i = p), (s = h), (a = r);
          break;
        case 5:
          (i = r), (s = h), (a = l);
      }
      return [i, s, a];
    }
    function RGBtoHSV(t, e, r) {
      var i,
        s = Math.max(t, e, r),
        a = Math.min(t, e, r),
        n = s - a,
        o = 0 === s ? 0 : n / s,
        h = s / 255;
      switch (s) {
        case a:
          i = 0;
          break;
        case t:
          (i = e - r + n * (e < r ? 6 : 0)), (i /= 6 * n);
          break;
        case e:
          (i = r - t + 2 * n), (i /= 6 * n);
          break;
        case r:
          (i = t - e + 4 * n), (i /= 6 * n);
      }
      return [i, o, h];
    }
    function addSaturationToRGB(t, e) {
      var r = RGBtoHSV(255 * t[0], 255 * t[1], 255 * t[2]);
      return (
        (r[1] += e),
        r[1] > 1 ? (r[1] = 1) : r[1] <= 0 && (r[1] = 0),
        HSVtoRGB(r[0], r[1], r[2])
      );
    }
    function addBrightnessToRGB(t, e) {
      var r = RGBtoHSV(255 * t[0], 255 * t[1], 255 * t[2]);
      return (
        (r[2] += e),
        r[2] > 1 ? (r[2] = 1) : r[2] < 0 && (r[2] = 0),
        HSVtoRGB(r[0], r[1], r[2])
      );
    }
    function addHueToRGB(t, e) {
      var r = RGBtoHSV(255 * t[0], 255 * t[1], 255 * t[2]);
      return (
        (r[0] += e / 360),
        r[0] > 1 ? (r[0] -= 1) : r[0] < 0 && (r[0] += 1),
        HSVtoRGB(r[0], r[1], r[2])
      );
    }
    var rgbToHex = (function () {
        var t,
          e,
          r = [];
        for (t = 0; t < 256; t += 1)
          (e = t.toString(16)), (r[t] = 1 === e.length ? "0" + e : e);
        return function (t, e, i) {
          return (
            t < 0 && (t = 0),
            e < 0 && (e = 0),
            i < 0 && (i = 0),
            "#" + r[t] + r[e] + r[i]
          );
        };
      })(),
      setSubframeEnabled = function (t) {
        subframeEnabled = !!t;
      },
      getSubframeEnabled = function () {
        return subframeEnabled;
      },
      setExpressionsPlugin = function (t) {
        expressionsPlugin = t;
      },
      getExpressionsPlugin = function () {
        return expressionsPlugin;
      },
      setDefaultCurveSegments = function (t) {
        defaultCurveSegments = t;
      },
      getDefaultCurveSegments = function () {
        return defaultCurveSegments;
      },
      setIdPrefix = function (t) {
        idPrefix$1 = t;
      },
      getIdPrefix = function () {
        return idPrefix$1;
      };
    function createNS(t) {
      return document.createElementNS(svgNS, t);
    }
    function _typeof$5(t) {
      return (
        (_typeof$5 =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
                return typeof t;
              }
            : function (t) {
                return t &&
                  "function" == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              }),
        _typeof$5(t)
      );
    }
    var dataManager = (function () {
        var t,
          e,
          r = 1,
          i = [],
          s = {
            onmessage: function () {},
            postMessage: function (e) {
              t({ data: e });
            },
          },
          a = {
            postMessage: function (t) {
              s.onmessage({ data: t });
            },
          };
        function n() {
          e ||
            ((e = (function (e) {
              if (window.Worker && window.Blob && getWebWorker()) {
                var r = new Blob(
                    ["var _workerSelf = self; self.onmessage = ", e.toString()],
                    { type: "text/javascript" }
                  ),
                  i = URL.createObjectURL(r);
                return new Worker(i);
              }
              return (t = e), s;
            })(function (t) {
              if (
                (a.dataManager ||
                  (a.dataManager = (function () {
                    function t(s, a) {
                      var n,
                        o,
                        h,
                        l,
                        p,
                        m,
                        c = s.length;
                      for (o = 0; o < c; o += 1)
                        if ("ks" in (n = s[o]) && !n.completed) {
                          if (
                            ((n.completed = !0),
                            n.tt && (s[o - 1].td = n.tt),
                            n.hasMask)
                          ) {
                            var d = n.masksProperties;
                            for (l = d.length, h = 0; h < l; h += 1)
                              if (d[h].pt.k.i) i(d[h].pt.k);
                              else
                                for (m = d[h].pt.k.length, p = 0; p < m; p += 1)
                                  d[h].pt.k[p].s && i(d[h].pt.k[p].s[0]),
                                    d[h].pt.k[p].e && i(d[h].pt.k[p].e[0]);
                          }
                          0 === n.ty
                            ? ((n.layers = e(n.refId, a)), t(n.layers, a))
                            : 4 === n.ty
                            ? r(n.shapes)
                            : 5 === n.ty && f(n);
                        }
                    }
                    function e(t, e) {
                      var r = (function (t, e) {
                        for (var r = 0, i = e.length; r < i; ) {
                          if (e[r].id === t) return e[r];
                          r += 1;
                        }
                        return null;
                      })(t, e);
                      return r
                        ? r.layers.__used
                          ? JSON.parse(JSON.stringify(r.layers))
                          : ((r.layers.__used = !0), r.layers)
                        : null;
                    }
                    function r(t) {
                      var e, s, a;
                      for (e = t.length - 1; e >= 0; e -= 1)
                        if ("sh" === t[e].ty)
                          if (t[e].ks.k.i) i(t[e].ks.k);
                          else
                            for (a = t[e].ks.k.length, s = 0; s < a; s += 1)
                              t[e].ks.k[s].s && i(t[e].ks.k[s].s[0]),
                                t[e].ks.k[s].e && i(t[e].ks.k[s].e[0]);
                        else "gr" === t[e].ty && r(t[e].it);
                    }
                    function i(t) {
                      var e,
                        r = t.i.length;
                      for (e = 0; e < r; e += 1)
                        (t.i[e][0] += t.v[e][0]),
                          (t.i[e][1] += t.v[e][1]),
                          (t.o[e][0] += t.v[e][0]),
                          (t.o[e][1] += t.v[e][1]);
                    }
                    function s(t, e) {
                      var r = e ? e.split(".") : [100, 100, 100];
                      return (
                        t[0] > r[0] ||
                        (!(r[0] > t[0]) &&
                          (t[1] > r[1] ||
                            (!(r[1] > t[1]) &&
                              (t[2] > r[2] || (!(r[2] > t[2]) && null)))))
                      );
                    }
                    var a,
                      n = (function () {
                        var t = [4, 4, 14];
                        function e(t) {
                          var e,
                            r,
                            i,
                            s = t.length;
                          for (e = 0; e < s; e += 1)
                            5 === t[e].ty &&
                              ((i = void 0),
                              (i = (r = t[e]).t.d),
                              (r.t.d = { k: [{ s: i, t: 0 }] }));
                        }
                        return function (r) {
                          if (s(t, r.v) && (e(r.layers), r.assets)) {
                            var i,
                              a = r.assets.length;
                            for (i = 0; i < a; i += 1)
                              r.assets[i].layers && e(r.assets[i].layers);
                          }
                        };
                      })(),
                      o =
                        ((a = [4, 7, 99]),
                        function (t) {
                          if (t.chars && !s(a, t.v)) {
                            var e,
                              i = t.chars.length;
                            for (e = 0; e < i; e += 1) {
                              var n = t.chars[e];
                              n.data &&
                                n.data.shapes &&
                                (r(n.data.shapes),
                                (n.data.ip = 0),
                                (n.data.op = 99999),
                                (n.data.st = 0),
                                (n.data.sr = 1),
                                (n.data.ks = {
                                  p: { k: [0, 0], a: 0 },
                                  s: { k: [100, 100], a: 0 },
                                  a: { k: [0, 0], a: 0 },
                                  r: { k: 0, a: 0 },
                                  o: { k: 100, a: 0 },
                                }),
                                t.chars[e].t ||
                                  (n.data.shapes.push({ ty: "no" }),
                                  n.data.shapes[0].it.push({
                                    p: { k: [0, 0], a: 0 },
                                    s: { k: [100, 100], a: 0 },
                                    a: { k: [0, 0], a: 0 },
                                    r: { k: 0, a: 0 },
                                    o: { k: 100, a: 0 },
                                    sk: { k: 0, a: 0 },
                                    sa: { k: 0, a: 0 },
                                    ty: "tr",
                                  })));
                            }
                          }
                        }),
                      h = (function () {
                        var t = [5, 7, 15];
                        function e(t) {
                          var e,
                            r,
                            i = t.length;
                          for (e = 0; e < i; e += 1)
                            5 === t[e].ty &&
                              ((r = void 0),
                              "number" == typeof (r = t[e].t.p).a &&
                                (r.a = { a: 0, k: r.a }),
                              "number" == typeof r.p &&
                                (r.p = { a: 0, k: r.p }),
                              "number" == typeof r.r &&
                                (r.r = { a: 0, k: r.r }));
                        }
                        return function (r) {
                          if (s(t, r.v) && (e(r.layers), r.assets)) {
                            var i,
                              a = r.assets.length;
                            for (i = 0; i < a; i += 1)
                              r.assets[i].layers && e(r.assets[i].layers);
                          }
                        };
                      })(),
                      l = (function () {
                        var t = [4, 1, 9];
                        function e(t) {
                          var r,
                            i,
                            s,
                            a = t.length;
                          for (r = 0; r < a; r += 1)
                            if ("gr" === t[r].ty) e(t[r].it);
                            else if ("fl" === t[r].ty || "st" === t[r].ty)
                              if (t[r].c.k && t[r].c.k[0].i)
                                for (s = t[r].c.k.length, i = 0; i < s; i += 1)
                                  t[r].c.k[i].s &&
                                    ((t[r].c.k[i].s[0] /= 255),
                                    (t[r].c.k[i].s[1] /= 255),
                                    (t[r].c.k[i].s[2] /= 255),
                                    (t[r].c.k[i].s[3] /= 255)),
                                    t[r].c.k[i].e &&
                                      ((t[r].c.k[i].e[0] /= 255),
                                      (t[r].c.k[i].e[1] /= 255),
                                      (t[r].c.k[i].e[2] /= 255),
                                      (t[r].c.k[i].e[3] /= 255));
                              else
                                (t[r].c.k[0] /= 255),
                                  (t[r].c.k[1] /= 255),
                                  (t[r].c.k[2] /= 255),
                                  (t[r].c.k[3] /= 255);
                        }
                        function r(t) {
                          var r,
                            i = t.length;
                          for (r = 0; r < i; r += 1)
                            4 === t[r].ty && e(t[r].shapes);
                        }
                        return function (e) {
                          if (s(t, e.v) && (r(e.layers), e.assets)) {
                            var i,
                              a = e.assets.length;
                            for (i = 0; i < a; i += 1)
                              e.assets[i].layers && r(e.assets[i].layers);
                          }
                        };
                      })(),
                      p = (function () {
                        var t = [4, 4, 18];
                        function e(t) {
                          var r, i, s;
                          for (r = t.length - 1; r >= 0; r -= 1)
                            if ("sh" === t[r].ty)
                              if (t[r].ks.k.i) t[r].ks.k.c = t[r].closed;
                              else
                                for (s = t[r].ks.k.length, i = 0; i < s; i += 1)
                                  t[r].ks.k[i].s &&
                                    (t[r].ks.k[i].s[0].c = t[r].closed),
                                    t[r].ks.k[i].e &&
                                      (t[r].ks.k[i].e[0].c = t[r].closed);
                            else "gr" === t[r].ty && e(t[r].it);
                        }
                        function r(t) {
                          var r,
                            i,
                            s,
                            a,
                            n,
                            o,
                            h = t.length;
                          for (i = 0; i < h; i += 1) {
                            if ((r = t[i]).hasMask) {
                              var l = r.masksProperties;
                              for (a = l.length, s = 0; s < a; s += 1)
                                if (l[s].pt.k.i) l[s].pt.k.c = l[s].cl;
                                else
                                  for (
                                    o = l[s].pt.k.length, n = 0;
                                    n < o;
                                    n += 1
                                  )
                                    l[s].pt.k[n].s &&
                                      (l[s].pt.k[n].s[0].c = l[s].cl),
                                      l[s].pt.k[n].e &&
                                        (l[s].pt.k[n].e[0].c = l[s].cl);
                            }
                            4 === r.ty && e(r.shapes);
                          }
                        }
                        return function (e) {
                          if (s(t, e.v) && (r(e.layers), e.assets)) {
                            var i,
                              a = e.assets.length;
                            for (i = 0; i < a; i += 1)
                              e.assets[i].layers && r(e.assets[i].layers);
                          }
                        };
                      })();
                    function f(t) {
                      0 === t.t.a.length && t.t.p;
                    }
                    var m = {
                      completeData: function (r) {
                        r.__complete ||
                          (l(r),
                          n(r),
                          o(r),
                          h(r),
                          p(r),
                          t(r.layers, r.assets),
                          (function (r, i) {
                            if (r) {
                              var s = 0,
                                a = r.length;
                              for (s = 0; s < a; s += 1)
                                1 === r[s].t &&
                                  ((r[s].data.layers = e(r[s].data.refId, i)),
                                  t(r[s].data.layers, i));
                            }
                          })(r.chars, r.assets),
                          (r.__complete = !0));
                      },
                    };
                    return (
                      (m.checkColors = l),
                      (m.checkChars = o),
                      (m.checkPathProperties = h),
                      (m.checkShapes = p),
                      (m.completeLayers = t),
                      m
                    );
                  })()),
                a.assetLoader ||
                  (a.assetLoader = (function () {
                    function t(t) {
                      var e = t.getResponseHeader("content-type");
                      return (e &&
                        "json" === t.responseType &&
                        -1 !== e.indexOf("json")) ||
                        (t.response && "object" === _typeof$5(t.response))
                        ? t.response
                        : t.response && "string" == typeof t.response
                        ? JSON.parse(t.response)
                        : t.responseText
                        ? JSON.parse(t.responseText)
                        : null;
                    }
                    return {
                      load: function (e, r, i, s) {
                        var a,
                          n = new XMLHttpRequest();
                        try {
                          n.responseType = "json";
                        } catch (t) {}
                        n.onreadystatechange = function () {
                          if (4 === n.readyState)
                            if (200 === n.status) (a = t(n)), i(a);
                            else
                              try {
                                (a = t(n)), i(a);
                              } catch (t) {
                                s && s(t);
                              }
                        };
                        try {
                          n.open("GET", e, !0);
                        } catch (t) {
                          n.open("GET", r + "/" + e, !0);
                        }
                        n.send();
                      },
                    };
                  })()),
                "loadAnimation" === t.data.type)
              )
                a.assetLoader.load(
                  t.data.path,
                  t.data.fullPath,
                  function (e) {
                    a.dataManager.completeData(e),
                      a.postMessage({
                        id: t.data.id,
                        payload: e,
                        status: "success",
                      });
                  },
                  function () {
                    a.postMessage({ id: t.data.id, status: "error" });
                  }
                );
              else if ("complete" === t.data.type) {
                var e = t.data.animation;
                a.dataManager.completeData(e),
                  a.postMessage({
                    id: t.data.id,
                    payload: e,
                    status: "success",
                  });
              } else
                "loadData" === t.data.type &&
                  a.assetLoader.load(
                    t.data.path,
                    t.data.fullPath,
                    function (e) {
                      a.postMessage({
                        id: t.data.id,
                        payload: e,
                        status: "success",
                      });
                    },
                    function () {
                      a.postMessage({ id: t.data.id, status: "error" });
                    }
                  );
            })),
            (e.onmessage = function (t) {
              var e = t.data,
                r = e.id,
                s = i[r];
              (i[r] = null),
                "success" === e.status
                  ? s.onComplete(e.payload)
                  : s.onError && s.onError();
            }));
        }
        function o(t, e) {
          var s = "processId_" + (r += 1);
          return (i[s] = { onComplete: t, onError: e }), s;
        }
        return {
          loadAnimation: function (t, r, i) {
            n();
            var s = o(r, i);
            e.postMessage({
              type: "loadAnimation",
              path: t,
              fullPath: window.location.origin + window.location.pathname,
              id: s,
            });
          },
          loadData: function (t, r, i) {
            n();
            var s = o(r, i);
            e.postMessage({
              type: "loadData",
              path: t,
              fullPath: window.location.origin + window.location.pathname,
              id: s,
            });
          },
          completeAnimation: function (t, r, i) {
            n();
            var s = o(r, i);
            e.postMessage({ type: "complete", animation: t, id: s });
          },
        };
      })(),
      ImagePreloader = (function () {
        var t = (function () {
          var t = createTag("canvas");
          (t.width = 1), (t.height = 1);
          var e = t.getContext("2d");
          return (e.fillStyle = "rgba(0,0,0,0)"), e.fillRect(0, 0, 1, 1), t;
        })();
        function e() {
          (this.loadedAssets += 1),
            this.loadedAssets === this.totalImages &&
              this.loadedFootagesCount === this.totalFootages &&
              this.imagesLoadedCb &&
              this.imagesLoadedCb(null);
        }
        function r() {
          (this.loadedFootagesCount += 1),
            this.loadedAssets === this.totalImages &&
              this.loadedFootagesCount === this.totalFootages &&
              this.imagesLoadedCb &&
              this.imagesLoadedCb(null);
        }
        function i(t, e, r) {
          var i = "";
          if (t.e) i = t.p;
          else if (e) {
            var s = t.p;
            -1 !== s.indexOf("images/") && (s = s.split("/")[1]), (i = e + s);
          } else (i = r), (i += t.u ? t.u : ""), (i += t.p);
          return i;
        }
        function s(t) {
          var e = 0,
            r = setInterval(
              function () {
                (t.getBBox().width || e > 500) &&
                  (this._imageLoaded(), clearInterval(r)),
                  (e += 1);
              }.bind(this),
              50
            );
        }
        function a(t) {
          var e = { assetData: t },
            r = i(t, this.assetsPath, this.path);
          return (
            dataManager.loadData(
              r,
              function (t) {
                (e.img = t), this._footageLoaded();
              }.bind(this),
              function () {
                (e.img = {}), this._footageLoaded();
              }.bind(this)
            ),
            e
          );
        }
        function n() {
          (this._imageLoaded = e.bind(this)),
            (this._footageLoaded = r.bind(this)),
            (this.testImageLoaded = s.bind(this)),
            (this.createFootageData = a.bind(this)),
            (this.assetsPath = ""),
            (this.path = ""),
            (this.totalImages = 0),
            (this.totalFootages = 0),
            (this.loadedAssets = 0),
            (this.loadedFootagesCount = 0),
            (this.imagesLoadedCb = null),
            (this.images = []);
        }
        return (
          (n.prototype = {
            loadAssets: function (t, e) {
              var r;
              this.imagesLoadedCb = e;
              var i = t.length;
              for (r = 0; r < i; r += 1)
                t[r].layers ||
                  (t[r].t && "seq" !== t[r].t
                    ? 3 === t[r].t &&
                      ((this.totalFootages += 1),
                      this.images.push(this.createFootageData(t[r])))
                    : ((this.totalImages += 1),
                      this.images.push(this._createImageData(t[r]))));
            },
            setAssetsPath: function (t) {
              this.assetsPath = t || "";
            },
            setPath: function (t) {
              this.path = t || "";
            },
            loadedImages: function () {
              return this.totalImages === this.loadedAssets;
            },
            loadedFootages: function () {
              return this.totalFootages === this.loadedFootagesCount;
            },
            destroy: function () {
              (this.imagesLoadedCb = null), (this.images.length = 0);
            },
            getAsset: function (t) {
              for (var e = 0, r = this.images.length; e < r; ) {
                if (this.images[e].assetData === t) return this.images[e].img;
                e += 1;
              }
              return null;
            },
            createImgData: function (e) {
              var r = i(e, this.assetsPath, this.path),
                s = createTag("img");
              (s.crossOrigin = "anonymous"),
                s.addEventListener("load", this._imageLoaded, !1),
                s.addEventListener(
                  "error",
                  function () {
                    (a.img = t), this._imageLoaded();
                  }.bind(this),
                  !1
                ),
                (s.src = r);
              var a = { img: s, assetData: e };
              return a;
            },
            createImageData: function (e) {
              var r = i(e, this.assetsPath, this.path),
                s = createNS("image");
              isSafari
                ? this.testImageLoaded(s)
                : s.addEventListener("load", this._imageLoaded, !1),
                s.addEventListener(
                  "error",
                  function () {
                    (a.img = t), this._imageLoaded();
                  }.bind(this),
                  !1
                ),
                s.setAttributeNS("http://www.w3.org/1999/xlink", "href", r),
                this._elementHelper.append
                  ? this._elementHelper.append(s)
                  : this._elementHelper.appendChild(s);
              var a = { img: s, assetData: e };
              return a;
            },
            imageLoaded: e,
            footageLoaded: r,
            setCacheType: function (t, e) {
              "svg" === t
                ? ((this._elementHelper = e),
                  (this._createImageData = this.createImageData.bind(this)))
                : (this._createImageData = this.createImgData.bind(this));
            },
          }),
          n
        );
      })();
    function BaseEvent() {}
    BaseEvent.prototype = {
      triggerEvent: function (t, e) {
        if (this._cbs[t])
          for (var r = this._cbs[t], i = 0; i < r.length; i += 1) r[i](e);
      },
      addEventListener: function (t, e) {
        return (
          this._cbs[t] || (this._cbs[t] = []),
          this._cbs[t].push(e),
          function () {
            this.removeEventListener(t, e);
          }.bind(this)
        );
      },
      removeEventListener: function (t, e) {
        if (e) {
          if (this._cbs[t]) {
            for (var r = 0, i = this._cbs[t].length; r < i; )
              this._cbs[t][r] === e &&
                (this._cbs[t].splice(r, 1), (r -= 1), (i -= 1)),
                (r += 1);
            this._cbs[t].length || (this._cbs[t] = null);
          }
        } else this._cbs[t] = null;
      },
    };
    var markerParser = (function () {
        function t(t) {
          for (
            var e, r = t.split("\r\n"), i = {}, s = 0, a = 0;
            a < r.length;
            a += 1
          )
            2 === (e = r[a].split(":")).length &&
              ((i[e[0]] = e[1].trim()), (s += 1));
          if (0 === s) throw new Error();
          return i;
        }
        return function (e) {
          for (var r = [], i = 0; i < e.length; i += 1) {
            var s = e[i],
              a = { time: s.tm, duration: s.dr };
            try {
              a.payload = JSON.parse(e[i].cm);
            } catch (r) {
              try {
                a.payload = t(e[i].cm);
              } catch (t) {
                a.payload = { name: e[i].cm };
              }
            }
            r.push(a);
          }
          return r;
        };
      })(),
      ProjectInterface = (function () {
        function t(t) {
          this.compositions.push(t);
        }
        return function () {
          function e(t) {
            for (var e = 0, r = this.compositions.length; e < r; ) {
              if (
                this.compositions[e].data &&
                this.compositions[e].data.nm === t
              )
                return (
                  this.compositions[e].prepareFrame &&
                    this.compositions[e].data.xt &&
                    this.compositions[e].prepareFrame(this.currentFrame),
                  this.compositions[e].compInterface
                );
              e += 1;
            }
            return null;
          }
          return (
            (e.compositions = []),
            (e.currentFrame = 0),
            (e.registerComposition = t),
            e
          );
        };
      })(),
      renderers = {},
      registerRenderer = function (t, e) {
        renderers[t] = e;
      };
    function getRenderer(t) {
      return renderers[t];
    }
    function _typeof$4(t) {
      return (
        (_typeof$4 =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
                return typeof t;
              }
            : function (t) {
                return t &&
                  "function" == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              }),
        _typeof$4(t)
      );
    }
    var AnimationItem = function () {
      (this._cbs = []),
        (this.name = ""),
        (this.path = ""),
        (this.isLoaded = !1),
        (this.currentFrame = 0),
        (this.currentRawFrame = 0),
        (this.firstFrame = 0),
        (this.totalFrames = 0),
        (this.frameRate = 0),
        (this.frameMult = 0),
        (this.playSpeed = 1),
        (this.playDirection = 1),
        (this.playCount = 0),
        (this.animationData = {}),
        (this.assets = []),
        (this.isPaused = !0),
        (this.autoplay = !1),
        (this.loop = !0),
        (this.renderer = null),
        (this.animationID = createElementID()),
        (this.assetsPath = ""),
        (this.timeCompleted = 0),
        (this.segmentPos = 0),
        (this.isSubframeEnabled = getSubframeEnabled()),
        (this.segments = []),
        (this._idle = !0),
        (this._completedLoop = !1),
        (this.projectInterface = ProjectInterface()),
        (this.imagePreloader = new ImagePreloader()),
        (this.audioController = audioControllerFactory()),
        (this.markers = []),
        (this.configAnimation = this.configAnimation.bind(this)),
        (this.onSetupError = this.onSetupError.bind(this)),
        (this.onSegmentComplete = this.onSegmentComplete.bind(this)),
        (this.drawnFrameEvent = new BMEnterFrameEvent("drawnFrame", 0, 0, 0));
    };
    extendPrototype([BaseEvent], AnimationItem),
      (AnimationItem.prototype.setParams = function (t) {
        (t.wrapper || t.container) && (this.wrapper = t.wrapper || t.container);
        var e = "svg";
        t.animType ? (e = t.animType) : t.renderer && (e = t.renderer);
        var r = getRenderer(e);
        (this.renderer = new r(this, t.rendererSettings)),
          this.imagePreloader.setCacheType(e, this.renderer.globalData.defs),
          this.renderer.setProjectInterface(this.projectInterface),
          (this.animType = e),
          "" === t.loop || null === t.loop || void 0 === t.loop || !0 === t.loop
            ? (this.loop = !0)
            : !1 === t.loop
            ? (this.loop = !1)
            : (this.loop = parseInt(t.loop, 10)),
          (this.autoplay = !("autoplay" in t) || t.autoplay),
          (this.name = t.name ? t.name : ""),
          (this.autoloadSegments =
            !Object.prototype.hasOwnProperty.call(t, "autoloadSegments") ||
            t.autoloadSegments),
          (this.assetsPath = t.assetsPath),
          (this.initialSegment = t.initialSegment),
          t.audioFactory &&
            this.audioController.setAudioFactory(t.audioFactory),
          t.animationData
            ? this.setupAnimation(t.animationData)
            : t.path &&
              (-1 !== t.path.lastIndexOf("\\")
                ? (this.path = t.path.substr(0, t.path.lastIndexOf("\\") + 1))
                : (this.path = t.path.substr(0, t.path.lastIndexOf("/") + 1)),
              (this.fileName = t.path.substr(t.path.lastIndexOf("/") + 1)),
              (this.fileName = this.fileName.substr(
                0,
                this.fileName.lastIndexOf(".json")
              )),
              dataManager.loadAnimation(
                t.path,
                this.configAnimation,
                this.onSetupError
              ));
      }),
      (AnimationItem.prototype.onSetupError = function () {
        this.trigger("data_failed");
      }),
      (AnimationItem.prototype.setupAnimation = function (t) {
        dataManager.completeAnimation(t, this.configAnimation);
      }),
      (AnimationItem.prototype.setData = function (t, e) {
        e && "object" !== _typeof$4(e) && (e = JSON.parse(e));
        var r = { wrapper: t, animationData: e },
          i = t.attributes;
        (r.path = i.getNamedItem("data-animation-path")
          ? i.getNamedItem("data-animation-path").value
          : i.getNamedItem("data-bm-path")
          ? i.getNamedItem("data-bm-path").value
          : i.getNamedItem("bm-path")
          ? i.getNamedItem("bm-path").value
          : ""),
          (r.animType = i.getNamedItem("data-anim-type")
            ? i.getNamedItem("data-anim-type").value
            : i.getNamedItem("data-bm-type")
            ? i.getNamedItem("data-bm-type").value
            : i.getNamedItem("bm-type")
            ? i.getNamedItem("bm-type").value
            : i.getNamedItem("data-bm-renderer")
            ? i.getNamedItem("data-bm-renderer").value
            : i.getNamedItem("bm-renderer")
            ? i.getNamedItem("bm-renderer").value
            : "canvas");
        var s = i.getNamedItem("data-anim-loop")
          ? i.getNamedItem("data-anim-loop").value
          : i.getNamedItem("data-bm-loop")
          ? i.getNamedItem("data-bm-loop").value
          : i.getNamedItem("bm-loop")
          ? i.getNamedItem("bm-loop").value
          : "";
        "false" === s
          ? (r.loop = !1)
          : "true" === s
          ? (r.loop = !0)
          : "" !== s && (r.loop = parseInt(s, 10));
        var a = i.getNamedItem("data-anim-autoplay")
          ? i.getNamedItem("data-anim-autoplay").value
          : i.getNamedItem("data-bm-autoplay")
          ? i.getNamedItem("data-bm-autoplay").value
          : !i.getNamedItem("bm-autoplay") ||
            i.getNamedItem("bm-autoplay").value;
        (r.autoplay = "false" !== a),
          (r.name = i.getNamedItem("data-name")
            ? i.getNamedItem("data-name").value
            : i.getNamedItem("data-bm-name")
            ? i.getNamedItem("data-bm-name").value
            : i.getNamedItem("bm-name")
            ? i.getNamedItem("bm-name").value
            : ""),
          "false" ===
            (i.getNamedItem("data-anim-prerender")
              ? i.getNamedItem("data-anim-prerender").value
              : i.getNamedItem("data-bm-prerender")
              ? i.getNamedItem("data-bm-prerender").value
              : i.getNamedItem("bm-prerender")
              ? i.getNamedItem("bm-prerender").value
              : "") && (r.prerender = !1),
          this.setParams(r);
      }),
      (AnimationItem.prototype.includeLayers = function (t) {
        t.op > this.animationData.op &&
          ((this.animationData.op = t.op),
          (this.totalFrames = Math.floor(t.op - this.animationData.ip)));
        var e,
          r,
          i = this.animationData.layers,
          s = i.length,
          a = t.layers,
          n = a.length;
        for (r = 0; r < n; r += 1)
          for (e = 0; e < s; ) {
            if (i[e].id === a[r].id) {
              i[e] = a[r];
              break;
            }
            e += 1;
          }
        if (
          ((t.chars || t.fonts) &&
            (this.renderer.globalData.fontManager.addChars(t.chars),
            this.renderer.globalData.fontManager.addFonts(
              t.fonts,
              this.renderer.globalData.defs
            )),
          t.assets)
        )
          for (s = t.assets.length, e = 0; e < s; e += 1)
            this.animationData.assets.push(t.assets[e]);
        (this.animationData.__complete = !1),
          dataManager.completeAnimation(
            this.animationData,
            this.onSegmentComplete
          );
      }),
      (AnimationItem.prototype.onSegmentComplete = function (t) {
        this.animationData = t;
        var e = getExpressionsPlugin();
        e && e.initExpressions(this), this.loadNextSegment();
      }),
      (AnimationItem.prototype.loadNextSegment = function () {
        var t = this.animationData.segments;
        if (!t || 0 === t.length || !this.autoloadSegments)
          return (
            this.trigger("data_ready"),
            void (this.timeCompleted = this.totalFrames)
          );
        var e = t.shift();
        this.timeCompleted = e.time * this.frameRate;
        var r = this.path + this.fileName + "_" + this.segmentPos + ".json";
        (this.segmentPos += 1),
          dataManager.loadData(
            r,
            this.includeLayers.bind(this),
            function () {
              this.trigger("data_failed");
            }.bind(this)
          );
      }),
      (AnimationItem.prototype.loadSegments = function () {
        this.animationData.segments || (this.timeCompleted = this.totalFrames),
          this.loadNextSegment();
      }),
      (AnimationItem.prototype.imagesLoaded = function () {
        this.trigger("loaded_images"), this.checkLoaded();
      }),
      (AnimationItem.prototype.preloadImages = function () {
        this.imagePreloader.setAssetsPath(this.assetsPath),
          this.imagePreloader.setPath(this.path),
          this.imagePreloader.loadAssets(
            this.animationData.assets,
            this.imagesLoaded.bind(this)
          );
      }),
      (AnimationItem.prototype.configAnimation = function (t) {
        if (this.renderer)
          try {
            (this.animationData = t),
              this.initialSegment
                ? ((this.totalFrames = Math.floor(
                    this.initialSegment[1] - this.initialSegment[0]
                  )),
                  (this.firstFrame = Math.round(this.initialSegment[0])))
                : ((this.totalFrames = Math.floor(
                    this.animationData.op - this.animationData.ip
                  )),
                  (this.firstFrame = Math.round(this.animationData.ip))),
              this.renderer.configAnimation(t),
              t.assets || (t.assets = []),
              (this.assets = this.animationData.assets),
              (this.frameRate = this.animationData.fr),
              (this.frameMult = this.animationData.fr / 1e3),
              this.renderer.searchExtraCompositions(t.assets),
              (this.markers = markerParser(t.markers || [])),
              this.trigger("config_ready"),
              this.preloadImages(),
              this.loadSegments(),
              this.updaFrameModifier(),
              this.waitForFontsLoaded(),
              this.isPaused && this.audioController.pause();
          } catch (t) {
            this.triggerConfigError(t);
          }
      }),
      (AnimationItem.prototype.waitForFontsLoaded = function () {
        this.renderer &&
          (this.renderer.globalData.fontManager.isLoaded
            ? this.checkLoaded()
            : setTimeout(this.waitForFontsLoaded.bind(this), 20));
      }),
      (AnimationItem.prototype.checkLoaded = function () {
        if (
          !this.isLoaded &&
          this.renderer.globalData.fontManager.isLoaded &&
          (this.imagePreloader.loadedImages() ||
            "canvas" !== this.renderer.rendererType) &&
          this.imagePreloader.loadedFootages()
        ) {
          this.isLoaded = !0;
          var t = getExpressionsPlugin();
          t && t.initExpressions(this),
            this.renderer.initItems(),
            setTimeout(
              function () {
                this.trigger("DOMLoaded");
              }.bind(this),
              0
            ),
            this.gotoFrame(),
            this.autoplay && this.play();
        }
      }),
      (AnimationItem.prototype.resize = function () {
        this.renderer.updateContainerSize();
      }),
      (AnimationItem.prototype.setSubframe = function (t) {
        this.isSubframeEnabled = !!t;
      }),
      (AnimationItem.prototype.gotoFrame = function () {
        (this.currentFrame = this.isSubframeEnabled
          ? this.currentRawFrame
          : ~~this.currentRawFrame),
          this.timeCompleted !== this.totalFrames &&
            this.currentFrame > this.timeCompleted &&
            (this.currentFrame = this.timeCompleted),
          this.trigger("enterFrame"),
          this.renderFrame(),
          this.trigger("drawnFrame");
      }),
      (AnimationItem.prototype.renderFrame = function () {
        if (!1 !== this.isLoaded && this.renderer)
          try {
            this.renderer.renderFrame(this.currentFrame + this.firstFrame);
          } catch (t) {
            this.triggerRenderFrameError(t);
          }
      }),
      (AnimationItem.prototype.play = function (t) {
        (t && this.name !== t) ||
          (!0 === this.isPaused &&
            ((this.isPaused = !1),
            this.trigger("_pause"),
            this.audioController.resume(),
            this._idle && ((this._idle = !1), this.trigger("_active"))));
      }),
      (AnimationItem.prototype.pause = function (t) {
        (t && this.name !== t) ||
          (!1 === this.isPaused &&
            ((this.isPaused = !0),
            this.trigger("_play"),
            (this._idle = !0),
            this.trigger("_idle"),
            this.audioController.pause()));
      }),
      (AnimationItem.prototype.togglePause = function (t) {
        (t && this.name !== t) ||
          (!0 === this.isPaused ? this.play() : this.pause());
      }),
      (AnimationItem.prototype.stop = function (t) {
        (t && this.name !== t) ||
          (this.pause(),
          (this.playCount = 0),
          (this._completedLoop = !1),
          this.setCurrentRawFrameValue(0));
      }),
      (AnimationItem.prototype.getMarkerData = function (t) {
        for (var e, r = 0; r < this.markers.length; r += 1)
          if ((e = this.markers[r]).payload && e.payload.name === t) return e;
        return null;
      }),
      (AnimationItem.prototype.goToAndStop = function (t, e, r) {
        if (!r || this.name === r) {
          var i = Number(t);
          if (isNaN(i)) {
            var s = this.getMarkerData(t);
            s && this.goToAndStop(s.time, !0);
          } else
            e
              ? this.setCurrentRawFrameValue(t)
              : this.setCurrentRawFrameValue(t * this.frameModifier);
          this.pause();
        }
      }),
      (AnimationItem.prototype.goToAndPlay = function (t, e, r) {
        if (!r || this.name === r) {
          var i = Number(t);
          if (isNaN(i)) {
            var s = this.getMarkerData(t);
            s &&
              (s.duration
                ? this.playSegments([s.time, s.time + s.duration], !0)
                : this.goToAndStop(s.time, !0));
          } else this.goToAndStop(i, e, r);
          this.play();
        }
      }),
      (AnimationItem.prototype.advanceTime = function (t) {
        if (!0 !== this.isPaused && !1 !== this.isLoaded) {
          var e = this.currentRawFrame + t * this.frameModifier,
            r = !1;
          e >= this.totalFrames - 1 && this.frameModifier > 0
            ? this.loop && this.playCount !== this.loop
              ? e >= this.totalFrames
                ? ((this.playCount += 1),
                  this.checkSegments(e % this.totalFrames) ||
                    (this.setCurrentRawFrameValue(e % this.totalFrames),
                    (this._completedLoop = !0),
                    this.trigger("loopComplete")))
                : this.setCurrentRawFrameValue(e)
              : this.checkSegments(
                  e > this.totalFrames ? e % this.totalFrames : 0
                ) || ((r = !0), (e = this.totalFrames - 1))
            : e < 0
            ? this.checkSegments(e % this.totalFrames) ||
              (!this.loop || (this.playCount-- <= 0 && !0 !== this.loop)
                ? ((r = !0), (e = 0))
                : (this.setCurrentRawFrameValue(
                    this.totalFrames + (e % this.totalFrames)
                  ),
                  this._completedLoop
                    ? this.trigger("loopComplete")
                    : (this._completedLoop = !0)))
            : this.setCurrentRawFrameValue(e),
            r &&
              (this.setCurrentRawFrameValue(e),
              this.pause(),
              this.trigger("complete"));
        }
      }),
      (AnimationItem.prototype.adjustSegment = function (t, e) {
        (this.playCount = 0),
          t[1] < t[0]
            ? (this.frameModifier > 0 &&
                (this.playSpeed < 0
                  ? this.setSpeed(-this.playSpeed)
                  : this.setDirection(-1)),
              (this.totalFrames = t[0] - t[1]),
              (this.timeCompleted = this.totalFrames),
              (this.firstFrame = t[1]),
              this.setCurrentRawFrameValue(this.totalFrames - 0.001 - e))
            : t[1] > t[0] &&
              (this.frameModifier < 0 &&
                (this.playSpeed < 0
                  ? this.setSpeed(-this.playSpeed)
                  : this.setDirection(1)),
              (this.totalFrames = t[1] - t[0]),
              (this.timeCompleted = this.totalFrames),
              (this.firstFrame = t[0]),
              this.setCurrentRawFrameValue(0.001 + e)),
          this.trigger("segmentStart");
      }),
      (AnimationItem.prototype.setSegment = function (t, e) {
        var r = -1;
        this.isPaused &&
          (this.currentRawFrame + this.firstFrame < t
            ? (r = t)
            : this.currentRawFrame + this.firstFrame > e && (r = e - t)),
          (this.firstFrame = t),
          (this.totalFrames = e - t),
          (this.timeCompleted = this.totalFrames),
          -1 !== r && this.goToAndStop(r, !0);
      }),
      (AnimationItem.prototype.playSegments = function (t, e) {
        if ((e && (this.segments.length = 0), "object" === _typeof$4(t[0]))) {
          var r,
            i = t.length;
          for (r = 0; r < i; r += 1) this.segments.push(t[r]);
        } else this.segments.push(t);
        this.segments.length &&
          e &&
          this.adjustSegment(this.segments.shift(), 0),
          this.isPaused && this.play();
      }),
      (AnimationItem.prototype.resetSegments = function (t) {
        (this.segments.length = 0),
          this.segments.push([this.animationData.ip, this.animationData.op]),
          t && this.checkSegments(0);
      }),
      (AnimationItem.prototype.checkSegments = function (t) {
        return (
          !!this.segments.length &&
          (this.adjustSegment(this.segments.shift(), t), !0)
        );
      }),
      (AnimationItem.prototype.destroy = function (t) {
        (t && this.name !== t) ||
          !this.renderer ||
          (this.renderer.destroy(),
          this.imagePreloader.destroy(),
          this.trigger("destroy"),
          (this._cbs = null),
          (this.onEnterFrame = null),
          (this.onLoopComplete = null),
          (this.onComplete = null),
          (this.onSegmentStart = null),
          (this.onDestroy = null),
          (this.renderer = null),
          (this.renderer = null),
          (this.imagePreloader = null),
          (this.projectInterface = null));
      }),
      (AnimationItem.prototype.setCurrentRawFrameValue = function (t) {
        (this.currentRawFrame = t), this.gotoFrame();
      }),
      (AnimationItem.prototype.setSpeed = function (t) {
        (this.playSpeed = t), this.updaFrameModifier();
      }),
      (AnimationItem.prototype.setDirection = function (t) {
        (this.playDirection = t < 0 ? -1 : 1), this.updaFrameModifier();
      }),
      (AnimationItem.prototype.setVolume = function (t, e) {
        (e && this.name !== e) || this.audioController.setVolume(t);
      }),
      (AnimationItem.prototype.getVolume = function () {
        return this.audioController.getVolume();
      }),
      (AnimationItem.prototype.mute = function (t) {
        (t && this.name !== t) || this.audioController.mute();
      }),
      (AnimationItem.prototype.unmute = function (t) {
        (t && this.name !== t) || this.audioController.unmute();
      }),
      (AnimationItem.prototype.updaFrameModifier = function () {
        (this.frameModifier =
          this.frameMult * this.playSpeed * this.playDirection),
          this.audioController.setRate(this.playSpeed * this.playDirection);
      }),
      (AnimationItem.prototype.getPath = function () {
        return this.path;
      }),
      (AnimationItem.prototype.getAssetsPath = function (t) {
        var e = "";
        if (t.e) e = t.p;
        else if (this.assetsPath) {
          var r = t.p;
          -1 !== r.indexOf("images/") && (r = r.split("/")[1]),
            (e = this.assetsPath + r);
        } else (e = this.path), (e += t.u ? t.u : ""), (e += t.p);
        return e;
      }),
      (AnimationItem.prototype.getAssetData = function (t) {
        for (var e = 0, r = this.assets.length; e < r; ) {
          if (t === this.assets[e].id) return this.assets[e];
          e += 1;
        }
        return null;
      }),
      (AnimationItem.prototype.hide = function () {
        this.renderer.hide();
      }),
      (AnimationItem.prototype.show = function () {
        this.renderer.show();
      }),
      (AnimationItem.prototype.getDuration = function (t) {
        return t ? this.totalFrames : this.totalFrames / this.frameRate;
      }),
      (AnimationItem.prototype.updateDocumentData = function (t, e, r) {
        try {
          this.renderer.getElementByPath(t).updateDocumentData(e, r);
        } catch (t) {}
      }),
      (AnimationItem.prototype.trigger = function (t) {
        if (this._cbs && this._cbs[t])
          switch (t) {
            case "enterFrame":
              this.triggerEvent(
                t,
                new BMEnterFrameEvent(
                  t,
                  this.currentFrame,
                  this.totalFrames,
                  this.frameModifier
                )
              );
              break;
            case "drawnFrame":
              (this.drawnFrameEvent.currentTime = this.currentFrame),
                (this.drawnFrameEvent.totalTime = this.totalFrames),
                (this.drawnFrameEvent.direction = this.frameModifier),
                this.triggerEvent(t, this.drawnFrameEvent);
              break;
            case "loopComplete":
              this.triggerEvent(
                t,
                new BMCompleteLoopEvent(
                  t,
                  this.loop,
                  this.playCount,
                  this.frameMult
                )
              );
              break;
            case "complete":
              this.triggerEvent(t, new BMCompleteEvent(t, this.frameMult));
              break;
            case "segmentStart":
              this.triggerEvent(
                t,
                new BMSegmentStartEvent(t, this.firstFrame, this.totalFrames)
              );
              break;
            case "destroy":
              this.triggerEvent(t, new BMDestroyEvent(t, this));
              break;
            default:
              this.triggerEvent(t);
          }
        "enterFrame" === t &&
          this.onEnterFrame &&
          this.onEnterFrame.call(
            this,
            new BMEnterFrameEvent(
              t,
              this.currentFrame,
              this.totalFrames,
              this.frameMult
            )
          ),
          "loopComplete" === t &&
            this.onLoopComplete &&
            this.onLoopComplete.call(
              this,
              new BMCompleteLoopEvent(
                t,
                this.loop,
                this.playCount,
                this.frameMult
              )
            ),
          "complete" === t &&
            this.onComplete &&
            this.onComplete.call(this, new BMCompleteEvent(t, this.frameMult)),
          "segmentStart" === t &&
            this.onSegmentStart &&
            this.onSegmentStart.call(
              this,
              new BMSegmentStartEvent(t, this.firstFrame, this.totalFrames)
            ),
          "destroy" === t &&
            this.onDestroy &&
            this.onDestroy.call(this, new BMDestroyEvent(t, this));
      }),
      (AnimationItem.prototype.triggerRenderFrameError = function (t) {
        var e = new BMRenderFrameErrorEvent(t, this.currentFrame);
        this.triggerEvent("error", e),
          this.onError && this.onError.call(this, e);
      }),
      (AnimationItem.prototype.triggerConfigError = function (t) {
        var e = new BMConfigErrorEvent(t, this.currentFrame);
        this.triggerEvent("error", e),
          this.onError && this.onError.call(this, e);
      });
    var animationManager = (function () {
        var t = {},
          e = [],
          r = 0,
          i = 0,
          s = 0,
          a = !0,
          n = !1;
        function o(t) {
          for (var r = 0, s = t.target; r < i; )
            e[r].animation === s &&
              (e.splice(r, 1), (r -= 1), (i -= 1), s.isPaused || p()),
              (r += 1);
        }
        function h(t, r) {
          if (!t) return null;
          for (var s = 0; s < i; ) {
            if (e[s].elem === t && null !== e[s].elem) return e[s].animation;
            s += 1;
          }
          var a = new AnimationItem();
          return f(a, t), a.setData(t, r), a;
        }
        function l() {
          (s += 1), d();
        }
        function p() {
          s -= 1;
        }
        function f(t, r) {
          t.addEventListener("destroy", o),
            t.addEventListener("_active", l),
            t.addEventListener("_idle", p),
            e.push({ elem: r, animation: t }),
            (i += 1);
        }
        function m(t) {
          var o,
            h = t - r;
          for (o = 0; o < i; o += 1) e[o].animation.advanceTime(h);
          (r = t), s && !n ? window.requestAnimationFrame(m) : (a = !0);
        }
        function c(t) {
          (r = t), window.requestAnimationFrame(m);
        }
        function d() {
          !n && s && a && (window.requestAnimationFrame(c), (a = !1));
        }
        return (
          (t.registerAnimation = h),
          (t.loadAnimation = function (t) {
            var e = new AnimationItem();
            return f(e, null), e.setParams(t), e;
          }),
          (t.setSpeed = function (t, r) {
            var s;
            for (s = 0; s < i; s += 1) e[s].animation.setSpeed(t, r);
          }),
          (t.setDirection = function (t, r) {
            var s;
            for (s = 0; s < i; s += 1) e[s].animation.setDirection(t, r);
          }),
          (t.play = function (t) {
            var r;
            for (r = 0; r < i; r += 1) e[r].animation.play(t);
          }),
          (t.pause = function (t) {
            var r;
            for (r = 0; r < i; r += 1) e[r].animation.pause(t);
          }),
          (t.stop = function (t) {
            var r;
            for (r = 0; r < i; r += 1) e[r].animation.stop(t);
          }),
          (t.togglePause = function (t) {
            var r;
            for (r = 0; r < i; r += 1) e[r].animation.togglePause(t);
          }),
          (t.searchAnimations = function (t, e, r) {
            var i,
              s = [].concat(
                [].slice.call(document.getElementsByClassName("lottie")),
                [].slice.call(document.getElementsByClassName("bodymovin"))
              ),
              a = s.length;
            for (i = 0; i < a; i += 1)
              r && s[i].setAttribute("data-bm-type", r), h(s[i], t);
            if (e && 0 === a) {
              r || (r = "svg");
              var n = document.getElementsByTagName("body")[0];
              n.innerText = "";
              var o = createTag("div");
              (o.style.width = "100%"),
                (o.style.height = "100%"),
                o.setAttribute("data-bm-type", r),
                n.appendChild(o),
                h(o, t);
            }
          }),
          (t.resize = function () {
            var t;
            for (t = 0; t < i; t += 1) e[t].animation.resize();
          }),
          (t.goToAndStop = function (t, r, s) {
            var a;
            for (a = 0; a < i; a += 1) e[a].animation.goToAndStop(t, r, s);
          }),
          (t.destroy = function (t) {
            var r;
            for (r = i - 1; r >= 0; r -= 1) e[r].animation.destroy(t);
          }),
          (t.freeze = function () {
            n = !0;
          }),
          (t.unfreeze = function () {
            (n = !1), d();
          }),
          (t.setVolume = function (t, r) {
            var s;
            for (s = 0; s < i; s += 1) e[s].animation.setVolume(t, r);
          }),
          (t.mute = function (t) {
            var r;
            for (r = 0; r < i; r += 1) e[r].animation.mute(t);
          }),
          (t.unmute = function (t) {
            var r;
            for (r = 0; r < i; r += 1) e[r].animation.unmute(t);
          }),
          (t.getRegisteredAnimations = function () {
            var t,
              r = e.length,
              i = [];
            for (t = 0; t < r; t += 1) i.push(e[t].animation);
            return i;
          }),
          t
        );
      })(),
      BezierFactory = (function () {
        var t = {
            getBezierEasing: function (t, r, i, s, a) {
              var n =
                a ||
                ("bez_" + t + "_" + r + "_" + i + "_" + s).replace(/\./g, "p");
              if (e[n]) return e[n];
              var o = new l([t, r, i, s]);
              return (e[n] = o), o;
            },
          },
          e = {};
        var r = 0.1,
          i = "function" == typeof Float32Array;
        function s(t, e) {
          return 1 - 3 * e + 3 * t;
        }
        function a(t, e) {
          return 3 * e - 6 * t;
        }
        function n(t) {
          return 3 * t;
        }
        function o(t, e, r) {
          return ((s(e, r) * t + a(e, r)) * t + n(e)) * t;
        }
        function h(t, e, r) {
          return 3 * s(e, r) * t * t + 2 * a(e, r) * t + n(e);
        }
        function l(t) {
          (this._p = t),
            (this._mSampleValues = i ? new Float32Array(11) : new Array(11)),
            (this._precomputed = !1),
            (this.get = this.get.bind(this));
        }
        return (
          (l.prototype = {
            get: function (t) {
              var e = this._p[0],
                r = this._p[1],
                i = this._p[2],
                s = this._p[3];
              return (
                this._precomputed || this._precompute(),
                e === r && i === s
                  ? t
                  : 0 === t
                  ? 0
                  : 1 === t
                  ? 1
                  : o(this._getTForX(t), r, s)
              );
            },
            _precompute: function () {
              var t = this._p[0],
                e = this._p[1],
                r = this._p[2],
                i = this._p[3];
              (this._precomputed = !0),
                (t === e && r === i) || this._calcSampleValues();
            },
            _calcSampleValues: function () {
              for (var t = this._p[0], e = this._p[2], i = 0; i < 11; ++i)
                this._mSampleValues[i] = o(i * r, t, e);
            },
            _getTForX: function (t) {
              for (
                var e = this._p[0],
                  i = this._p[2],
                  s = this._mSampleValues,
                  a = 0,
                  n = 1;
                10 !== n && s[n] <= t;
                ++n
              )
                a += r;
              var l = a + ((t - s[--n]) / (s[n + 1] - s[n])) * r,
                p = h(l, e, i);
              return p >= 0.001
                ? (function (t, e, r, i) {
                    for (var s = 0; s < 4; ++s) {
                      var a = h(e, r, i);
                      if (0 === a) return e;
                      e -= (o(e, r, i) - t) / a;
                    }
                    return e;
                  })(t, l, e, i)
                : 0 === p
                ? l
                : (function (t, e, r, i, s) {
                    var a,
                      n,
                      h = 0;
                    do {
                      (a = o((n = e + (r - e) / 2), i, s) - t) > 0
                        ? (r = n)
                        : (e = n);
                    } while (Math.abs(a) > 1e-7 && ++h < 10);
                    return n;
                  })(t, a, a + r, e, i);
            },
          }),
          t
        );
      })(),
      pooling = {
        double: function (t) {
          return t.concat(createSizedArray(t.length));
        },
      },
      poolFactory = function (t, e, r) {
        var i = 0,
          s = t,
          a = createSizedArray(s);
        return {
          newElement: function () {
            return i ? a[(i -= 1)] : e();
          },
          release: function (t) {
            i === s && ((a = pooling.double(a)), (s *= 2)),
              r && r(t),
              (a[i] = t),
              (i += 1);
          },
        };
      },
      bezierLengthPool = poolFactory(8, function () {
        return {
          addedLength: 0,
          percents: createTypedArray("float32", getDefaultCurveSegments()),
          lengths: createTypedArray("float32", getDefaultCurveSegments()),
        };
      }),
      segmentsLengthPool = poolFactory(
        8,
        function () {
          return { lengths: [], totalLength: 0 };
        },
        function (t) {
          var e,
            r = t.lengths.length;
          for (e = 0; e < r; e += 1) bezierLengthPool.release(t.lengths[e]);
          t.lengths.length = 0;
        }
      );
    function bezFunction() {
      var t = Math;
      function e(t, e, r, i, s, a) {
        var n = t * i + e * s + r * a - s * i - a * t - r * e;
        return n > -0.001 && n < 0.001;
      }
      var r = function (t, e, r, i) {
        var s,
          a,
          n,
          o,
          h,
          l,
          p = getDefaultCurveSegments(),
          f = 0,
          m = [],
          c = [],
          d = bezierLengthPool.newElement();
        for (n = r.length, s = 0; s < p; s += 1) {
          for (h = s / (p - 1), l = 0, a = 0; a < n; a += 1)
            (o =
              bmPow(1 - h, 3) * t[a] +
              3 * bmPow(1 - h, 2) * h * r[a] +
              3 * (1 - h) * bmPow(h, 2) * i[a] +
              bmPow(h, 3) * e[a]),
              (m[a] = o),
              null !== c[a] && (l += bmPow(m[a] - c[a], 2)),
              (c[a] = m[a]);
          l && (f += l = bmSqrt(l)), (d.percents[s] = h), (d.lengths[s] = f);
        }
        return (d.addedLength = f), d;
      };
      function i(t) {
        (this.segmentLength = 0), (this.points = new Array(t));
      }
      function s(t, e) {
        (this.partialLength = t), (this.point = e);
      }
      var a,
        n =
          ((a = {}),
          function (t, r, n, o) {
            var h = (
              t[0] +
              "_" +
              t[1] +
              "_" +
              r[0] +
              "_" +
              r[1] +
              "_" +
              n[0] +
              "_" +
              n[1] +
              "_" +
              o[0] +
              "_" +
              o[1]
            ).replace(/\./g, "p");
            if (!a[h]) {
              var l,
                p,
                f,
                m,
                c,
                d,
                u,
                y = getDefaultCurveSegments(),
                g = 0,
                v = null;
              2 === t.length &&
                (t[0] !== r[0] || t[1] !== r[1]) &&
                e(t[0], t[1], r[0], r[1], t[0] + n[0], t[1] + n[1]) &&
                e(t[0], t[1], r[0], r[1], r[0] + o[0], r[1] + o[1]) &&
                (y = 2);
              var b = new i(y);
              for (f = n.length, l = 0; l < y; l += 1) {
                for (
                  u = createSizedArray(f), c = l / (y - 1), d = 0, p = 0;
                  p < f;
                  p += 1
                )
                  (m =
                    bmPow(1 - c, 3) * t[p] +
                    3 * bmPow(1 - c, 2) * c * (t[p] + n[p]) +
                    3 * (1 - c) * bmPow(c, 2) * (r[p] + o[p]) +
                    bmPow(c, 3) * r[p]),
                    (u[p] = m),
                    null !== v && (d += bmPow(u[p] - v[p], 2));
                (g += d = bmSqrt(d)), (b.points[l] = new s(d, u)), (v = u);
              }
              (b.segmentLength = g), (a[h] = b);
            }
            return a[h];
          });
      function o(t, e) {
        var r = e.percents,
          i = e.lengths,
          s = r.length,
          a = bmFloor((s - 1) * t),
          n = t * e.addedLength,
          o = 0;
        if (a === s - 1 || 0 === a || n === i[a]) return r[a];
        for (var h = i[a] > n ? -1 : 1, l = !0; l; )
          if (
            (i[a] <= n && i[a + 1] > n
              ? ((o = (n - i[a]) / (i[a + 1] - i[a])), (l = !1))
              : (a += h),
            a < 0 || a >= s - 1)
          ) {
            if (a === s - 1) return r[a];
            l = !1;
          }
        return r[a] + (r[a + 1] - r[a]) * o;
      }
      var h = createTypedArray("float32", 8);
      return {
        getSegmentsLength: function (t) {
          var e,
            i = segmentsLengthPool.newElement(),
            s = t.c,
            a = t.v,
            n = t.o,
            o = t.i,
            h = t._length,
            l = i.lengths,
            p = 0;
          for (e = 0; e < h - 1; e += 1)
            (l[e] = r(a[e], a[e + 1], n[e], o[e + 1])), (p += l[e].addedLength);
          return (
            s &&
              h &&
              ((l[e] = r(a[e], a[0], n[e], o[0])), (p += l[e].addedLength)),
            (i.totalLength = p),
            i
          );
        },
        getNewSegment: function (e, r, i, s, a, n, l) {
          a < 0 ? (a = 0) : a > 1 && (a = 1);
          var p,
            f = o(a, l),
            m = o((n = n > 1 ? 1 : n), l),
            c = e.length,
            d = 1 - f,
            u = 1 - m,
            y = d * d * d,
            g = f * d * d * 3,
            v = f * f * d * 3,
            b = f * f * f,
            P = d * d * u,
            E = f * d * u + d * f * u + d * d * m,
            x = f * f * u + d * f * m + f * d * m,
            S = f * f * m,
            _ = d * u * u,
            C = f * u * u + d * m * u + d * u * m,
            A = f * m * u + d * m * m + f * u * m,
            T = f * m * m,
            D = u * u * u,
            k = m * u * u + u * m * u + u * u * m,
            M = m * m * u + u * m * m + m * u * m,
            F = m * m * m;
          for (p = 0; p < c; p += 1)
            (h[4 * p] =
              t.round(1e3 * (y * e[p] + g * i[p] + v * s[p] + b * r[p])) / 1e3),
              (h[4 * p + 1] =
                t.round(1e3 * (P * e[p] + E * i[p] + x * s[p] + S * r[p])) /
                1e3),
              (h[4 * p + 2] =
                t.round(1e3 * (_ * e[p] + C * i[p] + A * s[p] + T * r[p])) /
                1e3),
              (h[4 * p + 3] =
                t.round(1e3 * (D * e[p] + k * i[p] + M * s[p] + F * r[p])) /
                1e3);
          return h;
        },
        getPointInSegment: function (e, r, i, s, a, n) {
          var h = o(a, n),
            l = 1 - h;
          return [
            t.round(
              1e3 *
                (l * l * l * e[0] +
                  (h * l * l + l * h * l + l * l * h) * i[0] +
                  (h * h * l + l * h * h + h * l * h) * s[0] +
                  h * h * h * r[0])
            ) / 1e3,
            t.round(
              1e3 *
                (l * l * l * e[1] +
                  (h * l * l + l * h * l + l * l * h) * i[1] +
                  (h * h * l + l * h * h + h * l * h) * s[1] +
                  h * h * h * r[1])
            ) / 1e3,
          ];
        },
        buildBezierData: n,
        pointOnLine2D: e,
        pointOnLine3D: function (r, i, s, a, n, o, h, l, p) {
          if (0 === s && 0 === o && 0 === p) return e(r, i, a, n, h, l);
          var f,
            m = t.sqrt(t.pow(a - r, 2) + t.pow(n - i, 2) + t.pow(o - s, 2)),
            c = t.sqrt(t.pow(h - r, 2) + t.pow(l - i, 2) + t.pow(p - s, 2)),
            d = t.sqrt(t.pow(h - a, 2) + t.pow(l - n, 2) + t.pow(p - o, 2));
          return (
            (f =
              m > c
                ? m > d
                  ? m - c - d
                  : d - c - m
                : d > c
                ? d - c - m
                : c - m - d) > -1e-4 && f < 1e-4
          );
        },
      };
    }
    var bez = bezFunction(),
      PropertyFactory = (function () {
        var t = initialDefaultFrame,
          e = Math.abs;
        function r(t, e) {
          var r,
            s = this.offsetTime;
          "multidimensional" === this.propType &&
            (r = createTypedArray("float32", this.pv.length));
          for (
            var a,
              n,
              o,
              h,
              l,
              p,
              f,
              m,
              c,
              d = e.lastIndex,
              u = d,
              y = this.keyframes.length - 1,
              g = !0;
            g;

          ) {
            if (
              ((a = this.keyframes[u]),
              (n = this.keyframes[u + 1]),
              u === y - 1 && t >= n.t - s)
            ) {
              a.h && (a = n), (d = 0);
              break;
            }
            if (n.t - s > t) {
              d = u;
              break;
            }
            u < y - 1 ? (u += 1) : ((d = 0), (g = !1));
          }
          o = this.keyframesMetadata[u] || {};
          var v,
            b,
            P,
            E,
            x,
            S,
            _,
            C,
            A,
            T,
            D = n.t - s,
            k = a.t - s;
          if (a.to) {
            o.bezierData ||
              (o.bezierData = bez.buildBezierData(a.s, n.s || a.e, a.to, a.ti));
            var M = o.bezierData;
            if (t >= D || t < k) {
              var F = t >= D ? M.points.length - 1 : 0;
              for (l = M.points[F].point.length, h = 0; h < l; h += 1)
                r[h] = M.points[F].point[h];
            } else {
              o.__fnct
                ? (c = o.__fnct)
                : ((c = BezierFactory.getBezierEasing(
                    a.o.x,
                    a.o.y,
                    a.i.x,
                    a.i.y,
                    a.n
                  ).get),
                  (o.__fnct = c)),
                (p = c((t - k) / (D - k)));
              var w,
                I = M.segmentLength * p,
                V =
                  e.lastFrame < t && e._lastKeyframeIndex === u
                    ? e._lastAddedLength
                    : 0;
              for (
                m =
                  e.lastFrame < t && e._lastKeyframeIndex === u
                    ? e._lastPoint
                    : 0,
                  g = !0,
                  f = M.points.length;
                g;

              ) {
                if (
                  ((V += M.points[m].partialLength),
                  0 === I || 0 === p || m === M.points.length - 1)
                ) {
                  for (l = M.points[m].point.length, h = 0; h < l; h += 1)
                    r[h] = M.points[m].point[h];
                  break;
                }
                if (I >= V && I < V + M.points[m + 1].partialLength) {
                  for (
                    w = (I - V) / M.points[m + 1].partialLength,
                      l = M.points[m].point.length,
                      h = 0;
                    h < l;
                    h += 1
                  )
                    r[h] =
                      M.points[m].point[h] +
                      (M.points[m + 1].point[h] - M.points[m].point[h]) * w;
                  break;
                }
                m < f - 1 ? (m += 1) : (g = !1);
              }
              (e._lastPoint = m),
                (e._lastAddedLength = V - M.points[m].partialLength),
                (e._lastKeyframeIndex = u);
            }
          } else {
            var B, R, L, G, z;
            if (((y = a.s.length), (v = n.s || a.e), this.sh && 1 !== a.h))
              if (t >= D) (r[0] = v[0]), (r[1] = v[1]), (r[2] = v[2]);
              else if (t <= k)
                (r[0] = a.s[0]), (r[1] = a.s[1]), (r[2] = a.s[2]);
              else {
                var N = i(a.s),
                  O = i(v);
                (b = r),
                  (P = (function (t, e, r) {
                    var i,
                      s,
                      a,
                      n,
                      o,
                      h = [],
                      l = t[0],
                      p = t[1],
                      f = t[2],
                      m = t[3],
                      c = e[0],
                      d = e[1],
                      u = e[2],
                      y = e[3];
                    return (
                      (s = l * c + p * d + f * u + m * y) < 0 &&
                        ((s = -s), (c = -c), (d = -d), (u = -u), (y = -y)),
                      1 - s > 1e-6
                        ? ((i = Math.acos(s)),
                          (a = Math.sin(i)),
                          (n = Math.sin((1 - r) * i) / a),
                          (o = Math.sin(r * i) / a))
                        : ((n = 1 - r), (o = r)),
                      (h[0] = n * l + o * c),
                      (h[1] = n * p + o * d),
                      (h[2] = n * f + o * u),
                      (h[3] = n * m + o * y),
                      h
                    );
                  })(N, O, (t - k) / (D - k))),
                  (E = P[0]),
                  (x = P[1]),
                  (S = P[2]),
                  (_ = P[3]),
                  (C = Math.atan2(
                    2 * x * _ - 2 * E * S,
                    1 - 2 * x * x - 2 * S * S
                  )),
                  (A = Math.asin(2 * E * x + 2 * S * _)),
                  (T = Math.atan2(
                    2 * E * _ - 2 * x * S,
                    1 - 2 * E * E - 2 * S * S
                  )),
                  (b[0] = C / degToRads),
                  (b[1] = A / degToRads),
                  (b[2] = T / degToRads);
              }
            else
              for (u = 0; u < y; u += 1)
                1 !== a.h &&
                  (t >= D
                    ? (p = 1)
                    : t < k
                    ? (p = 0)
                    : (a.o.x.constructor === Array
                        ? (o.__fnct || (o.__fnct = []),
                          o.__fnct[u]
                            ? (c = o.__fnct[u])
                            : ((B = void 0 === a.o.x[u] ? a.o.x[0] : a.o.x[u]),
                              (R = void 0 === a.o.y[u] ? a.o.y[0] : a.o.y[u]),
                              (L = void 0 === a.i.x[u] ? a.i.x[0] : a.i.x[u]),
                              (G = void 0 === a.i.y[u] ? a.i.y[0] : a.i.y[u]),
                              (c = BezierFactory.getBezierEasing(
                                B,
                                R,
                                L,
                                G
                              ).get),
                              (o.__fnct[u] = c)))
                        : o.__fnct
                        ? (c = o.__fnct)
                        : ((B = a.o.x),
                          (R = a.o.y),
                          (L = a.i.x),
                          (G = a.i.y),
                          (c = BezierFactory.getBezierEasing(B, R, L, G).get),
                          (a.keyframeMetadata = c)),
                      (p = c((t - k) / (D - k))))),
                  (v = n.s || a.e),
                  (z = 1 === a.h ? a.s[u] : a.s[u] + (v[u] - a.s[u]) * p),
                  "multidimensional" === this.propType ? (r[u] = z) : (r = z);
          }
          return (e.lastIndex = d), r;
        }
        function i(t) {
          var e = t[0] * degToRads,
            r = t[1] * degToRads,
            i = t[2] * degToRads,
            s = Math.cos(e / 2),
            a = Math.cos(r / 2),
            n = Math.cos(i / 2),
            o = Math.sin(e / 2),
            h = Math.sin(r / 2),
            l = Math.sin(i / 2);
          return [
            o * h * n + s * a * l,
            o * a * n + s * h * l,
            s * h * n - o * a * l,
            s * a * n - o * h * l,
          ];
        }
        function s() {
          var e = this.comp.renderedFrame - this.offsetTime,
            r = this.keyframes[0].t - this.offsetTime,
            i = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
          if (
            !(
              e === this._caching.lastFrame ||
              (this._caching.lastFrame !== t &&
                ((this._caching.lastFrame >= i && e >= i) ||
                  (this._caching.lastFrame < r && e < r)))
            )
          ) {
            this._caching.lastFrame >= e &&
              ((this._caching._lastKeyframeIndex = -1),
              (this._caching.lastIndex = 0));
            var s = this.interpolateValue(e, this._caching);
            this.pv = s;
          }
          return (this._caching.lastFrame = e), this.pv;
        }
        function a(t) {
          var r;
          if ("unidimensional" === this.propType)
            (r = t * this.mult),
              e(this.v - r) > 1e-5 && ((this.v = r), (this._mdf = !0));
          else
            for (var i = 0, s = this.v.length; i < s; )
              (r = t[i] * this.mult),
                e(this.v[i] - r) > 1e-5 && ((this.v[i] = r), (this._mdf = !0)),
                (i += 1);
        }
        function n() {
          if (
            this.elem.globalData.frameId !== this.frameId &&
            this.effectsSequence.length
          )
            if (this.lock) this.setVValue(this.pv);
            else {
              var t;
              (this.lock = !0), (this._mdf = this._isFirstFrame);
              var e = this.effectsSequence.length,
                r = this.kf ? this.pv : this.data.k;
              for (t = 0; t < e; t += 1) r = this.effectsSequence[t](r);
              this.setVValue(r),
                (this._isFirstFrame = !1),
                (this.lock = !1),
                (this.frameId = this.elem.globalData.frameId);
            }
        }
        function o(t) {
          this.effectsSequence.push(t), this.container.addDynamicProperty(this);
        }
        function h(t, e, r, i) {
          (this.propType = "unidimensional"),
            (this.mult = r || 1),
            (this.data = e),
            (this.v = r ? e.k * r : e.k),
            (this.pv = e.k),
            (this._mdf = !1),
            (this.elem = t),
            (this.container = i),
            (this.comp = t.comp),
            (this.k = !1),
            (this.kf = !1),
            (this.vel = 0),
            (this.effectsSequence = []),
            (this._isFirstFrame = !0),
            (this.getValue = n),
            (this.setVValue = a),
            (this.addEffect = o);
        }
        function l(t, e, r, i) {
          var s;
          (this.propType = "multidimensional"),
            (this.mult = r || 1),
            (this.data = e),
            (this._mdf = !1),
            (this.elem = t),
            (this.container = i),
            (this.comp = t.comp),
            (this.k = !1),
            (this.kf = !1),
            (this.frameId = -1);
          var h = e.k.length;
          for (
            this.v = createTypedArray("float32", h),
              this.pv = createTypedArray("float32", h),
              this.vel = createTypedArray("float32", h),
              s = 0;
            s < h;
            s += 1
          )
            (this.v[s] = e.k[s] * this.mult), (this.pv[s] = e.k[s]);
          (this._isFirstFrame = !0),
            (this.effectsSequence = []),
            (this.getValue = n),
            (this.setVValue = a),
            (this.addEffect = o);
        }
        function p(e, i, h, l) {
          (this.propType = "unidimensional"),
            (this.keyframes = i.k),
            (this.keyframesMetadata = []),
            (this.offsetTime = e.data.st),
            (this.frameId = -1),
            (this._caching = {
              lastFrame: t,
              lastIndex: 0,
              value: 0,
              _lastKeyframeIndex: -1,
            }),
            (this.k = !0),
            (this.kf = !0),
            (this.data = i),
            (this.mult = h || 1),
            (this.elem = e),
            (this.container = l),
            (this.comp = e.comp),
            (this.v = t),
            (this.pv = t),
            (this._isFirstFrame = !0),
            (this.getValue = n),
            (this.setVValue = a),
            (this.interpolateValue = r),
            (this.effectsSequence = [s.bind(this)]),
            (this.addEffect = o);
        }
        function f(e, i, h, l) {
          var p;
          this.propType = "multidimensional";
          var f,
            m,
            c,
            d,
            u = i.k.length;
          for (p = 0; p < u - 1; p += 1)
            i.k[p].to &&
              i.k[p].s &&
              i.k[p + 1] &&
              i.k[p + 1].s &&
              ((f = i.k[p].s),
              (m = i.k[p + 1].s),
              (c = i.k[p].to),
              (d = i.k[p].ti),
              ((2 === f.length &&
                (f[0] !== m[0] || f[1] !== m[1]) &&
                bez.pointOnLine2D(
                  f[0],
                  f[1],
                  m[0],
                  m[1],
                  f[0] + c[0],
                  f[1] + c[1]
                ) &&
                bez.pointOnLine2D(
                  f[0],
                  f[1],
                  m[0],
                  m[1],
                  m[0] + d[0],
                  m[1] + d[1]
                )) ||
                (3 === f.length &&
                  (f[0] !== m[0] || f[1] !== m[1] || f[2] !== m[2]) &&
                  bez.pointOnLine3D(
                    f[0],
                    f[1],
                    f[2],
                    m[0],
                    m[1],
                    m[2],
                    f[0] + c[0],
                    f[1] + c[1],
                    f[2] + c[2]
                  ) &&
                  bez.pointOnLine3D(
                    f[0],
                    f[1],
                    f[2],
                    m[0],
                    m[1],
                    m[2],
                    m[0] + d[0],
                    m[1] + d[1],
                    m[2] + d[2]
                  ))) &&
                ((i.k[p].to = null), (i.k[p].ti = null)),
              f[0] === m[0] &&
                f[1] === m[1] &&
                0 === c[0] &&
                0 === c[1] &&
                0 === d[0] &&
                0 === d[1] &&
                (2 === f.length ||
                  (f[2] === m[2] && 0 === c[2] && 0 === d[2])) &&
                ((i.k[p].to = null), (i.k[p].ti = null)));
          (this.effectsSequence = [s.bind(this)]),
            (this.data = i),
            (this.keyframes = i.k),
            (this.keyframesMetadata = []),
            (this.offsetTime = e.data.st),
            (this.k = !0),
            (this.kf = !0),
            (this._isFirstFrame = !0),
            (this.mult = h || 1),
            (this.elem = e),
            (this.container = l),
            (this.comp = e.comp),
            (this.getValue = n),
            (this.setVValue = a),
            (this.interpolateValue = r),
            (this.frameId = -1);
          var y = i.k[0].s.length;
          for (
            this.v = createTypedArray("float32", y),
              this.pv = createTypedArray("float32", y),
              p = 0;
            p < y;
            p += 1
          )
            (this.v[p] = t), (this.pv[p] = t);
          (this._caching = {
            lastFrame: t,
            lastIndex: 0,
            value: createTypedArray("float32", y),
          }),
            (this.addEffect = o);
        }
        return {
          getProp: function (t, e, r, i, s) {
            var a;
            if (e.k.length)
              if ("number" == typeof e.k[0]) a = new l(t, e, i, s);
              else
                switch (r) {
                  case 0:
                    a = new p(t, e, i, s);
                    break;
                  case 1:
                    a = new f(t, e, i, s);
                }
            else a = new h(t, e, i, s);
            return a.effectsSequence.length && s.addDynamicProperty(a), a;
          },
        };
      })();
    function DynamicPropertyContainer() {}
    DynamicPropertyContainer.prototype = {
      addDynamicProperty: function (t) {
        -1 === this.dynamicProperties.indexOf(t) &&
          (this.dynamicProperties.push(t),
          this.container.addDynamicProperty(this),
          (this._isAnimated = !0));
      },
      iterateDynamicProperties: function () {
        var t;
        this._mdf = !1;
        var e = this.dynamicProperties.length;
        for (t = 0; t < e; t += 1)
          this.dynamicProperties[t].getValue(),
            this.dynamicProperties[t]._mdf && (this._mdf = !0);
      },
      initDynamicPropertyContainer: function (t) {
        (this.container = t),
          (this.dynamicProperties = []),
          (this._mdf = !1),
          (this._isAnimated = !1);
      },
    };
    var pointPool = poolFactory(8, function () {
      return createTypedArray("float32", 2);
    });
    function ShapePath() {
      (this.c = !1),
        (this._length = 0),
        (this._maxLength = 8),
        (this.v = createSizedArray(this._maxLength)),
        (this.o = createSizedArray(this._maxLength)),
        (this.i = createSizedArray(this._maxLength));
    }
    (ShapePath.prototype.setPathData = function (t, e) {
      (this.c = t), this.setLength(e);
      for (var r = 0; r < e; )
        (this.v[r] = pointPool.newElement()),
          (this.o[r] = pointPool.newElement()),
          (this.i[r] = pointPool.newElement()),
          (r += 1);
    }),
      (ShapePath.prototype.setLength = function (t) {
        for (; this._maxLength < t; ) this.doubleArrayLength();
        this._length = t;
      }),
      (ShapePath.prototype.doubleArrayLength = function () {
        (this.v = this.v.concat(createSizedArray(this._maxLength))),
          (this.i = this.i.concat(createSizedArray(this._maxLength))),
          (this.o = this.o.concat(createSizedArray(this._maxLength))),
          (this._maxLength *= 2);
      }),
      (ShapePath.prototype.setXYAt = function (t, e, r, i, s) {
        var a;
        switch (
          ((this._length = Math.max(this._length, i + 1)),
          this._length >= this._maxLength && this.doubleArrayLength(),
          r)
        ) {
          case "v":
            a = this.v;
            break;
          case "i":
            a = this.i;
            break;
          case "o":
            a = this.o;
            break;
          default:
            a = [];
        }
        (!a[i] || (a[i] && !s)) && (a[i] = pointPool.newElement()),
          (a[i][0] = t),
          (a[i][1] = e);
      }),
      (ShapePath.prototype.setTripleAt = function (t, e, r, i, s, a, n, o) {
        this.setXYAt(t, e, "v", n, o),
          this.setXYAt(r, i, "o", n, o),
          this.setXYAt(s, a, "i", n, o);
      }),
      (ShapePath.prototype.reverse = function () {
        var t = new ShapePath();
        t.setPathData(this.c, this._length);
        var e = this.v,
          r = this.o,
          i = this.i,
          s = 0;
        this.c &&
          (t.setTripleAt(
            e[0][0],
            e[0][1],
            i[0][0],
            i[0][1],
            r[0][0],
            r[0][1],
            0,
            !1
          ),
          (s = 1));
        var a,
          n = this._length - 1,
          o = this._length;
        for (a = s; a < o; a += 1)
          t.setTripleAt(
            e[n][0],
            e[n][1],
            i[n][0],
            i[n][1],
            r[n][0],
            r[n][1],
            a,
            !1
          ),
            (n -= 1);
        return t;
      });
    var shapePool =
        ((factory = poolFactory(
          4,
          function () {
            return new ShapePath();
          },
          function (t) {
            var e,
              r = t._length;
            for (e = 0; e < r; e += 1)
              pointPool.release(t.v[e]),
                pointPool.release(t.i[e]),
                pointPool.release(t.o[e]),
                (t.v[e] = null),
                (t.i[e] = null),
                (t.o[e] = null);
            (t._length = 0), (t.c = !1);
          }
        )),
        (factory.clone = function (t) {
          var e,
            r = factory.newElement(),
            i = void 0 === t._length ? t.v.length : t._length;
          for (r.setLength(i), r.c = t.c, e = 0; e < i; e += 1)
            r.setTripleAt(
              t.v[e][0],
              t.v[e][1],
              t.o[e][0],
              t.o[e][1],
              t.i[e][0],
              t.i[e][1],
              e
            );
          return r;
        }),
        factory),
      factory;
    function ShapeCollection() {
      (this._length = 0),
        (this._maxLength = 4),
        (this.shapes = createSizedArray(this._maxLength));
    }
    (ShapeCollection.prototype.addShape = function (t) {
      this._length === this._maxLength &&
        ((this.shapes = this.shapes.concat(createSizedArray(this._maxLength))),
        (this._maxLength *= 2)),
        (this.shapes[this._length] = t),
        (this._length += 1);
    }),
      (ShapeCollection.prototype.releaseShapes = function () {
        var t;
        for (t = 0; t < this._length; t += 1) shapePool.release(this.shapes[t]);
        this._length = 0;
      });
    var shapeCollectionPool =
        ((ob = {
          newShapeCollection: function () {
            return _length ? pool[(_length -= 1)] : new ShapeCollection();
          },
          release: function (t) {
            var e,
              r = t._length;
            for (e = 0; e < r; e += 1) shapePool.release(t.shapes[e]);
            (t._length = 0),
              _length === _maxLength &&
                ((pool = pooling.double(pool)), (_maxLength *= 2)),
              (pool[_length] = t),
              (_length += 1);
          },
        }),
        (_length = 0),
        (_maxLength = 4),
        (pool = createSizedArray(_maxLength)),
        ob),
      ob,
      _length,
      _maxLength,
      pool,
      ShapePropertyFactory = (function () {
        var t = -999999;
        function e(t, e, r) {
          var i,
            s,
            a,
            n,
            o,
            h,
            l,
            p,
            f,
            m = r.lastIndex,
            c = this.keyframes;
          if (t < c[0].t - this.offsetTime) (i = c[0].s[0]), (a = !0), (m = 0);
          else if (t >= c[c.length - 1].t - this.offsetTime)
            (i = c[c.length - 1].s
              ? c[c.length - 1].s[0]
              : c[c.length - 2].e[0]),
              (a = !0);
          else {
            for (
              var d, u, y, g = m, v = c.length - 1, b = !0;
              b && ((d = c[g]), !((u = c[g + 1]).t - this.offsetTime > t));

            )
              g < v - 1 ? (g += 1) : (b = !1);
            if (
              ((y = this.keyframesMetadata[g] || {}), (m = g), !(a = 1 === d.h))
            ) {
              if (t >= u.t - this.offsetTime) p = 1;
              else if (t < d.t - this.offsetTime) p = 0;
              else {
                var P;
                y.__fnct
                  ? (P = y.__fnct)
                  : ((P = BezierFactory.getBezierEasing(
                      d.o.x,
                      d.o.y,
                      d.i.x,
                      d.i.y
                    ).get),
                    (y.__fnct = P)),
                  (p = P(
                    (t - (d.t - this.offsetTime)) /
                      (u.t - this.offsetTime - (d.t - this.offsetTime))
                  ));
              }
              s = u.s ? u.s[0] : d.e[0];
            }
            i = d.s[0];
          }
          for (
            h = e._length, l = i.i[0].length, r.lastIndex = m, n = 0;
            n < h;
            n += 1
          )
            for (o = 0; o < l; o += 1)
              (f = a ? i.i[n][o] : i.i[n][o] + (s.i[n][o] - i.i[n][o]) * p),
                (e.i[n][o] = f),
                (f = a ? i.o[n][o] : i.o[n][o] + (s.o[n][o] - i.o[n][o]) * p),
                (e.o[n][o] = f),
                (f = a ? i.v[n][o] : i.v[n][o] + (s.v[n][o] - i.v[n][o]) * p),
                (e.v[n][o] = f);
        }
        function r() {
          var e = this.comp.renderedFrame - this.offsetTime,
            r = this.keyframes[0].t - this.offsetTime,
            i = this.keyframes[this.keyframes.length - 1].t - this.offsetTime,
            s = this._caching.lastFrame;
          return (
            (s !== t && ((s < r && e < r) || (s > i && e > i))) ||
              ((this._caching.lastIndex = s < e ? this._caching.lastIndex : 0),
              this.interpolateShape(e, this.pv, this._caching)),
            (this._caching.lastFrame = e),
            this.pv
          );
        }
        function i() {
          this.paths = this.localShapeCollection;
        }
        function s(t) {
          (function (t, e) {
            if (t._length !== e._length || t.c !== e.c) return !1;
            var r,
              i = t._length;
            for (r = 0; r < i; r += 1)
              if (
                t.v[r][0] !== e.v[r][0] ||
                t.v[r][1] !== e.v[r][1] ||
                t.o[r][0] !== e.o[r][0] ||
                t.o[r][1] !== e.o[r][1] ||
                t.i[r][0] !== e.i[r][0] ||
                t.i[r][1] !== e.i[r][1]
              )
                return !1;
            return !0;
          })(this.v, t) ||
            ((this.v = shapePool.clone(t)),
            this.localShapeCollection.releaseShapes(),
            this.localShapeCollection.addShape(this.v),
            (this._mdf = !0),
            (this.paths = this.localShapeCollection));
        }
        function a() {
          if (this.elem.globalData.frameId !== this.frameId)
            if (this.effectsSequence.length)
              if (this.lock) this.setVValue(this.pv);
              else {
                var t, e;
                (this.lock = !0),
                  (this._mdf = !1),
                  (t = this.kf
                    ? this.pv
                    : this.data.ks
                    ? this.data.ks.k
                    : this.data.pt.k);
                var r = this.effectsSequence.length;
                for (e = 0; e < r; e += 1) t = this.effectsSequence[e](t);
                this.setVValue(t),
                  (this.lock = !1),
                  (this.frameId = this.elem.globalData.frameId);
              }
            else this._mdf = !1;
        }
        function n(t, e, r) {
          (this.propType = "shape"),
            (this.comp = t.comp),
            (this.container = t),
            (this.elem = t),
            (this.data = e),
            (this.k = !1),
            (this.kf = !1),
            (this._mdf = !1);
          var s = 3 === r ? e.pt.k : e.ks.k;
          (this.v = shapePool.clone(s)),
            (this.pv = shapePool.clone(this.v)),
            (this.localShapeCollection =
              shapeCollectionPool.newShapeCollection()),
            (this.paths = this.localShapeCollection),
            this.paths.addShape(this.v),
            (this.reset = i),
            (this.effectsSequence = []);
        }
        function o(t) {
          this.effectsSequence.push(t), this.container.addDynamicProperty(this);
        }
        function h(e, s, a) {
          (this.propType = "shape"),
            (this.comp = e.comp),
            (this.elem = e),
            (this.container = e),
            (this.offsetTime = e.data.st),
            (this.keyframes = 3 === a ? s.pt.k : s.ks.k),
            (this.keyframesMetadata = []),
            (this.k = !0),
            (this.kf = !0);
          var n = this.keyframes[0].s[0].i.length;
          (this.v = shapePool.newElement()),
            this.v.setPathData(this.keyframes[0].s[0].c, n),
            (this.pv = shapePool.clone(this.v)),
            (this.localShapeCollection =
              shapeCollectionPool.newShapeCollection()),
            (this.paths = this.localShapeCollection),
            this.paths.addShape(this.v),
            (this.lastFrame = t),
            (this.reset = i),
            (this._caching = { lastFrame: t, lastIndex: 0 }),
            (this.effectsSequence = [r.bind(this)]);
        }
        (n.prototype.interpolateShape = e),
          (n.prototype.getValue = a),
          (n.prototype.setVValue = s),
          (n.prototype.addEffect = o),
          (h.prototype.getValue = a),
          (h.prototype.interpolateShape = e),
          (h.prototype.setVValue = s),
          (h.prototype.addEffect = o);
        var l = (function () {
            var t = roundCorner;
            function e(t, e) {
              (this.v = shapePool.newElement()),
                this.v.setPathData(!0, 4),
                (this.localShapeCollection =
                  shapeCollectionPool.newShapeCollection()),
                (this.paths = this.localShapeCollection),
                this.localShapeCollection.addShape(this.v),
                (this.d = e.d),
                (this.elem = t),
                (this.comp = t.comp),
                (this.frameId = -1),
                this.initDynamicPropertyContainer(t),
                (this.p = PropertyFactory.getProp(t, e.p, 1, 0, this)),
                (this.s = PropertyFactory.getProp(t, e.s, 1, 0, this)),
                this.dynamicProperties.length
                  ? (this.k = !0)
                  : ((this.k = !1), this.convertEllToPath());
            }
            return (
              (e.prototype = {
                reset: i,
                getValue: function () {
                  this.elem.globalData.frameId !== this.frameId &&
                    ((this.frameId = this.elem.globalData.frameId),
                    this.iterateDynamicProperties(),
                    this._mdf && this.convertEllToPath());
                },
                convertEllToPath: function () {
                  var e = this.p.v[0],
                    r = this.p.v[1],
                    i = this.s.v[0] / 2,
                    s = this.s.v[1] / 2,
                    a = 3 !== this.d,
                    n = this.v;
                  (n.v[0][0] = e),
                    (n.v[0][1] = r - s),
                    (n.v[1][0] = a ? e + i : e - i),
                    (n.v[1][1] = r),
                    (n.v[2][0] = e),
                    (n.v[2][1] = r + s),
                    (n.v[3][0] = a ? e - i : e + i),
                    (n.v[3][1] = r),
                    (n.i[0][0] = a ? e - i * t : e + i * t),
                    (n.i[0][1] = r - s),
                    (n.i[1][0] = a ? e + i : e - i),
                    (n.i[1][1] = r - s * t),
                    (n.i[2][0] = a ? e + i * t : e - i * t),
                    (n.i[2][1] = r + s),
                    (n.i[3][0] = a ? e - i : e + i),
                    (n.i[3][1] = r + s * t),
                    (n.o[0][0] = a ? e + i * t : e - i * t),
                    (n.o[0][1] = r - s),
                    (n.o[1][0] = a ? e + i : e - i),
                    (n.o[1][1] = r + s * t),
                    (n.o[2][0] = a ? e - i * t : e + i * t),
                    (n.o[2][1] = r + s),
                    (n.o[3][0] = a ? e - i : e + i),
                    (n.o[3][1] = r - s * t);
                },
              }),
              extendPrototype([DynamicPropertyContainer], e),
              e
            );
          })(),
          p = (function () {
            function t(t, e) {
              (this.v = shapePool.newElement()),
                this.v.setPathData(!0, 0),
                (this.elem = t),
                (this.comp = t.comp),
                (this.data = e),
                (this.frameId = -1),
                (this.d = e.d),
                this.initDynamicPropertyContainer(t),
                1 === e.sy
                  ? ((this.ir = PropertyFactory.getProp(t, e.ir, 0, 0, this)),
                    (this.is = PropertyFactory.getProp(t, e.is, 0, 0.01, this)),
                    (this.convertToPath = this.convertStarToPath))
                  : (this.convertToPath = this.convertPolygonToPath),
                (this.pt = PropertyFactory.getProp(t, e.pt, 0, 0, this)),
                (this.p = PropertyFactory.getProp(t, e.p, 1, 0, this)),
                (this.r = PropertyFactory.getProp(t, e.r, 0, degToRads, this)),
                (this.or = PropertyFactory.getProp(t, e.or, 0, 0, this)),
                (this.os = PropertyFactory.getProp(t, e.os, 0, 0.01, this)),
                (this.localShapeCollection =
                  shapeCollectionPool.newShapeCollection()),
                this.localShapeCollection.addShape(this.v),
                (this.paths = this.localShapeCollection),
                this.dynamicProperties.length
                  ? (this.k = !0)
                  : ((this.k = !1), this.convertToPath());
            }
            return (
              (t.prototype = {
                reset: i,
                getValue: function () {
                  this.elem.globalData.frameId !== this.frameId &&
                    ((this.frameId = this.elem.globalData.frameId),
                    this.iterateDynamicProperties(),
                    this._mdf && this.convertToPath());
                },
                convertStarToPath: function () {
                  var t,
                    e,
                    r,
                    i,
                    s = 2 * Math.floor(this.pt.v),
                    a = (2 * Math.PI) / s,
                    n = !0,
                    o = this.or.v,
                    h = this.ir.v,
                    l = this.os.v,
                    p = this.is.v,
                    f = (2 * Math.PI * o) / (2 * s),
                    m = (2 * Math.PI * h) / (2 * s),
                    c = -Math.PI / 2;
                  c += this.r.v;
                  var d = 3 === this.data.d ? -1 : 1;
                  for (this.v._length = 0, t = 0; t < s; t += 1) {
                    (r = n ? l : p), (i = n ? f : m);
                    var u = (e = n ? o : h) * Math.cos(c),
                      y = e * Math.sin(c),
                      g = 0 === u && 0 === y ? 0 : y / Math.sqrt(u * u + y * y),
                      v =
                        0 === u && 0 === y ? 0 : -u / Math.sqrt(u * u + y * y);
                    (u += +this.p.v[0]),
                      (y += +this.p.v[1]),
                      this.v.setTripleAt(
                        u,
                        y,
                        u - g * i * r * d,
                        y - v * i * r * d,
                        u + g * i * r * d,
                        y + v * i * r * d,
                        t,
                        !0
                      ),
                      (n = !n),
                      (c += a * d);
                  }
                },
                convertPolygonToPath: function () {
                  var t,
                    e = Math.floor(this.pt.v),
                    r = (2 * Math.PI) / e,
                    i = this.or.v,
                    s = this.os.v,
                    a = (2 * Math.PI * i) / (4 * e),
                    n = 0.5 * -Math.PI,
                    o = 3 === this.data.d ? -1 : 1;
                  for (
                    n += this.r.v, this.v._length = 0, t = 0;
                    t < e;
                    t += 1
                  ) {
                    var h = i * Math.cos(n),
                      l = i * Math.sin(n),
                      p = 0 === h && 0 === l ? 0 : l / Math.sqrt(h * h + l * l),
                      f =
                        0 === h && 0 === l ? 0 : -h / Math.sqrt(h * h + l * l);
                    (h += +this.p.v[0]),
                      (l += +this.p.v[1]),
                      this.v.setTripleAt(
                        h,
                        l,
                        h - p * a * s * o,
                        l - f * a * s * o,
                        h + p * a * s * o,
                        l + f * a * s * o,
                        t,
                        !0
                      ),
                      (n += r * o);
                  }
                  (this.paths.length = 0), (this.paths[0] = this.v);
                },
              }),
              extendPrototype([DynamicPropertyContainer], t),
              t
            );
          })(),
          f = (function () {
            function t(t, e) {
              (this.v = shapePool.newElement()),
                (this.v.c = !0),
                (this.localShapeCollection =
                  shapeCollectionPool.newShapeCollection()),
                this.localShapeCollection.addShape(this.v),
                (this.paths = this.localShapeCollection),
                (this.elem = t),
                (this.comp = t.comp),
                (this.frameId = -1),
                (this.d = e.d),
                this.initDynamicPropertyContainer(t),
                (this.p = PropertyFactory.getProp(t, e.p, 1, 0, this)),
                (this.s = PropertyFactory.getProp(t, e.s, 1, 0, this)),
                (this.r = PropertyFactory.getProp(t, e.r, 0, 0, this)),
                this.dynamicProperties.length
                  ? (this.k = !0)
                  : ((this.k = !1), this.convertRectToPath());
            }
            return (
              (t.prototype = {
                convertRectToPath: function () {
                  var t = this.p.v[0],
                    e = this.p.v[1],
                    r = this.s.v[0] / 2,
                    i = this.s.v[1] / 2,
                    s = bmMin(r, i, this.r.v),
                    a = s * (1 - roundCorner);
                  (this.v._length = 0),
                    2 === this.d || 1 === this.d
                      ? (this.v.setTripleAt(
                          t + r,
                          e - i + s,
                          t + r,
                          e - i + s,
                          t + r,
                          e - i + a,
                          0,
                          !0
                        ),
                        this.v.setTripleAt(
                          t + r,
                          e + i - s,
                          t + r,
                          e + i - a,
                          t + r,
                          e + i - s,
                          1,
                          !0
                        ),
                        0 !== s
                          ? (this.v.setTripleAt(
                              t + r - s,
                              e + i,
                              t + r - s,
                              e + i,
                              t + r - a,
                              e + i,
                              2,
                              !0
                            ),
                            this.v.setTripleAt(
                              t - r + s,
                              e + i,
                              t - r + a,
                              e + i,
                              t - r + s,
                              e + i,
                              3,
                              !0
                            ),
                            this.v.setTripleAt(
                              t - r,
                              e + i - s,
                              t - r,
                              e + i - s,
                              t - r,
                              e + i - a,
                              4,
                              !0
                            ),
                            this.v.setTripleAt(
                              t - r,
                              e - i + s,
                              t - r,
                              e - i + a,
                              t - r,
                              e - i + s,
                              5,
                              !0
                            ),
                            this.v.setTripleAt(
                              t - r + s,
                              e - i,
                              t - r + s,
                              e - i,
                              t - r + a,
                              e - i,
                              6,
                              !0
                            ),
                            this.v.setTripleAt(
                              t + r - s,
                              e - i,
                              t + r - a,
                              e - i,
                              t + r - s,
                              e - i,
                              7,
                              !0
                            ))
                          : (this.v.setTripleAt(
                              t - r,
                              e + i,
                              t - r + a,
                              e + i,
                              t - r,
                              e + i,
                              2
                            ),
                            this.v.setTripleAt(
                              t - r,
                              e - i,
                              t - r,
                              e - i + a,
                              t - r,
                              e - i,
                              3
                            )))
                      : (this.v.setTripleAt(
                          t + r,
                          e - i + s,
                          t + r,
                          e - i + a,
                          t + r,
                          e - i + s,
                          0,
                          !0
                        ),
                        0 !== s
                          ? (this.v.setTripleAt(
                              t + r - s,
                              e - i,
                              t + r - s,
                              e - i,
                              t + r - a,
                              e - i,
                              1,
                              !0
                            ),
                            this.v.setTripleAt(
                              t - r + s,
                              e - i,
                              t - r + a,
                              e - i,
                              t - r + s,
                              e - i,
                              2,
                              !0
                            ),
                            this.v.setTripleAt(
                              t - r,
                              e - i + s,
                              t - r,
                              e - i + s,
                              t - r,
                              e - i + a,
                              3,
                              !0
                            ),
                            this.v.setTripleAt(
                              t - r,
                              e + i - s,
                              t - r,
                              e + i - a,
                              t - r,
                              e + i - s,
                              4,
                              !0
                            ),
                            this.v.setTripleAt(
                              t - r + s,
                              e + i,
                              t - r + s,
                              e + i,
                              t - r + a,
                              e + i,
                              5,
                              !0
                            ),
                            this.v.setTripleAt(
                              t + r - s,
                              e + i,
                              t + r - a,
                              e + i,
                              t + r - s,
                              e + i,
                              6,
                              !0
                            ),
                            this.v.setTripleAt(
                              t + r,
                              e + i - s,
                              t + r,
                              e + i - s,
                              t + r,
                              e + i - a,
                              7,
                              !0
                            ))
                          : (this.v.setTripleAt(
                              t - r,
                              e - i,
                              t - r + a,
                              e - i,
                              t - r,
                              e - i,
                              1,
                              !0
                            ),
                            this.v.setTripleAt(
                              t - r,
                              e + i,
                              t - r,
                              e + i - a,
                              t - r,
                              e + i,
                              2,
                              !0
                            ),
                            this.v.setTripleAt(
                              t + r,
                              e + i,
                              t + r - a,
                              e + i,
                              t + r,
                              e + i,
                              3,
                              !0
                            )));
                },
                getValue: function () {
                  this.elem.globalData.frameId !== this.frameId &&
                    ((this.frameId = this.elem.globalData.frameId),
                    this.iterateDynamicProperties(),
                    this._mdf && this.convertRectToPath());
                },
                reset: i,
              }),
              extendPrototype([DynamicPropertyContainer], t),
              t
            );
          })();
        var m = {
          getShapeProp: function (t, e, r) {
            var i;
            return (
              3 === r || 4 === r
                ? (i = (3 === r ? e.pt : e.ks).k.length
                    ? new h(t, e, r)
                    : new n(t, e, r))
                : 5 === r
                ? (i = new f(t, e))
                : 6 === r
                ? (i = new l(t, e))
                : 7 === r && (i = new p(t, e)),
              i.k && t.addDynamicProperty(i),
              i
            );
          },
          getConstructorFunction: function () {
            return n;
          },
          getKeyframedConstructorFunction: function () {
            return h;
          },
        };
        return m;
      })(),
      Matrix = (function () {
        var t = Math.cos,
          e = Math.sin,
          r = Math.tan,
          i = Math.round;
        function s() {
          return (
            (this.props[0] = 1),
            (this.props[1] = 0),
            (this.props[2] = 0),
            (this.props[3] = 0),
            (this.props[4] = 0),
            (this.props[5] = 1),
            (this.props[6] = 0),
            (this.props[7] = 0),
            (this.props[8] = 0),
            (this.props[9] = 0),
            (this.props[10] = 1),
            (this.props[11] = 0),
            (this.props[12] = 0),
            (this.props[13] = 0),
            (this.props[14] = 0),
            (this.props[15] = 1),
            this
          );
        }
        function a(r) {
          if (0 === r) return this;
          var i = t(r),
            s = e(r);
          return this._t(i, -s, 0, 0, s, i, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }
        function n(r) {
          if (0 === r) return this;
          var i = t(r),
            s = e(r);
          return this._t(1, 0, 0, 0, 0, i, -s, 0, 0, s, i, 0, 0, 0, 0, 1);
        }
        function o(r) {
          if (0 === r) return this;
          var i = t(r),
            s = e(r);
          return this._t(i, 0, s, 0, 0, 1, 0, 0, -s, 0, i, 0, 0, 0, 0, 1);
        }
        function h(r) {
          if (0 === r) return this;
          var i = t(r),
            s = e(r);
          return this._t(i, -s, 0, 0, s, i, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }
        function l(t, e) {
          return this._t(1, e, t, 1, 0, 0);
        }
        function p(t, e) {
          return this.shear(r(t), r(e));
        }
        function f(i, s) {
          var a = t(s),
            n = e(s);
          return this._t(a, n, 0, 0, -n, a, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)
            ._t(1, 0, 0, 0, r(i), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)
            ._t(a, -n, 0, 0, n, a, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }
        function m(t, e, r) {
          return (
            r || 0 === r || (r = 1),
            1 === t && 1 === e && 1 === r
              ? this
              : this._t(t, 0, 0, 0, 0, e, 0, 0, 0, 0, r, 0, 0, 0, 0, 1)
          );
        }
        function c(t, e, r, i, s, a, n, o, h, l, p, f, m, c, d, u) {
          return (
            (this.props[0] = t),
            (this.props[1] = e),
            (this.props[2] = r),
            (this.props[3] = i),
            (this.props[4] = s),
            (this.props[5] = a),
            (this.props[6] = n),
            (this.props[7] = o),
            (this.props[8] = h),
            (this.props[9] = l),
            (this.props[10] = p),
            (this.props[11] = f),
            (this.props[12] = m),
            (this.props[13] = c),
            (this.props[14] = d),
            (this.props[15] = u),
            this
          );
        }
        function d(t, e, r) {
          return (
            (r = r || 0),
            0 !== t || 0 !== e || 0 !== r
              ? this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, t, e, r, 1)
              : this
          );
        }
        function u(t, e, r, i, s, a, n, o, h, l, p, f, m, c, d, u) {
          var y = this.props;
          if (
            1 === t &&
            0 === e &&
            0 === r &&
            0 === i &&
            0 === s &&
            1 === a &&
            0 === n &&
            0 === o &&
            0 === h &&
            0 === l &&
            1 === p &&
            0 === f
          )
            return (
              (y[12] = y[12] * t + y[15] * m),
              (y[13] = y[13] * a + y[15] * c),
              (y[14] = y[14] * p + y[15] * d),
              (y[15] *= u),
              (this._identityCalculated = !1),
              this
            );
          var g = y[0],
            v = y[1],
            b = y[2],
            P = y[3],
            E = y[4],
            x = y[5],
            S = y[6],
            _ = y[7],
            C = y[8],
            A = y[9],
            T = y[10],
            D = y[11],
            k = y[12],
            M = y[13],
            F = y[14],
            w = y[15];
          return (
            (y[0] = g * t + v * s + b * h + P * m),
            (y[1] = g * e + v * a + b * l + P * c),
            (y[2] = g * r + v * n + b * p + P * d),
            (y[3] = g * i + v * o + b * f + P * u),
            (y[4] = E * t + x * s + S * h + _ * m),
            (y[5] = E * e + x * a + S * l + _ * c),
            (y[6] = E * r + x * n + S * p + _ * d),
            (y[7] = E * i + x * o + S * f + _ * u),
            (y[8] = C * t + A * s + T * h + D * m),
            (y[9] = C * e + A * a + T * l + D * c),
            (y[10] = C * r + A * n + T * p + D * d),
            (y[11] = C * i + A * o + T * f + D * u),
            (y[12] = k * t + M * s + F * h + w * m),
            (y[13] = k * e + M * a + F * l + w * c),
            (y[14] = k * r + M * n + F * p + w * d),
            (y[15] = k * i + M * o + F * f + w * u),
            (this._identityCalculated = !1),
            this
          );
        }
        function y() {
          return (
            this._identityCalculated ||
              ((this._identity = !(
                1 !== this.props[0] ||
                0 !== this.props[1] ||
                0 !== this.props[2] ||
                0 !== this.props[3] ||
                0 !== this.props[4] ||
                1 !== this.props[5] ||
                0 !== this.props[6] ||
                0 !== this.props[7] ||
                0 !== this.props[8] ||
                0 !== this.props[9] ||
                1 !== this.props[10] ||
                0 !== this.props[11] ||
                0 !== this.props[12] ||
                0 !== this.props[13] ||
                0 !== this.props[14] ||
                1 !== this.props[15]
              )),
              (this._identityCalculated = !0)),
            this._identity
          );
        }
        function g(t) {
          for (var e = 0; e < 16; ) {
            if (t.props[e] !== this.props[e]) return !1;
            e += 1;
          }
          return !0;
        }
        function v(t) {
          var e;
          for (e = 0; e < 16; e += 1) t.props[e] = this.props[e];
          return t;
        }
        function b(t) {
          var e;
          for (e = 0; e < 16; e += 1) this.props[e] = t[e];
        }
        function P(t, e, r) {
          return {
            x:
              t * this.props[0] +
              e * this.props[4] +
              r * this.props[8] +
              this.props[12],
            y:
              t * this.props[1] +
              e * this.props[5] +
              r * this.props[9] +
              this.props[13],
            z:
              t * this.props[2] +
              e * this.props[6] +
              r * this.props[10] +
              this.props[14],
          };
        }
        function E(t, e, r) {
          return (
            t * this.props[0] +
            e * this.props[4] +
            r * this.props[8] +
            this.props[12]
          );
        }
        function x(t, e, r) {
          return (
            t * this.props[1] +
            e * this.props[5] +
            r * this.props[9] +
            this.props[13]
          );
        }
        function S(t, e, r) {
          return (
            t * this.props[2] +
            e * this.props[6] +
            r * this.props[10] +
            this.props[14]
          );
        }
        function _() {
          var t = this.props[0] * this.props[5] - this.props[1] * this.props[4],
            e = this.props[5] / t,
            r = -this.props[1] / t,
            i = -this.props[4] / t,
            s = this.props[0] / t,
            a =
              (this.props[4] * this.props[13] -
                this.props[5] * this.props[12]) /
              t,
            n =
              -(
                this.props[0] * this.props[13] -
                this.props[1] * this.props[12]
              ) / t,
            o = new Matrix();
          return (
            (o.props[0] = e),
            (o.props[1] = r),
            (o.props[4] = i),
            (o.props[5] = s),
            (o.props[12] = a),
            (o.props[13] = n),
            o
          );
        }
        function C(t) {
          return this.getInverseMatrix().applyToPointArray(
            t[0],
            t[1],
            t[2] || 0
          );
        }
        function A(t) {
          var e,
            r = t.length,
            i = [];
          for (e = 0; e < r; e += 1) i[e] = C(t[e]);
          return i;
        }
        function T(t, e, r) {
          var i = createTypedArray("float32", 6);
          if (this.isIdentity())
            (i[0] = t[0]),
              (i[1] = t[1]),
              (i[2] = e[0]),
              (i[3] = e[1]),
              (i[4] = r[0]),
              (i[5] = r[1]);
          else {
            var s = this.props[0],
              a = this.props[1],
              n = this.props[4],
              o = this.props[5],
              h = this.props[12],
              l = this.props[13];
            (i[0] = t[0] * s + t[1] * n + h),
              (i[1] = t[0] * a + t[1] * o + l),
              (i[2] = e[0] * s + e[1] * n + h),
              (i[3] = e[0] * a + e[1] * o + l),
              (i[4] = r[0] * s + r[1] * n + h),
              (i[5] = r[0] * a + r[1] * o + l);
          }
          return i;
        }
        function D(t, e, r) {
          return this.isIdentity()
            ? [t, e, r]
            : [
                t * this.props[0] +
                  e * this.props[4] +
                  r * this.props[8] +
                  this.props[12],
                t * this.props[1] +
                  e * this.props[5] +
                  r * this.props[9] +
                  this.props[13],
                t * this.props[2] +
                  e * this.props[6] +
                  r * this.props[10] +
                  this.props[14],
              ];
        }
        function k(t, e) {
          if (this.isIdentity()) return t + "," + e;
          var r = this.props;
          return (
            Math.round(100 * (t * r[0] + e * r[4] + r[12])) / 100 +
            "," +
            Math.round(100 * (t * r[1] + e * r[5] + r[13])) / 100
          );
        }
        function M() {
          for (var t = 0, e = this.props, r = "matrix3d("; t < 16; )
            (r += i(1e4 * e[t]) / 1e4), (r += 15 === t ? ")" : ","), (t += 1);
          return r;
        }
        function F(t) {
          return (t < 1e-6 && t > 0) || (t > -1e-6 && t < 0)
            ? i(1e4 * t) / 1e4
            : t;
        }
        function w() {
          var t = this.props;
          return (
            "matrix(" +
            F(t[0]) +
            "," +
            F(t[1]) +
            "," +
            F(t[4]) +
            "," +
            F(t[5]) +
            "," +
            F(t[12]) +
            "," +
            F(t[13]) +
            ")"
          );
        }
        return function () {
          (this.reset = s),
            (this.rotate = a),
            (this.rotateX = n),
            (this.rotateY = o),
            (this.rotateZ = h),
            (this.skew = p),
            (this.skewFromAxis = f),
            (this.shear = l),
            (this.scale = m),
            (this.setTransform = c),
            (this.translate = d),
            (this.transform = u),
            (this.applyToPoint = P),
            (this.applyToX = E),
            (this.applyToY = x),
            (this.applyToZ = S),
            (this.applyToPointArray = D),
            (this.applyToTriplePoints = T),
            (this.applyToPointStringified = k),
            (this.toCSS = M),
            (this.to2dCSS = w),
            (this.clone = v),
            (this.cloneFromProps = b),
            (this.equals = g),
            (this.inversePoints = A),
            (this.inversePoint = C),
            (this.getInverseMatrix = _),
            (this._t = this.transform),
            (this.isIdentity = y),
            (this._identity = !0),
            (this._identityCalculated = !1),
            (this.props = createTypedArray("float32", 16)),
            this.reset();
        };
      })();
    function _typeof$3(t) {
      return (
        (_typeof$3 =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
                return typeof t;
              }
            : function (t) {
                return t &&
                  "function" == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              }),
        _typeof$3(t)
      );
    }
    var lottie = {},
      standalone = "__[STANDALONE]__",
      animationData = "__[ANIMATIONDATA]__",
      renderer = "";
    function setLocation(t) {
      setLocationHref(t);
    }
    function searchAnimations() {
      !0 === standalone
        ? animationManager.searchAnimations(animationData, standalone, renderer)
        : animationManager.searchAnimations();
    }
    function setSubframeRendering(t) {
      setSubframeEnabled(t);
    }
    function setPrefix(t) {
      setIdPrefix(t);
    }
    function loadAnimation(t) {
      return (
        !0 === standalone && (t.animationData = JSON.parse(animationData)),
        animationManager.loadAnimation(t)
      );
    }
    function setQuality(t) {
      if ("string" == typeof t)
        switch (t) {
          case "high":
            setDefaultCurveSegments(200);
            break;
          default:
          case "medium":
            setDefaultCurveSegments(50);
            break;
          case "low":
            setDefaultCurveSegments(10);
        }
      else !isNaN(t) && t > 1 && setDefaultCurveSegments(t);
      getDefaultCurveSegments() >= 50 ? roundValues(!1) : roundValues(!0);
    }
    function inBrowser() {
      return "undefined" != typeof navigator;
    }
    function installPlugin(t, e) {
      "expressions" === t && setExpressionsPlugin(e);
    }
    function getFactory(t) {
      switch (t) {
        case "propertyFactory":
          return PropertyFactory;
        case "shapePropertyFactory":
          return ShapePropertyFactory;
        case "matrix":
          return Matrix;
        default:
          return null;
      }
    }
    function checkReady() {
      "complete" === document.readyState &&
        (clearInterval(readyStateCheckInterval), searchAnimations());
    }
    function getQueryVariable(t) {
      for (var e = queryString.split("&"), r = 0; r < e.length; r += 1) {
        var i = e[r].split("=");
        if (decodeURIComponent(i[0]) == t) return decodeURIComponent(i[1]);
      }
      return null;
    }
    (lottie.play = animationManager.play),
      (lottie.pause = animationManager.pause),
      (lottie.setLocationHref = setLocation),
      (lottie.togglePause = animationManager.togglePause),
      (lottie.setSpeed = animationManager.setSpeed),
      (lottie.setDirection = animationManager.setDirection),
      (lottie.stop = animationManager.stop),
      (lottie.searchAnimations = searchAnimations),
      (lottie.registerAnimation = animationManager.registerAnimation),
      (lottie.loadAnimation = loadAnimation),
      (lottie.setSubframeRendering = setSubframeRendering),
      (lottie.resize = animationManager.resize),
      (lottie.goToAndStop = animationManager.goToAndStop),
      (lottie.destroy = animationManager.destroy),
      (lottie.setQuality = setQuality),
      (lottie.inBrowser = inBrowser),
      (lottie.installPlugin = installPlugin),
      (lottie.freeze = animationManager.freeze),
      (lottie.unfreeze = animationManager.unfreeze),
      (lottie.setVolume = animationManager.setVolume),
      (lottie.mute = animationManager.mute),
      (lottie.unmute = animationManager.unmute),
      (lottie.getRegisteredAnimations =
        animationManager.getRegisteredAnimations),
      (lottie.useWebWorker = setWebWorker),
      (lottie.setIDPrefix = setPrefix),
      (lottie.__getFactory = getFactory),
      (lottie.version = "5.9.4");
    var queryString = "";
    if (standalone) {
      var scripts = document.getElementsByTagName("script"),
        index = scripts.length - 1,
        myScript = scripts[index] || { src: "" };
      (queryString = myScript.src
        ? myScript.src.replace(/^[^\?]+\??/, "")
        : ""),
        (renderer = getQueryVariable("renderer"));
    }
    var readyStateCheckInterval = setInterval(checkReady, 100);
    try {
      ("object" ===
        ("undefined" == typeof exports ? "undefined" : _typeof$3(exports)) &&
        "undefined" != typeof module) ||
        ("function" == typeof define && define.amd) ||
        (window.bodymovin = lottie);
    } catch (t) {}
    var ShapeModifiers = (function () {
      var t = {},
        e = {};
      return (
        (t.registerModifier = function (t, r) {
          e[t] || (e[t] = r);
        }),
        (t.getModifier = function (t, r, i) {
          return new e[t](r, i);
        }),
        t
      );
    })();
    function ShapeModifier() {}
    function TrimModifier() {}
    function PuckerAndBloatModifier() {}
    (ShapeModifier.prototype.initModifierProperties = function () {}),
      (ShapeModifier.prototype.addShapeToModifier = function () {}),
      (ShapeModifier.prototype.addShape = function (t) {
        if (!this.closed) {
          t.sh.container.addDynamicProperty(t.sh);
          var e = {
            shape: t.sh,
            data: t,
            localShapeCollection: shapeCollectionPool.newShapeCollection(),
          };
          this.shapes.push(e),
            this.addShapeToModifier(e),
            this._isAnimated && t.setAsAnimated();
        }
      }),
      (ShapeModifier.prototype.init = function (t, e) {
        (this.shapes = []),
          (this.elem = t),
          this.initDynamicPropertyContainer(t),
          this.initModifierProperties(t, e),
          (this.frameId = initialDefaultFrame),
          (this.closed = !1),
          (this.k = !1),
          this.dynamicProperties.length ? (this.k = !0) : this.getValue(!0);
      }),
      (ShapeModifier.prototype.processKeys = function () {
        this.elem.globalData.frameId !== this.frameId &&
          ((this.frameId = this.elem.globalData.frameId),
          this.iterateDynamicProperties());
      }),
      extendPrototype([DynamicPropertyContainer], ShapeModifier),
      extendPrototype([ShapeModifier], TrimModifier),
      (TrimModifier.prototype.initModifierProperties = function (t, e) {
        (this.s = PropertyFactory.getProp(t, e.s, 0, 0.01, this)),
          (this.e = PropertyFactory.getProp(t, e.e, 0, 0.01, this)),
          (this.o = PropertyFactory.getProp(t, e.o, 0, 0, this)),
          (this.sValue = 0),
          (this.eValue = 0),
          (this.getValue = this.processKeys),
          (this.m = e.m),
          (this._isAnimated =
            !!this.s.effectsSequence.length ||
            !!this.e.effectsSequence.length ||
            !!this.o.effectsSequence.length);
      }),
      (TrimModifier.prototype.addShapeToModifier = function (t) {
        t.pathsData = [];
      }),
      (TrimModifier.prototype.calculateShapeEdges = function (t, e, r, i, s) {
        var a = [];
        e <= 1
          ? a.push({ s: t, e: e })
          : t >= 1
          ? a.push({ s: t - 1, e: e - 1 })
          : (a.push({ s: t, e: 1 }), a.push({ s: 0, e: e - 1 }));
        var n,
          o,
          h = [],
          l = a.length;
        for (n = 0; n < l; n += 1) {
          var p, f;
          if (!((o = a[n]).e * s < i || o.s * s > i + r))
            (p = o.s * s <= i ? 0 : (o.s * s - i) / r),
              (f = o.e * s >= i + r ? 1 : (o.e * s - i) / r),
              h.push([p, f]);
        }
        return h.length || h.push([0, 0]), h;
      }),
      (TrimModifier.prototype.releasePathsData = function (t) {
        var e,
          r = t.length;
        for (e = 0; e < r; e += 1) segmentsLengthPool.release(t[e]);
        return (t.length = 0), t;
      }),
      (TrimModifier.prototype.processShapes = function (t) {
        var e, r, i, s;
        if (this._mdf || t) {
          var a = (this.o.v % 360) / 360;
          if (
            (a < 0 && (a += 1),
            (e = this.s.v > 1 ? 1 + a : this.s.v < 0 ? 0 + a : this.s.v + a) >
              (r = this.e.v > 1 ? 1 + a : this.e.v < 0 ? 0 + a : this.e.v + a))
          ) {
            var n = e;
            (e = r), (r = n);
          }
          (e = 1e-4 * Math.round(1e4 * e)),
            (r = 1e-4 * Math.round(1e4 * r)),
            (this.sValue = e),
            (this.eValue = r);
        } else (e = this.sValue), (r = this.eValue);
        var o,
          h,
          l,
          p,
          f,
          m = this.shapes.length,
          c = 0;
        if (r === e)
          for (s = 0; s < m; s += 1)
            this.shapes[s].localShapeCollection.releaseShapes(),
              (this.shapes[s].shape._mdf = !0),
              (this.shapes[s].shape.paths =
                this.shapes[s].localShapeCollection),
              this._mdf && (this.shapes[s].pathsData.length = 0);
        else if ((1 === r && 0 === e) || (0 === r && 1 === e)) {
          if (this._mdf)
            for (s = 0; s < m; s += 1)
              (this.shapes[s].pathsData.length = 0),
                (this.shapes[s].shape._mdf = !0);
        } else {
          var d,
            u,
            y = [];
          for (s = 0; s < m; s += 1)
            if (
              (d = this.shapes[s]).shape._mdf ||
              this._mdf ||
              t ||
              2 === this.m
            ) {
              if (
                ((h = (i = d.shape.paths)._length),
                (f = 0),
                !d.shape._mdf && d.pathsData.length)
              )
                f = d.totalShapeLength;
              else {
                for (
                  l = this.releasePathsData(d.pathsData), o = 0;
                  o < h;
                  o += 1
                )
                  (p = bez.getSegmentsLength(i.shapes[o])),
                    l.push(p),
                    (f += p.totalLength);
                (d.totalShapeLength = f), (d.pathsData = l);
              }
              (c += f), (d.shape._mdf = !0);
            } else d.shape.paths = d.localShapeCollection;
          var g,
            v = e,
            b = r,
            P = 0;
          for (s = m - 1; s >= 0; s -= 1)
            if ((d = this.shapes[s]).shape._mdf) {
              for (
                (u = d.localShapeCollection).releaseShapes(),
                  2 === this.m && m > 1
                    ? ((g = this.calculateShapeEdges(
                        e,
                        r,
                        d.totalShapeLength,
                        P,
                        c
                      )),
                      (P += d.totalShapeLength))
                    : (g = [[v, b]]),
                  h = g.length,
                  o = 0;
                o < h;
                o += 1
              ) {
                (v = g[o][0]),
                  (b = g[o][1]),
                  (y.length = 0),
                  b <= 1
                    ? y.push({
                        s: d.totalShapeLength * v,
                        e: d.totalShapeLength * b,
                      })
                    : v >= 1
                    ? y.push({
                        s: d.totalShapeLength * (v - 1),
                        e: d.totalShapeLength * (b - 1),
                      })
                    : (y.push({
                        s: d.totalShapeLength * v,
                        e: d.totalShapeLength,
                      }),
                      y.push({ s: 0, e: d.totalShapeLength * (b - 1) }));
                var E = this.addShapes(d, y[0]);
                if (y[0].s !== y[0].e) {
                  if (y.length > 1)
                    if (d.shape.paths.shapes[d.shape.paths._length - 1].c) {
                      var x = E.pop();
                      this.addPaths(E, u), (E = this.addShapes(d, y[1], x));
                    } else this.addPaths(E, u), (E = this.addShapes(d, y[1]));
                  this.addPaths(E, u);
                }
              }
              d.shape.paths = u;
            }
        }
      }),
      (TrimModifier.prototype.addPaths = function (t, e) {
        var r,
          i = t.length;
        for (r = 0; r < i; r += 1) e.addShape(t[r]);
      }),
      (TrimModifier.prototype.addSegment = function (t, e, r, i, s, a, n) {
        s.setXYAt(e[0], e[1], "o", a),
          s.setXYAt(r[0], r[1], "i", a + 1),
          n && s.setXYAt(t[0], t[1], "v", a),
          s.setXYAt(i[0], i[1], "v", a + 1);
      }),
      (TrimModifier.prototype.addSegmentFromArray = function (t, e, r, i) {
        e.setXYAt(t[1], t[5], "o", r),
          e.setXYAt(t[2], t[6], "i", r + 1),
          i && e.setXYAt(t[0], t[4], "v", r),
          e.setXYAt(t[3], t[7], "v", r + 1);
      }),
      (TrimModifier.prototype.addShapes = function (t, e, r) {
        var i,
          s,
          a,
          n,
          o,
          h,
          l,
          p,
          f = t.pathsData,
          m = t.shape.paths.shapes,
          c = t.shape.paths._length,
          d = 0,
          u = [],
          y = !0;
        for (
          r
            ? ((o = r._length), (p = r._length))
            : ((r = shapePool.newElement()), (o = 0), (p = 0)),
            u.push(r),
            i = 0;
          i < c;
          i += 1
        ) {
          for (
            h = f[i].lengths,
              r.c = m[i].c,
              a = m[i].c ? h.length : h.length + 1,
              s = 1;
            s < a;
            s += 1
          )
            if (d + (n = h[s - 1]).addedLength < e.s)
              (d += n.addedLength), (r.c = !1);
            else {
              if (d > e.e) {
                r.c = !1;
                break;
              }
              e.s <= d && e.e >= d + n.addedLength
                ? (this.addSegment(
                    m[i].v[s - 1],
                    m[i].o[s - 1],
                    m[i].i[s],
                    m[i].v[s],
                    r,
                    o,
                    y
                  ),
                  (y = !1))
                : ((l = bez.getNewSegment(
                    m[i].v[s - 1],
                    m[i].v[s],
                    m[i].o[s - 1],
                    m[i].i[s],
                    (e.s - d) / n.addedLength,
                    (e.e - d) / n.addedLength,
                    h[s - 1]
                  )),
                  this.addSegmentFromArray(l, r, o, y),
                  (y = !1),
                  (r.c = !1)),
                (d += n.addedLength),
                (o += 1);
            }
          if (m[i].c && h.length) {
            if (((n = h[s - 1]), d <= e.e)) {
              var g = h[s - 1].addedLength;
              e.s <= d && e.e >= d + g
                ? (this.addSegment(
                    m[i].v[s - 1],
                    m[i].o[s - 1],
                    m[i].i[0],
                    m[i].v[0],
                    r,
                    o,
                    y
                  ),
                  (y = !1))
                : ((l = bez.getNewSegment(
                    m[i].v[s - 1],
                    m[i].v[0],
                    m[i].o[s - 1],
                    m[i].i[0],
                    (e.s - d) / g,
                    (e.e - d) / g,
                    h[s - 1]
                  )),
                  this.addSegmentFromArray(l, r, o, y),
                  (y = !1),
                  (r.c = !1));
            } else r.c = !1;
            (d += n.addedLength), (o += 1);
          }
          if (
            (r._length &&
              (r.setXYAt(r.v[p][0], r.v[p][1], "i", p),
              r.setXYAt(
                r.v[r._length - 1][0],
                r.v[r._length - 1][1],
                "o",
                r._length - 1
              )),
            d > e.e)
          )
            break;
          i < c - 1 &&
            ((r = shapePool.newElement()), (y = !0), u.push(r), (o = 0));
        }
        return u;
      }),
      extendPrototype([ShapeModifier], PuckerAndBloatModifier),
      (PuckerAndBloatModifier.prototype.initModifierProperties = function (
        t,
        e
      ) {
        (this.getValue = this.processKeys),
          (this.amount = PropertyFactory.getProp(t, e.a, 0, null, this)),
          (this._isAnimated = !!this.amount.effectsSequence.length);
      }),
      (PuckerAndBloatModifier.prototype.processPath = function (t, e) {
        var r = e / 100,
          i = [0, 0],
          s = t._length,
          a = 0;
        for (a = 0; a < s; a += 1) (i[0] += t.v[a][0]), (i[1] += t.v[a][1]);
        (i[0] /= s), (i[1] /= s);
        var n,
          o,
          h,
          l,
          p,
          f,
          m = shapePool.newElement();
        for (m.c = t.c, a = 0; a < s; a += 1)
          (n = t.v[a][0] + (i[0] - t.v[a][0]) * r),
            (o = t.v[a][1] + (i[1] - t.v[a][1]) * r),
            (h = t.o[a][0] + (i[0] - t.o[a][0]) * -r),
            (l = t.o[a][1] + (i[1] - t.o[a][1]) * -r),
            (p = t.i[a][0] + (i[0] - t.i[a][0]) * -r),
            (f = t.i[a][1] + (i[1] - t.i[a][1]) * -r),
            m.setTripleAt(n, o, h, l, p, f, a);
        return m;
      }),
      (PuckerAndBloatModifier.prototype.processShapes = function (t) {
        var e,
          r,
          i,
          s,
          a,
          n,
          o = this.shapes.length,
          h = this.amount.v;
        if (0 !== h)
          for (r = 0; r < o; r += 1) {
            if (
              ((n = (a = this.shapes[r]).localShapeCollection),
              a.shape._mdf || this._mdf || t)
            )
              for (
                n.releaseShapes(),
                  a.shape._mdf = !0,
                  e = a.shape.paths.shapes,
                  s = a.shape.paths._length,
                  i = 0;
                i < s;
                i += 1
              )
                n.addShape(this.processPath(e[i], h));
            a.shape.paths = a.localShapeCollection;
          }
        this.dynamicProperties.length || (this._mdf = !1);
      });
    var TransformPropertyFactory = (function () {
      var t = [0, 0];
      function e(t, e, r) {
        if (
          ((this.elem = t),
          (this.frameId = -1),
          (this.propType = "transform"),
          (this.data = e),
          (this.v = new Matrix()),
          (this.pre = new Matrix()),
          (this.appliedTransformations = 0),
          this.initDynamicPropertyContainer(r || t),
          e.p && e.p.s
            ? ((this.px = PropertyFactory.getProp(t, e.p.x, 0, 0, this)),
              (this.py = PropertyFactory.getProp(t, e.p.y, 0, 0, this)),
              e.p.z &&
                (this.pz = PropertyFactory.getProp(t, e.p.z, 0, 0, this)))
            : (this.p = PropertyFactory.getProp(
                t,
                e.p || { k: [0, 0, 0] },
                1,
                0,
                this
              )),
          e.rx)
        ) {
          if (
            ((this.rx = PropertyFactory.getProp(t, e.rx, 0, degToRads, this)),
            (this.ry = PropertyFactory.getProp(t, e.ry, 0, degToRads, this)),
            (this.rz = PropertyFactory.getProp(t, e.rz, 0, degToRads, this)),
            e.or.k[0].ti)
          ) {
            var i,
              s = e.or.k.length;
            for (i = 0; i < s; i += 1)
              (e.or.k[i].to = null), (e.or.k[i].ti = null);
          }
          (this.or = PropertyFactory.getProp(t, e.or, 1, degToRads, this)),
            (this.or.sh = !0);
        } else
          this.r = PropertyFactory.getProp(
            t,
            e.r || { k: 0 },
            0,
            degToRads,
            this
          );
        e.sk &&
          ((this.sk = PropertyFactory.getProp(t, e.sk, 0, degToRads, this)),
          (this.sa = PropertyFactory.getProp(t, e.sa, 0, degToRads, this))),
          (this.a = PropertyFactory.getProp(
            t,
            e.a || { k: [0, 0, 0] },
            1,
            0,
            this
          )),
          (this.s = PropertyFactory.getProp(
            t,
            e.s || { k: [100, 100, 100] },
            1,
            0.01,
            this
          )),
          e.o
            ? (this.o = PropertyFactory.getProp(t, e.o, 0, 0.01, t))
            : (this.o = { _mdf: !1, v: 1 }),
          (this._isDirty = !0),
          this.dynamicProperties.length || this.getValue(!0);
      }
      return (
        (e.prototype = {
          applyToMatrix: function (t) {
            var e = this._mdf;
            this.iterateDynamicProperties(),
              (this._mdf = this._mdf || e),
              this.a && t.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]),
              this.s && t.scale(this.s.v[0], this.s.v[1], this.s.v[2]),
              this.sk && t.skewFromAxis(-this.sk.v, this.sa.v),
              this.r
                ? t.rotate(-this.r.v)
                : t
                    .rotateZ(-this.rz.v)
                    .rotateY(this.ry.v)
                    .rotateX(this.rx.v)
                    .rotateZ(-this.or.v[2])
                    .rotateY(this.or.v[1])
                    .rotateX(this.or.v[0]),
              this.data.p.s
                ? this.data.p.z
                  ? t.translate(this.px.v, this.py.v, -this.pz.v)
                  : t.translate(this.px.v, this.py.v, 0)
                : t.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
          },
          getValue: function (e) {
            if (this.elem.globalData.frameId !== this.frameId) {
              if (
                (this._isDirty &&
                  (this.precalculateMatrix(), (this._isDirty = !1)),
                this.iterateDynamicProperties(),
                this._mdf || e)
              ) {
                var r;
                if (
                  (this.v.cloneFromProps(this.pre.props),
                  this.appliedTransformations < 1 &&
                    this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]),
                  this.appliedTransformations < 2 &&
                    this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]),
                  this.sk &&
                    this.appliedTransformations < 3 &&
                    this.v.skewFromAxis(-this.sk.v, this.sa.v),
                  this.r && this.appliedTransformations < 4
                    ? this.v.rotate(-this.r.v)
                    : !this.r &&
                      this.appliedTransformations < 4 &&
                      this.v
                        .rotateZ(-this.rz.v)
                        .rotateY(this.ry.v)
                        .rotateX(this.rx.v)
                        .rotateZ(-this.or.v[2])
                        .rotateY(this.or.v[1])
                        .rotateX(this.or.v[0]),
                  this.autoOriented)
                ) {
                  var i, s;
                  if (
                    ((r = this.elem.globalData.frameRate),
                    this.p && this.p.keyframes && this.p.getValueAtTime)
                  )
                    this.p._caching.lastFrame + this.p.offsetTime <=
                    this.p.keyframes[0].t
                      ? ((i = this.p.getValueAtTime(
                          (this.p.keyframes[0].t + 0.01) / r,
                          0
                        )),
                        (s = this.p.getValueAtTime(
                          this.p.keyframes[0].t / r,
                          0
                        )))
                      : this.p._caching.lastFrame + this.p.offsetTime >=
                        this.p.keyframes[this.p.keyframes.length - 1].t
                      ? ((i = this.p.getValueAtTime(
                          this.p.keyframes[this.p.keyframes.length - 1].t / r,
                          0
                        )),
                        (s = this.p.getValueAtTime(
                          (this.p.keyframes[this.p.keyframes.length - 1].t -
                            0.05) /
                            r,
                          0
                        )))
                      : ((i = this.p.pv),
                        (s = this.p.getValueAtTime(
                          (this.p._caching.lastFrame +
                            this.p.offsetTime -
                            0.01) /
                            r,
                          this.p.offsetTime
                        )));
                  else if (
                    this.px &&
                    this.px.keyframes &&
                    this.py.keyframes &&
                    this.px.getValueAtTime &&
                    this.py.getValueAtTime
                  ) {
                    (i = []), (s = []);
                    var a = this.px,
                      n = this.py;
                    a._caching.lastFrame + a.offsetTime <= a.keyframes[0].t
                      ? ((i[0] = a.getValueAtTime(
                          (a.keyframes[0].t + 0.01) / r,
                          0
                        )),
                        (i[1] = n.getValueAtTime(
                          (n.keyframes[0].t + 0.01) / r,
                          0
                        )),
                        (s[0] = a.getValueAtTime(a.keyframes[0].t / r, 0)),
                        (s[1] = n.getValueAtTime(n.keyframes[0].t / r, 0)))
                      : a._caching.lastFrame + a.offsetTime >=
                        a.keyframes[a.keyframes.length - 1].t
                      ? ((i[0] = a.getValueAtTime(
                          a.keyframes[a.keyframes.length - 1].t / r,
                          0
                        )),
                        (i[1] = n.getValueAtTime(
                          n.keyframes[n.keyframes.length - 1].t / r,
                          0
                        )),
                        (s[0] = a.getValueAtTime(
                          (a.keyframes[a.keyframes.length - 1].t - 0.01) / r,
                          0
                        )),
                        (s[1] = n.getValueAtTime(
                          (n.keyframes[n.keyframes.length - 1].t - 0.01) / r,
                          0
                        )))
                      : ((i = [a.pv, n.pv]),
                        (s[0] = a.getValueAtTime(
                          (a._caching.lastFrame + a.offsetTime - 0.01) / r,
                          a.offsetTime
                        )),
                        (s[1] = n.getValueAtTime(
                          (n._caching.lastFrame + n.offsetTime - 0.01) / r,
                          n.offsetTime
                        )));
                  } else i = s = t;
                  this.v.rotate(-Math.atan2(i[1] - s[1], i[0] - s[0]));
                }
                this.data.p && this.data.p.s
                  ? this.data.p.z
                    ? this.v.translate(this.px.v, this.py.v, -this.pz.v)
                    : this.v.translate(this.px.v, this.py.v, 0)
                  : this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
              }
              this.frameId = this.elem.globalData.frameId;
            }
          },
          precalculateMatrix: function () {
            if (
              !this.a.k &&
              (this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]),
              (this.appliedTransformations = 1),
              !this.s.effectsSequence.length)
            ) {
              if (
                (this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]),
                (this.appliedTransformations = 2),
                this.sk)
              ) {
                if (
                  this.sk.effectsSequence.length ||
                  this.sa.effectsSequence.length
                )
                  return;
                this.pre.skewFromAxis(-this.sk.v, this.sa.v),
                  (this.appliedTransformations = 3);
              }
              this.r
                ? this.r.effectsSequence.length ||
                  (this.pre.rotate(-this.r.v),
                  (this.appliedTransformations = 4))
                : this.rz.effectsSequence.length ||
                  this.ry.effectsSequence.length ||
                  this.rx.effectsSequence.length ||
                  this.or.effectsSequence.length ||
                  (this.pre
                    .rotateZ(-this.rz.v)
                    .rotateY(this.ry.v)
                    .rotateX(this.rx.v)
                    .rotateZ(-this.or.v[2])
                    .rotateY(this.or.v[1])
                    .rotateX(this.or.v[0]),
                  (this.appliedTransformations = 4));
            }
          },
          autoOrient: function () {},
        }),
        extendPrototype([DynamicPropertyContainer], e),
        (e.prototype.addDynamicProperty = function (t) {
          this._addDynamicProperty(t),
            this.elem.addDynamicProperty(t),
            (this._isDirty = !0);
        }),
        (e.prototype._addDynamicProperty =
          DynamicPropertyContainer.prototype.addDynamicProperty),
        {
          getTransformProperty: function (t, r, i) {
            return new e(t, r, i);
          },
        }
      );
    })();
    function RepeaterModifier() {}
    function RoundCornersModifier() {}
    function getFontProperties(t) {
      for (
        var e = t.fStyle ? t.fStyle.split(" ") : [],
          r = "normal",
          i = "normal",
          s = e.length,
          a = 0;
        a < s;
        a += 1
      )
        switch (e[a].toLowerCase()) {
          case "italic":
            i = "italic";
            break;
          case "bold":
            r = "700";
            break;
          case "black":
            r = "900";
            break;
          case "medium":
            r = "500";
            break;
          case "regular":
          case "normal":
            r = "400";
            break;
          case "light":
          case "thin":
            r = "200";
        }
      return { style: i, weight: t.fWeight || r };
    }
    extendPrototype([ShapeModifier], RepeaterModifier),
      (RepeaterModifier.prototype.initModifierProperties = function (t, e) {
        (this.getValue = this.processKeys),
          (this.c = PropertyFactory.getProp(t, e.c, 0, null, this)),
          (this.o = PropertyFactory.getProp(t, e.o, 0, null, this)),
          (this.tr = TransformPropertyFactory.getTransformProperty(
            t,
            e.tr,
            this
          )),
          (this.so = PropertyFactory.getProp(t, e.tr.so, 0, 0.01, this)),
          (this.eo = PropertyFactory.getProp(t, e.tr.eo, 0, 0.01, this)),
          (this.data = e),
          this.dynamicProperties.length || this.getValue(!0),
          (this._isAnimated = !!this.dynamicProperties.length),
          (this.pMatrix = new Matrix()),
          (this.rMatrix = new Matrix()),
          (this.sMatrix = new Matrix()),
          (this.tMatrix = new Matrix()),
          (this.matrix = new Matrix());
      }),
      (RepeaterModifier.prototype.applyTransforms = function (
        t,
        e,
        r,
        i,
        s,
        a
      ) {
        var n = a ? -1 : 1,
          o = i.s.v[0] + (1 - i.s.v[0]) * (1 - s),
          h = i.s.v[1] + (1 - i.s.v[1]) * (1 - s);
        t.translate(i.p.v[0] * n * s, i.p.v[1] * n * s, i.p.v[2]),
          e.translate(-i.a.v[0], -i.a.v[1], i.a.v[2]),
          e.rotate(-i.r.v * n * s),
          e.translate(i.a.v[0], i.a.v[1], i.a.v[2]),
          r.translate(-i.a.v[0], -i.a.v[1], i.a.v[2]),
          r.scale(a ? 1 / o : o, a ? 1 / h : h),
          r.translate(i.a.v[0], i.a.v[1], i.a.v[2]);
      }),
      (RepeaterModifier.prototype.init = function (t, e, r, i) {
        for (
          this.elem = t,
            this.arr = e,
            this.pos = r,
            this.elemsData = i,
            this._currentCopies = 0,
            this._elements = [],
            this._groups = [],
            this.frameId = -1,
            this.initDynamicPropertyContainer(t),
            this.initModifierProperties(t, e[r]);
          r > 0;

        )
          (r -= 1), this._elements.unshift(e[r]);
        this.dynamicProperties.length ? (this.k = !0) : this.getValue(!0);
      }),
      (RepeaterModifier.prototype.resetElements = function (t) {
        var e,
          r = t.length;
        for (e = 0; e < r; e += 1)
          (t[e]._processed = !1),
            "gr" === t[e].ty && this.resetElements(t[e].it);
      }),
      (RepeaterModifier.prototype.cloneElements = function (t) {
        var e = JSON.parse(JSON.stringify(t));
        return this.resetElements(e), e;
      }),
      (RepeaterModifier.prototype.changeGroupRender = function (t, e) {
        var r,
          i = t.length;
        for (r = 0; r < i; r += 1)
          (t[r]._render = e),
            "gr" === t[r].ty && this.changeGroupRender(t[r].it, e);
      }),
      (RepeaterModifier.prototype.processShapes = function (t) {
        var e,
          r,
          i,
          s,
          a,
          n = !1;
        if (this._mdf || t) {
          var o,
            h = Math.ceil(this.c.v);
          if (this._groups.length < h) {
            for (; this._groups.length < h; ) {
              var l = { it: this.cloneElements(this._elements), ty: "gr" };
              l.it.push({
                a: { a: 0, ix: 1, k: [0, 0] },
                nm: "Transform",
                o: { a: 0, ix: 7, k: 100 },
                p: { a: 0, ix: 2, k: [0, 0] },
                r: {
                  a: 1,
                  ix: 6,
                  k: [
                    { s: 0, e: 0, t: 0 },
                    { s: 0, e: 0, t: 1 },
                  ],
                },
                s: { a: 0, ix: 3, k: [100, 100] },
                sa: { a: 0, ix: 5, k: 0 },
                sk: { a: 0, ix: 4, k: 0 },
                ty: "tr",
              }),
                this.arr.splice(0, 0, l),
                this._groups.splice(0, 0, l),
                (this._currentCopies += 1);
            }
            this.elem.reloadShapes(), (n = !0);
          }
          for (a = 0, i = 0; i <= this._groups.length - 1; i += 1) {
            if (
              ((o = a < h),
              (this._groups[i]._render = o),
              this.changeGroupRender(this._groups[i].it, o),
              !o)
            ) {
              var p = this.elemsData[i].it,
                f = p[p.length - 1];
              0 !== f.transform.op.v
                ? ((f.transform.op._mdf = !0), (f.transform.op.v = 0))
                : (f.transform.op._mdf = !1);
            }
            a += 1;
          }
          this._currentCopies = h;
          var m = this.o.v,
            c = m % 1,
            d = m > 0 ? Math.floor(m) : Math.ceil(m),
            u = this.pMatrix.props,
            y = this.rMatrix.props,
            g = this.sMatrix.props;
          this.pMatrix.reset(),
            this.rMatrix.reset(),
            this.sMatrix.reset(),
            this.tMatrix.reset(),
            this.matrix.reset();
          var v,
            b,
            P = 0;
          if (m > 0) {
            for (; P < d; )
              this.applyTransforms(
                this.pMatrix,
                this.rMatrix,
                this.sMatrix,
                this.tr,
                1,
                !1
              ),
                (P += 1);
            c &&
              (this.applyTransforms(
                this.pMatrix,
                this.rMatrix,
                this.sMatrix,
                this.tr,
                c,
                !1
              ),
              (P += c));
          } else if (m < 0) {
            for (; P > d; )
              this.applyTransforms(
                this.pMatrix,
                this.rMatrix,
                this.sMatrix,
                this.tr,
                1,
                !0
              ),
                (P -= 1);
            c &&
              (this.applyTransforms(
                this.pMatrix,
                this.rMatrix,
                this.sMatrix,
                this.tr,
                -c,
                !0
              ),
              (P -= c));
          }
          for (
            i = 1 === this.data.m ? 0 : this._currentCopies - 1,
              s = 1 === this.data.m ? 1 : -1,
              a = this._currentCopies;
            a;

          ) {
            if (
              ((b = (r = (e = this.elemsData[i].it)[e.length - 1].transform
                .mProps.v.props).length),
              (e[e.length - 1].transform.mProps._mdf = !0),
              (e[e.length - 1].transform.op._mdf = !0),
              (e[e.length - 1].transform.op.v =
                1 === this._currentCopies
                  ? this.so.v
                  : this.so.v +
                    (this.eo.v - this.so.v) * (i / (this._currentCopies - 1))),
              0 !== P)
            ) {
              for (
                ((0 !== i && 1 === s) ||
                  (i !== this._currentCopies - 1 && -1 === s)) &&
                  this.applyTransforms(
                    this.pMatrix,
                    this.rMatrix,
                    this.sMatrix,
                    this.tr,
                    1,
                    !1
                  ),
                  this.matrix.transform(
                    y[0],
                    y[1],
                    y[2],
                    y[3],
                    y[4],
                    y[5],
                    y[6],
                    y[7],
                    y[8],
                    y[9],
                    y[10],
                    y[11],
                    y[12],
                    y[13],
                    y[14],
                    y[15]
                  ),
                  this.matrix.transform(
                    g[0],
                    g[1],
                    g[2],
                    g[3],
                    g[4],
                    g[5],
                    g[6],
                    g[7],
                    g[8],
                    g[9],
                    g[10],
                    g[11],
                    g[12],
                    g[13],
                    g[14],
                    g[15]
                  ),
                  this.matrix.transform(
                    u[0],
                    u[1],
                    u[2],
                    u[3],
                    u[4],
                    u[5],
                    u[6],
                    u[7],
                    u[8],
                    u[9],
                    u[10],
                    u[11],
                    u[12],
                    u[13],
                    u[14],
                    u[15]
                  ),
                  v = 0;
                v < b;
                v += 1
              )
                r[v] = this.matrix.props[v];
              this.matrix.reset();
            } else
              for (this.matrix.reset(), v = 0; v < b; v += 1)
                r[v] = this.matrix.props[v];
            (P += 1), (a -= 1), (i += s);
          }
        } else
          for (a = this._currentCopies, i = 0, s = 1; a; )
            (r = (e = this.elemsData[i].it)[e.length - 1].transform.mProps.v
              .props),
              (e[e.length - 1].transform.mProps._mdf = !1),
              (e[e.length - 1].transform.op._mdf = !1),
              (a -= 1),
              (i += s);
        return n;
      }),
      (RepeaterModifier.prototype.addShape = function () {}),
      extendPrototype([ShapeModifier], RoundCornersModifier),
      (RoundCornersModifier.prototype.initModifierProperties = function (t, e) {
        (this.getValue = this.processKeys),
          (this.rd = PropertyFactory.getProp(t, e.r, 0, null, this)),
          (this._isAnimated = !!this.rd.effectsSequence.length);
      }),
      (RoundCornersModifier.prototype.processPath = function (t, e) {
        var r,
          i = shapePool.newElement();
        i.c = t.c;
        var s,
          a,
          n,
          o,
          h,
          l,
          p,
          f,
          m,
          c,
          d,
          u,
          y = t._length,
          g = 0;
        for (r = 0; r < y; r += 1)
          (s = t.v[r]),
            (n = t.o[r]),
            (a = t.i[r]),
            s[0] === n[0] && s[1] === n[1] && s[0] === a[0] && s[1] === a[1]
              ? (0 !== r && r !== y - 1) || t.c
                ? ((o = 0 === r ? t.v[y - 1] : t.v[r - 1]),
                  (l = (h = Math.sqrt(
                    Math.pow(s[0] - o[0], 2) + Math.pow(s[1] - o[1], 2)
                  ))
                    ? Math.min(h / 2, e) / h
                    : 0),
                  (p = d = s[0] + (o[0] - s[0]) * l),
                  (f = u = s[1] - (s[1] - o[1]) * l),
                  (m = p - (p - s[0]) * roundCorner),
                  (c = f - (f - s[1]) * roundCorner),
                  i.setTripleAt(p, f, m, c, d, u, g),
                  (g += 1),
                  (o = r === y - 1 ? t.v[0] : t.v[r + 1]),
                  (l = (h = Math.sqrt(
                    Math.pow(s[0] - o[0], 2) + Math.pow(s[1] - o[1], 2)
                  ))
                    ? Math.min(h / 2, e) / h
                    : 0),
                  (p = m = s[0] + (o[0] - s[0]) * l),
                  (f = c = s[1] + (o[1] - s[1]) * l),
                  (d = p - (p - s[0]) * roundCorner),
                  (u = f - (f - s[1]) * roundCorner),
                  i.setTripleAt(p, f, m, c, d, u, g),
                  (g += 1))
                : (i.setTripleAt(s[0], s[1], n[0], n[1], a[0], a[1], g),
                  (g += 1))
              : (i.setTripleAt(
                  t.v[r][0],
                  t.v[r][1],
                  t.o[r][0],
                  t.o[r][1],
                  t.i[r][0],
                  t.i[r][1],
                  g
                ),
                (g += 1));
        return i;
      }),
      (RoundCornersModifier.prototype.processShapes = function (t) {
        var e,
          r,
          i,
          s,
          a,
          n,
          o = this.shapes.length,
          h = this.rd.v;
        if (0 !== h)
          for (r = 0; r < o; r += 1) {
            if (
              ((n = (a = this.shapes[r]).localShapeCollection),
              a.shape._mdf || this._mdf || t)
            )
              for (
                n.releaseShapes(),
                  a.shape._mdf = !0,
                  e = a.shape.paths.shapes,
                  s = a.shape.paths._length,
                  i = 0;
                i < s;
                i += 1
              )
                n.addShape(this.processPath(e[i], h));
            a.shape.paths = a.localShapeCollection;
          }
        this.dynamicProperties.length || (this._mdf = !1);
      });
    var FontManager = (function () {
      var t = { w: 0, size: 0, shapes: [], data: { shapes: [] } },
        e = [];
      e = e.concat([
        2304, 2305, 2306, 2307, 2362, 2363, 2364, 2364, 2366, 2367, 2368, 2369,
        2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379, 2380, 2381,
        2382, 2383, 2387, 2388, 2389, 2390, 2391, 2402, 2403,
      ]);
      var r = ["d83cdffb", "d83cdffc", "d83cdffd", "d83cdffe", "d83cdfff"],
        i = [65039, 8205];
      function s(t, e) {
        var r = createTag("span");
        r.setAttribute("aria-hidden", !0), (r.style.fontFamily = e);
        var i = createTag("span");
        (i.innerText = "giItT1WQy@!-/#"),
          (r.style.position = "absolute"),
          (r.style.left = "-10000px"),
          (r.style.top = "-10000px"),
          (r.style.fontSize = "300px"),
          (r.style.fontVariant = "normal"),
          (r.style.fontStyle = "normal"),
          (r.style.fontWeight = "normal"),
          (r.style.letterSpacing = "0"),
          r.appendChild(i),
          document.body.appendChild(r);
        var s = i.offsetWidth;
        return (
          (i.style.fontFamily =
            (function (t) {
              var e,
                r = t.split(","),
                i = r.length,
                s = [];
              for (e = 0; e < i; e += 1)
                "sans-serif" !== r[e] && "monospace" !== r[e] && s.push(r[e]);
              return s.join(",");
            })(t) +
            ", " +
            e),
          { node: i, w: s, parent: r }
        );
      }
      function a(t, e) {
        var r,
          i = document.body && e ? "svg" : "canvas",
          s = getFontProperties(t);
        if ("svg" === i) {
          var a = createNS("text");
          (a.style.fontSize = "100px"),
            a.setAttribute("font-family", t.fFamily),
            a.setAttribute("font-style", s.style),
            a.setAttribute("font-weight", s.weight),
            (a.textContent = "1"),
            t.fClass
              ? ((a.style.fontFamily = "inherit"),
                a.setAttribute("class", t.fClass))
              : (a.style.fontFamily = t.fFamily),
            e.appendChild(a),
            (r = a);
        } else {
          var n = new OffscreenCanvas(500, 500).getContext("2d");
          (n.font = s.style + " " + s.weight + " 100px " + t.fFamily), (r = n);
        }
        return {
          measureText: function (t) {
            return "svg" === i
              ? ((r.textContent = t), r.getComputedTextLength())
              : r.measureText(t).width;
          },
        };
      }
      var n = function () {
        (this.fonts = []),
          (this.chars = null),
          (this.typekitLoaded = 0),
          (this.isLoaded = !1),
          (this._warned = !1),
          (this.initTime = Date.now()),
          (this.setIsLoadedBinded = this.setIsLoaded.bind(this)),
          (this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this));
      };
      (n.isModifier = function (t, e) {
        var i = t.toString(16) + e.toString(16);
        return -1 !== r.indexOf(i);
      }),
        (n.isZeroWidthJoiner = function (t, e) {
          return e ? t === i[0] && e === i[1] : t === i[1];
        }),
        (n.isCombinedCharacter = function (t) {
          return -1 !== e.indexOf(t);
        });
      var o = {
        addChars: function (t) {
          if (t) {
            var e;
            this.chars || (this.chars = []);
            var r,
              i,
              s = t.length,
              a = this.chars.length;
            for (e = 0; e < s; e += 1) {
              for (r = 0, i = !1; r < a; )
                this.chars[r].style === t[e].style &&
                  this.chars[r].fFamily === t[e].fFamily &&
                  this.chars[r].ch === t[e].ch &&
                  (i = !0),
                  (r += 1);
              i || (this.chars.push(t[e]), (a += 1));
            }
          }
        },
        addFonts: function (t, e) {
          if (t) {
            if (this.chars)
              return (this.isLoaded = !0), void (this.fonts = t.list);
            if (!document.body)
              return (
                (this.isLoaded = !0),
                t.list.forEach(function (t) {
                  (t.helper = a(t)), (t.cache = {});
                }),
                void (this.fonts = t.list)
              );
            var r,
              i = t.list,
              n = i.length,
              o = n;
            for (r = 0; r < n; r += 1) {
              var h,
                l,
                p = !0;
              if (
                ((i[r].loaded = !1),
                (i[r].monoCase = s(i[r].fFamily, "monospace")),
                (i[r].sansCase = s(i[r].fFamily, "sans-serif")),
                i[r].fPath)
              ) {
                if ("p" === i[r].fOrigin || 3 === i[r].origin) {
                  if (
                    ((h = document.querySelectorAll(
                      'style[f-forigin="p"][f-family="' +
                        i[r].fFamily +
                        '"], style[f-origin="3"][f-family="' +
                        i[r].fFamily +
                        '"]'
                    )).length > 0 && (p = !1),
                    p)
                  ) {
                    var f = createTag("style");
                    f.setAttribute("f-forigin", i[r].fOrigin),
                      f.setAttribute("f-origin", i[r].origin),
                      f.setAttribute("f-family", i[r].fFamily),
                      (f.type = "text/css"),
                      (f.innerText =
                        "@font-face {font-family: " +
                        i[r].fFamily +
                        "; font-style: normal; src: url('" +
                        i[r].fPath +
                        "');}"),
                      e.appendChild(f);
                  }
                } else if ("g" === i[r].fOrigin || 1 === i[r].origin) {
                  for (
                    h = document.querySelectorAll(
                      'link[f-forigin="g"], link[f-origin="1"]'
                    ),
                      l = 0;
                    l < h.length;
                    l += 1
                  )
                    -1 !== h[l].href.indexOf(i[r].fPath) && (p = !1);
                  if (p) {
                    var m = createTag("link");
                    m.setAttribute("f-forigin", i[r].fOrigin),
                      m.setAttribute("f-origin", i[r].origin),
                      (m.type = "text/css"),
                      (m.rel = "stylesheet"),
                      (m.href = i[r].fPath),
                      document.body.appendChild(m);
                  }
                } else if ("t" === i[r].fOrigin || 2 === i[r].origin) {
                  for (
                    h = document.querySelectorAll(
                      'script[f-forigin="t"], script[f-origin="2"]'
                    ),
                      l = 0;
                    l < h.length;
                    l += 1
                  )
                    i[r].fPath === h[l].src && (p = !1);
                  if (p) {
                    var c = createTag("link");
                    c.setAttribute("f-forigin", i[r].fOrigin),
                      c.setAttribute("f-origin", i[r].origin),
                      c.setAttribute("rel", "stylesheet"),
                      c.setAttribute("href", i[r].fPath),
                      e.appendChild(c);
                  }
                }
              } else (i[r].loaded = !0), (o -= 1);
              (i[r].helper = a(i[r], e)),
                (i[r].cache = {}),
                this.fonts.push(i[r]);
            }
            0 === o
              ? (this.isLoaded = !0)
              : setTimeout(this.checkLoadedFonts.bind(this), 100);
          } else this.isLoaded = !0;
        },
        getCharData: function (e, r, i) {
          for (var s = 0, a = this.chars.length; s < a; ) {
            if (
              this.chars[s].ch === e &&
              this.chars[s].style === r &&
              this.chars[s].fFamily === i
            )
              return this.chars[s];
            s += 1;
          }
          return (
            (("string" == typeof e && 13 !== e.charCodeAt(0)) || !e) &&
              console &&
              console.warn &&
              !this._warned &&
              ((this._warned = !0),
              console.warn(
                "Missing character from exported characters list: ",
                e,
                r,
                i
              )),
            t
          );
        },
        getFontByName: function (t) {
          for (var e = 0, r = this.fonts.length; e < r; ) {
            if (this.fonts[e].fName === t) return this.fonts[e];
            e += 1;
          }
          return this.fonts[0];
        },
        measureText: function (t, e, r) {
          var i = this.getFontByName(e),
            s = t.charCodeAt(0);
          if (!i.cache[s + 1]) {
            var a = i.helper;
            if (" " === t) {
              var n = a.measureText("|" + t + "|"),
                o = a.measureText("||");
              i.cache[s + 1] = (n - o) / 100;
            } else i.cache[s + 1] = a.measureText(t) / 100;
          }
          return i.cache[s + 1] * r;
        },
        checkLoadedFonts: function () {
          var t,
            e,
            r,
            i = this.fonts.length,
            s = i;
          for (t = 0; t < i; t += 1)
            this.fonts[t].loaded
              ? (s -= 1)
              : "n" === this.fonts[t].fOrigin || 0 === this.fonts[t].origin
              ? (this.fonts[t].loaded = !0)
              : ((e = this.fonts[t].monoCase.node),
                (r = this.fonts[t].monoCase.w),
                e.offsetWidth !== r
                  ? ((s -= 1), (this.fonts[t].loaded = !0))
                  : ((e = this.fonts[t].sansCase.node),
                    (r = this.fonts[t].sansCase.w),
                    e.offsetWidth !== r &&
                      ((s -= 1), (this.fonts[t].loaded = !0))),
                this.fonts[t].loaded &&
                  (this.fonts[t].sansCase.parent.parentNode.removeChild(
                    this.fonts[t].sansCase.parent
                  ),
                  this.fonts[t].monoCase.parent.parentNode.removeChild(
                    this.fonts[t].monoCase.parent
                  )));
          0 !== s && Date.now() - this.initTime < 5e3
            ? setTimeout(this.checkLoadedFontsBinded, 20)
            : setTimeout(this.setIsLoadedBinded, 10);
        },
        setIsLoaded: function () {
          this.isLoaded = !0;
        },
      };
      return (n.prototype = o), n;
    })();
    function RenderableElement() {}
    RenderableElement.prototype = {
      initRenderable: function () {
        (this.isInRange = !1),
          (this.hidden = !1),
          (this.isTransparent = !1),
          (this.renderableComponents = []);
      },
      addRenderableComponent: function (t) {
        -1 === this.renderableComponents.indexOf(t) &&
          this.renderableComponents.push(t);
      },
      removeRenderableComponent: function (t) {
        -1 !== this.renderableComponents.indexOf(t) &&
          this.renderableComponents.splice(
            this.renderableComponents.indexOf(t),
            1
          );
      },
      prepareRenderableFrame: function (t) {
        this.checkLayerLimits(t);
      },
      checkTransparency: function () {
        this.finalTransform.mProp.o.v <= 0
          ? !this.isTransparent &&
            this.globalData.renderConfig.hideOnTransparent &&
            ((this.isTransparent = !0), this.hide())
          : this.isTransparent && ((this.isTransparent = !1), this.show());
      },
      checkLayerLimits: function (t) {
        this.data.ip - this.data.st <= t && this.data.op - this.data.st > t
          ? !0 !== this.isInRange &&
            ((this.globalData._mdf = !0),
            (this._mdf = !0),
            (this.isInRange = !0),
            this.show())
          : !1 !== this.isInRange &&
            ((this.globalData._mdf = !0), (this.isInRange = !1), this.hide());
      },
      renderRenderable: function () {
        var t,
          e = this.renderableComponents.length;
        for (t = 0; t < e; t += 1)
          this.renderableComponents[t].renderFrame(this._isFirstFrame);
      },
      sourceRectAtTime: function () {
        return { top: 0, left: 0, width: 100, height: 100 };
      },
      getLayerSize: function () {
        return 5 === this.data.ty
          ? { w: this.data.textData.width, h: this.data.textData.height }
          : { w: this.data.width, h: this.data.height };
      },
    };
    var MaskManagerInterface = (function () {
        function t(t, e) {
          (this._mask = t), (this._data = e);
        }
        Object.defineProperty(t.prototype, "maskPath", {
          get: function () {
            return (
              this._mask.prop.k && this._mask.prop.getValue(), this._mask.prop
            );
          },
        }),
          Object.defineProperty(t.prototype, "maskOpacity", {
            get: function () {
              return (
                this._mask.op.k && this._mask.op.getValue(),
                100 * this._mask.op.v
              );
            },
          });
        return function (e) {
          var r,
            i = createSizedArray(e.viewData.length),
            s = e.viewData.length;
          for (r = 0; r < s; r += 1)
            i[r] = new t(e.viewData[r], e.masksProperties[r]);
          return function (t) {
            for (r = 0; r < s; ) {
              if (e.masksProperties[r].nm === t) return i[r];
              r += 1;
            }
            return null;
          };
        };
      })(),
      ExpressionPropertyInterface = (function () {
        var t = { pv: 0, v: 0, mult: 1 },
          e = { pv: [0, 0, 0], v: [0, 0, 0], mult: 1 };
        function r(t, e, r) {
          Object.defineProperty(t, "velocity", {
            get: function () {
              return e.getVelocityAtTime(e.comp.currentFrame);
            },
          }),
            (t.numKeys = e.keyframes ? e.keyframes.length : 0),
            (t.key = function (i) {
              if (!t.numKeys) return 0;
              var s = "";
              s =
                "s" in e.keyframes[i - 1]
                  ? e.keyframes[i - 1].s
                  : "e" in e.keyframes[i - 2]
                  ? e.keyframes[i - 2].e
                  : e.keyframes[i - 2].s;
              var a =
                "unidimensional" === r ? new Number(s) : Object.assign({}, s);
              return (
                (a.time =
                  e.keyframes[i - 1].t / e.elem.comp.globalData.frameRate),
                (a.value = "unidimensional" === r ? s[0] : s),
                a
              );
            }),
            (t.valueAtTime = e.getValueAtTime),
            (t.speedAtTime = e.getSpeedAtTime),
            (t.velocityAtTime = e.getVelocityAtTime),
            (t.propertyGroup = e.propertyGroup);
        }
        function i() {
          return t;
        }
        return function (s) {
          return s
            ? "unidimensional" === s.propType
              ? (function (e) {
                  (e && "pv" in e) || (e = t);
                  var i = 1 / e.mult,
                    s = e.pv * i,
                    a = new Number(s);
                  return (
                    (a.value = s),
                    r(a, e, "unidimensional"),
                    function () {
                      return (
                        e.k && e.getValue(),
                        (s = e.v * i),
                        a.value !== s &&
                          (((a = new Number(s)).value = s),
                          r(a, e, "unidimensional")),
                        a
                      );
                    }
                  );
                })(s)
              : (function (t) {
                  (t && "pv" in t) || (t = e);
                  var i = 1 / t.mult,
                    s = (t.data && t.data.l) || t.pv.length,
                    a = createTypedArray("float32", s),
                    n = createTypedArray("float32", s);
                  return (
                    (a.value = n),
                    r(a, t, "multidimensional"),
                    function () {
                      t.k && t.getValue();
                      for (var e = 0; e < s; e += 1)
                        (n[e] = t.v[e] * i), (a[e] = n[e]);
                      return a;
                    }
                  );
                })(s)
            : i;
        };
      })(),
      TransformExpressionInterface = function (t) {
        function e(t) {
          switch (t) {
            case "scale":
            case "Scale":
            case "ADBE Scale":
            case 6:
              return e.scale;
            case "rotation":
            case "Rotation":
            case "ADBE Rotation":
            case "ADBE Rotate Z":
            case 10:
              return e.rotation;
            case "ADBE Rotate X":
              return e.xRotation;
            case "ADBE Rotate Y":
              return e.yRotation;
            case "position":
            case "Position":
            case "ADBE Position":
            case 2:
              return e.position;
            case "ADBE Position_0":
              return e.xPosition;
            case "ADBE Position_1":
              return e.yPosition;
            case "ADBE Position_2":
              return e.zPosition;
            case "anchorPoint":
            case "AnchorPoint":
            case "Anchor Point":
            case "ADBE AnchorPoint":
            case 1:
              return e.anchorPoint;
            case "opacity":
            case "Opacity":
            case 11:
              return e.opacity;
            default:
              return null;
          }
        }
        var r, i, s, a;
        return (
          Object.defineProperty(e, "rotation", {
            get: ExpressionPropertyInterface(t.r || t.rz),
          }),
          Object.defineProperty(e, "zRotation", {
            get: ExpressionPropertyInterface(t.rz || t.r),
          }),
          Object.defineProperty(e, "xRotation", {
            get: ExpressionPropertyInterface(t.rx),
          }),
          Object.defineProperty(e, "yRotation", {
            get: ExpressionPropertyInterface(t.ry),
          }),
          Object.defineProperty(e, "scale", {
            get: ExpressionPropertyInterface(t.s),
          }),
          t.p
            ? (a = ExpressionPropertyInterface(t.p))
            : ((r = ExpressionPropertyInterface(t.px)),
              (i = ExpressionPropertyInterface(t.py)),
              t.pz && (s = ExpressionPropertyInterface(t.pz))),
          Object.defineProperty(e, "position", {
            get: function () {
              return t.p ? a() : [r(), i(), s ? s() : 0];
            },
          }),
          Object.defineProperty(e, "xPosition", {
            get: ExpressionPropertyInterface(t.px),
          }),
          Object.defineProperty(e, "yPosition", {
            get: ExpressionPropertyInterface(t.py),
          }),
          Object.defineProperty(e, "zPosition", {
            get: ExpressionPropertyInterface(t.pz),
          }),
          Object.defineProperty(e, "anchorPoint", {
            get: ExpressionPropertyInterface(t.a),
          }),
          Object.defineProperty(e, "opacity", {
            get: ExpressionPropertyInterface(t.o),
          }),
          Object.defineProperty(e, "skew", {
            get: ExpressionPropertyInterface(t.sk),
          }),
          Object.defineProperty(e, "skewAxis", {
            get: ExpressionPropertyInterface(t.sa),
          }),
          Object.defineProperty(e, "orientation", {
            get: ExpressionPropertyInterface(t.or),
          }),
          e
        );
      },
      LayerExpressionInterface = (function () {
        function t(t) {
          var e = new Matrix();
          void 0 !== t
            ? this._elem.finalTransform.mProp.getValueAtTime(t).clone(e)
            : this._elem.finalTransform.mProp.applyToMatrix(e);
          return e;
        }
        function e(t, e) {
          var r = this.getMatrix(e);
          return (
            (r.props[12] = 0),
            (r.props[13] = 0),
            (r.props[14] = 0),
            this.applyPoint(r, t)
          );
        }
        function r(t, e) {
          var r = this.getMatrix(e);
          return this.applyPoint(r, t);
        }
        function i(t, e) {
          var r = this.getMatrix(e);
          return (
            (r.props[12] = 0),
            (r.props[13] = 0),
            (r.props[14] = 0),
            this.invertPoint(r, t)
          );
        }
        function s(t, e) {
          var r = this.getMatrix(e);
          return this.invertPoint(r, t);
        }
        function a(t, e) {
          if (this._elem.hierarchy && this._elem.hierarchy.length) {
            var r,
              i = this._elem.hierarchy.length;
            for (r = 0; r < i; r += 1)
              this._elem.hierarchy[r].finalTransform.mProp.applyToMatrix(t);
          }
          return t.applyToPointArray(e[0], e[1], e[2] || 0);
        }
        function n(t, e) {
          if (this._elem.hierarchy && this._elem.hierarchy.length) {
            var r,
              i = this._elem.hierarchy.length;
            for (r = 0; r < i; r += 1)
              this._elem.hierarchy[r].finalTransform.mProp.applyToMatrix(t);
          }
          return t.inversePoint(e);
        }
        function o(t) {
          var e = new Matrix();
          if (
            (e.reset(),
            this._elem.finalTransform.mProp.applyToMatrix(e),
            this._elem.hierarchy && this._elem.hierarchy.length)
          ) {
            var r,
              i = this._elem.hierarchy.length;
            for (r = 0; r < i; r += 1)
              this._elem.hierarchy[r].finalTransform.mProp.applyToMatrix(e);
            return e.inversePoint(t);
          }
          return e.inversePoint(t);
        }
        function h() {
          return [1, 1, 1, 1];
        }
        return function (l) {
          var p;
          function f(t) {
            switch (t) {
              case "ADBE Root Vectors Group":
              case "Contents":
              case 2:
                return f.shapeInterface;
              case 1:
              case 6:
              case "Transform":
              case "transform":
              case "ADBE Transform Group":
                return p;
              case 4:
              case "ADBE Effect Parade":
              case "effects":
              case "Effects":
                return f.effect;
              case "ADBE Text Properties":
                return f.textInterface;
              default:
                return null;
            }
          }
          (f.getMatrix = t),
            (f.invertPoint = n),
            (f.applyPoint = a),
            (f.toWorld = r),
            (f.toWorldVec = e),
            (f.fromWorld = s),
            (f.fromWorldVec = i),
            (f.toComp = r),
            (f.fromComp = o),
            (f.sampleImage = h),
            (f.sourceRectAtTime = l.sourceRectAtTime.bind(l)),
            (f._elem = l);
          var m = getDescriptor(
            (p = TransformExpressionInterface(l.finalTransform.mProp)),
            "anchorPoint"
          );
          return (
            Object.defineProperties(f, {
              hasParent: {
                get: function () {
                  return l.hierarchy.length;
                },
              },
              parent: {
                get: function () {
                  return l.hierarchy[0].layerInterface;
                },
              },
              rotation: getDescriptor(p, "rotation"),
              scale: getDescriptor(p, "scale"),
              position: getDescriptor(p, "position"),
              opacity: getDescriptor(p, "opacity"),
              anchorPoint: m,
              anchor_point: m,
              transform: {
                get: function () {
                  return p;
                },
              },
              active: {
                get: function () {
                  return l.isInRange;
                },
              },
            }),
            (f.startTime = l.data.st),
            (f.index = l.data.ind),
            (f.source = l.data.refId),
            (f.height = 0 === l.data.ty ? l.data.h : 100),
            (f.width = 0 === l.data.ty ? l.data.w : 100),
            (f.inPoint = l.data.ip / l.comp.globalData.frameRate),
            (f.outPoint = l.data.op / l.comp.globalData.frameRate),
            (f._name = l.data.nm),
            (f.registerMaskInterface = function (t) {
              f.mask = new MaskManagerInterface(t, l);
            }),
            (f.registerEffectsInterface = function (t) {
              f.effect = t;
            }),
            f
          );
        };
      })(),
      propertyGroupFactory = function (t, e) {
        return function (r) {
          return (r = void 0 === r ? 1 : r) <= 0 ? t : e(r - 1);
        };
      },
      PropertyInterface = function (t, e) {
        var r = { _name: t };
        return function (t) {
          return (t = void 0 === t ? 1 : t) <= 0 ? r : e(t - 1);
        };
      },
      EffectsExpressionInterface = (function () {
        function t(r, i, s, a) {
          function n(t) {
            for (var e = r.ef, i = 0, s = e.length; i < s; ) {
              if (t === e[i].nm || t === e[i].mn || t === e[i].ix)
                return 5 === e[i].ty ? l[i] : l[i]();
              i += 1;
            }
            throw new Error();
          }
          var o,
            h = propertyGroupFactory(n, s),
            l = [],
            p = r.ef.length;
          for (o = 0; o < p; o += 1)
            5 === r.ef[o].ty
              ? l.push(
                  t(
                    r.ef[o],
                    i.effectElements[o],
                    i.effectElements[o].propertyGroup,
                    a
                  )
                )
              : l.push(e(i.effectElements[o], r.ef[o].ty, a, h));
          return (
            "ADBE Color Control" === r.mn &&
              Object.defineProperty(n, "color", {
                get: function () {
                  return l[0]();
                },
              }),
            Object.defineProperties(n, {
              numProperties: {
                get: function () {
                  return r.np;
                },
              },
              _name: { value: r.nm },
              propertyGroup: { value: h },
            }),
            (n.enabled = 0 !== r.en),
            (n.active = n.enabled),
            n
          );
        }
        function e(t, e, r, i) {
          var s = ExpressionPropertyInterface(t.p);
          return (
            t.p.setGroupProperty &&
              t.p.setGroupProperty(PropertyInterface("", i)),
            function () {
              return 10 === e ? r.comp.compInterface(t.p.v) : s();
            }
          );
        }
        return {
          createEffectsInterface: function (e, r) {
            if (e.effectsManager) {
              var i,
                s = [],
                a = e.data.ef,
                n = e.effectsManager.effectElements.length;
              for (i = 0; i < n; i += 1)
                s.push(t(a[i], e.effectsManager.effectElements[i], r, e));
              var o = e.data.ef || [],
                h = function (t) {
                  for (i = 0, n = o.length; i < n; ) {
                    if (t === o[i].nm || t === o[i].mn || t === o[i].ix)
                      return s[i];
                    i += 1;
                  }
                  return null;
                };
              return (
                Object.defineProperty(h, "numProperties", {
                  get: function () {
                    return o.length;
                  },
                }),
                h
              );
            }
            return null;
          },
        };
      })(),
      CompExpressionInterface = function (t) {
        function e(e) {
          for (var r = 0, i = t.layers.length; r < i; ) {
            if (t.layers[r].nm === e || t.layers[r].ind === e)
              return t.elements[r].layerInterface;
            r += 1;
          }
          return null;
        }
        return (
          Object.defineProperty(e, "_name", { value: t.data.nm }),
          (e.layer = e),
          (e.pixelAspect = 1),
          (e.height = t.data.h || t.globalData.compSize.h),
          (e.width = t.data.w || t.globalData.compSize.w),
          (e.pixelAspect = 1),
          (e.frameDuration = 1 / t.globalData.frameRate),
          (e.displayStartTime = 0),
          (e.numLayers = t.layers.length),
          e
        );
      },
      ShapePathInterface = function (t, e, r) {
        var i = e.sh;
        function s(t) {
          return "Shape" === t ||
            "shape" === t ||
            "Path" === t ||
            "path" === t ||
            "ADBE Vector Shape" === t ||
            2 === t
            ? s.path
            : null;
        }
        var a = propertyGroupFactory(s, r);
        return (
          i.setGroupProperty(PropertyInterface("Path", a)),
          Object.defineProperties(s, {
            path: {
              get: function () {
                return i.k && i.getValue(), i;
              },
            },
            shape: {
              get: function () {
                return i.k && i.getValue(), i;
              },
            },
            _name: { value: t.nm },
            ix: { value: t.ix },
            propertyIndex: { value: t.ix },
            mn: { value: t.mn },
            propertyGroup: { value: r },
          }),
          s
        );
      },
      ShapeExpressionInterface = (function () {
        function t(t, o, c) {
          var d,
            u = [],
            y = t ? t.length : 0;
          for (d = 0; d < y; d += 1)
            "gr" === t[d].ty
              ? u.push(e(t[d], o[d], c))
              : "fl" === t[d].ty
              ? u.push(r(t[d], o[d], c))
              : "st" === t[d].ty
              ? u.push(a(t[d], o[d], c))
              : "tm" === t[d].ty
              ? u.push(n(t[d], o[d], c))
              : "tr" === t[d].ty ||
                ("el" === t[d].ty
                  ? u.push(h(t[d], o[d], c))
                  : "sr" === t[d].ty
                  ? u.push(l(t[d], o[d], c))
                  : "sh" === t[d].ty
                  ? u.push(ShapePathInterface(t[d], o[d], c))
                  : "rc" === t[d].ty
                  ? u.push(p(t[d], o[d], c))
                  : "rd" === t[d].ty
                  ? u.push(f(t[d], o[d], c))
                  : "rp" === t[d].ty
                  ? u.push(m(t[d], o[d], c))
                  : "gf" === t[d].ty
                  ? u.push(i(t[d], o[d], c))
                  : u.push(s(t[d], o[d])));
          return u;
        }
        function e(e, r, i) {
          var s = function (t) {
            switch (t) {
              case "ADBE Vectors Group":
              case "Contents":
              case 2:
                return s.content;
              default:
                return s.transform;
            }
          };
          s.propertyGroup = propertyGroupFactory(s, i);
          var a = (function (e, r, i) {
              var s,
                a = function (t) {
                  for (var e = 0, r = s.length; e < r; ) {
                    if (
                      s[e]._name === t ||
                      s[e].mn === t ||
                      s[e].propertyIndex === t ||
                      s[e].ix === t ||
                      s[e].ind === t
                    )
                      return s[e];
                    e += 1;
                  }
                  return "number" == typeof t ? s[t - 1] : null;
                };
              (a.propertyGroup = propertyGroupFactory(a, i)),
                (s = t(e.it, r.it, a.propertyGroup)),
                (a.numProperties = s.length);
              var n = o(
                e.it[e.it.length - 1],
                r.it[r.it.length - 1],
                a.propertyGroup
              );
              return (
                (a.transform = n),
                (a.propertyIndex = e.cix),
                (a._name = e.nm),
                a
              );
            })(e, r, s.propertyGroup),
            n = o(
              e.it[e.it.length - 1],
              r.it[r.it.length - 1],
              s.propertyGroup
            );
          return (
            (s.content = a),
            (s.transform = n),
            Object.defineProperty(s, "_name", {
              get: function () {
                return e.nm;
              },
            }),
            (s.numProperties = e.np),
            (s.propertyIndex = e.ix),
            (s.nm = e.nm),
            (s.mn = e.mn),
            s
          );
        }
        function r(t, e, r) {
          function i(t) {
            return "Color" === t || "color" === t
              ? i.color
              : "Opacity" === t || "opacity" === t
              ? i.opacity
              : null;
          }
          return (
            Object.defineProperties(i, {
              color: { get: ExpressionPropertyInterface(e.c) },
              opacity: { get: ExpressionPropertyInterface(e.o) },
              _name: { value: t.nm },
              mn: { value: t.mn },
            }),
            e.c.setGroupProperty(PropertyInterface("Color", r)),
            e.o.setGroupProperty(PropertyInterface("Opacity", r)),
            i
          );
        }
        function i(t, e, r) {
          function i(t) {
            return "Start Point" === t || "start point" === t
              ? i.startPoint
              : "End Point" === t || "end point" === t
              ? i.endPoint
              : "Opacity" === t || "opacity" === t
              ? i.opacity
              : null;
          }
          return (
            Object.defineProperties(i, {
              startPoint: { get: ExpressionPropertyInterface(e.s) },
              endPoint: { get: ExpressionPropertyInterface(e.e) },
              opacity: { get: ExpressionPropertyInterface(e.o) },
              type: {
                get: function () {
                  return "a";
                },
              },
              _name: { value: t.nm },
              mn: { value: t.mn },
            }),
            e.s.setGroupProperty(PropertyInterface("Start Point", r)),
            e.e.setGroupProperty(PropertyInterface("End Point", r)),
            e.o.setGroupProperty(PropertyInterface("Opacity", r)),
            i
          );
        }
        function s() {
          return function () {
            return null;
          };
        }
        function a(t, e, r) {
          var i,
            s = propertyGroupFactory(l, r),
            a = propertyGroupFactory(h, s);
          function n(r) {
            Object.defineProperty(h, t.d[r].nm, {
              get: ExpressionPropertyInterface(e.d.dataProps[r].p),
            });
          }
          var o = t.d ? t.d.length : 0,
            h = {};
          for (i = 0; i < o; i += 1)
            n(i), e.d.dataProps[i].p.setGroupProperty(a);
          function l(t) {
            return "Color" === t || "color" === t
              ? l.color
              : "Opacity" === t || "opacity" === t
              ? l.opacity
              : "Stroke Width" === t || "stroke width" === t
              ? l.strokeWidth
              : null;
          }
          return (
            Object.defineProperties(l, {
              color: { get: ExpressionPropertyInterface(e.c) },
              opacity: { get: ExpressionPropertyInterface(e.o) },
              strokeWidth: { get: ExpressionPropertyInterface(e.w) },
              dash: {
                get: function () {
                  return h;
                },
              },
              _name: { value: t.nm },
              mn: { value: t.mn },
            }),
            e.c.setGroupProperty(PropertyInterface("Color", s)),
            e.o.setGroupProperty(PropertyInterface("Opacity", s)),
            e.w.setGroupProperty(PropertyInterface("Stroke Width", s)),
            l
          );
        }
        function n(t, e, r) {
          function i(e) {
            return e === t.e.ix || "End" === e || "end" === e
              ? i.end
              : e === t.s.ix
              ? i.start
              : e === t.o.ix
              ? i.offset
              : null;
          }
          var s = propertyGroupFactory(i, r);
          return (
            (i.propertyIndex = t.ix),
            e.s.setGroupProperty(PropertyInterface("Start", s)),
            e.e.setGroupProperty(PropertyInterface("End", s)),
            e.o.setGroupProperty(PropertyInterface("Offset", s)),
            (i.propertyIndex = t.ix),
            (i.propertyGroup = r),
            Object.defineProperties(i, {
              start: { get: ExpressionPropertyInterface(e.s) },
              end: { get: ExpressionPropertyInterface(e.e) },
              offset: { get: ExpressionPropertyInterface(e.o) },
              _name: { value: t.nm },
            }),
            (i.mn = t.mn),
            i
          );
        }
        function o(t, e, r) {
          function i(e) {
            return t.a.ix === e || "Anchor Point" === e
              ? i.anchorPoint
              : t.o.ix === e || "Opacity" === e
              ? i.opacity
              : t.p.ix === e || "Position" === e
              ? i.position
              : t.r.ix === e || "Rotation" === e || "ADBE Vector Rotation" === e
              ? i.rotation
              : t.s.ix === e || "Scale" === e
              ? i.scale
              : (t.sk && t.sk.ix === e) || "Skew" === e
              ? i.skew
              : (t.sa && t.sa.ix === e) || "Skew Axis" === e
              ? i.skewAxis
              : null;
          }
          var s = propertyGroupFactory(i, r);
          return (
            e.transform.mProps.o.setGroupProperty(
              PropertyInterface("Opacity", s)
            ),
            e.transform.mProps.p.setGroupProperty(
              PropertyInterface("Position", s)
            ),
            e.transform.mProps.a.setGroupProperty(
              PropertyInterface("Anchor Point", s)
            ),
            e.transform.mProps.s.setGroupProperty(
              PropertyInterface("Scale", s)
            ),
            e.transform.mProps.r.setGroupProperty(
              PropertyInterface("Rotation", s)
            ),
            e.transform.mProps.sk &&
              (e.transform.mProps.sk.setGroupProperty(
                PropertyInterface("Skew", s)
              ),
              e.transform.mProps.sa.setGroupProperty(
                PropertyInterface("Skew Angle", s)
              )),
            e.transform.op.setGroupProperty(PropertyInterface("Opacity", s)),
            Object.defineProperties(i, {
              opacity: {
                get: ExpressionPropertyInterface(e.transform.mProps.o),
              },
              position: {
                get: ExpressionPropertyInterface(e.transform.mProps.p),
              },
              anchorPoint: {
                get: ExpressionPropertyInterface(e.transform.mProps.a),
              },
              scale: { get: ExpressionPropertyInterface(e.transform.mProps.s) },
              rotation: {
                get: ExpressionPropertyInterface(e.transform.mProps.r),
              },
              skew: { get: ExpressionPropertyInterface(e.transform.mProps.sk) },
              skewAxis: {
                get: ExpressionPropertyInterface(e.transform.mProps.sa),
              },
              _name: { value: t.nm },
            }),
            (i.ty = "tr"),
            (i.mn = t.mn),
            (i.propertyGroup = r),
            i
          );
        }
        function h(t, e, r) {
          function i(e) {
            return t.p.ix === e ? i.position : t.s.ix === e ? i.size : null;
          }
          var s = propertyGroupFactory(i, r);
          i.propertyIndex = t.ix;
          var a = "tm" === e.sh.ty ? e.sh.prop : e.sh;
          return (
            a.s.setGroupProperty(PropertyInterface("Size", s)),
            a.p.setGroupProperty(PropertyInterface("Position", s)),
            Object.defineProperties(i, {
              size: { get: ExpressionPropertyInterface(a.s) },
              position: { get: ExpressionPropertyInterface(a.p) },
              _name: { value: t.nm },
            }),
            (i.mn = t.mn),
            i
          );
        }
        function l(t, e, r) {
          function i(e) {
            return t.p.ix === e
              ? i.position
              : t.r.ix === e
              ? i.rotation
              : t.pt.ix === e
              ? i.points
              : t.or.ix === e || "ADBE Vector Star Outer Radius" === e
              ? i.outerRadius
              : t.os.ix === e
              ? i.outerRoundness
              : !t.ir ||
                (t.ir.ix !== e && "ADBE Vector Star Inner Radius" !== e)
              ? t.is && t.is.ix === e
                ? i.innerRoundness
                : null
              : i.innerRadius;
          }
          var s = propertyGroupFactory(i, r),
            a = "tm" === e.sh.ty ? e.sh.prop : e.sh;
          return (
            (i.propertyIndex = t.ix),
            a.or.setGroupProperty(PropertyInterface("Outer Radius", s)),
            a.os.setGroupProperty(PropertyInterface("Outer Roundness", s)),
            a.pt.setGroupProperty(PropertyInterface("Points", s)),
            a.p.setGroupProperty(PropertyInterface("Position", s)),
            a.r.setGroupProperty(PropertyInterface("Rotation", s)),
            t.ir &&
              (a.ir.setGroupProperty(PropertyInterface("Inner Radius", s)),
              a.is.setGroupProperty(PropertyInterface("Inner Roundness", s))),
            Object.defineProperties(i, {
              position: { get: ExpressionPropertyInterface(a.p) },
              rotation: { get: ExpressionPropertyInterface(a.r) },
              points: { get: ExpressionPropertyInterface(a.pt) },
              outerRadius: { get: ExpressionPropertyInterface(a.or) },
              outerRoundness: { get: ExpressionPropertyInterface(a.os) },
              innerRadius: { get: ExpressionPropertyInterface(a.ir) },
              innerRoundness: { get: ExpressionPropertyInterface(a.is) },
              _name: { value: t.nm },
            }),
            (i.mn = t.mn),
            i
          );
        }
        function p(t, e, r) {
          function i(e) {
            return t.p.ix === e
              ? i.position
              : t.r.ix === e
              ? i.roundness
              : t.s.ix === e || "Size" === e || "ADBE Vector Rect Size" === e
              ? i.size
              : null;
          }
          var s = propertyGroupFactory(i, r),
            a = "tm" === e.sh.ty ? e.sh.prop : e.sh;
          return (
            (i.propertyIndex = t.ix),
            a.p.setGroupProperty(PropertyInterface("Position", s)),
            a.s.setGroupProperty(PropertyInterface("Size", s)),
            a.r.setGroupProperty(PropertyInterface("Rotation", s)),
            Object.defineProperties(i, {
              position: { get: ExpressionPropertyInterface(a.p) },
              roundness: { get: ExpressionPropertyInterface(a.r) },
              size: { get: ExpressionPropertyInterface(a.s) },
              _name: { value: t.nm },
            }),
            (i.mn = t.mn),
            i
          );
        }
        function f(t, e, r) {
          function i(e) {
            return t.r.ix === e || "Round Corners 1" === e ? i.radius : null;
          }
          var s = propertyGroupFactory(i, r),
            a = e;
          return (
            (i.propertyIndex = t.ix),
            a.rd.setGroupProperty(PropertyInterface("Radius", s)),
            Object.defineProperties(i, {
              radius: { get: ExpressionPropertyInterface(a.rd) },
              _name: { value: t.nm },
            }),
            (i.mn = t.mn),
            i
          );
        }
        function m(t, e, r) {
          function i(e) {
            return t.c.ix === e || "Copies" === e
              ? i.copies
              : t.o.ix === e || "Offset" === e
              ? i.offset
              : null;
          }
          var s = propertyGroupFactory(i, r),
            a = e;
          return (
            (i.propertyIndex = t.ix),
            a.c.setGroupProperty(PropertyInterface("Copies", s)),
            a.o.setGroupProperty(PropertyInterface("Offset", s)),
            Object.defineProperties(i, {
              copies: { get: ExpressionPropertyInterface(a.c) },
              offset: { get: ExpressionPropertyInterface(a.o) },
              _name: { value: t.nm },
            }),
            (i.mn = t.mn),
            i
          );
        }
        return function (e, r, i) {
          var s;
          function a(t) {
            if ("number" == typeof t)
              return 0 === (t = void 0 === t ? 1 : t) ? i : s[t - 1];
            for (var e = 0, r = s.length; e < r; ) {
              if (s[e]._name === t) return s[e];
              e += 1;
            }
            return null;
          }
          return (
            (a.propertyGroup = propertyGroupFactory(a, function () {
              return i;
            })),
            (s = t(e, r, a.propertyGroup)),
            (a.numProperties = s.length),
            (a._name = "Contents"),
            a
          );
        };
      })(),
      TextExpressionInterface = function (t) {
        var e, r;
        function i(t) {
          return "ADBE Text Document" === t ? i.sourceText : null;
        }
        return (
          Object.defineProperty(i, "sourceText", {
            get: function () {
              t.textProperty.getValue();
              var i = t.textProperty.currentData.t;
              return (
                i !== e &&
                  ((t.textProperty.currentData.t = e),
                  ((r = new String(i)).value = i || new String(i))),
                r
              );
            },
          }),
          i
        );
      },
      getBlendMode =
        ((blendModeEnums = {
          0: "source-over",
          1: "multiply",
          2: "screen",
          3: "overlay",
          4: "darken",
          5: "lighten",
          6: "color-dodge",
          7: "color-burn",
          8: "hard-light",
          9: "soft-light",
          10: "difference",
          11: "exclusion",
          12: "hue",
          13: "saturation",
          14: "color",
          15: "luminosity",
        }),
        function (t) {
          return blendModeEnums[t] || "";
        }),
      blendModeEnums;
    function SliderEffect(t, e, r) {
      this.p = PropertyFactory.getProp(e, t.v, 0, 0, r);
    }
    function AngleEffect(t, e, r) {
      this.p = PropertyFactory.getProp(e, t.v, 0, 0, r);
    }
    function ColorEffect(t, e, r) {
      this.p = PropertyFactory.getProp(e, t.v, 1, 0, r);
    }
    function PointEffect(t, e, r) {
      this.p = PropertyFactory.getProp(e, t.v, 1, 0, r);
    }
    function LayerIndexEffect(t, e, r) {
      this.p = PropertyFactory.getProp(e, t.v, 0, 0, r);
    }
    function MaskIndexEffect(t, e, r) {
      this.p = PropertyFactory.getProp(e, t.v, 0, 0, r);
    }
    function CheckboxEffect(t, e, r) {
      this.p = PropertyFactory.getProp(e, t.v, 0, 0, r);
    }
    function NoValueEffect() {
      this.p = {};
    }
    function EffectsManager(t, e) {
      var r,
        i = t.ef || [];
      this.effectElements = [];
      var s,
        a = i.length;
      for (r = 0; r < a; r += 1)
        (s = new GroupEffect(i[r], e)), this.effectElements.push(s);
    }
    function GroupEffect(t, e) {
      this.init(t, e);
    }
    function BaseElement() {}
    function FrameElement() {}
    function _typeof$2(t) {
      return (
        (_typeof$2 =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
                return typeof t;
              }
            : function (t) {
                return t &&
                  "function" == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              }),
        _typeof$2(t)
      );
    }
    extendPrototype([DynamicPropertyContainer], GroupEffect),
      (GroupEffect.prototype.getValue =
        GroupEffect.prototype.iterateDynamicProperties),
      (GroupEffect.prototype.init = function (t, e) {
        var r;
        (this.data = t),
          (this.effectElements = []),
          this.initDynamicPropertyContainer(e);
        var i,
          s = this.data.ef.length,
          a = this.data.ef;
        for (r = 0; r < s; r += 1) {
          switch (((i = null), a[r].ty)) {
            case 0:
              i = new SliderEffect(a[r], e, this);
              break;
            case 1:
              i = new AngleEffect(a[r], e, this);
              break;
            case 2:
              i = new ColorEffect(a[r], e, this);
              break;
            case 3:
              i = new PointEffect(a[r], e, this);
              break;
            case 4:
            case 7:
              i = new CheckboxEffect(a[r], e, this);
              break;
            case 10:
              i = new LayerIndexEffect(a[r], e, this);
              break;
            case 11:
              i = new MaskIndexEffect(a[r], e, this);
              break;
            case 5:
              i = new EffectsManager(a[r], e, this);
              break;
            default:
              i = new NoValueEffect(a[r], e, this);
          }
          i && this.effectElements.push(i);
        }
      }),
      (BaseElement.prototype = {
        checkMasks: function () {
          if (!this.data.hasMask) return !1;
          for (var t = 0, e = this.data.masksProperties.length; t < e; ) {
            if (
              "n" !== this.data.masksProperties[t].mode &&
              !1 !== this.data.masksProperties[t].cl
            )
              return !0;
            t += 1;
          }
          return !1;
        },
        initExpressions: function () {
          (this.layerInterface = LayerExpressionInterface(this)),
            this.data.hasMask &&
              this.maskManager &&
              this.layerInterface.registerMaskInterface(this.maskManager);
          var t = EffectsExpressionInterface.createEffectsInterface(
            this,
            this.layerInterface
          );
          this.layerInterface.registerEffectsInterface(t),
            0 === this.data.ty || this.data.xt
              ? (this.compInterface = CompExpressionInterface(this))
              : 4 === this.data.ty
              ? ((this.layerInterface.shapeInterface = ShapeExpressionInterface(
                  this.shapesData,
                  this.itemsData,
                  this.layerInterface
                )),
                (this.layerInterface.content =
                  this.layerInterface.shapeInterface))
              : 5 === this.data.ty &&
                ((this.layerInterface.textInterface =
                  TextExpressionInterface(this)),
                (this.layerInterface.text = this.layerInterface.textInterface));
        },
        setBlendMode: function () {
          var t = getBlendMode(this.data.bm);
          (this.baseElement || this.layerElement).style["mix-blend-mode"] = t;
        },
        initBaseData: function (t, e, r) {
          (this.globalData = e),
            (this.comp = r),
            (this.data = t),
            (this.layerId = createElementID()),
            this.data.sr || (this.data.sr = 1),
            (this.effectsManager = new EffectsManager(
              this.data,
              this,
              this.dynamicProperties
            ));
        },
        getType: function () {
          return this.type;
        },
        sourceRectAtTime: function () {},
      }),
      (FrameElement.prototype = {
        initFrame: function () {
          (this._isFirstFrame = !1),
            (this.dynamicProperties = []),
            (this._mdf = !1);
        },
        prepareProperties: function (t, e) {
          var r,
            i = this.dynamicProperties.length;
          for (r = 0; r < i; r += 1)
            (e ||
              (this._isParent &&
                "transform" === this.dynamicProperties[r].propType)) &&
              (this.dynamicProperties[r].getValue(),
              this.dynamicProperties[r]._mdf &&
                ((this.globalData._mdf = !0), (this._mdf = !0)));
        },
        addDynamicProperty: function (t) {
          -1 === this.dynamicProperties.indexOf(t) &&
            this.dynamicProperties.push(t);
        },
      });
    var FootageInterface =
        ((dataInterfaceFactory = function (t) {
          function e(t) {
            return "Outline" === t ? e.outlineInterface() : null;
          }
          return (
            (e._name = "Outline"),
            (e.outlineInterface = (function (t) {
              var e = "",
                r = t.getFootageData();
              function i(t) {
                if (r[t])
                  return (e = t), "object" === _typeof$2((r = r[t])) ? i : r;
                var s = t.indexOf(e);
                if (-1 !== s) {
                  var a = parseInt(t.substr(s + e.length), 10);
                  return "object" === _typeof$2((r = r[a])) ? i : r;
                }
                return "";
              }
              return function () {
                return (e = ""), (r = t.getFootageData()), i;
              };
            })(t)),
            e
          );
        }),
        function (t) {
          function e(t) {
            return "Data" === t ? e.dataInterface : null;
          }
          return (
            (e._name = "Data"), (e.dataInterface = dataInterfaceFactory(t)), e
          );
        }),
      dataInterfaceFactory;
    function FootageElement(t, e, r) {
      this.initFrame(),
        this.initRenderable(),
        (this.assetData = e.getAssetData(t.refId)),
        (this.footageData = e.imageLoader.getAsset(this.assetData)),
        this.initBaseData(t, e, r);
    }
    function AudioElement(t, e, r) {
      this.initFrame(),
        this.initRenderable(),
        (this.assetData = e.getAssetData(t.refId)),
        this.initBaseData(t, e, r),
        (this._isPlaying = !1),
        (this._canPlay = !1);
      var i = this.globalData.getAssetsPath(this.assetData);
      (this.audio = this.globalData.audioController.createAudio(i)),
        (this._currentTime = 0),
        this.globalData.audioController.addAudio(this),
        (this._volumeMultiplier = 1),
        (this._volume = 1),
        (this._previousVolume = null),
        (this.tm = t.tm
          ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this)
          : { _placeholder: !0 }),
        (this.lv = PropertyFactory.getProp(
          this,
          t.au && t.au.lv ? t.au.lv : { k: [100] },
          1,
          0.01,
          this
        ));
    }
    function BaseRenderer() {}
    function TransformElement() {}
    function MaskElement(t, e, r) {
      (this.data = t),
        (this.element = e),
        (this.globalData = r),
        (this.storedData = []),
        (this.masksProperties = this.data.masksProperties || []),
        (this.maskElement = null);
      var i,
        s,
        a = this.globalData.defs,
        n = this.masksProperties ? this.masksProperties.length : 0;
      (this.viewData = createSizedArray(n)), (this.solidPath = "");
      var o,
        h,
        l,
        p,
        f,
        m,
        c = this.masksProperties,
        d = 0,
        u = [],
        y = createElementID(),
        g = "clipPath",
        v = "clip-path";
      for (i = 0; i < n; i += 1)
        if (
          ((("a" !== c[i].mode && "n" !== c[i].mode) ||
            c[i].inv ||
            100 !== c[i].o.k ||
            c[i].o.x) &&
            ((g = "mask"), (v = "mask")),
          ("s" !== c[i].mode && "i" !== c[i].mode) || 0 !== d
            ? (l = null)
            : ((l = createNS("rect")).setAttribute("fill", "#ffffff"),
              l.setAttribute("width", this.element.comp.data.w || 0),
              l.setAttribute("height", this.element.comp.data.h || 0),
              u.push(l)),
          (s = createNS("path")),
          "n" === c[i].mode)
        )
          (this.viewData[i] = {
            op: PropertyFactory.getProp(
              this.element,
              c[i].o,
              0,
              0.01,
              this.element
            ),
            prop: ShapePropertyFactory.getShapeProp(this.element, c[i], 3),
            elem: s,
            lastPath: "",
          }),
            a.appendChild(s);
        else {
          var b;
          if (
            ((d += 1),
            s.setAttribute("fill", "s" === c[i].mode ? "#000000" : "#ffffff"),
            s.setAttribute("clip-rule", "nonzero"),
            0 !== c[i].x.k
              ? ((g = "mask"),
                (v = "mask"),
                (m = PropertyFactory.getProp(
                  this.element,
                  c[i].x,
                  0,
                  null,
                  this.element
                )),
                (b = createElementID()),
                (p = createNS("filter")).setAttribute("id", b),
                (f = createNS("feMorphology")).setAttribute(
                  "operator",
                  "erode"
                ),
                f.setAttribute("in", "SourceGraphic"),
                f.setAttribute("radius", "0"),
                p.appendChild(f),
                a.appendChild(p),
                s.setAttribute(
                  "stroke",
                  "s" === c[i].mode ? "#000000" : "#ffffff"
                ))
              : ((f = null), (m = null)),
            (this.storedData[i] = {
              elem: s,
              x: m,
              expan: f,
              lastPath: "",
              lastOperator: "",
              filterId: b,
              lastRadius: 0,
            }),
            "i" === c[i].mode)
          ) {
            h = u.length;
            var P = createNS("g");
            for (o = 0; o < h; o += 1) P.appendChild(u[o]);
            var E = createNS("mask");
            E.setAttribute("mask-type", "alpha"),
              E.setAttribute("id", y + "_" + d),
              E.appendChild(s),
              a.appendChild(E),
              P.setAttribute(
                "mask",
                "url(" + getLocationHref() + "#" + y + "_" + d + ")"
              ),
              (u.length = 0),
              u.push(P);
          } else u.push(s);
          c[i].inv &&
            !this.solidPath &&
            (this.solidPath = this.createLayerSolidPath()),
            (this.viewData[i] = {
              elem: s,
              lastPath: "",
              op: PropertyFactory.getProp(
                this.element,
                c[i].o,
                0,
                0.01,
                this.element
              ),
              prop: ShapePropertyFactory.getShapeProp(this.element, c[i], 3),
              invRect: l,
            }),
            this.viewData[i].prop.k ||
              this.drawPath(c[i], this.viewData[i].prop.v, this.viewData[i]);
        }
      for (this.maskElement = createNS(g), n = u.length, i = 0; i < n; i += 1)
        this.maskElement.appendChild(u[i]);
      d > 0 &&
        (this.maskElement.setAttribute("id", y),
        this.element.maskedElement.setAttribute(
          v,
          "url(" + getLocationHref() + "#" + y + ")"
        ),
        a.appendChild(this.maskElement)),
        this.viewData.length && this.element.addRenderableComponent(this);
    }
    (FootageElement.prototype.prepareFrame = function () {}),
      extendPrototype(
        [RenderableElement, BaseElement, FrameElement],
        FootageElement
      ),
      (FootageElement.prototype.getBaseElement = function () {
        return null;
      }),
      (FootageElement.prototype.renderFrame = function () {}),
      (FootageElement.prototype.destroy = function () {}),
      (FootageElement.prototype.initExpressions = function () {
        this.layerInterface = FootageInterface(this);
      }),
      (FootageElement.prototype.getFootageData = function () {
        return this.footageData;
      }),
      (AudioElement.prototype.prepareFrame = function (t) {
        if (
          (this.prepareRenderableFrame(t, !0),
          this.prepareProperties(t, !0),
          this.tm._placeholder)
        )
          this._currentTime = t / this.data.sr;
        else {
          var e = this.tm.v;
          this._currentTime = e;
        }
        this._volume = this.lv.v[0];
        var r = this._volume * this._volumeMultiplier;
        this._previousVolume !== r &&
          ((this._previousVolume = r), this.audio.volume(r));
      }),
      extendPrototype(
        [RenderableElement, BaseElement, FrameElement],
        AudioElement
      ),
      (AudioElement.prototype.renderFrame = function () {
        this.isInRange &&
          this._canPlay &&
          (this._isPlaying
            ? (!this.audio.playing() ||
                Math.abs(
                  this._currentTime / this.globalData.frameRate -
                    this.audio.seek()
                ) > 0.1) &&
              this.audio.seek(this._currentTime / this.globalData.frameRate)
            : (this.audio.play(),
              this.audio.seek(this._currentTime / this.globalData.frameRate),
              (this._isPlaying = !0)));
      }),
      (AudioElement.prototype.show = function () {}),
      (AudioElement.prototype.hide = function () {
        this.audio.pause(), (this._isPlaying = !1);
      }),
      (AudioElement.prototype.pause = function () {
        this.audio.pause(), (this._isPlaying = !1), (this._canPlay = !1);
      }),
      (AudioElement.prototype.resume = function () {
        this._canPlay = !0;
      }),
      (AudioElement.prototype.setRate = function (t) {
        this.audio.rate(t);
      }),
      (AudioElement.prototype.volume = function (t) {
        (this._volumeMultiplier = t),
          (this._previousVolume = t * this._volume),
          this.audio.volume(this._previousVolume);
      }),
      (AudioElement.prototype.getBaseElement = function () {
        return null;
      }),
      (AudioElement.prototype.destroy = function () {}),
      (AudioElement.prototype.sourceRectAtTime = function () {}),
      (AudioElement.prototype.initExpressions = function () {}),
      (BaseRenderer.prototype.checkLayers = function (t) {
        var e,
          r,
          i = this.layers.length;
        for (this.completeLayers = !0, e = i - 1; e >= 0; e -= 1)
          this.elements[e] ||
            ((r = this.layers[e]).ip - r.st <= t - this.layers[e].st &&
              r.op - r.st > t - this.layers[e].st &&
              this.buildItem(e)),
            (this.completeLayers = !!this.elements[e] && this.completeLayers);
        this.checkPendingElements();
      }),
      (BaseRenderer.prototype.createItem = function (t) {
        switch (t.ty) {
          case 2:
            return this.createImage(t);
          case 0:
            return this.createComp(t);
          case 1:
            return this.createSolid(t);
          case 3:
          default:
            return this.createNull(t);
          case 4:
            return this.createShape(t);
          case 5:
            return this.createText(t);
          case 6:
            return this.createAudio(t);
          case 13:
            return this.createCamera(t);
          case 15:
            return this.createFootage(t);
        }
      }),
      (BaseRenderer.prototype.createCamera = function () {
        throw new Error("You're using a 3d camera. Try the html renderer.");
      }),
      (BaseRenderer.prototype.createAudio = function (t) {
        return new AudioElement(t, this.globalData, this);
      }),
      (BaseRenderer.prototype.createFootage = function (t) {
        return new FootageElement(t, this.globalData, this);
      }),
      (BaseRenderer.prototype.buildAllItems = function () {
        var t,
          e = this.layers.length;
        for (t = 0; t < e; t += 1) this.buildItem(t);
        this.checkPendingElements();
      }),
      (BaseRenderer.prototype.includeLayers = function (t) {
        var e;
        this.completeLayers = !1;
        var r,
          i = t.length,
          s = this.layers.length;
        for (e = 0; e < i; e += 1)
          for (r = 0; r < s; ) {
            if (this.layers[r].id === t[e].id) {
              this.layers[r] = t[e];
              break;
            }
            r += 1;
          }
      }),
      (BaseRenderer.prototype.setProjectInterface = function (t) {
        this.globalData.projectInterface = t;
      }),
      (BaseRenderer.prototype.initItems = function () {
        this.globalData.progressiveLoad || this.buildAllItems();
      }),
      (BaseRenderer.prototype.buildElementParenting = function (t, e, r) {
        for (
          var i = this.elements, s = this.layers, a = 0, n = s.length;
          a < n;

        )
          s[a].ind == e &&
            (i[a] && !0 !== i[a]
              ? (r.push(i[a]),
                i[a].setAsParent(),
                void 0 !== s[a].parent
                  ? this.buildElementParenting(t, s[a].parent, r)
                  : t.setHierarchy(r))
              : (this.buildItem(a), this.addPendingElement(t))),
            (a += 1);
      }),
      (BaseRenderer.prototype.addPendingElement = function (t) {
        this.pendingElements.push(t);
      }),
      (BaseRenderer.prototype.searchExtraCompositions = function (t) {
        var e,
          r = t.length;
        for (e = 0; e < r; e += 1)
          if (t[e].xt) {
            var i = this.createComp(t[e]);
            i.initExpressions(),
              this.globalData.projectInterface.registerComposition(i);
          }
      }),
      (BaseRenderer.prototype.getElementByPath = function (t) {
        var e,
          r = t.shift();
        if ("number" == typeof r) e = this.elements[r];
        else {
          var i,
            s = this.elements.length;
          for (i = 0; i < s; i += 1)
            if (this.elements[i].data.nm === r) {
              e = this.elements[i];
              break;
            }
        }
        return 0 === t.length ? e : e.getElementByPath(t);
      }),
      (BaseRenderer.prototype.setupGlobalData = function (t, e) {
        (this.globalData.fontManager = new FontManager()),
          this.globalData.fontManager.addChars(t.chars),
          this.globalData.fontManager.addFonts(t.fonts, e),
          (this.globalData.getAssetData = this.animationItem.getAssetData.bind(
            this.animationItem
          )),
          (this.globalData.getAssetsPath =
            this.animationItem.getAssetsPath.bind(this.animationItem)),
          (this.globalData.imageLoader = this.animationItem.imagePreloader),
          (this.globalData.audioController =
            this.animationItem.audioController),
          (this.globalData.frameId = 0),
          (this.globalData.frameRate = t.fr),
          (this.globalData.nm = t.nm),
          (this.globalData.compSize = { w: t.w, h: t.h });
      }),
      (TransformElement.prototype = {
        initTransform: function () {
          (this.finalTransform = {
            mProp: this.data.ks
              ? TransformPropertyFactory.getTransformProperty(
                  this,
                  this.data.ks,
                  this
                )
              : { o: 0 },
            _matMdf: !1,
            _opMdf: !1,
            mat: new Matrix(),
          }),
            this.data.ao && (this.finalTransform.mProp.autoOriented = !0),
            this.data.ty;
        },
        renderTransform: function () {
          if (
            ((this.finalTransform._opMdf =
              this.finalTransform.mProp.o._mdf || this._isFirstFrame),
            (this.finalTransform._matMdf =
              this.finalTransform.mProp._mdf || this._isFirstFrame),
            this.hierarchy)
          ) {
            var t,
              e = this.finalTransform.mat,
              r = 0,
              i = this.hierarchy.length;
            if (!this.finalTransform._matMdf)
              for (; r < i; ) {
                if (this.hierarchy[r].finalTransform.mProp._mdf) {
                  this.finalTransform._matMdf = !0;
                  break;
                }
                r += 1;
              }
            if (this.finalTransform._matMdf)
              for (
                t = this.finalTransform.mProp.v.props,
                  e.cloneFromProps(t),
                  r = 0;
                r < i;
                r += 1
              )
                (t = this.hierarchy[r].finalTransform.mProp.v.props),
                  e.transform(
                    t[0],
                    t[1],
                    t[2],
                    t[3],
                    t[4],
                    t[5],
                    t[6],
                    t[7],
                    t[8],
                    t[9],
                    t[10],
                    t[11],
                    t[12],
                    t[13],
                    t[14],
                    t[15]
                  );
          }
        },
        globalToLocal: function (t) {
          var e = [];
          e.push(this.finalTransform);
          for (var r, i = !0, s = this.comp; i; )
            s.finalTransform
              ? (s.data.hasMask && e.splice(0, 0, s.finalTransform),
                (s = s.comp))
              : (i = !1);
          var a,
            n = e.length;
          for (r = 0; r < n; r += 1)
            (a = e[r].mat.applyToPointArray(0, 0, 0)),
              (t = [t[0] - a[0], t[1] - a[1], 0]);
          return t;
        },
        mHelper: new Matrix(),
      }),
      (MaskElement.prototype.getMaskProperty = function (t) {
        return this.viewData[t].prop;
      }),
      (MaskElement.prototype.renderFrame = function (t) {
        var e,
          r = this.element.finalTransform.mat,
          i = this.masksProperties.length;
        for (e = 0; e < i; e += 1)
          if (
            ((this.viewData[e].prop._mdf || t) &&
              this.drawPath(
                this.masksProperties[e],
                this.viewData[e].prop.v,
                this.viewData[e]
              ),
            (this.viewData[e].op._mdf || t) &&
              this.viewData[e].elem.setAttribute(
                "fill-opacity",
                this.viewData[e].op.v
              ),
            "n" !== this.masksProperties[e].mode &&
              (this.viewData[e].invRect &&
                (this.element.finalTransform.mProp._mdf || t) &&
                this.viewData[e].invRect.setAttribute(
                  "transform",
                  r.getInverseMatrix().to2dCSS()
                ),
              this.storedData[e].x && (this.storedData[e].x._mdf || t)))
          ) {
            var s = this.storedData[e].expan;
            this.storedData[e].x.v < 0
              ? ("erode" !== this.storedData[e].lastOperator &&
                  ((this.storedData[e].lastOperator = "erode"),
                  this.storedData[e].elem.setAttribute(
                    "filter",
                    "url(" +
                      getLocationHref() +
                      "#" +
                      this.storedData[e].filterId +
                      ")"
                  )),
                s.setAttribute("radius", -this.storedData[e].x.v))
              : ("dilate" !== this.storedData[e].lastOperator &&
                  ((this.storedData[e].lastOperator = "dilate"),
                  this.storedData[e].elem.setAttribute("filter", null)),
                this.storedData[e].elem.setAttribute(
                  "stroke-width",
                  2 * this.storedData[e].x.v
                ));
          }
      }),
      (MaskElement.prototype.getMaskelement = function () {
        return this.maskElement;
      }),
      (MaskElement.prototype.createLayerSolidPath = function () {
        var t = "M0,0 ";
        return (
          (t += " h" + this.globalData.compSize.w),
          (t += " v" + this.globalData.compSize.h),
          (t += " h-" + this.globalData.compSize.w),
          (t += " v-" + this.globalData.compSize.h + " ")
        );
      }),
      (MaskElement.prototype.drawPath = function (t, e, r) {
        var i,
          s,
          a = " M" + e.v[0][0] + "," + e.v[0][1];
        for (s = e._length, i = 1; i < s; i += 1)
          a +=
            " C" +
            e.o[i - 1][0] +
            "," +
            e.o[i - 1][1] +
            " " +
            e.i[i][0] +
            "," +
            e.i[i][1] +
            " " +
            e.v[i][0] +
            "," +
            e.v[i][1];
        if (
          (e.c &&
            s > 1 &&
            (a +=
              " C" +
              e.o[i - 1][0] +
              "," +
              e.o[i - 1][1] +
              " " +
              e.i[0][0] +
              "," +
              e.i[0][1] +
              " " +
              e.v[0][0] +
              "," +
              e.v[0][1]),
          r.lastPath !== a)
        ) {
          var n = "";
          r.elem &&
            (e.c && (n = t.inv ? this.solidPath + a : a),
            r.elem.setAttribute("d", n)),
            (r.lastPath = a);
        }
      }),
      (MaskElement.prototype.destroy = function () {
        (this.element = null),
          (this.globalData = null),
          (this.maskElement = null),
          (this.data = null),
          (this.masksProperties = null);
      });
    var filtersFactory = (function () {
        var t = {};
        return (
          (t.createFilter = function (t, e) {
            var r = createNS("filter");
            r.setAttribute("id", t),
              !0 !== e &&
                (r.setAttribute("filterUnits", "objectBoundingBox"),
                r.setAttribute("x", "0%"),
                r.setAttribute("y", "0%"),
                r.setAttribute("width", "100%"),
                r.setAttribute("height", "100%"));
            return r;
          }),
          (t.createAlphaToLuminanceFilter = function () {
            var t = createNS("feColorMatrix");
            return (
              t.setAttribute("type", "matrix"),
              t.setAttribute("color-interpolation-filters", "sRGB"),
              t.setAttribute(
                "values",
                "0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1"
              ),
              t
            );
          }),
          t
        );
      })(),
      featureSupport = (function () {
        var t = { maskType: !0 };
        return (
          (/MSIE 10/i.test(navigator.userAgent) ||
            /MSIE 9/i.test(navigator.userAgent) ||
            /rv:11.0/i.test(navigator.userAgent) ||
            /Edge\/\d./i.test(navigator.userAgent)) &&
            (t.maskType = !1),
          t
        );
      })(),
      registeredEffects = {},
      idPrefix = "filter_result_";
    function SVGEffects(t) {
      var e,
        r,
        i = "SourceGraphic",
        s = t.data.ef ? t.data.ef.length : 0,
        a = createElementID(),
        n = filtersFactory.createFilter(a, !0),
        o = 0;
      for (this.filters = [], e = 0; e < s; e += 1) {
        r = null;
        var h = t.data.ef[e].ty;
        if (registeredEffects[h])
          (r = new (0, registeredEffects[h].effect)(
            n,
            t.effectsManager.effectElements[e],
            t,
            idPrefix + o,
            i
          )),
            (i = idPrefix + o),
            registeredEffects[h].countsAsEffect && (o += 1);
        r && this.filters.push(r);
      }
      o &&
        (t.globalData.defs.appendChild(n),
        t.layerElement.setAttribute(
          "filter",
          "url(" + getLocationHref() + "#" + a + ")"
        )),
        this.filters.length && t.addRenderableComponent(this);
    }
    function registerEffect(t, e, r) {
      registeredEffects[t] = { effect: e, countsAsEffect: r };
    }
    function SVGBaseElement() {}
    function HierarchyElement() {}
    function RenderableDOMElement() {}
    function IImageElement(t, e, r) {
      (this.assetData = e.getAssetData(t.refId)),
        this.initElement(t, e, r),
        (this.sourceRect = {
          top: 0,
          left: 0,
          width: this.assetData.w,
          height: this.assetData.h,
        });
    }
    function ProcessedElement(t, e) {
      (this.elem = t), (this.pos = e);
    }
    function IShapeElement() {}
    (SVGEffects.prototype.renderFrame = function (t) {
      var e,
        r = this.filters.length;
      for (e = 0; e < r; e += 1) this.filters[e].renderFrame(t);
    }),
      (SVGBaseElement.prototype = {
        initRendererElement: function () {
          this.layerElement = createNS("g");
        },
        createContainerElements: function () {
          (this.matteElement = createNS("g")),
            (this.transformedElement = this.layerElement),
            (this.maskedElement = this.layerElement),
            (this._sizeChanged = !1);
          var t,
            e,
            r,
            i = null;
          if (this.data.td) {
            if (3 == this.data.td || 1 == this.data.td) {
              var s = createNS("mask");
              s.setAttribute("id", this.layerId),
                s.setAttribute(
                  "mask-type",
                  3 == this.data.td ? "luminance" : "alpha"
                ),
                s.appendChild(this.layerElement),
                (i = s),
                this.globalData.defs.appendChild(s),
                featureSupport.maskType ||
                  1 != this.data.td ||
                  (s.setAttribute("mask-type", "luminance"),
                  (t = createElementID()),
                  (e = filtersFactory.createFilter(t)),
                  this.globalData.defs.appendChild(e),
                  e.appendChild(filtersFactory.createAlphaToLuminanceFilter()),
                  (r = createNS("g")).appendChild(this.layerElement),
                  (i = r),
                  s.appendChild(r),
                  r.setAttribute(
                    "filter",
                    "url(" + getLocationHref() + "#" + t + ")"
                  ));
            } else if (2 == this.data.td) {
              var a = createNS("mask");
              a.setAttribute("id", this.layerId),
                a.setAttribute("mask-type", "alpha");
              var n = createNS("g");
              a.appendChild(n),
                (t = createElementID()),
                (e = filtersFactory.createFilter(t));
              var o = createNS("feComponentTransfer");
              o.setAttribute("in", "SourceGraphic"), e.appendChild(o);
              var h = createNS("feFuncA");
              h.setAttribute("type", "table"),
                h.setAttribute("tableValues", "1.0 0.0"),
                o.appendChild(h),
                this.globalData.defs.appendChild(e);
              var l = createNS("rect");
              l.setAttribute("width", this.comp.data.w),
                l.setAttribute("height", this.comp.data.h),
                l.setAttribute("x", "0"),
                l.setAttribute("y", "0"),
                l.setAttribute("fill", "#ffffff"),
                l.setAttribute("opacity", "0"),
                n.setAttribute(
                  "filter",
                  "url(" + getLocationHref() + "#" + t + ")"
                ),
                n.appendChild(l),
                n.appendChild(this.layerElement),
                (i = n),
                featureSupport.maskType ||
                  (a.setAttribute("mask-type", "luminance"),
                  e.appendChild(filtersFactory.createAlphaToLuminanceFilter()),
                  (r = createNS("g")),
                  n.appendChild(l),
                  r.appendChild(this.layerElement),
                  (i = r),
                  n.appendChild(r)),
                this.globalData.defs.appendChild(a);
            }
          } else
            this.data.tt
              ? (this.matteElement.appendChild(this.layerElement),
                (i = this.matteElement),
                (this.baseElement = this.matteElement))
              : (this.baseElement = this.layerElement);
          if (
            (this.data.ln && this.layerElement.setAttribute("id", this.data.ln),
            this.data.cl &&
              this.layerElement.setAttribute("class", this.data.cl),
            0 === this.data.ty && !this.data.hd)
          ) {
            var p = createNS("clipPath"),
              f = createNS("path");
            f.setAttribute(
              "d",
              "M0,0 L" +
                this.data.w +
                ",0 L" +
                this.data.w +
                "," +
                this.data.h +
                " L0," +
                this.data.h +
                "z"
            );
            var m = createElementID();
            if (
              (p.setAttribute("id", m),
              p.appendChild(f),
              this.globalData.defs.appendChild(p),
              this.checkMasks())
            ) {
              var c = createNS("g");
              c.setAttribute(
                "clip-path",
                "url(" + getLocationHref() + "#" + m + ")"
              ),
                c.appendChild(this.layerElement),
                (this.transformedElement = c),
                i
                  ? i.appendChild(this.transformedElement)
                  : (this.baseElement = this.transformedElement);
            } else
              this.layerElement.setAttribute(
                "clip-path",
                "url(" + getLocationHref() + "#" + m + ")"
              );
          }
          0 !== this.data.bm && this.setBlendMode();
        },
        renderElement: function () {
          this.finalTransform._matMdf &&
            this.transformedElement.setAttribute(
              "transform",
              this.finalTransform.mat.to2dCSS()
            ),
            this.finalTransform._opMdf &&
              this.transformedElement.setAttribute(
                "opacity",
                this.finalTransform.mProp.o.v
              );
        },
        destroyBaseElement: function () {
          (this.layerElement = null),
            (this.matteElement = null),
            this.maskManager.destroy();
        },
        getBaseElement: function () {
          return this.data.hd ? null : this.baseElement;
        },
        createRenderableComponents: function () {
          (this.maskManager = new MaskElement(
            this.data,
            this,
            this.globalData
          )),
            (this.renderableEffectsManager = new SVGEffects(this));
        },
        setMatte: function (t) {
          this.matteElement &&
            this.matteElement.setAttribute(
              "mask",
              "url(" + getLocationHref() + "#" + t + ")"
            );
        },
      }),
      (HierarchyElement.prototype = {
        initHierarchy: function () {
          (this.hierarchy = []), (this._isParent = !1), this.checkParenting();
        },
        setHierarchy: function (t) {
          this.hierarchy = t;
        },
        setAsParent: function () {
          this._isParent = !0;
        },
        checkParenting: function () {
          void 0 !== this.data.parent &&
            this.comp.buildElementParenting(this, this.data.parent, []);
        },
      }),
      extendPrototype(
        [
          RenderableElement,
          createProxyFunction({
            initElement: function (t, e, r) {
              this.initFrame(),
                this.initBaseData(t, e, r),
                this.initTransform(t, e, r),
                this.initHierarchy(),
                this.initRenderable(),
                this.initRendererElement(),
                this.createContainerElements(),
                this.createRenderableComponents(),
                this.createContent(),
                this.hide();
            },
            hide: function () {
              this.hidden ||
                (this.isInRange && !this.isTransparent) ||
                (((this.baseElement || this.layerElement).style.display =
                  "none"),
                (this.hidden = !0));
            },
            show: function () {
              this.isInRange &&
                !this.isTransparent &&
                (this.data.hd ||
                  ((this.baseElement || this.layerElement).style.display =
                    "block"),
                (this.hidden = !1),
                (this._isFirstFrame = !0));
            },
            renderFrame: function () {
              this.data.hd ||
                this.hidden ||
                (this.renderTransform(),
                this.renderRenderable(),
                this.renderElement(),
                this.renderInnerContent(),
                this._isFirstFrame && (this._isFirstFrame = !1));
            },
            renderInnerContent: function () {},
            prepareFrame: function (t) {
              (this._mdf = !1),
                this.prepareRenderableFrame(t),
                this.prepareProperties(t, this.isInRange),
                this.checkTransparency();
            },
            destroy: function () {
              (this.innerElem = null), this.destroyBaseElement();
            },
          }),
        ],
        RenderableDOMElement
      ),
      extendPrototype(
        [
          BaseElement,
          TransformElement,
          SVGBaseElement,
          HierarchyElement,
          FrameElement,
          RenderableDOMElement,
        ],
        IImageElement
      ),
      (IImageElement.prototype.createContent = function () {
        var t = this.globalData.getAssetsPath(this.assetData);
        (this.innerElem = createNS("image")),
          this.innerElem.setAttribute("width", this.assetData.w + "px"),
          this.innerElem.setAttribute("height", this.assetData.h + "px"),
          this.innerElem.setAttribute(
            "preserveAspectRatio",
            this.assetData.pr ||
              this.globalData.renderConfig.imagePreserveAspectRatio
          ),
          this.innerElem.setAttributeNS(
            "http://www.w3.org/1999/xlink",
            "href",
            t
          ),
          this.layerElement.appendChild(this.innerElem);
      }),
      (IImageElement.prototype.sourceRectAtTime = function () {
        return this.sourceRect;
      }),
      (IShapeElement.prototype = {
        addShapeToModifiers: function (t) {
          var e,
            r = this.shapeModifiers.length;
          for (e = 0; e < r; e += 1) this.shapeModifiers[e].addShape(t);
        },
        isShapeInAnimatedModifiers: function (t) {
          for (var e = this.shapeModifiers.length; 0 < e; )
            if (this.shapeModifiers[0].isAnimatedWithShape(t)) return !0;
          return !1;
        },
        renderModifiers: function () {
          if (this.shapeModifiers.length) {
            var t,
              e = this.shapes.length;
            for (t = 0; t < e; t += 1) this.shapes[t].sh.reset();
            for (
              t = (e = this.shapeModifiers.length) - 1;
              t >= 0 &&
              !this.shapeModifiers[t].processShapes(this._isFirstFrame);
              t -= 1
            );
          }
        },
        searchProcessedElement: function (t) {
          for (var e = this.processedElements, r = 0, i = e.length; r < i; ) {
            if (e[r].elem === t) return e[r].pos;
            r += 1;
          }
          return 0;
        },
        addProcessedElement: function (t, e) {
          for (var r = this.processedElements, i = r.length; i; )
            if (r[(i -= 1)].elem === t) return void (r[i].pos = e);
          r.push(new ProcessedElement(t, e));
        },
        prepareFrame: function (t) {
          this.prepareRenderableFrame(t),
            this.prepareProperties(t, this.isInRange);
        },
      });
    var lineCapEnum = { 1: "butt", 2: "round", 3: "square" },
      lineJoinEnum = { 1: "miter", 2: "round", 3: "bevel" };
    function SVGShapeData(t, e, r) {
      (this.caches = []),
        (this.styles = []),
        (this.transformers = t),
        (this.lStr = ""),
        (this.sh = r),
        (this.lvl = e),
        (this._isAnimated = !!r.k);
      for (var i = 0, s = t.length; i < s; ) {
        if (t[i].mProps.dynamicProperties.length) {
          this._isAnimated = !0;
          break;
        }
        i += 1;
      }
    }
    function SVGStyleData(t, e) {
      (this.data = t),
        (this.type = t.ty),
        (this.d = ""),
        (this.lvl = e),
        (this._mdf = !1),
        (this.closed = !0 === t.hd),
        (this.pElem = createNS("path")),
        (this.msElem = null);
    }
    function DashProperty(t, e, r, i) {
      var s;
      (this.elem = t),
        (this.frameId = -1),
        (this.dataProps = createSizedArray(e.length)),
        (this.renderer = r),
        (this.k = !1),
        (this.dashStr = ""),
        (this.dashArray = createTypedArray(
          "float32",
          e.length ? e.length - 1 : 0
        )),
        (this.dashoffset = createTypedArray("float32", 1)),
        this.initDynamicPropertyContainer(i);
      var a,
        n = e.length || 0;
      for (s = 0; s < n; s += 1)
        (a = PropertyFactory.getProp(t, e[s].v, 0, 0, this)),
          (this.k = a.k || this.k),
          (this.dataProps[s] = { n: e[s].n, p: a });
      this.k || this.getValue(!0), (this._isAnimated = this.k);
    }
    function SVGStrokeStyleData(t, e, r) {
      this.initDynamicPropertyContainer(t),
        (this.getValue = this.iterateDynamicProperties),
        (this.o = PropertyFactory.getProp(t, e.o, 0, 0.01, this)),
        (this.w = PropertyFactory.getProp(t, e.w, 0, null, this)),
        (this.d = new DashProperty(t, e.d || {}, "svg", this)),
        (this.c = PropertyFactory.getProp(t, e.c, 1, 255, this)),
        (this.style = r),
        (this._isAnimated = !!this._isAnimated);
    }
    function SVGFillStyleData(t, e, r) {
      this.initDynamicPropertyContainer(t),
        (this.getValue = this.iterateDynamicProperties),
        (this.o = PropertyFactory.getProp(t, e.o, 0, 0.01, this)),
        (this.c = PropertyFactory.getProp(t, e.c, 1, 255, this)),
        (this.style = r);
    }
    function SVGNoStyleData(t, e, r) {
      this.initDynamicPropertyContainer(t),
        (this.getValue = this.iterateDynamicProperties),
        (this.style = r);
    }
    function GradientProperty(t, e, r) {
      (this.data = e), (this.c = createTypedArray("uint8c", 4 * e.p));
      var i = e.k.k[0].s ? e.k.k[0].s.length - 4 * e.p : e.k.k.length - 4 * e.p;
      (this.o = createTypedArray("float32", i)),
        (this._cmdf = !1),
        (this._omdf = !1),
        (this._collapsable = this.checkCollapsable()),
        (this._hasOpacity = i),
        this.initDynamicPropertyContainer(r),
        (this.prop = PropertyFactory.getProp(t, e.k, 1, null, this)),
        (this.k = this.prop.k),
        this.getValue(!0);
    }
    function SVGGradientFillStyleData(t, e, r) {
      this.initDynamicPropertyContainer(t),
        (this.getValue = this.iterateDynamicProperties),
        this.initGradientData(t, e, r);
    }
    function SVGGradientStrokeStyleData(t, e, r) {
      this.initDynamicPropertyContainer(t),
        (this.getValue = this.iterateDynamicProperties),
        (this.w = PropertyFactory.getProp(t, e.w, 0, null, this)),
        (this.d = new DashProperty(t, e.d || {}, "svg", this)),
        this.initGradientData(t, e, r),
        (this._isAnimated = !!this._isAnimated);
    }
    function ShapeGroupData() {
      (this.it = []), (this.prevViewData = []), (this.gr = createNS("g"));
    }
    function SVGTransformData(t, e, r) {
      (this.transform = { mProps: t, op: e, container: r }),
        (this.elements = []),
        (this._isAnimated =
          this.transform.mProps.dynamicProperties.length ||
          this.transform.op.effectsSequence.length);
    }
    (SVGShapeData.prototype.setAsAnimated = function () {
      this._isAnimated = !0;
    }),
      (SVGStyleData.prototype.reset = function () {
        (this.d = ""), (this._mdf = !1);
      }),
      (DashProperty.prototype.getValue = function (t) {
        if (
          (this.elem.globalData.frameId !== this.frameId || t) &&
          ((this.frameId = this.elem.globalData.frameId),
          this.iterateDynamicProperties(),
          (this._mdf = this._mdf || t),
          this._mdf)
        ) {
          var e = 0,
            r = this.dataProps.length;
          for (
            "svg" === this.renderer && (this.dashStr = ""), e = 0;
            e < r;
            e += 1
          )
            "o" !== this.dataProps[e].n
              ? "svg" === this.renderer
                ? (this.dashStr += " " + this.dataProps[e].p.v)
                : (this.dashArray[e] = this.dataProps[e].p.v)
              : (this.dashoffset[0] = this.dataProps[e].p.v);
        }
      }),
      extendPrototype([DynamicPropertyContainer], DashProperty),
      extendPrototype([DynamicPropertyContainer], SVGStrokeStyleData),
      extendPrototype([DynamicPropertyContainer], SVGFillStyleData),
      extendPrototype([DynamicPropertyContainer], SVGNoStyleData),
      (GradientProperty.prototype.comparePoints = function (t, e) {
        for (var r = 0, i = this.o.length / 2; r < i; ) {
          if (Math.abs(t[4 * r] - t[4 * e + 2 * r]) > 0.01) return !1;
          r += 1;
        }
        return !0;
      }),
      (GradientProperty.prototype.checkCollapsable = function () {
        if (this.o.length / 2 != this.c.length / 4) return !1;
        if (this.data.k.k[0].s)
          for (var t = 0, e = this.data.k.k.length; t < e; ) {
            if (!this.comparePoints(this.data.k.k[t].s, this.data.p)) return !1;
            t += 1;
          }
        else if (!this.comparePoints(this.data.k.k, this.data.p)) return !1;
        return !0;
      }),
      (GradientProperty.prototype.getValue = function (t) {
        if (
          (this.prop.getValue(),
          (this._mdf = !1),
          (this._cmdf = !1),
          (this._omdf = !1),
          this.prop._mdf || t)
        ) {
          var e,
            r,
            i,
            s = 4 * this.data.p;
          for (e = 0; e < s; e += 1)
            (r = e % 4 == 0 ? 100 : 255),
              (i = Math.round(this.prop.v[e] * r)),
              this.c[e] !== i && ((this.c[e] = i), (this._cmdf = !t));
          if (this.o.length)
            for (s = this.prop.v.length, e = 4 * this.data.p; e < s; e += 1)
              (r = e % 2 == 0 ? 100 : 1),
                (i =
                  e % 2 == 0
                    ? Math.round(100 * this.prop.v[e])
                    : this.prop.v[e]),
                this.o[e - 4 * this.data.p] !== i &&
                  ((this.o[e - 4 * this.data.p] = i), (this._omdf = !t));
          this._mdf = !t;
        }
      }),
      extendPrototype([DynamicPropertyContainer], GradientProperty),
      (SVGGradientFillStyleData.prototype.initGradientData = function (
        t,
        e,
        r
      ) {
        (this.o = PropertyFactory.getProp(t, e.o, 0, 0.01, this)),
          (this.s = PropertyFactory.getProp(t, e.s, 1, null, this)),
          (this.e = PropertyFactory.getProp(t, e.e, 1, null, this)),
          (this.h = PropertyFactory.getProp(t, e.h || { k: 0 }, 0, 0.01, this)),
          (this.a = PropertyFactory.getProp(
            t,
            e.a || { k: 0 },
            0,
            degToRads,
            this
          )),
          (this.g = new GradientProperty(t, e.g, this)),
          (this.style = r),
          (this.stops = []),
          this.setGradientData(r.pElem, e),
          this.setGradientOpacity(e, r),
          (this._isAnimated = !!this._isAnimated);
      }),
      (SVGGradientFillStyleData.prototype.setGradientData = function (t, e) {
        var r = createElementID(),
          i = createNS(1 === e.t ? "linearGradient" : "radialGradient");
        i.setAttribute("id", r),
          i.setAttribute("spreadMethod", "pad"),
          i.setAttribute("gradientUnits", "userSpaceOnUse");
        var s,
          a,
          n,
          o = [];
        for (n = 4 * e.g.p, a = 0; a < n; a += 4)
          (s = createNS("stop")), i.appendChild(s), o.push(s);
        t.setAttribute(
          "gf" === e.ty ? "fill" : "stroke",
          "url(" + getLocationHref() + "#" + r + ")"
        ),
          (this.gf = i),
          (this.cst = o);
      }),
      (SVGGradientFillStyleData.prototype.setGradientOpacity = function (t, e) {
        if (this.g._hasOpacity && !this.g._collapsable) {
          var r,
            i,
            s,
            a = createNS("mask"),
            n = createNS("path");
          a.appendChild(n);
          var o = createElementID(),
            h = createElementID();
          a.setAttribute("id", h);
          var l = createNS(1 === t.t ? "linearGradient" : "radialGradient");
          l.setAttribute("id", o),
            l.setAttribute("spreadMethod", "pad"),
            l.setAttribute("gradientUnits", "userSpaceOnUse"),
            (s = t.g.k.k[0].s ? t.g.k.k[0].s.length : t.g.k.k.length);
          var p = this.stops;
          for (i = 4 * t.g.p; i < s; i += 2)
            (r = createNS("stop")).setAttribute(
              "stop-color",
              "rgb(255,255,255)"
            ),
              l.appendChild(r),
              p.push(r);
          n.setAttribute(
            "gf" === t.ty ? "fill" : "stroke",
            "url(" + getLocationHref() + "#" + o + ")"
          ),
            "gs" === t.ty &&
              (n.setAttribute("stroke-linecap", lineCapEnum[t.lc || 2]),
              n.setAttribute("stroke-linejoin", lineJoinEnum[t.lj || 2]),
              1 === t.lj && n.setAttribute("stroke-miterlimit", t.ml)),
            (this.of = l),
            (this.ms = a),
            (this.ost = p),
            (this.maskId = h),
            (e.msElem = n);
        }
      }),
      extendPrototype([DynamicPropertyContainer], SVGGradientFillStyleData),
      extendPrototype(
        [SVGGradientFillStyleData, DynamicPropertyContainer],
        SVGGradientStrokeStyleData
      );
    var buildShapeString = function (t, e, r, i) {
        if (0 === e) return "";
        var s,
          a = t.o,
          n = t.i,
          o = t.v,
          h = " M" + i.applyToPointStringified(o[0][0], o[0][1]);
        for (s = 1; s < e; s += 1)
          h +=
            " C" +
            i.applyToPointStringified(a[s - 1][0], a[s - 1][1]) +
            " " +
            i.applyToPointStringified(n[s][0], n[s][1]) +
            " " +
            i.applyToPointStringified(o[s][0], o[s][1]);
        return (
          r &&
            e &&
            ((h +=
              " C" +
              i.applyToPointStringified(a[s - 1][0], a[s - 1][1]) +
              " " +
              i.applyToPointStringified(n[0][0], n[0][1]) +
              " " +
              i.applyToPointStringified(o[0][0], o[0][1])),
            (h += "z")),
          h
        );
      },
      SVGElementsRenderer = (function () {
        var t = new Matrix(),
          e = new Matrix();
        function r(t, e, r) {
          (r || e.transform.op._mdf) &&
            e.transform.container.setAttribute("opacity", e.transform.op.v),
            (r || e.transform.mProps._mdf) &&
              e.transform.container.setAttribute(
                "transform",
                e.transform.mProps.v.to2dCSS()
              );
        }
        function i() {}
        function s(r, i, s) {
          var a,
            n,
            o,
            h,
            l,
            p,
            f,
            m,
            c,
            d,
            u,
            y = i.styles.length,
            g = i.lvl;
          for (p = 0; p < y; p += 1) {
            if (((h = i.sh._mdf || s), i.styles[p].lvl < g)) {
              for (
                m = e.reset(),
                  d = g - i.styles[p].lvl,
                  u = i.transformers.length - 1;
                !h && d > 0;

              )
                (h = i.transformers[u].mProps._mdf || h), (d -= 1), (u -= 1);
              if (h)
                for (
                  d = g - i.styles[p].lvl, u = i.transformers.length - 1;
                  d > 0;

                )
                  (c = i.transformers[u].mProps.v.props),
                    m.transform(
                      c[0],
                      c[1],
                      c[2],
                      c[3],
                      c[4],
                      c[5],
                      c[6],
                      c[7],
                      c[8],
                      c[9],
                      c[10],
                      c[11],
                      c[12],
                      c[13],
                      c[14],
                      c[15]
                    ),
                    (d -= 1),
                    (u -= 1);
            } else m = t;
            if (((n = (f = i.sh.paths)._length), h)) {
              for (o = "", a = 0; a < n; a += 1)
                (l = f.shapes[a]) &&
                  l._length &&
                  (o += buildShapeString(l, l._length, l.c, m));
              i.caches[p] = o;
            } else o = i.caches[p];
            (i.styles[p].d += !0 === r.hd ? "" : o),
              (i.styles[p]._mdf = h || i.styles[p]._mdf);
          }
        }
        function a(t, e, r) {
          var i = e.style;
          (e.c._mdf || r) &&
            i.pElem.setAttribute(
              "fill",
              "rgb(" +
                bmFloor(e.c.v[0]) +
                "," +
                bmFloor(e.c.v[1]) +
                "," +
                bmFloor(e.c.v[2]) +
                ")"
            ),
            (e.o._mdf || r) && i.pElem.setAttribute("fill-opacity", e.o.v);
        }
        function n(t, e, r) {
          o(t, e, r), h(t, e, r);
        }
        function o(t, e, r) {
          var i,
            s,
            a,
            n,
            o,
            h = e.gf,
            l = e.g._hasOpacity,
            p = e.s.v,
            f = e.e.v;
          if (e.o._mdf || r) {
            var m = "gf" === t.ty ? "fill-opacity" : "stroke-opacity";
            e.style.pElem.setAttribute(m, e.o.v);
          }
          if (e.s._mdf || r) {
            var c = 1 === t.t ? "x1" : "cx",
              d = "x1" === c ? "y1" : "cy";
            h.setAttribute(c, p[0]),
              h.setAttribute(d, p[1]),
              l &&
                !e.g._collapsable &&
                (e.of.setAttribute(c, p[0]), e.of.setAttribute(d, p[1]));
          }
          if (e.g._cmdf || r) {
            i = e.cst;
            var u = e.g.c;
            for (a = i.length, s = 0; s < a; s += 1)
              (n = i[s]).setAttribute("offset", u[4 * s] + "%"),
                n.setAttribute(
                  "stop-color",
                  "rgb(" +
                    u[4 * s + 1] +
                    "," +
                    u[4 * s + 2] +
                    "," +
                    u[4 * s + 3] +
                    ")"
                );
          }
          if (l && (e.g._omdf || r)) {
            var y = e.g.o;
            for (
              a = (i = e.g._collapsable ? e.cst : e.ost).length, s = 0;
              s < a;
              s += 1
            )
              (n = i[s]),
                e.g._collapsable || n.setAttribute("offset", y[2 * s] + "%"),
                n.setAttribute("stop-opacity", y[2 * s + 1]);
          }
          if (1 === t.t)
            (e.e._mdf || r) &&
              (h.setAttribute("x2", f[0]),
              h.setAttribute("y2", f[1]),
              l &&
                !e.g._collapsable &&
                (e.of.setAttribute("x2", f[0]), e.of.setAttribute("y2", f[1])));
          else if (
            ((e.s._mdf || e.e._mdf || r) &&
              ((o = Math.sqrt(
                Math.pow(p[0] - f[0], 2) + Math.pow(p[1] - f[1], 2)
              )),
              h.setAttribute("r", o),
              l && !e.g._collapsable && e.of.setAttribute("r", o)),
            e.e._mdf || e.h._mdf || e.a._mdf || r)
          ) {
            o ||
              (o = Math.sqrt(
                Math.pow(p[0] - f[0], 2) + Math.pow(p[1] - f[1], 2)
              ));
            var g = Math.atan2(f[1] - p[1], f[0] - p[0]),
              v = e.h.v;
            v >= 1 ? (v = 0.99) : v <= -1 && (v = -0.99);
            var b = o * v,
              P = Math.cos(g + e.a.v) * b + p[0],
              E = Math.sin(g + e.a.v) * b + p[1];
            h.setAttribute("fx", P),
              h.setAttribute("fy", E),
              l &&
                !e.g._collapsable &&
                (e.of.setAttribute("fx", P), e.of.setAttribute("fy", E));
          }
        }
        function h(t, e, r) {
          var i = e.style,
            s = e.d;
          s &&
            (s._mdf || r) &&
            s.dashStr &&
            (i.pElem.setAttribute("stroke-dasharray", s.dashStr),
            i.pElem.setAttribute("stroke-dashoffset", s.dashoffset[0])),
            e.c &&
              (e.c._mdf || r) &&
              i.pElem.setAttribute(
                "stroke",
                "rgb(" +
                  bmFloor(e.c.v[0]) +
                  "," +
                  bmFloor(e.c.v[1]) +
                  "," +
                  bmFloor(e.c.v[2]) +
                  ")"
              ),
            (e.o._mdf || r) && i.pElem.setAttribute("stroke-opacity", e.o.v),
            (e.w._mdf || r) &&
              (i.pElem.setAttribute("stroke-width", e.w.v),
              i.msElem && i.msElem.setAttribute("stroke-width", e.w.v));
        }
        return {
          createRenderFunction: function (t) {
            switch (t.ty) {
              case "fl":
                return a;
              case "gf":
                return o;
              case "gs":
                return n;
              case "st":
                return h;
              case "sh":
              case "el":
              case "rc":
              case "sr":
                return s;
              case "tr":
                return r;
              case "no":
                return i;
              default:
                return null;
            }
          },
        };
      })();
    function SVGShapeElement(t, e, r) {
      (this.shapes = []),
        (this.shapesData = t.shapes),
        (this.stylesList = []),
        (this.shapeModifiers = []),
        (this.itemsData = []),
        (this.processedElements = []),
        (this.animatedContents = []),
        this.initElement(t, e, r),
        (this.prevViewData = []);
    }
    function LetterProps(t, e, r, i, s, a) {
      (this.o = t),
        (this.sw = e),
        (this.sc = r),
        (this.fc = i),
        (this.m = s),
        (this.p = a),
        (this._mdf = { o: !0, sw: !!e, sc: !!r, fc: !!i, m: !0, p: !0 });
    }
    function TextProperty(t, e) {
      (this._frameId = initialDefaultFrame),
        (this.pv = ""),
        (this.v = ""),
        (this.kf = !1),
        (this._isFirstFrame = !0),
        (this._mdf = !1),
        (this.data = e),
        (this.elem = t),
        (this.comp = this.elem.comp),
        (this.keysIndex = 0),
        (this.canResize = !1),
        (this.minimumFontSize = 1),
        (this.effectsSequence = []),
        (this.currentData = {
          ascent: 0,
          boxWidth: this.defaultBoxWidth,
          f: "",
          fStyle: "",
          fWeight: "",
          fc: "",
          j: "",
          justifyOffset: "",
          l: [],
          lh: 0,
          lineWidths: [],
          ls: "",
          of: "",
          s: "",
          sc: "",
          sw: 0,
          t: 0,
          tr: 0,
          sz: 0,
          ps: null,
          fillColorAnim: !1,
          strokeColorAnim: !1,
          strokeWidthAnim: !1,
          yOffset: 0,
          finalSize: 0,
          finalText: [],
          finalLineHeight: 0,
          __complete: !1,
        }),
        this.copyData(this.currentData, this.data.d.k[0].s),
        this.searchProperty() || this.completeTextData(this.currentData);
    }
    extendPrototype(
      [
        BaseElement,
        TransformElement,
        SVGBaseElement,
        IShapeElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement,
      ],
      SVGShapeElement
    ),
      (SVGShapeElement.prototype.initSecondaryElement = function () {}),
      (SVGShapeElement.prototype.identityMatrix = new Matrix()),
      (SVGShapeElement.prototype.buildExpressionInterface = function () {}),
      (SVGShapeElement.prototype.createContent = function () {
        this.searchShapes(
          this.shapesData,
          this.itemsData,
          this.prevViewData,
          this.layerElement,
          0,
          [],
          !0
        ),
          this.filterUniqueShapes();
      }),
      (SVGShapeElement.prototype.filterUniqueShapes = function () {
        var t,
          e,
          r,
          i,
          s = this.shapes.length,
          a = this.stylesList.length,
          n = [],
          o = !1;
        for (r = 0; r < a; r += 1) {
          for (
            i = this.stylesList[r], o = !1, n.length = 0, t = 0;
            t < s;
            t += 1
          )
            -1 !== (e = this.shapes[t]).styles.indexOf(i) &&
              (n.push(e), (o = e._isAnimated || o));
          n.length > 1 && o && this.setShapesAsAnimated(n);
        }
      }),
      (SVGShapeElement.prototype.setShapesAsAnimated = function (t) {
        var e,
          r = t.length;
        for (e = 0; e < r; e += 1) t[e].setAsAnimated();
      }),
      (SVGShapeElement.prototype.createStyleElement = function (t, e) {
        var r,
          i = new SVGStyleData(t, e),
          s = i.pElem;
        if ("st" === t.ty) r = new SVGStrokeStyleData(this, t, i);
        else if ("fl" === t.ty) r = new SVGFillStyleData(this, t, i);
        else if ("gf" === t.ty || "gs" === t.ty) {
          (r = new (
            "gf" === t.ty
              ? SVGGradientFillStyleData
              : SVGGradientStrokeStyleData
          )(this, t, i)),
            this.globalData.defs.appendChild(r.gf),
            r.maskId &&
              (this.globalData.defs.appendChild(r.ms),
              this.globalData.defs.appendChild(r.of),
              s.setAttribute(
                "mask",
                "url(" + getLocationHref() + "#" + r.maskId + ")"
              ));
        } else "no" === t.ty && (r = new SVGNoStyleData(this, t, i));
        return (
          ("st" !== t.ty && "gs" !== t.ty) ||
            (s.setAttribute("stroke-linecap", lineCapEnum[t.lc || 2]),
            s.setAttribute("stroke-linejoin", lineJoinEnum[t.lj || 2]),
            s.setAttribute("fill-opacity", "0"),
            1 === t.lj && s.setAttribute("stroke-miterlimit", t.ml)),
          2 === t.r && s.setAttribute("fill-rule", "evenodd"),
          t.ln && s.setAttribute("id", t.ln),
          t.cl && s.setAttribute("class", t.cl),
          t.bm && (s.style["mix-blend-mode"] = getBlendMode(t.bm)),
          this.stylesList.push(i),
          this.addToAnimatedContents(t, r),
          r
        );
      }),
      (SVGShapeElement.prototype.createGroupElement = function (t) {
        var e = new ShapeGroupData();
        return (
          t.ln && e.gr.setAttribute("id", t.ln),
          t.cl && e.gr.setAttribute("class", t.cl),
          t.bm && (e.gr.style["mix-blend-mode"] = getBlendMode(t.bm)),
          e
        );
      }),
      (SVGShapeElement.prototype.createTransformElement = function (t, e) {
        var r = TransformPropertyFactory.getTransformProperty(this, t, this),
          i = new SVGTransformData(r, r.o, e);
        return this.addToAnimatedContents(t, i), i;
      }),
      (SVGShapeElement.prototype.createShapeElement = function (t, e, r) {
        var i = 4;
        "rc" === t.ty
          ? (i = 5)
          : "el" === t.ty
          ? (i = 6)
          : "sr" === t.ty && (i = 7);
        var s = new SVGShapeData(
          e,
          r,
          ShapePropertyFactory.getShapeProp(this, t, i, this)
        );
        return (
          this.shapes.push(s),
          this.addShapeToModifiers(s),
          this.addToAnimatedContents(t, s),
          s
        );
      }),
      (SVGShapeElement.prototype.addToAnimatedContents = function (t, e) {
        for (var r = 0, i = this.animatedContents.length; r < i; ) {
          if (this.animatedContents[r].element === e) return;
          r += 1;
        }
        this.animatedContents.push({
          fn: SVGElementsRenderer.createRenderFunction(t),
          element: e,
          data: t,
        });
      }),
      (SVGShapeElement.prototype.setElementStyles = function (t) {
        var e,
          r = t.styles,
          i = this.stylesList.length;
        for (e = 0; e < i; e += 1)
          this.stylesList[e].closed || r.push(this.stylesList[e]);
      }),
      (SVGShapeElement.prototype.reloadShapes = function () {
        var t;
        this._isFirstFrame = !0;
        var e = this.itemsData.length;
        for (t = 0; t < e; t += 1) this.prevViewData[t] = this.itemsData[t];
        for (
          this.searchShapes(
            this.shapesData,
            this.itemsData,
            this.prevViewData,
            this.layerElement,
            0,
            [],
            !0
          ),
            this.filterUniqueShapes(),
            e = this.dynamicProperties.length,
            t = 0;
          t < e;
          t += 1
        )
          this.dynamicProperties[t].getValue();
        this.renderModifiers();
      }),
      (SVGShapeElement.prototype.searchShapes = function (t, e, r, i, s, a, n) {
        var o,
          h,
          l,
          p,
          f,
          m,
          c = [].concat(a),
          d = t.length - 1,
          u = [],
          y = [];
        for (o = d; o >= 0; o -= 1) {
          if (
            ((m = this.searchProcessedElement(t[o]))
              ? (e[o] = r[m - 1])
              : (t[o]._render = n),
            "fl" === t[o].ty ||
              "st" === t[o].ty ||
              "gf" === t[o].ty ||
              "gs" === t[o].ty ||
              "no" === t[o].ty)
          )
            m
              ? (e[o].style.closed = !1)
              : (e[o] = this.createStyleElement(t[o], s)),
              t[o]._render &&
                e[o].style.pElem.parentNode !== i &&
                i.appendChild(e[o].style.pElem),
              u.push(e[o].style);
          else if ("gr" === t[o].ty) {
            if (m)
              for (l = e[o].it.length, h = 0; h < l; h += 1)
                e[o].prevViewData[h] = e[o].it[h];
            else e[o] = this.createGroupElement(t[o]);
            this.searchShapes(
              t[o].it,
              e[o].it,
              e[o].prevViewData,
              e[o].gr,
              s + 1,
              c,
              n
            ),
              t[o]._render &&
                e[o].gr.parentNode !== i &&
                i.appendChild(e[o].gr);
          } else
            "tr" === t[o].ty
              ? (m || (e[o] = this.createTransformElement(t[o], i)),
                (p = e[o].transform),
                c.push(p))
              : "sh" === t[o].ty ||
                "rc" === t[o].ty ||
                "el" === t[o].ty ||
                "sr" === t[o].ty
              ? (m || (e[o] = this.createShapeElement(t[o], c, s)),
                this.setElementStyles(e[o]))
              : "tm" === t[o].ty ||
                "rd" === t[o].ty ||
                "ms" === t[o].ty ||
                "pb" === t[o].ty
              ? (m
                  ? ((f = e[o]).closed = !1)
                  : ((f = ShapeModifiers.getModifier(t[o].ty)).init(this, t[o]),
                    (e[o] = f),
                    this.shapeModifiers.push(f)),
                y.push(f))
              : "rp" === t[o].ty &&
                (m
                  ? ((f = e[o]).closed = !0)
                  : ((f = ShapeModifiers.getModifier(t[o].ty)),
                    (e[o] = f),
                    f.init(this, t, o, e),
                    this.shapeModifiers.push(f),
                    (n = !1)),
                y.push(f));
          this.addProcessedElement(t[o], o + 1);
        }
        for (d = u.length, o = 0; o < d; o += 1) u[o].closed = !0;
        for (d = y.length, o = 0; o < d; o += 1) y[o].closed = !0;
      }),
      (SVGShapeElement.prototype.renderInnerContent = function () {
        var t;
        this.renderModifiers();
        var e = this.stylesList.length;
        for (t = 0; t < e; t += 1) this.stylesList[t].reset();
        for (this.renderShape(), t = 0; t < e; t += 1)
          (this.stylesList[t]._mdf || this._isFirstFrame) &&
            (this.stylesList[t].msElem &&
              (this.stylesList[t].msElem.setAttribute(
                "d",
                this.stylesList[t].d
              ),
              (this.stylesList[t].d = "M0 0" + this.stylesList[t].d)),
            this.stylesList[t].pElem.setAttribute(
              "d",
              this.stylesList[t].d || "M0 0"
            ));
      }),
      (SVGShapeElement.prototype.renderShape = function () {
        var t,
          e,
          r = this.animatedContents.length;
        for (t = 0; t < r; t += 1)
          (e = this.animatedContents[t]),
            (this._isFirstFrame || e.element._isAnimated) &&
              !0 !== e.data &&
              e.fn(e.data, e.element, this._isFirstFrame);
      }),
      (SVGShapeElement.prototype.destroy = function () {
        this.destroyBaseElement(),
          (this.shapesData = null),
          (this.itemsData = null);
      }),
      (LetterProps.prototype.update = function (t, e, r, i, s, a) {
        (this._mdf.o = !1),
          (this._mdf.sw = !1),
          (this._mdf.sc = !1),
          (this._mdf.fc = !1),
          (this._mdf.m = !1),
          (this._mdf.p = !1);
        var n = !1;
        return (
          this.o !== t && ((this.o = t), (this._mdf.o = !0), (n = !0)),
          this.sw !== e && ((this.sw = e), (this._mdf.sw = !0), (n = !0)),
          this.sc !== r && ((this.sc = r), (this._mdf.sc = !0), (n = !0)),
          this.fc !== i && ((this.fc = i), (this._mdf.fc = !0), (n = !0)),
          this.m !== s && ((this.m = s), (this._mdf.m = !0), (n = !0)),
          !a.length ||
            (this.p[0] === a[0] &&
              this.p[1] === a[1] &&
              this.p[4] === a[4] &&
              this.p[5] === a[5] &&
              this.p[12] === a[12] &&
              this.p[13] === a[13]) ||
            ((this.p = a), (this._mdf.p = !0), (n = !0)),
          n
        );
      }),
      (TextProperty.prototype.defaultBoxWidth = [0, 0]),
      (TextProperty.prototype.copyData = function (t, e) {
        for (var r in e)
          Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
        return t;
      }),
      (TextProperty.prototype.setCurrentData = function (t) {
        t.__complete || this.completeTextData(t),
          (this.currentData = t),
          (this.currentData.boxWidth =
            this.currentData.boxWidth || this.defaultBoxWidth),
          (this._mdf = !0);
      }),
      (TextProperty.prototype.searchProperty = function () {
        return this.searchKeyframes();
      }),
      (TextProperty.prototype.searchKeyframes = function () {
        return (
          (this.kf = this.data.d.k.length > 1),
          this.kf && this.addEffect(this.getKeyframeValue.bind(this)),
          this.kf
        );
      }),
      (TextProperty.prototype.addEffect = function (t) {
        this.effectsSequence.push(t), this.elem.addDynamicProperty(this);
      }),
      (TextProperty.prototype.getValue = function (t) {
        if (
          (this.elem.globalData.frameId !== this.frameId &&
            this.effectsSequence.length) ||
          t
        ) {
          this.currentData.t = this.data.d.k[this.keysIndex].s.t;
          var e = this.currentData,
            r = this.keysIndex;
          if (this.lock) this.setCurrentData(this.currentData);
          else {
            var i;
            (this.lock = !0), (this._mdf = !1);
            var s = this.effectsSequence.length,
              a = t || this.data.d.k[this.keysIndex].s;
            for (i = 0; i < s; i += 1)
              a =
                r !== this.keysIndex
                  ? this.effectsSequence[i](a, a.t)
                  : this.effectsSequence[i](this.currentData, a.t);
            e !== a && this.setCurrentData(a),
              (this.v = this.currentData),
              (this.pv = this.v),
              (this.lock = !1),
              (this.frameId = this.elem.globalData.frameId);
          }
        }
      }),
      (TextProperty.prototype.getKeyframeValue = function () {
        for (
          var t = this.data.d.k,
            e = this.elem.comp.renderedFrame,
            r = 0,
            i = t.length;
          r <= i - 1 && !(r === i - 1 || t[r + 1].t > e);

        )
          r += 1;
        return (
          this.keysIndex !== r && (this.keysIndex = r),
          this.data.d.k[this.keysIndex].s
        );
      }),
      (TextProperty.prototype.buildFinalText = function (t) {
        for (var e, r, i = [], s = 0, a = t.length, n = !1; s < a; )
          (e = t.charCodeAt(s)),
            FontManager.isCombinedCharacter(e)
              ? (i[i.length - 1] += t.charAt(s))
              : e >= 55296 && e <= 56319
              ? (r = t.charCodeAt(s + 1)) >= 56320 && r <= 57343
                ? (n || FontManager.isModifier(e, r)
                    ? ((i[i.length - 1] += t.substr(s, 2)), (n = !1))
                    : i.push(t.substr(s, 2)),
                  (s += 1))
                : i.push(t.charAt(s))
              : e > 56319
              ? ((r = t.charCodeAt(s + 1)),
                FontManager.isZeroWidthJoiner(e, r)
                  ? ((n = !0), (i[i.length - 1] += t.substr(s, 2)), (s += 1))
                  : i.push(t.charAt(s)))
              : FontManager.isZeroWidthJoiner(e)
              ? ((i[i.length - 1] += t.charAt(s)), (n = !0))
              : i.push(t.charAt(s)),
            (s += 1);
        return i;
      }),
      (TextProperty.prototype.completeTextData = function (t) {
        t.__complete = !0;
        var e,
          r,
          i,
          s,
          a,
          n,
          o,
          h = this.elem.globalData.fontManager,
          l = this.data,
          p = [],
          f = 0,
          m = l.m.g,
          c = 0,
          d = 0,
          u = 0,
          y = [],
          g = 0,
          v = 0,
          b = h.getFontByName(t.f),
          P = 0,
          E = getFontProperties(b);
        (t.fWeight = E.weight),
          (t.fStyle = E.style),
          (t.finalSize = t.s),
          (t.finalText = this.buildFinalText(t.t)),
          (r = t.finalText.length),
          (t.finalLineHeight = t.lh);
        var x,
          S = (t.tr / 1e3) * t.finalSize;
        if (t.sz)
          for (var _, C, A = !0, T = t.sz[0], D = t.sz[1]; A; ) {
            (_ = 0),
              (g = 0),
              (r = (C = this.buildFinalText(t.t)).length),
              (S = (t.tr / 1e3) * t.finalSize);
            var k = -1;
            for (e = 0; e < r; e += 1)
              (x = C[e].charCodeAt(0)),
                (i = !1),
                " " === C[e]
                  ? (k = e)
                  : (13 !== x && 3 !== x) ||
                    ((g = 0),
                    (i = !0),
                    (_ += t.finalLineHeight || 1.2 * t.finalSize)),
                h.chars
                  ? ((o = h.getCharData(C[e], b.fStyle, b.fFamily)),
                    (P = i ? 0 : (o.w * t.finalSize) / 100))
                  : (P = h.measureText(C[e], t.f, t.finalSize)),
                g + P > T && " " !== C[e]
                  ? (-1 === k ? (r += 1) : (e = k),
                    (_ += t.finalLineHeight || 1.2 * t.finalSize),
                    C.splice(e, k === e ? 1 : 0, "\r"),
                    (k = -1),
                    (g = 0))
                  : ((g += P), (g += S));
            (_ += (b.ascent * t.finalSize) / 100),
              this.canResize && t.finalSize > this.minimumFontSize && D < _
                ? ((t.finalSize -= 1),
                  (t.finalLineHeight = (t.finalSize * t.lh) / t.s))
                : ((t.finalText = C), (r = t.finalText.length), (A = !1));
          }
        (g = -S), (P = 0);
        var M,
          F = 0;
        for (e = 0; e < r; e += 1)
          if (
            ((i = !1),
            13 === (x = (M = t.finalText[e]).charCodeAt(0)) || 3 === x
              ? ((F = 0),
                y.push(g),
                (v = g > v ? g : v),
                (g = -2 * S),
                (s = ""),
                (i = !0),
                (u += 1))
              : (s = M),
            h.chars
              ? ((o = h.getCharData(M, b.fStyle, h.getFontByName(t.f).fFamily)),
                (P = i ? 0 : (o.w * t.finalSize) / 100))
              : (P = h.measureText(s, t.f, t.finalSize)),
            " " === M ? (F += P + S) : ((g += P + S + F), (F = 0)),
            p.push({
              l: P,
              an: P,
              add: c,
              n: i,
              anIndexes: [],
              val: s,
              line: u,
              animatorJustifyOffset: 0,
            }),
            2 == m)
          ) {
            if (((c += P), "" === s || " " === s || e === r - 1)) {
              for (("" !== s && " " !== s) || (c -= P); d <= e; )
                (p[d].an = c), (p[d].ind = f), (p[d].extra = P), (d += 1);
              (f += 1), (c = 0);
            }
          } else if (3 == m) {
            if (((c += P), "" === s || e === r - 1)) {
              for ("" === s && (c -= P); d <= e; )
                (p[d].an = c), (p[d].ind = f), (p[d].extra = P), (d += 1);
              (c = 0), (f += 1);
            }
          } else (p[f].ind = f), (p[f].extra = 0), (f += 1);
        if (((t.l = p), (v = g > v ? g : v), y.push(g), t.sz))
          (t.boxWidth = t.sz[0]), (t.justifyOffset = 0);
        else
          switch (((t.boxWidth = v), t.j)) {
            case 1:
              t.justifyOffset = -t.boxWidth;
              break;
            case 2:
              t.justifyOffset = -t.boxWidth / 2;
              break;
            default:
              t.justifyOffset = 0;
          }
        t.lineWidths = y;
        var w,
          I,
          V,
          B,
          R = l.a;
        n = R.length;
        var L = [];
        for (a = 0; a < n; a += 1) {
          for (
            (w = R[a]).a.sc && (t.strokeColorAnim = !0),
              w.a.sw && (t.strokeWidthAnim = !0),
              (w.a.fc || w.a.fh || w.a.fs || w.a.fb) && (t.fillColorAnim = !0),
              B = 0,
              V = w.s.b,
              e = 0;
            e < r;
            e += 1
          )
            ((I = p[e]).anIndexes[a] = B),
              ((1 == V && "" !== I.val) ||
                (2 == V && "" !== I.val && " " !== I.val) ||
                (3 == V && (I.n || " " == I.val || e == r - 1)) ||
                (4 == V && (I.n || e == r - 1))) &&
                (1 === w.s.rn && L.push(B), (B += 1));
          l.a[a].s.totalChars = B;
          var G,
            z = -1;
          if (1 === w.s.rn)
            for (e = 0; e < r; e += 1)
              z != (I = p[e]).anIndexes[a] &&
                ((z = I.anIndexes[a]),
                (G = L.splice(Math.floor(Math.random() * L.length), 1)[0])),
                (I.anIndexes[a] = G);
        }
        (t.yOffset = t.finalLineHeight || 1.2 * t.finalSize),
          (t.ls = t.ls || 0),
          (t.ascent = (b.ascent * t.finalSize) / 100);
      }),
      (TextProperty.prototype.updateDocumentData = function (t, e) {
        e = void 0 === e ? this.keysIndex : e;
        var r = this.copyData({}, this.data.d.k[e].s);
        (r = this.copyData(r, t)),
          (this.data.d.k[e].s = r),
          this.recalculate(e),
          this.elem.addDynamicProperty(this);
      }),
      (TextProperty.prototype.recalculate = function (t) {
        var e = this.data.d.k[t].s;
        (e.__complete = !1),
          (this.keysIndex = 0),
          (this._isFirstFrame = !0),
          this.getValue(e);
      }),
      (TextProperty.prototype.canResizeFont = function (t) {
        (this.canResize = t),
          this.recalculate(this.keysIndex),
          this.elem.addDynamicProperty(this);
      }),
      (TextProperty.prototype.setMinimumFontSize = function (t) {
        (this.minimumFontSize = Math.floor(t) || 1),
          this.recalculate(this.keysIndex),
          this.elem.addDynamicProperty(this);
      });
    var TextSelectorProp = (function () {
      var t = Math.max,
        e = Math.min,
        r = Math.floor;
      function i(t, e) {
        (this._currentTextLength = -1),
          (this.k = !1),
          (this.data = e),
          (this.elem = t),
          (this.comp = t.comp),
          (this.finalS = 0),
          (this.finalE = 0),
          this.initDynamicPropertyContainer(t),
          (this.s = PropertyFactory.getProp(t, e.s || { k: 0 }, 0, 0, this)),
          (this.e =
            "e" in e
              ? PropertyFactory.getProp(t, e.e, 0, 0, this)
              : { v: 100 }),
          (this.o = PropertyFactory.getProp(t, e.o || { k: 0 }, 0, 0, this)),
          (this.xe = PropertyFactory.getProp(t, e.xe || { k: 0 }, 0, 0, this)),
          (this.ne = PropertyFactory.getProp(t, e.ne || { k: 0 }, 0, 0, this)),
          (this.sm = PropertyFactory.getProp(
            t,
            e.sm || { k: 100 },
            0,
            0,
            this
          )),
          (this.a = PropertyFactory.getProp(t, e.a, 0, 0.01, this)),
          this.dynamicProperties.length || this.getValue();
      }
      return (
        (i.prototype = {
          getMult: function (i) {
            this._currentTextLength !==
              this.elem.textProperty.currentData.l.length && this.getValue();
            var s = 0,
              a = 0,
              n = 1,
              o = 1;
            this.ne.v > 0 ? (s = this.ne.v / 100) : (a = -this.ne.v / 100),
              this.xe.v > 0
                ? (n = 1 - this.xe.v / 100)
                : (o = 1 + this.xe.v / 100);
            var h = BezierFactory.getBezierEasing(s, a, n, o).get,
              l = 0,
              p = this.finalS,
              f = this.finalE,
              m = this.data.sh;
            if (2 === m)
              l = h(
                (l =
                  f === p
                    ? i >= f
                      ? 1
                      : 0
                    : t(0, e(0.5 / (f - p) + (i - p) / (f - p), 1)))
              );
            else if (3 === m)
              l = h(
                (l =
                  f === p
                    ? i >= f
                      ? 0
                      : 1
                    : 1 - t(0, e(0.5 / (f - p) + (i - p) / (f - p), 1)))
              );
            else if (4 === m)
              f === p
                ? (l = 0)
                : (l = t(0, e(0.5 / (f - p) + (i - p) / (f - p), 1))) < 0.5
                ? (l *= 2)
                : (l = 1 - 2 * (l - 0.5)),
                (l = h(l));
            else if (5 === m) {
              if (f === p) l = 0;
              else {
                var c = f - p,
                  d = -c / 2 + (i = e(t(0, i + 0.5 - p), f - p)),
                  u = c / 2;
                l = Math.sqrt(1 - (d * d) / (u * u));
              }
              l = h(l);
            } else
              6 === m
                ? (f === p
                    ? (l = 0)
                    : ((i = e(t(0, i + 0.5 - p), f - p)),
                      (l =
                        (1 + Math.cos(Math.PI + (2 * Math.PI * i) / (f - p))) /
                        2)),
                  (l = h(l)))
                : (i >= r(p) &&
                    (l = t(0, e(i - p < 0 ? e(f, 1) - (p - i) : f - i, 1))),
                  (l = h(l)));
            if (100 !== this.sm.v) {
              var y = 0.01 * this.sm.v;
              0 === y && (y = 1e-8);
              var g = 0.5 - 0.5 * y;
              l < g ? (l = 0) : (l = (l - g) / y) > 1 && (l = 1);
            }
            return l * this.a.v;
          },
          getValue: function (t) {
            this.iterateDynamicProperties(),
              (this._mdf = t || this._mdf),
              (this._currentTextLength =
                this.elem.textProperty.currentData.l.length || 0),
              t && 2 === this.data.r && (this.e.v = this._currentTextLength);
            var e = 2 === this.data.r ? 1 : 100 / this.data.totalChars,
              r = this.o.v / e,
              i = this.s.v / e + r,
              s = this.e.v / e + r;
            if (i > s) {
              var a = i;
              (i = s), (s = a);
            }
            (this.finalS = i), (this.finalE = s);
          },
        }),
        extendPrototype([DynamicPropertyContainer], i),
        {
          getTextSelectorProp: function (t, e, r) {
            return new i(t, e, r);
          },
        }
      );
    })();
    function TextAnimatorDataProperty(t, e, r) {
      var i = { propType: !1 },
        s = PropertyFactory.getProp,
        a = e.a;
      (this.a = {
        r: a.r ? s(t, a.r, 0, degToRads, r) : i,
        rx: a.rx ? s(t, a.rx, 0, degToRads, r) : i,
        ry: a.ry ? s(t, a.ry, 0, degToRads, r) : i,
        sk: a.sk ? s(t, a.sk, 0, degToRads, r) : i,
        sa: a.sa ? s(t, a.sa, 0, degToRads, r) : i,
        s: a.s ? s(t, a.s, 1, 0.01, r) : i,
        a: a.a ? s(t, a.a, 1, 0, r) : i,
        o: a.o ? s(t, a.o, 0, 0.01, r) : i,
        p: a.p ? s(t, a.p, 1, 0, r) : i,
        sw: a.sw ? s(t, a.sw, 0, 0, r) : i,
        sc: a.sc ? s(t, a.sc, 1, 0, r) : i,
        fc: a.fc ? s(t, a.fc, 1, 0, r) : i,
        fh: a.fh ? s(t, a.fh, 0, 0, r) : i,
        fs: a.fs ? s(t, a.fs, 0, 0.01, r) : i,
        fb: a.fb ? s(t, a.fb, 0, 0.01, r) : i,
        t: a.t ? s(t, a.t, 0, 0, r) : i,
      }),
        (this.s = TextSelectorProp.getTextSelectorProp(t, e.s, r)),
        (this.s.t = e.s.t);
    }
    function TextAnimatorProperty(t, e, r) {
      (this._isFirstFrame = !0),
        (this._hasMaskedPath = !1),
        (this._frameId = -1),
        (this._textData = t),
        (this._renderType = e),
        (this._elem = r),
        (this._animatorsData = createSizedArray(this._textData.a.length)),
        (this._pathData = {}),
        (this._moreOptions = { alignment: {} }),
        (this.renderedLetters = []),
        (this.lettersChangedFlag = !1),
        this.initDynamicPropertyContainer(r);
    }
    function ITextElement() {}
    (TextAnimatorProperty.prototype.searchProperties = function () {
      var t,
        e,
        r = this._textData.a.length,
        i = PropertyFactory.getProp;
      for (t = 0; t < r; t += 1)
        (e = this._textData.a[t]),
          (this._animatorsData[t] = new TextAnimatorDataProperty(
            this._elem,
            e,
            this
          ));
      this._textData.p && "m" in this._textData.p
        ? ((this._pathData = {
            a: i(this._elem, this._textData.p.a, 0, 0, this),
            f: i(this._elem, this._textData.p.f, 0, 0, this),
            l: i(this._elem, this._textData.p.l, 0, 0, this),
            r: i(this._elem, this._textData.p.r, 0, 0, this),
            p: i(this._elem, this._textData.p.p, 0, 0, this),
            m: this._elem.maskManager.getMaskProperty(this._textData.p.m),
          }),
          (this._hasMaskedPath = !0))
        : (this._hasMaskedPath = !1),
        (this._moreOptions.alignment = i(
          this._elem,
          this._textData.m.a,
          1,
          0,
          this
        ));
    }),
      (TextAnimatorProperty.prototype.getMeasures = function (t, e) {
        if (
          ((this.lettersChangedFlag = e),
          this._mdf ||
            this._isFirstFrame ||
            e ||
            (this._hasMaskedPath && this._pathData.m._mdf))
        ) {
          this._isFirstFrame = !1;
          var r,
            i,
            s,
            a,
            n,
            o,
            h,
            l,
            p,
            f,
            m,
            c,
            d,
            u,
            y,
            g,
            v,
            b,
            P,
            E = this._moreOptions.alignment.v,
            x = this._animatorsData,
            S = this._textData,
            _ = this.mHelper,
            C = this._renderType,
            A = this.renderedLetters.length,
            T = t.l;
          if (this._hasMaskedPath) {
            if (
              ((P = this._pathData.m), !this._pathData.n || this._pathData._mdf)
            ) {
              var D,
                k = P.v;
              for (
                this._pathData.r.v && (k = k.reverse()),
                  n = { tLength: 0, segments: [] },
                  a = k._length - 1,
                  g = 0,
                  s = 0;
                s < a;
                s += 1
              )
                (D = bez.buildBezierData(
                  k.v[s],
                  k.v[s + 1],
                  [k.o[s][0] - k.v[s][0], k.o[s][1] - k.v[s][1]],
                  [k.i[s + 1][0] - k.v[s + 1][0], k.i[s + 1][1] - k.v[s + 1][1]]
                )),
                  (n.tLength += D.segmentLength),
                  n.segments.push(D),
                  (g += D.segmentLength);
              (s = a),
                P.v.c &&
                  ((D = bez.buildBezierData(
                    k.v[s],
                    k.v[0],
                    [k.o[s][0] - k.v[s][0], k.o[s][1] - k.v[s][1]],
                    [k.i[0][0] - k.v[0][0], k.i[0][1] - k.v[0][1]]
                  )),
                  (n.tLength += D.segmentLength),
                  n.segments.push(D),
                  (g += D.segmentLength)),
                (this._pathData.pi = n);
            }
            if (
              ((n = this._pathData.pi),
              (o = this._pathData.f.v),
              (m = 0),
              (f = 1),
              (l = 0),
              (p = !0),
              (u = n.segments),
              o < 0 && P.v.c)
            )
              for (
                n.tLength < Math.abs(o) && (o = -Math.abs(o) % n.tLength),
                  f = (d = u[(m = u.length - 1)].points).length - 1;
                o < 0;

              )
                (o += d[f].partialLength),
                  (f -= 1) < 0 && (f = (d = u[(m -= 1)].points).length - 1);
            (c = (d = u[m].points)[f - 1]), (y = (h = d[f]).partialLength);
          }
          (a = T.length), (r = 0), (i = 0);
          var M,
            F,
            w,
            I,
            V,
            B = 1.2 * t.finalSize * 0.714,
            R = !0;
          w = x.length;
          var L,
            G,
            z,
            N,
            O,
            H,
            j,
            q,
            W,
            $,
            Y,
            X,
            K = -1,
            J = o,
            Z = m,
            U = f,
            Q = -1,
            tt = "",
            et = this.defaultPropsArray;
          if (2 === t.j || 1 === t.j) {
            var rt = 0,
              it = 0,
              st = 2 === t.j ? -0.5 : -1,
              at = 0,
              nt = !0;
            for (s = 0; s < a; s += 1)
              if (T[s].n) {
                for (rt && (rt += it); at < s; )
                  (T[at].animatorJustifyOffset = rt), (at += 1);
                (rt = 0), (nt = !0);
              } else {
                for (F = 0; F < w; F += 1)
                  (M = x[F].a).t.propType &&
                    (nt && 2 === t.j && (it += M.t.v * st),
                    (V = x[F].s.getMult(T[s].anIndexes[F], S.a[F].s.totalChars))
                      .length
                      ? (rt += M.t.v * V[0] * st)
                      : (rt += M.t.v * V * st));
                nt = !1;
              }
            for (rt && (rt += it); at < s; )
              (T[at].animatorJustifyOffset = rt), (at += 1);
          }
          for (s = 0; s < a; s += 1) {
            if ((_.reset(), (N = 1), T[s].n))
              (r = 0),
                (i += t.yOffset),
                (i += R ? 1 : 0),
                (o = J),
                (R = !1),
                this._hasMaskedPath &&
                  ((f = U),
                  (c = (d = u[(m = Z)].points)[f - 1]),
                  (y = (h = d[f]).partialLength),
                  (l = 0)),
                (tt = ""),
                (Y = ""),
                (W = ""),
                (X = ""),
                (et = this.defaultPropsArray);
            else {
              if (this._hasMaskedPath) {
                if (Q !== T[s].line) {
                  switch (t.j) {
                    case 1:
                      o += g - t.lineWidths[T[s].line];
                      break;
                    case 2:
                      o += (g - t.lineWidths[T[s].line]) / 2;
                  }
                  Q = T[s].line;
                }
                K !== T[s].ind &&
                  (T[K] && (o += T[K].extra),
                  (o += T[s].an / 2),
                  (K = T[s].ind)),
                  (o += E[0] * T[s].an * 0.005);
                var ot = 0;
                for (F = 0; F < w; F += 1)
                  (M = x[F].a).p.propType &&
                    ((V = x[F].s.getMult(
                      T[s].anIndexes[F],
                      S.a[F].s.totalChars
                    )).length
                      ? (ot += M.p.v[0] * V[0])
                      : (ot += M.p.v[0] * V)),
                    M.a.propType &&
                      ((V = x[F].s.getMult(
                        T[s].anIndexes[F],
                        S.a[F].s.totalChars
                      )).length
                        ? (ot += M.a.v[0] * V[0])
                        : (ot += M.a.v[0] * V));
                for (
                  p = !0,
                    this._pathData.a.v &&
                      ((o =
                        0.5 * T[0].an +
                        ((g -
                          this._pathData.f.v -
                          0.5 * T[0].an -
                          0.5 * T[T.length - 1].an) *
                          K) /
                          (a - 1)),
                      (o += this._pathData.f.v));
                  p;

                )
                  l + y >= o + ot || !d
                    ? ((v = (o + ot - l) / h.partialLength),
                      (G = c.point[0] + (h.point[0] - c.point[0]) * v),
                      (z = c.point[1] + (h.point[1] - c.point[1]) * v),
                      _.translate(-E[0] * T[s].an * 0.005, -E[1] * B * 0.01),
                      (p = !1))
                    : d &&
                      ((l += h.partialLength),
                      (f += 1) >= d.length &&
                        ((f = 0),
                        u[(m += 1)]
                          ? (d = u[m].points)
                          : P.v.c
                          ? ((f = 0), (d = u[(m = 0)].points))
                          : ((l -= h.partialLength), (d = null))),
                      d && ((c = h), (y = (h = d[f]).partialLength)));
                (L = T[s].an / 2 - T[s].add), _.translate(-L, 0, 0);
              } else
                (L = T[s].an / 2 - T[s].add),
                  _.translate(-L, 0, 0),
                  _.translate(-E[0] * T[s].an * 0.005, -E[1] * B * 0.01, 0);
              for (F = 0; F < w; F += 1)
                (M = x[F].a).t.propType &&
                  ((V = x[F].s.getMult(T[s].anIndexes[F], S.a[F].s.totalChars)),
                  (0 === r && 0 === t.j) ||
                    (this._hasMaskedPath
                      ? V.length
                        ? (o += M.t.v * V[0])
                        : (o += M.t.v * V)
                      : V.length
                      ? (r += M.t.v * V[0])
                      : (r += M.t.v * V)));
              for (
                t.strokeWidthAnim && (H = t.sw || 0),
                  t.strokeColorAnim &&
                    (O = t.sc ? [t.sc[0], t.sc[1], t.sc[2]] : [0, 0, 0]),
                  t.fillColorAnim && t.fc && (j = [t.fc[0], t.fc[1], t.fc[2]]),
                  F = 0;
                F < w;
                F += 1
              )
                (M = x[F].a).a.propType &&
                  ((V = x[F].s.getMult(T[s].anIndexes[F], S.a[F].s.totalChars))
                    .length
                    ? _.translate(
                        -M.a.v[0] * V[0],
                        -M.a.v[1] * V[1],
                        M.a.v[2] * V[2]
                      )
                    : _.translate(-M.a.v[0] * V, -M.a.v[1] * V, M.a.v[2] * V));
              for (F = 0; F < w; F += 1)
                (M = x[F].a).s.propType &&
                  ((V = x[F].s.getMult(T[s].anIndexes[F], S.a[F].s.totalChars))
                    .length
                    ? _.scale(
                        1 + (M.s.v[0] - 1) * V[0],
                        1 + (M.s.v[1] - 1) * V[1],
                        1
                      )
                    : _.scale(
                        1 + (M.s.v[0] - 1) * V,
                        1 + (M.s.v[1] - 1) * V,
                        1
                      ));
              for (F = 0; F < w; F += 1) {
                if (
                  ((M = x[F].a),
                  (V = x[F].s.getMult(T[s].anIndexes[F], S.a[F].s.totalChars)),
                  M.sk.propType &&
                    (V.length
                      ? _.skewFromAxis(-M.sk.v * V[0], M.sa.v * V[1])
                      : _.skewFromAxis(-M.sk.v * V, M.sa.v * V)),
                  M.r.propType &&
                    (V.length
                      ? _.rotateZ(-M.r.v * V[2])
                      : _.rotateZ(-M.r.v * V)),
                  M.ry.propType &&
                    (V.length
                      ? _.rotateY(M.ry.v * V[1])
                      : _.rotateY(M.ry.v * V)),
                  M.rx.propType &&
                    (V.length
                      ? _.rotateX(M.rx.v * V[0])
                      : _.rotateX(M.rx.v * V)),
                  M.o.propType &&
                    (V.length
                      ? (N += (M.o.v * V[0] - N) * V[0])
                      : (N += (M.o.v * V - N) * V)),
                  t.strokeWidthAnim &&
                    M.sw.propType &&
                    (V.length ? (H += M.sw.v * V[0]) : (H += M.sw.v * V)),
                  t.strokeColorAnim && M.sc.propType)
                )
                  for (q = 0; q < 3; q += 1)
                    V.length
                      ? (O[q] += (M.sc.v[q] - O[q]) * V[0])
                      : (O[q] += (M.sc.v[q] - O[q]) * V);
                if (t.fillColorAnim && t.fc) {
                  if (M.fc.propType)
                    for (q = 0; q < 3; q += 1)
                      V.length
                        ? (j[q] += (M.fc.v[q] - j[q]) * V[0])
                        : (j[q] += (M.fc.v[q] - j[q]) * V);
                  M.fh.propType &&
                    (j = V.length
                      ? addHueToRGB(j, M.fh.v * V[0])
                      : addHueToRGB(j, M.fh.v * V)),
                    M.fs.propType &&
                      (j = V.length
                        ? addSaturationToRGB(j, M.fs.v * V[0])
                        : addSaturationToRGB(j, M.fs.v * V)),
                    M.fb.propType &&
                      (j = V.length
                        ? addBrightnessToRGB(j, M.fb.v * V[0])
                        : addBrightnessToRGB(j, M.fb.v * V));
                }
              }
              for (F = 0; F < w; F += 1)
                (M = x[F].a).p.propType &&
                  ((V = x[F].s.getMult(T[s].anIndexes[F], S.a[F].s.totalChars)),
                  this._hasMaskedPath
                    ? V.length
                      ? _.translate(0, M.p.v[1] * V[0], -M.p.v[2] * V[1])
                      : _.translate(0, M.p.v[1] * V, -M.p.v[2] * V)
                    : V.length
                    ? _.translate(
                        M.p.v[0] * V[0],
                        M.p.v[1] * V[1],
                        -M.p.v[2] * V[2]
                      )
                    : _.translate(M.p.v[0] * V, M.p.v[1] * V, -M.p.v[2] * V));
              if (
                (t.strokeWidthAnim && (W = H < 0 ? 0 : H),
                t.strokeColorAnim &&
                  ($ =
                    "rgb(" +
                    Math.round(255 * O[0]) +
                    "," +
                    Math.round(255 * O[1]) +
                    "," +
                    Math.round(255 * O[2]) +
                    ")"),
                t.fillColorAnim &&
                  t.fc &&
                  (Y =
                    "rgb(" +
                    Math.round(255 * j[0]) +
                    "," +
                    Math.round(255 * j[1]) +
                    "," +
                    Math.round(255 * j[2]) +
                    ")"),
                this._hasMaskedPath)
              ) {
                if (
                  (_.translate(0, -t.ls),
                  _.translate(0, E[1] * B * 0.01 + i, 0),
                  this._pathData.p.v)
                ) {
                  b = (h.point[1] - c.point[1]) / (h.point[0] - c.point[0]);
                  var ht = (180 * Math.atan(b)) / Math.PI;
                  h.point[0] < c.point[0] && (ht += 180),
                    _.rotate((-ht * Math.PI) / 180);
                }
                _.translate(G, z, 0),
                  (o -= E[0] * T[s].an * 0.005),
                  T[s + 1] &&
                    K !== T[s + 1].ind &&
                    ((o += T[s].an / 2), (o += 0.001 * t.tr * t.finalSize));
              } else {
                switch (
                  (_.translate(r, i, 0),
                  t.ps && _.translate(t.ps[0], t.ps[1] + t.ascent, 0),
                  t.j)
                ) {
                  case 1:
                    _.translate(
                      T[s].animatorJustifyOffset +
                        t.justifyOffset +
                        (t.boxWidth - t.lineWidths[T[s].line]),
                      0,
                      0
                    );
                    break;
                  case 2:
                    _.translate(
                      T[s].animatorJustifyOffset +
                        t.justifyOffset +
                        (t.boxWidth - t.lineWidths[T[s].line]) / 2,
                      0,
                      0
                    );
                }
                _.translate(0, -t.ls),
                  _.translate(L, 0, 0),
                  _.translate(E[0] * T[s].an * 0.005, E[1] * B * 0.01, 0),
                  (r += T[s].l + 0.001 * t.tr * t.finalSize);
              }
              "html" === C
                ? (tt = _.toCSS())
                : "svg" === C
                ? (tt = _.to2dCSS())
                : (et = [
                    _.props[0],
                    _.props[1],
                    _.props[2],
                    _.props[3],
                    _.props[4],
                    _.props[5],
                    _.props[6],
                    _.props[7],
                    _.props[8],
                    _.props[9],
                    _.props[10],
                    _.props[11],
                    _.props[12],
                    _.props[13],
                    _.props[14],
                    _.props[15],
                  ]),
                (X = N);
            }
            A <= s
              ? ((I = new LetterProps(X, W, $, Y, tt, et)),
                this.renderedLetters.push(I),
                (A += 1),
                (this.lettersChangedFlag = !0))
              : ((I = this.renderedLetters[s]),
                (this.lettersChangedFlag =
                  I.update(X, W, $, Y, tt, et) || this.lettersChangedFlag));
          }
        }
      }),
      (TextAnimatorProperty.prototype.getValue = function () {
        this._elem.globalData.frameId !== this._frameId &&
          ((this._frameId = this._elem.globalData.frameId),
          this.iterateDynamicProperties());
      }),
      (TextAnimatorProperty.prototype.mHelper = new Matrix()),
      (TextAnimatorProperty.prototype.defaultPropsArray = []),
      extendPrototype([DynamicPropertyContainer], TextAnimatorProperty),
      (ITextElement.prototype.initElement = function (t, e, r) {
        (this.lettersChangedFlag = !0),
          this.initFrame(),
          this.initBaseData(t, e, r),
          (this.textProperty = new TextProperty(
            this,
            t.t,
            this.dynamicProperties
          )),
          (this.textAnimator = new TextAnimatorProperty(
            t.t,
            this.renderType,
            this
          )),
          this.initTransform(t, e, r),
          this.initHierarchy(),
          this.initRenderable(),
          this.initRendererElement(),
          this.createContainerElements(),
          this.createRenderableComponents(),
          this.createContent(),
          this.hide(),
          this.textAnimator.searchProperties(this.dynamicProperties);
      }),
      (ITextElement.prototype.prepareFrame = function (t) {
        (this._mdf = !1),
          this.prepareRenderableFrame(t),
          this.prepareProperties(t, this.isInRange),
          (this.textProperty._mdf || this.textProperty._isFirstFrame) &&
            (this.buildNewText(),
            (this.textProperty._isFirstFrame = !1),
            (this.textProperty._mdf = !1));
      }),
      (ITextElement.prototype.createPathShape = function (t, e) {
        var r,
          i,
          s = e.length,
          a = "";
        for (r = 0; r < s; r += 1)
          "sh" === e[r].ty &&
            ((i = e[r].ks.k), (a += buildShapeString(i, i.i.length, !0, t)));
        return a;
      }),
      (ITextElement.prototype.updateDocumentData = function (t, e) {
        this.textProperty.updateDocumentData(t, e);
      }),
      (ITextElement.prototype.canResizeFont = function (t) {
        this.textProperty.canResizeFont(t);
      }),
      (ITextElement.prototype.setMinimumFontSize = function (t) {
        this.textProperty.setMinimumFontSize(t);
      }),
      (ITextElement.prototype.applyTextPropertiesToMatrix = function (
        t,
        e,
        r,
        i,
        s
      ) {
        switch (
          (t.ps && e.translate(t.ps[0], t.ps[1] + t.ascent, 0),
          e.translate(0, -t.ls, 0),
          t.j)
        ) {
          case 1:
            e.translate(t.justifyOffset + (t.boxWidth - t.lineWidths[r]), 0, 0);
            break;
          case 2:
            e.translate(
              t.justifyOffset + (t.boxWidth - t.lineWidths[r]) / 2,
              0,
              0
            );
        }
        e.translate(i, s, 0);
      }),
      (ITextElement.prototype.buildColor = function (t) {
        return (
          "rgb(" +
          Math.round(255 * t[0]) +
          "," +
          Math.round(255 * t[1]) +
          "," +
          Math.round(255 * t[2]) +
          ")"
        );
      }),
      (ITextElement.prototype.emptyProp = new LetterProps()),
      (ITextElement.prototype.destroy = function () {});
    var emptyShapeData = { shapes: [] };
    function SVGTextLottieElement(t, e, r) {
      (this.textSpans = []),
        (this.renderType = "svg"),
        this.initElement(t, e, r);
    }
    function ISolidElement(t, e, r) {
      this.initElement(t, e, r);
    }
    function NullElement(t, e, r) {
      this.initFrame(),
        this.initBaseData(t, e, r),
        this.initFrame(),
        this.initTransform(t, e, r),
        this.initHierarchy();
    }
    function SVGRendererBase() {}
    function ICompElement() {}
    function SVGCompElement(t, e, r) {
      (this.layers = t.layers),
        (this.supports3d = !0),
        (this.completeLayers = !1),
        (this.pendingElements = []),
        (this.elements = this.layers
          ? createSizedArray(this.layers.length)
          : []),
        this.initElement(t, e, r),
        (this.tm = t.tm
          ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this)
          : { _placeholder: !0 });
    }
    function SVGRenderer(t, e) {
      (this.animationItem = t),
        (this.layers = null),
        (this.renderedFrame = -1),
        (this.svgElement = createNS("svg"));
      var r = "";
      if (e && e.title) {
        var i = createNS("title"),
          s = createElementID();
        i.setAttribute("id", s),
          (i.textContent = e.title),
          this.svgElement.appendChild(i),
          (r += s);
      }
      if (e && e.description) {
        var a = createNS("desc"),
          n = createElementID();
        a.setAttribute("id", n),
          (a.textContent = e.description),
          this.svgElement.appendChild(a),
          (r += " " + n);
      }
      r && this.svgElement.setAttribute("aria-labelledby", r);
      var o = createNS("defs");
      this.svgElement.appendChild(o);
      var h = createNS("g");
      this.svgElement.appendChild(h),
        (this.layerElement = h),
        (this.renderConfig = {
          preserveAspectRatio: (e && e.preserveAspectRatio) || "xMidYMid meet",
          imagePreserveAspectRatio:
            (e && e.imagePreserveAspectRatio) || "xMidYMid slice",
          contentVisibility: (e && e.contentVisibility) || "visible",
          progressiveLoad: (e && e.progressiveLoad) || !1,
          hideOnTransparent: !(e && !1 === e.hideOnTransparent),
          viewBoxOnly: (e && e.viewBoxOnly) || !1,
          viewBoxSize: (e && e.viewBoxSize) || !1,
          className: (e && e.className) || "",
          id: (e && e.id) || "",
          focusable: e && e.focusable,
          filterSize: {
            width: (e && e.filterSize && e.filterSize.width) || "100%",
            height: (e && e.filterSize && e.filterSize.height) || "100%",
            x: (e && e.filterSize && e.filterSize.x) || "0%",
            y: (e && e.filterSize && e.filterSize.y) || "0%",
          },
          width: e && e.width,
          height: e && e.height,
        }),
        (this.globalData = {
          _mdf: !1,
          frameNum: -1,
          defs: o,
          renderConfig: this.renderConfig,
        }),
        (this.elements = []),
        (this.pendingElements = []),
        (this.destroyed = !1),
        (this.rendererType = "svg");
    }
    function CVContextData() {
      var t;
      (this.saved = []),
        (this.cArrPos = 0),
        (this.cTr = new Matrix()),
        (this.cO = 1);
      for (
        this.savedOp = createTypedArray("float32", 15), t = 0;
        t < 15;
        t += 1
      )
        this.saved[t] = createTypedArray("float32", 16);
      this._length = 15;
    }
    function ShapeTransformManager() {
      (this.sequences = {}),
        (this.sequenceList = []),
        (this.transform_key_count = 0);
    }
    function CVEffects() {}
    function CVMaskElement(t, e) {
      var r;
      (this.data = t),
        (this.element = e),
        (this.masksProperties = this.data.masksProperties || []),
        (this.viewData = createSizedArray(this.masksProperties.length));
      var i = this.masksProperties.length,
        s = !1;
      for (r = 0; r < i; r += 1)
        "n" !== this.masksProperties[r].mode && (s = !0),
          (this.viewData[r] = ShapePropertyFactory.getShapeProp(
            this.element,
            this.masksProperties[r],
            3
          ));
      (this.hasMasks = s), s && this.element.addRenderableComponent(this);
    }
    function CVBaseElement() {}
    function CVShapeData(t, e, r, i) {
      (this.styledShapes = []), (this.tr = [0, 0, 0, 0, 0, 0]);
      var s,
        a = 4;
      "rc" === e.ty
        ? (a = 5)
        : "el" === e.ty
        ? (a = 6)
        : "sr" === e.ty && (a = 7),
        (this.sh = ShapePropertyFactory.getShapeProp(t, e, a, t));
      var n,
        o = r.length;
      for (s = 0; s < o; s += 1)
        r[s].closed ||
          ((n = {
            transforms: i.addTransformSequence(r[s].transforms),
            trNodes: [],
          }),
          this.styledShapes.push(n),
          r[s].elements.push(n));
    }
    function CVShapeElement(t, e, r) {
      (this.shapes = []),
        (this.shapesData = t.shapes),
        (this.stylesList = []),
        (this.itemsData = []),
        (this.prevViewData = []),
        (this.shapeModifiers = []),
        (this.processedElements = []),
        (this.transformsManager = new ShapeTransformManager()),
        this.initElement(t, e, r);
    }
    function CVTextElement(t, e, r) {
      (this.textSpans = []),
        (this.yOffset = 0),
        (this.fillColorAnim = !1),
        (this.strokeColorAnim = !1),
        (this.strokeWidthAnim = !1),
        (this.stroke = !1),
        (this.fill = !1),
        (this.justifyOffset = 0),
        (this.currentRender = null),
        (this.renderType = "canvas"),
        (this.values = {
          fill: "rgba(0,0,0,0)",
          stroke: "rgba(0,0,0,0)",
          sWidth: 0,
          fValue: "",
        }),
        this.initElement(t, e, r);
    }
    function CVImageElement(t, e, r) {
      (this.assetData = e.getAssetData(t.refId)),
        (this.img = e.imageLoader.getAsset(this.assetData)),
        this.initElement(t, e, r);
    }
    function CVSolidElement(t, e, r) {
      this.initElement(t, e, r);
    }
    function CanvasRendererBase(t, e) {
      (this.animationItem = t),
        (this.renderConfig = {
          clearCanvas: !e || void 0 === e.clearCanvas || e.clearCanvas,
          context: (e && e.context) || null,
          progressiveLoad: (e && e.progressiveLoad) || !1,
          preserveAspectRatio: (e && e.preserveAspectRatio) || "xMidYMid meet",
          imagePreserveAspectRatio:
            (e && e.imagePreserveAspectRatio) || "xMidYMid slice",
          contentVisibility: (e && e.contentVisibility) || "visible",
          className: (e && e.className) || "",
          id: (e && e.id) || "",
        }),
        (this.renderConfig.dpr = (e && e.dpr) || 1),
        this.animationItem.wrapper &&
          (this.renderConfig.dpr =
            (e && e.dpr) || window.devicePixelRatio || 1),
        (this.renderedFrame = -1),
        (this.globalData = {
          frameNum: -1,
          _mdf: !1,
          renderConfig: this.renderConfig,
          currentGlobalAlpha: -1,
        }),
        (this.contextData = new CVContextData()),
        (this.elements = []),
        (this.pendingElements = []),
        (this.transformMat = new Matrix()),
        (this.completeLayers = !1),
        (this.rendererType = "canvas");
    }
    function CVCompElement(t, e, r) {
      (this.completeLayers = !1),
        (this.layers = t.layers),
        (this.pendingElements = []),
        (this.elements = createSizedArray(this.layers.length)),
        this.initElement(t, e, r),
        (this.tm = t.tm
          ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this)
          : { _placeholder: !0 });
    }
    function CanvasRenderer(t, e) {
      (this.animationItem = t),
        (this.renderConfig = {
          clearCanvas: !e || void 0 === e.clearCanvas || e.clearCanvas,
          context: (e && e.context) || null,
          progressiveLoad: (e && e.progressiveLoad) || !1,
          preserveAspectRatio: (e && e.preserveAspectRatio) || "xMidYMid meet",
          imagePreserveAspectRatio:
            (e && e.imagePreserveAspectRatio) || "xMidYMid slice",
          contentVisibility: (e && e.contentVisibility) || "visible",
          className: (e && e.className) || "",
          id: (e && e.id) || "",
        }),
        (this.renderConfig.dpr = (e && e.dpr) || 1),
        this.animationItem.wrapper &&
          (this.renderConfig.dpr =
            (e && e.dpr) || window.devicePixelRatio || 1),
        (this.renderedFrame = -1),
        (this.globalData = {
          frameNum: -1,
          _mdf: !1,
          renderConfig: this.renderConfig,
          currentGlobalAlpha: -1,
        }),
        (this.contextData = new CVContextData()),
        (this.elements = []),
        (this.pendingElements = []),
        (this.transformMat = new Matrix()),
        (this.completeLayers = !1),
        (this.rendererType = "canvas");
    }
    function HBaseElement() {}
    function HSolidElement(t, e, r) {
      this.initElement(t, e, r);
    }
    function HShapeElement(t, e, r) {
      (this.shapes = []),
        (this.shapesData = t.shapes),
        (this.stylesList = []),
        (this.shapeModifiers = []),
        (this.itemsData = []),
        (this.processedElements = []),
        (this.animatedContents = []),
        (this.shapesContainer = createNS("g")),
        this.initElement(t, e, r),
        (this.prevViewData = []),
        (this.currentBBox = { x: 999999, y: -999999, h: 0, w: 0 });
    }
    function HTextElement(t, e, r) {
      (this.textSpans = []),
        (this.textPaths = []),
        (this.currentBBox = { x: 999999, y: -999999, h: 0, w: 0 }),
        (this.renderType = "svg"),
        (this.isMasked = !1),
        this.initElement(t, e, r);
    }
    function HCameraElement(t, e, r) {
      this.initFrame(), this.initBaseData(t, e, r), this.initHierarchy();
      var i = PropertyFactory.getProp;
      if (
        ((this.pe = i(this, t.pe, 0, 0, this)),
        t.ks.p.s
          ? ((this.px = i(this, t.ks.p.x, 1, 0, this)),
            (this.py = i(this, t.ks.p.y, 1, 0, this)),
            (this.pz = i(this, t.ks.p.z, 1, 0, this)))
          : (this.p = i(this, t.ks.p, 1, 0, this)),
        t.ks.a && (this.a = i(this, t.ks.a, 1, 0, this)),
        t.ks.or.k.length && t.ks.or.k[0].to)
      ) {
        var s,
          a = t.ks.or.k.length;
        for (s = 0; s < a; s += 1)
          (t.ks.or.k[s].to = null), (t.ks.or.k[s].ti = null);
      }
      (this.or = i(this, t.ks.or, 1, degToRads, this)),
        (this.or.sh = !0),
        (this.rx = i(this, t.ks.rx, 0, degToRads, this)),
        (this.ry = i(this, t.ks.ry, 0, degToRads, this)),
        (this.rz = i(this, t.ks.rz, 0, degToRads, this)),
        (this.mat = new Matrix()),
        (this._prevMat = new Matrix()),
        (this._isFirstFrame = !0),
        (this.finalTransform = { mProp: this });
    }
    function HImageElement(t, e, r) {
      (this.assetData = e.getAssetData(t.refId)), this.initElement(t, e, r);
    }
    function HybridRendererBase(t, e) {
      (this.animationItem = t),
        (this.layers = null),
        (this.renderedFrame = -1),
        (this.renderConfig = {
          className: (e && e.className) || "",
          imagePreserveAspectRatio:
            (e && e.imagePreserveAspectRatio) || "xMidYMid slice",
          hideOnTransparent: !(e && !1 === e.hideOnTransparent),
          filterSize: {
            width: (e && e.filterSize && e.filterSize.width) || "400%",
            height: (e && e.filterSize && e.filterSize.height) || "400%",
            x: (e && e.filterSize && e.filterSize.x) || "-100%",
            y: (e && e.filterSize && e.filterSize.y) || "-100%",
          },
        }),
        (this.globalData = {
          _mdf: !1,
          frameNum: -1,
          renderConfig: this.renderConfig,
        }),
        (this.pendingElements = []),
        (this.elements = []),
        (this.threeDElements = []),
        (this.destroyed = !1),
        (this.camera = null),
        (this.supports3d = !0),
        (this.rendererType = "html");
    }
    function HCompElement(t, e, r) {
      (this.layers = t.layers),
        (this.supports3d = !t.hasMask),
        (this.completeLayers = !1),
        (this.pendingElements = []),
        (this.elements = this.layers
          ? createSizedArray(this.layers.length)
          : []),
        this.initElement(t, e, r),
        (this.tm = t.tm
          ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this)
          : { _placeholder: !0 });
    }
    function HybridRenderer(t, e) {
      (this.animationItem = t),
        (this.layers = null),
        (this.renderedFrame = -1),
        (this.renderConfig = {
          className: (e && e.className) || "",
          imagePreserveAspectRatio:
            (e && e.imagePreserveAspectRatio) || "xMidYMid slice",
          hideOnTransparent: !(e && !1 === e.hideOnTransparent),
          filterSize: {
            width: (e && e.filterSize && e.filterSize.width) || "400%",
            height: (e && e.filterSize && e.filterSize.height) || "400%",
            x: (e && e.filterSize && e.filterSize.x) || "-100%",
            y: (e && e.filterSize && e.filterSize.y) || "-100%",
          },
        }),
        (this.globalData = {
          _mdf: !1,
          frameNum: -1,
          renderConfig: this.renderConfig,
        }),
        (this.pendingElements = []),
        (this.elements = []),
        (this.threeDElements = []),
        (this.destroyed = !1),
        (this.camera = null),
        (this.supports3d = !0),
        (this.rendererType = "html");
    }
    extendPrototype(
      [
        BaseElement,
        TransformElement,
        SVGBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement,
        ITextElement,
      ],
      SVGTextLottieElement
    ),
      (SVGTextLottieElement.prototype.createContent = function () {
        this.data.singleShape &&
          !this.globalData.fontManager.chars &&
          (this.textContainer = createNS("text"));
      }),
      (SVGTextLottieElement.prototype.buildTextContents = function (t) {
        for (var e = 0, r = t.length, i = [], s = ""; e < r; )
          t[e] === String.fromCharCode(13) || t[e] === String.fromCharCode(3)
            ? (i.push(s), (s = ""))
            : (s += t[e]),
            (e += 1);
        return i.push(s), i;
      }),
      (SVGTextLottieElement.prototype.buildShapeData = function (t, e) {
        if (t.shapes && t.shapes.length) {
          var r = t.shapes[0];
          if (r.it) {
            var i = r.it[r.it.length - 1];
            i.s && ((i.s.k[0] = e), (i.s.k[1] = e));
          }
        }
        return t;
      }),
      (SVGTextLottieElement.prototype.buildNewText = function () {
        var t, e;
        this.addDynamicProperty(this);
        var r = this.textProperty.currentData;
        (this.renderedLetters = createSizedArray(r ? r.l.length : 0)),
          r.fc
            ? this.layerElement.setAttribute("fill", this.buildColor(r.fc))
            : this.layerElement.setAttribute("fill", "rgba(0,0,0,0)"),
          r.sc &&
            (this.layerElement.setAttribute("stroke", this.buildColor(r.sc)),
            this.layerElement.setAttribute("stroke-width", r.sw)),
          this.layerElement.setAttribute("font-size", r.finalSize);
        var i = this.globalData.fontManager.getFontByName(r.f);
        if (i.fClass) this.layerElement.setAttribute("class", i.fClass);
        else {
          this.layerElement.setAttribute("font-family", i.fFamily);
          var s = r.fWeight,
            a = r.fStyle;
          this.layerElement.setAttribute("font-style", a),
            this.layerElement.setAttribute("font-weight", s);
        }
        this.layerElement.setAttribute("aria-label", r.t);
        var n,
          o = r.l || [],
          h = !!this.globalData.fontManager.chars;
        e = o.length;
        var l = this.mHelper,
          p = this.data.singleShape,
          f = 0,
          m = 0,
          c = !0,
          d = 0.001 * r.tr * r.finalSize;
        if (!p || h || r.sz) {
          var u,
            y = this.textSpans.length;
          for (t = 0; t < e; t += 1) {
            if (
              (this.textSpans[t] ||
                (this.textSpans[t] = {
                  span: null,
                  childSpan: null,
                  glyph: null,
                }),
              !h || !p || 0 === t)
            ) {
              if (
                ((n =
                  y > t ? this.textSpans[t].span : createNS(h ? "g" : "text")),
                y <= t)
              ) {
                if (
                  (n.setAttribute("stroke-linecap", "butt"),
                  n.setAttribute("stroke-linejoin", "round"),
                  n.setAttribute("stroke-miterlimit", "4"),
                  (this.textSpans[t].span = n),
                  h)
                ) {
                  var g = createNS("g");
                  n.appendChild(g), (this.textSpans[t].childSpan = g);
                }
                (this.textSpans[t].span = n), this.layerElement.appendChild(n);
              }
              n.style.display = "inherit";
            }
            if (
              (l.reset(),
              p &&
                (o[t].n &&
                  ((f = -d), (m += r.yOffset), (m += c ? 1 : 0), (c = !1)),
                this.applyTextPropertiesToMatrix(r, l, o[t].line, f, m),
                (f += o[t].l || 0),
                (f += d)),
              h)
            ) {
              var v;
              if (
                1 ===
                (u = this.globalData.fontManager.getCharData(
                  r.finalText[t],
                  i.fStyle,
                  this.globalData.fontManager.getFontByName(r.f).fFamily
                )).t
              )
                v = new SVGCompElement(u.data, this.globalData, this);
              else {
                var b = emptyShapeData;
                u.data &&
                  u.data.shapes &&
                  (b = this.buildShapeData(u.data, r.finalSize)),
                  (v = new SVGShapeElement(b, this.globalData, this));
              }
              if (this.textSpans[t].glyph) {
                var P = this.textSpans[t].glyph;
                this.textSpans[t].childSpan.removeChild(P.layerElement),
                  P.destroy();
              }
              (this.textSpans[t].glyph = v),
                (v._debug = !0),
                v.prepareFrame(0),
                v.renderFrame(),
                this.textSpans[t].childSpan.appendChild(v.layerElement),
                1 === u.t &&
                  this.textSpans[t].childSpan.setAttribute(
                    "transform",
                    "scale(" + r.finalSize / 100 + "," + r.finalSize / 100 + ")"
                  );
            } else
              p &&
                n.setAttribute(
                  "transform",
                  "translate(" + l.props[12] + "," + l.props[13] + ")"
                ),
                (n.textContent = o[t].val),
                n.setAttributeNS(
                  "http://www.w3.org/XML/1998/namespace",
                  "xml:space",
                  "preserve"
                );
          }
          p && n && n.setAttribute("d", "");
        } else {
          var E = this.textContainer,
            x = "start";
          switch (r.j) {
            case 1:
              x = "end";
              break;
            case 2:
              x = "middle";
              break;
            default:
              x = "start";
          }
          E.setAttribute("text-anchor", x), E.setAttribute("letter-spacing", d);
          var S = this.buildTextContents(r.finalText);
          for (
            e = S.length, m = r.ps ? r.ps[1] + r.ascent : 0, t = 0;
            t < e;
            t += 1
          )
            ((n = this.textSpans[t].span || createNS("tspan")).textContent =
              S[t]),
              n.setAttribute("x", 0),
              n.setAttribute("y", m),
              (n.style.display = "inherit"),
              E.appendChild(n),
              this.textSpans[t] ||
                (this.textSpans[t] = { span: null, glyph: null }),
              (this.textSpans[t].span = n),
              (m += r.finalLineHeight);
          this.layerElement.appendChild(E);
        }
        for (; t < this.textSpans.length; )
          (this.textSpans[t].span.style.display = "none"), (t += 1);
        this._sizeChanged = !0;
      }),
      (SVGTextLottieElement.prototype.sourceRectAtTime = function () {
        if (
          (this.prepareFrame(this.comp.renderedFrame - this.data.st),
          this.renderInnerContent(),
          this._sizeChanged)
        ) {
          this._sizeChanged = !1;
          var t = this.layerElement.getBBox();
          this.bbox = { top: t.y, left: t.x, width: t.width, height: t.height };
        }
        return this.bbox;
      }),
      (SVGTextLottieElement.prototype.getValue = function () {
        var t,
          e,
          r = this.textSpans.length;
        for (this.renderedFrame = this.comp.renderedFrame, t = 0; t < r; t += 1)
          (e = this.textSpans[t].glyph) &&
            (e.prepareFrame(this.comp.renderedFrame - this.data.st),
            e._mdf && (this._mdf = !0));
      }),
      (SVGTextLottieElement.prototype.renderInnerContent = function () {
        if (
          (!this.data.singleShape || this._mdf) &&
          (this.textAnimator.getMeasures(
            this.textProperty.currentData,
            this.lettersChangedFlag
          ),
          this.lettersChangedFlag || this.textAnimator.lettersChangedFlag)
        ) {
          var t, e;
          this._sizeChanged = !0;
          var r,
            i,
            s,
            a = this.textAnimator.renderedLetters,
            n = this.textProperty.currentData.l;
          for (e = n.length, t = 0; t < e; t += 1)
            n[t].n ||
              ((r = a[t]),
              (i = this.textSpans[t].span),
              (s = this.textSpans[t].glyph) && s.renderFrame(),
              r._mdf.m && i.setAttribute("transform", r.m),
              r._mdf.o && i.setAttribute("opacity", r.o),
              r._mdf.sw && i.setAttribute("stroke-width", r.sw),
              r._mdf.sc && i.setAttribute("stroke", r.sc),
              r._mdf.fc && i.setAttribute("fill", r.fc));
        }
      }),
      extendPrototype([IImageElement], ISolidElement),
      (ISolidElement.prototype.createContent = function () {
        var t = createNS("rect");
        t.setAttribute("width", this.data.sw),
          t.setAttribute("height", this.data.sh),
          t.setAttribute("fill", this.data.sc),
          this.layerElement.appendChild(t);
      }),
      (NullElement.prototype.prepareFrame = function (t) {
        this.prepareProperties(t, !0);
      }),
      (NullElement.prototype.renderFrame = function () {}),
      (NullElement.prototype.getBaseElement = function () {
        return null;
      }),
      (NullElement.prototype.destroy = function () {}),
      (NullElement.prototype.sourceRectAtTime = function () {}),
      (NullElement.prototype.hide = function () {}),
      extendPrototype(
        [BaseElement, TransformElement, HierarchyElement, FrameElement],
        NullElement
      ),
      extendPrototype([BaseRenderer], SVGRendererBase),
      (SVGRendererBase.prototype.createNull = function (t) {
        return new NullElement(t, this.globalData, this);
      }),
      (SVGRendererBase.prototype.createShape = function (t) {
        return new SVGShapeElement(t, this.globalData, this);
      }),
      (SVGRendererBase.prototype.createText = function (t) {
        return new SVGTextLottieElement(t, this.globalData, this);
      }),
      (SVGRendererBase.prototype.createImage = function (t) {
        return new IImageElement(t, this.globalData, this);
      }),
      (SVGRendererBase.prototype.createSolid = function (t) {
        return new ISolidElement(t, this.globalData, this);
      }),
      (SVGRendererBase.prototype.configAnimation = function (t) {
        this.svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg"),
          this.renderConfig.viewBoxSize
            ? this.svgElement.setAttribute(
                "viewBox",
                this.renderConfig.viewBoxSize
              )
            : this.svgElement.setAttribute("viewBox", "0 0 " + t.w + " " + t.h),
          this.renderConfig.viewBoxOnly ||
            (this.svgElement.setAttribute("width", t.w),
            this.svgElement.setAttribute("height", t.h),
            (this.svgElement.style.width = "100%"),
            (this.svgElement.style.height = "100%"),
            (this.svgElement.style.transform = "translate3d(0,0,0)"),
            (this.svgElement.style.contentVisibility =
              this.renderConfig.contentVisibility)),
          this.renderConfig.width &&
            this.svgElement.setAttribute("width", this.renderConfig.width),
          this.renderConfig.height &&
            this.svgElement.setAttribute("height", this.renderConfig.height),
          this.renderConfig.className &&
            this.svgElement.setAttribute("class", this.renderConfig.className),
          this.renderConfig.id &&
            this.svgElement.setAttribute("id", this.renderConfig.id),
          void 0 !== this.renderConfig.focusable &&
            this.svgElement.setAttribute(
              "focusable",
              this.renderConfig.focusable
            ),
          this.svgElement.setAttribute(
            "preserveAspectRatio",
            this.renderConfig.preserveAspectRatio
          ),
          this.animationItem.wrapper.appendChild(this.svgElement);
        var e = this.globalData.defs;
        this.setupGlobalData(t, e),
          (this.globalData.progressiveLoad = this.renderConfig.progressiveLoad),
          (this.data = t);
        var r = createNS("clipPath"),
          i = createNS("rect");
        i.setAttribute("width", t.w),
          i.setAttribute("height", t.h),
          i.setAttribute("x", 0),
          i.setAttribute("y", 0);
        var s = createElementID();
        r.setAttribute("id", s),
          r.appendChild(i),
          this.layerElement.setAttribute(
            "clip-path",
            "url(" + getLocationHref() + "#" + s + ")"
          ),
          e.appendChild(r),
          (this.layers = t.layers),
          (this.elements = createSizedArray(t.layers.length));
      }),
      (SVGRendererBase.prototype.destroy = function () {
        var t;
        this.animationItem.wrapper &&
          (this.animationItem.wrapper.innerText = ""),
          (this.layerElement = null),
          (this.globalData.defs = null);
        var e = this.layers ? this.layers.length : 0;
        for (t = 0; t < e; t += 1)
          this.elements[t] && this.elements[t].destroy();
        (this.elements.length = 0),
          (this.destroyed = !0),
          (this.animationItem = null);
      }),
      (SVGRendererBase.prototype.updateContainerSize = function () {}),
      (SVGRendererBase.prototype.buildItem = function (t) {
        var e = this.elements;
        if (!e[t] && 99 !== this.layers[t].ty) {
          e[t] = !0;
          var r = this.createItem(this.layers[t]);
          (e[t] = r),
            getExpressionsPlugin() &&
              (0 === this.layers[t].ty &&
                this.globalData.projectInterface.registerComposition(r),
              r.initExpressions()),
            this.appendElementInPos(r, t),
            this.layers[t].tt &&
              (this.elements[t - 1] && !0 !== this.elements[t - 1]
                ? r.setMatte(e[t - 1].layerId)
                : (this.buildItem(t - 1), this.addPendingElement(r)));
        }
      }),
      (SVGRendererBase.prototype.checkPendingElements = function () {
        for (; this.pendingElements.length; ) {
          var t = this.pendingElements.pop();
          if ((t.checkParenting(), t.data.tt))
            for (var e = 0, r = this.elements.length; e < r; ) {
              if (this.elements[e] === t) {
                t.setMatte(this.elements[e - 1].layerId);
                break;
              }
              e += 1;
            }
        }
      }),
      (SVGRendererBase.prototype.renderFrame = function (t) {
        if (this.renderedFrame !== t && !this.destroyed) {
          var e;
          null === t ? (t = this.renderedFrame) : (this.renderedFrame = t),
            (this.globalData.frameNum = t),
            (this.globalData.frameId += 1),
            (this.globalData.projectInterface.currentFrame = t),
            (this.globalData._mdf = !1);
          var r = this.layers.length;
          for (
            this.completeLayers || this.checkLayers(t), e = r - 1;
            e >= 0;
            e -= 1
          )
            (this.completeLayers || this.elements[e]) &&
              this.elements[e].prepareFrame(t - this.layers[e].st);
          if (this.globalData._mdf)
            for (e = 0; e < r; e += 1)
              (this.completeLayers || this.elements[e]) &&
                this.elements[e].renderFrame();
        }
      }),
      (SVGRendererBase.prototype.appendElementInPos = function (t, e) {
        var r = t.getBaseElement();
        if (r) {
          for (var i, s = 0; s < e; )
            this.elements[s] &&
              !0 !== this.elements[s] &&
              this.elements[s].getBaseElement() &&
              (i = this.elements[s].getBaseElement()),
              (s += 1);
          i
            ? this.layerElement.insertBefore(r, i)
            : this.layerElement.appendChild(r);
        }
      }),
      (SVGRendererBase.prototype.hide = function () {
        this.layerElement.style.display = "none";
      }),
      (SVGRendererBase.prototype.show = function () {
        this.layerElement.style.display = "block";
      }),
      extendPrototype(
        [
          BaseElement,
          TransformElement,
          HierarchyElement,
          FrameElement,
          RenderableDOMElement,
        ],
        ICompElement
      ),
      (ICompElement.prototype.initElement = function (t, e, r) {
        this.initFrame(),
          this.initBaseData(t, e, r),
          this.initTransform(t, e, r),
          this.initRenderable(),
          this.initHierarchy(),
          this.initRendererElement(),
          this.createContainerElements(),
          this.createRenderableComponents(),
          (!this.data.xt && e.progressiveLoad) || this.buildAllItems(),
          this.hide();
      }),
      (ICompElement.prototype.prepareFrame = function (t) {
        if (
          ((this._mdf = !1),
          this.prepareRenderableFrame(t),
          this.prepareProperties(t, this.isInRange),
          this.isInRange || this.data.xt)
        ) {
          if (this.tm._placeholder) this.renderedFrame = t / this.data.sr;
          else {
            var e = this.tm.v;
            e === this.data.op && (e = this.data.op - 1),
              (this.renderedFrame = e);
          }
          var r,
            i = this.elements.length;
          for (
            this.completeLayers || this.checkLayers(this.renderedFrame),
              r = i - 1;
            r >= 0;
            r -= 1
          )
            (this.completeLayers || this.elements[r]) &&
              (this.elements[r].prepareFrame(
                this.renderedFrame - this.layers[r].st
              ),
              this.elements[r]._mdf && (this._mdf = !0));
        }
      }),
      (ICompElement.prototype.renderInnerContent = function () {
        var t,
          e = this.layers.length;
        for (t = 0; t < e; t += 1)
          (this.completeLayers || this.elements[t]) &&
            this.elements[t].renderFrame();
      }),
      (ICompElement.prototype.setElements = function (t) {
        this.elements = t;
      }),
      (ICompElement.prototype.getElements = function () {
        return this.elements;
      }),
      (ICompElement.prototype.destroyElements = function () {
        var t,
          e = this.layers.length;
        for (t = 0; t < e; t += 1)
          this.elements[t] && this.elements[t].destroy();
      }),
      (ICompElement.prototype.destroy = function () {
        this.destroyElements(), this.destroyBaseElement();
      }),
      extendPrototype(
        [SVGRendererBase, ICompElement, SVGBaseElement],
        SVGCompElement
      ),
      (SVGCompElement.prototype.createComp = function (t) {
        return new SVGCompElement(t, this.globalData, this);
      }),
      extendPrototype([SVGRendererBase], SVGRenderer),
      (SVGRenderer.prototype.createComp = function (t) {
        return new SVGCompElement(t, this.globalData, this);
      }),
      (CVContextData.prototype.duplicate = function () {
        var t = 2 * this._length,
          e = this.savedOp;
        (this.savedOp = createTypedArray("float32", t)), this.savedOp.set(e);
        var r = 0;
        for (r = this._length; r < t; r += 1)
          this.saved[r] = createTypedArray("float32", 16);
        this._length = t;
      }),
      (CVContextData.prototype.reset = function () {
        (this.cArrPos = 0), this.cTr.reset(), (this.cO = 1);
      }),
      (ShapeTransformManager.prototype = {
        addTransformSequence: function (t) {
          var e,
            r = t.length,
            i = "_";
          for (e = 0; e < r; e += 1) i += t[e].transform.key + "_";
          var s = this.sequences[i];
          return (
            s ||
              ((s = {
                transforms: [].concat(t),
                finalTransform: new Matrix(),
                _mdf: !1,
              }),
              (this.sequences[i] = s),
              this.sequenceList.push(s)),
            s
          );
        },
        processSequence: function (t, e) {
          for (var r, i = 0, s = t.transforms.length, a = e; i < s && !e; ) {
            if (t.transforms[i].transform.mProps._mdf) {
              a = !0;
              break;
            }
            i += 1;
          }
          if (a)
            for (t.finalTransform.reset(), i = s - 1; i >= 0; i -= 1)
              (r = t.transforms[i].transform.mProps.v.props),
                t.finalTransform.transform(
                  r[0],
                  r[1],
                  r[2],
                  r[3],
                  r[4],
                  r[5],
                  r[6],
                  r[7],
                  r[8],
                  r[9],
                  r[10],
                  r[11],
                  r[12],
                  r[13],
                  r[14],
                  r[15]
                );
          t._mdf = a;
        },
        processSequences: function (t) {
          var e,
            r = this.sequenceList.length;
          for (e = 0; e < r; e += 1)
            this.processSequence(this.sequenceList[e], t);
        },
        getNewKey: function () {
          return (
            (this.transform_key_count += 1), "_" + this.transform_key_count
          );
        },
      }),
      (CVEffects.prototype.renderFrame = function () {}),
      (CVMaskElement.prototype.renderFrame = function () {
        if (this.hasMasks) {
          var t,
            e,
            r,
            i,
            s = this.element.finalTransform.mat,
            a = this.element.canvasContext,
            n = this.masksProperties.length;
          for (a.beginPath(), t = 0; t < n; t += 1)
            if ("n" !== this.masksProperties[t].mode) {
              var o;
              this.masksProperties[t].inv &&
                (a.moveTo(0, 0),
                a.lineTo(this.element.globalData.compSize.w, 0),
                a.lineTo(
                  this.element.globalData.compSize.w,
                  this.element.globalData.compSize.h
                ),
                a.lineTo(0, this.element.globalData.compSize.h),
                a.lineTo(0, 0)),
                (i = this.viewData[t].v),
                (e = s.applyToPointArray(i.v[0][0], i.v[0][1], 0)),
                a.moveTo(e[0], e[1]);
              var h = i._length;
              for (o = 1; o < h; o += 1)
                (r = s.applyToTriplePoints(i.o[o - 1], i.i[o], i.v[o])),
                  a.bezierCurveTo(r[0], r[1], r[2], r[3], r[4], r[5]);
              (r = s.applyToTriplePoints(i.o[o - 1], i.i[0], i.v[0])),
                a.bezierCurveTo(r[0], r[1], r[2], r[3], r[4], r[5]);
            }
          this.element.globalData.renderer.save(!0), a.clip();
        }
      }),
      (CVMaskElement.prototype.getMaskProperty =
        MaskElement.prototype.getMaskProperty),
      (CVMaskElement.prototype.destroy = function () {
        this.element = null;
      }),
      (CVBaseElement.prototype = {
        createElements: function () {},
        initRendererElement: function () {},
        createContainerElements: function () {
          (this.canvasContext = this.globalData.canvasContext),
            (this.renderableEffectsManager = new CVEffects(this));
        },
        createContent: function () {},
        setBlendMode: function () {
          var t = this.globalData;
          if (t.blendMode !== this.data.bm) {
            t.blendMode = this.data.bm;
            var e = getBlendMode(this.data.bm);
            t.canvasContext.globalCompositeOperation = e;
          }
        },
        createRenderableComponents: function () {
          this.maskManager = new CVMaskElement(this.data, this);
        },
        hideElement: function () {
          this.hidden ||
            (this.isInRange && !this.isTransparent) ||
            (this.hidden = !0);
        },
        showElement: function () {
          this.isInRange &&
            !this.isTransparent &&
            ((this.hidden = !1),
            (this._isFirstFrame = !0),
            (this.maskManager._isFirstFrame = !0));
        },
        renderFrame: function () {
          if (!this.hidden && !this.data.hd) {
            this.renderTransform(),
              this.renderRenderable(),
              this.setBlendMode();
            var t = 0 === this.data.ty;
            this.globalData.renderer.save(t),
              this.globalData.renderer.ctxTransform(
                this.finalTransform.mat.props
              ),
              this.globalData.renderer.ctxOpacity(
                this.finalTransform.mProp.o.v
              ),
              this.renderInnerContent(),
              this.globalData.renderer.restore(t),
              this.maskManager.hasMasks && this.globalData.renderer.restore(!0),
              this._isFirstFrame && (this._isFirstFrame = !1);
          }
        },
        destroy: function () {
          (this.canvasContext = null),
            (this.data = null),
            (this.globalData = null),
            this.maskManager.destroy();
        },
        mHelper: new Matrix(),
      }),
      (CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement),
      (CVBaseElement.prototype.show = CVBaseElement.prototype.showElement),
      (CVShapeData.prototype.setAsAnimated =
        SVGShapeData.prototype.setAsAnimated),
      extendPrototype(
        [
          BaseElement,
          TransformElement,
          CVBaseElement,
          IShapeElement,
          HierarchyElement,
          FrameElement,
          RenderableElement,
        ],
        CVShapeElement
      ),
      (CVShapeElement.prototype.initElement =
        RenderableDOMElement.prototype.initElement),
      (CVShapeElement.prototype.transformHelper = { opacity: 1, _opMdf: !1 }),
      (CVShapeElement.prototype.dashResetter = []),
      (CVShapeElement.prototype.createContent = function () {
        this.searchShapes(
          this.shapesData,
          this.itemsData,
          this.prevViewData,
          !0,
          []
        );
      }),
      (CVShapeElement.prototype.createStyleElement = function (t, e) {
        var r = {
            data: t,
            type: t.ty,
            preTransforms: this.transformsManager.addTransformSequence(e),
            transforms: [],
            elements: [],
            closed: !0 === t.hd,
          },
          i = {};
        if (
          ("fl" === t.ty || "st" === t.ty
            ? ((i.c = PropertyFactory.getProp(this, t.c, 1, 255, this)),
              i.c.k ||
                (r.co =
                  "rgb(" +
                  bmFloor(i.c.v[0]) +
                  "," +
                  bmFloor(i.c.v[1]) +
                  "," +
                  bmFloor(i.c.v[2]) +
                  ")"))
            : ("gf" !== t.ty && "gs" !== t.ty) ||
              ((i.s = PropertyFactory.getProp(this, t.s, 1, null, this)),
              (i.e = PropertyFactory.getProp(this, t.e, 1, null, this)),
              (i.h = PropertyFactory.getProp(
                this,
                t.h || { k: 0 },
                0,
                0.01,
                this
              )),
              (i.a = PropertyFactory.getProp(
                this,
                t.a || { k: 0 },
                0,
                degToRads,
                this
              )),
              (i.g = new GradientProperty(this, t.g, this))),
          (i.o = PropertyFactory.getProp(this, t.o, 0, 0.01, this)),
          "st" === t.ty || "gs" === t.ty)
        ) {
          if (
            ((r.lc = lineCapEnum[t.lc || 2]),
            (r.lj = lineJoinEnum[t.lj || 2]),
            1 == t.lj && (r.ml = t.ml),
            (i.w = PropertyFactory.getProp(this, t.w, 0, null, this)),
            i.w.k || (r.wi = i.w.v),
            t.d)
          ) {
            var s = new DashProperty(this, t.d, "canvas", this);
            (i.d = s),
              i.d.k || ((r.da = i.d.dashArray), (r.do = i.d.dashoffset[0]));
          }
        } else r.r = 2 === t.r ? "evenodd" : "nonzero";
        return this.stylesList.push(r), (i.style = r), i;
      }),
      (CVShapeElement.prototype.createGroupElement = function () {
        return { it: [], prevViewData: [] };
      }),
      (CVShapeElement.prototype.createTransformElement = function (t) {
        return {
          transform: {
            opacity: 1,
            _opMdf: !1,
            key: this.transformsManager.getNewKey(),
            op: PropertyFactory.getProp(this, t.o, 0, 0.01, this),
            mProps: TransformPropertyFactory.getTransformProperty(
              this,
              t,
              this
            ),
          },
        };
      }),
      (CVShapeElement.prototype.createShapeElement = function (t) {
        var e = new CVShapeData(
          this,
          t,
          this.stylesList,
          this.transformsManager
        );
        return this.shapes.push(e), this.addShapeToModifiers(e), e;
      }),
      (CVShapeElement.prototype.reloadShapes = function () {
        var t;
        this._isFirstFrame = !0;
        var e = this.itemsData.length;
        for (t = 0; t < e; t += 1) this.prevViewData[t] = this.itemsData[t];
        for (
          this.searchShapes(
            this.shapesData,
            this.itemsData,
            this.prevViewData,
            !0,
            []
          ),
            e = this.dynamicProperties.length,
            t = 0;
          t < e;
          t += 1
        )
          this.dynamicProperties[t].getValue();
        this.renderModifiers(),
          this.transformsManager.processSequences(this._isFirstFrame);
      }),
      (CVShapeElement.prototype.addTransformToStyleList = function (t) {
        var e,
          r = this.stylesList.length;
        for (e = 0; e < r; e += 1)
          this.stylesList[e].closed || this.stylesList[e].transforms.push(t);
      }),
      (CVShapeElement.prototype.removeTransformFromStyleList = function () {
        var t,
          e = this.stylesList.length;
        for (t = 0; t < e; t += 1)
          this.stylesList[t].closed || this.stylesList[t].transforms.pop();
      }),
      (CVShapeElement.prototype.closeStyles = function (t) {
        var e,
          r = t.length;
        for (e = 0; e < r; e += 1) t[e].closed = !0;
      }),
      (CVShapeElement.prototype.searchShapes = function (t, e, r, i, s) {
        var a,
          n,
          o,
          h,
          l,
          p,
          f = t.length - 1,
          m = [],
          c = [],
          d = [].concat(s);
        for (a = f; a >= 0; a -= 1) {
          if (
            ((h = this.searchProcessedElement(t[a]))
              ? (e[a] = r[h - 1])
              : (t[a]._shouldRender = i),
            "fl" === t[a].ty ||
              "st" === t[a].ty ||
              "gf" === t[a].ty ||
              "gs" === t[a].ty)
          )
            h
              ? (e[a].style.closed = !1)
              : (e[a] = this.createStyleElement(t[a], d)),
              m.push(e[a].style);
          else if ("gr" === t[a].ty) {
            if (h)
              for (o = e[a].it.length, n = 0; n < o; n += 1)
                e[a].prevViewData[n] = e[a].it[n];
            else e[a] = this.createGroupElement(t[a]);
            this.searchShapes(t[a].it, e[a].it, e[a].prevViewData, i, d);
          } else
            "tr" === t[a].ty
              ? (h || ((p = this.createTransformElement(t[a])), (e[a] = p)),
                d.push(e[a]),
                this.addTransformToStyleList(e[a]))
              : "sh" === t[a].ty ||
                "rc" === t[a].ty ||
                "el" === t[a].ty ||
                "sr" === t[a].ty
              ? h || (e[a] = this.createShapeElement(t[a]))
              : "tm" === t[a].ty || "rd" === t[a].ty || "pb" === t[a].ty
              ? (h
                  ? ((l = e[a]).closed = !1)
                  : ((l = ShapeModifiers.getModifier(t[a].ty)).init(this, t[a]),
                    (e[a] = l),
                    this.shapeModifiers.push(l)),
                c.push(l))
              : "rp" === t[a].ty &&
                (h
                  ? ((l = e[a]).closed = !0)
                  : ((l = ShapeModifiers.getModifier(t[a].ty)),
                    (e[a] = l),
                    l.init(this, t, a, e),
                    this.shapeModifiers.push(l),
                    (i = !1)),
                c.push(l));
          this.addProcessedElement(t[a], a + 1);
        }
        for (
          this.removeTransformFromStyleList(),
            this.closeStyles(m),
            f = c.length,
            a = 0;
          a < f;
          a += 1
        )
          c[a].closed = !0;
      }),
      (CVShapeElement.prototype.renderInnerContent = function () {
        (this.transformHelper.opacity = 1),
          (this.transformHelper._opMdf = !1),
          this.renderModifiers(),
          this.transformsManager.processSequences(this._isFirstFrame),
          this.renderShape(
            this.transformHelper,
            this.shapesData,
            this.itemsData,
            !0
          );
      }),
      (CVShapeElement.prototype.renderShapeTransform = function (t, e) {
        (t._opMdf || e.op._mdf || this._isFirstFrame) &&
          ((e.opacity = t.opacity), (e.opacity *= e.op.v), (e._opMdf = !0));
      }),
      (CVShapeElement.prototype.drawLayer = function () {
        var t,
          e,
          r,
          i,
          s,
          a,
          n,
          o,
          h,
          l = this.stylesList.length,
          p = this.globalData.renderer,
          f = this.globalData.canvasContext;
        for (t = 0; t < l; t += 1)
          if (
            (("st" !== (o = (h = this.stylesList[t]).type) && "gs" !== o) ||
              0 !== h.wi) &&
            h.data._shouldRender &&
            0 !== h.coOp &&
            0 !== this.globalData.currentGlobalAlpha
          ) {
            for (
              p.save(),
                a = h.elements,
                "st" === o || "gs" === o
                  ? ((f.strokeStyle = "st" === o ? h.co : h.grd),
                    (f.lineWidth = h.wi),
                    (f.lineCap = h.lc),
                    (f.lineJoin = h.lj),
                    (f.miterLimit = h.ml || 0))
                  : (f.fillStyle = "fl" === o ? h.co : h.grd),
                p.ctxOpacity(h.coOp),
                "st" !== o && "gs" !== o && f.beginPath(),
                p.ctxTransform(h.preTransforms.finalTransform.props),
                r = a.length,
                e = 0;
              e < r;
              e += 1
            ) {
              for (
                ("st" !== o && "gs" !== o) ||
                  (f.beginPath(),
                  h.da && (f.setLineDash(h.da), (f.lineDashOffset = h.do))),
                  s = (n = a[e].trNodes).length,
                  i = 0;
                i < s;
                i += 1
              )
                "m" === n[i].t
                  ? f.moveTo(n[i].p[0], n[i].p[1])
                  : "c" === n[i].t
                  ? f.bezierCurveTo(
                      n[i].pts[0],
                      n[i].pts[1],
                      n[i].pts[2],
                      n[i].pts[3],
                      n[i].pts[4],
                      n[i].pts[5]
                    )
                  : f.closePath();
              ("st" !== o && "gs" !== o) ||
                (f.stroke(), h.da && f.setLineDash(this.dashResetter));
            }
            "st" !== o && "gs" !== o && f.fill(h.r), p.restore();
          }
      }),
      (CVShapeElement.prototype.renderShape = function (t, e, r, i) {
        var s, a;
        for (a = t, s = e.length - 1; s >= 0; s -= 1)
          "tr" === e[s].ty
            ? ((a = r[s].transform), this.renderShapeTransform(t, a))
            : "sh" === e[s].ty ||
              "el" === e[s].ty ||
              "rc" === e[s].ty ||
              "sr" === e[s].ty
            ? this.renderPath(e[s], r[s])
            : "fl" === e[s].ty
            ? this.renderFill(e[s], r[s], a)
            : "st" === e[s].ty
            ? this.renderStroke(e[s], r[s], a)
            : "gf" === e[s].ty || "gs" === e[s].ty
            ? this.renderGradientFill(e[s], r[s], a)
            : "gr" === e[s].ty
            ? this.renderShape(a, e[s].it, r[s].it)
            : e[s].ty;
        i && this.drawLayer();
      }),
      (CVShapeElement.prototype.renderStyledShape = function (t, e) {
        if (this._isFirstFrame || e._mdf || t.transforms._mdf) {
          var r,
            i,
            s,
            a = t.trNodes,
            n = e.paths,
            o = n._length;
          a.length = 0;
          var h = t.transforms.finalTransform;
          for (s = 0; s < o; s += 1) {
            var l = n.shapes[s];
            if (l && l.v) {
              for (i = l._length, r = 1; r < i; r += 1)
                1 === r &&
                  a.push({
                    t: "m",
                    p: h.applyToPointArray(l.v[0][0], l.v[0][1], 0),
                  }),
                  a.push({
                    t: "c",
                    pts: h.applyToTriplePoints(l.o[r - 1], l.i[r], l.v[r]),
                  });
              1 === i &&
                a.push({
                  t: "m",
                  p: h.applyToPointArray(l.v[0][0], l.v[0][1], 0),
                }),
                l.c &&
                  i &&
                  (a.push({
                    t: "c",
                    pts: h.applyToTriplePoints(l.o[r - 1], l.i[0], l.v[0]),
                  }),
                  a.push({ t: "z" }));
            }
          }
          t.trNodes = a;
        }
      }),
      (CVShapeElement.prototype.renderPath = function (t, e) {
        if (!0 !== t.hd && t._shouldRender) {
          var r,
            i = e.styledShapes.length;
          for (r = 0; r < i; r += 1)
            this.renderStyledShape(e.styledShapes[r], e.sh);
        }
      }),
      (CVShapeElement.prototype.renderFill = function (t, e, r) {
        var i = e.style;
        (e.c._mdf || this._isFirstFrame) &&
          (i.co =
            "rgb(" +
            bmFloor(e.c.v[0]) +
            "," +
            bmFloor(e.c.v[1]) +
            "," +
            bmFloor(e.c.v[2]) +
            ")"),
          (e.o._mdf || r._opMdf || this._isFirstFrame) &&
            (i.coOp = e.o.v * r.opacity);
      }),
      (CVShapeElement.prototype.renderGradientFill = function (t, e, r) {
        var i,
          s = e.style;
        if (
          !s.grd ||
          e.g._mdf ||
          e.s._mdf ||
          e.e._mdf ||
          (1 !== t.t && (e.h._mdf || e.a._mdf))
        ) {
          var a,
            n = this.globalData.canvasContext,
            o = e.s.v,
            h = e.e.v;
          if (1 === t.t) i = n.createLinearGradient(o[0], o[1], h[0], h[1]);
          else {
            var l = Math.sqrt(
                Math.pow(o[0] - h[0], 2) + Math.pow(o[1] - h[1], 2)
              ),
              p = Math.atan2(h[1] - o[1], h[0] - o[0]),
              f = e.h.v;
            f >= 1 ? (f = 0.99) : f <= -1 && (f = -0.99);
            var m = l * f,
              c = Math.cos(p + e.a.v) * m + o[0],
              d = Math.sin(p + e.a.v) * m + o[1];
            i = n.createRadialGradient(c, d, 0, o[0], o[1], l);
          }
          var u = t.g.p,
            y = e.g.c,
            g = 1;
          for (a = 0; a < u; a += 1)
            e.g._hasOpacity && e.g._collapsable && (g = e.g.o[2 * a + 1]),
              i.addColorStop(
                y[4 * a] / 100,
                "rgba(" +
                  y[4 * a + 1] +
                  "," +
                  y[4 * a + 2] +
                  "," +
                  y[4 * a + 3] +
                  "," +
                  g +
                  ")"
              );
          s.grd = i;
        }
        s.coOp = e.o.v * r.opacity;
      }),
      (CVShapeElement.prototype.renderStroke = function (t, e, r) {
        var i = e.style,
          s = e.d;
        s &&
          (s._mdf || this._isFirstFrame) &&
          ((i.da = s.dashArray), (i.do = s.dashoffset[0])),
          (e.c._mdf || this._isFirstFrame) &&
            (i.co =
              "rgb(" +
              bmFloor(e.c.v[0]) +
              "," +
              bmFloor(e.c.v[1]) +
              "," +
              bmFloor(e.c.v[2]) +
              ")"),
          (e.o._mdf || r._opMdf || this._isFirstFrame) &&
            (i.coOp = e.o.v * r.opacity),
          (e.w._mdf || this._isFirstFrame) && (i.wi = e.w.v);
      }),
      (CVShapeElement.prototype.destroy = function () {
        (this.shapesData = null),
          (this.globalData = null),
          (this.canvasContext = null),
          (this.stylesList.length = 0),
          (this.itemsData.length = 0);
      }),
      extendPrototype(
        [
          BaseElement,
          TransformElement,
          CVBaseElement,
          HierarchyElement,
          FrameElement,
          RenderableElement,
          ITextElement,
        ],
        CVTextElement
      ),
      (CVTextElement.prototype.tHelper = createTag("canvas").getContext("2d")),
      (CVTextElement.prototype.buildNewText = function () {
        var t = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(t.l ? t.l.length : 0);
        var e = !1;
        t.fc
          ? ((e = !0), (this.values.fill = this.buildColor(t.fc)))
          : (this.values.fill = "rgba(0,0,0,0)"),
          (this.fill = e);
        var r = !1;
        t.sc &&
          ((r = !0),
          (this.values.stroke = this.buildColor(t.sc)),
          (this.values.sWidth = t.sw));
        var i,
          s,
          a,
          n,
          o,
          h,
          l,
          p,
          f,
          m,
          c,
          d,
          u = this.globalData.fontManager.getFontByName(t.f),
          y = t.l,
          g = this.mHelper;
        (this.stroke = r),
          (this.values.fValue =
            t.finalSize +
            "px " +
            this.globalData.fontManager.getFontByName(t.f).fFamily),
          (s = t.finalText.length);
        var v = this.data.singleShape,
          b = 0.001 * t.tr * t.finalSize,
          P = 0,
          E = 0,
          x = !0,
          S = 0;
        for (i = 0; i < s; i += 1) {
          (n =
            ((a = this.globalData.fontManager.getCharData(
              t.finalText[i],
              u.fStyle,
              this.globalData.fontManager.getFontByName(t.f).fFamily
            )) &&
              a.data) ||
            {}),
            g.reset(),
            v &&
              y[i].n &&
              ((P = -b), (E += t.yOffset), (E += x ? 1 : 0), (x = !1)),
            (f = (l = n.shapes ? n.shapes[0].it : []).length),
            g.scale(t.finalSize / 100, t.finalSize / 100),
            v && this.applyTextPropertiesToMatrix(t, g, y[i].line, P, E),
            (c = createSizedArray(f - 1));
          var _ = 0;
          for (p = 0; p < f; p += 1)
            if ("sh" === l[p].ty) {
              for (
                h = l[p].ks.k.i.length, m = l[p].ks.k, d = [], o = 1;
                o < h;
                o += 1
              )
                1 === o &&
                  d.push(
                    g.applyToX(m.v[0][0], m.v[0][1], 0),
                    g.applyToY(m.v[0][0], m.v[0][1], 0)
                  ),
                  d.push(
                    g.applyToX(m.o[o - 1][0], m.o[o - 1][1], 0),
                    g.applyToY(m.o[o - 1][0], m.o[o - 1][1], 0),
                    g.applyToX(m.i[o][0], m.i[o][1], 0),
                    g.applyToY(m.i[o][0], m.i[o][1], 0),
                    g.applyToX(m.v[o][0], m.v[o][1], 0),
                    g.applyToY(m.v[o][0], m.v[o][1], 0)
                  );
              d.push(
                g.applyToX(m.o[o - 1][0], m.o[o - 1][1], 0),
                g.applyToY(m.o[o - 1][0], m.o[o - 1][1], 0),
                g.applyToX(m.i[0][0], m.i[0][1], 0),
                g.applyToY(m.i[0][0], m.i[0][1], 0),
                g.applyToX(m.v[0][0], m.v[0][1], 0),
                g.applyToY(m.v[0][0], m.v[0][1], 0)
              ),
                (c[_] = d),
                (_ += 1);
            }
          v && ((P += y[i].l), (P += b)),
            this.textSpans[S]
              ? (this.textSpans[S].elem = c)
              : (this.textSpans[S] = { elem: c }),
            (S += 1);
        }
      }),
      (CVTextElement.prototype.renderInnerContent = function () {
        var t,
          e,
          r,
          i,
          s,
          a,
          n = this.canvasContext;
        (n.font = this.values.fValue),
          (n.lineCap = "butt"),
          (n.lineJoin = "miter"),
          (n.miterLimit = 4),
          this.data.singleShape ||
            this.textAnimator.getMeasures(
              this.textProperty.currentData,
              this.lettersChangedFlag
            );
        var o,
          h = this.textAnimator.renderedLetters,
          l = this.textProperty.currentData.l;
        e = l.length;
        var p,
          f,
          m = null,
          c = null,
          d = null;
        for (t = 0; t < e; t += 1)
          if (!l[t].n) {
            if (
              ((o = h[t]) &&
                (this.globalData.renderer.save(),
                this.globalData.renderer.ctxTransform(o.p),
                this.globalData.renderer.ctxOpacity(o.o)),
              this.fill)
            ) {
              for (
                o && o.fc
                  ? m !== o.fc && ((m = o.fc), (n.fillStyle = o.fc))
                  : m !== this.values.fill &&
                    ((m = this.values.fill), (n.fillStyle = this.values.fill)),
                  i = (p = this.textSpans[t].elem).length,
                  this.globalData.canvasContext.beginPath(),
                  r = 0;
                r < i;
                r += 1
              )
                for (
                  a = (f = p[r]).length,
                    this.globalData.canvasContext.moveTo(f[0], f[1]),
                    s = 2;
                  s < a;
                  s += 6
                )
                  this.globalData.canvasContext.bezierCurveTo(
                    f[s],
                    f[s + 1],
                    f[s + 2],
                    f[s + 3],
                    f[s + 4],
                    f[s + 5]
                  );
              this.globalData.canvasContext.closePath(),
                this.globalData.canvasContext.fill();
            }
            if (this.stroke) {
              for (
                o && o.sw
                  ? d !== o.sw && ((d = o.sw), (n.lineWidth = o.sw))
                  : d !== this.values.sWidth &&
                    ((d = this.values.sWidth),
                    (n.lineWidth = this.values.sWidth)),
                  o && o.sc
                    ? c !== o.sc && ((c = o.sc), (n.strokeStyle = o.sc))
                    : c !== this.values.stroke &&
                      ((c = this.values.stroke),
                      (n.strokeStyle = this.values.stroke)),
                  i = (p = this.textSpans[t].elem).length,
                  this.globalData.canvasContext.beginPath(),
                  r = 0;
                r < i;
                r += 1
              )
                for (
                  a = (f = p[r]).length,
                    this.globalData.canvasContext.moveTo(f[0], f[1]),
                    s = 2;
                  s < a;
                  s += 6
                )
                  this.globalData.canvasContext.bezierCurveTo(
                    f[s],
                    f[s + 1],
                    f[s + 2],
                    f[s + 3],
                    f[s + 4],
                    f[s + 5]
                  );
              this.globalData.canvasContext.closePath(),
                this.globalData.canvasContext.stroke();
            }
            o && this.globalData.renderer.restore();
          }
      }),
      extendPrototype(
        [
          BaseElement,
          TransformElement,
          CVBaseElement,
          HierarchyElement,
          FrameElement,
          RenderableElement,
        ],
        CVImageElement
      ),
      (CVImageElement.prototype.initElement =
        SVGShapeElement.prototype.initElement),
      (CVImageElement.prototype.prepareFrame =
        IImageElement.prototype.prepareFrame),
      (CVImageElement.prototype.createContent = function () {
        if (
          this.img.width &&
          (this.assetData.w !== this.img.width ||
            this.assetData.h !== this.img.height)
        ) {
          var t = createTag("canvas");
          (t.width = this.assetData.w), (t.height = this.assetData.h);
          var e,
            r,
            i = t.getContext("2d"),
            s = this.img.width,
            a = this.img.height,
            n = s / a,
            o = this.assetData.w / this.assetData.h,
            h =
              this.assetData.pr ||
              this.globalData.renderConfig.imagePreserveAspectRatio;
          (n > o && "xMidYMid slice" === h) || (n < o && "xMidYMid slice" !== h)
            ? (e = (r = a) * o)
            : (r = (e = s) / o),
            i.drawImage(
              this.img,
              (s - e) / 2,
              (a - r) / 2,
              e,
              r,
              0,
              0,
              this.assetData.w,
              this.assetData.h
            ),
            (this.img = t);
        }
      }),
      (CVImageElement.prototype.renderInnerContent = function () {
        this.canvasContext.drawImage(this.img, 0, 0);
      }),
      (CVImageElement.prototype.destroy = function () {
        this.img = null;
      }),
      extendPrototype(
        [
          BaseElement,
          TransformElement,
          CVBaseElement,
          HierarchyElement,
          FrameElement,
          RenderableElement,
        ],
        CVSolidElement
      ),
      (CVSolidElement.prototype.initElement =
        SVGShapeElement.prototype.initElement),
      (CVSolidElement.prototype.prepareFrame =
        IImageElement.prototype.prepareFrame),
      (CVSolidElement.prototype.renderInnerContent = function () {
        var t = this.canvasContext;
        (t.fillStyle = this.data.sc),
          t.fillRect(0, 0, this.data.sw, this.data.sh);
      }),
      extendPrototype([BaseRenderer], CanvasRendererBase),
      (CanvasRendererBase.prototype.createShape = function (t) {
        return new CVShapeElement(t, this.globalData, this);
      }),
      (CanvasRendererBase.prototype.createText = function (t) {
        return new CVTextElement(t, this.globalData, this);
      }),
      (CanvasRendererBase.prototype.createImage = function (t) {
        return new CVImageElement(t, this.globalData, this);
      }),
      (CanvasRendererBase.prototype.createSolid = function (t) {
        return new CVSolidElement(t, this.globalData, this);
      }),
      (CanvasRendererBase.prototype.createNull =
        SVGRenderer.prototype.createNull),
      (CanvasRendererBase.prototype.ctxTransform = function (t) {
        if (
          1 !== t[0] ||
          0 !== t[1] ||
          0 !== t[4] ||
          1 !== t[5] ||
          0 !== t[12] ||
          0 !== t[13]
        )
          if (this.renderConfig.clearCanvas) {
            this.transformMat.cloneFromProps(t);
            var e = this.contextData.cTr.props;
            this.transformMat.transform(
              e[0],
              e[1],
              e[2],
              e[3],
              e[4],
              e[5],
              e[6],
              e[7],
              e[8],
              e[9],
              e[10],
              e[11],
              e[12],
              e[13],
              e[14],
              e[15]
            ),
              this.contextData.cTr.cloneFromProps(this.transformMat.props);
            var r = this.contextData.cTr.props;
            this.canvasContext.setTransform(
              r[0],
              r[1],
              r[4],
              r[5],
              r[12],
              r[13]
            );
          } else
            this.canvasContext.transform(t[0], t[1], t[4], t[5], t[12], t[13]);
      }),
      (CanvasRendererBase.prototype.ctxOpacity = function (t) {
        if (!this.renderConfig.clearCanvas)
          return (
            (this.canvasContext.globalAlpha *= t < 0 ? 0 : t),
            void (this.globalData.currentGlobalAlpha = this.contextData.cO)
          );
        (this.contextData.cO *= t < 0 ? 0 : t),
          this.globalData.currentGlobalAlpha !== this.contextData.cO &&
            ((this.canvasContext.globalAlpha = this.contextData.cO),
            (this.globalData.currentGlobalAlpha = this.contextData.cO));
      }),
      (CanvasRendererBase.prototype.reset = function () {
        this.renderConfig.clearCanvas
          ? this.contextData.reset()
          : this.canvasContext.restore();
      }),
      (CanvasRendererBase.prototype.save = function (t) {
        if (this.renderConfig.clearCanvas) {
          t && this.canvasContext.save();
          var e,
            r = this.contextData.cTr.props;
          this.contextData._length <= this.contextData.cArrPos &&
            this.contextData.duplicate();
          var i = this.contextData.saved[this.contextData.cArrPos];
          for (e = 0; e < 16; e += 1) i[e] = r[e];
          (this.contextData.savedOp[this.contextData.cArrPos] =
            this.contextData.cO),
            (this.contextData.cArrPos += 1);
        } else this.canvasContext.save();
      }),
      (CanvasRendererBase.prototype.restore = function (t) {
        if (this.renderConfig.clearCanvas) {
          t &&
            (this.canvasContext.restore(),
            (this.globalData.blendMode = "source-over")),
            (this.contextData.cArrPos -= 1);
          var e,
            r = this.contextData.saved[this.contextData.cArrPos],
            i = this.contextData.cTr.props;
          for (e = 0; e < 16; e += 1) i[e] = r[e];
          this.canvasContext.setTransform(r[0], r[1], r[4], r[5], r[12], r[13]),
            (r = this.contextData.savedOp[this.contextData.cArrPos]),
            (this.contextData.cO = r),
            this.globalData.currentGlobalAlpha !== r &&
              ((this.canvasContext.globalAlpha = r),
              (this.globalData.currentGlobalAlpha = r));
        } else this.canvasContext.restore();
      }),
      (CanvasRendererBase.prototype.configAnimation = function (t) {
        if (this.animationItem.wrapper) {
          this.animationItem.container = createTag("canvas");
          var e = this.animationItem.container.style;
          (e.width = "100%"), (e.height = "100%");
          var r = "0px 0px 0px";
          (e.transformOrigin = r),
            (e.mozTransformOrigin = r),
            (e.webkitTransformOrigin = r),
            (e["-webkit-transform"] = r),
            (e.contentVisibility = this.renderConfig.contentVisibility),
            this.animationItem.wrapper.appendChild(
              this.animationItem.container
            ),
            (this.canvasContext =
              this.animationItem.container.getContext("2d")),
            this.renderConfig.className &&
              this.animationItem.container.setAttribute(
                "class",
                this.renderConfig.className
              ),
            this.renderConfig.id &&
              this.animationItem.container.setAttribute(
                "id",
                this.renderConfig.id
              );
        } else this.canvasContext = this.renderConfig.context;
        (this.data = t),
          (this.layers = t.layers),
          (this.transformCanvas = {
            w: t.w,
            h: t.h,
            sx: 0,
            sy: 0,
            tx: 0,
            ty: 0,
          }),
          this.setupGlobalData(t, document.body),
          (this.globalData.canvasContext = this.canvasContext),
          (this.globalData.renderer = this),
          (this.globalData.isDashed = !1),
          (this.globalData.progressiveLoad = this.renderConfig.progressiveLoad),
          (this.globalData.transformCanvas = this.transformCanvas),
          (this.elements = createSizedArray(t.layers.length)),
          this.updateContainerSize();
      }),
      (CanvasRendererBase.prototype.updateContainerSize = function () {
        var t, e, r, i;
        if (
          (this.reset(),
          this.animationItem.wrapper && this.animationItem.container
            ? ((t = this.animationItem.wrapper.offsetWidth),
              (e = this.animationItem.wrapper.offsetHeight),
              this.animationItem.container.setAttribute(
                "width",
                t * this.renderConfig.dpr
              ),
              this.animationItem.container.setAttribute(
                "height",
                e * this.renderConfig.dpr
              ))
            : ((t = this.canvasContext.canvas.width * this.renderConfig.dpr),
              (e = this.canvasContext.canvas.height * this.renderConfig.dpr)),
          -1 !== this.renderConfig.preserveAspectRatio.indexOf("meet") ||
            -1 !== this.renderConfig.preserveAspectRatio.indexOf("slice"))
        ) {
          var s = this.renderConfig.preserveAspectRatio.split(" "),
            a = s[1] || "meet",
            n = s[0] || "xMidYMid",
            o = n.substr(0, 4),
            h = n.substr(4);
          (r = t / e),
            ((i = this.transformCanvas.w / this.transformCanvas.h) > r &&
              "meet" === a) ||
            (i < r && "slice" === a)
              ? ((this.transformCanvas.sx =
                  t / (this.transformCanvas.w / this.renderConfig.dpr)),
                (this.transformCanvas.sy =
                  t / (this.transformCanvas.w / this.renderConfig.dpr)))
              : ((this.transformCanvas.sx =
                  e / (this.transformCanvas.h / this.renderConfig.dpr)),
                (this.transformCanvas.sy =
                  e / (this.transformCanvas.h / this.renderConfig.dpr))),
            (this.transformCanvas.tx =
              "xMid" === o &&
              ((i < r && "meet" === a) || (i > r && "slice" === a))
                ? ((t - this.transformCanvas.w * (e / this.transformCanvas.h)) /
                    2) *
                  this.renderConfig.dpr
                : "xMax" === o &&
                  ((i < r && "meet" === a) || (i > r && "slice" === a))
                ? (t - this.transformCanvas.w * (e / this.transformCanvas.h)) *
                  this.renderConfig.dpr
                : 0),
            (this.transformCanvas.ty =
              "YMid" === h &&
              ((i > r && "meet" === a) || (i < r && "slice" === a))
                ? ((e - this.transformCanvas.h * (t / this.transformCanvas.w)) /
                    2) *
                  this.renderConfig.dpr
                : "YMax" === h &&
                  ((i > r && "meet" === a) || (i < r && "slice" === a))
                ? (e - this.transformCanvas.h * (t / this.transformCanvas.w)) *
                  this.renderConfig.dpr
                : 0);
        } else
          "none" === this.renderConfig.preserveAspectRatio
            ? ((this.transformCanvas.sx =
                t / (this.transformCanvas.w / this.renderConfig.dpr)),
              (this.transformCanvas.sy =
                e / (this.transformCanvas.h / this.renderConfig.dpr)),
              (this.transformCanvas.tx = 0),
              (this.transformCanvas.ty = 0))
            : ((this.transformCanvas.sx = this.renderConfig.dpr),
              (this.transformCanvas.sy = this.renderConfig.dpr),
              (this.transformCanvas.tx = 0),
              (this.transformCanvas.ty = 0));
        (this.transformCanvas.props = [
          this.transformCanvas.sx,
          0,
          0,
          0,
          0,
          this.transformCanvas.sy,
          0,
          0,
          0,
          0,
          1,
          0,
          this.transformCanvas.tx,
          this.transformCanvas.ty,
          0,
          1,
        ]),
          this.ctxTransform(this.transformCanvas.props),
          this.canvasContext.beginPath(),
          this.canvasContext.rect(
            0,
            0,
            this.transformCanvas.w,
            this.transformCanvas.h
          ),
          this.canvasContext.closePath(),
          this.canvasContext.clip(),
          this.renderFrame(this.renderedFrame, !0);
      }),
      (CanvasRendererBase.prototype.destroy = function () {
        var t;
        for (
          this.renderConfig.clearCanvas &&
            this.animationItem.wrapper &&
            (this.animationItem.wrapper.innerText = ""),
            t = (this.layers ? this.layers.length : 0) - 1;
          t >= 0;
          t -= 1
        )
          this.elements[t] && this.elements[t].destroy();
        (this.elements.length = 0),
          (this.globalData.canvasContext = null),
          (this.animationItem.container = null),
          (this.destroyed = !0);
      }),
      (CanvasRendererBase.prototype.renderFrame = function (t, e) {
        if (
          (this.renderedFrame !== t ||
            !0 !== this.renderConfig.clearCanvas ||
            e) &&
          !this.destroyed &&
          -1 !== t
        ) {
          var r;
          (this.renderedFrame = t),
            (this.globalData.frameNum = t - this.animationItem._isFirstFrame),
            (this.globalData.frameId += 1),
            (this.globalData._mdf = !this.renderConfig.clearCanvas || e),
            (this.globalData.projectInterface.currentFrame = t);
          var i = this.layers.length;
          for (this.completeLayers || this.checkLayers(t), r = 0; r < i; r += 1)
            (this.completeLayers || this.elements[r]) &&
              this.elements[r].prepareFrame(t - this.layers[r].st);
          if (this.globalData._mdf) {
            for (
              !0 === this.renderConfig.clearCanvas
                ? this.canvasContext.clearRect(
                    0,
                    0,
                    this.transformCanvas.w,
                    this.transformCanvas.h
                  )
                : this.save(),
                r = i - 1;
              r >= 0;
              r -= 1
            )
              (this.completeLayers || this.elements[r]) &&
                this.elements[r].renderFrame();
            !0 !== this.renderConfig.clearCanvas && this.restore();
          }
        }
      }),
      (CanvasRendererBase.prototype.buildItem = function (t) {
        var e = this.elements;
        if (!e[t] && 99 !== this.layers[t].ty) {
          var r = this.createItem(this.layers[t], this, this.globalData);
          (e[t] = r), r.initExpressions();
        }
      }),
      (CanvasRendererBase.prototype.checkPendingElements = function () {
        for (; this.pendingElements.length; ) {
          this.pendingElements.pop().checkParenting();
        }
      }),
      (CanvasRendererBase.prototype.hide = function () {
        this.animationItem.container.style.display = "none";
      }),
      (CanvasRendererBase.prototype.show = function () {
        this.animationItem.container.style.display = "block";
      }),
      extendPrototype(
        [CanvasRendererBase, ICompElement, CVBaseElement],
        CVCompElement
      ),
      (CVCompElement.prototype.renderInnerContent = function () {
        var t,
          e = this.canvasContext;
        for (
          e.beginPath(),
            e.moveTo(0, 0),
            e.lineTo(this.data.w, 0),
            e.lineTo(this.data.w, this.data.h),
            e.lineTo(0, this.data.h),
            e.lineTo(0, 0),
            e.clip(),
            t = this.layers.length - 1;
          t >= 0;
          t -= 1
        )
          (this.completeLayers || this.elements[t]) &&
            this.elements[t].renderFrame();
      }),
      (CVCompElement.prototype.destroy = function () {
        var t;
        for (t = this.layers.length - 1; t >= 0; t -= 1)
          this.elements[t] && this.elements[t].destroy();
        (this.layers = null), (this.elements = null);
      }),
      (CVCompElement.prototype.createComp = function (t) {
        return new CVCompElement(t, this.globalData, this);
      }),
      extendPrototype([CanvasRendererBase], CanvasRenderer),
      (CanvasRenderer.prototype.createComp = function (t) {
        return new CVCompElement(t, this.globalData, this);
      }),
      (HBaseElement.prototype = {
        checkBlendMode: function () {},
        initRendererElement: function () {
          (this.baseElement = createTag(this.data.tg || "div")),
            this.data.hasMask
              ? ((this.svgElement = createNS("svg")),
                (this.layerElement = createNS("g")),
                (this.maskedElement = this.layerElement),
                this.svgElement.appendChild(this.layerElement),
                this.baseElement.appendChild(this.svgElement))
              : (this.layerElement = this.baseElement),
            styleDiv(this.baseElement);
        },
        createContainerElements: function () {
          (this.renderableEffectsManager = new CVEffects(this)),
            (this.transformedElement = this.baseElement),
            (this.maskedElement = this.layerElement),
            this.data.ln && this.layerElement.setAttribute("id", this.data.ln),
            this.data.cl &&
              this.layerElement.setAttribute("class", this.data.cl),
            0 !== this.data.bm && this.setBlendMode();
        },
        renderElement: function () {
          var t = this.transformedElement ? this.transformedElement.style : {};
          if (this.finalTransform._matMdf) {
            var e = this.finalTransform.mat.toCSS();
            (t.transform = e), (t.webkitTransform = e);
          }
          this.finalTransform._opMdf &&
            (t.opacity = this.finalTransform.mProp.o.v);
        },
        renderFrame: function () {
          this.data.hd ||
            this.hidden ||
            (this.renderTransform(),
            this.renderRenderable(),
            this.renderElement(),
            this.renderInnerContent(),
            this._isFirstFrame && (this._isFirstFrame = !1));
        },
        destroy: function () {
          (this.layerElement = null),
            (this.transformedElement = null),
            this.matteElement && (this.matteElement = null),
            this.maskManager &&
              (this.maskManager.destroy(), (this.maskManager = null));
        },
        createRenderableComponents: function () {
          this.maskManager = new MaskElement(this.data, this, this.globalData);
        },
        addEffects: function () {},
        setMatte: function () {},
      }),
      (HBaseElement.prototype.getBaseElement =
        SVGBaseElement.prototype.getBaseElement),
      (HBaseElement.prototype.destroyBaseElement =
        HBaseElement.prototype.destroy),
      (HBaseElement.prototype.buildElementParenting =
        BaseRenderer.prototype.buildElementParenting),
      extendPrototype(
        [
          BaseElement,
          TransformElement,
          HBaseElement,
          HierarchyElement,
          FrameElement,
          RenderableDOMElement,
        ],
        HSolidElement
      ),
      (HSolidElement.prototype.createContent = function () {
        var t;
        this.data.hasMask
          ? ((t = createNS("rect")).setAttribute("width", this.data.sw),
            t.setAttribute("height", this.data.sh),
            t.setAttribute("fill", this.data.sc),
            this.svgElement.setAttribute("width", this.data.sw),
            this.svgElement.setAttribute("height", this.data.sh))
          : (((t = createTag("div")).style.width = this.data.sw + "px"),
            (t.style.height = this.data.sh + "px"),
            (t.style.backgroundColor = this.data.sc)),
          this.layerElement.appendChild(t);
      }),
      extendPrototype(
        [
          BaseElement,
          TransformElement,
          HSolidElement,
          SVGShapeElement,
          HBaseElement,
          HierarchyElement,
          FrameElement,
          RenderableElement,
        ],
        HShapeElement
      ),
      (HShapeElement.prototype._renderShapeFrame =
        HShapeElement.prototype.renderInnerContent),
      (HShapeElement.prototype.createContent = function () {
        var t;
        if (((this.baseElement.style.fontSize = 0), this.data.hasMask))
          this.layerElement.appendChild(this.shapesContainer),
            (t = this.svgElement);
        else {
          t = createNS("svg");
          var e = this.comp.data ? this.comp.data : this.globalData.compSize;
          t.setAttribute("width", e.w),
            t.setAttribute("height", e.h),
            t.appendChild(this.shapesContainer),
            this.layerElement.appendChild(t);
        }
        this.searchShapes(
          this.shapesData,
          this.itemsData,
          this.prevViewData,
          this.shapesContainer,
          0,
          [],
          !0
        ),
          this.filterUniqueShapes(),
          (this.shapeCont = t);
      }),
      (HShapeElement.prototype.getTransformedPoint = function (t, e) {
        var r,
          i = t.length;
        for (r = 0; r < i; r += 1)
          e = t[r].mProps.v.applyToPointArray(e[0], e[1], 0);
        return e;
      }),
      (HShapeElement.prototype.calculateShapeBoundingBox = function (t, e) {
        var r,
          i,
          s,
          a,
          n,
          o = t.sh.v,
          h = t.transformers,
          l = o._length;
        if (!(l <= 1)) {
          for (r = 0; r < l - 1; r += 1)
            (i = this.getTransformedPoint(h, o.v[r])),
              (s = this.getTransformedPoint(h, o.o[r])),
              (a = this.getTransformedPoint(h, o.i[r + 1])),
              (n = this.getTransformedPoint(h, o.v[r + 1])),
              this.checkBounds(i, s, a, n, e);
          o.c &&
            ((i = this.getTransformedPoint(h, o.v[r])),
            (s = this.getTransformedPoint(h, o.o[r])),
            (a = this.getTransformedPoint(h, o.i[0])),
            (n = this.getTransformedPoint(h, o.v[0])),
            this.checkBounds(i, s, a, n, e));
        }
      }),
      (HShapeElement.prototype.checkBounds = function (t, e, r, i, s) {
        this.getBoundsOfCurve(t, e, r, i);
        var a = this.shapeBoundingBox;
        (s.x = bmMin(a.left, s.x)),
          (s.xMax = bmMax(a.right, s.xMax)),
          (s.y = bmMin(a.top, s.y)),
          (s.yMax = bmMax(a.bottom, s.yMax));
      }),
      (HShapeElement.prototype.shapeBoundingBox = {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
      }),
      (HShapeElement.prototype.tempBoundingBox = {
        x: 0,
        xMax: 0,
        y: 0,
        yMax: 0,
        width: 0,
        height: 0,
      }),
      (HShapeElement.prototype.getBoundsOfCurve = function (t, e, r, i) {
        for (
          var s,
            a,
            n,
            o,
            h,
            l,
            p,
            f = [
              [t[0], i[0]],
              [t[1], i[1]],
            ],
            m = 0;
          m < 2;
          ++m
        )
          (a = 6 * t[m] - 12 * e[m] + 6 * r[m]),
            (s = -3 * t[m] + 9 * e[m] - 9 * r[m] + 3 * i[m]),
            (n = 3 * e[m] - 3 * t[m]),
            (a |= 0),
            (n |= 0),
            (0 === (s |= 0) && 0 === a) ||
              (0 === s
                ? (o = -n / a) > 0 &&
                  o < 1 &&
                  f[m].push(this.calculateF(o, t, e, r, i, m))
                : (h = a * a - 4 * n * s) >= 0 &&
                  ((l = (-a + bmSqrt(h)) / (2 * s)) > 0 &&
                    l < 1 &&
                    f[m].push(this.calculateF(l, t, e, r, i, m)),
                  (p = (-a - bmSqrt(h)) / (2 * s)) > 0 &&
                    p < 1 &&
                    f[m].push(this.calculateF(p, t, e, r, i, m))));
        (this.shapeBoundingBox.left = bmMin.apply(null, f[0])),
          (this.shapeBoundingBox.top = bmMin.apply(null, f[1])),
          (this.shapeBoundingBox.right = bmMax.apply(null, f[0])),
          (this.shapeBoundingBox.bottom = bmMax.apply(null, f[1]));
      }),
      (HShapeElement.prototype.calculateF = function (t, e, r, i, s, a) {
        return (
          bmPow(1 - t, 3) * e[a] +
          3 * bmPow(1 - t, 2) * t * r[a] +
          3 * (1 - t) * bmPow(t, 2) * i[a] +
          bmPow(t, 3) * s[a]
        );
      }),
      (HShapeElement.prototype.calculateBoundingBox = function (t, e) {
        var r,
          i = t.length;
        for (r = 0; r < i; r += 1)
          t[r] && t[r].sh
            ? this.calculateShapeBoundingBox(t[r], e)
            : t[r] && t[r].it && this.calculateBoundingBox(t[r].it, e);
      }),
      (HShapeElement.prototype.currentBoxContains = function (t) {
        return (
          this.currentBBox.x <= t.x &&
          this.currentBBox.y <= t.y &&
          this.currentBBox.width + this.currentBBox.x >= t.x + t.width &&
          this.currentBBox.height + this.currentBBox.y >= t.y + t.height
        );
      }),
      (HShapeElement.prototype.renderInnerContent = function () {
        if (
          (this._renderShapeFrame(),
          !this.hidden && (this._isFirstFrame || this._mdf))
        ) {
          var t = this.tempBoundingBox,
            e = 999999;
          if (
            ((t.x = e),
            (t.xMax = -e),
            (t.y = e),
            (t.yMax = -e),
            this.calculateBoundingBox(this.itemsData, t),
            (t.width = t.xMax < t.x ? 0 : t.xMax - t.x),
            (t.height = t.yMax < t.y ? 0 : t.yMax - t.y),
            this.currentBoxContains(t))
          )
            return;
          var r = !1;
          if (
            (this.currentBBox.w !== t.width &&
              ((this.currentBBox.w = t.width),
              this.shapeCont.setAttribute("width", t.width),
              (r = !0)),
            this.currentBBox.h !== t.height &&
              ((this.currentBBox.h = t.height),
              this.shapeCont.setAttribute("height", t.height),
              (r = !0)),
            r || this.currentBBox.x !== t.x || this.currentBBox.y !== t.y)
          ) {
            (this.currentBBox.w = t.width),
              (this.currentBBox.h = t.height),
              (this.currentBBox.x = t.x),
              (this.currentBBox.y = t.y),
              this.shapeCont.setAttribute(
                "viewBox",
                this.currentBBox.x +
                  " " +
                  this.currentBBox.y +
                  " " +
                  this.currentBBox.w +
                  " " +
                  this.currentBBox.h
              );
            var i = this.shapeCont.style,
              s =
                "translate(" +
                this.currentBBox.x +
                "px," +
                this.currentBBox.y +
                "px)";
            (i.transform = s), (i.webkitTransform = s);
          }
        }
      }),
      extendPrototype(
        [
          BaseElement,
          TransformElement,
          HBaseElement,
          HierarchyElement,
          FrameElement,
          RenderableDOMElement,
          ITextElement,
        ],
        HTextElement
      ),
      (HTextElement.prototype.createContent = function () {
        if (((this.isMasked = this.checkMasks()), this.isMasked)) {
          (this.renderType = "svg"),
            (this.compW = this.comp.data.w),
            (this.compH = this.comp.data.h),
            this.svgElement.setAttribute("width", this.compW),
            this.svgElement.setAttribute("height", this.compH);
          var t = createNS("g");
          this.maskedElement.appendChild(t), (this.innerElem = t);
        } else (this.renderType = "html"), (this.innerElem = this.layerElement);
        this.checkParenting();
      }),
      (HTextElement.prototype.buildNewText = function () {
        var t = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(t.l ? t.l.length : 0);
        var e = this.innerElem.style,
          r = t.fc ? this.buildColor(t.fc) : "rgba(0,0,0,0)";
        (e.fill = r),
          (e.color = r),
          t.sc &&
            ((e.stroke = this.buildColor(t.sc)), (e.strokeWidth = t.sw + "px"));
        var i,
          s,
          a = this.globalData.fontManager.getFontByName(t.f);
        if (!this.globalData.fontManager.chars)
          if (
            ((e.fontSize = t.finalSize + "px"),
            (e.lineHeight = t.finalSize + "px"),
            a.fClass)
          )
            this.innerElem.className = a.fClass;
          else {
            e.fontFamily = a.fFamily;
            var n = t.fWeight,
              o = t.fStyle;
            (e.fontStyle = o), (e.fontWeight = n);
          }
        var h,
          l,
          p,
          f = t.l;
        s = f.length;
        var m,
          c = this.mHelper,
          d = "",
          u = 0;
        for (i = 0; i < s; i += 1) {
          if (
            (this.globalData.fontManager.chars
              ? (this.textPaths[u]
                  ? (h = this.textPaths[u])
                  : ((h = createNS("path")).setAttribute(
                      "stroke-linecap",
                      lineCapEnum[1]
                    ),
                    h.setAttribute("stroke-linejoin", lineJoinEnum[2]),
                    h.setAttribute("stroke-miterlimit", "4")),
                this.isMasked ||
                  (this.textSpans[u]
                    ? (p = (l = this.textSpans[u]).children[0])
                    : (((l = createTag("div")).style.lineHeight = 0),
                      (p = createNS("svg")).appendChild(h),
                      styleDiv(l))))
              : this.isMasked
              ? (h = this.textPaths[u] ? this.textPaths[u] : createNS("text"))
              : this.textSpans[u]
              ? ((l = this.textSpans[u]), (h = this.textPaths[u]))
              : (styleDiv((l = createTag("span"))),
                styleDiv((h = createTag("span"))),
                l.appendChild(h)),
            this.globalData.fontManager.chars)
          ) {
            var y,
              g = this.globalData.fontManager.getCharData(
                t.finalText[i],
                a.fStyle,
                this.globalData.fontManager.getFontByName(t.f).fFamily
              );
            if (
              ((y = g ? g.data : null),
              c.reset(),
              y &&
                y.shapes &&
                y.shapes.length &&
                ((m = y.shapes[0].it),
                c.scale(t.finalSize / 100, t.finalSize / 100),
                (d = this.createPathShape(c, m)),
                h.setAttribute("d", d)),
              this.isMasked)
            )
              this.innerElem.appendChild(h);
            else {
              if ((this.innerElem.appendChild(l), y && y.shapes)) {
                document.body.appendChild(p);
                var v = p.getBBox();
                p.setAttribute("width", v.width + 2),
                  p.setAttribute("height", v.height + 2),
                  p.setAttribute(
                    "viewBox",
                    v.x -
                      1 +
                      " " +
                      (v.y - 1) +
                      " " +
                      (v.width + 2) +
                      " " +
                      (v.height + 2)
                  );
                var b = p.style,
                  P = "translate(" + (v.x - 1) + "px," + (v.y - 1) + "px)";
                (b.transform = P),
                  (b.webkitTransform = P),
                  (f[i].yOffset = v.y - 1);
              } else p.setAttribute("width", 1), p.setAttribute("height", 1);
              l.appendChild(p);
            }
          } else if (
            ((h.textContent = f[i].val),
            h.setAttributeNS(
              "http://www.w3.org/XML/1998/namespace",
              "xml:space",
              "preserve"
            ),
            this.isMasked)
          )
            this.innerElem.appendChild(h);
          else {
            this.innerElem.appendChild(l);
            var E = h.style,
              x = "translate3d(0," + -t.finalSize / 1.2 + "px,0)";
            (E.transform = x), (E.webkitTransform = x);
          }
          this.isMasked ? (this.textSpans[u] = h) : (this.textSpans[u] = l),
            (this.textSpans[u].style.display = "block"),
            (this.textPaths[u] = h),
            (u += 1);
        }
        for (; u < this.textSpans.length; )
          (this.textSpans[u].style.display = "none"), (u += 1);
      }),
      (HTextElement.prototype.renderInnerContent = function () {
        var t;
        if (this.data.singleShape) {
          if (!this._isFirstFrame && !this.lettersChangedFlag) return;
          if (this.isMasked && this.finalTransform._matMdf) {
            this.svgElement.setAttribute(
              "viewBox",
              -this.finalTransform.mProp.p.v[0] +
                " " +
                -this.finalTransform.mProp.p.v[1] +
                " " +
                this.compW +
                " " +
                this.compH
            ),
              (t = this.svgElement.style);
            var e =
              "translate(" +
              -this.finalTransform.mProp.p.v[0] +
              "px," +
              -this.finalTransform.mProp.p.v[1] +
              "px)";
            (t.transform = e), (t.webkitTransform = e);
          }
        }
        if (
          (this.textAnimator.getMeasures(
            this.textProperty.currentData,
            this.lettersChangedFlag
          ),
          this.lettersChangedFlag || this.textAnimator.lettersChangedFlag)
        ) {
          var r,
            i,
            s,
            a,
            n,
            o = 0,
            h = this.textAnimator.renderedLetters,
            l = this.textProperty.currentData.l;
          for (i = l.length, r = 0; r < i; r += 1)
            l[r].n
              ? (o += 1)
              : ((a = this.textSpans[r]),
                (n = this.textPaths[r]),
                (s = h[o]),
                (o += 1),
                s._mdf.m &&
                  (this.isMasked
                    ? a.setAttribute("transform", s.m)
                    : ((a.style.webkitTransform = s.m),
                      (a.style.transform = s.m))),
                (a.style.opacity = s.o),
                s.sw && s._mdf.sw && n.setAttribute("stroke-width", s.sw),
                s.sc && s._mdf.sc && n.setAttribute("stroke", s.sc),
                s.fc &&
                  s._mdf.fc &&
                  (n.setAttribute("fill", s.fc), (n.style.color = s.fc)));
          if (
            this.innerElem.getBBox &&
            !this.hidden &&
            (this._isFirstFrame || this._mdf)
          ) {
            var p = this.innerElem.getBBox();
            this.currentBBox.w !== p.width &&
              ((this.currentBBox.w = p.width),
              this.svgElement.setAttribute("width", p.width)),
              this.currentBBox.h !== p.height &&
                ((this.currentBBox.h = p.height),
                this.svgElement.setAttribute("height", p.height));
            if (
              this.currentBBox.w !== p.width + 2 ||
              this.currentBBox.h !== p.height + 2 ||
              this.currentBBox.x !== p.x - 1 ||
              this.currentBBox.y !== p.y - 1
            ) {
              (this.currentBBox.w = p.width + 2),
                (this.currentBBox.h = p.height + 2),
                (this.currentBBox.x = p.x - 1),
                (this.currentBBox.y = p.y - 1),
                this.svgElement.setAttribute(
                  "viewBox",
                  this.currentBBox.x +
                    " " +
                    this.currentBBox.y +
                    " " +
                    this.currentBBox.w +
                    " " +
                    this.currentBBox.h
                ),
                (t = this.svgElement.style);
              var f =
                "translate(" +
                this.currentBBox.x +
                "px," +
                this.currentBBox.y +
                "px)";
              (t.transform = f), (t.webkitTransform = f);
            }
          }
        }
      }),
      extendPrototype(
        [BaseElement, FrameElement, HierarchyElement],
        HCameraElement
      ),
      (HCameraElement.prototype.setup = function () {
        var t,
          e,
          r,
          i,
          s = this.comp.threeDElements.length;
        for (t = 0; t < s; t += 1)
          if ("3d" === (e = this.comp.threeDElements[t]).type) {
            (r = e.perspectiveElem.style), (i = e.container.style);
            var a = this.pe.v + "px",
              n = "0px 0px 0px",
              o = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
            (r.perspective = a),
              (r.webkitPerspective = a),
              (i.transformOrigin = n),
              (i.mozTransformOrigin = n),
              (i.webkitTransformOrigin = n),
              (r.transform = o),
              (r.webkitTransform = o);
          }
      }),
      (HCameraElement.prototype.createElements = function () {}),
      (HCameraElement.prototype.hide = function () {}),
      (HCameraElement.prototype.renderFrame = function () {
        var t,
          e,
          r = this._isFirstFrame;
        if (this.hierarchy)
          for (e = this.hierarchy.length, t = 0; t < e; t += 1)
            r = this.hierarchy[t].finalTransform.mProp._mdf || r;
        if (
          r ||
          this.pe._mdf ||
          (this.p && this.p._mdf) ||
          (this.px && (this.px._mdf || this.py._mdf || this.pz._mdf)) ||
          this.rx._mdf ||
          this.ry._mdf ||
          this.rz._mdf ||
          this.or._mdf ||
          (this.a && this.a._mdf)
        ) {
          if ((this.mat.reset(), this.hierarchy))
            for (t = e = this.hierarchy.length - 1; t >= 0; t -= 1) {
              var i = this.hierarchy[t].finalTransform.mProp;
              this.mat.translate(-i.p.v[0], -i.p.v[1], i.p.v[2]),
                this.mat
                  .rotateX(-i.or.v[0])
                  .rotateY(-i.or.v[1])
                  .rotateZ(i.or.v[2]),
                this.mat.rotateX(-i.rx.v).rotateY(-i.ry.v).rotateZ(i.rz.v),
                this.mat.scale(1 / i.s.v[0], 1 / i.s.v[1], 1 / i.s.v[2]),
                this.mat.translate(i.a.v[0], i.a.v[1], i.a.v[2]);
            }
          if (
            (this.p
              ? this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2])
              : this.mat.translate(-this.px.v, -this.py.v, this.pz.v),
            this.a)
          ) {
            var s;
            s = this.p
              ? [
                  this.p.v[0] - this.a.v[0],
                  this.p.v[1] - this.a.v[1],
                  this.p.v[2] - this.a.v[2],
                ]
              : [
                  this.px.v - this.a.v[0],
                  this.py.v - this.a.v[1],
                  this.pz.v - this.a.v[2],
                ];
            var a = Math.sqrt(
                Math.pow(s[0], 2) + Math.pow(s[1], 2) + Math.pow(s[2], 2)
              ),
              n = [s[0] / a, s[1] / a, s[2] / a],
              o = Math.sqrt(n[2] * n[2] + n[0] * n[0]),
              h = Math.atan2(n[1], o),
              l = Math.atan2(n[0], -n[2]);
            this.mat.rotateY(l).rotateX(-h);
          }
          this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v),
            this.mat
              .rotateX(-this.or.v[0])
              .rotateY(-this.or.v[1])
              .rotateZ(this.or.v[2]),
            this.mat.translate(
              this.globalData.compSize.w / 2,
              this.globalData.compSize.h / 2,
              0
            ),
            this.mat.translate(0, 0, this.pe.v);
          var p = !this._prevMat.equals(this.mat);
          if ((p || this.pe._mdf) && this.comp.threeDElements) {
            var f, m, c;
            for (e = this.comp.threeDElements.length, t = 0; t < e; t += 1)
              if ("3d" === (f = this.comp.threeDElements[t]).type) {
                if (p) {
                  var d = this.mat.toCSS();
                  ((c = f.container.style).transform = d),
                    (c.webkitTransform = d);
                }
                this.pe._mdf &&
                  (((m = f.perspectiveElem.style).perspective =
                    this.pe.v + "px"),
                  (m.webkitPerspective = this.pe.v + "px"));
              }
            this.mat.clone(this._prevMat);
          }
        }
        this._isFirstFrame = !1;
      }),
      (HCameraElement.prototype.prepareFrame = function (t) {
        this.prepareProperties(t, !0);
      }),
      (HCameraElement.prototype.destroy = function () {}),
      (HCameraElement.prototype.getBaseElement = function () {
        return null;
      }),
      extendPrototype(
        [
          BaseElement,
          TransformElement,
          HBaseElement,
          HSolidElement,
          HierarchyElement,
          FrameElement,
          RenderableElement,
        ],
        HImageElement
      ),
      (HImageElement.prototype.createContent = function () {
        var t = this.globalData.getAssetsPath(this.assetData),
          e = new Image();
        this.data.hasMask
          ? ((this.imageElem = createNS("image")),
            this.imageElem.setAttribute("width", this.assetData.w + "px"),
            this.imageElem.setAttribute("height", this.assetData.h + "px"),
            this.imageElem.setAttributeNS(
              "http://www.w3.org/1999/xlink",
              "href",
              t
            ),
            this.layerElement.appendChild(this.imageElem),
            this.baseElement.setAttribute("width", this.assetData.w),
            this.baseElement.setAttribute("height", this.assetData.h))
          : this.layerElement.appendChild(e),
          (e.crossOrigin = "anonymous"),
          (e.src = t),
          this.data.ln && this.baseElement.setAttribute("id", this.data.ln);
      }),
      extendPrototype([BaseRenderer], HybridRendererBase),
      (HybridRendererBase.prototype.buildItem =
        SVGRenderer.prototype.buildItem),
      (HybridRendererBase.prototype.checkPendingElements = function () {
        for (; this.pendingElements.length; ) {
          this.pendingElements.pop().checkParenting();
        }
      }),
      (HybridRendererBase.prototype.appendElementInPos = function (t, e) {
        var r = t.getBaseElement();
        if (r) {
          var i = this.layers[e];
          if (i.ddd && this.supports3d) this.addTo3dContainer(r, e);
          else if (this.threeDElements) this.addTo3dContainer(r, e);
          else {
            for (var s, a, n = 0; n < e; )
              this.elements[n] &&
                !0 !== this.elements[n] &&
                this.elements[n].getBaseElement &&
                ((a = this.elements[n]),
                (s =
                  (this.layers[n].ddd
                    ? this.getThreeDContainerByPos(n)
                    : a.getBaseElement()) || s)),
                (n += 1);
            s
              ? (i.ddd && this.supports3d) ||
                this.layerElement.insertBefore(r, s)
              : (i.ddd && this.supports3d) || this.layerElement.appendChild(r);
          }
        }
      }),
      (HybridRendererBase.prototype.createShape = function (t) {
        return this.supports3d
          ? new HShapeElement(t, this.globalData, this)
          : new SVGShapeElement(t, this.globalData, this);
      }),
      (HybridRendererBase.prototype.createText = function (t) {
        return this.supports3d
          ? new HTextElement(t, this.globalData, this)
          : new SVGTextLottieElement(t, this.globalData, this);
      }),
      (HybridRendererBase.prototype.createCamera = function (t) {
        return (
          (this.camera = new HCameraElement(t, this.globalData, this)),
          this.camera
        );
      }),
      (HybridRendererBase.prototype.createImage = function (t) {
        return this.supports3d
          ? new HImageElement(t, this.globalData, this)
          : new IImageElement(t, this.globalData, this);
      }),
      (HybridRendererBase.prototype.createSolid = function (t) {
        return this.supports3d
          ? new HSolidElement(t, this.globalData, this)
          : new ISolidElement(t, this.globalData, this);
      }),
      (HybridRendererBase.prototype.createNull =
        SVGRenderer.prototype.createNull),
      (HybridRendererBase.prototype.getThreeDContainerByPos = function (t) {
        for (var e = 0, r = this.threeDElements.length; e < r; ) {
          if (
            this.threeDElements[e].startPos <= t &&
            this.threeDElements[e].endPos >= t
          )
            return this.threeDElements[e].perspectiveElem;
          e += 1;
        }
        return null;
      }),
      (HybridRendererBase.prototype.createThreeDContainer = function (t, e) {
        var r,
          i,
          s = createTag("div");
        styleDiv(s);
        var a = createTag("div");
        if ((styleDiv(a), "3d" === e)) {
          ((r = s.style).width = this.globalData.compSize.w + "px"),
            (r.height = this.globalData.compSize.h + "px");
          var n = "50% 50%";
          (r.webkitTransformOrigin = n),
            (r.mozTransformOrigin = n),
            (r.transformOrigin = n);
          var o = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
          ((i = a.style).transform = o), (i.webkitTransform = o);
        }
        s.appendChild(a);
        var h = {
          container: a,
          perspectiveElem: s,
          startPos: t,
          endPos: t,
          type: e,
        };
        return this.threeDElements.push(h), h;
      }),
      (HybridRendererBase.prototype.build3dContainers = function () {
        var t,
          e,
          r = this.layers.length,
          i = "";
        for (t = 0; t < r; t += 1)
          this.layers[t].ddd && 3 !== this.layers[t].ty
            ? ("3d" !== i &&
                ((i = "3d"), (e = this.createThreeDContainer(t, "3d"))),
              (e.endPos = Math.max(e.endPos, t)))
            : ("2d" !== i &&
                ((i = "2d"), (e = this.createThreeDContainer(t, "2d"))),
              (e.endPos = Math.max(e.endPos, t)));
        for (t = (r = this.threeDElements.length) - 1; t >= 0; t -= 1)
          this.resizerElem.appendChild(this.threeDElements[t].perspectiveElem);
      }),
      (HybridRendererBase.prototype.addTo3dContainer = function (t, e) {
        for (var r = 0, i = this.threeDElements.length; r < i; ) {
          if (e <= this.threeDElements[r].endPos) {
            for (var s, a = this.threeDElements[r].startPos; a < e; )
              this.elements[a] &&
                this.elements[a].getBaseElement &&
                (s = this.elements[a].getBaseElement()),
                (a += 1);
            s
              ? this.threeDElements[r].container.insertBefore(t, s)
              : this.threeDElements[r].container.appendChild(t);
            break;
          }
          r += 1;
        }
      }),
      (HybridRendererBase.prototype.configAnimation = function (t) {
        var e = createTag("div"),
          r = this.animationItem.wrapper,
          i = e.style;
        (i.width = t.w + "px"),
          (i.height = t.h + "px"),
          (this.resizerElem = e),
          styleDiv(e),
          (i.transformStyle = "flat"),
          (i.mozTransformStyle = "flat"),
          (i.webkitTransformStyle = "flat"),
          this.renderConfig.className &&
            e.setAttribute("class", this.renderConfig.className),
          r.appendChild(e),
          (i.overflow = "hidden");
        var s = createNS("svg");
        s.setAttribute("width", "1"),
          s.setAttribute("height", "1"),
          styleDiv(s),
          this.resizerElem.appendChild(s);
        var a = createNS("defs");
        s.appendChild(a),
          (this.data = t),
          this.setupGlobalData(t, s),
          (this.globalData.defs = a),
          (this.layers = t.layers),
          (this.layerElement = this.resizerElem),
          this.build3dContainers(),
          this.updateContainerSize();
      }),
      (HybridRendererBase.prototype.destroy = function () {
        var t;
        this.animationItem.wrapper &&
          (this.animationItem.wrapper.innerText = ""),
          (this.animationItem.container = null),
          (this.globalData.defs = null);
        var e = this.layers ? this.layers.length : 0;
        for (t = 0; t < e; t += 1) this.elements[t].destroy();
        (this.elements.length = 0),
          (this.destroyed = !0),
          (this.animationItem = null);
      }),
      (HybridRendererBase.prototype.updateContainerSize = function () {
        var t,
          e,
          r,
          i,
          s = this.animationItem.wrapper.offsetWidth,
          a = this.animationItem.wrapper.offsetHeight,
          n = s / a;
        this.globalData.compSize.w / this.globalData.compSize.h > n
          ? ((t = s / this.globalData.compSize.w),
            (e = s / this.globalData.compSize.w),
            (r = 0),
            (i =
              (a -
                this.globalData.compSize.h * (s / this.globalData.compSize.w)) /
              2))
          : ((t = a / this.globalData.compSize.h),
            (e = a / this.globalData.compSize.h),
            (r =
              (s -
                this.globalData.compSize.w * (a / this.globalData.compSize.h)) /
              2),
            (i = 0));
        var o = this.resizerElem.style;
        (o.webkitTransform =
          "matrix3d(" +
          t +
          ",0,0,0,0," +
          e +
          ",0,0,0,0,1,0," +
          r +
          "," +
          i +
          ",0,1)"),
          (o.transform = o.webkitTransform);
      }),
      (HybridRendererBase.prototype.renderFrame =
        SVGRenderer.prototype.renderFrame),
      (HybridRendererBase.prototype.hide = function () {
        this.resizerElem.style.display = "none";
      }),
      (HybridRendererBase.prototype.show = function () {
        this.resizerElem.style.display = "block";
      }),
      (HybridRendererBase.prototype.initItems = function () {
        if ((this.buildAllItems(), this.camera)) this.camera.setup();
        else {
          var t,
            e = this.globalData.compSize.w,
            r = this.globalData.compSize.h,
            i = this.threeDElements.length;
          for (t = 0; t < i; t += 1) {
            var s = this.threeDElements[t].perspectiveElem.style;
            (s.webkitPerspective =
              Math.sqrt(Math.pow(e, 2) + Math.pow(r, 2)) + "px"),
              (s.perspective = s.webkitPerspective);
          }
        }
      }),
      (HybridRendererBase.prototype.searchExtraCompositions = function (t) {
        var e,
          r = t.length,
          i = createTag("div");
        for (e = 0; e < r; e += 1)
          if (t[e].xt) {
            var s = this.createComp(t[e], i, this.globalData.comp, null);
            s.initExpressions(),
              this.globalData.projectInterface.registerComposition(s);
          }
      }),
      extendPrototype(
        [HybridRendererBase, ICompElement, HBaseElement],
        HCompElement
      ),
      (HCompElement.prototype._createBaseContainerElements =
        HCompElement.prototype.createContainerElements),
      (HCompElement.prototype.createContainerElements = function () {
        this._createBaseContainerElements(),
          this.data.hasMask
            ? (this.svgElement.setAttribute("width", this.data.w),
              this.svgElement.setAttribute("height", this.data.h),
              (this.transformedElement = this.baseElement))
            : (this.transformedElement = this.layerElement);
      }),
      (HCompElement.prototype.addTo3dContainer = function (t, e) {
        for (var r, i = 0; i < e; )
          this.elements[i] &&
            this.elements[i].getBaseElement &&
            (r = this.elements[i].getBaseElement()),
            (i += 1);
        r
          ? this.layerElement.insertBefore(t, r)
          : this.layerElement.appendChild(t);
      }),
      (HCompElement.prototype.createComp = function (t) {
        return this.supports3d
          ? new HCompElement(t, this.globalData, this)
          : new SVGCompElement(t, this.globalData, this);
      }),
      extendPrototype([HybridRendererBase], HybridRenderer),
      (HybridRenderer.prototype.createComp = function (t) {
        return this.supports3d
          ? new HCompElement(t, this.globalData, this)
          : new SVGCompElement(t, this.globalData, this);
      });
    var Expressions = (function () {
      var t = {};
      return (
        (t.initExpressions = function (t) {
          var e = 0,
            r = [];
          (t.renderer.compInterface = CompExpressionInterface(t.renderer)),
            t.renderer.globalData.projectInterface.registerComposition(
              t.renderer
            ),
            (t.renderer.globalData.pushExpression = function () {
              e += 1;
            }),
            (t.renderer.globalData.popExpression = function () {
              0 == (e -= 1) &&
                (function () {
                  var t,
                    e = r.length;
                  for (t = 0; t < e; t += 1) r[t].release();
                  r.length = 0;
                })();
            }),
            (t.renderer.globalData.registerExpressionProperty = function (t) {
              -1 === r.indexOf(t) && r.push(t);
            });
        }),
        t
      );
    })();
    function _typeof$1(t) {
      return (
        (_typeof$1 =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
                return typeof t;
              }
            : function (t) {
                return t &&
                  "function" == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              }),
        _typeof$1(t)
      );
    }
    function seedRandom(t, e) {
      var r,
        i = this,
        s = 256,
        a = e.pow(s, 6),
        n = e.pow(2, 52),
        o = 2 * n,
        h = 255;
      function l(t) {
        var e,
          r = t.length,
          i = this,
          a = 0,
          n = (i.i = i.j = 0),
          o = (i.S = []);
        for (r || (t = [r++]); a < s; ) o[a] = a++;
        for (a = 0; a < s; a++)
          (o[a] = o[(n = h & (n + t[a % r] + (e = o[a])))]), (o[n] = e);
        i.g = function (t) {
          for (var e, r = 0, a = i.i, n = i.j, o = i.S; t--; )
            (e = o[(a = h & (a + 1))]),
              (r = r * s + o[h & ((o[a] = o[(n = h & (n + e))]) + (o[n] = e))]);
          return (i.i = a), (i.j = n), r;
        };
      }
      function p(t, e) {
        return (e.i = t.i), (e.j = t.j), (e.S = t.S.slice()), e;
      }
      function f(t, e) {
        var r,
          i = [],
          s = _typeof$1(t);
        if (e && "object" == s)
          for (r in t)
            try {
              i.push(f(t[r], e - 1));
            } catch (t) {}
        return i.length ? i : "string" == s ? t : t + "\0";
      }
      function m(t, e) {
        for (var r, i = t + "", s = 0; s < i.length; )
          e[h & s] = h & ((r ^= 19 * e[h & s]) + i.charCodeAt(s++));
        return c(e);
      }
      function c(t) {
        return String.fromCharCode.apply(0, t);
      }
      (e.seedrandom = function (h, d, u) {
        var y = [],
          g = m(
            f(
              (d = !0 === d ? { entropy: !0 } : d || {}).entropy
                ? [h, c(t)]
                : null === h
                ? (function () {
                    try {
                      r;
                      var e = new Uint8Array(s);
                      return (i.crypto || i.msCrypto).getRandomValues(e), c(e);
                    } catch (e) {
                      var a = i.navigator,
                        n = a && a.plugins;
                      return [+new Date(), i, n, i.screen, c(t)];
                    }
                  })()
                : h,
              3
            ),
            y
          ),
          v = new l(y),
          b = function () {
            for (var t = v.g(6), e = a, r = 0; t < n; )
              (t = (t + r) * s), (e *= s), (r = v.g(1));
            for (; t >= o; ) (t /= 2), (e /= 2), (r >>>= 1);
            return (t + r) / e;
          };
        return (
          (b.int32 = function () {
            return 0 | v.g(4);
          }),
          (b.quick = function () {
            return v.g(4) / 4294967296;
          }),
          (b.double = b),
          m(c(v.S), t),
          (
            d.pass ||
            u ||
            function (t, r, i, s) {
              return (
                s &&
                  (s.S && p(s, v),
                  (t.state = function () {
                    return p(v, {});
                  })),
                i ? ((e.random = t), r) : t
              );
            }
          )(b, g, "global" in d ? d.global : this == e, d.state)
        );
      }),
        m(e.random(), t);
    }
    function initialize$2(t) {
      seedRandom([], t);
    }
    var propTypes = { SHAPE: "shape" };
    function _typeof(t) {
      return (
        (_typeof =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (t) {
                return typeof t;
              }
            : function (t) {
                return t &&
                  "function" == typeof Symbol &&
                  t.constructor === Symbol &&
                  t !== Symbol.prototype
                  ? "symbol"
                  : typeof t;
              }),
        _typeof(t)
      );
    }
    var ExpressionManager = (function () {
        var ob = {},
          Math = BMMath,
          window = null,
          document = null,
          XMLHttpRequest = null,
          fetch = null,
          frames = null;
        function $bm_isInstanceOfArray(t) {
          return t.constructor === Array || t.constructor === Float32Array;
        }
        function isNumerable(t, e) {
          return (
            "number" === t ||
            "boolean" === t ||
            "string" === t ||
            e instanceof Number
          );
        }
        function $bm_neg(t) {
          var e = _typeof(t);
          if ("number" === e || "boolean" === e || t instanceof Number)
            return -t;
          if ($bm_isInstanceOfArray(t)) {
            var r,
              i = t.length,
              s = [];
            for (r = 0; r < i; r += 1) s[r] = -t[r];
            return s;
          }
          return t.propType ? t.v : -t;
        }
        initialize$2(BMMath);
        var easeInBez = BezierFactory.getBezierEasing(
            0.333,
            0,
            0.833,
            0.833,
            "easeIn"
          ).get,
          easeOutBez = BezierFactory.getBezierEasing(
            0.167,
            0.167,
            0.667,
            1,
            "easeOut"
          ).get,
          easeInOutBez = BezierFactory.getBezierEasing(
            0.33,
            0,
            0.667,
            1,
            "easeInOut"
          ).get;
        function sum(t, e) {
          var r = _typeof(t),
            i = _typeof(e);
          if ("string" === r || "string" === i) return t + e;
          if (isNumerable(r, t) && isNumerable(i, e)) return t + e;
          if ($bm_isInstanceOfArray(t) && isNumerable(i, e))
            return ((t = t.slice(0))[0] += e), t;
          if (isNumerable(r, t) && $bm_isInstanceOfArray(e))
            return ((e = e.slice(0))[0] = t + e[0]), e;
          if ($bm_isInstanceOfArray(t) && $bm_isInstanceOfArray(e)) {
            for (
              var s = 0, a = t.length, n = e.length, o = [];
              s < a || s < n;

            )
              ("number" == typeof t[s] || t[s] instanceof Number) &&
              ("number" == typeof e[s] || e[s] instanceof Number)
                ? (o[s] = t[s] + e[s])
                : (o[s] = void 0 === e[s] ? t[s] : t[s] || e[s]),
                (s += 1);
            return o;
          }
          return 0;
        }
        var add = sum;
        function sub(t, e) {
          var r = _typeof(t),
            i = _typeof(e);
          if (isNumerable(r, t) && isNumerable(i, e))
            return (
              "string" === r && (t = parseInt(t, 10)),
              "string" === i && (e = parseInt(e, 10)),
              t - e
            );
          if ($bm_isInstanceOfArray(t) && isNumerable(i, e))
            return ((t = t.slice(0))[0] -= e), t;
          if (isNumerable(r, t) && $bm_isInstanceOfArray(e))
            return ((e = e.slice(0))[0] = t - e[0]), e;
          if ($bm_isInstanceOfArray(t) && $bm_isInstanceOfArray(e)) {
            for (
              var s = 0, a = t.length, n = e.length, o = [];
              s < a || s < n;

            )
              ("number" == typeof t[s] || t[s] instanceof Number) &&
              ("number" == typeof e[s] || e[s] instanceof Number)
                ? (o[s] = t[s] - e[s])
                : (o[s] = void 0 === e[s] ? t[s] : t[s] || e[s]),
                (s += 1);
            return o;
          }
          return 0;
        }
        function mul(t, e) {
          var r,
            i,
            s,
            a = _typeof(t),
            n = _typeof(e);
          if (isNumerable(a, t) && isNumerable(n, e)) return t * e;
          if ($bm_isInstanceOfArray(t) && isNumerable(n, e)) {
            for (
              s = t.length, r = createTypedArray("float32", s), i = 0;
              i < s;
              i += 1
            )
              r[i] = t[i] * e;
            return r;
          }
          if (isNumerable(a, t) && $bm_isInstanceOfArray(e)) {
            for (
              s = e.length, r = createTypedArray("float32", s), i = 0;
              i < s;
              i += 1
            )
              r[i] = t * e[i];
            return r;
          }
          return 0;
        }
        function div(t, e) {
          var r,
            i,
            s,
            a = _typeof(t),
            n = _typeof(e);
          if (isNumerable(a, t) && isNumerable(n, e)) return t / e;
          if ($bm_isInstanceOfArray(t) && isNumerable(n, e)) {
            for (
              s = t.length, r = createTypedArray("float32", s), i = 0;
              i < s;
              i += 1
            )
              r[i] = t[i] / e;
            return r;
          }
          if (isNumerable(a, t) && $bm_isInstanceOfArray(e)) {
            for (
              s = e.length, r = createTypedArray("float32", s), i = 0;
              i < s;
              i += 1
            )
              r[i] = t / e[i];
            return r;
          }
          return 0;
        }
        function mod(t, e) {
          return (
            "string" == typeof t && (t = parseInt(t, 10)),
            "string" == typeof e && (e = parseInt(e, 10)),
            t % e
          );
        }
        var $bm_sum = sum,
          $bm_sub = sub,
          $bm_mul = mul,
          $bm_div = div,
          $bm_mod = mod;
        function clamp(t, e, r) {
          if (e > r) {
            var i = r;
            (r = e), (e = i);
          }
          return Math.min(Math.max(t, e), r);
        }
        function radiansToDegrees(t) {
          return t / degToRads;
        }
        var radians_to_degrees = radiansToDegrees;
        function degreesToRadians(t) {
          return t * degToRads;
        }
        var degrees_to_radians = radiansToDegrees,
          helperLengthArray = [0, 0, 0, 0, 0, 0];
        function length(t, e) {
          if ("number" == typeof t || t instanceof Number)
            return (e = e || 0), Math.abs(t - e);
          var r;
          e || (e = helperLengthArray);
          var i = Math.min(t.length, e.length),
            s = 0;
          for (r = 0; r < i; r += 1) s += Math.pow(e[r] - t[r], 2);
          return Math.sqrt(s);
        }
        function normalize(t) {
          return div(t, length(t));
        }
        function rgbToHsl(t) {
          var e,
            r,
            i = t[0],
            s = t[1],
            a = t[2],
            n = Math.max(i, s, a),
            o = Math.min(i, s, a),
            h = (n + o) / 2;
          if (n === o) (e = 0), (r = 0);
          else {
            var l = n - o;
            switch (((r = h > 0.5 ? l / (2 - n - o) : l / (n + o)), n)) {
              case i:
                e = (s - a) / l + (s < a ? 6 : 0);
                break;
              case s:
                e = (a - i) / l + 2;
                break;
              case a:
                e = (i - s) / l + 4;
            }
            e /= 6;
          }
          return [e, r, h, t[3]];
        }
        function hue2rgb(t, e, r) {
          return (
            r < 0 && (r += 1),
            r > 1 && (r -= 1),
            r < 1 / 6
              ? t + 6 * (e - t) * r
              : r < 0.5
              ? e
              : r < 2 / 3
              ? t + (e - t) * (2 / 3 - r) * 6
              : t
          );
        }
        function hslToRgb(t) {
          var e,
            r,
            i,
            s = t[0],
            a = t[1],
            n = t[2];
          if (0 === a) (e = n), (i = n), (r = n);
          else {
            var o = n < 0.5 ? n * (1 + a) : n + a - n * a,
              h = 2 * n - o;
            (e = hue2rgb(h, o, s + 1 / 3)),
              (r = hue2rgb(h, o, s)),
              (i = hue2rgb(h, o, s - 1 / 3));
          }
          return [e, r, i, t[3]];
        }
        function linear(t, e, r, i, s) {
          if (
            ((void 0 !== i && void 0 !== s) ||
              ((i = e), (s = r), (e = 0), (r = 1)),
            r < e)
          ) {
            var a = r;
            (r = e), (e = a);
          }
          if (t <= e) return i;
          if (t >= r) return s;
          var n,
            o = r === e ? 0 : (t - e) / (r - e);
          if (!i.length) return i + (s - i) * o;
          var h = i.length,
            l = createTypedArray("float32", h);
          for (n = 0; n < h; n += 1) l[n] = i[n] + (s[n] - i[n]) * o;
          return l;
        }
        function random(t, e) {
          if (
            (void 0 === e &&
              (void 0 === t ? ((t = 0), (e = 1)) : ((e = t), (t = void 0))),
            e.length)
          ) {
            var r,
              i = e.length;
            t || (t = createTypedArray("float32", i));
            var s = createTypedArray("float32", i),
              a = BMMath.random();
            for (r = 0; r < i; r += 1) s[r] = t[r] + a * (e[r] - t[r]);
            return s;
          }
          return void 0 === t && (t = 0), t + BMMath.random() * (e - t);
        }
        function createPath(t, e, r, i) {
          var s,
            a = t.length,
            n = shapePool.newElement();
          n.setPathData(!!i, a);
          var o,
            h,
            l = [0, 0];
          for (s = 0; s < a; s += 1)
            (o = e && e[s] ? e[s] : l),
              (h = r && r[s] ? r[s] : l),
              n.setTripleAt(
                t[s][0],
                t[s][1],
                h[0] + t[s][0],
                h[1] + t[s][1],
                o[0] + t[s][0],
                o[1] + t[s][1],
                s,
                !0
              );
          return n;
        }
        function initiateExpression(elem, data, property) {
          var val = data.x,
            needsVelocity = /velocity(?![\w\d])/.test(val),
            _needsRandom = -1 !== val.indexOf("random"),
            elemType = elem.data.ty,
            transform,
            $bm_transform,
            content,
            effect,
            thisProperty = property;
          (thisProperty.valueAtTime = thisProperty.getValueAtTime),
            Object.defineProperty(thisProperty, "value", {
              get: function () {
                return thisProperty.v;
              },
            }),
            (elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate),
            (elem.comp.displayStartTime = 0);
          var inPoint = elem.data.ip / elem.comp.globalData.frameRate,
            outPoint = elem.data.op / elem.comp.globalData.frameRate,
            width = elem.data.sw ? elem.data.sw : 0,
            height = elem.data.sh ? elem.data.sh : 0,
            name = elem.data.nm,
            loopIn,
            loop_in,
            loopOut,
            loop_out,
            smooth,
            toWorld,
            fromWorld,
            fromComp,
            toComp,
            fromCompToSurface,
            position,
            rotation,
            anchorPoint,
            scale,
            thisLayer,
            thisComp,
            mask,
            valueAtTime,
            velocityAtTime,
            scoped_bm_rt,
            expression_function = eval(
              "[function _expression_function(){" +
                val +
                ";scoped_bm_rt=$bm_rt}]"
            )[0],
            numKeys = property.kf ? data.k.length : 0,
            active = !this.data || !0 !== this.data.hd,
            wiggle = function (t, e) {
              var r,
                i,
                s = this.pv.length ? this.pv.length : 1,
                a = createTypedArray("float32", s);
              var n = Math.floor(5 * time);
              for (r = 0, i = 0; r < n; ) {
                for (i = 0; i < s; i += 1) a[i] += -e + 2 * e * BMMath.random();
                r += 1;
              }
              var o = 5 * time,
                h = o - Math.floor(o),
                l = createTypedArray("float32", s);
              if (s > 1) {
                for (i = 0; i < s; i += 1)
                  l[i] = this.pv[i] + a[i] + (-e + 2 * e * BMMath.random()) * h;
                return l;
              }
              return this.pv + a[0] + (-e + 2 * e * BMMath.random()) * h;
            }.bind(this);
          function loopInDuration(t, e) {
            return loopIn(t, e, !0);
          }
          function loopOutDuration(t, e) {
            return loopOut(t, e, !0);
          }
          thisProperty.loopIn &&
            ((loopIn = thisProperty.loopIn.bind(thisProperty)),
            (loop_in = loopIn)),
            thisProperty.loopOut &&
              ((loopOut = thisProperty.loopOut.bind(thisProperty)),
              (loop_out = loopOut)),
            thisProperty.smooth &&
              (smooth = thisProperty.smooth.bind(thisProperty)),
            this.getValueAtTime &&
              (valueAtTime = this.getValueAtTime.bind(this)),
            this.getVelocityAtTime &&
              (velocityAtTime = this.getVelocityAtTime.bind(this));
          var comp = elem.comp.globalData.projectInterface.bind(
              elem.comp.globalData.projectInterface
            ),
            time,
            velocity,
            value,
            text,
            textIndex,
            textTotal,
            selectorValue;
          function lookAt(t, e) {
            var r = [e[0] - t[0], e[1] - t[1], e[2] - t[2]],
              i =
                Math.atan2(r[0], Math.sqrt(r[1] * r[1] + r[2] * r[2])) /
                degToRads;
            return [-Math.atan2(r[1], r[2]) / degToRads, i, 0];
          }
          function easeOut(t, e, r, i, s) {
            return applyEase(easeOutBez, t, e, r, i, s);
          }
          function easeIn(t, e, r, i, s) {
            return applyEase(easeInBez, t, e, r, i, s);
          }
          function ease(t, e, r, i, s) {
            return applyEase(easeInOutBez, t, e, r, i, s);
          }
          function applyEase(t, e, r, i, s, a) {
            void 0 === s ? ((s = r), (a = i)) : (e = (e - r) / (i - r)),
              e > 1 ? (e = 1) : e < 0 && (e = 0);
            var n = t(e);
            if ($bm_isInstanceOfArray(s)) {
              var o,
                h = s.length,
                l = createTypedArray("float32", h);
              for (o = 0; o < h; o += 1) l[o] = (a[o] - s[o]) * n + s[o];
              return l;
            }
            return (a - s) * n + s;
          }
          function nearestKey(t) {
            var e,
              r,
              i,
              s = data.k.length;
            if (data.k.length && "number" != typeof data.k[0])
              if (
                ((r = -1), (t *= elem.comp.globalData.frameRate) < data.k[0].t)
              )
                (r = 1), (i = data.k[0].t);
              else {
                for (e = 0; e < s - 1; e += 1) {
                  if (t === data.k[e].t) {
                    (r = e + 1), (i = data.k[e].t);
                    break;
                  }
                  if (t > data.k[e].t && t < data.k[e + 1].t) {
                    t - data.k[e].t > data.k[e + 1].t - t
                      ? ((r = e + 2), (i = data.k[e + 1].t))
                      : ((r = e + 1), (i = data.k[e].t));
                    break;
                  }
                }
                -1 === r && ((r = e + 1), (i = data.k[e].t));
              }
            else (r = 0), (i = 0);
            var a = {};
            return (
              (a.index = r), (a.time = i / elem.comp.globalData.frameRate), a
            );
          }
          function key(t) {
            var e, r, i;
            if (!data.k.length || "number" == typeof data.k[0])
              throw new Error("The property has no keyframe at index " + t);
            (t -= 1),
              (e = {
                time: data.k[t].t / elem.comp.globalData.frameRate,
                value: [],
              });
            var s = Object.prototype.hasOwnProperty.call(data.k[t], "s")
              ? data.k[t].s
              : data.k[t - 1].e;
            for (i = s.length, r = 0; r < i; r += 1)
              (e[r] = s[r]), (e.value[r] = s[r]);
            return e;
          }
          function framesToTime(t, e) {
            return e || (e = elem.comp.globalData.frameRate), t / e;
          }
          function timeToFrames(t, e) {
            return (
              t || 0 === t || (t = time),
              e || (e = elem.comp.globalData.frameRate),
              t * e
            );
          }
          function seedRandom(t) {
            BMMath.seedrandom(randSeed + t);
          }
          function sourceRectAtTime() {
            return elem.sourceRectAtTime();
          }
          function substring(t, e) {
            return "string" == typeof value
              ? void 0 === e
                ? value.substring(t)
                : value.substring(t, e)
              : "";
          }
          function substr(t, e) {
            return "string" == typeof value
              ? void 0 === e
                ? value.substr(t)
                : value.substr(t, e)
              : "";
          }
          function posterizeTime(t) {
            (time = 0 === t ? 0 : Math.floor(time * t) / t),
              (value = valueAtTime(time));
          }
          var index = elem.data.ind,
            hasParent = !(!elem.hierarchy || !elem.hierarchy.length),
            parent,
            randSeed = Math.floor(1e6 * Math.random()),
            globalData = elem.globalData;
          function executeExpression(t) {
            return (
              (value = t),
              this.frameExpressionId === elem.globalData.frameId &&
              "textSelector" !== this.propType
                ? value
                : ("textSelector" === this.propType &&
                    ((textIndex = this.textIndex),
                    (textTotal = this.textTotal),
                    (selectorValue = this.selectorValue)),
                  thisLayer ||
                    ((text = elem.layerInterface.text),
                    (thisLayer = elem.layerInterface),
                    (thisComp = elem.comp.compInterface),
                    (toWorld = thisLayer.toWorld.bind(thisLayer)),
                    (fromWorld = thisLayer.fromWorld.bind(thisLayer)),
                    (fromComp = thisLayer.fromComp.bind(thisLayer)),
                    (toComp = thisLayer.toComp.bind(thisLayer)),
                    (mask = thisLayer.mask
                      ? thisLayer.mask.bind(thisLayer)
                      : null),
                    (fromCompToSurface = fromComp)),
                  transform ||
                    ((transform = elem.layerInterface("ADBE Transform Group")),
                    ($bm_transform = transform),
                    transform && (anchorPoint = transform.anchorPoint)),
                  4 !== elemType ||
                    content ||
                    (content = thisLayer("ADBE Root Vectors Group")),
                  effect || (effect = thisLayer(4)),
                  (hasParent = !(!elem.hierarchy || !elem.hierarchy.length)) &&
                    !parent &&
                    (parent = elem.hierarchy[0].layerInterface),
                  (time =
                    this.comp.renderedFrame / this.comp.globalData.frameRate),
                  _needsRandom && seedRandom(randSeed + time),
                  needsVelocity && (velocity = velocityAtTime(time)),
                  expression_function(),
                  (this.frameExpressionId = elem.globalData.frameId),
                  (scoped_bm_rt =
                    scoped_bm_rt.propType === propTypes.SHAPE
                      ? scoped_bm_rt.v
                      : scoped_bm_rt))
            );
          }
          return (
            (executeExpression.__preventDeadCodeRemoval = [
              $bm_transform,
              anchorPoint,
              time,
              velocity,
              inPoint,
              outPoint,
              width,
              height,
              name,
              loop_in,
              loop_out,
              smooth,
              toComp,
              fromCompToSurface,
              toWorld,
              fromWorld,
              mask,
              position,
              rotation,
              scale,
              thisComp,
              numKeys,
              active,
              wiggle,
              loopInDuration,
              loopOutDuration,
              comp,
              lookAt,
              easeOut,
              easeIn,
              ease,
              nearestKey,
              key,
              text,
              textIndex,
              textTotal,
              selectorValue,
              framesToTime,
              timeToFrames,
              sourceRectAtTime,
              substring,
              substr,
              posterizeTime,
              index,
              globalData,
            ]),
            executeExpression
          );
        }
        return (
          (ob.initiateExpression = initiateExpression),
          (ob.__preventDeadCodeRemoval = [
            window,
            document,
            XMLHttpRequest,
            fetch,
            frames,
            $bm_neg,
            add,
            $bm_sum,
            $bm_sub,
            $bm_mul,
            $bm_div,
            $bm_mod,
            clamp,
            radians_to_degrees,
            degreesToRadians,
            degrees_to_radians,
            normalize,
            rgbToHsl,
            hslToRgb,
            linear,
            random,
            createPath,
          ]),
          ob
        );
      })(),
      expressionHelpers = {
        searchExpressions: function (t, e, r) {
          e.x &&
            ((r.k = !0),
            (r.x = !0),
            (r.initiateExpression = ExpressionManager.initiateExpression),
            r.effectsSequence.push(r.initiateExpression(t, e, r).bind(r)));
        },
        getSpeedAtTime: function (t) {
          var e = this.getValueAtTime(t),
            r = this.getValueAtTime(t + -0.01),
            i = 0;
          if (e.length) {
            var s;
            for (s = 0; s < e.length; s += 1) i += Math.pow(r[s] - e[s], 2);
            i = 100 * Math.sqrt(i);
          } else i = 0;
          return i;
        },
        getVelocityAtTime: function (t) {
          if (void 0 !== this.vel) return this.vel;
          var e,
            r,
            i = -0.001,
            s = this.getValueAtTime(t),
            a = this.getValueAtTime(t + i);
          if (s.length)
            for (
              e = createTypedArray("float32", s.length), r = 0;
              r < s.length;
              r += 1
            )
              e[r] = (a[r] - s[r]) / i;
          else e = (a - s) / i;
          return e;
        },
        getValueAtTime: function (t) {
          return (
            (t *= this.elem.globalData.frameRate),
            (t -= this.offsetTime) !== this._cachingAtTime.lastFrame &&
              ((this._cachingAtTime.lastIndex =
                this._cachingAtTime.lastFrame < t
                  ? this._cachingAtTime.lastIndex
                  : 0),
              (this._cachingAtTime.value = this.interpolateValue(
                t,
                this._cachingAtTime
              )),
              (this._cachingAtTime.lastFrame = t)),
            this._cachingAtTime.value
          );
        },
        getStaticValueAtTime: function () {
          return this.pv;
        },
        setGroupProperty: function (t) {
          this.propertyGroup = t;
        },
      };
    function addPropertyDecorator() {
      function t(t, e, r) {
        if (!this.k || !this.keyframes) return this.pv;
        t = t ? t.toLowerCase() : "";
        var i,
          s,
          a,
          n,
          o,
          h = this.comp.renderedFrame,
          l = this.keyframes,
          p = l[l.length - 1].t;
        if (h <= p) return this.pv;
        if (
          (r
            ? (s =
                p -
                (i = e
                  ? Math.abs(p - this.elem.comp.globalData.frameRate * e)
                  : Math.max(0, p - this.elem.data.ip)))
            : ((!e || e > l.length - 1) && (e = l.length - 1),
              (i = p - (s = l[l.length - 1 - e].t))),
          "pingpong" === t)
        ) {
          if (Math.floor((h - s) / i) % 2 != 0)
            return this.getValueAtTime(
              (i - ((h - s) % i) + s) / this.comp.globalData.frameRate,
              0
            );
        } else {
          if ("offset" === t) {
            var f = this.getValueAtTime(s / this.comp.globalData.frameRate, 0),
              m = this.getValueAtTime(p / this.comp.globalData.frameRate, 0),
              c = this.getValueAtTime(
                (((h - s) % i) + s) / this.comp.globalData.frameRate,
                0
              ),
              d = Math.floor((h - s) / i);
            if (this.pv.length) {
              for (n = (o = new Array(f.length)).length, a = 0; a < n; a += 1)
                o[a] = (m[a] - f[a]) * d + c[a];
              return o;
            }
            return (m - f) * d + c;
          }
          if ("continue" === t) {
            var u = this.getValueAtTime(p / this.comp.globalData.frameRate, 0),
              y = this.getValueAtTime(
                (p - 0.001) / this.comp.globalData.frameRate,
                0
              );
            if (this.pv.length) {
              for (n = (o = new Array(u.length)).length, a = 0; a < n; a += 1)
                o[a] =
                  u[a] +
                  ((u[a] - y[a]) * ((h - p) / this.comp.globalData.frameRate)) /
                    5e-4;
              return o;
            }
            return u + ((h - p) / 0.001) * (u - y);
          }
        }
        return this.getValueAtTime(
          (((h - s) % i) + s) / this.comp.globalData.frameRate,
          0
        );
      }
      function e(t, e, r) {
        if (!this.k) return this.pv;
        t = t ? t.toLowerCase() : "";
        var i,
          s,
          a,
          n,
          o,
          h = this.comp.renderedFrame,
          l = this.keyframes,
          p = l[0].t;
        if (h >= p) return this.pv;
        if (
          (r
            ? (s =
                p +
                (i = e
                  ? Math.abs(this.elem.comp.globalData.frameRate * e)
                  : Math.max(0, this.elem.data.op - p)))
            : ((!e || e > l.length - 1) && (e = l.length - 1),
              (i = (s = l[e].t) - p)),
          "pingpong" === t)
        ) {
          if (Math.floor((p - h) / i) % 2 == 0)
            return this.getValueAtTime(
              (((p - h) % i) + p) / this.comp.globalData.frameRate,
              0
            );
        } else {
          if ("offset" === t) {
            var f = this.getValueAtTime(p / this.comp.globalData.frameRate, 0),
              m = this.getValueAtTime(s / this.comp.globalData.frameRate, 0),
              c = this.getValueAtTime(
                (i - ((p - h) % i) + p) / this.comp.globalData.frameRate,
                0
              ),
              d = Math.floor((p - h) / i) + 1;
            if (this.pv.length) {
              for (n = (o = new Array(f.length)).length, a = 0; a < n; a += 1)
                o[a] = c[a] - (m[a] - f[a]) * d;
              return o;
            }
            return c - (m - f) * d;
          }
          if ("continue" === t) {
            var u = this.getValueAtTime(p / this.comp.globalData.frameRate, 0),
              y = this.getValueAtTime(
                (p + 0.001) / this.comp.globalData.frameRate,
                0
              );
            if (this.pv.length) {
              for (n = (o = new Array(u.length)).length, a = 0; a < n; a += 1)
                o[a] = u[a] + ((u[a] - y[a]) * (p - h)) / 0.001;
              return o;
            }
            return u + ((u - y) * (p - h)) / 0.001;
          }
        }
        return this.getValueAtTime(
          (i - (((p - h) % i) + p)) / this.comp.globalData.frameRate,
          0
        );
      }
      function r(t, e) {
        if (!this.k) return this.pv;
        if (((t = 0.5 * (t || 0.4)), (e = Math.floor(e || 5)) <= 1))
          return this.pv;
        var r,
          i,
          s = this.comp.renderedFrame / this.comp.globalData.frameRate,
          a = s - t,
          n = e > 1 ? (s + t - a) / (e - 1) : 1,
          o = 0,
          h = 0;
        for (
          r = this.pv.length ? createTypedArray("float32", this.pv.length) : 0;
          o < e;

        ) {
          if (((i = this.getValueAtTime(a + o * n)), this.pv.length))
            for (h = 0; h < this.pv.length; h += 1) r[h] += i[h];
          else r += i;
          o += 1;
        }
        if (this.pv.length) for (h = 0; h < this.pv.length; h += 1) r[h] /= e;
        else r /= e;
        return r;
      }
      function i(t) {
        this._transformCachingAtTime ||
          (this._transformCachingAtTime = { v: new Matrix() });
        var e = this._transformCachingAtTime.v;
        if (
          (e.cloneFromProps(this.pre.props), this.appliedTransformations < 1)
        ) {
          var r = this.a.getValueAtTime(t);
          e.translate(
            -r[0] * this.a.mult,
            -r[1] * this.a.mult,
            r[2] * this.a.mult
          );
        }
        if (this.appliedTransformations < 2) {
          var i = this.s.getValueAtTime(t);
          e.scale(i[0] * this.s.mult, i[1] * this.s.mult, i[2] * this.s.mult);
        }
        if (this.sk && this.appliedTransformations < 3) {
          var s = this.sk.getValueAtTime(t),
            a = this.sa.getValueAtTime(t);
          e.skewFromAxis(-s * this.sk.mult, a * this.sa.mult);
        }
        if (this.r && this.appliedTransformations < 4) {
          var n = this.r.getValueAtTime(t);
          e.rotate(-n * this.r.mult);
        } else if (!this.r && this.appliedTransformations < 4) {
          var o = this.rz.getValueAtTime(t),
            h = this.ry.getValueAtTime(t),
            l = this.rx.getValueAtTime(t),
            p = this.or.getValueAtTime(t);
          e.rotateZ(-o * this.rz.mult)
            .rotateY(h * this.ry.mult)
            .rotateX(l * this.rx.mult)
            .rotateZ(-p[2] * this.or.mult)
            .rotateY(p[1] * this.or.mult)
            .rotateX(p[0] * this.or.mult);
        }
        if (this.data.p && this.data.p.s) {
          var f = this.px.getValueAtTime(t),
            m = this.py.getValueAtTime(t);
          if (this.data.p.z) {
            var c = this.pz.getValueAtTime(t);
            e.translate(f * this.px.mult, m * this.py.mult, -c * this.pz.mult);
          } else e.translate(f * this.px.mult, m * this.py.mult, 0);
        } else {
          var d = this.p.getValueAtTime(t);
          e.translate(
            d[0] * this.p.mult,
            d[1] * this.p.mult,
            -d[2] * this.p.mult
          );
        }
        return e;
      }
      function s() {
        return this.v.clone(new Matrix());
      }
      var a = TransformPropertyFactory.getTransformProperty;
      TransformPropertyFactory.getTransformProperty = function (t, e, r) {
        var n = a(t, e, r);
        return (
          n.dynamicProperties.length
            ? (n.getValueAtTime = i.bind(n))
            : (n.getValueAtTime = s.bind(n)),
          (n.setGroupProperty = expressionHelpers.setGroupProperty),
          n
        );
      };
      var n = PropertyFactory.getProp;
      PropertyFactory.getProp = function (i, s, a, o, h) {
        var l = n(i, s, a, o, h);
        l.kf
          ? (l.getValueAtTime = expressionHelpers.getValueAtTime.bind(l))
          : (l.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(l)),
          (l.setGroupProperty = expressionHelpers.setGroupProperty),
          (l.loopOut = t),
          (l.loopIn = e),
          (l.smooth = r),
          (l.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(l)),
          (l.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(l)),
          (l.numKeys = 1 === s.a ? s.k.length : 0),
          (l.propertyIndex = s.ix);
        var p = 0;
        return (
          0 !== a &&
            (p = createTypedArray(
              "float32",
              1 === s.a ? s.k[0].s.length : s.k.length
            )),
          (l._cachingAtTime = {
            lastFrame: initialDefaultFrame,
            lastIndex: 0,
            value: p,
          }),
          expressionHelpers.searchExpressions(i, s, l),
          l.k && h.addDynamicProperty(l),
          l
        );
      };
      var o = ShapePropertyFactory.getConstructorFunction(),
        h = ShapePropertyFactory.getKeyframedConstructorFunction();
      function l() {}
      (l.prototype = {
        vertices: function (t, e) {
          this.k && this.getValue();
          var r,
            i = this.v;
          void 0 !== e && (i = this.getValueAtTime(e, 0));
          var s = i._length,
            a = i[t],
            n = i.v,
            o = createSizedArray(s);
          for (r = 0; r < s; r += 1)
            o[r] =
              "i" === t || "o" === t
                ? [a[r][0] - n[r][0], a[r][1] - n[r][1]]
                : [a[r][0], a[r][1]];
          return o;
        },
        points: function (t) {
          return this.vertices("v", t);
        },
        inTangents: function (t) {
          return this.vertices("i", t);
        },
        outTangents: function (t) {
          return this.vertices("o", t);
        },
        isClosed: function () {
          return this.v.c;
        },
        pointOnPath: function (t, e) {
          var r = this.v;
          void 0 !== e && (r = this.getValueAtTime(e, 0)),
            this._segmentsLength ||
              (this._segmentsLength = bez.getSegmentsLength(r));
          for (
            var i,
              s = this._segmentsLength,
              a = s.lengths,
              n = s.totalLength * t,
              o = 0,
              h = a.length,
              l = 0;
            o < h;

          ) {
            if (l + a[o].addedLength > n) {
              var p = o,
                f = r.c && o === h - 1 ? 0 : o + 1,
                m = (n - l) / a[o].addedLength;
              i = bez.getPointInSegment(
                r.v[p],
                r.v[f],
                r.o[p],
                r.i[f],
                m,
                a[o]
              );
              break;
            }
            (l += a[o].addedLength), (o += 1);
          }
          return (
            i ||
              (i = r.c
                ? [r.v[0][0], r.v[0][1]]
                : [r.v[r._length - 1][0], r.v[r._length - 1][1]]),
            i
          );
        },
        vectorOnPath: function (t, e, r) {
          1 == t ? (t = this.v.c) : 0 == t && (t = 0.999);
          var i = this.pointOnPath(t, e),
            s = this.pointOnPath(t + 0.001, e),
            a = s[0] - i[0],
            n = s[1] - i[1],
            o = Math.sqrt(Math.pow(a, 2) + Math.pow(n, 2));
          return 0 === o
            ? [0, 0]
            : "tangent" === r
            ? [a / o, n / o]
            : [-n / o, a / o];
        },
        tangentOnPath: function (t, e) {
          return this.vectorOnPath(t, e, "tangent");
        },
        normalOnPath: function (t, e) {
          return this.vectorOnPath(t, e, "normal");
        },
        setGroupProperty: expressionHelpers.setGroupProperty,
        getValueAtTime: expressionHelpers.getStaticValueAtTime,
      }),
        extendPrototype([l], o),
        extendPrototype([l], h),
        (h.prototype.getValueAtTime = function (t) {
          return (
            this._cachingAtTime ||
              (this._cachingAtTime = {
                shapeValue: shapePool.clone(this.pv),
                lastIndex: 0,
                lastTime: initialDefaultFrame,
              }),
            (t *= this.elem.globalData.frameRate),
            (t -= this.offsetTime) !== this._cachingAtTime.lastTime &&
              ((this._cachingAtTime.lastIndex =
                this._cachingAtTime.lastTime < t ? this._caching.lastIndex : 0),
              (this._cachingAtTime.lastTime = t),
              this.interpolateShape(
                t,
                this._cachingAtTime.shapeValue,
                this._cachingAtTime
              )),
            this._cachingAtTime.shapeValue
          );
        }),
        (h.prototype.initiateExpression = ExpressionManager.initiateExpression);
      var p = ShapePropertyFactory.getShapeProp;
      ShapePropertyFactory.getShapeProp = function (t, e, r, i, s) {
        var a = p(t, e, r, i, s);
        return (
          (a.propertyIndex = e.ix),
          (a.lock = !1),
          3 === r
            ? expressionHelpers.searchExpressions(t, e.pt, a)
            : 4 === r && expressionHelpers.searchExpressions(t, e.ks, a),
          a.k && t.addDynamicProperty(a),
          a
        );
      };
    }
    function initialize$1() {
      addPropertyDecorator();
    }
    function addDecorator() {
      (TextProperty.prototype.getExpressionValue = function (t, e) {
        var r = this.calculateExpression(e);
        if (t.t !== r) {
          var i = {};
          return (
            this.copyData(i, t), (i.t = r.toString()), (i.__complete = !1), i
          );
        }
        return t;
      }),
        (TextProperty.prototype.searchProperty = function () {
          var t = this.searchKeyframes(),
            e = this.searchExpressions();
          return (this.kf = t || e), this.kf;
        }),
        (TextProperty.prototype.searchExpressions = function () {
          return this.data.d.x
            ? ((this.calculateExpression =
                ExpressionManager.initiateExpression.bind(this)(
                  this.elem,
                  this.data.d,
                  this
                )),
              this.addEffect(this.getExpressionValue.bind(this)),
              !0)
            : null;
        });
    }
    function initialize() {
      addDecorator();
    }
    function SVGComposableEffect() {}
    function SVGTintFilter(t, e, r, i, s) {
      this.filterManager = e;
      var a = createNS("feColorMatrix");
      a.setAttribute("type", "matrix"),
        a.setAttribute("color-interpolation-filters", "linearRGB"),
        a.setAttribute(
          "values",
          "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"
        ),
        a.setAttribute("result", i + "_tint_1"),
        t.appendChild(a),
        (a = createNS("feColorMatrix")).setAttribute("type", "matrix"),
        a.setAttribute("color-interpolation-filters", "sRGB"),
        a.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"),
        a.setAttribute("result", i + "_tint_2"),
        t.appendChild(a),
        (this.matrixFilter = a);
      var n = this.createMergeNode(i, [s, i + "_tint_1", i + "_tint_2"]);
      t.appendChild(n);
    }
    function SVGFillFilter(t, e, r, i) {
      this.filterManager = e;
      var s = createNS("feColorMatrix");
      s.setAttribute("type", "matrix"),
        s.setAttribute("color-interpolation-filters", "sRGB"),
        s.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"),
        s.setAttribute("result", i),
        t.appendChild(s),
        (this.matrixFilter = s);
    }
    function SVGStrokeEffect(t, e, r) {
      (this.initialized = !1),
        (this.filterManager = e),
        (this.elem = r),
        (this.paths = []);
    }
    function SVGTritoneFilter(t, e, r, i) {
      this.filterManager = e;
      var s = createNS("feColorMatrix");
      s.setAttribute("type", "matrix"),
        s.setAttribute("color-interpolation-filters", "linearRGB"),
        s.setAttribute(
          "values",
          "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"
        ),
        t.appendChild(s);
      var a = createNS("feComponentTransfer");
      a.setAttribute("color-interpolation-filters", "sRGB"),
        a.setAttribute("result", i),
        (this.matrixFilter = a);
      var n = createNS("feFuncR");
      n.setAttribute("type", "table"), a.appendChild(n), (this.feFuncR = n);
      var o = createNS("feFuncG");
      o.setAttribute("type", "table"), a.appendChild(o), (this.feFuncG = o);
      var h = createNS("feFuncB");
      h.setAttribute("type", "table"),
        a.appendChild(h),
        (this.feFuncB = h),
        t.appendChild(a);
    }
    function SVGProLevelsFilter(t, e, r, i) {
      this.filterManager = e;
      var s = this.filterManager.effectElements,
        a = createNS("feComponentTransfer");
      (s[10].p.k ||
        0 !== s[10].p.v ||
        s[11].p.k ||
        1 !== s[11].p.v ||
        s[12].p.k ||
        1 !== s[12].p.v ||
        s[13].p.k ||
        0 !== s[13].p.v ||
        s[14].p.k ||
        1 !== s[14].p.v) &&
        (this.feFuncR = this.createFeFunc("feFuncR", a)),
        (s[17].p.k ||
          0 !== s[17].p.v ||
          s[18].p.k ||
          1 !== s[18].p.v ||
          s[19].p.k ||
          1 !== s[19].p.v ||
          s[20].p.k ||
          0 !== s[20].p.v ||
          s[21].p.k ||
          1 !== s[21].p.v) &&
          (this.feFuncG = this.createFeFunc("feFuncG", a)),
        (s[24].p.k ||
          0 !== s[24].p.v ||
          s[25].p.k ||
          1 !== s[25].p.v ||
          s[26].p.k ||
          1 !== s[26].p.v ||
          s[27].p.k ||
          0 !== s[27].p.v ||
          s[28].p.k ||
          1 !== s[28].p.v) &&
          (this.feFuncB = this.createFeFunc("feFuncB", a)),
        (s[31].p.k ||
          0 !== s[31].p.v ||
          s[32].p.k ||
          1 !== s[32].p.v ||
          s[33].p.k ||
          1 !== s[33].p.v ||
          s[34].p.k ||
          0 !== s[34].p.v ||
          s[35].p.k ||
          1 !== s[35].p.v) &&
          (this.feFuncA = this.createFeFunc("feFuncA", a)),
        (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) &&
          (a.setAttribute("color-interpolation-filters", "sRGB"),
          t.appendChild(a)),
        (s[3].p.k ||
          0 !== s[3].p.v ||
          s[4].p.k ||
          1 !== s[4].p.v ||
          s[5].p.k ||
          1 !== s[5].p.v ||
          s[6].p.k ||
          0 !== s[6].p.v ||
          s[7].p.k ||
          1 !== s[7].p.v) &&
          ((a = createNS("feComponentTransfer")).setAttribute(
            "color-interpolation-filters",
            "sRGB"
          ),
          a.setAttribute("result", i),
          t.appendChild(a),
          (this.feFuncRComposed = this.createFeFunc("feFuncR", a)),
          (this.feFuncGComposed = this.createFeFunc("feFuncG", a)),
          (this.feFuncBComposed = this.createFeFunc("feFuncB", a)));
    }
    function SVGDropShadowEffect(t, e, r, i, s) {
      var a = e.container.globalData.renderConfig.filterSize;
      t.setAttribute("x", a.x),
        t.setAttribute("y", a.y),
        t.setAttribute("width", a.width),
        t.setAttribute("height", a.height),
        (this.filterManager = e);
      var n = createNS("feGaussianBlur");
      n.setAttribute("in", "SourceAlpha"),
        n.setAttribute("result", i + "_drop_shadow_1"),
        n.setAttribute("stdDeviation", "0"),
        (this.feGaussianBlur = n),
        t.appendChild(n);
      var o = createNS("feOffset");
      o.setAttribute("dx", "25"),
        o.setAttribute("dy", "0"),
        o.setAttribute("in", i + "_drop_shadow_1"),
        o.setAttribute("result", i + "_drop_shadow_2"),
        (this.feOffset = o),
        t.appendChild(o);
      var h = createNS("feFlood");
      h.setAttribute("flood-color", "#00ff00"),
        h.setAttribute("flood-opacity", "1"),
        h.setAttribute("result", i + "_drop_shadow_3"),
        (this.feFlood = h),
        t.appendChild(h);
      var l = createNS("feComposite");
      l.setAttribute("in", i + "_drop_shadow_3"),
        l.setAttribute("in2", i + "_drop_shadow_2"),
        l.setAttribute("operator", "in"),
        l.setAttribute("result", i + "_drop_shadow_4"),
        t.appendChild(l);
      var p = this.createMergeNode(i, [i + "_drop_shadow_4", s]);
      t.appendChild(p);
    }
    (SVGComposableEffect.prototype = {
      createMergeNode: function (t, e) {
        var r,
          i,
          s = createNS("feMerge");
        for (s.setAttribute("result", t), i = 0; i < e.length; i += 1)
          (r = createNS("feMergeNode")).setAttribute("in", e[i]),
            s.appendChild(r),
            s.appendChild(r);
        return s;
      },
    }),
      extendPrototype([SVGComposableEffect], SVGTintFilter),
      (SVGTintFilter.prototype.renderFrame = function (t) {
        if (t || this.filterManager._mdf) {
          var e = this.filterManager.effectElements[0].p.v,
            r = this.filterManager.effectElements[1].p.v,
            i = this.filterManager.effectElements[2].p.v / 100;
          this.matrixFilter.setAttribute(
            "values",
            r[0] -
              e[0] +
              " 0 0 0 " +
              e[0] +
              " " +
              (r[1] - e[1]) +
              " 0 0 0 " +
              e[1] +
              " " +
              (r[2] - e[2]) +
              " 0 0 0 " +
              e[2] +
              " 0 0 0 " +
              i +
              " 0"
          );
        }
      }),
      (SVGFillFilter.prototype.renderFrame = function (t) {
        if (t || this.filterManager._mdf) {
          var e = this.filterManager.effectElements[2].p.v,
            r = this.filterManager.effectElements[6].p.v;
          this.matrixFilter.setAttribute(
            "values",
            "0 0 0 0 " +
              e[0] +
              " 0 0 0 0 " +
              e[1] +
              " 0 0 0 0 " +
              e[2] +
              " 0 0 0 " +
              r +
              " 0"
          );
        }
      }),
      (SVGStrokeEffect.prototype.initialize = function () {
        var t,
          e,
          r,
          i,
          s =
            this.elem.layerElement.children ||
            this.elem.layerElement.childNodes;
        for (
          1 === this.filterManager.effectElements[1].p.v
            ? ((i = this.elem.maskManager.masksProperties.length), (r = 0))
            : (i = (r = this.filterManager.effectElements[0].p.v - 1) + 1),
            (e = createNS("g")).setAttribute("fill", "none"),
            e.setAttribute("stroke-linecap", "round"),
            e.setAttribute("stroke-dashoffset", 1);
          r < i;
          r += 1
        )
          (t = createNS("path")),
            e.appendChild(t),
            this.paths.push({ p: t, m: r });
        if (3 === this.filterManager.effectElements[10].p.v) {
          var a = createNS("mask"),
            n = createElementID();
          a.setAttribute("id", n),
            a.setAttribute("mask-type", "alpha"),
            a.appendChild(e),
            this.elem.globalData.defs.appendChild(a);
          var o = createNS("g");
          for (
            o.setAttribute("mask", "url(" + getLocationHref() + "#" + n + ")");
            s[0];

          )
            o.appendChild(s[0]);
          this.elem.layerElement.appendChild(o),
            (this.masker = a),
            e.setAttribute("stroke", "#fff");
        } else if (
          1 === this.filterManager.effectElements[10].p.v ||
          2 === this.filterManager.effectElements[10].p.v
        ) {
          if (2 === this.filterManager.effectElements[10].p.v)
            for (
              s =
                this.elem.layerElement.children ||
                this.elem.layerElement.childNodes;
              s.length;

            )
              this.elem.layerElement.removeChild(s[0]);
          this.elem.layerElement.appendChild(e),
            this.elem.layerElement.removeAttribute("mask"),
            e.setAttribute("stroke", "#fff");
        }
        (this.initialized = !0), (this.pathMasker = e);
      }),
      (SVGStrokeEffect.prototype.renderFrame = function (t) {
        var e;
        this.initialized || this.initialize();
        var r,
          i,
          s = this.paths.length;
        for (e = 0; e < s; e += 1)
          if (
            -1 !== this.paths[e].m &&
            ((r = this.elem.maskManager.viewData[this.paths[e].m]),
            (i = this.paths[e].p),
            (t || this.filterManager._mdf || r.prop._mdf) &&
              i.setAttribute("d", r.lastPath),
            t ||
              this.filterManager.effectElements[9].p._mdf ||
              this.filterManager.effectElements[4].p._mdf ||
              this.filterManager.effectElements[7].p._mdf ||
              this.filterManager.effectElements[8].p._mdf ||
              r.prop._mdf)
          ) {
            var a;
            if (
              0 !== this.filterManager.effectElements[7].p.v ||
              100 !== this.filterManager.effectElements[8].p.v
            ) {
              var n =
                  0.01 *
                  Math.min(
                    this.filterManager.effectElements[7].p.v,
                    this.filterManager.effectElements[8].p.v
                  ),
                o =
                  0.01 *
                  Math.max(
                    this.filterManager.effectElements[7].p.v,
                    this.filterManager.effectElements[8].p.v
                  ),
                h = i.getTotalLength();
              a = "0 0 0 " + h * n + " ";
              var l,
                p = h * (o - n),
                f =
                  1 +
                  2 *
                    this.filterManager.effectElements[4].p.v *
                    this.filterManager.effectElements[9].p.v *
                    0.01,
                m = Math.floor(p / f);
              for (l = 0; l < m; l += 1)
                a +=
                  "1 " +
                  2 *
                    this.filterManager.effectElements[4].p.v *
                    this.filterManager.effectElements[9].p.v *
                    0.01 +
                  " ";
              a += "0 " + 10 * h + " 0 0";
            } else
              a =
                "1 " +
                2 *
                  this.filterManager.effectElements[4].p.v *
                  this.filterManager.effectElements[9].p.v *
                  0.01;
            i.setAttribute("stroke-dasharray", a);
          }
        if (
          ((t || this.filterManager.effectElements[4].p._mdf) &&
            this.pathMasker.setAttribute(
              "stroke-width",
              2 * this.filterManager.effectElements[4].p.v
            ),
          (t || this.filterManager.effectElements[6].p._mdf) &&
            this.pathMasker.setAttribute(
              "opacity",
              this.filterManager.effectElements[6].p.v
            ),
          (1 === this.filterManager.effectElements[10].p.v ||
            2 === this.filterManager.effectElements[10].p.v) &&
            (t || this.filterManager.effectElements[3].p._mdf))
        ) {
          var c = this.filterManager.effectElements[3].p.v;
          this.pathMasker.setAttribute(
            "stroke",
            "rgb(" +
              bmFloor(255 * c[0]) +
              "," +
              bmFloor(255 * c[1]) +
              "," +
              bmFloor(255 * c[2]) +
              ")"
          );
        }
      }),
      (SVGTritoneFilter.prototype.renderFrame = function (t) {
        if (t || this.filterManager._mdf) {
          var e = this.filterManager.effectElements[0].p.v,
            r = this.filterManager.effectElements[1].p.v,
            i = this.filterManager.effectElements[2].p.v,
            s = i[0] + " " + r[0] + " " + e[0],
            a = i[1] + " " + r[1] + " " + e[1],
            n = i[2] + " " + r[2] + " " + e[2];
          this.feFuncR.setAttribute("tableValues", s),
            this.feFuncG.setAttribute("tableValues", a),
            this.feFuncB.setAttribute("tableValues", n);
        }
      }),
      (SVGProLevelsFilter.prototype.createFeFunc = function (t, e) {
        var r = createNS(t);
        return r.setAttribute("type", "table"), e.appendChild(r), r;
      }),
      (SVGProLevelsFilter.prototype.getTableValue = function (t, e, r, i, s) {
        for (
          var a,
            n,
            o = 0,
            h = Math.min(t, e),
            l = Math.max(t, e),
            p = Array.call(null, { length: 256 }),
            f = 0,
            m = s - i,
            c = e - t;
          o <= 256;

        )
          (n =
            (a = o / 256) <= h
              ? c < 0
                ? s
                : i
              : a >= l
              ? c < 0
                ? i
                : s
              : i + m * Math.pow((a - t) / c, 1 / r)),
            (p[f] = n),
            (f += 1),
            (o += 256 / 255);
        return p.join(" ");
      }),
      (SVGProLevelsFilter.prototype.renderFrame = function (t) {
        if (t || this.filterManager._mdf) {
          var e,
            r = this.filterManager.effectElements;
          this.feFuncRComposed &&
            (t ||
              r[3].p._mdf ||
              r[4].p._mdf ||
              r[5].p._mdf ||
              r[6].p._mdf ||
              r[7].p._mdf) &&
            ((e = this.getTableValue(
              r[3].p.v,
              r[4].p.v,
              r[5].p.v,
              r[6].p.v,
              r[7].p.v
            )),
            this.feFuncRComposed.setAttribute("tableValues", e),
            this.feFuncGComposed.setAttribute("tableValues", e),
            this.feFuncBComposed.setAttribute("tableValues", e)),
            this.feFuncR &&
              (t ||
                r[10].p._mdf ||
                r[11].p._mdf ||
                r[12].p._mdf ||
                r[13].p._mdf ||
                r[14].p._mdf) &&
              ((e = this.getTableValue(
                r[10].p.v,
                r[11].p.v,
                r[12].p.v,
                r[13].p.v,
                r[14].p.v
              )),
              this.feFuncR.setAttribute("tableValues", e)),
            this.feFuncG &&
              (t ||
                r[17].p._mdf ||
                r[18].p._mdf ||
                r[19].p._mdf ||
                r[20].p._mdf ||
                r[21].p._mdf) &&
              ((e = this.getTableValue(
                r[17].p.v,
                r[18].p.v,
                r[19].p.v,
                r[20].p.v,
                r[21].p.v
              )),
              this.feFuncG.setAttribute("tableValues", e)),
            this.feFuncB &&
              (t ||
                r[24].p._mdf ||
                r[25].p._mdf ||
                r[26].p._mdf ||
                r[27].p._mdf ||
                r[28].p._mdf) &&
              ((e = this.getTableValue(
                r[24].p.v,
                r[25].p.v,
                r[26].p.v,
                r[27].p.v,
                r[28].p.v
              )),
              this.feFuncB.setAttribute("tableValues", e)),
            this.feFuncA &&
              (t ||
                r[31].p._mdf ||
                r[32].p._mdf ||
                r[33].p._mdf ||
                r[34].p._mdf ||
                r[35].p._mdf) &&
              ((e = this.getTableValue(
                r[31].p.v,
                r[32].p.v,
                r[33].p.v,
                r[34].p.v,
                r[35].p.v
              )),
              this.feFuncA.setAttribute("tableValues", e));
        }
      }),
      extendPrototype([SVGComposableEffect], SVGDropShadowEffect),
      (SVGDropShadowEffect.prototype.renderFrame = function (t) {
        if (t || this.filterManager._mdf) {
          if (
            ((t || this.filterManager.effectElements[4].p._mdf) &&
              this.feGaussianBlur.setAttribute(
                "stdDeviation",
                this.filterManager.effectElements[4].p.v / 4
              ),
            t || this.filterManager.effectElements[0].p._mdf)
          ) {
            var e = this.filterManager.effectElements[0].p.v;
            this.feFlood.setAttribute(
              "flood-color",
              rgbToHex(
                Math.round(255 * e[0]),
                Math.round(255 * e[1]),
                Math.round(255 * e[2])
              )
            );
          }
          if (
            ((t || this.filterManager.effectElements[1].p._mdf) &&
              this.feFlood.setAttribute(
                "flood-opacity",
                this.filterManager.effectElements[1].p.v / 255
              ),
            t ||
              this.filterManager.effectElements[2].p._mdf ||
              this.filterManager.effectElements[3].p._mdf)
          ) {
            var r = this.filterManager.effectElements[3].p.v,
              i = (this.filterManager.effectElements[2].p.v - 90) * degToRads,
              s = r * Math.cos(i),
              a = r * Math.sin(i);
            this.feOffset.setAttribute("dx", s),
              this.feOffset.setAttribute("dy", a);
          }
        }
      });
    var _svgMatteSymbols = [];
    function SVGMatte3Effect(t, e, r) {
      (this.initialized = !1),
        (this.filterManager = e),
        (this.filterElem = t),
        (this.elem = r),
        (r.matteElement = createNS("g")),
        r.matteElement.appendChild(r.layerElement),
        r.matteElement.appendChild(r.transformedElement),
        (r.baseElement = r.matteElement);
    }
    function SVGGaussianBlurEffect(t, e, r, i) {
      t.setAttribute("x", "-100%"),
        t.setAttribute("y", "-100%"),
        t.setAttribute("width", "300%"),
        t.setAttribute("height", "300%"),
        (this.filterManager = e);
      var s = createNS("feGaussianBlur");
      s.setAttribute("result", i), t.appendChild(s), (this.feGaussianBlur = s);
    }
    return (
      (SVGMatte3Effect.prototype.findSymbol = function (t) {
        for (var e = 0, r = _svgMatteSymbols.length; e < r; ) {
          if (_svgMatteSymbols[e] === t) return _svgMatteSymbols[e];
          e += 1;
        }
        return null;
      }),
      (SVGMatte3Effect.prototype.replaceInParent = function (t, e) {
        var r = t.layerElement.parentNode;
        if (r) {
          for (
            var i, s = r.children, a = 0, n = s.length;
            a < n && s[a] !== t.layerElement;

          )
            a += 1;
          a <= n - 2 && (i = s[a + 1]);
          var o = createNS("use");
          o.setAttribute("href", "#" + e),
            i ? r.insertBefore(o, i) : r.appendChild(o);
        }
      }),
      (SVGMatte3Effect.prototype.setElementAsMask = function (t, e) {
        if (!this.findSymbol(e)) {
          var r = createElementID(),
            i = createNS("mask");
          i.setAttribute("id", e.layerId),
            i.setAttribute("mask-type", "alpha"),
            _svgMatteSymbols.push(e);
          var s = t.globalData.defs;
          s.appendChild(i);
          var a = createNS("symbol");
          a.setAttribute("id", r),
            this.replaceInParent(e, r),
            a.appendChild(e.layerElement),
            s.appendChild(a);
          var n = createNS("use");
          n.setAttribute("href", "#" + r),
            i.appendChild(n),
            (e.data.hd = !1),
            e.show();
        }
        t.setMatte(e.layerId);
      }),
      (SVGMatte3Effect.prototype.initialize = function () {
        for (
          var t = this.filterManager.effectElements[0].p.v,
            e = this.elem.comp.elements,
            r = 0,
            i = e.length;
          r < i;

        )
          e[r] && e[r].data.ind === t && this.setElementAsMask(this.elem, e[r]),
            (r += 1);
        this.initialized = !0;
      }),
      (SVGMatte3Effect.prototype.renderFrame = function () {
        this.initialized || this.initialize();
      }),
      (SVGGaussianBlurEffect.prototype.renderFrame = function (t) {
        if (t || this.filterManager._mdf) {
          var e = 0.3 * this.filterManager.effectElements[0].p.v,
            r = this.filterManager.effectElements[1].p.v,
            i = 3 == r ? 0 : e,
            s = 2 == r ? 0 : e;
          this.feGaussianBlur.setAttribute("stdDeviation", i + " " + s);
          var a =
            1 == this.filterManager.effectElements[2].p.v
              ? "wrap"
              : "duplicate";
          this.feGaussianBlur.setAttribute("edgeMode", a);
        }
      }),
      registerRenderer("canvas", CanvasRenderer),
      registerRenderer("html", HybridRenderer),
      registerRenderer("svg", SVGRenderer),
      ShapeModifiers.registerModifier("tm", TrimModifier),
      ShapeModifiers.registerModifier("pb", PuckerAndBloatModifier),
      ShapeModifiers.registerModifier("rp", RepeaterModifier),
      ShapeModifiers.registerModifier("rd", RoundCornersModifier),
      setExpressionsPlugin(Expressions),
      initialize$1(),
      initialize(),
      registerEffect(20, SVGTintFilter, !0),
      registerEffect(21, SVGFillFilter, !0),
      registerEffect(22, SVGStrokeEffect, !1),
      registerEffect(23, SVGTritoneFilter, !0),
      registerEffect(24, SVGProLevelsFilter, !0),
      registerEffect(25, SVGDropShadowEffect, !0),
      registerEffect(28, SVGMatte3Effect, !1),
      registerEffect(29, SVGGaussianBlurEffect, !0),
      lottie
    );
  });

let Arrow_Circle = document.querySelector(".index_arrow_icon");
let Arrow_Circle_animation = bodymovin.loadAnimation({
  container: Arrow_Circle,
  renderer: "svg",
  loop: true,
  autoplay: true,
  path: "https://cdn.shopify.com/s/files/1/0621/0168/4404/files/Arrow_Circle.json?v=1664247754",
});

let Arrow_Circle_2 = document.querySelector(".team_scroll_new");
let Arrow_Circle_animation_2 = bodymovin.loadAnimation({
  container: Arrow_Circle_2,
  renderer: "svg",
  loop: true,
  autoplay: true,
  path: "https://cdn.shopify.com/s/files/1/0621/0168/4404/files/Arrow_Circle.json?v=1664247754",
});

let Arrow_Circle_3 = document.querySelector(".value_scroll_new");
let Arrow_Circle_animation_3 = bodymovin.loadAnimation({
  container: Arrow_Circle_3,
  renderer: "svg",
  loop: true,
  autoplay: true,
  path: "https://cdn.shopify.com/s/files/1/0621/0168/4404/files/Arrow_Circle.json?v=1664247754",
});

var count = 0;
$(".Index_meta_blog_category_bottompart_textsarticle_icons_new").each(
  function () {
    count = count + 1;
    let Arrow_Circle_3 = document.querySelector(
      ".Index_meta_blog_category_bottompart_textsarticle_icons_new_" + count
    );
    let Arrow_Circle_animation_3 = bodymovin.loadAnimation({
      container: Arrow_Circle_3,
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: "https://cdn.shopify.com/s/files/1/0621/0168/4404/files/Arrow_Circle_2.json?v=1664247869",
    });
  }
);

let Arrow_Circle_4 = document.querySelector(
  ".Page_value_of_good_information_topheading_svg_icon_new"
);
let Arrow_Circle_animation_4 = bodymovin.loadAnimation({
  container: Arrow_Circle_4,
  renderer: "svg",
  loop: true,
  autoplay: true,
  path: "https://cdn.shopify.com/s/files/1/0621/0168/4404/files/spinner.json?v=1664438369",
});

let Arrow_Circle_5 = document.querySelector(".brands_icon_svg");
let Arrow_Circle_animation_5 = bodymovin.loadAnimation({
  container: Arrow_Circle_5,
  renderer: "svg",
  loop: true,
  autoplay: true,
  path: "https://cdn.shopify.com/s/files/1/0621/0168/4404/files/Brands.json?v=1664535267",
});

/* home page 5 icons */
let iconMenu1 = document.querySelector(".rightside_desksvgiconboxs_1");
let animationMenu1 = bodymovin.loadAnimation({
  container: iconMenu1,
  renderer: "svg",
  loop: false,
  autoplay: true,
  path: "https://cdn.shopify.com/s/files/1/0621/0168/4404/files/icon_1.json?v=1664248485",
});

let iconMenu2 = document.querySelector(".rightside_desksvgiconboxs_2");
let animationMenu2 = bodymovin.loadAnimation({
  container: iconMenu2,
  renderer: "svg",
  loop: false,
  autoplay: true,
  path: "https://cdn.shopify.com/s/files/1/0621/0168/4404/files/icon_5.json?v=1664248485",
});

let iconMenu3 = document.querySelector(".rightside_desksvgiconboxs_3");
let animationMenu3 = bodymovin.loadAnimation({
  container: iconMenu3,
  renderer: "svg",
  loop: false,
  autoplay: true,
  path: "https://cdn.shopify.com/s/files/1/0621/0168/4404/files/icon_2.json?v=1664248485",
});

let iconMenu4 = document.querySelector(".rightside_desksvgiconboxs_4");
let animationMenu4 = bodymovin.loadAnimation({
  container: iconMenu4,
  renderer: "svg",
  loop: false,
  autoplay: true,
  path: "https://cdn.shopify.com/s/files/1/0621/0168/4404/files/icon_3.json?v=1664248485",
});

let iconMenu5 = document.querySelector(".rightside_desksvgiconboxs_5");
let animationMenu5 = bodymovin.loadAnimation({
  container: iconMenu5,
  renderer: "svg",
  loop: false,
  autoplay: true,
  path: "https://cdn.shopify.com/s/files/1/0621/0168/4404/files/icon_4.json?v=1664248485",
});

animationMenu1.stop();
animationMenu2.stop();
animationMenu3.stop();
animationMenu4.stop();
animationMenu5.stop();

$(window).load(function () {
  var $el = $(".Index_icons_texts_loop_new"); //record the elem so you don't crawl the DOM everytime
  if ($el.length > 0) {
    var stickyHeaderTop = $el.offset().top - $el.height() / 1.2; // passing "true" will also include the top and bottom margin
    //var stickyHeaderTop = top_part + 90;
    console.log(stickyHeaderTop);
  }
  $(window).scroll(function () {
    if ($(window).scrollTop() > stickyHeaderTop) {
      if ($("body").hasClass("run-icon-5") == false) {
        $("body").addClass("run-icon-5");

        //$(".rightside_desksvgiconboxs_1 > svg:first-child").css("display","none");
        $(".rightside_desksvgiconboxs_1 > svg:nth-child(2)").css(
          "display",
          "block"
        );
        animationMenu1.stop();
        animationMenu1.play();

        animationMenu1.onComplete = function () {
          // On complete, proceed to next .step
          //console.log('complete');
          $(".rightside_desksvgiconboxs_1 > svg:first-child").css(
            "display",
            "block"
          );
          //$(".rightside_desksvgiconboxs_1 > svg:nth-child(2)").css("display","none");

          //$(".rightside_desksvgiconboxs_2 > svg:first-child").css("display","none");
          $(".rightside_desksvgiconboxs_2 > svg:nth-child(2)").css(
            "display",
            "block"
          );
          animationMenu2.stop();
          animationMenu2.play();
        };

        animationMenu2.onComplete = function () {
          // On complete, proceed to next .step
          //console.log('complete');
          $(".rightside_desksvgiconboxs_2 > svg:first-child").css(
            "display",
            "block"
          );
          //$(".rightside_desksvgiconboxs_2 > svg:nth-child(2)").css("display","none");

          //$(".rightside_desksvgiconboxs_3 > svg:first-child").css("display","none");
          $(".rightside_desksvgiconboxs_3 > svg:nth-child(2)").css(
            "display",
            "block"
          );
          animationMenu3.stop();
          animationMenu3.play();
        };

        animationMenu3.onComplete = function () {
          // On complete, proceed to next .step
          //console.log('complete');
          $(".rightside_desksvgiconboxs_3 > svg:first-child").css(
            "display",
            "block"
          );
          //$(".rightside_desksvgiconboxs_3 > svg:nth-child(2)").css("display","none");

          //$(".rightside_desksvgiconboxs_4 > svg:first-child").css("display","none");
          $(".rightside_desksvgiconboxs_4 > svg:nth-child(2)").css(
            "display",
            "block"
          );
          animationMenu4.stop();
          animationMenu4.play();
        };

        animationMenu4.onComplete = function () {
          // On complete, proceed to next .step
          //console.log('complete');
          $(".rightside_desksvgiconboxs_4 > svg:first-child").css(
            "display",
            "block"
          );
          //$(".rightside_desksvgiconboxs_4 > svg:nth-child(2)").css("display","none");

          //$(".rightside_desksvgiconboxs_5 > svg:first-child").css("display","none");
          $(".rightside_desksvgiconboxs_5 > svg:nth-child(2)").css(
            "display",
            "block"
          );
          animationMenu5.stop();
          animationMenu5.play();
        };

        animationMenu5.onComplete = function () {
          // On complete, proceed to next .step
          //console.log('complete');
          $(".rightside_desksvgiconboxs_5 > svg:first-child").css(
            "display",
            "block"
          );
          //$(".rightside_desksvgiconboxs_5 > svg:nth-child(2)").css("display","none");

          //$(".rightside_desksvgiconboxs_1 > svg:first-child").css("display","none");
          $(".rightside_desksvgiconboxs_1 > svg:nth-child(2)").css(
            "display",
            "block"
          );
          animationMenu1.stop();
          animationMenu1.play();
        };
      }
    }
  });
});

/* value-of-good 8 icons */
let iconMenu1Page = document.querySelector(
  ".Page_value_of_good_icons_texts_allloop_svgiconboxs_1"
);
let animationMenu1Page = bodymovin.loadAnimation({
  container: iconMenu1Page,
  renderer: "svg",
  loop: false,
  autoplay: true,
  path: "https://cdn.shopify.com/s/files/1/0621/0168/4404/files/page_07.json?v=1664253349",
});

let iconMenu2Page = document.querySelector(
  ".Page_value_of_good_icons_texts_allloop_svgiconboxs_2"
);
let animationMenu2Page = bodymovin.loadAnimation({
  container: iconMenu2Page,
  renderer: "svg",
  loop: false,
  autoplay: true,
  path: "https://cdn.shopify.com/s/files/1/0621/0168/4404/files/new_page_02.json?v=1664447963",
});

let iconMenu3Page = document.querySelector(
  ".Page_value_of_good_icons_texts_allloop_svgiconboxs_3"
);
let animationMenu3Page = bodymovin.loadAnimation({
  container: iconMenu3Page,
  renderer: "svg",
  loop: false,
  autoplay: true,
  path: "https://cdn.shopify.com/s/files/1/0621/0168/4404/files/new_page_03.json?v=1664447963",
});

let iconMenu4Page = document.querySelector(
  ".Page_value_of_good_icons_texts_allloop_svgiconboxs_4"
);
let animationMenu4Page = bodymovin.loadAnimation({
  container: iconMenu4Page,
  renderer: "svg",
  loop: false,
  autoplay: true,
  path: "https://cdn.shopify.com/s/files/1/0621/0168/4404/files/new_page_04.json?v=1664447963",
});

let iconMenu5Page = document.querySelector(
  ".Page_value_of_good_icons_texts_allloop_svgiconboxs_5"
);
let animationMenu5Page = bodymovin.loadAnimation({
  container: iconMenu5Page,
  renderer: "svg",
  loop: false,
  autoplay: true,
  path: "https://cdn.shopify.com/s/files/1/0621/0168/4404/files/new_page_05.json?v=1664447962",
});

let iconMenu6Page = document.querySelector(
  ".Page_value_of_good_icons_texts_allloop_svgiconboxs_6"
);
let animationMenu6Page = bodymovin.loadAnimation({
  container: iconMenu6Page,
  renderer: "svg",
  loop: false,
  autoplay: true,
  path: "https://cdn.shopify.com/s/files/1/0621/0168/4404/files/new_page_06.json?v=1664447962",
});

let iconMenu7Page = document.querySelector(
  ".Page_value_of_good_icons_texts_allloop_svgiconboxs_7"
);
let animationMenu7Page = bodymovin.loadAnimation({
  container: iconMenu7Page,
  renderer: "svg",
  loop: false,
  autoplay: true,
  path: "https://cdn.shopify.com/s/files/1/0621/0168/4404/files/new_page_07.json?v=1664447962",
});

let iconMenu8Page = document.querySelector(
  ".Page_value_of_good_icons_texts_allloop_svgiconboxs_8"
);
let animationMenu8Page = bodymovin.loadAnimation({
  container: iconMenu8Page,
  renderer: "svg",
  loop: false,
  autoplay: true,
  path: "https://cdn.shopify.com/s/files/1/0621/0168/4404/files/new_page_08.json?v=1664447962",
});

animationMenu1Page.stop();
animationMenu2Page.stop();
animationMenu3Page.stop();
animationMenu4Page.stop();
animationMenu5Page.stop();
animationMenu6Page.stop();
animationMenu7Page.stop();
animationMenu8Page.stop();

$(window).load(function () {
  var $el = $(".Page_value_of_good_icons_texts_new"); //record the elem so you don't crawl the DOM everytime
  if ($el.length > 0) {
    var stickyHeaderTop = $el.offset().top - $el.height() / 1.8; // passing "true" will also include the top and bottom margin
    //var stickyHeaderTop = top_part + 90;
    console.log(stickyHeaderTop);
  }
  $(window).scroll(function () {
    if ($(window).scrollTop() > stickyHeaderTop) {
      if ($("body").hasClass("run-icon-4") == false) {
        $("body").addClass("run-icon-4");

        //$(".Page_value_of_good_icons_texts_allloop_svgiconboxs_1 > svg:first-child").css("display","none");
        $(
          ".Page_value_of_good_icons_texts_allloop_svgiconboxs_1 > svg:nth-child(2)"
        ).css("display", "block");
        animationMenu1Page.stop();
        animationMenu1Page.play();

        animationMenu1Page.onComplete = function () {
          // On complete, proceed to next .step
          //console.log('complete');
          $(
            ".Page_value_of_good_icons_texts_allloop_svgiconboxs_1 > svg:first-child"
          ).css("display", "block");
          //$(".Page_value_of_good_icons_texts_allloop_svgiconboxs_1 > svg:nth-child(2)").css("display","none");

          //$(".Page_value_of_good_icons_texts_allloop_svgiconboxs_2 > svg:first-child").css("display","none");
          $(
            ".Page_value_of_good_icons_texts_allloop_svgiconboxs_2 > svg:nth-child(2)"
          ).css("display", "block");
          animationMenu2Page.stop();
          animationMenu2Page.play();
        };

        animationMenu2Page.onComplete = function () {
          // On complete, proceed to next .step
          //console.log('complete');
          $(
            ".Page_value_of_good_icons_texts_allloop_svgiconboxs_2 > svg:first-child"
          ).css("display", "block");
          //$(".Page_value_of_good_icons_texts_allloop_svgiconboxs_2 > svg:nth-child(2)").css("display","none");

          //$(".Page_value_of_good_icons_texts_allloop_svgiconboxs_3 > svg:first-child").css("display","none");
          $(
            ".Page_value_of_good_icons_texts_allloop_svgiconboxs_3 > svg:nth-child(2)"
          ).css("display", "block");
          animationMenu3Page.stop();
          animationMenu3Page.play();
        };

        animationMenu3Page.onComplete = function () {
          // On complete, proceed to next .step
          //console.log('complete');
          $(
            ".Page_value_of_good_icons_texts_allloop_svgiconboxs_3 > svg:first-child"
          ).css("display", "block");
          //$(".Page_value_of_good_icons_texts_allloop_svgiconboxs_3 > svg:nth-child(2)").css("display","none");

          //$(".Page_value_of_good_icons_texts_allloop_svgiconboxs_4 > svg:first-child").css("display","none");
          $(
            ".Page_value_of_good_icons_texts_allloop_svgiconboxs_4 > svg:nth-child(2)"
          ).css("display", "block");
          animationMenu4Page.stop();
          animationMenu4Page.play();
        };

        animationMenu4Page.onComplete = function () {
          // On complete, proceed to next .step
          //console.log('complete');
          $(
            ".Page_value_of_good_icons_texts_allloop_svgiconboxs_4 > svg:first-child"
          ).css("display", "block");
          //$(".Page_value_of_good_icons_texts_allloop_svgiconboxs_4 > svg:nth-child(2)").css("display","none");

          //$(".Page_value_of_good_icons_texts_allloop_svgiconboxs_5 > svg:first-child").css("display","none");
          $(
            ".Page_value_of_good_icons_texts_allloop_svgiconboxs_5 > svg:nth-child(2)"
          ).css("display", "block");
          animationMenu5Page.stop();
          animationMenu5Page.play();
        };

        animationMenu5Page.onComplete = function () {
          // On complete, proceed to next .step
          //console.log('complete');
          $(
            ".Page_value_of_good_icons_texts_allloop_svgiconboxs_5 > svg:first-child"
          ).css("display", "block");
          //$(".Page_value_of_good_icons_texts_allloop_svgiconboxs_5 > svg:nth-child(2)").css("display","none");

          //$(".Page_value_of_good_icons_texts_allloop_svgiconboxs_6 > svg:first-child").css("display","none");
          $(
            ".Page_value_of_good_icons_texts_allloop_svgiconboxs_6 > svg:nth-child(2)"
          ).css("display", "block");
          animationMenu6Page.stop();
          animationMenu6Page.play();
        };

        animationMenu6Page.onComplete = function () {
          // On complete, proceed to next .step
          //console.log('complete');
          $(
            ".Page_value_of_good_icons_texts_allloop_svgiconboxs_6 > svg:first-child"
          ).css("display", "block");
          //$(".Page_value_of_good_icons_texts_allloop_svgiconboxs_6 > svg:nth-child(2)").css("display","none");

          //$(".Page_value_of_good_icons_texts_allloop_svgiconboxs_7 > svg:first-child").css("display","none");
          $(
            ".Page_value_of_good_icons_texts_allloop_svgiconboxs_7 > svg:nth-child(2)"
          ).css("display", "block");
          animationMenu7Page.stop();
          animationMenu7Page.play();
        };

        animationMenu7Page.onComplete = function () {
          // On complete, proceed to next .step
          //console.log('complete');
          $(
            ".Page_value_of_good_icons_texts_allloop_svgiconboxs_7 > svg:first-child"
          ).css("display", "block");
          //$(".Page_value_of_good_icons_texts_allloop_svgiconboxs_7 > svg:nth-child(2)").css("display","none");

          //$(".Page_value_of_good_icons_texts_allloop_svgiconboxs_8 > svg:first-child").css("display","none");
          $(
            ".Page_value_of_good_icons_texts_allloop_svgiconboxs_8 > svg:nth-child(2)"
          ).css("display", "block");
          animationMenu8Page.stop();
          animationMenu8Page.play();
        };

        animationMenu8Page.onComplete = function () {
          // On complete, proceed to next .step
          //console.log('complete');
          $(
            ".Page_value_of_good_icons_texts_allloop_svgiconboxs_8 > svg:first-child"
          ).css("display", "block");
          //$(".Page_value_of_good_icons_texts_allloop_svgiconboxs_8 > svg:nth-child(2)").css("display","none");

          //$(".Page_value_of_good_icons_texts_allloop_svgiconboxs_1 > svg:first-child").css("display","none");
          $(
            ".Page_value_of_good_icons_texts_allloop_svgiconboxs_1 > svg:nth-child(2)"
          ).css("display", "block");
          //animationMenu1Page.stop();
          //animationMenu1Page.play();
        };
      }
    }
  });
});

/* value of good 3 icons */
let PlaneticonMenu1 = document.querySelector(
  ".Page_value_of_good_info_column_allloop_boxs_svg_1"
);
let PlanetanimationMenu1 = bodymovin.loadAnimation({
  container: PlaneticonMenu1,
  renderer: "svg",
  loop: false,
  autoplay: true,
  path: "https://cdn.shopify.com/s/files/1/0621/0168/4404/files/People.json?v=1664439826",
});

let PlaneticonMenu2 = document.querySelector(
  ".Page_value_of_good_info_column_allloop_boxs_svg_2"
);
let PlanetanimationMenu2 = bodymovin.loadAnimation({
  container: PlaneticonMenu2,
  renderer: "svg",
  loop: false,
  autoplay: true,
  path: "https://cdn.shopify.com/s/files/1/0621/0168/4404/files/Planet.json?v=1664439826",
});

let PlaneticonMenu3 = document.querySelector(
  ".Page_value_of_good_info_column_allloop_boxs_svg_3"
);
let PlanetanimationMenu3 = bodymovin.loadAnimation({
  container: PlaneticonMenu3,
  renderer: "svg",
  loop: false,
  autoplay: true,
  path: "https://cdn.shopify.com/s/files/1/0621/0168/4404/files/Profit.json?v=1664439826",
});

PlanetanimationMenu1.stop();
PlanetanimationMenu2.stop();
PlanetanimationMenu3.stop();

$(window).load(function () {
  var $el = $(".Page_value_of_good_info_column_new"); //record the elem so you don't crawl the DOM everytime
  if ($el.length > 0) {
    var stickyHeaderTop = $el.offset().top - $el.height() / 2; // passing "true" will also include the top and bottom margin
    //var stickyHeaderTop = top_part + 90;
    console.log(stickyHeaderTop);
  }
  $(window).scroll(function () {
    if ($(window).scrollTop() > stickyHeaderTop) {
      if ($("body").hasClass("run-icon-3") == false) {
        $("body").addClass("run-icon-3");

        //$(".rightside_desksvgiconboxs_1 > svg:first-child").css("display","none");
        //$(".rightside_desksvgiconboxs_1 > svg:nth-child(2)").css("display","block");
        PlanetanimationMenu1.stop();
        PlanetanimationMenu1.play();

        PlanetanimationMenu1.onComplete = function () {
          // On complete, proceed to next .step
          //console.log('complete');
          //$(".rightside_desksvgiconboxs_1 > svg:first-child").css("display","block");
          //$(".rightside_desksvgiconboxs_1 > svg:nth-child(2)").css("display","none");

          //$(".rightside_desksvgiconboxs_2 > svg:first-child").css("display","none");
          //$(".rightside_desksvgiconboxs_2 > svg:nth-child(2)").css("display","block");
          PlanetanimationMenu2.stop();
          PlanetanimationMenu2.play();
        };

        PlanetanimationMenu2.onComplete = function () {
          // On complete, proceed to next .step
          //console.log('complete');
          //$(".rightside_desksvgiconboxs_2 > svg:first-child").css("display","block");
          //$(".rightside_desksvgiconboxs_2 > svg:nth-child(2)").css("display","none");

          //$(".rightside_desksvgiconboxs_3 > svg:first-child").css("display","none");
          //$(".rightside_desksvgiconboxs_3 > svg:nth-child(2)").css("display","block");
          PlanetanimationMenu3.stop();
          PlanetanimationMenu3.play();
        };

        PlanetanimationMenu3.onComplete = function () {
          // On complete, proceed to next .step
          //console.log('complete');
          //$(".rightside_desksvgiconboxs_3 > svg:first-child").css("display","block");
          //$(".rightside_desksvgiconboxs_3 > svg:nth-child(2)").css("display","none");
          //$(".rightside_desksvgiconboxs_4 > svg:first-child").css("display","none");
          //$(".rightside_desksvgiconboxs_4 > svg:nth-child(2)").css("display","block");
          //PlanetanimationMenu1.stop();
          //PlanetanimationMenu1.play();
        };
      }
    }
  });
});

/* Manifesto 3 icons */
let ManifestoiconMenu1 = document.querySelector(
  ".blog_team_value_slider_allloop_rightboxs_in_1"
);
let ManifestoanimationMenu1 = bodymovin.loadAnimation({
  container: ManifestoiconMenu1,
  renderer: "svg",
  loop: false,
  autoplay: true,
  path: "https://cdn.shopify.com/s/files/1/0621/0168/4404/files/Manifesto_2.json?v=1664448672",
});

let ManifestoiconMenu2 = document.querySelector(
  ".blog_team_value_slider_allloop_rightboxs_in_2"
);
let ManifestoanimationMenu2 = bodymovin.loadAnimation({
  container: ManifestoiconMenu2,
  renderer: "svg",
  loop: false,
  autoplay: true,
  path: "https://cdn.shopify.com/s/files/1/0621/0168/4404/files/Manifesto_4.json?v=1664448905",
});

let ManifestoiconMenu3 = document.querySelector(
  ".blog_team_value_slider_allloop_rightboxs_in_3"
);
let ManifestoanimationMenu3 = bodymovin.loadAnimation({
  container: ManifestoiconMenu3,
  renderer: "svg",
  loop: false,
  autoplay: true,
  path: "https://cdn.shopify.com/s/files/1/0621/0168/4404/files/Manifesto_5.json?v=1664448905",
});

ManifestoanimationMenu1.stop();
ManifestoanimationMenu2.stop();
ManifestoanimationMenu3.stop();

$(window).load(function () {
  var $el = $(".Page_about_us_value_slider_new"); //record the elem so you don't crawl the DOM everytime
  if ($el.length > 0) {
    var stickyHeaderTop = $el.offset().top - $el.height() / 2; // passing "true" will also include the top and bottom margin
    //var stickyHeaderTop = top_part + 90;
    console.log(stickyHeaderTop);
  }
  $(window).scroll(function () {
    if ($(window).scrollTop() > stickyHeaderTop) {
      if ($("body").hasClass("run-icon-2") == false) {
        $("body").addClass("run-icon-2");

        //$(".rightside_desksvgiconboxs_1 > svg:first-child").css("display","none");
        //$(".rightside_desksvgiconboxs_1 > svg:nth-child(2)").css("display","block");
        ManifestoanimationMenu1.stop();
        ManifestoanimationMenu1.play();

        ManifestoanimationMenu1.onComplete = function () {
          // On complete, proceed to next .step
          //console.log('complete');
          //$(".rightside_desksvgiconboxs_1 > svg:first-child").css("display","block");
          //$(".rightside_desksvgiconboxs_1 > svg:nth-child(2)").css("display","none");

          //$(".rightside_desksvgiconboxs_2 > svg:first-child").css("display","none");
          //$(".rightside_desksvgiconboxs_2 > svg:nth-child(2)").css("display","block");
          ManifestoanimationMenu2.stop();
          ManifestoanimationMenu2.play();
        };

        ManifestoanimationMenu2.onComplete = function () {
          // On complete, proceed to next .step
          //console.log('complete');
          //$(".rightside_desksvgiconboxs_2 > svg:first-child").css("display","block");
          //$(".rightside_desksvgiconboxs_2 > svg:nth-child(2)").css("display","none");

          //$(".rightside_desksvgiconboxs_3 > svg:first-child").css("display","none");
          //$(".rightside_desksvgiconboxs_3 > svg:nth-child(2)").css("display","block");
          ManifestoanimationMenu3.stop();
          ManifestoanimationMenu3.play();
        };

        ManifestoanimationMenu3.onComplete = function () {
          // On complete, proceed to next .step
          //console.log('complete');
          //$(".rightside_desksvgiconboxs_3 > svg:first-child").css("display","block");
          //$(".rightside_desksvgiconboxs_3 > svg:nth-child(2)").css("display","none");

          //$(".rightside_desksvgiconboxs_4 > svg:first-child").css("display","none");
          //$(".rightside_desksvgiconboxs_4 > svg:nth-child(2)").css("display","block");
          ManifestoanimationMenu1.stop();
          ManifestoanimationMenu1.play();
        };
      }
    }
  });
});

/* Manifesto 3 icons Mobile */
let ManifestoiconMenu1_m = document.querySelector(
  ".blog_team_value_slider_allloop_rightboxs_mobile_in_1"
);
let ManifestoanimationMenu1_m = bodymovin.loadAnimation({
  container: ManifestoiconMenu1_m,
  renderer: "svg",
  loop: false,
  autoplay: true,
  path: "https://cdn.shopify.com/s/files/1/0621/0168/4404/files/Manifesto_2_m.json?v=1664448672",
});

let ManifestoiconMenu2_m = document.querySelector(
  ".blog_team_value_slider_allloop_rightboxs_mobile_in_2"
);
let ManifestoanimationMenu2_m = bodymovin.loadAnimation({
  container: ManifestoiconMenu2_m,
  renderer: "svg",
  loop: false,
  autoplay: true,
  path: "https://cdn.shopify.com/s/files/1/0621/0168/4404/files/Manifesto_4_m.json?v=1664448905",
});

let ManifestoiconMenu3_m = document.querySelector(
  ".blog_team_value_slider_allloop_rightboxs_mobile_in_3"
);
let ManifestoanimationMenu3_m = bodymovin.loadAnimation({
  container: ManifestoiconMenu3_m,
  renderer: "svg",
  loop: false,
  autoplay: true,
  path: "https://cdn.shopify.com/s/files/1/0621/0168/4404/files/Manifesto_5_m.json?v=1664448905",
});

ManifestoanimationMenu1_m.stop();
ManifestoanimationMenu2_m.stop();
ManifestoanimationMenu3_m.stop();

$(window).load(function () {
  var $el = $(".Page_about_us_value_slider_new"); //record the elem so you don't crawl the DOM everytime
  if ($el.length > 0) {
    var stickyHeaderTop = $el.offset().top - $el.height() / 2; // passing "true" will also include the top and bottom margin
    //var stickyHeaderTop = top_part + 90;
    console.log(stickyHeaderTop);
  }
  $(window).scroll(function () {
    if ($(window).scrollTop() > stickyHeaderTop) {
      if ($("body").hasClass("run-icon-1") == false) {
        $("body").addClass("run-icon-1");

        //$(".rightside_desksvgiconboxs_1 > svg:first-child").css("display","none");
        //$(".rightside_desksvgiconboxs_1 > svg:nth-child(2)").css("display","block");
        ManifestoanimationMenu1_m.stop();
        ManifestoanimationMenu1_m.play();

        ManifestoanimationMenu1_m.onComplete = function () {
          // On complete, proceed to next .step
          //console.log('complete');
          //$(".rightside_desksvgiconboxs_1 > svg:first-child").css("display","block");
          //$(".rightside_desksvgiconboxs_1 > svg:nth-child(2)").css("display","none");

          //$(".rightside_desksvgiconboxs_2 > svg:first-child").css("display","none");
          //$(".rightside_desksvgiconboxs_2 > svg:nth-child(2)").css("display","block");
          ManifestoanimationMenu2_m.stop();
          ManifestoanimationMenu2_m.play();
        };

        ManifestoanimationMenu2_m.onComplete = function () {
          // On complete, proceed to next .step
          //console.log('complete');
          //$(".rightside_desksvgiconboxs_2 > svg:first-child").css("display","block");
          //$(".rightside_desksvgiconboxs_2 > svg:nth-child(2)").css("display","none");

          //$(".rightside_desksvgiconboxs_3 > svg:first-child").css("display","none");
          //$(".rightside_desksvgiconboxs_3 > svg:nth-child(2)").css("display","block");
          ManifestoanimationMenu3_m.stop();
          ManifestoanimationMenu3_m.play();
        };

        ManifestoanimationMenu3_m.onComplete = function () {
          // On complete, proceed to next .step
          //console.log('complete');
          //$(".rightside_desksvgiconboxs_3 > svg:first-child").css("display","block");
          //$(".rightside_desksvgiconboxs_3 > svg:nth-child(2)").css("display","none");

          //$(".rightside_desksvgiconboxs_4 > svg:first-child").css("display","none");
          //$(".rightside_desksvgiconboxs_4 > svg:nth-child(2)").css("display","block");
          ManifestoanimationMenu1_m.stop();
          ManifestoanimationMenu1_m.play();
        };
      }
    }
  });
});

/* Ignite 4 icons */
let igniteiconMenu1 = document.querySelector(
  ".blog_ignite_top_heading_toppart_first_svgiconthired_new"
);
let igniteanimationMenu1 = bodymovin.loadAnimation({
  container: igniteiconMenu1,
  renderer: "svg",
  loop: false,
  autoplay: false,
  path: "https://cdn.shopify.com/s/files/1/0621/0168/4404/files/Ignite_1.json?v=1664535614",
});

let igniteiconMenu2 = document.querySelector(
  ".blog_ignite_top_heading_toppart_second_svgiconfourth_new"
);
let igniteanimationMenu2 = bodymovin.loadAnimation({
  container: igniteiconMenu2,
  renderer: "svg",
  loop: false,
  autoplay: false,
  path: "https://cdn.shopify.com/s/files/1/0621/0168/4404/files/Ignite_2.json?v=1664535614",
});

let igniteiconMenu3 = document.querySelector(
  ".blog_ignite_top_heading_toppart_second_svgiconfifth_new"
);
let igniteanimationMenu3 = bodymovin.loadAnimation({
  container: igniteiconMenu3,
  renderer: "svg",
  loop: false,
  autoplay: false,
  path: "https://cdn.shopify.com/s/files/1/0621/0168/4404/files/Ignite_3.json?v=1664535614",
});

let igniteiconMenu4 = document.querySelector(
  ".blog_ignite_top_heading_toppart_thired_svgiconsixth_new"
);
let igniteanimationMenu4 = bodymovin.loadAnimation({
  container: igniteiconMenu4,
  renderer: "svg",
  loop: false,
  autoplay: false,
  path: "https://cdn.shopify.com/s/files/1/0621/0168/4404/files/Ignite_4.json?v=1664535615",
});

//igniteanimationMenu1.stop();
//igniteanimationMenu2.stop();
//igniteanimationMenu3.stop();
//igniteanimationMenu4.stop();

//$(".rightside_desksvgiconboxs_1 > svg:first-child").css("display","none");
//$(".rightside_desksvgiconboxs_1 > svg:nth-child(2)").css("display","block");
igniteanimationMenu1.stop();
igniteanimationMenu1.play();

igniteanimationMenu1.onComplete = function () {
  // On complete, proceed to next .step
  //console.log('complete');
  //$(".rightside_desksvgiconboxs_1 > svg:first-child").css("display","block");
  //$(".rightside_desksvgiconboxs_1 > svg:nth-child(2)").css("display","none");

  //$(".rightside_desksvgiconboxs_2 > svg:first-child").css("display","none");
  $(".rightside_desksvgiconboxs_2 > svg:nth-child(2)").css("display", "block");
  igniteanimationMenu2.stop();
  igniteanimationMenu2.play();
};

igniteanimationMenu2.onComplete = function () {
  // On complete, proceed to next .step
  //console.log('complete');
  //$(".rightside_desksvgiconboxs_2 > svg:first-child").css("display","block");
  //$(".rightside_desksvgiconboxs_2 > svg:nth-child(2)").css("display","none");

  //$(".rightside_desksvgiconboxs_3 > svg:first-child").css("display","none");
  //$(".rightside_desksvgiconboxs_3 > svg:nth-child(2)").css("display","block");
  igniteanimationMenu3.stop();
  igniteanimationMenu3.play();
};

igniteanimationMenu3.onComplete = function () {
  // On complete, proceed to next .step
  //console.log('complete');
  //$(".rightside_desksvgiconboxs_3 > svg:first-child").css("display","block");
  //$(".rightside_desksvgiconboxs_3 > svg:nth-child(2)").css("display","none");

  //$(".rightside_desksvgiconboxs_4 > svg:first-child").css("display","none");
  //$(".rightside_desksvgiconboxs_4 > svg:nth-child(2)").css("display","block");
  igniteanimationMenu4.stop();
  igniteanimationMenu4.play();
};

igniteanimationMenu4.onComplete = function () {
  // On complete, proceed to next .step
  //console.log('complete');
  //$(".rightside_desksvgiconboxs_4 > svg:first-child").css("display","block");
  //$(".rightside_desksvgiconboxs_4 > svg:nth-child(2)").css("display","none");
  //$(".rightside_desksvgiconboxs_5 > svg:first-child").css("display","none");
  //$(".rightside_desksvgiconboxs_5 > svg:nth-child(2)").css("display","block");
  //igniteanimationMenu1.stop();
  //igniteanimationMenu1.play();
};
$(document).ready(function () {
  let tag_link = $("[js-blog-tag-link]");
  tag_link.click(function (e) {
    tag_link.removeClass("blog_template_tagfilter_selected_new");
    e.preventDefault();
    const tag = $(this).data("blog-tag");
    $(this).addClass("blog_template_tagfilter_selected_new");
    blogAjax(tag);
  });
  let url = `${window.location.href}`;
  function blogAjax(tag) {
    if (tag === "All") {
      url = `${window.location.href}/?view=blog-ajax`;
    } else {
      url = `${window.location.href}/tagged/${tag}/?view=blog-ajax`;
    }
    const container = $("#tab-blog-section");
    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");
        var ajaxContainer = $(doc).find("#ajax-tab-blog-section");
        container.html(ajaxContainer.children());
      });
  }
});